import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ConstraintNumber: any;
  ConstraintString: any;
  ISODate: any;
  ISODateTime: any;
  JSON: any;
  JSONObject: any;
};

export type GqlAccount = {
  __typename?: 'Account';
  accountAlias: Scalars['String'];
  accountGuid: Scalars['String'];
  availableBalance: Scalars['Float'];
  bankName: Scalars['String'];
  lastDigits: Scalars['String'];
};

export type GqlAccountBalance = {
  __typename?: 'AccountBalance';
  accountBalanceCents: Scalars['Int'];
  accountBalanceCurrency: Scalars['String'];
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  insufficient: Scalars['Boolean'];
  multiplier: Scalars['Float'];
  orderTotalCents: Scalars['Int'];
  orderTotalCurrency: Scalars['String'];
  pendingTransactionTotalCents?: Maybe<Scalars['Int']>;
  phase: Scalars['String'];
};

export type GqlAccountDetailsInput = {
  accountAlias?: InputMaybe<Scalars['String']>;
  accountNumber: Scalars['String'];
  accountOwners?: InputMaybe<Array<Scalars['String']>>;
  accountType: Scalars['String'];
  bankName: Scalars['String'];
  currency: Scalars['String'];
  routingNumber: Scalars['String'];
};

export type GqlAchBatch = {
  __typename?: 'AchBatch';
  effectiveDate?: Maybe<GqlGoogleProtobufTimestamp>;
  estimatedSettledAt?: Maybe<GqlGoogleProtobufTimestamp>;
  failedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  fileName: Scalars['String'];
  generatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id: Scalars['String'];
  processedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  status: Scalars['String'];
  submittedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchEntry = {
  __typename?: 'AchEntry';
  achFileId?: Maybe<Scalars['String']>;
  bankAccountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id?: Maybe<Scalars['String']>;
  identificationNumber?: Maybe<Scalars['String']>;
  receiverName?: Maybe<Scalars['String']>;
  secCode?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  traceNumber?: Maybe<Scalars['String']>;
  transactionCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchEntryV2 = {
  __typename?: 'AchEntryV2';
  achFileId?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['String']>;
  batchFileId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  effectiveAt?: Maybe<GqlGoogleProtobufTimestamp>;
  failedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id?: Maybe<Scalars['String']>;
  identificationNumber?: Maybe<Scalars['String']>;
  receiverName?: Maybe<Scalars['String']>;
  retailerName?: Maybe<Scalars['String']>;
  secCode?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  traceNumber?: Maybe<Scalars['String']>;
  transactionCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchRawBatchFile = {
  __typename?: 'AchRawBatchFile';
  fileString: Scalars['String'];
};

export type GqlAchReturn = {
  __typename?: 'AchReturn';
  achEntryId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  originalTraceNumber?: Maybe<Scalars['String']>;
  returnTraceNumber?: Maybe<Scalars['String']>;
};

export type GqlAchReturnDetailReport = {
  __typename?: 'AchReturnDetailReport';
  achReturnDetailReport?: Maybe<Array<Maybe<GqlAchReturnDetailReportRow>>>;
};

export type GqlAchReturnDetailReportResponse = {
  __typename?: 'AchReturnDetailReportResponse';
  data?: Maybe<GqlAchReturnDetailReport>;
};

export type GqlAchReturnDetailReportRow = {
  __typename?: 'AchReturnDetailReportRow';
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<GqlGoogleProtobufTimestamp>;
  returnCode?: Maybe<Scalars['String']>;
  returnCodeCount?: Maybe<Scalars['Int']>;
  totalReturns?: Maybe<Scalars['Int']>;
};

export type GqlAchReturnFileUploadResult = {
  __typename?: 'AchReturnFileUploadResult';
  error?: Maybe<GqlErrorMessage>;
  identificationNumber: Scalars['String'];
  markedAsReturned: Scalars['Boolean'];
};

export type GqlAchReturnResponse = {
  __typename?: 'AchReturnResponse';
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  discretionaryData?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identificationNumber?: Maybe<Scalars['String']>;
  originalAchEntry: Scalars['String'];
  rdfiIdentification?: Maybe<Scalars['String']>;
  receiverName?: Maybe<Scalars['String']>;
  secCode?: Maybe<Scalars['String']>;
  transactionCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchReturnV2 = {
  __typename?: 'AchReturnV2';
  achEntryId?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id?: Maybe<Scalars['String']>;
  originalTraceNumber?: Maybe<Scalars['String']>;
  originalTransactionDate?: Maybe<GqlGoogleProtobufTimestamp>;
  receiverName?: Maybe<Scalars['String']>;
  retailerName?: Maybe<Scalars['String']>;
  returnTraceNumber?: Maybe<Scalars['String']>;
  returnedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchReturnV4 = {
  __typename?: 'AchReturnV4';
  achEntryId?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  originalTraceNumber?: Maybe<Scalars['String']>;
  originalTransactionDate?: Maybe<GqlGoogleProtobufTimestamp>;
  receiverName?: Maybe<Scalars['String']>;
  retailerName?: Maybe<Scalars['String']>;
  returnCode?: Maybe<Scalars['String']>;
  returnTraceNumber?: Maybe<Scalars['String']>;
  returnedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchReturnV5 = {
  __typename?: 'AchReturnV5';
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  originalTraceNumber?: Maybe<Scalars['String']>;
  originalTransactionDate?: Maybe<GqlGoogleProtobufTimestamp>;
  receiverName?: Maybe<Scalars['String']>;
  retailerName?: Maybe<Scalars['String']>;
  returnCode?: Maybe<Scalars['String']>;
  returnTraceNumber?: Maybe<Scalars['String']>;
  returnedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  returnedSourceId?: Maybe<Scalars['String']>;
  returnedSourceType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchReversal = {
  __typename?: 'AchReversal';
  achEntryId: Scalars['String'];
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id: Scalars['String'];
  identificationNumber?: Maybe<Scalars['String']>;
  receiverName?: Maybe<Scalars['String']>;
  retailerName?: Maybe<Scalars['String']>;
  returnedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  state?: Maybe<Scalars['String']>;
  successfulAt?: Maybe<GqlGoogleProtobufTimestamp>;
  traceNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlActionEstimates = {
  __typename?: 'ActionEstimates';
  delivery?: Maybe<GqlActionEstimatesValues>;
  pickup?: Maybe<GqlActionEstimatesValues>;
};

export type GqlActionEstimatesValues = {
  __typename?: 'ActionEstimatesValues';
  deliveryTimeInMinutes?: Maybe<Scalars['Float']>;
  rangeInMinutes?: Maybe<Scalars['Int']>;
  readyInMinutes?: Maybe<Scalars['Float']>;
};

export type GqlActivateBankAccountResponse = {
  __typename?: 'ActivateBankAccountResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type GqlActivatePaymentMethodResponse = {
  __typename?: 'ActivatePaymentMethodResponse';
  genericResponse?: Maybe<GqlGenericResponse>;
};

export type GqlActiveDispenariesResult = {
  __typename?: 'ActiveDispenariesResult';
  dispensaries?: Maybe<Array<Maybe<GqlActiveDispensaries>>>;
  meta?: Maybe<GqlActiveDispensariesMeta>;
};

export type GqlActiveDispensaries = {
  __typename?: 'ActiveDispensaries';
  _id?: Maybe<Scalars['String']>;
  integration?: Maybe<GqlActiveDispensariesIntegration>;
  profile?: Maybe<GqlActiveDispensariesProfile>;
};

export type GqlActiveDispensariesIntegration = {
  __typename?: 'ActiveDispensariesIntegration';
  adapter?: Maybe<Scalars['String']>;
  /** @deprecated Use ISO field */
  lastSyncAt?: Maybe<Scalars['String']>;
  lastSyncAtISO?: Maybe<Scalars['ISODateTime']>;
};

export type GqlActiveDispensariesMeta = {
  __typename?: 'ActiveDispensariesMeta';
  allStates?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GqlActiveDispensariesProfile = {
  __typename?: 'ActiveDispensariesProfile';
  cName?: Maybe<Scalars['String']>;
  /** @deprecated To be removed */
  chain?: Maybe<Scalars['String']>;
  connectedProductPercentage?: Maybe<Scalars['Float']>;
  embeddedPageViews?: Maybe<Scalars['Int']>;
  hideFromCCT?: Maybe<Scalars['Boolean']>;
  lastThirtyDaysSales?: Maybe<Scalars['Float']>;
  menuScore?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export enum AdInventoryId {
  /** @deprecated legacy AD inventoryID */
  categoryBrandAuc = 'category_brand_auc',
  categoryCarouselAuc = 'category_carousel_auc',
  /** @deprecated legacy AD inventoryID */
  homeBrandAuc = 'home_brand_auc',
  homeCarouselAuc = 'home_carousel_auc'
}

export type GqlAdSettings = {
  __typename?: 'AdSettings';
  enableAdsForDefault?: Maybe<Scalars['Boolean']>;
  enableAdsForEmbedded?: Maybe<Scalars['Boolean']>;
  enableAdsForKiosk?: Maybe<Scalars['Boolean']>;
  enableAdsForStoreFront?: Maybe<Scalars['Boolean']>;
};

export type GqlAdTrackers = {
  __typename?: 'AdTrackers';
  clickUrl: Scalars['String'];
  impressionUrl: Scalars['String'];
};

export type GqlAddressBasedDispensaryDataResult = {
  __typename?: 'AddressBasedDispensaryDataResult';
  deliveryInfo: GqlDispensaries_DeliveryInfo;
  taxes?: Maybe<Array<GqlDispensaries_TaxConfig_Tax>>;
};

export type GqlAdminOrderListType = {
  __typename?: 'AdminOrderListType';
  orders?: Maybe<Array<Maybe<GqlAdminOrderType>>>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlAdminOrderType = {
  __typename?: 'AdminOrderType';
  _id: Scalars['String'];
  createdAt?: Maybe<Scalars['ISODateTime']>;
  customerEmail?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customerPhone?: Maybe<Scalars['String']>;
  delivery?: Maybe<Scalars['Boolean']>;
  deliveryEstimate?: Maybe<Scalars['String']>;
  deliveryInfo?: Maybe<GqlOrders_DeliveryInfo>;
  deliveryOption?: Maybe<Scalars['Boolean']>;
  dispensaryId?: Maybe<Scalars['String']>;
  dispensaryName?: Maybe<Scalars['String']>;
  dispoTimezone?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  durationEstimates?: Maybe<GqlDurationEstimates>;
  effectiveStatus?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fleetManagementTask?: Maybe<GqlOrders_FleetManagementTask>;
  hypur?: Maybe<GqlHypurDetails>;
  isAfterHoursOrder?: Maybe<Scalars['Boolean']>;
  isAnonymous?: Maybe<Scalars['Boolean']>;
  isKioskOrder?: Maybe<Scalars['Boolean']>;
  isScheduledOrder?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  moneris?: Maybe<Array<Maybe<GqlMonerisDetails>>>;
  onfleetTask?: Maybe<GqlOrders_FleetManagementTask>;
  orderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  orderType?: Maybe<Scalars['String']>;
  payments?: Maybe<Array<Maybe<GqlPaymentDetails>>>;
  paysafe?: Maybe<GqlPaysafeDetails>;
  pos?: Maybe<GqlOrders_Pos>;
  reopened?: Maybe<Scalars['Boolean']>;
  reservation?: Maybe<GqlOrderReservation>;
  status?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Scalars['Float']>;
};

export type GqlAdsInspectorDutchieAdDecisionData = {
  __typename?: 'AdsInspectorDutchieAdDecisionData';
  adProviderDecisionId: Scalars['String'];
  adProviderFilters: Scalars['JSON'];
  adType: Scalars['String'];
  items: Array<GqlAdsInspectorDutchieAdDecisionItemData>;
  maxItems?: Maybe<Scalars['Int']>;
  menuFilters: Scalars['JSON'];
  minItems?: Maybe<Scalars['Int']>;
  rejectedReason?: Maybe<Scalars['String']>;
};

export type GqlAdsInspectorDutchieAdDecisionEvent = {
  __typename?: 'AdsInspectorDutchieAdDecisionEvent';
  data: GqlAdsInspectorDutchieAdDecisionData;
  timestamp: Scalars['ISODateTime'];
};

export type GqlAdsInspectorDutchieAdDecisionItemData = {
  __typename?: 'AdsInspectorDutchieAdDecisionItemData';
  adProviderDecisionId: Scalars['String'];
  adProviderDecisionItemId: Scalars['String'];
  brandId: Scalars['String'];
  campaignId: Scalars['String'];
  clickUrl: Scalars['String'];
  impressionUrl: Scalars['String'];
  libraryProductId: Scalars['String'];
  menuProductId?: Maybe<Scalars['String']>;
  rejectedReasons: Array<Scalars['String']>;
};

export type GqlAdsInspectorDutchieAdTrackerData = {
  __typename?: 'AdsInspectorDutchieAdTrackerData';
  adProviderDecisionId: Scalars['String'];
  adProviderDecisionItemId: Scalars['String'];
  provider: Scalars['String'];
  trackerType: Scalars['String'];
  uiPlacement: Scalars['String'];
  uiPlacementIndex: Scalars['Int'];
  uiVariant: Scalars['String'];
  uiVersion: Scalars['String'];
};

export type GqlAdsInspectorDutchieAdTrackerEvent = {
  __typename?: 'AdsInspectorDutchieAdTrackerEvent';
  data: GqlAdsInspectorDutchieAdTrackerData;
  timestamp: Scalars['ISODateTime'];
};

export type GqlAdsInspectorEvents = {
  __typename?: 'AdsInspectorEvents';
  dutchieAdDecisions: Array<GqlAdsInspectorDutchieAdDecisionEvent>;
  dutchieAdTrackers: Array<GqlAdsInspectorDutchieAdTrackerEvent>;
  timeframe: GqlAdsInspectorEventsTimeframe;
  totalCount: Scalars['Int'];
};

export type GqlAdsInspectorEventsInput = {
  dispensaryId: Scalars['String'];
  menuVariant: Scalars['String'];
};

export type GqlAdsInspectorEventsTimeframe = {
  __typename?: 'AdsInspectorEventsTimeframe';
  end?: Maybe<Scalars['ISODateTime']>;
  start?: Maybe<Scalars['ISODateTime']>;
};

export type GqlAeroSyncLinkStart = {
  __typename?: 'AeroSyncLinkStart';
  token: Scalars['String'];
  userId: Scalars['String'];
};

export type GqlAgeVerification = {
  __typename?: 'AgeVerification';
  isAgeVerified: Scalars['Boolean'];
};

export type GqlAnalyticsInput = {
  chainId?: InputMaybe<Scalars['String']>;
  clientTimezone?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['String'];
  prevEndDate?: InputMaybe<Scalars['String']>;
  prevStartDate?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
};

export type GqlAnalyticsMeta = {
  __typename?: 'AnalyticsMeta';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GqlAnalyticsOrdersByDate = {
  __typename?: 'AnalyticsOrdersByDate';
  date?: Maybe<Scalars['String']>;
  totalOrders?: Maybe<Scalars['Int']>;
  totalSales?: Maybe<Scalars['Float']>;
};

export type GqlAnalyticsPagination = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type GqlAnalyticsSort = {
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Int']>;
};

export type GqlApplicableCategoryInput = {
  category?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
};

export type GqlApplicationRule = {
  __typename?: 'ApplicationRule';
  _id?: Maybe<Scalars['String']>;
  applicationType?: Maybe<ApplicationType>;
  comparisonOperator?: Maybe<ComparisonOperators>;
  quantity?: Maybe<Scalars['Int']>;
};

export type GqlApplicationRuleInput = {
  applicationType?: InputMaybe<ApplicationType>;
  comparisonOperator?: InputMaybe<ComparisonOperators>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export enum ApplicationScope {
  all = 'ALL',
  each = 'EACH'
}

export enum ApplicationType {
  quantity = 'quantity',
  totalQuantity = 'totalQuantity'
}

export type GqlAppliedReward = {
  available?: InputMaybe<Scalars['Boolean']>;
  brand?: InputMaybe<Scalars['String']>;
  copy?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['Int']>;
  discountId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  isRedeemableOnline?: InputMaybe<Scalars['Boolean']>;
  operator?: InputMaybe<Scalars['String']>;
  rewardType?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type GqlApproveInstoreCartAuthorization = {
  __typename?: 'ApproveInstoreCartAuthorization';
  authorized: Scalars['Boolean'];
  code: Scalars['String'];
  status: Scalars['String'];
};

export type GqlApproveInstoreCartResponse = {
  __typename?: 'ApproveInstoreCartResponse';
  authorization: GqlApproveInstoreCartAuthorization;
  success?: Maybe<Scalars['Boolean']>;
};

export type GqlAssessment = {
  __typename?: 'Assessment';
  createdAt: GqlGoogleProtobufTimestamp;
  decision: Scalars['String'];
  externalId: Scalars['String'];
  externalType: Scalars['String'];
  score: Scalars['Float'];
  transactionId: Scalars['String'];
  transactionType: Scalars['String'];
};

export type GqlBackInStockSubscriptionStatus = {
  __typename?: 'BackInStockSubscriptionStatus';
  subscribed: Scalars['Boolean'];
};

export type GqlBankAccount = {
  __typename?: 'BankAccount';
  bankAccount?: Maybe<GqlBankDetails>;
  billingAddress?: Maybe<GqlBillingAddress>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GqlBankAccountDetails = {
  __typename?: 'BankAccountDetails';
  accountAlias: Scalars['String'];
  aggregator: Scalars['String'];
  bankName: Scalars['String'];
  billingAddressId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['ISODateTime']>;
  financialInstitutionLogo?: Maybe<Scalars['String']>;
  lastDigits: Scalars['String'];
  status: ConnectionStatus;
};

export type GqlBankAccountPaymentMethod = {
  __typename?: 'BankAccountPaymentMethod';
  bankAccountDetails: GqlBankAccountDetails;
  createdAt: Scalars['ISODateTime'];
  id: Scalars['String'];
  status: Scalars['String'];
  type?: Maybe<DutchiePayPaymentMethodType>;
  updatedAt: Scalars['ISODateTime'];
};

export type GqlBankAccounts = {
  __typename?: 'BankAccounts';
  bankAccounts?: Maybe<Array<GqlBankAccount>>;
};

export type GqlBankDetails = {
  __typename?: 'BankDetails';
  accountAlias?: Maybe<Scalars['String']>;
  bankName: Scalars['String'];
  lastDigits: Scalars['String'];
  linked?: Maybe<Scalars['Boolean']>;
  ownerName?: Maybe<Array<Scalars['String']>>;
};

export type GqlBaseOrderingSettings = {
  checkoutMessage?: Maybe<Scalars['String']>;
  enableASAPOrdering?: Maybe<Scalars['Boolean']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']>;
  enableScheduledOrdering?: Maybe<Scalars['Boolean']>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  /** @deprecated replaced by v2 to remove slots from type - RTL 8/9/21 */
  scheduledOrderingConfig?: Maybe<GqlReservationOptionsForOrderType>;
  scheduledOrderingConfigV2?: Maybe<GqlScheduledOrderingConfigV2>;
};

export type GqlBasicSettingsInput = {
  checkoutMessage?: InputMaybe<Scalars['String']>;
  enableASAPOrdering?: InputMaybe<Scalars['Boolean']>;
  enableAfterHoursOrdering?: InputMaybe<Scalars['Boolean']>;
  enableScheduledOrdering?: InputMaybe<Scalars['Boolean']>;
  orderMinimum?: InputMaybe<GqlOrderMinimumInput>;
  paymentTypes?: InputMaybe<GqlDispensaryUpdatePaymentTypeConfig>;
  pickupReminders?: InputMaybe<GqlPickupRemindersInput>;
  scheduledOrderingConfig?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
};

export type GqlBillingAddress = {
  __typename?: 'BillingAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  postalCode: Scalars['String'];
  state: Scalars['String'];
  status: Scalars['String'];
};

export type GqlBillingAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  latitude?: InputMaybe<Scalars['Float']>;
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['Float']>;
  postalCode: Scalars['String'];
  state: Scalars['String'];
  status: Scalars['String'];
};

export enum BillingPeriod {
  annual = 'annual',
  monthly = 'monthly',
  quarterly = 'quarterly'
}

export type GqlBillingSubscription = {
  __typename?: 'BillingSubscription';
  chargebeePlan: GqlChargebeePlan;
  chargebeeSubscription?: Maybe<GqlChargebeeSubscription>;
  chargebeeSubscriptionId?: Maybe<Scalars['String']>;
  dispensaryBilling?: Maybe<GqlDispensaryBilling>;
  dispensaryBillingId?: Maybe<Scalars['String']>;
  dispensaryId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  manualPayments?: Maybe<Scalars['Boolean']>;
};

export type GqlBogoConditionItem = {
  __typename?: 'BogoConditionItem';
  _id?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['String']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  brandName?: Maybe<Scalars['String']>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  categoryName?: Maybe<Scalars['String']>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  enterpriseProductId?: Maybe<Scalars['String']>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  exclusions?: Maybe<Array<Maybe<GqlExclusion>>>;
  inventoryTags?: Maybe<Array<Scalars['String']>>;
  productGroup?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  productTags?: Maybe<Array<Scalars['String']>>;
  quantity?: Maybe<Scalars['Int']>;
  requiresSingleSku?: Maybe<Scalars['Boolean']>;
  selectedCategoriesAndSubcategories?: Maybe<Array<Maybe<Scalars['String']>>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  weight?: Maybe<Scalars['String']>;
  weightOperator?: Maybe<ComparisonOperators>;
  weights?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GqlBogoConditionItemInput = {
  _id?: InputMaybe<Scalars['String']>;
  applicationRules?: InputMaybe<Array<InputMaybe<GqlApplicationRuleInput>>>;
  brandId?: InputMaybe<Scalars['String']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  brandName?: InputMaybe<Scalars['String']>;
  brandNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryName?: InputMaybe<Scalars['String']>;
  categoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  enterpriseProductId?: InputMaybe<Scalars['String']>;
  enterpriseProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  exclusions?: InputMaybe<Array<InputMaybe<GqlExclusionInput>>>;
  inventoryTags?: InputMaybe<Array<Scalars['String']>>;
  productGroup?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productTags?: InputMaybe<Array<Scalars['String']>>;
  quantity?: InputMaybe<Scalars['Int']>;
  requiresSingleSku?: InputMaybe<Scalars['Boolean']>;
  selectedCategoriesAndSubcategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  strainIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subcategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subcategoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalQuantity?: InputMaybe<GqlTotalQuantityInput>;
  totalSpend?: InputMaybe<GqlTotalSpendInput>;
  totalWeight?: InputMaybe<GqlTotalWeightInput>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['String']>;
  weightOperator?: InputMaybe<ComparisonOperators>;
  weights?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GqlBogoRewardItem = {
  __typename?: 'BogoRewardItem';
  _id?: Maybe<Scalars['String']>;
  /** @deprecated Use applicationRules */
  applicationRule?: Maybe<GqlApplicationRule>;
  applicationRules?: Maybe<Array<GqlApplicationRule>>;
  brandId?: Maybe<Scalars['String']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  brandName?: Maybe<Scalars['String']>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  categoryName?: Maybe<Scalars['String']>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  discountAmount?: Maybe<Scalars['Float']>;
  discountType?: Maybe<Scalars['String']>;
  dollarDiscount?: Maybe<Scalars['String']>;
  enterpriseProductId?: Maybe<Scalars['String']>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  exclusions?: Maybe<Array<Maybe<GqlExclusion>>>;
  inventoryTags?: Maybe<Array<Scalars['String']>>;
  percentDiscount?: Maybe<Scalars['String']>;
  productGroup?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  productTags?: Maybe<Array<Scalars['String']>>;
  quantity?: Maybe<Scalars['Int']>;
  requiresSingleSku?: Maybe<Scalars['Boolean']>;
  selectedCategoriesAndSubcategories?: Maybe<Array<Maybe<Scalars['String']>>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  targetPrice?: Maybe<Scalars['String']>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  weight?: Maybe<Scalars['String']>;
  weightOperator?: Maybe<ComparisonOperators>;
  weights?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GqlBogoRewardItemInput = {
  _id?: InputMaybe<Scalars['String']>;
  applicationRules?: InputMaybe<Array<InputMaybe<GqlApplicationRuleInput>>>;
  brandId?: InputMaybe<Scalars['String']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  brandName?: InputMaybe<Scalars['String']>;
  brandNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryName?: InputMaybe<Scalars['String']>;
  categoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  dollarDiscount?: InputMaybe<Scalars['String']>;
  enterpriseProductId?: InputMaybe<Scalars['String']>;
  enterpriseProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  exclusions?: InputMaybe<Array<InputMaybe<GqlExclusionInput>>>;
  inventoryTags?: InputMaybe<Array<Scalars['String']>>;
  percentDiscount?: InputMaybe<Scalars['String']>;
  productGroup?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productTags?: InputMaybe<Array<Scalars['String']>>;
  quantity?: InputMaybe<Scalars['Int']>;
  requiresSingleSku?: InputMaybe<Scalars['Boolean']>;
  selectedCategoriesAndSubcategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  strainIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subcategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subcategoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetPrice?: InputMaybe<Scalars['String']>;
  totalQuantity?: InputMaybe<GqlTotalQuantityInput>;
  totalSpend?: InputMaybe<GqlTotalSpendInput>;
  totalWeight?: InputMaybe<GqlTotalWeightInput>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['String']>;
  weightOperator?: InputMaybe<ComparisonOperators>;
  weights?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GqlBogoSavingsObj = {
  __typename?: 'BogoSavingsObj';
  displayAsPercentDiscount?: Maybe<Scalars['Boolean']>;
  individual?: Maybe<Array<Maybe<GqlBogoSavings_Individual>>>;
  isDiscountToCartReward?: Maybe<Scalars['Boolean']>;
  menuBogoDiscount?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export type GqlBogoSavings_Individual = {
  __typename?: 'BogoSavings_Individual';
  conditionQuantity?: Maybe<Scalars['Int']>;
  discountAmount?: Maybe<Scalars['Float']>;
  discountStacking?: Maybe<Scalars['Boolean']>;
  displayAsPercentDiscount?: Maybe<Scalars['Boolean']>;
  isDiscountToCartReward?: Maybe<Scalars['Boolean']>;
  maxApplicable?: Maybe<Scalars['Int']>;
  nonStackingBehavior?: Maybe<Scalars['String']>;
  percentDiscount?: Maybe<Scalars['String']>;
  specialId?: Maybe<Scalars['String']>;
  stackingBehavior?: Maybe<Scalars['String']>;
};

export type GqlBrand = {
  __typename?: 'Brand';
  /** @deprecated Use id */
  _id: Scalars['ID'];
  aliasList: Array<Maybe<Scalars['String']>>;
  brandCollisions?: Maybe<Array<GqlBrandCollision>>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  creatorUserId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dispensary?: Maybe<GqlDispensaries>;
  dispensaryId?: Maybe<Scalars['String']>;
  enterprise?: Maybe<GqlEnterprise>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isGlobal: Scalars['Boolean'];
  libraryProductsCount: Scalars['Int'];
  name: Scalars['String'];
  parentBrand?: Maybe<GqlBrand>;
  parentBrandId?: Maybe<Scalars['ID']>;
  productsCount: Scalars['Int'];
  regions?: Maybe<Array<GqlRegion>>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
};

export type GqlBrandCampaignDailyInsight = {
  __typename?: 'BrandCampaignDailyInsight';
  clicks: Scalars['Int'];
  date: Scalars['ISODateTime'];
  impressions: Scalars['Int'];
  revenue: Scalars['Float'];
  spend: Scalars['Float'];
};

export type GqlBrandCampaignInsight = {
  __typename?: 'BrandCampaignInsight';
  adType: Scalars['String'];
  campaignId: Scalars['String'];
  campaignName: Scalars['String'];
  category: Scalars['String'];
  insights: Array<GqlBrandCampaignDailyInsight>;
  state: Scalars['String'];
  subbrand?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
};

export type GqlBrandCampaignInsightsFilterInput = {
  endDate?: InputMaybe<Scalars['ISODateTime']>;
  startDate?: InputMaybe<Scalars['ISODateTime']>;
};

export type GqlBrandCategory = {
  __typename?: 'BrandCategory';
  details: GqlBrandCategoryDetails;
  insights: GqlBrandInventoryInsights;
};

export type GqlBrandCategoryDetails = {
  __typename?: 'BrandCategoryDetails';
  ecomCategory: Scalars['String'];
};

export type GqlBrandCategoryInsightsSummary = {
  __typename?: 'BrandCategoryInsightsSummary';
  categories: Array<GqlBrandCategory>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandCollision = {
  __typename?: 'BrandCollision';
  createdAt?: Maybe<Scalars['ISODateTime']>;
  firstBrand: GqlBrand;
  id: Scalars['ID'];
  isAllowed: Scalars['Boolean'];
  secondBrand: GqlBrand;
};

export type GqlBrandCollisionList = {
  __typename?: 'BrandCollisionList';
  brandCollisions: Array<GqlBrandCollision>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandEnterpriseSetting = {
  __typename?: 'BrandEnterpriseSetting';
  adsEnabled: Scalars['Boolean'];
  enterprise: GqlEnterprise;
  id: Scalars['ID'];
};

export type GqlBrandExportsFilterInput = {
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<BrandExportsStatusEnum>>;
  userId?: InputMaybe<Scalars['String']>;
};

export type GqlBrandExportsResponse = {
  __typename?: 'BrandExportsResponse';
  exports: Array<GqlFilteredCatalogExport>;
  meta?: Maybe<GqlQueryInfoType>;
};

export enum BrandExportsSortByEnum {
  completedAt = 'completedAt',
  filename = 'filename',
  name = 'name',
  processedCount = 'processedCount',
  status = 'status',
  userName = 'user_name'
}

export type GqlBrandExportsSortInput = {
  sortBy?: InputMaybe<BrandExportsSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export enum BrandExportsStatusEnum {
  completed = 'completed',
  failed = 'failed',
  inProgress = 'in_progress',
  pending = 'pending'
}

export type GqlBrandImportHistory = {
  __typename?: 'BrandImportHistory';
  brandId?: Maybe<Scalars['ID']>;
  completedAt?: Maybe<Scalars['ISODateTime']>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  failureCount?: Maybe<Scalars['Int']>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  importLevelError?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pendingCount?: Maybe<Scalars['Int']>;
  processedCount?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['ISODateTime']>;
  status?: Maybe<BrandImportStatusEnum>;
  successCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
  user?: Maybe<GqlBrandImportHistoryUser>;
};

export type GqlBrandImportHistoryDetail = {
  __typename?: 'BrandImportHistoryDetail';
  brandId: Scalars['ID'];
  completedAt?: Maybe<Scalars['ISODateTime']>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  failureCount?: Maybe<Scalars['Int']>;
  fileName?: Maybe<Scalars['String']>;
  importLevelError?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pendingCount?: Maybe<Scalars['Int']>;
  processedCount?: Maybe<Scalars['Int']>;
  rows: Array<GqlBrandImportHistoryDetailRow>;
  startedAt?: Maybe<Scalars['ISODateTime']>;
  status?: Maybe<BrandImportStatusEnum>;
  successCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
  user?: Maybe<GqlBrandImportHistoryUser>;
};

export type GqlBrandImportHistoryDetailFilterInput = {
  status?: InputMaybe<Array<BrandImportHistoryDetailStatusEnum>>;
};

export type GqlBrandImportHistoryDetailResponse = {
  __typename?: 'BrandImportHistoryDetailResponse';
  data: GqlBrandImportHistoryDetail;
  meta?: Maybe<GqlMeta>;
};

export type GqlBrandImportHistoryDetailRow = {
  __typename?: 'BrandImportHistoryDetailRow';
  attributes: GqlBrandImportHistoryDetailRowAttributes;
};

export type GqlBrandImportHistoryDetailRowAttributes = {
  __typename?: 'BrandImportHistoryDetailRowAttributes';
  columnValues?: Maybe<Scalars['JSONObject']>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  csvRowNumber: Scalars['Int'];
  importErrors?: Maybe<Array<GqlBrandImportHistoryDetailRowImportError>>;
  libraryProductImportId: Scalars['ID'];
  status?: Maybe<BrandImportHistoryDetailStatusEnum>;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
};

export type GqlBrandImportHistoryDetailRowImportError = {
  __typename?: 'BrandImportHistoryDetailRowImportError';
  columnName?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export enum BrandImportHistoryDetailStatusEnum {
  failed = 'failed',
  imagesProcessed = 'images_processed',
  pending = 'pending',
  success = 'success'
}

export type GqlBrandImportHistoryFailedRowsExport = {
  __typename?: 'BrandImportHistoryFailedRowsExport';
  failedRowsCsvUrl: Scalars['String'];
};

export type GqlBrandImportHistoryFilterInput = {
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<BrandImportStatusEnum>>;
};

export type GqlBrandImportHistoryResponse = {
  __typename?: 'BrandImportHistoryResponse';
  histories?: Maybe<Array<Maybe<GqlBrandImportHistory>>>;
  meta?: Maybe<GqlQueryInfoType>;
};

export enum BrandImportHistorySortByEnum {
  createdAt = 'createdAt',
  failureCount = 'failureCount',
  name = 'name',
  status = 'status',
  successCount = 'successCount',
  userName = 'user_name'
}

export type GqlBrandImportHistorySortInput = {
  sortBy?: InputMaybe<BrandImportHistorySortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlBrandImportHistoryUploadResponse = {
  __typename?: 'BrandImportHistoryUploadResponse';
  brandId: Scalars['ID'];
  completedAt?: Maybe<Scalars['ISODateTime']>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  failureCount?: Maybe<Scalars['Int']>;
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  importLevelError?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pendingCount?: Maybe<Scalars['Int']>;
  processedCount?: Maybe<Scalars['Int']>;
  rows: Array<GqlBrandImportHistoryDetailRow>;
  startedAt?: Maybe<Scalars['ISODateTime']>;
  status?: Maybe<BrandImportStatusEnum>;
  successCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
  user?: Maybe<GqlBrandImportHistoryUser>;
};

export type GqlBrandImportHistoryUser = {
  __typename?: 'BrandImportHistoryUser';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export enum BrandImportStatusEnum {
  allRowsFailed = 'all_rows_failed',
  failed = 'failed',
  imported = 'imported',
  inProgress = 'in_progress',
  partiallyImported = 'partially_imported',
  pending = 'pending'
}

export type GqlBrandInventoryInsights = {
  __typename?: 'BrandInventoryInsights';
  avgSalesPerDay30d?: Maybe<Scalars['Float']>;
  daysOnHand?: Maybe<Scalars['Float']>;
  daysOnMenu30d?: Maybe<Scalars['Float']>;
  daysSold30d?: Maybe<Scalars['Float']>;
  excessInventoryValue?: Maybe<InventoryOpportunityEnum>;
  gmvOpportunity?: Maybe<InventoryOpportunityEnum>;
  gmvPerWeek?: Maybe<Scalars['Float']>;
  lastRestockDate?: Maybe<Scalars['String']>;
  rawExcessInventoryValue?: Maybe<Scalars['Float']>;
  rawGmvOpportunity?: Maybe<Scalars['Float']>;
  sellThroughRate?: Maybe<Scalars['Float']>;
  status: InventoryStatusEnum;
  unitsRemaining?: Maybe<Scalars['Int']>;
};

export type GqlBrandKeyMetric = {
  __typename?: 'BrandKeyMetric';
  changePct: Scalars['Float'];
  value: Scalars['Float'];
};

export type GqlBrandKeyMetrics = {
  __typename?: 'BrandKeyMetrics';
  avgUnitPrice: GqlBrandKeyMetric;
  gmv: GqlBrandKeyMetric;
  unitsSold: GqlBrandKeyMetric;
};

export type GqlBrandList = {
  __typename?: 'BrandList';
  brands: Array<Maybe<GqlBrand>>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandLocation = {
  __typename?: 'BrandLocation';
  details: GqlBrandLocationDetails;
  insights: GqlBrandRetailerInsights;
  settings: GqlBrandRetailerSettings;
};

export type GqlBrandLocationDetails = {
  __typename?: 'BrandLocationDetails';
  dposLocationId: Scalars['ID'];
  dposLocationName: Scalars['String'];
  dposLspId: Scalars['ID'];
  dposLspName: Scalars['String'];
  dposServerRegion: Scalars['String'];
  isoRegionCode: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  subdivision: Scalars['String'];
  subdivisionName?: Maybe<Scalars['String']>;
};

export type GqlBrandLocationsInsightsSummary = {
  __typename?: 'BrandLocationsInsightsSummary';
  locations: Array<GqlBrandLocation>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandLsp = {
  __typename?: 'BrandLsp';
  details: GqlBrandLspDetails;
  insights: GqlBrandRetailerInsights;
  settings: GqlBrandRetailerSettings;
};

export type GqlBrandLspDetails = {
  __typename?: 'BrandLspDetails';
  dposLspId: Scalars['ID'];
  dposLspName: Scalars['String'];
  dposServerRegion: Scalars['String'];
  isoRegionCode?: Maybe<Scalars['String']>;
  subdivision?: Maybe<Scalars['String']>;
  subdivisionName?: Maybe<Scalars['String']>;
};

export type GqlBrandLspItem = {
  __typename?: 'BrandLspItem';
  details: GqlBrandLspDetails;
  focusedAccount: Scalars['Boolean'];
};

export type GqlBrandLspsFilterInput = {
  inventoryLevel: InventoryLevelEnum;
  isoRegionCodes?: InputMaybe<Array<Scalars['String']>>;
  optInStatus?: InputMaybe<Scalars['Boolean']>;
};

export type GqlBrandLspsInsightsSummary = {
  __typename?: 'BrandLspsInsightsSummary';
  lsps: Array<GqlBrandLsp>;
  meta?: Maybe<GqlQueryInfoType>;
};

export enum BrandMergeHistoriesSortByEnum {
  createdAt = 'createdAt',
  revertedAt = 'revertedAt'
}

export type GqlBrandMergeHistory = {
  __typename?: 'BrandMergeHistory';
  createdAt: Scalars['ISODateTime'];
  destinationBrand: GqlBrand;
  destinationBrandId: Scalars['ID'];
  id: Scalars['ID'];
  revertedAt?: Maybe<Scalars['ISODateTime']>;
  sourceBrand: GqlBrand;
  sourceBrandId: Scalars['ID'];
  user?: Maybe<GqlUsers>;
  userId: Scalars['ID'];
};

export type GqlBrandMergeHistoryList = {
  __typename?: 'BrandMergeHistoryList';
  brandMergeHistories: Array<GqlBrandMergeHistory>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandOverviewLsp = {
  __typename?: 'BrandOverviewLsp';
  details: GqlBrandOverviewLspDetails;
  locationCount: Scalars['Int'];
  region: Scalars['String'];
  settings: GqlBrandOverviewLspSettings;
};

export type GqlBrandOverviewLspDetails = {
  __typename?: 'BrandOverviewLspDetails';
  dposLspId: Scalars['String'];
  dposLspImageUrl?: Maybe<Scalars['String']>;
  dposLspName: Scalars['String'];
  dposServerRegion: Scalars['String'];
};

export type GqlBrandOverviewLspSettings = {
  __typename?: 'BrandOverviewLspSettings';
  optInStatus: Scalars['Boolean'];
};

export type GqlBrandOverviewLspsFilterInput = {
  isoRegionCodes?: InputMaybe<Array<Scalars['String']>>;
  optInStatus?: InputMaybe<Scalars['Boolean']>;
};

export type GqlBrandOverviewLspsSummary = {
  __typename?: 'BrandOverviewLspsSummary';
  lsps: Array<GqlBrandOverviewLsp>;
  meta?: Maybe<GqlQueryInfoType>;
};

export enum BrandPortalProductSearchApprovalStatusFilterEnum {
  approved = 'approved',
  draft = 'draft',
  inReview = 'in_review',
  pending = 'pending',
  rejected = 'rejected'
}

export type GqlBrandPortalProductSearchResponse = {
  __typename?: 'BrandPortalProductSearchResponse';
  libraryProducts?: Maybe<Array<Maybe<GqlBrandPortalProductSearchResult>>>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandPortalProductSearchResult = {
  __typename?: 'BrandPortalProductSearchResult';
  approvalStatus?: Maybe<Scalars['String']>;
  brand?: Maybe<GqlBrand>;
  brandId: Scalars['ID'];
  category: Scalars['String'];
  complianceRegionId: Scalars['ID'];
  createdAt: Scalars['ISODateTime'];
  id: Scalars['ID'];
  menuScore?: Maybe<Scalars['Float']>;
  modelName: Scalars['String'];
  name: Scalars['String'];
};

export enum BrandPortalProductSearchSortByEnum {
  createdAt = 'createdAt',
  name = 'name'
}

export type GqlBrandProduct = {
  __typename?: 'BrandProduct';
  details: GqlBrandProductDetails;
  insights: GqlBrandInventoryInsights;
};

export type GqlBrandProductDetails = {
  __typename?: 'BrandProductDetails';
  productId: Scalars['ID'];
  productImageUrl?: Maybe<Scalars['String']>;
  productName: Scalars['String'];
};

export type GqlBrandProductInsightsSummary = {
  __typename?: 'BrandProductInsightsSummary';
  meta?: Maybe<GqlQueryInfoType>;
  products: Array<GqlBrandProduct>;
};

export type GqlBrandRegion = {
  __typename?: 'BrandRegion';
  isoRegionCode: Scalars['String'];
  subdivision: Scalars['String'];
  subdivisionName: Scalars['String'];
};

export type GqlBrandRegionsFilterInput = {
  inventoryLevel: InventoryLevelEnum;
};

export type GqlBrandRetailerInsights = {
  __typename?: 'BrandRetailerInsights';
  categoryLowStockAlerts: Scalars['Int'];
  categoryOutOfStockAlerts: Scalars['Int'];
  excessInventoryValue?: Maybe<InventoryOpportunityEnum>;
  expiringStockAlerts: Scalars['Int'];
  gmvOpportunity: InventoryOpportunityEnum;
  lowStockAlerts: Scalars['Int'];
  outOfStockAlerts: Scalars['Int'];
  overStockAlerts: Scalars['Int'];
  rawExcessInventoryValue?: Maybe<Scalars['Float']>;
  rawGmvOpportunity?: Maybe<Scalars['Float']>;
};

export type GqlBrandRetailerSettings = {
  __typename?: 'BrandRetailerSettings';
  optInStatus: Scalars['Boolean'];
};

export enum BrandSortByEnum {
  description = 'description',
  dispensary = 'dispensary',
  imageUrl = 'imageUrl',
  name = 'name',
  productsCount = 'productsCount',
  score = 'score',
  updatedAt = 'updatedAt'
}

export type GqlBrandSummary = {
  __typename?: 'BrandSummary';
  brandId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  centsChange?: Maybe<Scalars['Float']>;
  dispensaryId?: Maybe<Scalars['String']>;
  numProducts?: Maybe<Scalars['Int']>;
  percentChange?: Maybe<Scalars['Float']>;
  percentSales?: Maybe<Scalars['Float']>;
  totalSalesCents?: Maybe<Scalars['Float']>;
};

export type GqlBrandUser = {
  __typename?: 'BrandUser';
  authorizedBrandIds: Array<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  emails: Array<GqlUserEmails>;
  id: Scalars['ID'];
  profile?: Maybe<GqlBrandUserProfile>;
};

export type GqlBrandUserAccount = {
  __typename?: 'BrandUserAccount';
  accessToken?: Maybe<Scalars['String']>;
  emails: Array<GqlUserEmails>;
  id: Scalars['ID'];
  profile?: Maybe<GqlBrandUserProfile>;
};

export type GqlBrandUserFocusedAccount = {
  __typename?: 'BrandUserFocusedAccount';
  dposLspId: Scalars['String'];
  dposServerRegion: Scalars['String'];
};

export type GqlBrandUserList = {
  __typename?: 'BrandUserList';
  brandUsers: Array<GqlBrandUser>;
  meta?: Maybe<GqlMeta>;
};

export type GqlBrandUserPermissions = {
  __typename?: 'BrandUserPermissions';
  manageAdCampaigns: Scalars['Boolean'];
  manageBrandGroup: Scalars['Boolean'];
  manageBrands: Scalars['Boolean'];
};

export type GqlBrandUserProfile = {
  __typename?: 'BrandUserProfile';
  firstName?: Maybe<Scalars['String']>;
  focusedAccounts?: Maybe<Array<GqlBrandUserFocusedAccount>>;
  lastName?: Maybe<Scalars['String']>;
  parentBrand: GqlBrand;
  parentBrandId: Scalars['ID'];
  permissions?: Maybe<GqlBrandUserPermissions>;
  phone?: Maybe<Scalars['String']>;
};

export enum BrandUsersSortBy {
  createdAt = 'created_at'
}

export type GqlBrandsSummaryInput = {
  brand?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  chainId?: InputMaybe<Scalars['String']>;
  clientTimezone?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  prevEndDate?: InputMaybe<Scalars['String']>;
  prevStartDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type GqlBucket = {
  __typename?: 'Bucket';
  checkedOutAt?: Maybe<Scalars['ISODateTime']>;
  checkedOutBy?: Maybe<GqlUsers>;
  completedReviewsCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISODateTime'];
  createdBy?: Maybe<GqlUsers>;
  filters?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  products: Array<Maybe<GqlProducts>>;
  productsCount: Scalars['Int'];
  teamName: Scalars['String'];
  updatedAt: Scalars['ISODateTime'];
};

export type GqlBucketProduct = {
  __typename?: 'BucketProduct';
  bucketId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  oldProductData?: Maybe<GqlOldProductData>;
  product?: Maybe<GqlProducts>;
  productId?: Maybe<Scalars['ID']>;
  review?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['String']>;
  reviewedBy?: Maybe<Scalars['ID']>;
  reviewedByUser?: Maybe<GqlUsers>;
  updatedAt?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type GqlBucketProductsMeta = {
  __typename?: 'BucketProductsMeta';
  reviewers?: Maybe<Array<Maybe<GqlUsers>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GqlBucketV2 = {
  __typename?: 'BucketV2';
  checkedOutAt?: Maybe<Scalars['ISODateTime']>;
  checkedOutBy?: Maybe<GqlUsers>;
  completedReviewsCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISODateTime'];
  createdBy?: Maybe<GqlUsers>;
  filters?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productIds: Array<Maybe<Scalars['String']>>;
  productsCount: Scalars['Int'];
  teamName: Scalars['String'];
  updatedAt: Scalars['ISODateTime'];
};

export type GqlBulkLibraryProductStatusUpdateMeta = {
  __typename?: 'BulkLibraryProductStatusUpdateMeta';
  status?: Maybe<Scalars['String']>;
};

export type GqlBulkLibraryProductStatusUpdateResponse = {
  __typename?: 'BulkLibraryProductStatusUpdateResponse';
  meta?: Maybe<GqlBulkLibraryProductStatusUpdateMeta>;
};

export type GqlBulkLibraryProductUpdateMeta = {
  __typename?: 'BulkLibraryProductUpdateMeta';
  jobId?: Maybe<Scalars['String']>;
  statusPath?: Maybe<Scalars['String']>;
};

export type GqlBulkLibraryProductUpdateResponse = {
  __typename?: 'BulkLibraryProductUpdateResponse';
  meta?: Maybe<GqlBulkLibraryProductUpdateMeta>;
};

export type GqlBulkLibraryProductUpdates = {
  brandId?: InputMaybe<Scalars['String']>;
  descriptionHtml?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subcategory?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type GqlBulkLibraryProductUploadError = {
  __typename?: 'BulkLibraryProductUploadError';
  message: Scalars['String'];
  row: Scalars['Int'];
};

export enum BulkLibraryProductUploadJobStatus {
  complete = 'complete',
  error = 'error',
  pending = 'pending',
  processing = 'processing'
}

export type GqlBulkLibraryProductUploadMetadata = {
  __typename?: 'BulkLibraryProductUploadMetadata';
  errorCount?: Maybe<Scalars['Int']>;
  successCount?: Maybe<Scalars['Int']>;
};

export type GqlBulkLibraryProductUploadResponse = {
  __typename?: 'BulkLibraryProductUploadResponse';
  jobStatusId: Scalars['ID'];
};

export type GqlBulkLibraryProductUploadStatusResponse = {
  __typename?: 'BulkLibraryProductUploadStatusResponse';
  errors?: Maybe<Array<GqlBulkLibraryProductUploadError>>;
  id: Scalars['ID'];
  metadata?: Maybe<GqlBulkLibraryProductUploadMetadata>;
  status: BulkLibraryProductUploadJobStatus;
  userId: Scalars['ID'];
};

/** Individual Product with buying data for delivery/pickup */
export type GqlBuyingOption = {
  __typename?: 'BuyingOption';
  delivery?: Maybe<GqlDurationEstimateRange>;
  distance?: Maybe<Scalars['String']>;
  pickup?: Maybe<GqlDurationEstimateRange>;
  product: GqlProducts;
};

export enum CacheControlScope {
  private = 'PRIVATE',
  public = 'PUBLIC'
}

export type GqlCalculateCheckout = {
  __typename?: 'CalculateCheckout';
  items: Array<GqlCalculateCheckoutItem>;
  priceSummary: GqlPriceSummary;
};

export type GqlCalculateCheckoutInput = {
  dispensaryId: Scalars['String'];
  items: Array<GqlCalculateCheckoutInputItem>;
  orderType: ReservationSlotTypes;
  pricingType: MenuPricingTypes;
};

export type GqlCalculateCheckoutInputItem = {
  option: Scalars['String'];
  productId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type GqlCalculateCheckoutItem = {
  __typename?: 'CalculateCheckoutItem';
  basePrice?: Maybe<Scalars['Float']>;
  discounts?: Maybe<GqlItemDiscounts>;
  errors: Array<Scalars['String']>;
  isDiscounted?: Maybe<Scalars['Boolean']>;
  option: Scalars['String'];
  productId: Scalars['String'];
  quantity: Scalars['Int'];
  taxes?: Maybe<GqlItemTaxes>;
  valid: Scalars['Boolean'];
};

export type GqlCalculationResults = {
  __typename?: 'CalculationResults';
  cartItemPrices?: Maybe<Array<Maybe<GqlCartItem>>>;
  discount?: Maybe<Scalars['Int']>;
  discountGamification?: Maybe<GqlCalculationResults_CartGamification>;
  discountWithoutLoyalty?: Maybe<Scalars['Float']>;
  fees?: Maybe<Array<Maybe<GqlFees>>>;
  grandTotal?: Maybe<Scalars['Int']>;
  itemTaxes?: Maybe<Array<Maybe<GqlItemTax>>>;
  loyaltyAppliedAsDiscount?: Maybe<Scalars['Float']>;
  loyaltyPointsUsed?: Maybe<Scalars['Int']>;
  originalTotal?: Maybe<Scalars['Int']>;
  posCustomerId?: Maybe<Scalars['Int']>;
  rewardValidationErrors?: Maybe<Array<Maybe<GqlRewardValidationError>>>;
  roundedDifference?: Maybe<Scalars['Int']>;
  subTotal?: Maybe<Scalars['Int']>;
  taxInclusivePricing?: Maybe<Scalars['Boolean']>;
  taxes?: Maybe<Scalars['Int']>;
  totalBottleDepositTax?: Maybe<Scalars['Int']>;
  totalCannabisTax?: Maybe<Scalars['Int']>;
  totalSalesTax?: Maybe<Scalars['Int']>;
};

export type GqlCalculationResults_CartGamification = {
  __typename?: 'CalculationResults_CartGamification';
  gamificationDetails?: Maybe<Array<Maybe<GqlGamificationDetailItem>>>;
};

export type GqlCalculationsInput = {
  cart: Array<GqlCartItemInput>;
  codeRedemptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** @deprecated 3/12/25: Use ecomUserId instead */
  customerId?: InputMaybe<Scalars['Int']>;
  customerTypeId: Scalars['Int'];
  deliveryCity?: InputMaybe<Scalars['String']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']>;
  deliveryScheduleId?: InputMaybe<Scalars['Int']>;
  deliveryState?: InputMaybe<Scalars['String']>;
  deliveryStreet?: InputMaybe<Scalars['String']>;
  deliveryStreet2?: InputMaybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  ecomUserId?: InputMaybe<Scalars['String']>;
  includeGamification?: InputMaybe<Scalars['Boolean']>;
  isDelivery?: InputMaybe<Scalars['Boolean']>;
  loyaltyPointsApplied?: InputMaybe<Scalars['Float']>;
  payerId?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  platformType?: InputMaybe<PlatformType>;
  posCustomerId?: InputMaybe<Scalars['String']>;
  preOrderType?: InputMaybe<PreOrderType>;
  rewardRedemptions?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type GqlCampaignSummary = {
  __typename?: 'CampaignSummary';
  averageOrderValue?: Maybe<Scalars['Float']>;
  averageOrderValueChangePercentage?: Maybe<Scalars['Float']>;
  conversionPercentage?: Maybe<Scalars['Float']>;
  conversionPercentageUnitChange?: Maybe<Scalars['Float']>;
  totalSales?: Maybe<Scalars['Float']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
};

export type GqlCannabinoid = {
  __typename?: 'Cannabinoid';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Major type of cannabis for a product */
export enum CannabisType {
  highCbd = 'HIGH_CBD',
  hybrid = 'HYBRID',
  indica = 'INDICA',
  nA = 'N_A',
  sativa = 'SATIVA',
  seed = 'SEED'
}

export type GqlCartItem = {
  __typename?: 'CartItem';
  discounts?: Maybe<Array<Maybe<GqlDiscount>>>;
  menuPrice?: Maybe<Scalars['Int']>;
  pricingTierAdjustment?: Maybe<Scalars['Int']>;
  pricingTierAdjustmentTotal?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  productName?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Int']>;
  summaryPrice?: Maybe<Scalars['Int']>;
  tax?: Maybe<Scalars['Int']>;
  unitPrice?: Maybe<Scalars['Int']>;
  unitWeightGrams?: Maybe<Scalars['Float']>;
};

export type GqlCartItemInput = {
  ecommKey?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  unitWeightGrams?: InputMaybe<Scalars['Float']>;
};

export type GqlCartSummary = {
  __typename?: 'CartSummary';
  createdAt: Scalars['ISODateTime'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  valueInCents: Scalars['Float'];
};

export enum Categories {
  accessories = 'ACCESSORIES',
  apparel = 'APPAREL',
  cbd = 'CBD',
  clones = 'CLONES',
  concentrate = 'CONCENTRATE',
  edible = 'EDIBLE',
  flower = 'FLOWER',
  /** Pain - should really be PRE-ROLLS */
  prerolls = 'PREROLLS',
  seeds = 'SEEDS',
  tincture = 'TINCTURE',
  topicals = 'TOPICALS',
  vaporizers = 'VAPORIZERS'
}

export type GqlCategoriesInput = {
  items?: InputMaybe<Array<InputMaybe<GqlCategoryInput>>>;
  mobileDisplay?: InputMaybe<CategoriesMobileDisplayOption>;
  style?: InputMaybe<RadiusOption>;
  type?: InputMaybe<CategoriesTypeOption>;
};

export enum CategoriesMobileDisplayOption {
  grid = 'GRID',
  row = 'ROW'
}

export enum CategoriesTypeOption {
  compact = 'COMPACT',
  large = 'LARGE',
  stacked = 'STACKED',
  text = 'TEXT'
}

export type GqlCategoryInput = {
  category: Scalars['String'];
  collectionId?: InputMaybe<Scalars['String']>;
  image: Scalars['String'];
};

export type GqlCategoryLineItem = {
  __typename?: 'CategoryLineItem';
  categoryOption?: Maybe<Scalars['String']>;
  percentOfTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  productType?: Maybe<Scalars['String']>;
  totalSales?: Maybe<Scalars['Float']>;
};

export type GqlCategoryPhoto = {
  __typename?: 'CategoryPhoto';
  category?: Maybe<Scalars['String']>;
  src?: Maybe<Scalars['String']>;
};

export type GqlCategorySubcategories = {
  __typename?: 'CategorySubcategories';
  category: Scalars['String'];
  subcategories: Array<Scalars['String']>;
};

export type GqlCategorySummary = {
  __typename?: 'CategorySummary';
  category?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type GqlChain = {
  __typename?: 'Chain';
  chainId?: Maybe<Scalars['String']>;
  dispensaryCount?: Maybe<Scalars['Int']>;
  dispensaryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastThirtyDaysSales?: Maybe<Scalars['Float']>;
};

export type GqlChainBillingMigrationInput = {
  chargebeeCustomerId: Scalars['ID'];
  chargebeeSubscriptionId: Scalars['ID'];
  dispensaryId: Scalars['ID'];
  manualPayments: Scalars['Boolean'];
};

export type GqlChainBillingReturn = {
  __typename?: 'ChainBillingReturn';
  error?: Maybe<Array<Maybe<GqlChainBillingReturnData>>>;
  success?: Maybe<Array<Maybe<GqlChainBillingReturnData>>>;
};

export type GqlChainBillingReturnData = {
  __typename?: 'ChainBillingReturnData';
  chain?: Maybe<Scalars['Boolean']>;
  chargebeeCustomerId?: Maybe<Scalars['String']>;
  chargebeeSubscriptionId?: Maybe<Scalars['String']>;
  dispensaryBillingId?: Maybe<Scalars['String']>;
  dispensaryId?: Maybe<Scalars['String']>;
  manualPayments?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  previousChargebeeCustomerId?: Maybe<Scalars['String']>;
  previousChargebeeSubscriptionId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type GqlChainDropdownOption = {
  __typename?: 'ChainDropdownOption';
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlChainFilterInput = {
  searchStr?: InputMaybe<Scalars['String']>;
};

export type GqlChainList = {
  __typename?: 'ChainList';
  chains?: Maybe<Array<Maybe<GqlChain>>>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlChainPaginationInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type GqlChainSortInput = {
  sortBy: Scalars['String'];
  sortDirection: Scalars['String'];
};

export type GqlChangeHistoryObject = {
  __typename?: 'ChangeHistoryObject';
  date?: Maybe<Scalars['String']>;
  totalSales?: Maybe<Scalars['Float']>;
};

export enum ChangeRequestActionType {
  createBrand = 'create_brand',
  createProduct = 'create_product',
  deleteProduct = 'delete_product',
  updateBrand = 'update_brand',
  updateProduct = 'update_product'
}

export enum ChannelSources {
  embedded = 'EMBEDDED',
  kiosk = 'KIOSK',
  main = 'MAIN',
  retailerMobile = 'RETAILER_MOBILE'
}

export type GqlChargeBeeHostedPage = {
  __typename?: 'ChargeBeeHostedPage';
  createdAt?: Maybe<Scalars['String']>;
  embed?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type GqlChargebeeCard = {
  __typename?: 'ChargebeeCard';
  brand?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
};

export type GqlChargebeeContact = {
  __typename?: 'ChargebeeContact';
  email?: Maybe<Scalars['String']>;
  sendBillingEmail?: Maybe<Scalars['Boolean']>;
};

export type GqlChargebeeCustomer = {
  __typename?: 'ChargebeeCustomer';
  company?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<Maybe<GqlChargebeeContact>>>;
  id?: Maybe<Scalars['ID']>;
  locationCount?: Maybe<Scalars['Int']>;
};

export type GqlChargebeeDownload = {
  __typename?: 'ChargebeeDownload';
  downloadUrl: Scalars['String'];
  object: Scalars['String'];
  validTill: Scalars['Int'];
};

export type GqlChargebeeLineItem = {
  __typename?: 'ChargebeeLineItem';
  amount?: Maybe<Scalars['Int']>;
  dateFrom?: Maybe<Scalars['Int']>;
  dateTo?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type GqlChargebeePaymentSource = {
  __typename?: 'ChargebeePaymentSource';
  card?: Maybe<GqlChargebeeCard>;
  customerId?: Maybe<Scalars['String']>;
  gateway?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GqlChargebeePlan = {
  __typename?: 'ChargebeePlan';
  period: Scalars['Int'];
  periodUnit: Scalars['String'];
};

export type GqlChargebeeSubscription = {
  __typename?: 'ChargebeeSubscription';
  activatedAt?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Int']>;
  currentTermEnd?: Maybe<Scalars['Int']>;
  currentTermStart?: Maybe<Scalars['Int']>;
  invoices?: Maybe<Array<Maybe<GqlInvoice>>>;
  nextBillingAt?: Maybe<Scalars['Int']>;
  planAmount?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  trialEnd?: Maybe<Scalars['Int']>;
  trialStart?: Maybe<Scalars['Int']>;
};

export type GqlChargebeeSubscriptionV2 = {
  __typename?: 'ChargebeeSubscriptionV2';
  activatedAt?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Int']>;
  currentTermEnd?: Maybe<Scalars['Int']>;
  currentTermStart?: Maybe<Scalars['Int']>;
  invoices?: Maybe<Array<GqlInvoice>>;
  nextBillingAt?: Maybe<Scalars['Int']>;
  planAmount?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['ID']>;
  startedAt?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  trialEnd?: Maybe<Scalars['Int']>;
  trialStart?: Maybe<Scalars['Int']>;
};

export type GqlChaseHostedProfileCredentials = GqlCheckoutCredentialsBase & {
  __typename?: 'ChaseHostedProfileCredentials';
  adapter: Scalars['String'];
  uID: Scalars['String'];
};

export type GqlCheckPurchaseLimitsCartItem = {
  id: Scalars['String'];
  option: Scalars['String'];
  quantity: Scalars['Int'];
};

export type GqlCheckPurchaseLimitsInput = {
  customerState: Scalars['String'];
  dispensaryId: Scalars['String'];
  existingItems: Array<GqlCheckPurchaseLimitsCartItem>;
  idToAdd: Scalars['String'];
  isChangingQuantity?: InputMaybe<Scalars['Boolean']>;
  isMedical?: InputMaybe<Scalars['Boolean']>;
  option: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
};

export type GqlCheckPurchaseLimitsResult = {
  __typename?: 'CheckPurchaseLimitsResult';
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  passesCheck: Scalars['Boolean'];
};

export type GqlCheckout = {
  __typename?: 'Checkout';
  address?: Maybe<GqlCheckoutAddress>;
  dispensaryId: Scalars['String'];
  id: Scalars['ID'];
  items: Array<GqlCheckoutItem>;
  orderType: Scalars['String'];
  pricingType: Scalars['String'];
};

export type GqlCheckoutAddress = {
  __typename?: 'CheckoutAddress';
  city?: Maybe<Scalars['String']>;
  deliverable: Scalars['Boolean'];
  formatted?: Maybe<Scalars['String']>;
  geometry?: Maybe<GqlCheckoutAddressGeometry>;
  state?: Maybe<Scalars['String']>;
  street1?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  valid: Scalars['Boolean'];
  zip?: Maybe<Scalars['String']>;
};

export type GqlCheckoutAddressGeometry = {
  __typename?: 'CheckoutAddressGeometry';
  coordinates?: Maybe<Array<Scalars['Float']>>;
  type?: Maybe<Scalars['String']>;
};

export type GqlCheckoutAddressInput = {
  city: Scalars['String'];
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type GqlCheckoutCredentialsBase = {
  adapter: Scalars['String'];
};

export type GqlCheckoutItem = {
  __typename?: 'CheckoutItem';
  checkoutId: Scalars['String'];
  id: Scalars['ID'];
  option: Scalars['String'];
  product?: Maybe<GqlProducts>;
  productId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type GqlCollection = {
  __typename?: 'Collection';
  allConditions: Scalars['Boolean'];
  cardBadgeColor?: Maybe<Scalars['String']>;
  cardBadgeEnabled: Scalars['Boolean'];
  cardBadgeTitle?: Maybe<Scalars['String']>;
  conditions: Array<GqlCondition>;
  customCategory?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  isAccessibleToCurrentUser?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isExclusive?: Maybe<Scalars['Boolean']>;
  matchAllSegmentConditions?: Maybe<Scalars['Boolean']>;
  navigationEnabled: Scalars['Boolean'];
  navigationTitle?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  productCount: Scalars['Int'];
  schedule?: Maybe<GqlSchedule>;
  segmentConditions?: Maybe<Array<GqlSegmentCondition>>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type GqlCollectionCardBadge = {
  __typename?: 'CollectionCardBadge';
  color?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type GqlCollectionPositionsInput = {
  collectionId: Scalars['ID'];
  position?: InputMaybe<Scalars['Int']>;
};

export type GqlCollectionProductCount = {
  __typename?: 'CollectionProductCount';
  id?: Maybe<Scalars['ID']>;
  productCount: Scalars['Int'];
};

export enum CollisionType {
  globalToGlobal = 'globalToGlobal',
  globalToLocal = 'globalToLocal',
  localToGlobal = 'localToGlobal',
  localToLocal = 'localToLocal'
}

export type GqlColorInput = {
  buttonsLinks?: InputMaybe<Scalars['String']>;
  discountTag?: InputMaybe<Scalars['String']>;
  navBar?: InputMaybe<Scalars['String']>;
  productCardButton?: InputMaybe<ProductCardButtonOption>;
  staffPickTag?: InputMaybe<Scalars['String']>;
};

export type GqlColorSettings = {
  __typename?: 'ColorSettings';
  linkColor?: Maybe<Scalars['String']>;
  navBarColor?: Maybe<Scalars['String']>;
};

export type GqlColorSettingsInputV2 = {
  linkColor: LinkColor;
  navBarColor: NavBarColor;
};

export type GqlColorSettingsV2 = {
  __typename?: 'ColorSettingsV2';
  linkColor: LinkColor;
  navBarColor: NavBarColor;
};

export type GqlColors = {
  __typename?: 'Colors';
  buttonsLinks?: Maybe<Scalars['String']>;
  discountTag?: Maybe<Scalars['String']>;
  navBar?: Maybe<Scalars['String']>;
  productCardButton?: Maybe<ProductCardButtonOption>;
  staffPickTag?: Maybe<Scalars['String']>;
};

export enum ComparisonOperators {
  between = 'between',
  equalTo = 'equalTo',
  greaterThan = 'greaterThan',
  greaterThanEqualTo = 'greaterThanEqualTo',
  lessThan = 'lessThan',
  lessThanEqualTo = 'lessThanEqualTo'
}

export type GqlCompleteAggregatorLinkResponse = {
  __typename?: 'CompleteAggregatorLinkResponse';
  paymentMethods: Array<Maybe<GqlBankAccountPaymentMethod>>;
};

export type GqlCondition = {
  __typename?: 'Condition';
  condition: Scalars['String'];
  id: Scalars['ID'];
  itemKey: Scalars['String'];
  itemValue: Scalars['String'];
  productCollectionId: Scalars['String'];
};

export enum ConditionType {
  item = 'ITEM',
  quantity = 'QUANTITY',
  spend = 'SPEND',
  weight = 'WEIGHT'
}

export type GqlConnectProductPreviewResponse = {
  __typename?: 'ConnectProductPreviewResponse';
  previewProduct: GqlPreviewProduct;
};

export enum ConnectionStatus {
  connectionStatusActive = 'CONNECTION_STATUS_ACTIVE',
  connectionStatusError = 'CONNECTION_STATUS_ERROR',
  connectionStatusPendingExpiration = 'CONNECTION_STATUS_PENDING_EXPIRATION',
  connectionStatusRevoked = 'CONNECTION_STATUS_REVOKED',
  connectionStatusUnspecified = 'CONNECTION_STATUS_UNSPECIFIED'
}

export type GqlConsumerDispensaryIntegrations = {
  __typename?: 'ConsumerDispensaryIntegrations';
  alpineiq?: Maybe<GqlDispensaries_Integrations>;
  dutchieposloyalty?: Maybe<GqlDispensaries_Integrations>;
  fyllo?: Maybe<GqlDispensaries_Integrations>;
  springbig?: Maybe<GqlDispensaries_Integrations>;
};

export type GqlConsumerStreamCredentials = {
  __typename?: 'ConsumerStreamCredentials';
  id?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type GqlConsumerUser = {
  __typename?: 'ConsumerUser';
  _id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  customers?: Maybe<Array<Maybe<GqlCustomers>>>;
  email?: Maybe<Scalars['String']>;
  profile?: Maybe<GqlConsumerUserProfile>;
};

export type GqlContactCrmProperty = GqlCrmProperty & {
  __typename?: 'ContactCrmProperty';
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlContentChangeRequestAttributes = {
  __typename?: 'ContentChangeRequestAttributes';
  brandId?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  cbdContent?: Maybe<GqlContentChangeRequestPotency>;
  connectedCount?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  effects?: Maybe<Scalars['JSON']>;
  image?: Maybe<Scalars['String']>;
  medicalOnly?: Maybe<Scalars['Boolean']>;
  menu_score?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  prices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  recOnly?: Maybe<Scalars['Boolean']>;
  strainType?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
  thcContent?: Maybe<GqlContentChangeRequestPotency>;
};

export type GqlContentChangeRequestComputedAttributes = {
  __typename?: 'ContentChangeRequestComputedAttributes';
  actionType?: Maybe<ChangeRequestActionType>;
  approvalStatus?: Maybe<Scalars['String']>;
  authorId?: Maybe<Scalars['ID']>;
  brandId?: Maybe<Scalars['ID']>;
  brandName?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  complianceRegionId?: Maybe<Scalars['String']>;
  connectedCount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  reviewerId?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type GqlContentChangeRequestFilters = {
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  category?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type GqlContentChangeRequestMeta = {
  __typename?: 'ContentChangeRequestMeta';
  filters?: Maybe<GqlContentChangeRequestMetaFilters>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GqlContentChangeRequestMetaFilterNumber = {
  __typename?: 'ContentChangeRequestMetaFilterNumber';
  label?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

export type GqlContentChangeRequestMetaFilterText = {
  __typename?: 'ContentChangeRequestMetaFilterText';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlContentChangeRequestMetaFilters = {
  __typename?: 'ContentChangeRequestMetaFilters';
  approvalStatus?: Maybe<Array<Maybe<GqlContentChangeRequestMetaFilterText>>>;
  brand?: Maybe<Array<Maybe<GqlContentChangeRequestMetaFilterText>>>;
  score?: Maybe<Array<Maybe<GqlContentChangeRequestMetaFilterNumber>>>;
  state?: Maybe<Array<Maybe<GqlContentChangeRequestMetaFilterText>>>;
};

export type GqlContentChangeRequestPotency = {
  __typename?: 'ContentChangeRequestPotency';
  range?: Maybe<Array<Maybe<Scalars['Float']>>>;
  unit?: Maybe<Scalars['String']>;
};

export type GqlContentChangeRequestSort = {
  sortBy: ContentChangeRequestSortByEnum;
  sortDirection: StringSortDirections;
};

export enum ContentChangeRequestSortByEnum {
  approvalStatus = 'approvalStatus',
  brandName = 'brandName',
  category = 'category',
  connectedCount = 'connectedCount',
  createdAt = 'createdAt',
  createdBy = 'createdBy',
  description = 'description',
  name = 'name',
  productName = 'productName',
  score = 'score',
  state = 'state'
}

export type GqlContentChangeRequests = {
  __typename?: 'ContentChangeRequests';
  contentChangeRequests?: Maybe<Array<Maybe<GqlSerializableContentChangeRequest>>>;
  meta?: Maybe<GqlContentChangeRequestMeta>;
};

export type GqlContentStatistics = {
  __typename?: 'ContentStatistics';
  connectedPercentage?: Maybe<Scalars['Float']>;
  menuScore?: Maybe<Scalars['Float']>;
};

export type GqlCopyLibraryProductErrors = {
  __typename?: 'CopyLibraryProductErrors';
  errors?: Maybe<Scalars['String']>;
  state_library_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GqlCopyLibraryProductMeta = {
  __typename?: 'CopyLibraryProductMeta';
  errors?: Maybe<Array<Maybe<GqlCopyLibraryProductErrors>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GqlCopyLibraryProductResponse = {
  __typename?: 'CopyLibraryProductResponse';
  libraryProducts?: Maybe<Array<Maybe<GqlLibraryProduct>>>;
  meta?: Maybe<GqlCopyLibraryProductMeta>;
};

export type GqlCouponList = {
  __typename?: 'CouponList';
  coupons?: Maybe<Array<Maybe<GqlCoupons>>>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlCouponSummary = {
  __typename?: 'CouponSummary';
  averageOrderValue?: Maybe<Scalars['Float']>;
  averageOrderValueChangePercentage?: Maybe<Scalars['Float']>;
  averageUsageChangePercentage?: Maybe<Scalars['Float']>;
  couponId?: Maybe<Scalars['String']>;
  couponName?: Maybe<Scalars['String']>;
  currentUsage?: Maybe<Scalars['Int']>;
  discount?: Maybe<Scalars['String']>;
  prevTotalSales?: Maybe<Scalars['Float']>;
  prevUsage?: Maybe<Scalars['Int']>;
  revenue?: Maybe<Scalars['Float']>;
};

export type GqlCouponValidationResponse = {
  __typename?: 'CouponValidationResponse';
  coupon?: Maybe<GqlCoupons>;
  isValid?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
};

export type GqlCouponValueInput = {
  _id?: InputMaybe<Scalars['String']>;
  applicableCategories?: InputMaybe<Array<InputMaybe<GqlCoupon_ApplicableCategoriesInput>>>;
  code?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  dollar?: InputMaybe<Scalars['Float']>;
  expDate?: InputMaybe<Scalars['String']>;
  fixedDiscountInCents?: InputMaybe<Scalars['Int']>;
  percent?: InputMaybe<Scalars['Float']>;
  percentDiscount?: InputMaybe<Scalars['Float']>;
  restrictions?: InputMaybe<GqlCouponRestrictionsInput>;
  usedBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GqlCoupons = {
  __typename?: 'Coupons';
  _id: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  addedDate?: Maybe<Scalars['String']>;
  /** @deprecated Replaced by percentDiscount || fixedDiscountInCents */
  amount?: Maybe<Scalars['String']>;
  applicableCategories?: Maybe<Array<Maybe<GqlCouponApplicableCategory>>>;
  code?: Maybe<Scalars['String']>;
  dispensary?: Maybe<Scalars['String']>;
  dispensaryId?: Maybe<Scalars['String']>;
  expDate?: Maybe<Scalars['String']>;
  fixedDiscountInCents?: Maybe<Scalars['Int']>;
  numAllowedUses?: Maybe<Scalars['Int']>;
  numUses?: Maybe<Scalars['Int']>;
  oneUsePerCustomer?: Maybe<Scalars['Boolean']>;
  percentDiscount?: Maybe<Scalars['Float']>;
  reimbursed?: Maybe<Scalars['Boolean']>;
  restrictions?: Maybe<GqlCouponRestrictions>;
  usedBy?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GqlCreateBankAccountResponse = {
  __typename?: 'CreateBankAccountResponse';
  bankAccount?: Maybe<GqlPaymentMethod>;
};

export type GqlCreateBillingGroupInput = {
  enterpriseId: Scalars['ID'];
  name: Scalars['String'];
  notificationEmails: Array<Scalars['String']>;
  payment: GqlPaymentMethodInput;
  retailers: Array<InputMaybe<Scalars['ID']>>;
};

export type GqlCreateCheckoutInputCartItem = {
  option: Scalars['String'];
  productId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type GqlCreateCheckoutInputCustomerInfo = {
  address?: InputMaybe<GqlCheckoutAddressInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type GqlCreateFraudAccountResponse = {
  __typename?: 'CreateFraudAccountResponse';
  success: Scalars['Boolean'];
};

export type GqlCreateFraudInput = {
  name: Scalars['String'];
  paymentMethods: Array<InputMaybe<GqlFraudPaymentMethod>>;
  phone: Scalars['String'];
  userEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type GqlCreateInstoreCartUrlResponse = {
  __typename?: 'CreateInstoreCartUrlResponse';
  instoreCartUrl: Scalars['String'];
};

export type GqlCreateMxEnrollmentResponse = {
  __typename?: 'CreateMxEnrollmentResponse';
  billingAddress?: Maybe<GqlBillingAddress>;
  url: Scalars['String'];
};

export type GqlCreateOrUpdateAchReturnResponse = {
  __typename?: 'CreateOrUpdateAchReturnResponse';
  achReturn: GqlAchReturnV2;
};

export type GqlCreateOrUpdateAchReturnResponseV4 = {
  __typename?: 'CreateOrUpdateAchReturnResponseV4';
  achReturn: GqlAchReturnV4;
};

export type GqlCreateOrUpdateAchReturnResponseV5 = {
  __typename?: 'CreateOrUpdateAchReturnResponseV5';
  achReturn: GqlAchReturnV5;
};

export type GqlCreateOrderError = {
  __typename?: 'CreateOrderError';
  extensions?: Maybe<Scalars['JSON']>;
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  params?: Maybe<Scalars['JSON']>;
  path?: Maybe<Scalars['String']>;
};

export type GqlCreateOrderResponse = {
  __typename?: 'CreateOrderResponse';
  errors?: Maybe<Array<Maybe<GqlCreateOrderError>>>;
  order?: Maybe<GqlOrders>;
  valid: Scalars['Boolean'];
};

export type GqlCreatePosMedUserInput = {
  alcoholUse: Scalars['Boolean'];
  bipolar: Scalars['Boolean'];
  bipolarManager?: InputMaybe<Scalars['String']>;
  bipolarMedications?: InputMaybe<Scalars['String']>;
  bipolarRisk?: InputMaybe<Scalars['Boolean']>;
  bipolarStable?: InputMaybe<Scalars['Boolean']>;
  city: Scalars['String'];
  currentMedicalCannabisUse: Scalars['Boolean'];
  currentlyBreastfeeding?: InputMaybe<Scalars['Boolean']>;
  currentlyPregnant?: InputMaybe<Scalars['Boolean']>;
  dateOfBirth: Scalars['String'];
  driversLicense: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender: Scalars['String'];
  historyOfSuicide?: InputMaybe<Scalars['Boolean']>;
  hospitalizedOrSurguries: Scalars['Boolean'];
  howOftenAlcohol?: InputMaybe<Scalars['String']>;
  howOftenTobacco?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  listMentalHealthConditions?: InputMaybe<Scalars['String']>;
  listOfAllergies?: InputMaybe<Scalars['String']>;
  listOfMedications?: InputMaybe<Scalars['String']>;
  medAllergies: Scalars['Boolean'];
  medicalCondition: Scalars['String'];
  mentalConditions: Scalars['Boolean'];
  mentalMedications?: InputMaybe<Scalars['String']>;
  opioidsOrLithium: Scalars['Boolean'];
  opioidsOrLithiumDoctor?: InputMaybe<Scalars['String']>;
  opioidsOrLithiumReason?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  physicallyDisabled: Scalars['Boolean'];
  preferredDispensary?: InputMaybe<Scalars['String']>;
  recentHospitalizationReason?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  streetAddress: Scalars['String'];
  takingMedications: Scalars['Boolean'];
  tobaccoUse: Scalars['Boolean'];
  unit: Scalars['String'];
  waitingAtDispensary: Scalars['Boolean'];
  zipCode: Scalars['String'];
};

export type GqlCreatePaymentCard = {
  billingPostalCode: Scalars['String'];
  cardholderFirstName?: InputMaybe<Scalars['String']>;
  cardholderLastName?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

export type GqlCreatePaymentCustomerDetails = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};

export type GqlCreatePaymentPayment = {
  __typename?: 'CreatePaymentPayment';
  amount?: Maybe<Scalars['Int']>;
  checkoutToken?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<PaymentStatus>;
  tipAMount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlCreatePaymentResponse = {
  __typename?: 'CreatePaymentResponse';
  payment: GqlCreatePaymentPayment;
  redirectUrl?: Maybe<Scalars['String']>;
};

export type GqlCreatePointsBoostInput = {
  dispensaryId: Scalars['String'];
  program?: InputMaybe<Scalars['String']>;
  signedUpForLoyalty?: InputMaybe<Scalars['Boolean']>;
  signedUpForPbb?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type GqlCreatePrintJobInput = {
  dispensaryId: Scalars['String'];
  orderId: Scalars['String'];
  printerId?: InputMaybe<Scalars['String']>;
};

export type GqlCreatePrintJobResponse = {
  __typename?: 'CreatePrintJobResponse';
  printJob: GqlPrintJob;
  success: Scalars['Boolean'];
};

export type GqlCreateRetailerEnrollmentResponse = {
  __typename?: 'CreateRetailerEnrollmentResponse';
  paymentMethod: GqlDutchiePayPaymentMethod;
};

export type GqlCrmProperties = {
  __typename?: 'CrmProperties';
  foreignProperties?: Maybe<GqlPropertyTypes>;
  localProperties?: Maybe<GqlPropertyTypes>;
};

export type GqlCrmProperty = {
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlCrossingMindsAuthResponse = {
  __typename?: 'CrossingMindsAuthResponse';
  jwtToken: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type GqlCurbsideArrival = {
  __typename?: 'CurbsideArrival';
  arrivalInformation?: Maybe<Scalars['String']>;
  arrivedAt?: Maybe<Scalars['ISODateTime']>;
  clearedAt?: Maybe<Scalars['ISODateTime']>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  dispensary?: Maybe<GqlDispensaries>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<GqlOrders>;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
};

export type GqlCurbsidePickupInput = {
  arrivalInformationInstructions?: InputMaybe<Scalars['String']>;
  checkoutMessage?: InputMaybe<Scalars['String']>;
  enableASAPOrdering?: InputMaybe<Scalars['Boolean']>;
  enableAfterHoursOrdering?: InputMaybe<Scalars['Boolean']>;
  enableCurbsideArrivals?: InputMaybe<Scalars['Boolean']>;
  enableScheduledOrdering?: InputMaybe<Scalars['Boolean']>;
  orderMinimum?: InputMaybe<GqlOrderMinimumInput>;
  paymentTypes?: InputMaybe<GqlDispensaryUpdatePaymentTypeConfig>;
  pickupReminders?: InputMaybe<GqlPickupRemindersInput>;
  scheduledOrderingConfig?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
};

export type GqlCurbsidePickupOrderingSettings = GqlBaseOrderingSettings & {
  __typename?: 'CurbsidePickupOrderingSettings';
  arrivalInformationInstructions?: Maybe<Scalars['String']>;
  checkoutMessage?: Maybe<Scalars['String']>;
  enableASAPOrdering?: Maybe<Scalars['Boolean']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']>;
  enableCurbsideArrivals?: Maybe<Scalars['Boolean']>;
  enableScheduledOrdering?: Maybe<Scalars['Boolean']>;
  orderMinimum?: Maybe<GqlOrderMinimum>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  pickupReminders?: Maybe<GqlPickupReminders>;
  /** @deprecated replaced by v2 to remove slots from type - RTL 8/9/21 */
  scheduledOrderingConfig?: Maybe<GqlReservationOptionsForOrderType>;
  scheduledOrderingConfigV2?: Maybe<GqlScheduledOrderingConfigV2>;
};

export type GqlCustomCategoryPhoto = {
  __typename?: 'CustomCategoryPhoto';
  category?: Maybe<Scalars['String']>;
  collectionId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum CustomFont {
  exo = 'EXO',
  firaSans = 'FIRA_SANS',
  heebo = 'HEEBO',
  lato = 'LATO',
  matter = 'MATTER',
  merriweather = 'MERRIWEATHER',
  notoSans = 'NOTO_SANS',
  nunito = 'NUNITO',
  proximaNova = 'PROXIMA_NOVA',
  rokkitt = 'ROKKITT',
  volkhov = 'VOLKHOV',
  vollkorn = 'VOLLKORN',
  workSans = 'WORK_SANS'
}

export type GqlCustomerDetailsResponse = {
  __typename?: 'CustomerDetailsResponse';
  externalId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  successfulOrderCount: Scalars['Int'];
};

export type GqlCustomerSubscription = {
  __typename?: 'CustomerSubscription';
  dispensaryId?: Maybe<Scalars['String']>;
  dispensaryName?: Maybe<Scalars['String']>;
  emailOptIn?: Maybe<Scalars['Boolean']>;
  emailSubscription?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export enum CustomerType {
  medical = 'medical',
  recreational = 'recreational'
}

export type GqlCustomerUnsubscribe = {
  __typename?: 'CustomerUnsubscribe';
  dispensary?: Maybe<GqlDispensaries>;
  subscribed?: Maybe<Scalars['Boolean']>;
};

export type GqlCustomers = {
  __typename?: 'Customers';
  _id?: Maybe<Scalars['String']>;
  ageVerified?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  dispensaryId?: Maybe<Scalars['String']>;
  dispensaryName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailOptIn?: Maybe<Scalars['Boolean']>;
  /** @deprecated Field no longer supported */
  emailSubscription?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  numOrders?: Maybe<Scalars['Int']>;
  ordersTotal?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  /** @deprecated Field no longer supported */
  subscriptions?: Maybe<Scalars['String']>;
  textNotifications?: Maybe<Scalars['Boolean']>;
  /** @deprecated Field no longer supported */
  textSubscription?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type GqlCustomersList = {
  __typename?: 'CustomersList';
  customers?: Maybe<Array<Maybe<GqlCustomers>>>;
  meta?: Maybe<GqlMeta>;
};

export type GqlCustomizationProvider = {
  __typename?: 'CustomizationProvider';
  /** @deprecated Replaced by manifestUrl */
  manifestURL?: Maybe<Scalars['String']>;
  manifestUrl?: Maybe<Scalars['String']>;
  modulePath?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  /** @deprecated Replaced by modulePath */
  themeName?: Maybe<Scalars['String']>;
};

export type GqlCustomizedCategories = {
  __typename?: 'CustomizedCategories';
  items?: Maybe<Array<Maybe<GqlCustomizedCategory>>>;
  mobileDisplay?: Maybe<CategoriesMobileDisplayOption>;
  style?: Maybe<RadiusOption>;
  type?: Maybe<CategoriesTypeOption>;
};

export type GqlCustomizedCategory = {
  __typename?: 'CustomizedCategory';
  category: Scalars['String'];
  collectionId?: Maybe<Scalars['String']>;
  image: Scalars['String'];
};

export type GqlDateRange = {
  max?: InputMaybe<Scalars['ISODateTime']>;
  min?: InputMaybe<Scalars['ISODateTime']>;
};

export type GqlDealCrmProperty = GqlCrmProperty & {
  __typename?: 'DealCrmProperty';
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlDeleteAccountResponse = {
  __typename?: 'DeleteAccountResponse';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type GqlDeliveryFeeTiers = {
  __typename?: 'DeliveryFeeTiers';
  feeInCents?: Maybe<Scalars['Int']>;
  feeType?: Maybe<FeeTypes>;
  maximumInCents?: Maybe<Scalars['Int']>;
  minimumInCents?: Maybe<Scalars['Int']>;
  percentFee?: Maybe<Scalars['Float']>;
};

export type GqlDeliveryInput = {
  checkoutMessage?: InputMaybe<Scalars['String']>;
  deliveryFeeTiers?: InputMaybe<Array<InputMaybe<GqlFeeTiersInput>>>;
  deliveryMode?: InputMaybe<DeliveryModes>;
  deliveryRadius?: InputMaybe<GqlDeliveryRadiusInput>;
  deliveryZipCodes?: InputMaybe<Array<InputMaybe<GqlDeliveryZipCodesInputV2>>>;
  deliveryZones?: InputMaybe<Array<InputMaybe<GqlDeliveryZonesInputV2>>>;
  enableASAPOrdering?: InputMaybe<Scalars['Boolean']>;
  enableAfterHoursOrdering?: InputMaybe<Scalars['Boolean']>;
  enableScheduledOrdering?: InputMaybe<Scalars['Boolean']>;
  paymentTypes?: InputMaybe<GqlDispensaryUpdatePaymentTypeConfig>;
  scheduledOrderingConfig?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
};

export enum DeliveryModes {
  cityLimits = 'cityLimits',
  drawn = 'drawn',
  radius = 'radius',
  zipCode = 'zipCode'
}

export type GqlDeliveryOrderingSettings = GqlBaseOrderingSettings & {
  __typename?: 'DeliveryOrderingSettings';
  checkoutMessage?: Maybe<Scalars['String']>;
  deliveryFeeTiers?: Maybe<Array<Maybe<GqlDeliveryFeeTiers>>>;
  deliveryMode?: Maybe<DeliveryModes>;
  deliveryRadius?: Maybe<GqlDeliveryRadius>;
  deliveryZipCodes?: Maybe<Array<Maybe<GqlDeliveryZipCodes>>>;
  deliveryZones?: Maybe<Array<Maybe<GqlDeliveryZones>>>;
  enableASAPOrdering?: Maybe<Scalars['Boolean']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']>;
  enableScheduledOrdering?: Maybe<Scalars['Boolean']>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  /** @deprecated replaced by v2 to remove slots from type - RTL 8/9/21 */
  scheduledOrderingConfig?: Maybe<GqlReservationOptionsForOrderType>;
  scheduledOrderingConfigV2?: Maybe<GqlScheduledOrderingConfigV2>;
};

export enum DeliveryPolicy {
  destinationBased = 'destinationBased',
  originBased = 'originBased'
}

export type GqlDeliveryRadius = {
  __typename?: 'DeliveryRadius';
  orderMinimum?: Maybe<GqlOrderMinimum>;
  radiusInMiles?: Maybe<Scalars['Float']>;
};

export type GqlDeliveryRadiusInput = {
  orderMinimum?: InputMaybe<GqlOrderMinimumInput>;
  radiusInMiles?: InputMaybe<Scalars['Float']>;
};

export type GqlDeliveryZipCodes = {
  __typename?: 'DeliveryZipCodes';
  feeInCents?: Maybe<Scalars['Int']>;
  feeType?: Maybe<FeeTypes>;
  minimumInCents?: Maybe<Scalars['Int']>;
  percentFee?: Maybe<Scalars['Float']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type GqlDeliveryZipCodesInputV2 = {
  feeInCents?: InputMaybe<Scalars['Int']>;
  feeType?: InputMaybe<FeeTypes>;
  minimumInCents?: InputMaybe<Scalars['Int']>;
  percentFee?: InputMaybe<Scalars['Float']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type GqlDeliveryZones = {
  __typename?: 'DeliveryZones';
  _id?: Maybe<Scalars['String']>;
  area?: Maybe<GqlPolygon>;
  feeInCents?: Maybe<Scalars['Int']>;
  feeType?: Maybe<FeeTypes>;
  minimumInCents?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  percentFee?: Maybe<Scalars['Float']>;
};

export type GqlDeliveryZonesInputV2 = {
  _id?: InputMaybe<Scalars['String']>;
  area?: InputMaybe<GqlPolygonInput>;
  feeInCents?: InputMaybe<Scalars['Int']>;
  feeType?: InputMaybe<FeeTypes>;
  minimumInCents?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  percentFee?: InputMaybe<Scalars['Float']>;
};

export type GqlDetailItem = {
  __typename?: 'DetailItem';
  basePrice?: Maybe<Scalars['Float']>;
  basePriceMult?: Maybe<Scalars['Float']>;
  bogoSavings?: Maybe<GqlBogoSavingsObj>;
  bottleDepositTaxCents?: Maybe<Scalars['Float']>;
  canonicalEffectivePotencyMg?: Maybe<Scalars['Float']>;
  enterpriseProductId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isOnSale?: Maybe<Scalars['Boolean']>;
  isVapeTaxed?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  menuBasePrice?: Maybe<Scalars['Float']>;
  menuCannabisTax?: Maybe<Scalars['Float']>;
  menuIndividualPrice?: Maybe<Scalars['Float']>;
  menuPrice?: Maybe<Scalars['Float']>;
  menuSaleAdjustment?: Maybe<Scalars['Float']>;
  menuSalesTax?: Maybe<Scalars['Float']>;
  option?: Maybe<Scalars['String']>;
  posId?: Maybe<Scalars['String']>;
  pricingTierData?: Maybe<GqlProducts_PricingTierData>;
  productBrand?: Maybe<Scalars['String']>;
  productBrandId?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productSubcategory?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  specialData?: Maybe<GqlProducts_SpecialData>;
  type?: Maybe<Scalars['String']>;
  weightInGrams?: Maybe<Scalars['Float']>;
  weightInMg?: Maybe<Scalars['Float']>;
  wholesalePrice?: Maybe<Scalars['Float']>;
};

export type GqlDeviceAccessCode = {
  __typename?: 'DeviceAccessCode';
  accessCode: Scalars['String'];
  channel: Scalars['String'];
  channelKey: Scalars['String'];
  id: Scalars['ID'];
};

export type GqlDeviceConnection = {
  __typename?: 'DeviceConnection';
  accessToken: Scalars['String'];
};

export type GqlDevice_Config = {
  __typename?: 'Device_config';
  getDeliveryOrders?: Maybe<Scalars['Boolean']>;
  getKioskOrders?: Maybe<Scalars['Boolean']>;
  getPickupOrders?: Maybe<Scalars['Boolean']>;
  orderSort?: Maybe<GqlDevice_Config_OrderSort>;
  /** @deprecated Replaced by getPickupOrders, getDeliveryOrders, getKioskOrders */
  orderSource?: Maybe<Scalars['String']>;
};

export type GqlDevice_Config_Input = {
  getDeliveryOrders?: InputMaybe<Scalars['Boolean']>;
  getKioskOrders?: InputMaybe<Scalars['Boolean']>;
  getPickupOrders?: InputMaybe<Scalars['Boolean']>;
  orderSort?: InputMaybe<GqlDevice_Config_OrderSort_Input>;
  orderSource?: InputMaybe<Scalars['String']>;
};

export type GqlDevice_Config_OrderSort = {
  __typename?: 'Device_config_orderSort';
  sortBy?: Maybe<Device_OrderSortOptions>;
  sortDirection?: Maybe<StringSortDirections>;
};

export type GqlDevice_Config_OrderSort_Input = {
  sortBy?: InputMaybe<Device_OrderSortOptions>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlDevice_FeatureFlags = {
  __typename?: 'Device_featureFlags';
  enableBatchPrint?: Maybe<Scalars['Boolean']>;
};

export enum Device_OrderSortOptions {
  createdAt = 'createdAt',
  reservation = 'reservation'
}

export type GqlDevices = {
  __typename?: 'Devices';
  _id?: Maybe<Scalars['String']>;
  accessCode?: Maybe<Scalars['String']>;
  autoPrintDevice?: Maybe<Scalars['Boolean']>;
  buildNumber?: Maybe<Scalars['String']>;
  config?: Maybe<GqlDevice_Config>;
  dispensary?: Maybe<GqlDispensaries>;
  dispensaryId?: Maybe<Scalars['String']>;
  featureFlags?: Maybe<GqlDevice_FeatureFlags>;
  lastSeenAt?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  online?: Maybe<Scalars['Boolean']>;
  printerConnected?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['String']>;
  versionNumber?: Maybe<Scalars['String']>;
};

export type GqlDisconnectBankAccountResponse = {
  __typename?: 'DisconnectBankAccountResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type GqlDiscount = {
  __typename?: 'Discount';
  amount?: Maybe<Scalars['Int']>;
  applicationMethod?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['Int']>;
  isLoyaltyReward?: Maybe<Scalars['Boolean']>;
  isPaymentIncentive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type GqlDiscountBundle = {
  __typename?: 'DiscountBundle';
  _id?: Maybe<Scalars['String']>;
  applyTo?: Maybe<ApplicationScope>;
  discountType?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlDiscountBundleInput = {
  _id?: InputMaybe<Scalars['String']>;
  applyTo?: InputMaybe<ApplicationScope>;
  discountType?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

export type GqlDiscountToCart = {
  __typename?: 'DiscountToCart';
  _id?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlDiscountToCartInput = {
  _id?: InputMaybe<Scalars['String']>;
  discountType?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export enum DiscountType {
  dollarDiscount = 'dollarDiscount',
  percentDiscount = 'percentDiscount',
  targetPrice = 'targetPrice'
}

export type GqlDispensaries = {
  __typename?: 'Dispensaries';
  SpecialLogoImage?: Maybe<Scalars['String']>;
  acceptsCreditCardTips?: Maybe<Scalars['Boolean']>;
  acceptsDutchiePayTips?: Maybe<Scalars['Boolean']>;
  acceptsTips?: Maybe<Scalars['Boolean']>;
  actionEstimates?: Maybe<GqlActionEstimates>;
  activeCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
  adSettings?: Maybe<GqlAdSettings>;
  address?: Maybe<Scalars['String']>;
  admins?: Maybe<Array<Maybe<GqlDispensaries_Profile_Admins>>>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  aeropay?: Maybe<Scalars['Boolean']>;
  ageVerificationBannerColor?: Maybe<Scalars['String']>;
  ageVerificationBannerHtml?: Maybe<Scalars['String']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  alt36?: Maybe<Scalars['Boolean']>;
  bannerImage?: Maybe<Scalars['String']>;
  brandedDutchiePayEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated use brandedDutchiePayLogoLight */
  brandedDutchiePayLogo?: Maybe<Scalars['String']>;
  brandedDutchiePayLogoDark?: Maybe<Scalars['String']>;
  brandedDutchiePayLogoLight?: Maybe<Scalars['String']>;
  brandedDutchiePayName?: Maybe<Scalars['String']>;
  /** @deprecated use brandedDutchiePayLogoDark */
  brandedDutchiePayWordmark?: Maybe<Scalars['String']>;
  cName?: Maybe<Scalars['String']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  canPay?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  cashOnly?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  cashless?: Maybe<Scalars['Boolean']>;
  categoryLimits?: Maybe<Array<Maybe<GqlDispensaries_CategoryLimits>>>;
  categoryLimitsEnabled?: Maybe<Scalars['Boolean']>;
  categoryPhotos?: Maybe<Array<Maybe<GqlCategoryPhoto>>>;
  chain?: Maybe<Scalars['String']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  check?: Maybe<Scalars['Boolean']>;
  /** @deprecated use WebCustomizationSettings.colorSettings - 10/25/22 */
  colorSettings?: Maybe<GqlColorSettings>;
  consumerDispensaryIntegrations?: Maybe<GqlConsumerDispensaryIntegrations>;
  coordinates?: Maybe<GqlDispensaries_Profile_Coordinates>;
  /** @deprecated Use ISO field */
  createdAt?: Maybe<Scalars['String']>;
  createdAtISO?: Maybe<Scalars['ISODateTime']>;
  /** @deprecated Removed support - 4/12/20 */
  creditCard?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  creditCardAtDoor?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  creditCardByPhone?: Maybe<Scalars['Boolean']>;
  customCategoryPhotos?: Maybe<Array<Maybe<GqlCustomCategoryPhoto>>>;
  customDomainSettings?: Maybe<GqlDispensaries_Profile_CustomDomain_Settings>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  debitOnly?: Maybe<Scalars['Boolean']>;
  /** @deprecated covered by DeliveryOrderingSettings in ordering-settings */
  deliveryArea?: Maybe<GqlPolygon>;
  /** @deprecated used and defined in ordering-settings */
  deliveryFee?: Maybe<Scalars['String']>;
  /** @deprecated defined within hours-settings */
  deliveryHours?: Maybe<GqlDispensaries_Profile_Hours>;
  /** @deprecated Fetch delivery info separately instead */
  deliveryInfo?: Maybe<GqlDispensaries_DeliveryInfo>;
  /** @deprecated used and defined in ordering-settings */
  deliveryMin?: Maybe<Scalars['String']>;
  /** @deprecated used and defined in ordering-settings */
  deliveryMode?: Maybe<DeliveryModes>;
  description?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
  drivers?: Maybe<Array<Maybe<GqlDispensaries_Profile_Drivers>>>;
  durationEstimateOverrides?: Maybe<GqlDurationEstimates>;
  /** @deprecated defined in hours-settings */
  effectiveHours?: Maybe<GqlEffectiveHours>;
  email?: Maybe<Scalars['String']>;
  emailConfirmation?: Maybe<Scalars['Boolean']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  embedBackUrl?: Maybe<Scalars['String']>;
  embedSettings?: Maybe<GqlDispensaries_Profile_Embed_Settings>;
  embeddedLogoImage?: Maybe<Scalars['String']>;
  embeddedMenuUrl?: Maybe<Scalars['String']>;
  enabledOrderTypes?: Maybe<GqlEnabledOrderTypes>;
  /** @deprecated Taxes V1 */
  exciseTax?: Maybe<GqlDispensaries_ExciseTax>;
  featureFlags: GqlDispensaries_FeatureFlags;
  feeTiers?: Maybe<Array<Maybe<GqlDispensaries_Profile_FeeTiers>>>;
  /** @deprecated Use ISO field */
  firstActiveAt?: Maybe<Scalars['String']>;
  firstActiveAtISO?: Maybe<Scalars['ISODateTime']>;
  fleetManagementIntegration?: Maybe<Array<Maybe<GqlDispensaries_Integrations>>>;
  fullName?: Maybe<Scalars['String']>;
  googleAnalyticsID?: Maybe<Scalars['String']>;
  googleTagManager?: Maybe<GqlDispensaries_GoogleTagManagerConfig>;
  /** @deprecated use storeSettings.requireEmailAddressForGuestCheckout - RTL, 4/28/2021 */
  guestEmailRequired?: Maybe<Scalars['Boolean']>;
  hasMenuIntegration: Scalars['Boolean'];
  hideFromCCT?: Maybe<Scalars['Boolean']>;
  hoursSettings?: Maybe<GqlDispensaryHoursSettings>;
  id: Scalars['String'];
  imageBanners?: Maybe<Array<Maybe<GqlImageBanner>>>;
  includeSalesTaxInMenu?: Maybe<Scalars['Boolean']>;
  /** @deprecated Taxes V1 */
  inclusiveSalesTax?: Maybe<Scalars['Boolean']>;
  isLibrary?: Maybe<Scalars['Boolean']>;
  /** @deprecated defined in ordering-settings as KioskOrderingSettings */
  kioskConfig?: Maybe<GqlDispensaries_KioskConfig>;
  /** @deprecated defined within KioskOrderingSettings in ordering-settings */
  kioskInstructions?: Maybe<Scalars['String']>;
  /** @deprecated defined within KioskOrderingSettings in ordering-settings */
  kioskOrderingEnabled?: Maybe<Scalars['Boolean']>;
  lastThirtyDaysSales?: Maybe<Scalars['Float']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  linx?: Maybe<Scalars['Boolean']>;
  listImage?: Maybe<Scalars['String']>;
  location?: Maybe<GqlDispensaries_Profile_Location>;
  logoImage?: Maybe<Scalars['String']>;
  /** @deprecated used and defined in ordering-settings as deliveryRadiusInMiles */
  maxDeliveryDistance?: Maybe<Scalars['Float']>;
  medSubjectToExciseTax?: Maybe<Scalars['Boolean']>;
  medicalDispensary?: Maybe<Scalars['Boolean']>;
  medicalOnly?: Maybe<Scalars['Boolean']>;
  menuBannerColor?: Maybe<Scalars['String']>;
  menuBannerHtml?: Maybe<Scalars['String']>;
  menuBannerTextBannerCollapsed?: Maybe<Scalars['Boolean']>;
  menuIntegration?: Maybe<Array<Maybe<GqlDispensaries_Integrations>>>;
  menuOrder?: Maybe<Scalars['String']>;
  menuScore?: Maybe<Scalars['Float']>;
  menuScoresByCategory?: Maybe<Array<Maybe<GqlMenuScore>>>;
  menuSections?: Maybe<Array<Maybe<GqlMenuSection>>>;
  menuSortSettings?: Maybe<Array<GqlMenuSortSetting>>;
  menuUrl?: Maybe<Scalars['String']>;
  menuWeights?: Maybe<Scalars['String']>;
  merrcoPublicToken?: Maybe<Scalars['String']>;
  messagingSettings?: Maybe<GqlDispensaries_MessagingSettings>;
  mixAndMatchPricingWeights?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  /**
   * convenience properties used frequently on server and client. Derived based on orderTypesConfig. See serializer for detail
   * @deprecated use OrderTypesConfig.offerAnyPickupService
   */
  offerAnyPickupService?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use orderTypesConfigV2 or enabledOrderTypes 07/2022 */
  offerCurbsidePickup?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use orderTypesConfigV2 or enabledOrderTypes 07/2022 */
  offerDelivery?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use orderTypesConfigV2 or enabledOrderTypes 07/2022 */
  offerDriveThruPickup?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use orderTypesConfigV2 or enabledOrderTypes 07/2022 */
  offerPickup?: Maybe<Scalars['Boolean']>;
  openInfoForDevice?: Maybe<GqlOpenInfoForDevice>;
  orderStatusEmailSettings?: Maybe<GqlOrderStatusEmailSettings>;
  /**
   * nested payment-type-per-order-type data; used in admin settings and checkout
   * @deprecated use OrderTypesConfigV2
   */
  orderTypesConfig?: Maybe<GqlOrderTypesConfig>;
  orderTypesConfigV2?: Maybe<GqlOrderTypesConfigV2>;
  ordersArePaused?: Maybe<Scalars['Boolean']>;
  ordersConfig?: Maybe<GqlDispensaries_OrdersConfig>;
  /** @deprecated legacy payment option */
  payInStore?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  payOnlineHypur?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  payOnlineMerrco?: Maybe<Scalars['Boolean']>;
  paymentFees?: Maybe<Array<Maybe<GqlDispensaries_PaymentFees>>>;
  /** booleans of all payment types the dispo accepts (derived from nested orderTypesConfig data). Existing references to profile-level bools should be changed to reference this list */
  paymentTypesAccepted?: Maybe<GqlPaymentTypesConfig>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  paytender?: Maybe<Scalars['Boolean']>;
  personalizationSettings?: Maybe<GqlPersonalizationSettings>;
  phone?: Maybe<Scalars['String']>;
  /** @deprecated defined in hours-settings */
  pickupHours?: Maybe<GqlDispensaries_Profile_Hours>;
  /** @deprecated defined in ordering-settings */
  pickupMinimum?: Maybe<GqlPickupMinimum>;
  plusSettings?: Maybe<GqlDispensaries_Profile_Plus_Settings>;
  printedMenuSettings?: Maybe<GqlDispensaries_PrintedMenuSettings>;
  productCategorySummary?: Maybe<Array<Maybe<GqlCategorySummary>>>;
  recDispensary?: Maybe<Scalars['Boolean']>;
  remoteExtensions?: Maybe<GqlRemoteExtensions>;
  removeMedicalCardFieldsAtCheckout?: Maybe<Scalars['Boolean']>;
  requirePhotoIdForDelivery?: Maybe<Scalars['Boolean']>;
  requirePhotoIdForPickup?: Maybe<Scalars['Boolean']>;
  requiresDriversLicense?: Maybe<Scalars['Boolean']>;
  requiresDriversLicenseForPickup?: Maybe<Scalars['Boolean']>;
  reservationsAvailableByOrderType?: Maybe<GqlReservationsAvailableByOrderType>;
  retailer: GqlRetailer;
  salesTax?: Maybe<Scalars['Float']>;
  seoSettings?: Maybe<GqlSeoSettings>;
  /** @deprecated defined in hours-settings in HoursSettingsForOrderType */
  specialHours?: Maybe<Array<Maybe<GqlSpecialHours>>>;
  specialsSettings?: Maybe<GqlSpecialsSettings>;
  /** @deprecated Use consumerDispensaryIntegrations.springbig.enabled field */
  springbigEnabled?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  /** @deprecated Moved to storeSettings 7/11/2019 */
  stealthMode?: Maybe<Scalars['Boolean']>;
  storeSettings: GqlDispensaries_StoreSettings;
  tags?: Maybe<GqlProductTags>;
  taxCalculationMethod: Scalars['String'];
  taxConfig: GqlDispensaries_TaxConfig;
  temporalLocation?: Maybe<GqlTemporalLocation>;
  /** @deprecated Not possible in aggregations anymore. Use separate query for device lookup. */
  terminals?: Maybe<Array<Maybe<GqlDispensaries_Terminals>>>;
  termsAndConditionsUrl?: Maybe<Scalars['String']>;
  textNotifications?: Maybe<Scalars['Boolean']>;
  tier?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  /** @deprecated Use ISO field */
  updatedAt?: Maybe<Scalars['String']>;
  updatedAtISO?: Maybe<Scalars['ISODateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  webCustomizationSettings?: Maybe<GqlWebCustomizationSettings>;
  webCustomizationSettingsV2?: Maybe<GqlWebCustomizationSettingsV2>;
};


export type GqlDispensariesImageBannersArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
};


export type GqlDispensariesMenuSectionsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
};

export type GqlDispensariesAdSettingsByMenuVariantResult = {
  __typename?: 'DispensariesAdSettingsByMenuVariantResult';
  adSettings?: Maybe<GqlAdSettings>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type GqlDispensariesPersonalizationSettingsByMenuVariantResult = {
  __typename?: 'DispensariesPersonalizationSettingsByMenuVariantResult';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  personalizationSettings?: Maybe<GqlPersonalizationSettings>;
};

export type GqlDispensaries_GoogleTagManagerConfig = {
  __typename?: 'Dispensaries_GoogleTagManagerConfig';
  containerIds?: Maybe<Scalars['JSON']>;
  flags?: Maybe<Scalars['JSON']>;
  gtmID?: Maybe<Scalars['String']>;
};

export type GqlDispensaries_TaxConfig = {
  __typename?: 'Dispensaries_TaxConfig';
  calculationMethod: Scalars['String'];
  discountTaxOrder: Scalars['String'];
  taxes: Array<Maybe<GqlDispensaries_TaxConfig_Tax>>;
  version: Scalars['Int'];
};

export type GqlDispensaries_TaxConfig_Tax = {
  __typename?: 'Dispensaries_TaxConfig_Tax';
  applyTo: GqlDispensaries_TaxConfig_Tax_ApplyTo;
  deliveryPolicy?: Maybe<DeliveryPolicy>;
  destinationRate?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  includeStateSalesTaxInDestinationRate?: Maybe<Scalars['Boolean']>;
  medical: Scalars['Boolean'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  potency?: Maybe<PotencyType>;
  potencyRate?: Maybe<Scalars['Float']>;
  rate: Scalars['Float'];
  recreational: Scalars['Boolean'];
  stages: Array<Maybe<GqlDispensaries_TaxConfig_Tax_Stage>>;
  taxBasis?: Maybe<Scalars['String']>;
  type: TaxType;
};

export type GqlDispensaries_TaxConfig_Tax_ApplyTo = {
  __typename?: 'Dispensaries_TaxConfig_Tax_ApplyTo';
  hemp: Scalars['Boolean'];
  types: Array<Maybe<Scalars['String']>>;
};

export type GqlDispensaries_TaxConfig_Tax_Stage = {
  __typename?: 'Dispensaries_TaxConfig_Tax_Stage';
  op: Dispensaries_TaxConfig_Tax_Stage_Ops;
  type: Dispensaries_TaxConfig_Tax_Stage_Types;
};

export enum Dispensaries_TaxConfig_Tax_Stage_Ops {
  add = 'add',
  noop = 'noop',
  subtract = 'subtract'
}

export enum Dispensaries_TaxConfig_Tax_Stage_Types {
  checkout = 'checkout',
  menu = 'menu',
  pos = 'pos'
}

export type GqlDispensaries_CategoryLimits = {
  __typename?: 'Dispensaries_categoryLimits';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlDispensaries_DeliveryInfo = {
  __typename?: 'Dispensaries_deliveryInfo';
  deliveryAreaId?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  feeType?: Maybe<FeeTypes>;
  feeVaries?: Maybe<Scalars['Boolean']>;
  minimum?: Maybe<Scalars['Int']>;
  minimumVaries?: Maybe<Scalars['Boolean']>;
  percentFee?: Maybe<Scalars['Float']>;
  withinBounds?: Maybe<Scalars['Boolean']>;
};

export type GqlDispensaries_ExciseTax = {
  __typename?: 'Dispensaries_exciseTax';
  local?: Maybe<Scalars['Float']>;
  medicalLocal?: Maybe<Scalars['Float']>;
  medicalState?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['Float']>;
};

export type GqlDispensaries_FeatureFlags = {
  __typename?: 'Dispensaries_featureFlags';
  /** @deprecated General Availability 2/23/21 */
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']>;
  /** @deprecated General Availability 7/09/2020 */
  enableArrivals?: Maybe<Scalars['Boolean']>;
  enableMenuImport?: Maybe<Scalars['Boolean']>;
  enableMixAndMatch?: Maybe<Scalars['Boolean']>;
  enableNonTerminalAutoConfirm?: Maybe<Scalars['Boolean']>;
  enablePausedOrders?: Maybe<Scalars['Boolean']>;
  /** @deprecated General Availability 2/23/21 */
  enableScheduledOrdering?: Maybe<Scalars['Boolean']>;
  hideDeliveryEstimate?: Maybe<Scalars['Boolean']>;
  hideMyAccount?: Maybe<Scalars['Boolean']>;
  hideStoreHours?: Maybe<Scalars['Boolean']>;
};

export type GqlDispensaries_FleetManagementIntegration_Credentials = {
  __typename?: 'Dispensaries_fleetManagementIntegration_credentials';
  apiKey?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  ordersEnabled?: Maybe<Scalars['Boolean']>;
  rewardsProgramPointsBoost?: Maybe<Scalars['Int']>;
};

export type GqlDispensaries_FleetManagementIntegration_Flags = {
  __typename?: 'Dispensaries_fleetManagementIntegration_flags';
  combineDiscounts?: Maybe<Scalars['Boolean']>;
  fleetManagementStatus?: Maybe<Scalars['String']>;
  onfleetStatus?: Maybe<Scalars['String']>;
};

export type GqlDispensaries_Integrations = {
  __typename?: 'Dispensaries_integrations';
  adapter?: Maybe<Scalars['String']>;
  credentials?: Maybe<GqlDispensaries_FleetManagementIntegration_Credentials>;
  enabled?: Maybe<Scalars['Boolean']>;
  flags?: Maybe<GqlDispensaries_FleetManagementIntegration_Flags>;
  integrationCategory?: Maybe<Scalars['String']>;
  /** @deprecated Use ISO field */
  lastSyncAt?: Maybe<Scalars['String']>;
  lastSyncAtISO?: Maybe<Scalars['ISODateTime']>;
  live?: Maybe<Scalars['Boolean']>;
};

export type GqlDispensaries_KioskConfig = {
  __typename?: 'Dispensaries_kioskConfig';
  directedOrders?: Maybe<Scalars['Boolean']>;
  fullNameOnly?: Maybe<Scalars['Boolean']>;
  hideEmailField?: Maybe<Scalars['Boolean']>;
  hidePhoneField?: Maybe<Scalars['Boolean']>;
  notesField?: Maybe<Scalars['Boolean']>;
  phoneRequired?: Maybe<Scalars['Boolean']>;
  showBirthdateField?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type GqlDispensaries_MessagingSettings = {
  __typename?: 'Dispensaries_messagingSettings';
  disableReadyForPickup?: Maybe<Scalars['Boolean']>;
  disableStartDelivery?: Maybe<Scalars['Boolean']>;
};

export type GqlDispensaries_OrdersConfig = {
  __typename?: 'Dispensaries_ordersConfig';
  autoClose?: Maybe<Scalars['Boolean']>;
  autoConfirm?: Maybe<Scalars['Boolean']>;
  posItemNames?: Maybe<Scalars['Boolean']>;
  terminalReceiptOptions?: Maybe<GqlTerminalReceiptOptions>;
};

export type GqlDispensaries_PaymentFees = {
  __typename?: 'Dispensaries_paymentFees';
  fee?: Maybe<Scalars['Float']>;
  feeType?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
};

export type GqlDispensaries_PrintedMenuSettings = {
  __typename?: 'Dispensaries_printedMenuSettings';
  Categories?: Maybe<Array<Maybe<GqlPrintedMenuSettings_CategoryEntry>>>;
  FooterText?: Maybe<GqlPrintedMenuSettings_Text>;
  HeaderText?: Maybe<GqlPrintedMenuSettings_Text>;
  MenuType?: Maybe<GqlPrintedMenuSettings_Type>;
  Order?: Maybe<GqlPrintedMenuSettings_Type>;
  PageBreaks?: Maybe<GqlPrintedMenuSettings_PageBreaks>;
  Photos?: Maybe<GqlPrintedMenuSettings_Photos>;
  StrainTypes?: Maybe<Array<Maybe<GqlPrintedMenuSettings_StrainTypesEntry>>>;
};

export type GqlDispensaries_Profile_Admins = {
  __typename?: 'Dispensaries_profile_admins';
  active?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
};

export type GqlDispensaries_Profile_Coordinates = {
  __typename?: 'Dispensaries_profile_coordinates';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type GqlDispensaries_Profile_CustomDomain_Settings = {
  __typename?: 'Dispensaries_profile_customDomain_settings';
  /** @deprecated use domain instead */
  cloudflareDomain?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
};

export type GqlDispensaries_Profile_Drivers = {
  __typename?: 'Dispensaries_profile_drivers';
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
};

export type GqlDispensaries_Profile_Embed_Settings = {
  __typename?: 'Dispensaries_profile_embed_settings';
  applyToAllLocations?: Maybe<Scalars['Boolean']>;
  autoGTM?: Maybe<Scalars['Boolean']>;
  autoScroll?: Maybe<Scalars['Boolean']>;
  autoScrollOffset?: Maybe<Scalars['Int']>;
  disablePageLoadsAtTop?: Maybe<Scalars['Boolean']>;
  disableRouting?: Maybe<Scalars['Boolean']>;
  disclaimerText?: Maybe<Scalars['String']>;
  disclaimerTextHtml?: Maybe<Scalars['String']>;
  enableFullScreenEmbeddedCheckout?: Maybe<Scalars['Boolean']>;
  iframeCSS?: Maybe<Scalars['String']>;
  pageCSS?: Maybe<Scalars['String']>;
  privacyPolicyUrl?: Maybe<Scalars['String']>;
};

export type GqlDispensaries_Profile_FeeTiers = {
  __typename?: 'Dispensaries_profile_feeTiers';
  fee?: Maybe<Scalars['String']>;
  feeType?: Maybe<FeeTypes>;
  max?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['String']>;
  percentFee?: Maybe<Scalars['Float']>;
};

export type GqlDispensaries_Profile_Hours = {
  __typename?: 'Dispensaries_profile_hours';
  Friday?: Maybe<GqlDayBounds>;
  Monday?: Maybe<GqlDayBounds>;
  Saturday?: Maybe<GqlDayBounds>;
  Sunday?: Maybe<GqlDayBounds>;
  Thursday?: Maybe<GqlDayBounds>;
  Tuesday?: Maybe<GqlDayBounds>;
  Wednesday?: Maybe<GqlDayBounds>;
};

export type GqlDispensaries_Profile_Location = {
  __typename?: 'Dispensaries_profile_location';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  geometry?: Maybe<GqlDispensaries_Profile_Location_Geometry>;
  ln1?: Maybe<Scalars['String']>;
  ln2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type GqlDispensaries_Profile_Location_Geometry = {
  __typename?: 'Dispensaries_profile_location_geometry';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']>>>;
  type?: Maybe<Scalars['String']>;
};

export type GqlDispensaries_Profile_MedicalCard = {
  __typename?: 'Dispensaries_profile_medicalCard';
  expirationDate?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
};

export type GqlDispensaries_Profile_Plus_Settings = {
  __typename?: 'Dispensaries_profile_plus_settings';
  checkoutUrl?: Maybe<Scalars['String']>;
  defaultReturnUrl?: Maybe<Scalars['String']>;
};

export type GqlDispensaries_StoreSettings = {
  __typename?: 'Dispensaries_storeSettings';
  collapseProductDescription: Scalars['Boolean'];
  customerMessagingTermsAccepted: Scalars['Boolean'];
  defaultViewStyle: MenuViewStyles;
  disableGuestCheckout: Scalars['Boolean'];
  disableGuestDOB: Scalars['Boolean'];
  disablePurchaseLimits: Scalars['Boolean'];
  displayKioskAnonymousCheckoutDisclaimer?: Maybe<Scalars['Boolean']>;
  displayPhoneConfirmation: Scalars['Boolean'];
  dontCombineWeightedProducts: Scalars['Boolean'];
  dontMapSubcategoriesByProductName?: Maybe<Scalars['Boolean']>;
  /** @deprecated used and defined in ordering-settings */
  enableAfterHoursOrderingForDelivery: Scalars['Boolean'];
  /** @deprecated used and defined per order type in ordering-settings */
  enableAfterHoursOrderingForPickup: Scalars['Boolean'];
  enableDutchiePayConsumerSurcharge?: Maybe<Scalars['Boolean']>;
  enableLLxSaleDiscountSync?: Maybe<Scalars['Boolean']>;
  enableLimitPerCustomer: Scalars['Boolean'];
  enableMixAndMatchPricingForDelivery: Scalars['Boolean'];
  enableMixAndMatchPricingForPickup: Scalars['Boolean'];
  enableOmniauthLoginCheckout?: Maybe<Scalars['Boolean']>;
  enableOrderStatusEmails: Scalars['Boolean'];
  enableProductUrgencyMessaging?: Maybe<Scalars['Boolean']>;
  enableRoundToNearestDollar?: Maybe<Scalars['Boolean']>;
  /** @deprecated used and defined in ordering-settings */
  enableScheduledOrderingForDelivery: Scalars['Boolean'];
  /** @deprecated used and defined per order type in ordering-settings */
  enableScheduledOrderingForPickup: Scalars['Boolean'];
  enableStorefrontAgeGate: Scalars['Boolean'];
  hardAgeGateAgeVerification: Scalars['Boolean'];
  hardAgeGateHideMenuContent: Scalars['Boolean'];
  hideAddressFromDutchieMain: Scalars['Boolean'];
  hideDiscountsFromConsumer?: Maybe<Scalars['Boolean']>;
  hideEffects: Scalars['Boolean'];
  hideFilters?: Maybe<Scalars['Boolean']>;
  hideFromMobileApp?: Maybe<Scalars['Boolean']>;
  hideOutOfStockProducts: Scalars['Boolean'];
  hideRoundingLineItem?: Maybe<Scalars['Boolean']>;
  isolatedMenus: Scalars['Boolean'];
  keepUncombinedWeights?: Maybe<Scalars['Boolean']>;
  prioritizeStaffPicksInSearchResults: Scalars['Boolean'];
  provideBackInstockEmailNotifications: Scalars['Boolean'];
  quantityLimit: Scalars['Int'];
  quantityLimitMaxAvailable: Scalars['Boolean'];
  requireEmailAddressForGuestCheckout: Scalars['Boolean'];
  requireMedCardPhotoForDelivery?: Maybe<Scalars['Boolean']>;
  requireMedCardPhotoForPickup?: Maybe<Scalars['Boolean']>;
  rewardsIntegrationConfiguration?: Maybe<GqlRewards_Integration_Configuration>;
  showLoyaltyRewards?: Maybe<Scalars['Boolean']>;
  showMobileAppSmartBanner?: Maybe<Scalars['Boolean']>;
  showPOSPackageId: Scalars['Boolean'];
  stealthMode: Scalars['Boolean'];
  subscriptions: GqlDispensaries_Subscriptions;
  usePotencyForConcentrateLimits?: Maybe<Scalars['Boolean']>;
  useStandardEquivalentForEdiblesLimits?: Maybe<Scalars['Boolean']>;
};

export type GqlDispensaries_Subscriptions = {
  __typename?: 'Dispensaries_subscriptions';
  enabled?: Maybe<Scalars['Boolean']>;
};

export type GqlDispensaries_SubscriptionsInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type GqlDispensaries_Terminals = {
  __typename?: 'Dispensaries_terminals';
  _id?: Maybe<Scalars['String']>;
  config?: Maybe<GqlDevice_Config>;
  /** @deprecated Use ISO field */
  lastSeenAt?: Maybe<Scalars['String']>;
  lastSeenAtISO?: Maybe<Scalars['ISODateTime']>;
  nickname?: Maybe<Scalars['String']>;
  versionNumber?: Maybe<Scalars['String']>;
};

export type GqlDispensaryAccountManagers = {
  __typename?: 'DispensaryAccountManagers';
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type GqlDispensaryAdSettings = {
  __typename?: 'DispensaryAdSettings';
  enableAdsForDefault: Scalars['Boolean'];
  enableAdsForEmbedded: Scalars['Boolean'];
  enableAdsForKiosk: Scalars['Boolean'];
  enableAdsForStoreFront: Scalars['Boolean'];
};

export type GqlDispensaryAdSettingsInput = {
  enableAdsForDefault: Scalars['Boolean'];
  enableAdsForEmbedded: Scalars['Boolean'];
  enableAdsForKiosk: Scalars['Boolean'];
  enableAdsForStoreFront: Scalars['Boolean'];
};

export type GqlDispensaryAssetUploadResponse = {
  __typename?: 'DispensaryAssetUploadResponse';
  fileIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GqlDispensaryBilling = {
  __typename?: 'DispensaryBilling';
  billingSubscription: GqlBillingSubscription;
  chain?: Maybe<Scalars['Boolean']>;
  chargebeeCustomer?: Maybe<GqlChargebeeCustomer>;
  chargebeeCustomerId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  paymentSources?: Maybe<Array<Maybe<GqlChargebeePaymentSource>>>;
};

export type GqlDispensaryBillingV2 = {
  __typename?: 'DispensaryBillingV2';
  chain?: Maybe<Scalars['Boolean']>;
  chargebeeCustomer?: Maybe<GqlChargebeeCustomer>;
  paymentSources?: Maybe<Array<Maybe<GqlChargebeePaymentSource>>>;
  retailerId?: Maybe<Scalars['ID']>;
};

export type GqlDispensaryCalcsInput = {
  deliveryInfo?: InputMaybe<GqlDispensaryDeliveryInfoInput>;
  dispensaryTimezone?: InputMaybe<Scalars['String']>;
  feeTiers?: InputMaybe<Array<InputMaybe<GqlDispensaryFeeTiersInput>>>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<GqlDispensaryLocationInput>;
  mixAndMatchPricingWeights?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paymentFees?: InputMaybe<Array<InputMaybe<GqlDispensaryPaymentFeeInput>>>;
  specialsSettings?: InputMaybe<GqlDispensarySpecialsSettingsInput>;
  storeSettings?: InputMaybe<GqlDispensaryStoreSettingsInput>;
  taxConfig?: InputMaybe<GqlDispensaryTaxConfigInput>;
  timezone?: InputMaybe<Scalars['String']>;
  useDartDiscountsPath?: InputMaybe<Scalars['Boolean']>;
};

export type GqlDispensaryDeliveryInfoInput = {
  deliveryAreaId?: InputMaybe<Scalars['String']>;
  fee?: InputMaybe<Scalars['Float']>;
  feeVaries?: InputMaybe<Scalars['Boolean']>;
  minimum?: InputMaybe<Scalars['Int']>;
  minimumVaries?: InputMaybe<Scalars['Boolean']>;
  withinBounds?: InputMaybe<Scalars['Boolean']>;
};

export type GqlDispensaryDropdownOption = {
  __typename?: 'DispensaryDropdownOption';
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlDispensaryFeeTiersInput = {
  fee?: InputMaybe<Scalars['String']>;
  feeType?: InputMaybe<Scalars['String']>;
  max?: InputMaybe<Scalars['String']>;
  min?: InputMaybe<Scalars['String']>;
  percentFee?: InputMaybe<Scalars['Int']>;
};

export type GqlDispensaryHoursSettings = {
  __typename?: 'DispensaryHoursSettings';
  curbsidePickup?: Maybe<GqlHoursSettingsForOrderType>;
  delivery?: Maybe<GqlHoursSettingsForOrderType>;
  driveThruPickup?: Maybe<GqlHoursSettingsForOrderType>;
  inStorePickup?: Maybe<GqlHoursSettingsForOrderType>;
};

export type GqlDispensaryLocationInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<GqlGeometryInput>;
  ln1?: InputMaybe<Scalars['String']>;
  ln2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export enum DispensaryOrderType {
  all = 'All',
  deliveryOnly = 'DeliveryOnly',
  kiosk = 'Kiosk',
  pickupAndDelivery = 'PickupAndDelivery',
  pickupOnly = 'PickupOnly'
}

export type GqlDispensaryPaymentFeeInput = {
  fee?: InputMaybe<Scalars['Float']>;
  feeType?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
};

export type GqlDispensaryPersonalizationSettings = {
  __typename?: 'DispensaryPersonalizationSettings';
  enablePersonalizationForDefault: Scalars['Boolean'];
  enablePersonalizationForEmbedded: Scalars['Boolean'];
  enablePersonalizationForKiosk: Scalars['Boolean'];
  enablePersonalizationForStoreFront: Scalars['Boolean'];
};

export type GqlDispensaryPersonalizationSettingsInput = {
  enablePersonalizationForDefault: Scalars['Boolean'];
  enablePersonalizationForEmbedded: Scalars['Boolean'];
  enablePersonalizationForKiosk: Scalars['Boolean'];
  enablePersonalizationForStoreFront: Scalars['Boolean'];
};

export enum DispensaryRoles {
  complianceAndLegal = 'complianceAndLegal',
  customerSales = 'customerSales',
  customerSupport = 'customerSupport',
  financeAndAccounting = 'financeAndAccounting',
  fulfillmentAndDelivery = 'fulfillmentAndDelivery',
  informationTechnology = 'informationTechnology',
  inventoryManagement = 'inventoryManagement',
  marketingAndPromotions = 'marketingAndPromotions',
  storeOperations = 'storeOperations',
  unknown = 'unknown'
}

export enum DispensarySortByType {
  deliveryEstimate = 'deliveryEstimate',
  deliveryFee = 'deliveryFee',
  deliveryMin = 'deliveryMin',
  distance = 'distance',
  integration = 'integration',
  pickupTime = 'pickupTime',
  terminal = 'terminal'
}

export type GqlDispensarySpecialsSettingsInput = {
  discountBehavior?: InputMaybe<Scalars['String']>;
  discountPrecedence?: InputMaybe<Scalars['String']>;
  discountStacking?: InputMaybe<Scalars['Boolean']>;
  enableIndividualDiscountStacking?: InputMaybe<Scalars['Boolean']>;
  enableIndividualSpecialPrecedence?: InputMaybe<Scalars['Boolean']>;
  nonStackingBehavior?: InputMaybe<Scalars['String']>;
  stackingBehavior?: InputMaybe<Scalars['String']>;
};

export type GqlDispensaryStoreSettingsInput = {
  collapseProductDescription?: InputMaybe<Scalars['Boolean']>;
  customerMessagingTermsAccepted?: InputMaybe<Scalars['Boolean']>;
  defaultViewStyle?: InputMaybe<Scalars['String']>;
  disableGuestCheckout?: InputMaybe<Scalars['Boolean']>;
  disableGuestDOB?: InputMaybe<Scalars['Boolean']>;
  disablePurchaseLimits?: InputMaybe<Scalars['Boolean']>;
  displayKioskAnonymousCheckoutDisclaimer?: InputMaybe<Scalars['Boolean']>;
  displayPhoneConfirmation?: InputMaybe<Scalars['Boolean']>;
  dontCombineWeightedProducts?: InputMaybe<Scalars['Boolean']>;
  dontMapSubcategoriesByProductName?: InputMaybe<Scalars['Boolean']>;
  enableAfterHoursOrderingForDelivery?: InputMaybe<Scalars['Boolean']>;
  enableAfterHoursOrderingForPickup?: InputMaybe<Scalars['Boolean']>;
  enableDutchiePayConsumerSurcharge?: InputMaybe<Scalars['Boolean']>;
  enableLLxSaleDiscountSync?: InputMaybe<Scalars['Boolean']>;
  enableLimitPerCustomer?: InputMaybe<Scalars['Boolean']>;
  enableMixAndMatchPricingForDelivery?: InputMaybe<Scalars['Boolean']>;
  enableMixAndMatchPricingForPickup?: InputMaybe<Scalars['Boolean']>;
  enableOmniauthLoginCheckout?: InputMaybe<Scalars['Boolean']>;
  enableOrderStatusEmails?: InputMaybe<Scalars['Boolean']>;
  enableProductUrgencyMessaging?: InputMaybe<Scalars['Boolean']>;
  enableRoundToNearestDollar?: InputMaybe<Scalars['Boolean']>;
  enableScheduledOrderingForDelivery?: InputMaybe<Scalars['Boolean']>;
  enableScheduledOrderingForPickup?: InputMaybe<Scalars['Boolean']>;
  enableStorefrontAgeGate?: InputMaybe<Scalars['Boolean']>;
  hardAgeGateAgeVerification?: InputMaybe<Scalars['Boolean']>;
  hardAgeGateHideMenuContent?: InputMaybe<Scalars['Boolean']>;
  hideAddressFromDutchieMain?: InputMaybe<Scalars['Boolean']>;
  hideDiscountsFromConsumer?: InputMaybe<Scalars['Boolean']>;
  hideEffects?: InputMaybe<Scalars['Boolean']>;
  hideFilters?: InputMaybe<Scalars['Boolean']>;
  hideFromMobileApp?: InputMaybe<Scalars['Boolean']>;
  hideOutOfStockProducts?: InputMaybe<Scalars['Boolean']>;
  hideRoundingLineItem?: InputMaybe<Scalars['Boolean']>;
  isolatedMenus?: InputMaybe<Scalars['Boolean']>;
  keepUncombinedWeights?: InputMaybe<Scalars['Boolean']>;
  prioritizeStaffPicksInSearchResults?: InputMaybe<Scalars['Boolean']>;
  provideBackInstockEmailNotifications?: InputMaybe<Scalars['Boolean']>;
  quantityLimit?: InputMaybe<Scalars['Int']>;
  quantityLimitMaxAvailable?: InputMaybe<Scalars['Boolean']>;
  requireEmailAddressForGuestCheckout?: InputMaybe<Scalars['Boolean']>;
  requireMedCardPhotoForDelivery?: InputMaybe<Scalars['Boolean']>;
  requireMedCardPhotoForPickup?: InputMaybe<Scalars['Boolean']>;
  rewardsIntegrationConfiguration?: InputMaybe<GqlRewardsIntegrationConfigurationInput>;
  showLoyaltyRewards?: InputMaybe<Scalars['Boolean']>;
  showMobileAppSmartBanner?: InputMaybe<Scalars['Boolean']>;
  showPOSPackageId?: InputMaybe<Scalars['Boolean']>;
  stealthMode?: InputMaybe<Scalars['Boolean']>;
  subscriptions?: InputMaybe<GqlSubscriptionsInput>;
  usePotencyForConcentrateLimits?: InputMaybe<Scalars['Boolean']>;
  useStandardEquivalentForEdiblesLimits?: InputMaybe<Scalars['Boolean']>;
};

export type GqlDispensaryStreamToken = {
  __typename?: 'DispensaryStreamToken';
  dispensaryId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type GqlDispensaryTaxConfigInput = {
  calculationMethod?: InputMaybe<Scalars['String']>;
  discountTaxOrder?: InputMaybe<Scalars['String']>;
  taxes?: InputMaybe<Array<InputMaybe<GqlTaxConfigTaxInput>>>;
  version?: InputMaybe<Scalars['Int']>;
};

export type GqlDriveThruPickupOrderingSettings = GqlBaseOrderingSettings & {
  __typename?: 'DriveThruPickupOrderingSettings';
  checkoutMessage?: Maybe<Scalars['String']>;
  enableASAPOrdering?: Maybe<Scalars['Boolean']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']>;
  enableScheduledOrdering?: Maybe<Scalars['Boolean']>;
  orderMinimum?: Maybe<GqlOrderMinimum>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  pickupReminders?: Maybe<GqlPickupReminders>;
  /** @deprecated replaced by v2 to remove slots from type - RTL 8/9/21 */
  scheduledOrderingConfig?: Maybe<GqlReservationOptionsForOrderType>;
  scheduledOrderingConfigV2?: Maybe<GqlScheduledOrderingConfigV2>;
};

export type GqlDropdownOption = {
  __typename?: 'DropdownOption';
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlDurationEstimateRange = {
  __typename?: 'DurationEstimateRange';
  enabled?: Maybe<Scalars['Boolean']>;
  highInMinutes?: Maybe<Scalars['Float']>;
  lowInMinutes?: Maybe<Scalars['Float']>;
};

export type GqlDurationEstimates = {
  __typename?: 'DurationEstimates';
  delivery?: Maybe<GqlDurationEstimateRange>;
  enabled?: Maybe<Scalars['Boolean']>;
  pickup?: Maybe<GqlDurationEstimateRange>;
};

export type GqlDutchiePay = {
  __typename?: 'DutchiePay';
  preAuth?: Maybe<GqlDutchiePayPreAuth>;
};

export type GqlDutchiePayEnrollment = {
  __typename?: 'DutchiePayEnrollment';
  bankAccounts: Array<Maybe<GqlMxBankAccount>>;
  billingAddress?: Maybe<GqlBillingAddress>;
  enrollment: GqlStatus;
};

export type GqlDutchiePayPaymentMethod = {
  __typename?: 'DutchiePayPaymentMethod';
  bankAccount?: Maybe<GqlBankDetails>;
  billingAddress?: Maybe<GqlBillingAddress>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  entity?: Maybe<GqlEntity>;
  id: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum DutchiePayPaymentMethodType {
  paymentMethodTypeBankAccount = 'PAYMENT_METHOD_TYPE_BANK_ACCOUNT',
  paymentMethodTypeUnspecified = 'PAYMENT_METHOD_TYPE_UNSPECIFIED'
}

export type GqlDutchiePayPreAuth = {
  __typename?: 'DutchiePayPreAuth';
  amount: Scalars['Int'];
  callbackUrl: Scalars['String'];
  currency: Scalars['Int'];
  paymentId: Scalars['String'];
};

export type GqlDutchiePosLoyaltyConfig = {
  __typename?: 'DutchiePosLoyaltyConfig';
  isEnabled: Scalars['Boolean'];
  loyaltyDaysToExpiration?: Maybe<Scalars['Int']>;
  loyaltyRequireOptIn: Scalars['Boolean'];
  mode?: Maybe<Scalars['String']>;
  onlineDescription?: Maybe<Scalars['String']>;
  onlineName?: Maybe<Scalars['String']>;
  redemptionType?: Maybe<Scalars['String']>;
  tierEarningBasis?: Maybe<Scalars['String']>;
  tiers?: Maybe<Array<Maybe<GqlDutchiePosLoyaltyTier>>>;
};

export type GqlDutchiePosLoyaltyTier = {
  __typename?: 'DutchiePosLoyaltyTier';
  badgeColor: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  threshold: Scalars['Int'];
};

export type GqlEcommerceAbandonedCartsResponse = {
  __typename?: 'EcommerceAbandonedCartsResponse';
  carts?: Maybe<Array<Maybe<GqlCartSummary>>>;
  meta?: Maybe<GqlAnalyticsMeta>;
};

export type GqlEcommerceConversionFunnel = {
  __typename?: 'EcommerceConversionFunnel';
  addedToCart?: Maybe<GqlEcommercePercent>;
  interacted?: Maybe<GqlEcommercePercent>;
  placedOrder?: Maybe<GqlEcommercePercent>;
  visitedCheckout?: Maybe<GqlEcommercePercent>;
  visitedMenu?: Maybe<GqlEcommercePercent>;
};

export type GqlEcommercePercent = {
  __typename?: 'EcommercePercent';
  currentValue?: Maybe<Scalars['Float']>;
  percentOfVisits?: Maybe<Scalars['Float']>;
  unitDifferenceFromLastPeriod?: Maybe<Scalars['Float']>;
};

export type GqlEcommerceValue = {
  __typename?: 'EcommerceValue';
  currentValue?: Maybe<Scalars['Float']>;
  percentDifference?: Maybe<Scalars['Float']>;
};

export enum Effect {
  body = 'BODY',
  calm = 'CALM',
  clearMind = 'CLEAR_MIND',
  comfort = 'COMFORT',
  creative = 'CREATIVE',
  energetic = 'ENERGETIC',
  euphoric = 'EUPHORIC',
  focused = 'FOCUSED',
  happy = 'HAPPY',
  inspired = 'INSPIRED',
  joints = 'JOINTS',
  mind = 'MIND',
  muscles = 'MUSCLES',
  painRelief = 'PAIN_RELIEF',
  relaxed = 'RELAXED',
  skinHealth = 'SKIN_HEALTH',
  sleepy = 'SLEEPY'
}

export type GqlEffectiveHours = {
  __typename?: 'EffectiveHours';
  /** @deprecated new HoursSettingsForOrderType in hours-settings has effective hours per order type */
  deliveryHours?: Maybe<GqlDispensaries_Profile_Hours>;
  /** @deprecated new HoursSettingsForOrderType in hours-settings has effective hours per order type */
  pickupHours?: Maybe<GqlDispensaries_Profile_Hours>;
};

export type GqlEnabledOrderTypes = {
  __typename?: 'EnabledOrderTypes';
  curbsidePickup?: Maybe<Scalars['Boolean']>;
  delivery?: Maybe<Scalars['Boolean']>;
  driveThruPickup?: Maybe<Scalars['Boolean']>;
  inStorePickup?: Maybe<Scalars['Boolean']>;
  kiosk?: Maybe<Scalars['Boolean']>;
  pickup?: Maybe<Scalars['Boolean']>;
};

export type GqlEnterprise = {
  __typename?: 'Enterprise';
  accountTier?: Maybe<Scalars['String']>;
  billingVersion: Scalars['Int'];
  createdAt: Scalars['ISODateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  primaryContactId?: Maybe<Scalars['ID']>;
  retailers: Array<GqlRetailer>;
  uniqueName: Scalars['String'];
  updatedAt: Scalars['ISODateTime'];
  website?: Maybe<Scalars['String']>;
};

export type GqlEnterpriseBrand = {
  __typename?: 'EnterpriseBrand';
  name?: Maybe<Scalars['String']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GqlEnterpriseCategory = {
  __typename?: 'EnterpriseCategory';
  category?: Maybe<Scalars['String']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  subcategory?: Maybe<Scalars['String']>;
};

export type GqlEnterpriseDispensaryAdSettings = {
  __typename?: 'EnterpriseDispensaryAdSettings';
  adSettings: GqlDispensaryAdSettings;
  id: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
};

export type GqlEnterpriseDispensaryPersonalizationSettings = {
  __typename?: 'EnterpriseDispensaryPersonalizationSettings';
  id: Scalars['String'];
  name: Scalars['String'];
  personalizationSettings: GqlDispensaryPersonalizationSettings;
  status: Scalars['String'];
};

export type GqlEnterpriseDispensaryProduct = {
  __typename?: 'EnterpriseDispensaryProduct';
  brandId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  dispensaryId?: Maybe<Scalars['String']>;
  enterpriseProductId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  /** @deprecated Wrong location and not used. (ENG-25806) 04/11/2022 */
  medicalOnly?: Maybe<Scalars['Boolean']>;
  /** @deprecated Wrong location and not used. (ENG-25806) 04/11/2022 */
  recOnly?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type GqlEnterpriseLoyaltySettings = {
  __typename?: 'EnterpriseLoyaltySettings';
  enterpriseId: Scalars['ID'];
  isoRegionCodes: Array<Scalars['String']>;
  landingPageUrl?: Maybe<Scalars['String']>;
  loyaltyEnrollmentUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  uniqueName: Scalars['String'];
};

export type GqlEnterpriseMobileAppSettings = {
  __typename?: 'EnterpriseMobileAppSettings';
  androidAppIcon?: Maybe<Scalars['String']>;
  androidExistingVersion?: Maybe<Scalars['String']>;
  androidExistingVersionCode?: Maybe<Scalars['Int']>;
  androidPackageName?: Maybe<Scalars['String']>;
  androidSplashBackgroundColor?: Maybe<Scalars['String']>;
  buildForIpad?: Maybe<Scalars['Boolean']>;
  firebaseProjectId?: Maybe<Scalars['String']>;
  headerImage?: Maybe<Scalars['String']>;
  iosAppIcon?: Maybe<Scalars['String']>;
  iosAppStoreId?: Maybe<Scalars['String']>;
  iosBundleIdentifier?: Maybe<Scalars['String']>;
  iosExistingVersion?: Maybe<Scalars['String']>;
  iosSplashBackgroundColor?: Maybe<Scalars['String']>;
  iosTeamId?: Maybe<Scalars['String']>;
  iosTeamName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
};

export type GqlEnterpriseMobileAppSettingsInput = {
  androidAppIcon?: InputMaybe<Scalars['String']>;
  androidExistingVersion?: InputMaybe<Scalars['String']>;
  androidExistingVersionCode?: InputMaybe<Scalars['Int']>;
  androidPackageName?: InputMaybe<Scalars['String']>;
  androidSplashBackgroundColor?: InputMaybe<Scalars['String']>;
  buildForIpad?: InputMaybe<Scalars['Boolean']>;
  firebaseProjectId?: InputMaybe<Scalars['String']>;
  headerImage?: InputMaybe<Scalars['String']>;
  iosAppIcon?: InputMaybe<Scalars['String']>;
  iosAppStoreId?: InputMaybe<Scalars['String']>;
  iosBundleIdentifier?: InputMaybe<Scalars['String']>;
  iosExistingVersion?: InputMaybe<Scalars['String']>;
  iosSplashBackgroundColor?: InputMaybe<Scalars['String']>;
  iosTeamId?: InputMaybe<Scalars['String']>;
  iosTeamName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
};

export type GqlEnterpriseProduct = {
  __typename?: 'EnterpriseProduct';
  brandId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  dispensaryProducts?: Maybe<Array<Maybe<GqlEnterpriseDispensaryProduct>>>;
  enterpriseProductId?: Maybe<Scalars['String']>;
  medicalOnly?: Maybe<Scalars['Boolean']>;
  medicalPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
  prices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  rawOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  recOnly?: Maybe<Scalars['Boolean']>;
  recPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  subcategory?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GqlEnterpriseProducts = {
  __typename?: 'EnterpriseProducts';
  brands?: Maybe<Array<Maybe<GqlEnterpriseBrand>>>;
  categories?: Maybe<Array<Maybe<GqlEnterpriseCategory>>>;
  products?: Maybe<Array<Maybe<GqlEnterpriseProduct>>>;
};

export type GqlEnterpriseSpecial = {
  __typename?: 'EnterpriseSpecial';
  _id?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  applyRewardsToConditions?: Maybe<Scalars['Boolean']>;
  bogoConditionLogicOperator?: Maybe<Scalars['String']>;
  bogoConditions?: Maybe<Array<Maybe<GqlBogoConditionItem>>>;
  bogoRewardLogicOperator?: Maybe<Scalars['String']>;
  bogoRewards?: Maybe<Array<Maybe<GqlBogoRewardItem>>>;
  cipher?: Maybe<Scalars['JSON']>;
  clicks?: Maybe<Scalars['Int']>;
  complete?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['String']>;
  discountPrecedence?: Maybe<Scalars['String']>;
  discountStacking?: Maybe<Scalars['Boolean']>;
  discountToCart?: Maybe<GqlDiscountToCart>;
  discountedPrices?: Maybe<Scalars['JSON']>;
  dispensaries?: Maybe<Array<Maybe<Scalars['String']>>>;
  dispensaryId?: Maybe<Scalars['String']>;
  displayRank?: Maybe<Scalars['Int']>;
  dollarDiscount?: Maybe<Scalars['Boolean']>;
  duplicatedFrom?: Maybe<Scalars['String']>;
  earliestStartStamp?: Maybe<Scalars['ISODateTime']>;
  eligibleProductOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  emailSpecial?: Maybe<Scalars['Boolean']>;
  endDay?: Maybe<Scalars['ISODateTime']>;
  endStamp?: Maybe<Scalars['ISODateTime']>;
  endTime?: Maybe<Scalars['String']>;
  enterpriseId?: Maybe<Scalars['String']>;
  enterpriseSpecialId?: Maybe<Scalars['String']>;
  excludeConditionItemsFromRewards?: Maybe<Scalars['Boolean']>;
  excludedProducts?: Maybe<Array<Maybe<GqlSpecialsExcludedProducts>>>;
  heading?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  inactiveDispensaries?: Maybe<Array<Maybe<Scalars['String']>>>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  itemsForAPrice?: Maybe<GqlItemsForAPrice>;
  latestEndStamp?: Maybe<Scalars['ISODateTime']>;
  localTime?: Maybe<Scalars['Boolean']>;
  menuDisplayDescription?: Maybe<Scalars['String']>;
  menuDisplayImage?: Maybe<Scalars['String']>;
  menuDisplayName?: Maybe<Scalars['String']>;
  menuType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  percentDiscount?: Maybe<Scalars['Boolean']>;
  productDiscounts?: Maybe<Scalars['JSON']>;
  productGroup?: Maybe<Scalars['String']>;
  productGroupRewards?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  recurring?: Maybe<GqlSpecialsRecurring>;
  redemptionLimit?: Maybe<Scalars['Int']>;
  /** @deprecated Use dispensaries instead. 11/11/2021 */
  retailers?: Maybe<Array<Maybe<Scalars['String']>>>;
  saleDiscounts?: Maybe<Array<Maybe<GqlSaleDiscount>>>;
  scope?: Maybe<SpecialScopes>;
  source?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  specialRestrictions?: Maybe<Scalars['JSON']>;
  specialType?: Maybe<SpecialTypes>;
  stackingBehavior?: Maybe<Scalars['String']>;
  stackingMode?: Maybe<Scalars['String']>;
  startDay?: Maybe<Scalars['ISODateTime']>;
  startStamp?: Maybe<Scalars['ISODateTime']>;
  startTime?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  targetPrice?: Maybe<Scalars['Boolean']>;
  timezone?: Maybe<Scalars['String']>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type GqlEnterpriseSpecialInputV2 = {
  _id?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  applicableToItemsOnSpecial?: InputMaybe<Scalars['Boolean']>;
  applicationMethod?: InputMaybe<SpecialApplicationMethodTypes>;
  applyRewardsToConditions?: InputMaybe<Scalars['Boolean']>;
  bogoConditionLogicOperator?: InputMaybe<Scalars['String']>;
  bogoConditions?: InputMaybe<Array<InputMaybe<GqlBogoConditionItemInput>>>;
  bogoRewardLogicOperator?: InputMaybe<Scalars['String']>;
  bogoRewards?: InputMaybe<Array<InputMaybe<GqlBogoRewardItemInput>>>;
  cipher?: InputMaybe<Scalars['JSON']>;
  code?: InputMaybe<Scalars['String']>;
  complete?: InputMaybe<Scalars['Boolean']>;
  conditionLogicOperator?: InputMaybe<LogicOperator>;
  conditions?: InputMaybe<Array<InputMaybe<GqlV4ConditionInput>>>;
  consumerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['ISODateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionHtml?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['String']>;
  discountBundle?: InputMaybe<GqlDiscountBundleInput>;
  discountPrecedence?: InputMaybe<Scalars['String']>;
  discountStacking?: InputMaybe<Scalars['Boolean']>;
  discountToCart?: InputMaybe<GqlDiscountToCartInput>;
  discountedPrices?: InputMaybe<Scalars['JSON']>;
  dispensaries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayRank?: InputMaybe<Scalars['Int']>;
  dollarDiscount?: InputMaybe<Scalars['Boolean']>;
  duplicatedFrom?: InputMaybe<Scalars['String']>;
  earliestStartStamp?: InputMaybe<Scalars['ISODateTime']>;
  editedStartStamp?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<GqlSpecialEmailInput>;
  emailSpecial?: InputMaybe<Scalars['Boolean']>;
  endDay?: InputMaybe<Scalars['String']>;
  endStamp?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  enterpriseId?: InputMaybe<Scalars['String']>;
  enterpriseSpecialId?: InputMaybe<Scalars['String']>;
  excludeConditionItemsFromRewards?: InputMaybe<Scalars['Boolean']>;
  excludedProducts?: InputMaybe<Array<InputMaybe<GqlSpecialsExcludedProductsInput>>>;
  firstTimeConsumerOnly?: InputMaybe<Scalars['Boolean']>;
  generatedByPOS?: InputMaybe<Scalars['Boolean']>;
  heading?: InputMaybe<Scalars['String']>;
  inactiveDispensaries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  inactiveDispensaryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isAvailableOnline?: InputMaybe<Scalars['Boolean']>;
  isRecurring?: InputMaybe<Scalars['Boolean']>;
  itemsForAPrice?: InputMaybe<GqlItemsForAPriceInput>;
  latestEndStamp?: InputMaybe<Scalars['ISODateTime']>;
  localTime?: InputMaybe<Scalars['Boolean']>;
  loyaltyPointsToRedeem?: InputMaybe<Scalars['Int']>;
  manualDefaultApplyTo?: InputMaybe<ManualDefaultApplyTo>;
  menuDisplay?: InputMaybe<GqlSpecialMenuDisplayInput>;
  menuDisplayDescription?: InputMaybe<Scalars['String']>;
  menuDisplayImage?: InputMaybe<Scalars['String']>;
  menuDisplayName?: InputMaybe<Scalars['String']>;
  menuType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<OrderType>;
  origin?: InputMaybe<Scalars['String']>;
  originId?: InputMaybe<Scalars['String']>;
  percentDiscount?: InputMaybe<Scalars['Boolean']>;
  productDiscounts?: InputMaybe<Array<InputMaybe<GqlProductDiscount>>>;
  productGroup?: InputMaybe<Scalars['String']>;
  productGroupRewards?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quantityUsed?: InputMaybe<Scalars['Int']>;
  recurring?: InputMaybe<GqlSpecialsInputRecurring>;
  redemptionLimit?: InputMaybe<Scalars['Int']>;
  redemptionLimitPerCart?: InputMaybe<Scalars['Int']>;
  redemptionLimitPerUser?: InputMaybe<Scalars['Int']>;
  reimbursed?: InputMaybe<Scalars['Boolean']>;
  requireManagerApproval?: InputMaybe<Scalars['Boolean']>;
  rewardLogicOperator?: InputMaybe<LogicOperator>;
  rewards?: InputMaybe<Array<InputMaybe<GqlV4RewardInput>>>;
  saleDiscounts?: InputMaybe<Array<InputMaybe<GqlSaleDiscountInput>>>;
  schedule?: InputMaybe<GqlSpecialScheduleInput>;
  scope?: InputMaybe<SpecialScopes>;
  source?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  specialId?: InputMaybe<Scalars['String']>;
  specialRestrictions?: InputMaybe<Array<InputMaybe<GqlSpecialRestriction>>>;
  specialType?: InputMaybe<Scalars['String']>;
  specialVersion?: InputMaybe<Scalars['Int']>;
  stackingBehavior?: InputMaybe<Scalars['String']>;
  stackingMode?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  startDay?: InputMaybe<Scalars['String']>;
  startStamp?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<SpecialStatus>;
  subject?: InputMaybe<Scalars['String']>;
  targetPrice?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
  totalAllowedUses?: InputMaybe<Scalars['Int']>;
  totalQuantity?: InputMaybe<GqlTotalQuantityInput>;
  totalSpend?: InputMaybe<GqlTotalSpendInput>;
  totalWeight?: InputMaybe<GqlTotalWeightInput>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
  usedBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  version?: InputMaybe<Scalars['Int']>;
};

export type GqlEnterpriseSpecialsHistory = {
  __typename?: 'EnterpriseSpecialsHistory';
  enterpriseSpecialId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  versions?: Maybe<Array<Maybe<GqlEnterpriseSpecial>>>;
};

export type GqlEnterpriseSpecialsSettings = {
  __typename?: 'EnterpriseSpecialsSettings';
  discountPrecedence?: Maybe<Scalars['String']>;
  discountStacking?: Maybe<Scalars['Boolean']>;
  enableIndividualDiscountStacking?: Maybe<Scalars['Boolean']>;
  enableIndividualSpecialPrecedence?: Maybe<Scalars['Boolean']>;
  nonStackingBehavior?: Maybe<Scalars['String']>;
  permissionEnabled?: Maybe<Scalars['Boolean']>;
  stackingBehavior?: Maybe<Scalars['String']>;
};

export type GqlEnterpriseSpecialsSettingsInput = {
  discountPrecedence?: InputMaybe<Scalars['String']>;
  discountStacking?: InputMaybe<Scalars['Boolean']>;
  enableIndividualDiscountStacking?: InputMaybe<Scalars['Boolean']>;
  enableIndividualSpecialPrecedence?: InputMaybe<Scalars['Boolean']>;
  nonStackingBehavior?: InputMaybe<Scalars['String']>;
  permissionEnabled?: InputMaybe<Scalars['Boolean']>;
  stackingBehavior?: InputMaybe<Scalars['String']>;
};

export type GqlEntity = {
  __typename?: 'Entity';
  externalId?: Maybe<Scalars['String']>;
  externalType?: Maybe<EntityTypes>;
  name?: Maybe<Scalars['String']>;
};

export type GqlEntityLinkingCodeResponse = {
  __typename?: 'EntityLinkingCodeResponse';
  code: Scalars['String'];
};

export enum EntityTypes {
  dispensary = 'Dispensary',
  user = 'User'
}

export type GqlErrorMessage = {
  __typename?: 'ErrorMessage';
  message: Scalars['String'];
};

export type GqlExcludedBogoProduct = {
  __typename?: 'ExcludedBOGOProduct';
  Name?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

export type GqlExcludedBogoProducts = {
  __typename?: 'ExcludedBOGOProducts';
  conditions?: Maybe<Array<Maybe<GqlExcludedBogoProduct>>>;
  rewards?: Maybe<Array<Maybe<GqlExcludedBogoProduct>>>;
};

export type GqlExclusion = {
  __typename?: 'Exclusion';
  _id?: Maybe<Scalars['String']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  inventoryTags?: Maybe<Array<Scalars['String']>>;
  matchOperator?: Maybe<Scalars['String']>;
  productGroup?: Maybe<ProductGroup>;
  productIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  productTags?: Maybe<Array<Scalars['String']>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  weightOperator?: Maybe<WeightOperator>;
  weights?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GqlExclusionInput = {
  _id?: InputMaybe<Scalars['String']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  brandNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enterpriseProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  inventoryTags?: InputMaybe<Array<Scalars['String']>>;
  matchOperator?: InputMaybe<Scalars['String']>;
  productGroup?: InputMaybe<ProductGroup>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productTags?: InputMaybe<Array<Scalars['String']>>;
  strainIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subcategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subcategoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weightOperator?: InputMaybe<WeightOperator>;
  weights?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GqlExists = {
  __typename?: 'Exists';
  _id?: Maybe<Scalars['String']>;
  exists?: Maybe<Scalars['Boolean']>;
};

export type GqlExport = {
  __typename?: 'Export';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type GqlExportFilteredCatalogFilterInput = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  category?: InputMaybe<Array<Scalars['String']>>;
  hasImages?: InputMaybe<Scalars['Boolean']>;
  stateLibrary?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<LibraryProductStatusEnum>;
};

export type GqlExportFilteredCatalogResponse = {
  __typename?: 'ExportFilteredCatalogResponse';
  completedAt?: Maybe<Scalars['ISODateTime']>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  filters: GqlExportFilteredCatalogResponseFilters;
  name: Scalars['String'];
  processedCount: Scalars['Int'];
  progressPercentage: Scalars['Float'];
  startedAt?: Maybe<Scalars['ISODateTime']>;
  status: ExportFilteredCatalogStatusEnum;
  totalCount: Scalars['Int'];
  updatedAt?: Maybe<Scalars['ISODateTime']>;
  user?: Maybe<GqlBrandImportHistoryUser>;
};

export type GqlExportFilteredCatalogResponseFilters = {
  __typename?: 'ExportFilteredCatalogResponseFilters';
  brandIds?: Maybe<Array<Scalars['ID']>>;
  category?: Maybe<Array<Scalars['String']>>;
  search?: Maybe<Scalars['String']>;
  stateLibrary?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<LibraryProductStatusEnum>;
};

export enum ExportFilteredCatalogStatusEnum {
  completed = 'completed',
  failed = 'failed',
  inProgress = 'inProgress',
  pending = 'pending'
}

export type GqlExtensionData = {
  __typename?: 'ExtensionData';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type GqlExtensionDataInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type GqlFeeTiersInput = {
  feeInCents?: InputMaybe<Scalars['Int']>;
  feeType?: InputMaybe<FeeTypes>;
  maximumInCents?: InputMaybe<Scalars['Int']>;
  minimumInCents?: InputMaybe<Scalars['Int']>;
  percentFee?: InputMaybe<Scalars['Float']>;
};

export enum FeeTypes {
  flat = 'flat',
  percent = 'percent'
}

export type GqlFees = {
  __typename?: 'Fees';
  deliveryFee?: Maybe<Scalars['Boolean']>;
  feeAmount?: Maybe<Scalars['Int']>;
  feeItemId?: Maybe<Scalars['Int']>;
  feeName?: Maybe<Scalars['String']>;
  paymentFee?: Maybe<Scalars['Boolean']>;
};

export type GqlFilteredBrandSummaryResponse = {
  __typename?: 'FilteredBrandSummaryResponse';
  brands?: Maybe<Array<Maybe<GqlBrandSummary>>>;
  meta?: Maybe<GqlAnalyticsMeta>;
};

export type GqlFilteredCatalogExport = {
  __typename?: 'FilteredCatalogExport';
  completedAt?: Maybe<Scalars['ISODateTime']>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  id: Scalars['ID'];
  isCompleted: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isFailed: Scalars['Boolean'];
  isPending: Scalars['Boolean'];
  isProcessing: Scalars['Boolean'];
  name: Scalars['String'];
  processedCount: Scalars['Int'];
  progressPercentage: Scalars['Float'];
  s3Url?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['ISODateTime']>;
  status: BrandExportsStatusEnum;
  totalCount: Scalars['Int'];
  updatedAt?: Maybe<Scalars['ISODateTime']>;
  user?: Maybe<GqlBrandImportHistoryUser>;
};

export type GqlFilteredEnterpriseSpecials = {
  __typename?: 'FilteredEnterpriseSpecials';
  queryInfo?: Maybe<GqlFilteredSpecialsInfo>;
  specials?: Maybe<Array<Maybe<GqlEnterpriseSpecial>>>;
};

export type GqlFilteredProductSummaryResponse = {
  __typename?: 'FilteredProductSummaryResponse';
  meta?: Maybe<GqlAnalyticsMeta>;
  products?: Maybe<Array<Maybe<GqlProductSummary>>>;
};

export type GqlFilteredSpecials = {
  __typename?: 'FilteredSpecials';
  queryInfo?: Maybe<GqlFilteredSpecialsInfo>;
  specials?: Maybe<Array<Maybe<GqlSpecials>>>;
};

export type GqlFilteredSpecialsInfo = {
  __typename?: 'FilteredSpecialsInfo';
  totalCount?: Maybe<Scalars['Int']>;
};

export type GqlFindLibraryProductsResponse = {
  __typename?: 'FindLibraryProductsResponse';
  libraryProducts?: Maybe<Array<Maybe<GqlLibraryProduct>>>;
};

export type GqlFontInput = {
  body?: InputMaybe<Scalars['String']>;
  heading?: InputMaybe<Scalars['String']>;
};

export type GqlFontSettings = {
  __typename?: 'FontSettings';
  family: CustomFont;
};

export type GqlFontSettingsInput = {
  family: CustomFont;
};

export type GqlFonts = {
  __typename?: 'Fonts';
  body?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
};

export type GqlFraudPaymentMethod = {
  paymentType: Scalars['String'];
  routingNumber: Scalars['String'];
};

export type GqlFundRethinkResponse = {
  __typename?: 'FundRethinkResponse';
  redirectUrl: Scalars['String'];
};

export type GqlGamificationDetailItem = {
  __typename?: 'GamificationDetailItem';
  discountId?: Maybe<Scalars['Int']>;
  satisfiers?: Maybe<Array<Maybe<GqlGamificationDetailItem_Satisfier>>>;
};

export type GqlGamificationDetailItem_Satisfier = {
  __typename?: 'GamificationDetailItem_Satisfier';
  minimumThreshold?: Maybe<Scalars['Float']>;
  products?: Maybe<Array<Maybe<GqlGamificationDetailItem_Satisfiers_Product>>>;
  thresholdType?: Maybe<Scalars['String']>;
};

export type GqlGamificationDetailItem_Satisfiers_Product = {
  __typename?: 'GamificationDetailItem_Satisfiers_Product';
  amount?: Maybe<Scalars['Float']>;
  ecommKey?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
};

export type GqlGenericExportResponse = {
  __typename?: 'GenericExportResponse';
  count?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type GqlGenericResponse = {
  __typename?: 'GenericResponse';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type GqlGeoJson_Features = {
  __typename?: 'GeoJson_features';
  geometry?: Maybe<GqlGeoJson_Geometry>;
  type?: Maybe<Scalars['String']>;
};

export type GqlGeoJson_FeaturesInput = {
  geometry?: InputMaybe<GqlGeoJson_GeometryInput>;
  type?: InputMaybe<Scalars['String']>;
};

export type GqlGeoJson_Geometry = {
  __typename?: 'GeoJson_geometry';
  coordinates?: Maybe<Scalars['JSON']>;
  type?: Maybe<Scalars['String']>;
};

export type GqlGeoJson_GeometryInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['Float']>>>>>>>;
  type?: InputMaybe<Scalars['String']>;
};

export type GqlGeographicSearchBounds = {
  lat: Scalars['String'];
  lon: Scalars['String'];
  radius: Scalars['String'];
};

export type GqlGeometryInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type GqlGetAchPaymentDetailsResponse = {
  __typename?: 'GetAchPaymentDetailsResponse';
  payment?: Maybe<GqlPayment>;
};

export type GqlGetAchPaymentFraudAssessmentsResponse = {
  __typename?: 'GetAchPaymentFraudAssessmentsResponse';
  assessments: Array<GqlAssessment>;
};

export type GqlGetCollectionProductCountConditionInput = {
  condition: Scalars['String'];
  itemKey: Scalars['String'];
  itemValue: Scalars['String'];
};

export type GqlGetCollectionProductCountInput = {
  allConditions: Scalars['Boolean'];
  conditions: Array<InputMaybe<GqlGetCollectionProductCountConditionInput>>;
};

export type GqlGetOrderSortInput = {
  desc: Scalars['Boolean'];
  id: Scalars['String'];
};

export type GqlGetOrderType = {
  __typename?: 'GetOrderType';
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<GqlOrders>;
};

export type GqlGetPersonalizedProductsInput = {
  dispensaryId: Scalars['String'];
  filter: GqlPersonalizedProductsFilter;
  limit?: InputMaybe<Scalars['Int']>;
};

export type GqlGetPersonalizedProductsV2Input = {
  dispensaryId: Scalars['String'];
  filters: GqlPersonalizedProductsFilterV2;
  limit?: InputMaybe<Scalars['Int']>;
  modelName: PersonalizedProductsModelNames;
  productIds?: InputMaybe<Array<Scalars['String']>>;
};

export type GqlGetRawAchBatchFileResponse = {
  __typename?: 'GetRawAchBatchFileResponse';
  data?: Maybe<GqlAchRawBatchFile>;
};

export type GqlGetSortedProductRecommendationsInput = {
  dispensaryId: Scalars['String'];
  filter: GqlPersonalizedProductsFilterV2;
  limit?: InputMaybe<Scalars['Int']>;
};

export type GqlGetSponsoredBrandInput = {
  category?: InputMaybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  filters?: InputMaybe<GqlGetSponsoredResourceFilters>;
  inventoryId: AdInventoryId;
  maximumProducts?: InputMaybe<Scalars['Int']>;
  minimumProducts?: InputMaybe<Scalars['Int']>;
};

export type GqlGetSponsoredProductsInput = {
  category?: InputMaybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  filters?: InputMaybe<GqlGetSponsoredResourceFilters>;
  inventoryId: SponsoredProductsInventoryId;
  limit: Scalars['Int'];
  productId?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type GqlGetSponsoredResourceFilters = {
  brands?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  category?: InputMaybe<Scalars['String']>;
  effects?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  menuType?: InputMaybe<Scalars['String']>;
  potencyCbd?: InputMaybe<GqlPotencyRange>;
  potencyThc?: InputMaybe<GqlPotencyRange>;
  strainTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['String']>;
};

export type GqlGetUserStatusResponse = {
  __typename?: 'GetUserStatusResponse';
  eligible: Scalars['Boolean'];
  incentive?: Maybe<GqlIncentive>;
};

export type GqlGlobalReward = {
  __typename?: 'GlobalReward';
  amountOff?: Maybe<Scalars['Int']>;
  discountType?: Maybe<DiscountType>;
  discountedPrice?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Boolean']>;
  percentDiscount?: Maybe<Scalars['Float']>;
};

export type GqlGlobalRewardInput = {
  amountOff?: InputMaybe<Scalars['Int']>;
  discountType?: InputMaybe<DiscountType>;
  discountedPrice?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  percentDiscount?: InputMaybe<Scalars['Float']>;
};

export type GqlGlobalThreshold = {
  __typename?: 'GlobalThreshold';
  comparisonOperator?: Maybe<ComparisonOperators>;
  price?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  thresholdType?: Maybe<GlobalThresholdType>;
  weight?: Maybe<GqlWeight>;
};

export type GqlGlobalThresholdInput = {
  comparisonOperator?: InputMaybe<ComparisonOperators>;
  price?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  thresholdType?: InputMaybe<GlobalThresholdType>;
  weight?: InputMaybe<GqlWeightInput>;
};

export enum GlobalThresholdType {
  totalPrice = 'TOTAL_PRICE',
  totalQuantity = 'TOTAL_QUANTITY',
  totalWeight = 'TOTAL_WEIGHT'
}

export type GqlGoogleProtobufTimestamp = {
  __typename?: 'GoogleProtobufTimestamp';
  nanos?: Maybe<Scalars['Int']>;
  seconds?: Maybe<Scalars['Int']>;
};

export type GqlHealthCheck = {
  __typename?: 'HealthCheck';
  status?: Maybe<Scalars['String']>;
};

export type GqlHoursForOrderType = {
  effectiveHours?: InputMaybe<GqlWeeklyHoursInput>;
  hours?: InputMaybe<GqlWeeklyHoursInput>;
  specialHours?: InputMaybe<Array<InputMaybe<GqlSpecialHoursSettingsInput>>>;
};

export type GqlHoursSettingsForOrderType = {
  __typename?: 'HoursSettingsForOrderType';
  effectiveHours?: Maybe<GqlWeeklyHours>;
  hours?: Maybe<GqlWeeklyHours>;
  specialHours?: Maybe<Array<Maybe<GqlSpecialHours>>>;
};

export type GqlHoursSettingsForOrderTypeInput = {
  hours?: InputMaybe<GqlWeeklyHoursInput>;
  specialHours?: InputMaybe<Array<InputMaybe<GqlSpecialHoursSettingsInput>>>;
};

export type GqlHoursSettingsUpdateInput = {
  curbsidePickup?: InputMaybe<GqlHoursSettingsForOrderTypeInput>;
  delivery?: InputMaybe<GqlHoursSettingsForOrderTypeInput>;
  dispensaryId: Scalars['String'];
  driveThruPickup?: InputMaybe<GqlHoursSettingsForOrderTypeInput>;
  inStorePickup?: InputMaybe<GqlHoursSettingsForOrderTypeInput>;
};

export type GqlHypurDetails = {
  __typename?: 'HypurDetails';
  id: Scalars['String'];
};

export type GqlHypurRedirect = {
  __typename?: 'HypurRedirect';
  url: Scalars['String'];
};

export type GqlHypurToken = {
  __typename?: 'HypurToken';
  accessToken: Scalars['String'];
  embedded: Scalars['Boolean'];
};

export type GqlIpInfo = {
  __typename?: 'IPInfo';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  hostname?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  loc?: Maybe<Scalars['String']>;
  org?: Maybe<Scalars['String']>;
  postal?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type GqlIdImage = {
  __typename?: 'IdImage';
  key?: Maybe<Scalars['String']>;
};

export type GqlIdUrl = {
  __typename?: 'IdUrl';
  url?: Maybe<Scalars['String']>;
};

export type GqlIdentityAdmin = {
  __typename?: 'IdentityAdmin';
  _id: Scalars['ID'];
  chainDispensaryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  dispensary?: Maybe<GqlDispensaries>;
  emails: Array<Maybe<GqlUserEmails>>;
  enterpriseId?: Maybe<Scalars['ID']>;
  profile: GqlIdentityAdminProfile;
  zendeskSingleSignOnToken?: Maybe<Scalars['String']>;
  zendeskWidgetToken?: Maybe<Scalars['String']>;
};

export type GqlIdentityAdminProfile = {
  __typename?: 'IdentityAdminProfile';
  acceptedTOS?: Maybe<Scalars['ISODateTime']>;
  active?: Maybe<Scalars['Boolean']>;
  audioNotificationsOnNewArrivalsDisabled?: Maybe<Scalars['Boolean']>;
  audioNotificationsOnNewOrdersDisabled?: Maybe<Scalars['Boolean']>;
  browserNotification?: Maybe<Scalars['Boolean']>;
  chainID?: Maybe<Scalars['String']>;
  chainId?: Maybe<Scalars['String']>;
  desktopNotification?: Maybe<Scalars['Boolean']>;
  dispensaryId?: Maybe<Scalars['String']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptIn?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  firstViewedTOS?: Maybe<Scalars['ISODateTime']>;
  focusedAccounts?: Maybe<Array<GqlBrandUserFocusedAccount>>;
  fullName?: Maybe<Scalars['String']>;
  isWeeklyReportEnabled?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  managedBrandIds?: Maybe<Array<Scalars['ID']>>;
  parentBrandId?: Maybe<Scalars['ID']>;
  permissions?: Maybe<GqlIdentityAdminProfilePermissions>;
  phone?: Maybe<Scalars['String']>;
  roleAtDispensary?: Maybe<DispensaryRoles>;
  streamTokens?: Maybe<Array<Maybe<GqlDispensaryStreamToken>>>;
  /** @deprecated no longer sending admin text notifications */
  textNotifications?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type GqlIdentityAdminProfilePermissions = {
  __typename?: 'IdentityAdminProfilePermissions';
  allLocations: Scalars['Boolean'];
  analytics: Scalars['Boolean'];
  billing: Scalars['Boolean'];
  customers: Scalars['Boolean'];
  dispensaryIds?: Maybe<Array<Scalars['String']>>;
  driver: Scalars['Boolean'];
  editBrandUsers?: Maybe<Scalars['Boolean']>;
  enterpriseAdmin?: Maybe<Scalars['Boolean']>;
  enterpriseSpecials?: Maybe<Scalars['Boolean']>;
  manageAdCampaigns: Scalars['Boolean'];
  /** @deprecated Use manageBrandGroup */
  manageAllBrands?: Maybe<Scalars['Boolean']>;
  manageBrandGroup?: Maybe<Scalars['Boolean']>;
  manageBrands?: Maybe<Scalars['Boolean']>;
  menu: Scalars['Boolean'];
  menuReview?: Maybe<Scalars['Boolean']>;
  messaging: Scalars['Boolean'];
  orders: Scalars['Boolean'];
  promote: Scalars['Boolean'];
  settings: Scalars['Boolean'];
  superMenuReview?: Maybe<Scalars['Boolean']>;
  tasks?: Maybe<Scalars['Boolean']>;
  techSupportFeatures?: Maybe<Scalars['Boolean']>;
  users: Scalars['Boolean'];
};

export type GqlIdentityConsumer = {
  __typename?: 'IdentityConsumer';
  _id: Scalars['ID'];
  createdAt?: Maybe<Scalars['ISODateTime']>;
  emails: Array<Maybe<GqlUserEmails>>;
  payByBankEnrollmentStatus?: Maybe<GqlShowEnrollmentResponse>;
  profile: GqlIdentityConsumerProfile;
};

export type GqlIdentityConsumerProfile = {
  __typename?: 'IdentityConsumerProfile';
  address?: Maybe<GqlConsumerUserProfileAddressType>;
  birthday?: Maybe<Scalars['String']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptIn?: Maybe<Scalars['Boolean']>;
  emailSubscription?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  inStoreEnrollmentCompleted?: Maybe<Scalars['Boolean']>;
  isExternalUser?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  medicalCard?: Maybe<GqlConsumerUserMedicalCard>;
  phone?: Maybe<Scalars['String']>;
  photoId?: Maybe<Scalars['String']>;
  textNotifications?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type GqlImageBanner = {
  __typename?: 'ImageBanner';
  _id: Scalars['String'];
  alt?: Maybe<Scalars['String']>;
  image: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use platforms.link instead */
  link?: Maybe<Scalars['String']>;
  mobileImage: Scalars['String'];
  /** @deprecated Use platforms.openInNewTab instead */
  openInNewTab?: Maybe<Scalars['Boolean']>;
  platforms?: Maybe<Array<Maybe<GqlImageBannerPlatform>>>;
  position: Scalars['Int'];
  schedule?: Maybe<GqlSchedule>;
};

export type GqlImageBannerPlatform = {
  __typename?: 'ImageBannerPlatform';
  enabled: Scalars['Boolean'];
  link?: Maybe<Scalars['String']>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  type: ImageBannerPlatformType;
};

export type GqlImageBannerPlatformInput = {
  enabled: Scalars['Boolean'];
  link?: InputMaybe<Scalars['String']>;
  openInNewTab?: InputMaybe<Scalars['Boolean']>;
  type: ImageBannerPlatformType;
};

export enum ImageBannerPlatformType {
  iosMobileApp = 'iosMobileApp',
  kiosk = 'kiosk',
  web = 'web'
}

export enum ImageOrigin {
  admin = 'admin',
  library = 'library',
  pos = 'pos'
}

export enum ImageVariantKeyEnum {
  specialLogoImage = 'SpecialLogoImage',
  bannerImage = 'bannerImage',
  brandedDutchiePayLogoDark = 'brandedDutchiePayLogoDark',
  brandedDutchiePayLogoLight = 'brandedDutchiePayLogoLight',
  embeddedLogoImage = 'embeddedLogoImage',
  listImage = 'listImage',
  logoImage = 'logoImage'
}

export type GqlImgixSettings = {
  __typename?: 'ImgixSettings';
  border?: Maybe<Scalars['String']>;
  fit?: Maybe<ImgixSettings_FitType>;
  mark?: Maybe<Scalars['String']>;
  markpad?: Maybe<Scalars['Int']>;
  markscale?: Maybe<Scalars['Int']>;
};

export enum ImgixSettings_FitType {
  crop = 'crop',
  fill = 'fill',
  fillmax = 'fillmax'
}

export type GqlImportMenuCsvInput = {
  customFieldMapping?: InputMaybe<Array<InputMaybe<GqlIntegrationsCustomFieldInput>>>;
  id: Scalars['String'];
  menuImportData?: InputMaybe<Scalars['String']>;
};

export type GqlInStorePickupOrderingSettings = GqlBaseOrderingSettings & {
  __typename?: 'InStorePickupOrderingSettings';
  checkoutMessage?: Maybe<Scalars['String']>;
  enableASAPOrdering?: Maybe<Scalars['Boolean']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']>;
  enableScheduledOrdering?: Maybe<Scalars['Boolean']>;
  orderMinimum?: Maybe<GqlOrderMinimum>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  pickupReminders?: Maybe<GqlPickupReminders>;
  /** @deprecated replaced by v2 to remove slots from type - RTL 8/9/21 */
  scheduledOrderingConfig?: Maybe<GqlReservationOptionsForOrderType>;
  scheduledOrderingConfigV2?: Maybe<GqlScheduledOrderingConfigV2>;
};

export type GqlIncentive = {
  __typename?: 'Incentive';
  active: Scalars['Boolean'];
  amountCents: Scalars['Int'];
  cohortName: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GqlInsightsFilterInput = {
  inventoryLevel: InventoryLevelEnum;
  isoRegionCodes?: InputMaybe<Array<Scalars['String']>>;
  lspAccounts?: InputMaybe<Array<GqlLspAccountFilter>>;
  optInStatus?: InputMaybe<Scalars['Boolean']>;
};

export enum InsightsSortByEnum {
  excessOpportunity = 'excessOpportunity',
  gmvOpportunity = 'gmvOpportunity'
}

export type GqlInsightsSortInput = {
  sortBy?: InputMaybe<InsightsSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlInstoreAnalyticsToken = {
  __typename?: 'InstoreAnalyticsToken';
  instoreAnalyticsTokenId: Scalars['String'];
};

export type GqlInstoreCart = {
  __typename?: 'InstoreCart';
  currency: Scalars['String'];
  discounts?: Maybe<Array<GqlSubtotalItem>>;
  fees?: Maybe<Array<GqlSubtotalItem>>;
  id: Scalars['String'];
  items: Array<GqlInstoreCartItem>;
  subtotalCents: Scalars['Int'];
  taxes: Array<GqlSubtotalItem>;
  tipCents: Scalars['Int'];
  totalCents: Scalars['Int'];
};

export type GqlInstoreCartDataType = {
  __typename?: 'InstoreCartDataType';
  instoreCart: GqlInstoreCart;
  retailerId: Scalars['String'];
  tippingDisabled: Scalars['Boolean'];
};

export type GqlInstoreCartItem = {
  __typename?: 'InstoreCartItem';
  brandName: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  quantity: Scalars['String'];
  valueCents: Scalars['Int'];
};

export type GqlIntegrations = {
  __typename?: 'Integrations';
  _id?: Maybe<Scalars['String']>;
  adapter?: Maybe<Scalars['String']>;
  categoryMapping?: Maybe<Array<Maybe<GqlIntegrationsCategoryMapping>>>;
  credentials?: Maybe<Scalars['JSON']>;
  crmPipelineMapping?: Maybe<GqlIntegrationsPipelineMapping>;
  crmPropertyMapping?: Maybe<Array<Maybe<GqlIntegrationsPropertyMapping>>>;
  dispensaryId?: Maybe<Scalars['String']>;
  failedSyncs?: Maybe<Scalars['Int']>;
  fieldMapping?: Maybe<Array<Maybe<GqlIntegrationsFieldMapping>>>;
  flags?: Maybe<Scalars['JSON']>;
  integrationCategory?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isRunning?: Maybe<Scalars['Boolean']>;
  kioskThresholds?: Maybe<Scalars['JSON']>;
  lastImportedAtISO?: Maybe<Scalars['ISODateTime']>;
  /** @deprecated Use ISO field */
  lastSyncAt?: Maybe<Scalars['String']>;
  lastSyncAtISO?: Maybe<Scalars['ISODateTime']>;
  live?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<GqlIntegrationsMeta>;
  pending?: Maybe<Scalars['Boolean']>;
  syncFailureMessage?: Maybe<Scalars['String']>;
  syncFailureType?: Maybe<Scalars['String']>;
  thresholds?: Maybe<Scalars['JSON']>;
  types?: Maybe<Scalars['JSON']>;
  weights?: Maybe<Scalars['JSON']>;
};

export type GqlIntegrationsAdapterStatus = {
  __typename?: 'IntegrationsAdapterStatus';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<IntegrationsAdapterStatusCode>;
};

export enum IntegrationsAdapterStatusCode {
  degraded = 'DEGRADED',
  down = 'DOWN',
  normal = 'NORMAL'
}

export type GqlIntegrationsCategoryMapping = {
  __typename?: 'IntegrationsCategoryMapping';
  foreignCategory?: Maybe<Scalars['String']>;
  localCategory?: Maybe<Scalars['String']>;
  localSubcategory?: Maybe<Scalars['String']>;
};

export type GqlIntegrationsCustomFieldInput = {
  foreignField?: InputMaybe<Scalars['String']>;
  localField?: InputMaybe<Scalars['String']>;
};

export type GqlIntegrationsCustomPropertyInput = {
  foreignProperty?: InputMaybe<Scalars['String']>;
  localProperty?: InputMaybe<Scalars['String']>;
};

export type GqlIntegrationsCustomTypeInput = {
  foreignCategory?: InputMaybe<Scalars['String']>;
  localCategory?: InputMaybe<Scalars['String']>;
  localSubcategory?: InputMaybe<Scalars['String']>;
};

export type GqlIntegrationsFieldMapping = {
  __typename?: 'IntegrationsFieldMapping';
  foreignField?: Maybe<Scalars['String']>;
  localField?: Maybe<Scalars['String']>;
};

export type GqlIntegrationsMeta = {
  __typename?: 'IntegrationsMeta';
  custom_types?: Maybe<Array<Maybe<Scalars['String']>>>;
  shopifyFields?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GqlIntegrationsPipelineMapping = {
  __typename?: 'IntegrationsPipelineMapping';
  mappings?: Maybe<GqlMappingTypes>;
  pipelineId?: Maybe<Scalars['String']>;
};

export type GqlIntegrationsPropertyMapping = {
  __typename?: 'IntegrationsPropertyMapping';
  foreignProperty?: Maybe<Scalars['String']>;
  localProperty?: Maybe<Scalars['String']>;
};

export type GqlIntegrationsUpdateCrmFieldsInput = {
  crmPropertyMapping?: InputMaybe<Array<InputMaybe<GqlIntegrationsCustomPropertyInput>>>;
  id: Scalars['String'];
};

export type GqlIntegrationsUpdateFieldsInput = {
  customFieldMapping?: InputMaybe<Array<InputMaybe<GqlIntegrationsCustomFieldInput>>>;
  id: Scalars['String'];
};

export type GqlIntegrationsUpdateHubspotPipelinesInput = {
  crmPipelineMapping?: InputMaybe<Scalars['JSON']>;
  id: Scalars['String'];
};

export type GqlIntegrationsUpdateInput = {
  adapter?: InputMaybe<Scalars['String']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  crmPipelineMapping?: InputMaybe<Scalars['JSON']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  flags?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  integrationType?: InputMaybe<Scalars['String']>;
  live?: InputMaybe<Scalars['Boolean']>;
};

export type GqlIntegrationsUpdateThresholdsInput = {
  id: Scalars['String'];
  kioskThresholds?: InputMaybe<Scalars['JSON']>;
  thresholds?: InputMaybe<Scalars['JSON']>;
};

export type GqlIntegrationsUpdateTypesInput = {
  customCategoryMapping?: InputMaybe<Array<InputMaybe<GqlIntegrationsCustomTypeInput>>>;
  id: Scalars['String'];
};

export enum InternalDataLoaders {
  archivedOrderLoader = 'archivedOrderLoader',
  availableReservationsLoader = 'availableReservationsLoader',
  brandLoader = 'brandLoader',
  bucketProductLoader = 'bucketProductLoader',
  chargebeeCustomerLoader = 'chargebeeCustomerLoader',
  chargebeeInvoiceLoader = 'chargebeeInvoiceLoader',
  chargebeePaymentSourceLoader = 'chargebeePaymentSourceLoader',
  chargebeePlanLoader = 'chargebeePlanLoader',
  chargebeeSubscriptionLoader = 'chargebeeSubscriptionLoader',
  collectionLoader = 'collectionLoader',
  curbsideArrivalByOrderLoader = 'curbsideArrivalByOrderLoader',
  dispensaryBillingLoader = 'dispensaryBillingLoader',
  dispensaryLoader = 'dispensaryLoader',
  integrationsByDispensaryLoader = 'integrationsByDispensaryLoader',
  libraryProductLoader = 'libraryProductLoader',
  orderLoader = 'orderLoader',
  productLoader = 'productLoader',
  strainByTerpeneLoader = 'strainByTerpeneLoader',
  strainLoader = 'strainLoader',
  terpeneByStrainLoader = 'terpeneByStrainLoader',
  userLoader = 'userLoader'
}

export enum InventoryLevelEnum {
  excess = 'excess',
  low = 'low'
}

export enum InventoryOpportunityEnum {
  high = 'High',
  low = 'Low',
  medium = 'Medium'
}

export enum InventoryStatusEnum {
  expiring = 'expiring',
  healthy = 'healthy',
  lowStock = 'lowStock',
  outOfStock = 'outOfStock',
  overStock = 'overStock'
}

export type GqlInvoice = {
  __typename?: 'Invoice';
  amountDue?: Maybe<Scalars['Int']>;
  amountPaid?: Maybe<Scalars['Int']>;
  billingCycle?: Maybe<Scalars['String']>;
  creditsApplied?: Maybe<Scalars['Int']>;
  dueDate?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  lineItems?: Maybe<Array<Maybe<GqlChargebeeLineItem>>>;
  status: Scalars['String'];
  total: Scalars['Float'];
};

export type GqlItemDiscounts = {
  __typename?: 'ItemDiscounts';
  total?: Maybe<Scalars['Int']>;
};

export type GqlItemTax = {
  __typename?: 'ItemTax';
  feeItemId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  showOnCheckout?: Maybe<Scalars['Boolean']>;
  showOnMenu?: Maybe<Scalars['Boolean']>;
  taxAmount?: Maybe<Scalars['Int']>;
  taxType?: Maybe<Scalars['String']>;
};

export type GqlItemTaxes = {
  __typename?: 'ItemTaxes';
  cannabis?: Maybe<Scalars['Int']>;
  sales?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type GqlItemsForAPrice = {
  __typename?: 'ItemsForAPrice';
  _id?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlItemsForAPriceInput = {
  _id?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type GqlKioskInput = {
  anonymousCheckout?: InputMaybe<Scalars['Boolean']>;
  directedOrders?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  fullNameOnly?: InputMaybe<Scalars['Boolean']>;
  hideEmailField?: InputMaybe<Scalars['Boolean']>;
  hidePhoneField?: InputMaybe<Scalars['Boolean']>;
  kioskInstructions?: InputMaybe<Scalars['String']>;
  notesField?: InputMaybe<Scalars['Boolean']>;
  paymentTypes?: InputMaybe<GqlDispensaryUpdatePaymentTypeConfig>;
  phoneRequired?: InputMaybe<Scalars['Boolean']>;
  showBirthdateField?: InputMaybe<Scalars['Boolean']>;
  timeout?: InputMaybe<GqlKioskTimeoutInput>;
  type?: InputMaybe<KioskTypes>;
};

export type GqlKioskOrderingSettings = {
  __typename?: 'KioskOrderingSettings';
  anonymousCheckout?: Maybe<Scalars['Boolean']>;
  directedOrders?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  fullNameOnly?: Maybe<Scalars['Boolean']>;
  hideEmailField?: Maybe<Scalars['Boolean']>;
  hidePhoneField?: Maybe<Scalars['Boolean']>;
  kioskInstructions?: Maybe<Scalars['String']>;
  notesField?: Maybe<Scalars['Boolean']>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  phoneRequired?: Maybe<Scalars['Boolean']>;
  showBirthdateField?: Maybe<Scalars['Boolean']>;
  timeout?: Maybe<GqlTimeoutConfig>;
  type?: Maybe<KioskTypes>;
};

export type GqlKioskTerminal = {
  __typename?: 'KioskTerminal';
  dispensaryId: Scalars['String'];
  id: Scalars['ID'];
  nickname?: Maybe<Scalars['String']>;
};

export type GqlKioskTimeoutInput = {
  duration?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export enum KioskTypes {
  basic = 'BASIC',
  pro = 'PRO'
}

export type GqlLegacyCalculationResults = {
  __typename?: 'LegacyCalculationResults';
  bottleDepositTaxCents?: Maybe<Scalars['Int']>;
  bottleDepositTaxExistence?: Maybe<GqlTaxExistence>;
  cannabisTax?: Maybe<Scalars['Float']>;
  cannabisTaxExistence?: Maybe<GqlTaxExistence>;
  cartSubtotal?: Maybe<Scalars['Float']>;
  credit?: Maybe<Scalars['Float']>;
  deliveryFee?: Maybe<Scalars['Float']>;
  details?: Maybe<Array<Maybe<GqlDetailItem>>>;
  lineitems?: Maybe<Array<Maybe<GqlLineItem>>>;
  menuTotal?: Maybe<Scalars['Float']>;
  mixAndMatch?: Maybe<Scalars['Float']>;
  otherFees?: Maybe<Scalars['Float']>;
  paymentFee?: Maybe<Scalars['Int']>;
  paymentIncentives?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  receipt?: Maybe<Scalars['JSON']>;
  reward?: Maybe<Scalars['Float']>;
  rounding?: Maybe<Scalars['Float']>;
  salesTaxExistence?: Maybe<GqlTaxExistence>;
  subtotal?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  tip?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type GqlLegacyCalculationsInput = {
  appliedRewards?: InputMaybe<Array<InputMaybe<GqlAppliedReward>>>;
  bypassCanadaDeliveryTax?: InputMaybe<Scalars['Boolean']>;
  cart?: InputMaybe<Scalars['JSON']>;
  couponValue?: InputMaybe<GqlCouponValueInput>;
  deliveryOption?: InputMaybe<Scalars['String']>;
  dispensary?: InputMaybe<GqlDispensaryCalcsInput>;
  firstTimePBBUser?: InputMaybe<Scalars['Boolean']>;
  manualDiscount?: InputMaybe<Scalars['Float']>;
  medicalOrder?: InputMaybe<Scalars['Boolean']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  priceService?: InputMaybe<Scalars['String']>;
  tipValue?: InputMaybe<GqlTipValueInput>;
  toMenu?: InputMaybe<Scalars['Boolean']>;
};

export type GqlLibraryProduct = {
  __typename?: 'LibraryProduct';
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['String']>;
  cannabinoids?: Maybe<Array<GqlProducts_CannabinoidV2>>;
  category?: Maybe<Scalars['String']>;
  cbdContent?: Maybe<GqlProductPotency>;
  changeRequests?: Maybe<Array<GqlProductChangeRequest>>;
  connectedCount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  createdBy?: Maybe<GqlUsers>;
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  effects?: Maybe<Scalars['JSON']>;
  gtin?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<GqlProducts_Images>>>;
  menuScore: Scalars['Float'];
  name: Scalars['String'];
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
  price: Scalars['Float'];
  prices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  productBatchId?: Maybe<Scalars['ID']>;
  productTemplate?: Maybe<Scalars['Boolean']>;
  sku?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  stockImage?: Maybe<Scalars['String']>;
  stockImageAliases?: Maybe<Scalars['String']>;
  stockImageCategory?: Maybe<Scalars['String']>;
  strainType?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
  terpenes?: Maybe<Array<GqlProducts_Terpene>>;
  thcContent?: Maybe<GqlProductPotency>;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
  updatedByBrand?: Maybe<Scalars['Boolean']>;
};

export type GqlLibraryProductCannabinoidsInputV2 = {
  active?: InputMaybe<Scalars['Boolean']>;
  cannabinoidId?: InputMaybe<Scalars['ID']>;
  unit?: InputMaybe<PotencyUnit>;
  value?: InputMaybe<Scalars['Float']>;
};

export type GqlLibraryProductChangeImpactCount = {
  __typename?: 'LibraryProductChangeImpactCount';
  count?: Maybe<Scalars['Int']>;
};

export type GqlLibraryProductChangeImpactResponse = {
  __typename?: 'LibraryProductChangeImpactResponse';
  totalCount?: Maybe<GqlLibraryProductChangeImpactCount>;
};

export type GqlLibraryProductLimitPerCustomerInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type GqlLibraryProductManualInventoryInput = {
  inventory?: InputMaybe<Scalars['Int']>;
  option?: InputMaybe<Scalars['String']>;
};

export type GqlLibraryProductPotencyInput = {
  range?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  unit: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export enum LibraryProductSortByEnum {
  brandName = 'brandName',
  category = 'category',
  connectedCount = 'connectedCount',
  createdAt = 'createdAt',
  createdBy = 'createdBy',
  description = 'description',
  menuScore = 'menuScore',
  name = 'name',
  stateLibrary = 'stateLibrary'
}

export enum LibraryProductStatusEnum {
  active = 'Active',
  archived = 'Archived',
  inactive = 'Inactive'
}

export type GqlLibraryProductTerpenesInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  terpeneId: Scalars['ID'];
  unit: PotencyUnit;
  value?: InputMaybe<Scalars['Float']>;
  values: Array<InputMaybe<Scalars['Float']>>;
};

export type GqlLibraryProducts = {
  __typename?: 'LibraryProducts';
  libraryProducts?: Maybe<Array<Maybe<GqlLibraryProduct>>>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlLineItem = {
  __typename?: 'LineItem';
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export enum LinkColor {
  aqua_1 = 'AQUA_1',
  aqua_2 = 'AQUA_2',
  aqua_3 = 'AQUA_3',
  blue_1 = 'BLUE_1',
  blue_2 = 'BLUE_2',
  blue_3 = 'BLUE_3',
  blue_4 = 'BLUE_4',
  blue_5 = 'BLUE_5',
  green_1 = 'GREEN_1',
  green_2 = 'GREEN_2',
  green_3 = 'GREEN_3',
  green_4 = 'GREEN_4',
  harvestBlue_1 = 'HARVEST_BLUE_1',
  orange_1 = 'ORANGE_1',
  orange_2 = 'ORANGE_2',
  orange_3 = 'ORANGE_3',
  pink_1 = 'PINK_1',
  pink_2 = 'PINK_2',
  purple_1 = 'PURPLE_1',
  purple_2 = 'PURPLE_2',
  purple_3 = 'PURPLE_3',
  purple_4 = 'PURPLE_4',
  red_1 = 'RED_1',
  red_2 = 'RED_2',
  red_3 = 'RED_3'
}

export type GqlListAccountBalancesResponse = {
  __typename?: 'ListAccountBalancesResponse';
  accountBalances: Array<GqlAccountBalance>;
};

export type GqlListAchBatchesResponse = {
  __typename?: 'ListAchBatchesResponse';
  achBatches?: Maybe<Array<GqlAchBatch>>;
};

export type GqlListAchEntriesResponse = {
  __typename?: 'ListAchEntriesResponse';
  achEntries?: Maybe<Array<GqlAchEntry>>;
};

export type GqlListAchEntriesResponseV3 = {
  __typename?: 'ListAchEntriesResponseV3';
  achEntries: Array<GqlAchEntryV2>;
};

export type GqlListAchReturnsResponse = {
  __typename?: 'ListAchReturnsResponse';
  achReturns?: Maybe<Array<GqlAchReturn>>;
};

export type GqlListAchReturnsResponseV3 = {
  __typename?: 'ListAchReturnsResponseV3';
  achReturns: Array<GqlAchReturnV2>;
};

export type GqlListAchReturnsResponseV4 = {
  __typename?: 'ListAchReturnsResponseV4';
  achReturns: Array<GqlAchReturnV4>;
};

export type GqlListAchReturnsResponseV5 = {
  __typename?: 'ListAchReturnsResponseV5';
  achReturns: Array<GqlAchReturnV5>;
};

export enum ListBrandsSortByEnum {
  createdAt = 'createdAt',
  name = 'name'
}

export type GqlListEntitiesResponse = {
  __typename?: 'ListEntitiesResponse';
  entities: Array<GqlEntity>;
};

export enum ListLibraryProductsSortByEnum {
  createdAt = 'createdAt',
  name = 'name'
}

export enum LoaderType {
  hasMany = 'HAS_MANY',
  hasOne = 'HAS_ONE',
  join = 'JOIN'
}

export type GqlLocationStatsProductOption = {
  __typename?: 'LocationStatsProductOption';
  price: Scalars['Float'];
  weight: Scalars['String'];
};

export enum LogicOperator {
  and = 'AND',
  or = 'OR'
}

export type GqlLoginAdmin = {
  __typename?: 'LoginAdmin';
  accessToken?: Maybe<Scalars['String']>;
  user?: Maybe<GqlIdentityAdmin>;
};

export type GqlLoginConsumer = {
  __typename?: 'LoginConsumer';
  accessToken?: Maybe<Scalars['String']>;
  dispensaryId?: Maybe<Scalars['String']>;
  transferToken?: Maybe<Scalars['String']>;
  user?: Maybe<GqlIdentityConsumer>;
};

export type GqlLoyaltyPassDispensaries = {
  __typename?: 'LoyaltyPassDispensaries';
  locGlobalIds: Array<Scalars['String']>;
  locIds: Array<Scalars['Int']>;
  lspGlobalIds: Array<Scalars['String']>;
  lspIds: Array<Scalars['Int']>;
};

export type GqlLoyaltyPassToken = {
  __typename?: 'LoyaltyPassToken';
  etag?: Maybe<Scalars['String']>;
  lastModifiedAt?: Maybe<Scalars['String']>;
  token: Scalars['String'];
};

export type GqlLoyaltyPassUrl = {
  __typename?: 'LoyaltyPassUrl';
  token: Scalars['String'];
  url: Scalars['String'];
};

export type GqlLspAccountFilter = {
  dposLspId: Scalars['ID'];
  dposServerRegion: Scalars['String'];
};

export type GqlLspBrand = {
  __typename?: 'LspBrand';
  brand: GqlBrand;
  insights: GqlLspBrandInsightsLight;
  settings?: Maybe<GqlLspBrandSettings>;
};

export type GqlLspBrandInsightsLight = {
  __typename?: 'LspBrandInsightsLight';
  totalSales: Scalars['Int'];
};

export type GqlLspBrandSearchSort = {
  sortBy: LspBrandSearchSortByEnum;
  sortDirection: StringSortDirections;
};

export enum LspBrandSearchSortByEnum {
  name = 'name'
}

export type GqlLspBrandSettings = {
  __typename?: 'LspBrandSettings';
  createdAt: Scalars['ISODateTime'];
  dataSharingEnabled: Scalars['Boolean'];
  updatedAt: Scalars['ISODateTime'];
};

export type GqlLspBrandSettingsBulkInput = {
  brandId: Scalars['String'];
  settings: GqlLspBrandSettingsInput;
};

export type GqlLspBrandSettingsInput = {
  dataSharingEnabled: Scalars['Boolean'];
};

export type GqlLspBrandsList = {
  __typename?: 'LspBrandsList';
  queryInfo: GqlQueryInfoType;
  results: Array<GqlLspBrand>;
};

export type GqlMxLinkStart = {
  __typename?: 'MXLinkStart';
  widgetUrl: Scalars['String'];
};

export enum ManualDefaultApplyTo {
  allitems = 'ALLITEMS',
  distributed = 'DISTRIBUTED',
  justone = 'JUSTONE',
  wholeline = 'WHOLELINE'
}

export type GqlMappingTypes = {
  __typename?: 'MappingTypes';
  abandoned?: Maybe<Scalars['String']>;
  closed?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['String']>;
  inTransit?: Maybe<Scalars['String']>;
  open?: Maybe<Scalars['String']>;
};

export type GqlMarkAchEntryAsReturnedResponse = {
  __typename?: 'MarkAchEntryAsReturnedResponse';
  achReturn: GqlAchReturn;
};

export type GqlMarkAchEntryAsReturnedResponseV3 = {
  __typename?: 'MarkAchEntryAsReturnedResponseV3';
  achReturn: GqlAchReturnV2;
};

export type GqlMarkAchEntryAsReturnedResponseV4 = {
  __typename?: 'MarkAchEntryAsReturnedResponseV4';
  achReturn: GqlAchReturnV4;
};

export type GqlMarkAchEntryAsReturnedResponseV5 = {
  __typename?: 'MarkAchEntryAsReturnedResponseV5';
  achReturn: GqlAchReturnV5;
};

export type GqlMarketingCampaignsResponse = {
  __typename?: 'MarketingCampaignsResponse';
  campaigns?: Maybe<Array<Maybe<GqlCampaignSummary>>>;
  meta?: Maybe<GqlAnalyticsMeta>;
};

export type GqlMarketingCouponsResponse = {
  __typename?: 'MarketingCouponsResponse';
  coupons?: Maybe<Array<Maybe<GqlCouponSummary>>>;
  meta?: Maybe<GqlAnalyticsMeta>;
};

export type GqlMarketingDataPointsResponse = {
  __typename?: 'MarketingDataPointsResponse';
  marketingRevenue?: Maybe<Array<Maybe<GqlMarketingRevenue>>>;
  totalCampaignsCents?: Maybe<Scalars['Float']>;
  totalCouponsCents?: Maybe<Scalars['Float']>;
  totalRevenueCents?: Maybe<Scalars['Float']>;
  totalSpecialsCents?: Maybe<Scalars['Float']>;
};

export type GqlMarketingRevenue = {
  __typename?: 'MarketingRevenue';
  campaignsCents?: Maybe<Scalars['Float']>;
  couponsCents?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['String']>;
  revenueCents?: Maybe<Scalars['Float']>;
  specialsCents?: Maybe<Scalars['Float']>;
};

export type GqlMarketingSpecialsResponse = {
  __typename?: 'MarketingSpecialsResponse';
  meta?: Maybe<GqlAnalyticsMeta>;
  specials?: Maybe<Array<Maybe<GqlSpecialSummary>>>;
};

export type GqlMarketplaceProduct = {
  __typename?: 'MarketplaceProduct';
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['ID']>;
  cannabinoids: Array<GqlNamedProductPotency>;
  category: Scalars['String'];
  cbdContent?: Maybe<GqlProductPotency>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  description?: Maybe<Scalars['String']>;
  effects?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  strainType?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
  terpenes: Array<GqlNamedProductPotency>;
  thcContent?: Maybe<GqlProductPotency>;
};

export type GqlMarketplaceProductLocation = {
  __typename?: 'MarketplaceProductLocation';
  consumerType?: Maybe<ProductConsumerType>;
  id?: Maybe<Scalars['String']>;
  point: GqlMarketplaceProductLocationGeometry;
};

export type GqlMarketplaceProductLocationGeometry = {
  __typename?: 'MarketplaceProductLocationGeometry';
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};

export type GqlMarketplaceProductLocationStats = {
  __typename?: 'MarketplaceProductLocationStats';
  marketplaceProduct: GqlMarketplaceProduct;
  nearbyStoreCount: Scalars['Int'];
  options?: Maybe<Array<GqlLocationStatsProductOption>>;
};

export type GqlMarketplaceProductOption = {
  __typename?: 'MarketplaceProductOption';
  price: Scalars['Float'];
  unit: Scalars['String'];
  weight: Scalars['String'];
};

export type GqlMarketplaceProductSearchResult = {
  __typename?: 'MarketplaceProductSearchResult';
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  cbdContent?: Maybe<GqlProductPotency>;
  createdAt?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<GqlProducts_Images>>>;
  locations: Array<Maybe<GqlMarketplaceProductLocation>>;
  minPrice: Scalars['Float'];
  name: Scalars['String'];
  options: Array<Maybe<GqlMarketplaceProductOption>>;
  rawOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  stockImage?: Maybe<Scalars['String']>;
  strainType?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
  thcContent?: Maybe<GqlProductPotency>;
};

export type GqlMaxReservationSlot = {
  __typename?: 'MaxReservationSlot';
  active?: Maybe<Scalars['Boolean']>;
  currentCount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['ISODate']>;
  deliveryAreaId?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  isNextDaySlot?: Maybe<Scalars['Boolean']>;
  maxOrders?: Maybe<Scalars['Int']>;
  slotId?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

export type GqlMaxReservationSlotInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  currentCount?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['ISODate']>;
  deliveryAreaId?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  isNextDaySlot?: InputMaybe<Scalars['Boolean']>;
  maxOrders?: InputMaybe<Scalars['Int']>;
  slotId?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type GqlMaxReservationSlotsByDay = {
  __typename?: 'MaxReservationSlotsByDay';
  Friday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Monday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Saturday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Sunday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Thursday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Tuesday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Wednesday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
};

export type GqlMaxReservationSlotsByDayInput = {
  Friday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Monday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Saturday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Sunday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Thursday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Tuesday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Wednesday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
};

export type GqlMaxReservationSlotsByOrderType = {
  __typename?: 'MaxReservationSlotsByOrderType';
  curbsidePickup?: Maybe<GqlMaxReservationSlotsGroup>;
  delivery?: Maybe<GqlMaxReservationSlotsGroup>;
  driveThruPickup?: Maybe<GqlMaxReservationSlotsGroup>;
  inStorePickup?: Maybe<GqlMaxReservationSlotsGroup>;
};

export type GqlMaxReservationSlotsGroup = {
  __typename?: 'MaxReservationSlotsGroup';
  maxReservationSlotsByDate?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  maxReservationSlotsByDay?: Maybe<GqlMaxReservationSlotsByDay>;
};

export type GqlMenuCleanup = {
  __typename?: 'MenuCleanup';
  products: Array<Maybe<GqlProducts>>;
  queryInfo: GqlQueryInfoType;
};

export type GqlMenuDesignInput = {
  dispensaryId?: InputMaybe<Scalars['String']>;
  menuDisplayDescription?: InputMaybe<Scalars['String']>;
  menuDisplayImage?: InputMaybe<Scalars['String']>;
  menuDisplayName?: InputMaybe<Scalars['String']>;
};

export type GqlMenuFilterTerpene = {
  __typename?: 'MenuFilterTerpene';
  compound_id: Scalars['String'];
  name: Scalars['String'];
  potency_id: Scalars['String'];
  unit: Scalars['String'];
  unitSymbol: Scalars['String'];
  values: Array<Scalars['Float']>;
};

export type GqlMenuFilters = {
  __typename?: 'MenuFilters';
  brands: Array<Maybe<GqlBrand>>;
  categoriesSubcategories: Array<GqlCategorySubcategories>;
  effects: Array<Maybe<Scalars['String']>>;
  hasProductsOnSpecial?: Maybe<Scalars['Boolean']>;
  strainTypes: Array<Maybe<Scalars['String']>>;
  subcategories: Array<Maybe<Scalars['String']>>;
  terpenes: Array<Maybe<GqlMenuFilterTerpene>>;
  weights: Array<Maybe<Scalars['String']>>;
};

export type GqlMenuScore = {
  __typename?: 'MenuScore';
  category?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type GqlMenuSection = {
  __typename?: 'MenuSection';
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  collectionId?: Maybe<Scalars['ID']>;
  dispensary: GqlDispensaries;
  dispensaryId: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  linkLabel: Scalars['String'];
  position: Scalars['Int'];
  products?: Maybe<Array<Scalars['ID']>>;
  sectionName?: Maybe<Scalars['String']>;
  sectionType: MenuSectionType;
  sortBy?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
};

export enum MenuSectionType {
  brand = 'BRAND',
  category = 'CATEGORY',
  collection = 'COLLECTION',
  custom = 'CUSTOM',
  offers = 'OFFERS',
  recentlyViewed = 'RECENTLY_VIEWED',
  specials = 'SPECIALS',
  staffPicks = 'STAFF_PICKS',
  subcategory = 'SUBCATEGORY',
  topSellers = 'TOP_SELLERS'
}

export type GqlMenuSortSetting = {
  __typename?: 'MenuSortSetting';
  brands?: Maybe<Array<Scalars['String']>>;
  category: Scalars['String'];
  menuOrder: Scalars['String'];
};

export type GqlMenuSortSettingInput = {
  brands?: InputMaybe<Array<Scalars['String']>>;
  category: Scalars['String'];
  menuOrder: Scalars['String'];
};

export enum MenuTypes {
  both = 'both',
  medical = 'medical',
  recreational = 'recreational'
}

export enum MenuViewStyles {
  cards = 'cards',
  list = 'list'
}

export type GqlMeta = {
  __typename?: 'Meta';
  totalCount?: Maybe<Scalars['Int']>;
};

export enum Modules {
  fraud = 'fraud',
  incentives = 'incentives',
  paymentProcessing = 'paymentProcessing',
  reporting = 'reporting'
}

export type GqlMonerisCard = {
  __typename?: 'MonerisCard';
  brand?: Maybe<Scalars['String']>;
  lastDigits?: Maybe<Scalars['String']>;
};

export type GqlMonerisDetails = {
  __typename?: 'MonerisDetails';
  card: GqlMonerisCard;
  id: Scalars['String'];
  status: Scalars['String'];
  transactionNumber: Scalars['String'];
};

export type GqlMonerisHtProfileCredentials = GqlCheckoutCredentialsBase & {
  __typename?: 'MonerisHTProfileCredentials';
  adapter: Scalars['String'];
  profileId: Scalars['String'];
};

export type GqlMonerisTokenizationProfile = {
  __typename?: 'MonerisTokenizationProfile';
  profileId: Scalars['String'];
};

export type GqlMongoProduct = {
  __typename?: 'MongoProduct';
  id: Scalars['ID'];
};

export type GqlMutation = {
  __typename?: 'Mutation';
  acceptBrandPortalTos?: Maybe<GqlGenericResponse>;
  acceptTermsOfService?: Maybe<GqlGenericResponse>;
  activateBankAccount?: Maybe<GqlActivateBankAccountResponse>;
  /** @deprecated Use activatePaymentMethodV2 */
  activatePaymentMethod: GqlGenericResponse;
  activatePaymentMethodV2: GqlActivatePaymentMethodResponse;
  activatePrinter: GqlGenericResponse;
  addBankPaymentMethodV2?: Maybe<GqlGenericResponse>;
  addCustomerToOrder?: Maybe<GqlOrderUpdated>;
  addDispensaryCustomer?: Maybe<GqlGenericResponse>;
  addPaymentMethodV2?: Maybe<GqlGenericResponse>;
  addSubscriptionToChain?: Maybe<GqlGenericResponse>;
  approveInstoreCart?: Maybe<GqlApproveInstoreCartResponse>;
  archiveOrder?: Maybe<GqlGenericResponse>;
  archiveProduct?: Maybe<GqlProducts>;
  brandPortalSecureUpload?: Maybe<GqlIdImage>;
  bulkCreateLspBrandSettings: Array<Maybe<GqlLspBrandSettings>>;
  bulkEndSpecialsV2?: Maybe<GqlGenericResponse>;
  bulkLibraryProductDelete?: Maybe<GqlGenericResponse>;
  bulkLibraryProductRestore?: Maybe<GqlGenericResponse>;
  bulkLibraryProductUpdate?: Maybe<GqlBulkLibraryProductUpdateResponse>;
  bulkLibraryProductUpload?: Maybe<GqlBulkLibraryProductUploadResponse>;
  bulkUpdateMenuSections?: Maybe<Array<Maybe<GqlMenuSection>>>;
  changeRequestApproveProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestCreateProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestDeleteProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestLockProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestRejectProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestUnlockProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestUpdateProduct?: Maybe<GqlProductChangeRequest>;
  checkInBucketV2?: Maybe<GqlBucket>;
  /** @deprecated Use checkOutBucketV3 mutation */
  checkOutBucketV2: GqlBucket;
  checkOutBucketV3: GqlBucketV2;
  clearAdsInspectorEvents: GqlGenericResponse;
  clearAllCurbsideArrivals: GqlGenericResponse;
  clearAllFeatureFlagOverrides?: Maybe<GqlGenericResponse>;
  clearCurbsideArrival: GqlGenericResponse;
  closeBucket: GqlBucket;
  completeAggregatorLink: GqlCompleteAggregatorLinkResponse;
  computeWithPriceCartV2?: Maybe<GqlCalculationResults>;
  connectDeviceV2?: Maybe<GqlDeviceConnection>;
  connectProduct?: Maybe<GqlGenericResponse>;
  connectProductPreview?: Maybe<GqlConnectProductPreviewResponse>;
  consumeDeviceAccessCode?: Maybe<GqlDeviceAccessCode>;
  consumerSignup?: Maybe<GqlLoginConsumer>;
  copyLibraryProduct?: Maybe<GqlCopyLibraryProductResponse>;
  /** @deprecated Use createAlpineUserV2 */
  createAlpineUser?: Maybe<GqlRewardUserResponse>;
  createAlpineUserV2?: Maybe<GqlRewardUserResponse>;
  createBackInStockSubscription?: Maybe<GqlGenericResponse>;
  createBankAccount?: Maybe<GqlCreateBankAccountResponse>;
  createBillingGroup?: Maybe<GqlGenericResponse>;
  createBrandEnterpriseSettings: Array<GqlBrandEnterpriseSetting>;
  createBrandUser?: Maybe<GqlBrandUser>;
  createBrandV2?: Maybe<GqlBrand>;
  createBucketForLibraryItem: GqlBucket;
  /** @deprecated Use createBucketV3 mutation */
  createBucketV2: GqlBucket;
  createBucketV3: GqlBucket;
  createCheckout?: Maybe<GqlCheckout>;
  createCollection: GqlCollection;
  createCouponV2?: Maybe<GqlCoupons>;
  createDeviceAccessCode?: Maybe<GqlDeviceAccessCode>;
  createDutchiePosLoyaltyMember?: Maybe<GqlRewardUserResponse>;
  createEnterpriseDutchiePosLoyaltyMember?: Maybe<GqlGenericResponse>;
  createEnterpriseSpecialV2?: Maybe<GqlGenericResponse>;
  createEnterpriseSpecialsSettings?: Maybe<GqlGenericResponse>;
  createFraudAccount?: Maybe<GqlCreateFraudAccountResponse>;
  createInstoreCartUrl?: Maybe<GqlCreateInstoreCartUrlResponse>;
  createIntegration?: Maybe<GqlIntegrations>;
  createLibraryProduct?: Maybe<GqlProducts>;
  createLibraryProductV2?: Maybe<GqlLibraryProduct>;
  createLibraryProductV3?: Maybe<GqlLibraryProduct>;
  createLoyaltyPassToken?: Maybe<GqlLoyaltyPassToken>;
  createLoyaltyPassUrl?: Maybe<GqlLoyaltyPassUrl>;
  createLspBrandSettings: GqlLspBrandSettings;
  createMenuSection?: Maybe<GqlMenuSection>;
  createMxEnrollment?: Maybe<GqlCreateMxEnrollmentResponse>;
  /** @deprecated Use createOrUpdateAchReturnV5 */
  createOrUpdateAchReturn?: Maybe<GqlCreateOrUpdateAchReturnResponse>;
  createOrUpdateAchReturnV5?: Maybe<GqlCreateOrUpdateAchReturnResponseV5>;
  /** @deprecated Use createOrUpdateAchReturnV5 */
  createOrUpdateAchReturnv4?: Maybe<GqlCreateOrUpdateAchReturnResponseV4>;
  createOrderV2?: Maybe<GqlCreateOrderResponse>;
  createOrderingSuspensionV2?: Maybe<GqlOrderingSuspension>;
  createPOSMedUser?: Maybe<GqlGenericResponse>;
  createPayment?: Maybe<GqlCreatePaymentResponse>;
  createPlusApiKeyV2?: Maybe<GqlPlusApiKey>;
  createPlusEnterpriseApiKey?: Maybe<GqlPlusApiKey>;
  createPointsBoost?: Maybe<GqlGenericResponse>;
  createPrintJob: GqlCreatePrintJobResponse;
  createProduct?: Maybe<GqlProducts>;
  createPublicContextSession?: Maybe<GqlPublicContextSession>;
  createReservationSlots?: Maybe<GqlGenericResponse>;
  createRetailerEnrollment?: Maybe<GqlCreateRetailerEnrollmentResponse>;
  createSpecialV3?: Maybe<GqlSpecials>;
  createSpringbigUser?: Maybe<GqlRewardUserResponse>;
  createStrainV2?: Maybe<GqlStrain>;
  createTerpeneV2?: Maybe<GqlTerpene>;
  createUser?: Maybe<GqlUsers>;
  crossingMindsLogin?: Maybe<GqlCrossingMindsAuthResponse>;
  deleteAccount: GqlDeleteAccountResponse;
  deleteBackInStockSubscription?: Maybe<GqlGenericResponse>;
  deleteBrand?: Maybe<GqlBrand>;
  deleteCollection?: Maybe<GqlGenericResponse>;
  deleteCoupon?: Maybe<GqlGenericResponse>;
  deleteCouponV2?: Maybe<GqlGenericResponse>;
  deleteDeviceV2?: Maybe<GqlDevices>;
  deleteEnterpriseSpecial?: Maybe<GqlGenericResponse>;
  deleteLibraryProduct?: Maybe<GqlLibraryProduct>;
  deletePrinter: GqlGenericResponse;
  deleteSpecialHours?: Maybe<GqlGenericResponse>;
  deleteSpecialV2?: Maybe<GqlSpecials>;
  deleteStrain?: Maybe<GqlStrain>;
  deleteSubscription?: Maybe<GqlGenericResponse>;
  deleteTerpene?: Maybe<GqlTerpene>;
  deleteUser?: Maybe<GqlUsers>;
  destroyMenuSection?: Maybe<GqlGenericResponse>;
  deviceHeartbeat?: Maybe<GqlGenericResponse>;
  disconnectBankAccount?: Maybe<GqlDisconnectBankAccountResponse>;
  /** Disconnect a dispensary product from its library product & mark the bucket product as disconnected */
  disconnectBucketProduct?: Maybe<GqlGenericResponse>;
  /** Disconnect a product from its library product */
  disconnectProduct?: Maybe<GqlGenericResponse>;
  dispensaryDemoRequest?: Maybe<GqlGenericResponse>;
  dispensaryOnboarding?: Maybe<GqlGenericResponse>;
  dispensaryRemoveFromChain?: Maybe<GqlGenericResponse>;
  dispensaryUpdate?: Maybe<GqlGenericResponse>;
  dispensaryUpdateHoursSettings?: Maybe<GqlGenericResponse>;
  dispensaryUpdateOptionsSettings?: Maybe<GqlGenericResponse>;
  dispensaryUpdateStatus?: Maybe<GqlGenericResponse>;
  dispensaryUpdateTaxConfiguration?: Maybe<GqlGenericResponse>;
  dispensaryUploadOnboardingAsset?: Maybe<GqlDispensaryAssetUploadResponse>;
  editCustomerV2?: Maybe<GqlGenericResponse>;
  emailIntegrationCredentials?: Maybe<GqlGenericResponse>;
  endEnterpriseSpecial?: Maybe<GqlGenericResponse>;
  endOrderingSuspensionV2?: Maybe<GqlOrderingSuspension>;
  endSpecialV2: GqlSpecials;
  expirePlusApiKey?: Maybe<GqlPlusApiKey>;
  expirePlusEnterpriseApiKey?: Maybe<GqlPlusApiKey>;
  exportCouponsSummaries?: Maybe<GqlGenericResponse>;
  exportCustomerReport?: Maybe<GqlGenericExportResponse>;
  exportDispensaryCustomers?: Maybe<GqlGenericResponse>;
  exportFilteredBrandsSummaries?: Maybe<GqlGenericResponse>;
  exportFilteredCampaignsSummaries?: Maybe<GqlGenericResponse>;
  exportFilteredCartsSummaries?: Maybe<GqlGenericResponse>;
  exportFilteredCatalog: GqlExportFilteredCatalogResponse;
  exportFilteredProductSummaries?: Maybe<GqlGenericResponse>;
  exportOrderReport?: Maybe<GqlGenericExportResponse>;
  exportOrders?: Maybe<GqlGenericResponse>;
  exportSpecialsSummaries?: Maybe<GqlGenericResponse>;
  forceDiscountSync?: Maybe<GqlGenericResponse>;
  generateDispensaryUserStreamToken?: Maybe<GqlDispensaryStreamToken>;
  generateHypurRedirectV3?: Maybe<GqlHypurRedirect>;
  generateHypurTokenV2?: Maybe<GqlHypurToken>;
  importCustomerCSV?: Maybe<GqlGenericResponse>;
  importDeliveryZipCodes?: Maybe<GqlGenericResponse>;
  importMenuCSV?: Maybe<GqlGenericResponse>;
  incrementClicks?: Maybe<GqlGenericResponse>;
  /** @deprecated Use integrationsDeleteInArma */
  integrationsDelete?: Maybe<GqlGenericResponse>;
  integrationsDeleteInArma?: Maybe<GqlGenericResponse>;
  integrationsForceSyncInArma?: Maybe<GqlGenericResponse>;
  integrationsSuggestion?: Maybe<GqlGenericResponse>;
  /** @deprecated Use updateIntegration */
  integrationsUpdate?: Maybe<GqlGenericResponse>;
  integrationsUpdateCrmFields?: Maybe<GqlGenericResponse>;
  integrationsUpdateFields?: Maybe<GqlGenericResponse>;
  integrationsUpdateHubspotPipelines?: Maybe<GqlGenericResponse>;
  integrationsUpdateThresholds?: Maybe<GqlGenericResponse>;
  integrationsUpdateTypes?: Maybe<GqlGenericResponse>;
  /** @deprecated Use integrationsWipeMenuInArma */
  integrationsWipeMenu?: Maybe<GqlGenericResponse>;
  integrationsWipeMenuInArma?: Maybe<GqlGenericResponse>;
  libraryProductChangeImpact?: Maybe<GqlProductImpactResponse>;
  libraryProductChangeImpactV3?: Maybe<GqlLibraryProductChangeImpactResponse>;
  logAnalyticsPayload?: Maybe<GqlGenericResponse>;
  loginAdmin?: Maybe<GqlLoginAdmin>;
  loginAdminViaToken?: Maybe<GqlLoginAdmin>;
  loginConsumer?: Maybe<GqlLoginConsumer>;
  logout?: Maybe<GqlGenericResponse>;
  /** @deprecated Use markAchEntryAsReturnedV5 */
  markAchEntryAsReturned?: Maybe<GqlMarkAchEntryAsReturnedResponse>;
  /** @deprecated Use markAchEntryAsReturnedV5 */
  markAchEntryAsReturnedV3?: Maybe<GqlMarkAchEntryAsReturnedResponseV3>;
  /** @deprecated Use markAchEntryAsReturnedV5 */
  markAchEntryAsReturnedV4?: Maybe<GqlMarkAchEntryAsReturnedResponseV4>;
  markAchEntryAsReturnedV5?: Maybe<GqlMarkAchEntryAsReturnedResponseV5>;
  markCurbsideArrivalArrivedV2: GqlCurbsideArrival;
  markOrderAutoPrinted?: Maybe<GqlGenericResponse>;
  markOrderPOSFailed?: Maybe<GqlOrderUpdated>;
  markOrderPrinted?: Maybe<GqlGenericResponse>;
  markOrdersBatchPrinted?: Maybe<GqlGenericResponse>;
  mergeBrand?: Maybe<GqlBrand>;
  mergeBrands?: Maybe<GqlGenericResponse>;
  /** @deprecated Use parseAchReturnFileUploadV2 */
  parseAchReturnFileUpload?: Maybe<GqlParseAchReturnFileUploadResponse>;
  parseAchReturnFileUploadV2?: Maybe<GqlParseAchReturnFileUploadResponse>;
  pauseSubscription?: Maybe<GqlGenericResponse>;
  persistCheckout?: Maybe<GqlGenericResponse>;
  persistCheckoutV2?: Maybe<GqlPersistCheckoutResponse>;
  printOrderOnTerminal?: Maybe<GqlOrderPrinted>;
  recordUserAcceptance?: Maybe<GqlRecordUserAcceptanceResponse>;
  rejectReasons: Array<RejectionReasons>;
  removeItem?: Maybe<GqlCheckout>;
  removeSubscriptionFromChain?: Maybe<GqlGenericResponse>;
  reopenOrder?: Maybe<GqlGenericResponse>;
  resetPasswordV2?: Maybe<GqlGenericResponse>;
  /** @deprecated Use createOrUpdateAchReturnV4 */
  respondToAchReturn?: Maybe<GqlRespondToAchReturnResponse>;
  resumeSubscription?: Maybe<GqlGenericResponse>;
  reversePayment?: Maybe<GqlReversePaymentResponse>;
  reverseSettlement?: Maybe<GqlReverseSettlementResponse>;
  revertBrandMerge?: Maybe<GqlBrandMergeHistory>;
  runChainBillingMigration?: Maybe<GqlChainBillingReturn>;
  sendBrandUserPasswordResetEmail?: Maybe<GqlGenericResponse>;
  sendPasswordResetEmailV2?: Maybe<GqlGenericResponse>;
  /** @deprecated Account verification feature has been sunset. */
  sendVerificationToken?: Maybe<GqlGenericResponse>;
  serverSideCalculations?: Maybe<GqlLegacyCalculationResults>;
  setFeatureFlagOverride?: Maybe<GqlGenericResponse>;
  setPasswordV2?: Maybe<GqlGenericResponse>;
  setViewedTermsOfService?: Maybe<GqlGenericResponse>;
  setupBillingV2?: Maybe<GqlGenericResponse>;
  setupRetailerBankPaymentMethod?: Maybe<GqlGenericResponse>;
  setupRetailerBilling?: Maybe<GqlGenericResponse>;
  setupRetailerCreditPaymentMethod?: Maybe<GqlGenericResponse>;
  /** @deprecated Moving to V2 for skip reasons change */
  skipBucketProduct: GqlGenericResponse;
  skipBucketProductV2: GqlGenericResponse;
  sortMenuSections?: Maybe<GqlGenericResponse>;
  speculativeProductUpdate?: Maybe<GqlProducts>;
  startPreAuthCheck?: Maybe<GqlStartPreAuthCheckResponse>;
  unarchiveOrder?: Maybe<GqlGenericResponse>;
  unenrollPayByBankUser: GqlUnenrollEnrollmentResponse;
  unsubscribeDispensaryCustomers?: Maybe<GqlGenericResponse>;
  updateAutoPrintDevicesV2?: Maybe<GqlGenericResponse>;
  updateBillingGroup?: Maybe<GqlGenericResponse>;
  updateBillingNotifications?: Maybe<GqlGenericResponse>;
  updateBrandCollision?: Maybe<GqlBrandCollision>;
  updateBrandEnterpriseSetting: GqlBrandEnterpriseSetting;
  updateBrandImportHistoryName: GqlBrandImportHistoryDetailResponse;
  updateBrandUser?: Maybe<GqlBrandUser>;
  updateBrandUserAccount?: Maybe<GqlBrandUserAccount>;
  updateBrandV2?: Maybe<GqlBrand>;
  updateChainDispensariesImage?: Maybe<GqlGenericResponse>;
  updateChangeRequestCreateProduct?: Maybe<GqlProductChangeRequest>;
  updateChangeRequestUpdateProduct?: Maybe<GqlProductChangeRequest>;
  updateChargebeeSubscription?: Maybe<GqlGenericResponse>;
  updateCheckout?: Maybe<GqlCheckout>;
  updateCname?: Maybe<GqlGenericResponse>;
  updateCollection: GqlCollection;
  updateCollectionPositions: Array<GqlCollection>;
  updateConsumerUser?: Maybe<GqlGenericResponse>;
  updateCoupon?: Maybe<GqlCoupons>;
  updateCurbsideArrivalV2?: Maybe<GqlCurbsideArrival>;
  updateCustomerSubscription?: Maybe<GqlGenericResponse>;
  updateDevice?: Maybe<GqlDevices>;
  updateDispensaryAdSettings?: Maybe<GqlGenericResponse>;
  updateDispensaryCustomer?: Maybe<GqlGenericResponse>;
  updateDispensaryPersonalizationSettings?: Maybe<GqlGenericResponse>;
  updateDutchiePosLoyaltyMember?: Maybe<GqlGenericResponse>;
  updateEmail?: Maybe<GqlGenericResponse>;
  updateEmailV2?: Maybe<GqlGenericResponse>;
  updateEnterpriseAdSettings?: Maybe<GqlUpdateEnterpriseAdSettingsResponse>;
  updateEnterpriseMobileAppSettings?: Maybe<GqlEnterpriseMobileAppSettings>;
  updateEnterprisePersonalizationSettings?: Maybe<GqlUpdateEnterprisePersonalizationSettingsResponse>;
  updateEnterpriseSpecialV2?: Maybe<GqlGenericResponse>;
  updateEnterpriseSpecialsSettings?: Maybe<GqlGenericResponse>;
  updateEnterpriseWebCustomizationSettingsV2?: Maybe<GqlGenericResponse>;
  updateHoursSettings?: Maybe<GqlGenericResponse>;
  updateImageBanners?: Maybe<GqlGenericResponse>;
  updateIntegration?: Maybe<GqlIntegrations>;
  updateKioskOrderPayment?: Maybe<GqlGenericResponse>;
  updateLibraryProduct?: Maybe<GqlUpdateLibraryProductResponse>;
  updateMenuSection?: Maybe<GqlMenuSection>;
  updateOrderStatus?: Maybe<GqlOrders>;
  updateOrderV2?: Maybe<GqlOrders>;
  updateOrderingSettings?: Maybe<GqlGenericResponse>;
  updatePasswordV2?: Maybe<GqlPasswordUpdate>;
  updatePlusOAuthProvider: GqlPlusOAuthProvider;
  updatePrinter: GqlGenericResponse;
  updateProduct?: Maybe<GqlProducts>;
  updateProductSort?: Maybe<GqlGenericResponse>;
  updateProductStatus?: Maybe<GqlProducts>;
  updateProfileV2?: Maybe<GqlGenericResponse>;
  updatePublicContextSession?: Maybe<GqlPublicContextSession>;
  updatePushNotificationToken?: Maybe<GqlGenericResponse>;
  updateQuantity?: Maybe<GqlCheckout>;
  updateRemoteExtensions?: Maybe<GqlGenericResponse>;
  updateReservationSlots?: Maybe<GqlGenericResponse>;
  updateSeoSettings?: Maybe<GqlGenericResponse>;
  updateSingleDispensaryAdSettings?: Maybe<GqlUpdateSingleDispensaryAdSettingsResponse>;
  updateSingleDispensaryPersonalizationSettings?: Maybe<GqlUpdateSingleDispensaryPersonalizationSettingsResponse>;
  updateSpecialMenuDesign?: Maybe<GqlGenericResponse>;
  updateSpecialV3?: Maybe<GqlSpecials>;
  updateSpecialsSortOrder?: Maybe<GqlGenericResponse>;
  updateStrainV2?: Maybe<GqlStrain>;
  updateSubscriptionBillingPeriod?: Maybe<GqlGenericResponse>;
  updateSubscriptionManualPayments?: Maybe<GqlGenericResponse>;
  updateSubscriptionPrice?: Maybe<GqlGenericResponse>;
  updateSubscriptionTrial?: Maybe<GqlGenericResponse>;
  updateTerpeneV2?: Maybe<GqlTerpene>;
  updateTextSetting?: Maybe<GqlGenericResponse>;
  updateUser?: Maybe<GqlUsers>;
  updateUserEmail?: Maybe<GqlGenericResponse>;
  updateUserPermissions?: Maybe<GqlGenericResponse>;
  updateUserRoleV2?: Maybe<GqlGenericResponse>;
  updateWebCustomizationSettings?: Maybe<GqlGenericResponse>;
  updateWebCustomizationSettingsV2?: Maybe<GqlGenericResponse>;
  uploadCsvImport: GqlBrandImportHistoryUploadResponse;
  uploadImage?: Maybe<GqlImageUrl>;
  uploadSecureImage?: Maybe<GqlIdImage>;
  /** @deprecated Account verification feature has been sunset. */
  validateVerificationToken?: Maybe<GqlGenericResponse>;
  verifyBucketProducts: GqlGenericResponse;
};


export type GqlMutationAcceptBrandPortalTosArgs = {
  resetToken: Scalars['String'];
};


export type GqlMutationActivateBankAccountArgs = {
  paymentMethodId: Scalars['String'];
};


export type GqlMutationActivatePaymentMethodArgs = {
  paymentMethodId: Scalars['String'];
};


export type GqlMutationActivatePaymentMethodV2Args = {
  paymentMethodId: Scalars['String'];
};


export type GqlMutationActivatePrinterArgs = {
  deviceIdentifier: Scalars['String'];
};


export type GqlMutationAddBankPaymentMethodV2Args = {
  accountId: Scalars['String'];
  chargebeeCustomerId: Scalars['String'];
  publicToken: Scalars['String'];
};


export type GqlMutationAddCustomerToOrderArgs = {
  input?: InputMaybe<GqlAddCustomerToOrderInput>;
};


export type GqlMutationAddDispensaryCustomerArgs = {
  customer: GqlDispensaryCustomerInput;
};


export type GqlMutationAddPaymentMethodV2Args = {
  chargebeeCustomerId: Scalars['String'];
  token: Scalars['String'];
};


export type GqlMutationAddSubscriptionToChainArgs = {
  chargebeeCustomerId: Scalars['String'];
  dispensaryIds: Array<InputMaybe<Scalars['String']>>;
};


export type GqlMutationApproveInstoreCartArgs = {
  instoreCartId: Scalars['String'];
  sessionId?: InputMaybe<Scalars['String']>;
  tipCents: Scalars['Int'];
};


export type GqlMutationArchiveOrderArgs = {
  input: GqlArchiveOrderInput;
};


export type GqlMutationArchiveProductArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type GqlMutationBrandPortalSecureUploadArgs = {
  brandId: Scalars['ID'];
  encoding?: InputMaybe<Scalars['String']>;
  file: Scalars['String'];
  mime?: InputMaybe<Scalars['String']>;
};


export type GqlMutationBulkCreateLspBrandSettingsArgs = {
  updates: Array<GqlLspBrandSettingsBulkInput>;
};


export type GqlMutationBulkEndSpecialsV2Args = {
  input: GqlEndSpecialsInput;
};


export type GqlMutationBulkLibraryProductDeleteArgs = {
  libraryProductIds?: InputMaybe<Array<Scalars['String']>>;
};


export type GqlMutationBulkLibraryProductRestoreArgs = {
  libraryProductIds?: InputMaybe<Array<Scalars['String']>>;
};


export type GqlMutationBulkLibraryProductUpdateArgs = {
  libraryProductIds?: InputMaybe<Array<Scalars['String']>>;
  updates: GqlBulkLibraryProductUpdates;
};


export type GqlMutationBulkLibraryProductUploadArgs = {
  s3Key: Scalars['String'];
};


export type GqlMutationBulkUpdateMenuSectionsArgs = {
  deletes?: InputMaybe<Array<Scalars['ID']>>;
  dispensaryId: Scalars['String'];
  menuSections?: InputMaybe<Array<GqlMenuSectionBulkUpdateInput>>;
};


export type GqlMutationChangeRequestApproveProductArgs = {
  id: Scalars['String'];
};


export type GqlMutationChangeRequestCreateProductArgs = {
  brandId: Scalars['String'];
  complianceRegionId: Scalars['String'];
  contentAttributes: GqlUpdatedLibraryProduct;
};


export type GqlMutationChangeRequestDeleteProductArgs = {
  productId: Scalars['String'];
};


export type GqlMutationChangeRequestLockProductArgs = {
  id: Scalars['String'];
};


export type GqlMutationChangeRequestRejectProductArgs = {
  feedback: Scalars['String'];
  id: Scalars['String'];
  rejectionReasons: Array<RejectionReasons>;
};


export type GqlMutationChangeRequestUnlockProductArgs = {
  id: Scalars['String'];
};


export type GqlMutationChangeRequestUpdateProductArgs = {
  contentAttributes: GqlUpdatedLibraryProduct;
  productId: Scalars['String'];
};


export type GqlMutationCheckInBucketV2Args = {
  uuid: Scalars['String'];
};


export type GqlMutationCheckOutBucketV2Args = {
  bucketId: Scalars['String'];
  uuid: Scalars['String'];
};


export type GqlMutationCheckOutBucketV3Args = {
  bucketId: Scalars['String'];
  uuid: Scalars['String'];
};


export type GqlMutationClearAdsInspectorEventsArgs = {
  input: GqlAdsInspectorEventsInput;
};


export type GqlMutationClearAllCurbsideArrivalsArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlMutationClearCurbsideArrivalArgs = {
  arrivalId: Scalars['String'];
};


export type GqlMutationCloseBucketArgs = {
  id: Scalars['String'];
};


export type GqlMutationCompleteAggregatorLinkArgs = {
  aggregator: Scalars['String'];
  aggregatorToken: Scalars['String'];
  dispensaryId?: InputMaybe<Scalars['String']>;
  dispensaryName?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  plaid?: InputMaybe<GqlPlaidLinkMetadata>;
  sessionId?: InputMaybe<Scalars['String']>;
};


export type GqlMutationComputeWithPriceCartV2Args = {
  input: GqlCalculationsInput;
};


export type GqlMutationConnectDeviceV2Args = {
  connectionToken: Scalars['String'];
};


export type GqlMutationConnectProductArgs = {
  id: Scalars['String'];
  libraryProductId: Scalars['String'];
  omitFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GqlMutationConnectProductPreviewArgs = {
  id: Scalars['String'];
  libraryProductId: Scalars['String'];
};


export type GqlMutationConsumeDeviceAccessCodeArgs = {
  accessCode: Scalars['String'];
  dispensaryId: Scalars['String'];
};


export type GqlMutationConsumerSignupArgs = {
  input: GqlConsumerSignupInput;
  publicContextSessionId?: InputMaybe<Scalars['String']>;
  turnstileToken?: InputMaybe<Scalars['String']>;
};


export type GqlMutationCopyLibraryProductArgs = {
  id: Scalars['String'];
  stateLibraryIds: Array<Scalars['String']>;
};


export type GqlMutationCreateAlpineUserArgs = {
  acceptedTerms: Scalars['Boolean'];
  address?: InputMaybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  favoriteStore: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  program: Scalars['String'];
};


export type GqlMutationCreateAlpineUserV2Args = {
  acceptedTerms: Scalars['Boolean'];
  address?: InputMaybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  favoriteStore: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  program: Scalars['String'];
};


export type GqlMutationCreateBackInStockSubscriptionArgs = {
  productId: Scalars['String'];
};


export type GqlMutationCreateBankAccountArgs = {
  adapter: Scalars['String'];
  aggregatorToken: Scalars['String'];
  billingAddressId: Scalars['String'];
  entityId: Scalars['String'];
  entityType: EntityTypes;
  sessionId?: InputMaybe<Scalars['String']>;
};


export type GqlMutationCreateBillingGroupArgs = {
  billingGroup: GqlCreateBillingGroupInput;
};


export type GqlMutationCreateBrandEnterpriseSettingsArgs = {
  brandId: Scalars['String'];
  settings: Array<GqlBrandEnterpriseSettingsInput>;
};


export type GqlMutationCreateBrandUserArgs = {
  updates: GqlBrandUserCreateInput;
};


export type GqlMutationCreateBrandV2Args = {
  brand: GqlBrandInput;
};


export type GqlMutationCreateBucketForLibraryItemArgs = {
  libraryItemId: Scalars['ID'];
};


export type GqlMutationCreateBucketV2Args = {
  bucket: GqlCreateBucketInput;
};


export type GqlMutationCreateBucketV3Args = {
  bucket: GqlCreateBucketInputV3;
};


export type GqlMutationCreateCheckoutArgs = {
  cart: Array<GqlCreateCheckoutInputCartItem>;
  dispensaryId: Scalars['String'];
  orderType: ReservationSlotTypes;
  paymentMethod?: InputMaybe<Scalars['String']>;
  pricingType: CustomerType;
};


export type GqlMutationCreateCollectionArgs = {
  dispensaryId: Scalars['String'];
  input: GqlUpdateCollectionInput;
};


export type GqlMutationCreateCouponV2Args = {
  coupon: GqlCreateCouponInput;
};


export type GqlMutationCreateDutchiePosLoyaltyMemberArgs = {
  dispensaryId: Scalars['String'];
  userId: Scalars['String'];
};


export type GqlMutationCreateEnterpriseDutchiePosLoyaltyMemberArgs = {
  enterpriseId: Scalars['String'];
  isoRegionCode: Scalars['String'];
  userId: Scalars['String'];
};


export type GqlMutationCreateEnterpriseSpecialV2Args = {
  input: GqlEnterpriseSpecialInputV2;
};


export type GqlMutationCreateEnterpriseSpecialsSettingsArgs = {
  enterpriseId: Scalars['ID'];
  input?: InputMaybe<GqlEnterpriseSpecialsSettingsInput>;
};


export type GqlMutationCreateFraudAccountArgs = {
  payload: GqlCreateFraudInput;
};


export type GqlMutationCreateInstoreCartUrlArgs = {
  orderId: Scalars['String'];
};


export type GqlMutationCreateIntegrationArgs = {
  integration: GqlIntegrationsUpdateInput;
};


export type GqlMutationCreateLibraryProductArgs = {
  product: GqlProductCreateInput;
  state: Scalars['String'];
};


export type GqlMutationCreateLibraryProductV2Args = {
  libraryProduct: GqlNewLibraryProduct;
  state: Scalars['String'];
};


export type GqlMutationCreateLibraryProductV3Args = {
  libraryProduct: GqlNewLibraryProductV2;
  state: Scalars['String'];
};


export type GqlMutationCreateLoyaltyPassTokenArgs = {
  dispensaryId: Scalars['String'];
  etag?: InputMaybe<Scalars['String']>;
  lastModifiedAt?: InputMaybe<Scalars['String']>;
};


export type GqlMutationCreateLoyaltyPassUrlArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlMutationCreateLspBrandSettingsArgs = {
  brandId: Scalars['String'];
  settings: GqlLspBrandSettingsInput;
};


export type GqlMutationCreateMenuSectionArgs = {
  menuSection: GqlMenuSectionCreateInput;
};


export type GqlMutationCreateMxEnrollmentArgs = {
  billingAddress: GqlBillingAddressInput;
  entityEmail: Scalars['String'];
  entityId: Scalars['String'];
  entityName: Scalars['String'];
  entityType: EntityTypes;
  isMobileApp: Scalars['Boolean'];
};


export type GqlMutationCreateOrUpdateAchReturnArgs = {
  achEntryId: Scalars['String'];
  achReturnId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  returnTraceNumber: Scalars['String'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']>;
};


export type GqlMutationCreateOrUpdateAchReturnV5Args = {
  achEntryId: Scalars['String'];
  achReturnId?: InputMaybe<Scalars['String']>;
  returnCode: Scalars['String'];
  returnTraceNumber: Scalars['String'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']>;
};


export type GqlMutationCreateOrUpdateAchReturnv4Args = {
  achEntryId: Scalars['String'];
  achReturnId?: InputMaybe<Scalars['String']>;
  returnCode: Scalars['String'];
  returnTraceNumber: Scalars['String'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']>;
};


export type GqlMutationCreateOrderV2Args = {
  order?: InputMaybe<GqlOrdersCreateInput>;
  turnstileToken?: InputMaybe<Scalars['String']>;
};


export type GqlMutationCreateOrderingSuspensionV2Args = {
  dispensaryId: Scalars['ID'];
};


export type GqlMutationCreatePosMedUserArgs = {
  dispensaryId: Scalars['String'];
  user: GqlCreatePosMedUserInput;
};


export type GqlMutationCreatePaymentArgs = {
  amount: Scalars['Int'];
  card?: InputMaybe<GqlCreatePaymentCard>;
  checkoutToken: Scalars['String'];
  currency: Scalars['String'];
  customerDetails: GqlCreatePaymentCustomerDetails;
  ecommLocationId: Scalars['String'];
  redirectUrl?: InputMaybe<Scalars['String']>;
  tipAmount?: InputMaybe<Scalars['Int']>;
};


export type GqlMutationCreatePlusApiKeyV2Args = {
  dispensaryId: Scalars['String'];
  keyType: PlusApiKeyType;
};


export type GqlMutationCreatePlusEnterpriseApiKeyArgs = {
  enterpriseId: Scalars['String'];
  keyType: PlusApiKeyType;
};


export type GqlMutationCreatePointsBoostArgs = {
  input: GqlCreatePointsBoostInput;
};


export type GqlMutationCreatePrintJobArgs = {
  input: GqlCreatePrintJobInput;
};


export type GqlMutationCreateProductArgs = {
  product?: InputMaybe<GqlProductCreateInput>;
};


export type GqlMutationCreatePublicContextSessionArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlMutationCreateReservationSlotsArgs = {
  input: GqlReservationSlotsCreateInput;
};


export type GqlMutationCreateRetailerEnrollmentArgs = {
  accountDetails: GqlAccountDetailsInput;
  billingAddress: GqlBillingAddressInput;
  entityId: Scalars['String'];
  entityName: Scalars['String'];
  entityType: Scalars['String'];
  serviceFeeDetails: GqlServiceFeeInput;
};


export type GqlMutationCreateSpecialV3Args = {
  input: GqlSpecialsInputV3;
};


export type GqlMutationCreateSpringbigUserArgs = {
  dispensaryId: Scalars['String'];
  userId: Scalars['String'];
};


export type GqlMutationCreateStrainV2Args = {
  strain: GqlStrainInput;
};


export type GqlMutationCreateTerpeneV2Args = {
  terpene: GqlTerpeneInput;
};


export type GqlMutationCreateUserArgs = {
  user: GqlUsersCreateInput;
};


export type GqlMutationDeleteBackInStockSubscriptionArgs = {
  productId: Scalars['String'];
};


export type GqlMutationDeleteBrandArgs = {
  id: Scalars['String'];
};


export type GqlMutationDeleteCollectionArgs = {
  collectionId: Scalars['String'];
};


export type GqlMutationDeleteCouponArgs = {
  id: Scalars['String'];
};


export type GqlMutationDeleteCouponV2Args = {
  id: Scalars['String'];
};


export type GqlMutationDeleteDeviceV2Args = {
  id: Scalars['ID'];
};


export type GqlMutationDeleteEnterpriseSpecialArgs = {
  enterprise_id: Scalars['String'];
  id: Scalars['String'];
};


export type GqlMutationDeleteLibraryProductArgs = {
  id: Scalars['String'];
};


export type GqlMutationDeletePrinterArgs = {
  printerId: Scalars['String'];
};


export type GqlMutationDeleteSpecialHoursArgs = {
  dispensaryId: Scalars['String'];
  specialHoursIds: Array<InputMaybe<Scalars['ID']>>;
};


export type GqlMutationDeleteSpecialV2Args = {
  id: Scalars['String'];
};


export type GqlMutationDeleteStrainArgs = {
  id: Scalars['String'];
};


export type GqlMutationDeleteSubscriptionArgs = {
  retailerIds: Array<InputMaybe<Scalars['ID']>>;
};


export type GqlMutationDeleteTerpeneArgs = {
  id: Scalars['String'];
};


export type GqlMutationDeleteUserArgs = {
  user: GqlUsersDeleteInput;
};


export type GqlMutationDestroyMenuSectionArgs = {
  dispensaryId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type GqlMutationDeviceHeartbeatArgs = {
  printerConnected: Scalars['Boolean'];
  versionNumber: Scalars['String'];
};


export type GqlMutationDisconnectBankAccountArgs = {
  mxAccountInfo: GqlMxAccountInfo;
};


export type GqlMutationDisconnectBucketProductArgs = {
  bucketId: Scalars['String'];
  productId: Scalars['String'];
};


export type GqlMutationDisconnectProductArgs = {
  id: Scalars['String'];
};


export type GqlMutationDispensaryDemoRequestArgs = {
  input: GqlDispensaryDemoRequestInput;
};


export type GqlMutationDispensaryOnboardingArgs = {
  input: GqlDispensaryOnboardingInput;
};


export type GqlMutationDispensaryRemoveFromChainArgs = {
  input: GqlDispensaryRemoveFromChainInput;
};


export type GqlMutationDispensaryUpdateArgs = {
  input: GqlDispensaryUpdateInput;
};


export type GqlMutationDispensaryUpdateHoursSettingsArgs = {
  input: GqlDispensaryUpdateHoursSettingsInput;
};


export type GqlMutationDispensaryUpdateOptionsSettingsArgs = {
  input: GqlDispensaryUpdateOptionsSettingsInput;
};


export type GqlMutationDispensaryUpdateStatusArgs = {
  input: GqlDispensaryUpdateStatusInput;
};


export type GqlMutationDispensaryUpdateTaxConfigurationArgs = {
  input?: InputMaybe<GqlDispensaryUpdateInput>;
};


export type GqlMutationDispensaryUploadOnboardingAssetArgs = {
  data?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
};


export type GqlMutationEditCustomerV2Args = {
  billingContactEmails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  billingNotificationEnabled?: InputMaybe<Scalars['Boolean']>;
  chargebeeCustomerId: Scalars['String'];
};


export type GqlMutationEmailIntegrationCredentialsArgs = {
  input?: InputMaybe<GqlIntegrationCredsInput>;
};


export type GqlMutationEndEnterpriseSpecialArgs = {
  enterprise_id: Scalars['String'];
  id: Scalars['String'];
};


export type GqlMutationEndOrderingSuspensionV2Args = {
  dispensaryId: Scalars['ID'];
};


export type GqlMutationEndSpecialV2Args = {
  id: Scalars['String'];
};


export type GqlMutationExpirePlusApiKeyArgs = {
  id: Scalars['String'];
};


export type GqlMutationExpirePlusEnterpriseApiKeyArgs = {
  id: Scalars['String'];
};


export type GqlMutationExportCouponsSummariesArgs = {
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationExportCustomerReportArgs = {
  export: GqlExportCustomerReportInput;
};


export type GqlMutationExportDispensaryCustomersArgs = {
  input: GqlCustomerExportInput;
};


export type GqlMutationExportFilteredBrandsSummariesArgs = {
  input: GqlBrandsSummaryInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationExportFilteredCampaignsSummariesArgs = {
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationExportFilteredCartsSummariesArgs = {
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationExportFilteredCatalogArgs = {
  filters?: InputMaybe<GqlExportFilteredCatalogFilterInput>;
  search?: InputMaybe<Scalars['String']>;
};


export type GqlMutationExportFilteredProductSummariesArgs = {
  input: GqlProductsSummaryInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationExportOrderReportArgs = {
  export: GqlExportOrderReportInput;
};


export type GqlMutationExportOrdersArgs = {
  cancelled?: InputMaybe<Scalars['Boolean']>;
  dispensaryId: Scalars['String'];
  email: Scalars['String'];
};


export type GqlMutationExportSpecialsSummariesArgs = {
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationForceDiscountSyncArgs = {
  integration_id: Scalars['String'];
};


export type GqlMutationGenerateDispensaryUserStreamTokenArgs = {
  input: GqlDispensaryUserStreamTokenInput;
};


export type GqlMutationGenerateHypurRedirectV3Args = {
  dispensaryId: Scalars['String'];
  embedded: Scalars['Boolean'];
  hostname?: InputMaybe<Scalars['String']>;
  v2?: InputMaybe<Scalars['Boolean']>;
};


export type GqlMutationGenerateHypurTokenV2Args = {
  code: Scalars['String'];
  hostname?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
};


export type GqlMutationImportCustomerCsvArgs = {
  CSV: Scalars['String'];
  dispensaryId: Scalars['String'];
};


export type GqlMutationImportDeliveryZipCodesArgs = {
  csv: Scalars['String'];
  dispensaryId: Scalars['String'];
};


export type GqlMutationImportMenuCsvArgs = {
  input: GqlImportMenuCsvInput;
};


export type GqlMutationIncrementClicksArgs = {
  special: GqlIncrementClicksInput;
};


export type GqlMutationIntegrationsDeleteArgs = {
  integrationId: Scalars['String'];
};


export type GqlMutationIntegrationsDeleteInArmaArgs = {
  integrationId: Scalars['String'];
};


export type GqlMutationIntegrationsForceSyncInArmaArgs = {
  integrationId: Scalars['String'];
};


export type GqlMutationIntegrationsSuggestionArgs = {
  dispensaryId: Scalars['String'];
  suggestion?: InputMaybe<Scalars['String']>;
};


export type GqlMutationIntegrationsUpdateArgs = {
  input: GqlIntegrationsUpdateInput;
};


export type GqlMutationIntegrationsUpdateCrmFieldsArgs = {
  input: GqlIntegrationsUpdateCrmFieldsInput;
};


export type GqlMutationIntegrationsUpdateFieldsArgs = {
  input: GqlIntegrationsUpdateFieldsInput;
};


export type GqlMutationIntegrationsUpdateHubspotPipelinesArgs = {
  input: GqlIntegrationsUpdateHubspotPipelinesInput;
};


export type GqlMutationIntegrationsUpdateThresholdsArgs = {
  input: GqlIntegrationsUpdateThresholdsInput;
};


export type GqlMutationIntegrationsUpdateTypesArgs = {
  input: GqlIntegrationsUpdateTypesInput;
};


export type GqlMutationIntegrationsWipeMenuArgs = {
  integrationId: Scalars['String'];
};


export type GqlMutationIntegrationsWipeMenuInArmaArgs = {
  dispensaryId: Scalars['String'];
  integrationId: Scalars['String'];
};


export type GqlMutationLibraryProductChangeImpactArgs = {
  product: GqlProductCreateInput;
};


export type GqlMutationLibraryProductChangeImpactV3Args = {
  id: Scalars['String'];
  updates: GqlUpdatedLibraryProduct;
};


export type GqlMutationLogAnalyticsPayloadArgs = {
  payload: Scalars['JSONObject'];
};


export type GqlMutationLoginAdminArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type GqlMutationLoginAdminViaTokenArgs = {
  transferToken: Scalars['String'];
};


export type GqlMutationLoginConsumerArgs = {
  dispensaryId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
  publicContextSessionId?: InputMaybe<Scalars['String']>;
  turnstileToken?: InputMaybe<Scalars['String']>;
};


export type GqlMutationMarkAchEntryAsReturnedArgs = {
  achEntryId: Scalars['String'];
  code: Scalars['String'];
  originalTraceNumber: Scalars['String'];
  returnTraceNumber: Scalars['String'];
};


export type GqlMutationMarkAchEntryAsReturnedV3Args = {
  achEntryId: Scalars['String'];
  code: Scalars['String'];
  returnTraceNumber: Scalars['String'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']>;
};


export type GqlMutationMarkAchEntryAsReturnedV4Args = {
  achEntryId: Scalars['String'];
  returnCode: Scalars['String'];
  returnTraceNumber: Scalars['String'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']>;
};


export type GqlMutationMarkAchEntryAsReturnedV5Args = {
  achEntryId: Scalars['String'];
  returnCode: Scalars['String'];
  returnTraceNumber: Scalars['String'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']>;
};


export type GqlMutationMarkCurbsideArrivalArrivedV2Args = {
  token: Scalars['String'];
};


export type GqlMutationMarkOrderAutoPrintedArgs = {
  input?: InputMaybe<GqlMarkOrderAutoPrintedInput>;
};


export type GqlMutationMarkOrderPosFailedArgs = {
  input?: InputMaybe<GqlMarkOrderPosFailedInput>;
};


export type GqlMutationMarkOrderPrintedArgs = {
  input?: InputMaybe<GqlMarkOrderPrintedInput>;
};


export type GqlMutationMarkOrdersBatchPrintedArgs = {
  input?: InputMaybe<GqlMarkOrdersBatchPrintedInput>;
};


export type GqlMutationMergeBrandArgs = {
  destinationBrandId: Scalars['String'];
  id: Scalars['String'];
};


export type GqlMutationMergeBrandsArgs = {
  ids: Array<Scalars['String']>;
};


export type GqlMutationParseAchReturnFileUploadArgs = {
  file: Scalars['String'];
};


export type GqlMutationParseAchReturnFileUploadV2Args = {
  file: Scalars['String'];
  fileName: Scalars['String'];
};


export type GqlMutationPauseSubscriptionArgs = {
  retailerIds: Array<InputMaybe<Scalars['ID']>>;
};


export type GqlMutationPersistCheckoutArgs = {
  dispensaryId: Scalars['String'];
  order: Scalars['JSON'];
  token: Scalars['String'];
};


export type GqlMutationPersistCheckoutV2Args = {
  dispensaryId: Scalars['String'];
  order: Scalars['JSON'];
  token?: InputMaybe<Scalars['String']>;
};


export type GqlMutationPrintOrderOnTerminalArgs = {
  input?: InputMaybe<GqlPrintOrderInput>;
};


export type GqlMutationRecordUserAcceptanceArgs = {
  acceptanceDocumentId: Scalars['String'];
  entityId: Scalars['String'];
  entityType: EntityTypes;
  userId: Scalars['String'];
};


export type GqlMutationRemoveItemArgs = {
  checkoutId: Scalars['String'];
  dispensaryId: Scalars['String'];
  option?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
};


export type GqlMutationRemoveSubscriptionFromChainArgs = {
  chargebeeCustomerId: Scalars['String'];
  ids: Array<InputMaybe<Scalars['String']>>;
};


export type GqlMutationReopenOrderArgs = {
  id: Scalars['String'];
};


export type GqlMutationResetPasswordV2Args = {
  input: GqlResetPasswordInput;
};


export type GqlMutationRespondToAchReturnArgs = {
  achReturnId: Scalars['String'];
  discretionaryData?: InputMaybe<Scalars['String']>;
  identificationNumber?: InputMaybe<Scalars['String']>;
  rdfiIdentification?: InputMaybe<Scalars['String']>;
  receiverName?: InputMaybe<Scalars['String']>;
  secCode?: InputMaybe<Scalars['String']>;
};


export type GqlMutationResumeSubscriptionArgs = {
  retailerIds: Array<InputMaybe<Scalars['ID']>>;
};


export type GqlMutationReversePaymentArgs = {
  achEntryId: Scalars['String'];
  identificationNumber?: InputMaybe<Scalars['String']>;
  traceNumber?: InputMaybe<Scalars['String']>;
};


export type GqlMutationReverseSettlementArgs = {
  achEntryId: Scalars['String'];
  identificationNumber?: InputMaybe<Scalars['String']>;
  traceNumber?: InputMaybe<Scalars['String']>;
};


export type GqlMutationRevertBrandMergeArgs = {
  id: Scalars['String'];
};


export type GqlMutationRunChainBillingMigrationArgs = {
  input: Array<GqlChainBillingMigrationInput>;
};


export type GqlMutationSendBrandUserPasswordResetEmailArgs = {
  email: Scalars['String'];
};


export type GqlMutationSendPasswordResetEmailV2Args = {
  email: Scalars['String'];
};


export type GqlMutationSendVerificationTokenArgs = {
  dispensaryId?: InputMaybe<Scalars['String']>;
  redirectUrl: Scalars['String'];
};


export type GqlMutationServerSideCalculationsArgs = {
  input: GqlLegacyCalculationsInput;
};


export type GqlMutationSetFeatureFlagOverrideArgs = {
  overrides: Scalars['JSON'];
};


export type GqlMutationSetPasswordV2Args = {
  input: GqlSetPasswordInput;
};


export type GqlMutationSetupBillingV2Args = {
  customerName: Scalars['String'];
  dispensaryIds: Array<Scalars['String']>;
};


export type GqlMutationSetupRetailerBankPaymentMethodArgs = {
  accountId: Scalars['String'];
  retailerIds: Array<InputMaybe<Scalars['ID']>>;
  token: Scalars['String'];
};


export type GqlMutationSetupRetailerBillingArgs = {
  retailerIds: Array<InputMaybe<Scalars['ID']>>;
};


export type GqlMutationSetupRetailerCreditPaymentMethodArgs = {
  retailerIds: Array<InputMaybe<Scalars['ID']>>;
  token: Scalars['String'];
};


export type GqlMutationSkipBucketProductArgs = {
  bucketId: Scalars['String'];
  productId: Scalars['String'];
};


export type GqlMutationSkipBucketProductV2Args = {
  bucketId: Scalars['String'];
  productId: Scalars['String'];
  skipReasons: Array<SkipReasonEnum>;
};


export type GqlMutationSortMenuSectionsArgs = {
  dispensaryId: Scalars['String'];
  ids: Array<Scalars['String']>;
};


export type GqlMutationSpeculativeProductUpdateArgs = {
  bucketId: Scalars['String'];
  product?: InputMaybe<GqlProductCreateInput>;
  productId: Scalars['String'];
};


export type GqlMutationStartPreAuthCheckArgs = {
  paymentMethodId: Scalars['String'];
};


export type GqlMutationUnarchiveOrderArgs = {
  id: Scalars['String'];
};


export type GqlMutationUnenrollPayByBankUserArgs = {
  entityId: Scalars['String'];
  entityType: EntityTypes;
};


export type GqlMutationUnsubscribeDispensaryCustomersArgs = {
  input: GqlUnsubscribeDispensaryCustomersInput;
};


export type GqlMutationUpdateAutoPrintDevicesV2Args = {
  deviceIds: Array<Scalars['String']>;
  dispensaryId: Scalars['String'];
};


export type GqlMutationUpdateBillingGroupArgs = {
  billingGroup: GqlUpdateBillingGroupInput;
};


export type GqlMutationUpdateBillingNotificationsArgs = {
  billingContactEmails: Array<InputMaybe<Scalars['String']>>;
  billingNotificationEnabled: Scalars['Boolean'];
  retailerIds: Array<InputMaybe<Scalars['ID']>>;
};


export type GqlMutationUpdateBrandCollisionArgs = {
  brandCollision: GqlBrandCollisionInput;
  id: Scalars['String'];
};


export type GqlMutationUpdateBrandEnterpriseSettingArgs = {
  id: Scalars['ID'];
  settings: GqlBrandEnterpriseSettingsInput;
};


export type GqlMutationUpdateBrandImportHistoryNameArgs = {
  brandId: Scalars['ID'];
  importId: Scalars['ID'];
  name: Scalars['String'];
};


export type GqlMutationUpdateBrandUserArgs = {
  id: Scalars['ID'];
  updates: GqlBrandUserUpdateInput;
};


export type GqlMutationUpdateBrandUserAccountArgs = {
  updates: GqlBrandUserUpdateAccountInput;
};


export type GqlMutationUpdateBrandV2Args = {
  brand: GqlBrandInput;
  id: Scalars['String'];
};


export type GqlMutationUpdateChainDispensariesImageArgs = {
  dispensaryId: Scalars['String'];
  image_variant_keys?: InputMaybe<Array<ImageVariantKeyEnum>>;
};


export type GqlMutationUpdateChangeRequestCreateProductArgs = {
  complianceRegionId?: InputMaybe<Scalars['String']>;
  contentAttributes?: InputMaybe<GqlUpdatedLibraryProduct>;
  feedback?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type GqlMutationUpdateChangeRequestUpdateProductArgs = {
  contentAttributes?: InputMaybe<GqlUpdatedLibraryProduct>;
  feedback?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type GqlMutationUpdateChargebeeSubscriptionArgs = {
  billingPeriod?: InputMaybe<BillingPeriod>;
  chargebeeSubscriptionId: Scalars['String'];
  endFreeTrial?: InputMaybe<Scalars['Boolean']>;
  freeTrialEndDate?: InputMaybe<Scalars['Int']>;
  manualPayments?: InputMaybe<Scalars['Boolean']>;
  pauseSubscription?: InputMaybe<Scalars['Boolean']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
};


export type GqlMutationUpdateCheckoutArgs = {
  address?: InputMaybe<GqlCheckoutAddressInput>;
  checkoutId: Scalars['String'];
  dispensaryId: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  orderType: Scalars['String'];
  pricingType?: InputMaybe<Scalars['String']>;
};


export type GqlMutationUpdateCnameArgs = {
  cname: Scalars['String'];
  dispensaryId: Scalars['String'];
};


export type GqlMutationUpdateCollectionArgs = {
  collectionId: Scalars['String'];
  input: GqlUpdateCollectionInput;
};


export type GqlMutationUpdateCollectionPositionsArgs = {
  dispensaryId: Scalars['String'];
  input: GqlUpdateCollectionPositionsInput;
};


export type GqlMutationUpdateConsumerUserArgs = {
  user: GqlConsumerUserProfileInput;
};


export type GqlMutationUpdateCouponArgs = {
  coupon: GqlUpdateCouponInput;
};


export type GqlMutationUpdateCurbsideArrivalV2Args = {
  arrivalInformation: Scalars['String'];
  token: Scalars['String'];
};


export type GqlMutationUpdateCustomerSubscriptionArgs = {
  customerId: Scalars['String'];
  subscribed: Scalars['Boolean'];
};


export type GqlMutationUpdateDeviceArgs = {
  device: GqlUpdateDeviceInput;
};


export type GqlMutationUpdateDispensaryAdSettingsArgs = {
  input: GqlUpdateDispensaryAdSettingsInput;
};


export type GqlMutationUpdateDispensaryCustomerArgs = {
  customer: GqlDispensaryCustomerInput;
};


export type GqlMutationUpdateDispensaryPersonalizationSettingsArgs = {
  input: GqlUpdateDispensaryPersonalizationSettingsInput;
};


export type GqlMutationUpdateDutchiePosLoyaltyMemberArgs = {
  dispensaryId: Scalars['String'];
  lastAndroidLoginUtc?: InputMaybe<Scalars['String']>;
  lastIosLoginUtc?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  userId: Scalars['String'];
};


export type GqlMutationUpdateEmailArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type GqlMutationUpdateEmailV2Args = {
  email: Scalars['String'];
};


export type GqlMutationUpdateEnterpriseAdSettingsArgs = {
  enterpriseId: Scalars['ID'];
  settings: GqlDispensaryAdSettingsInput;
};


export type GqlMutationUpdateEnterpriseMobileAppSettingsArgs = {
  enterpriseId: Scalars['ID'];
  input?: InputMaybe<GqlEnterpriseMobileAppSettingsInput>;
};


export type GqlMutationUpdateEnterprisePersonalizationSettingsArgs = {
  enterpriseId: Scalars['ID'];
  settings: GqlDispensaryPersonalizationSettingsInput;
};


export type GqlMutationUpdateEnterpriseSpecialV2Args = {
  id: Scalars['String'];
  input: GqlEnterpriseSpecialInputV2;
};


export type GqlMutationUpdateEnterpriseSpecialsSettingsArgs = {
  enterpriseId: Scalars['ID'];
  input?: InputMaybe<GqlEnterpriseSpecialsSettingsInput>;
};


export type GqlMutationUpdateEnterpriseWebCustomizationSettingsV2Args = {
  enterpriseId: Scalars['String'];
  input: GqlUpdateWebCustomizationSettingsV2Input;
};


export type GqlMutationUpdateHoursSettingsArgs = {
  input: GqlHoursSettingsUpdateInput;
};


export type GqlMutationUpdateImageBannersArgs = {
  dispensaryId: Scalars['String'];
  input: GqlUpdateImageBannersInput;
};


export type GqlMutationUpdateIntegrationArgs = {
  integration: GqlIntegrationsUpdateInput;
  integrationId: Scalars['String'];
};


export type GqlMutationUpdateKioskOrderPaymentArgs = {
  input?: InputMaybe<GqlUpdateKioskOrderPaymentInput>;
};


export type GqlMutationUpdateLibraryProductArgs = {
  id: Scalars['String'];
  updates: GqlUpdatedLibraryProduct;
};


export type GqlMutationUpdateMenuSectionArgs = {
  id: Scalars['ID'];
  menuSection: GqlMenuSectionUpdateInput;
};


export type GqlMutationUpdateOrderStatusArgs = {
  order?: InputMaybe<GqlOrdersStatusUpdateInput>;
};


export type GqlMutationUpdateOrderV2Args = {
  input?: InputMaybe<GqlOrdersCreateInput>;
};


export type GqlMutationUpdateOrderingSettingsArgs = {
  input: GqlOrderingSettingsUpdateInput;
};


export type GqlMutationUpdatePasswordV2Args = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type GqlMutationUpdatePlusOAuthProviderArgs = {
  enterpriseId: Scalars['String'];
  input: GqlPlusOAuthProviderInput;
};


export type GqlMutationUpdatePrinterArgs = {
  input: GqlUpdatePrinterInput;
};


export type GqlMutationUpdateProductArgs = {
  bucketId?: InputMaybe<Scalars['String']>;
  omitFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  product?: InputMaybe<GqlProductCreateInput>;
  productId?: InputMaybe<Scalars['String']>;
};


export type GqlMutationUpdateProductSortArgs = {
  input: GqlUpdateProductSortInput;
};


export type GqlMutationUpdateProductStatusArgs = {
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type GqlMutationUpdateProfileV2Args = {
  profile: GqlConsumerUserProfileInput;
};


export type GqlMutationUpdatePublicContextSessionArgs = {
  id: Scalars['String'];
  loginMethodVerified?: InputMaybe<Scalars['Boolean']>;
};


export type GqlMutationUpdatePushNotificationTokenArgs = {
  dispensaryId: Scalars['String'];
  token: Scalars['String'];
};


export type GqlMutationUpdateQuantityArgs = {
  checkoutId: Scalars['String'];
  dispensaryId: Scalars['String'];
  option?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
  quantity: Scalars['Int'];
};


export type GqlMutationUpdateRemoteExtensionsArgs = {
  dispensaryId: Scalars['String'];
  enterpriseId?: InputMaybe<Scalars['String']>;
  input: GqlUpdateRemoteExtensionsInput;
};


export type GqlMutationUpdateReservationSlotsArgs = {
  input: GqlReservationSlotsUpdateInput;
};


export type GqlMutationUpdateSeoSettingsArgs = {
  dispensaryId: Scalars['String'];
  input: GqlUpdateSeoSettingsInput;
};


export type GqlMutationUpdateSingleDispensaryAdSettingsArgs = {
  dispensaryId: Scalars['String'];
  settings: GqlDispensaryAdSettingsInput;
};


export type GqlMutationUpdateSingleDispensaryPersonalizationSettingsArgs = {
  dispensaryId: Scalars['String'];
  settings: GqlDispensaryPersonalizationSettingsInput;
};


export type GqlMutationUpdateSpecialMenuDesignArgs = {
  id: Scalars['ID'];
  input: GqlMenuDesignInput;
};


export type GqlMutationUpdateSpecialV3Args = {
  id: Scalars['String'];
  input: GqlSpecialsInputV3;
};


export type GqlMutationUpdateSpecialsSortOrderArgs = {
  input: GqlSortOrderInput;
};


export type GqlMutationUpdateStrainV2Args = {
  id: Scalars['String'];
  strain: GqlStrainInput;
};


export type GqlMutationUpdateSubscriptionBillingPeriodArgs = {
  billingPeriod: BillingPeriod;
  retailerIds: Array<InputMaybe<Scalars['ID']>>;
};


export type GqlMutationUpdateSubscriptionManualPaymentsArgs = {
  manualPayments: Scalars['Boolean'];
  retailerIds: Array<InputMaybe<Scalars['ID']>>;
};


export type GqlMutationUpdateSubscriptionPriceArgs = {
  priceInCents: Scalars['String'];
  retailerIds: Array<InputMaybe<Scalars['ID']>>;
};


export type GqlMutationUpdateSubscriptionTrialArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  retailerIds: Array<InputMaybe<Scalars['ID']>>;
};


export type GqlMutationUpdateTerpeneV2Args = {
  id: Scalars['String'];
  terpene: GqlTerpeneInput;
};


export type GqlMutationUpdateTextSettingArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};


export type GqlMutationUpdateUserArgs = {
  user: GqlUsersUpdateInput;
};


export type GqlMutationUpdateUserEmailArgs = {
  currentEmail: Scalars['String'];
  newEmail: Scalars['String'];
};


export type GqlMutationUpdateUserPermissionsArgs = {
  email: Scalars['String'];
  permission: Scalars['String'];
};


export type GqlMutationUpdateUserRoleV2Args = {
  email: Scalars['String'];
  role: UserRoles;
};


export type GqlMutationUpdateWebCustomizationSettingsArgs = {
  dispensaryId: Scalars['String'];
  input: GqlUpdateWebCustomizationSettingsInput;
};


export type GqlMutationUpdateWebCustomizationSettingsV2Args = {
  dispensaryId: Scalars['String'];
  input: GqlUpdateWebCustomizationSettingsV2Input;
};


export type GqlMutationUploadCsvImportArgs = {
  csvFile: Scalars['String'];
  filename: Scalars['String'];
};


export type GqlMutationUploadImageArgs = {
  input: GqlImageUploadInput;
};


export type GqlMutationUploadSecureImageArgs = {
  input: GqlImageUploadInput;
};


export type GqlMutationValidateVerificationTokenArgs = {
  token: Scalars['String'];
};


export type GqlMutationVerifyBucketProductsArgs = {
  ids: Array<Scalars['String']>;
};

export type GqlMxAccountInfo = {
  memberGuid: Scalars['String'];
  userGuid: Scalars['String'];
};

export type GqlMxBankAccount = {
  __typename?: 'MxBankAccount';
  accountAlias: Scalars['String'];
  active: Scalars['Boolean'];
  bankName: Scalars['String'];
  billingAddressId: Scalars['String'];
  createdAt?: Maybe<Scalars['ISODateTime']>;
  entityId: Scalars['String'];
  id: Scalars['String'];
  lastDigits: Scalars['String'];
  mx?: Maybe<GqlMxResponse>;
  status: Scalars['String'];
};

export type GqlMxBankAccounts = {
  __typename?: 'MxBankAccounts';
  bankAccounts?: Maybe<Array<GqlMxBankAccount>>;
};

export type GqlMxMemberVerification = {
  __typename?: 'MxMemberVerification';
  accounts: Array<GqlAccount>;
  identificationComplete: Scalars['Boolean'];
  needsAccountSelection: Scalars['Boolean'];
  needsMfa: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type GqlMxResponse = {
  __typename?: 'MxResponse';
  connectionStatus: Scalars['String'];
  widgetUrl: Scalars['String'];
};

export type GqlNamedProductPotency = {
  __typename?: 'NamedProductPotency';
  name: Scalars['String'];
  range: Array<Scalars['Float']>;
  unit: Scalars['String'];
};

export enum NavBarColor {
  aliceBlue = 'ALICE_BLUE',
  lightBrown = 'LIGHT_BROWN',
  white = 'WHITE',
  whiteSmoke = 'WHITE_SMOKE'
}

export type GqlNewLibraryProduct = {
  AdditionalOptions?: InputMaybe<Array<Scalars['String']>>;
  CBD?: InputMaybe<Scalars['String']>;
  CBDContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  Description?: InputMaybe<Scalars['String']>;
  Image?: InputMaybe<Scalars['String']>;
  Name: Scalars['String'];
  Options?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Prices?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  Status?: InputMaybe<Scalars['String']>;
  THC?: InputMaybe<Scalars['String']>;
  THCContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  addedUsingCCT?: InputMaybe<Scalars['Boolean']>;
  bottleDepositTaxCents?: InputMaybe<Scalars['Int']>;
  brandId?: InputMaybe<Scalars['String']>;
  cannabinoids?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  cannabinoidsV2?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  comingSoon?: InputMaybe<Scalars['Boolean']>;
  connectedCount?: InputMaybe<Scalars['Int']>;
  descriptionHtml?: InputMaybe<Scalars['String']>;
  duplicatedProductId?: InputMaybe<Scalars['String']>;
  effects?: InputMaybe<Scalars['JSON']>;
  flavors?: InputMaybe<Array<Scalars['String']>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  integrationKey?: InputMaybe<Scalars['String']>;
  limitsPerCustomer?: InputMaybe<Array<GqlLibraryProductLimitPerCustomerInput>>;
  manualInventory?: InputMaybe<Array<GqlLibraryProductManualInventoryInput>>;
  medicalOnly?: InputMaybe<Scalars['Boolean']>;
  medicalPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  rawOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  recOnly?: InputMaybe<Scalars['Boolean']>;
  recPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  strainType?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  terpenes?: InputMaybe<Array<GqlLibraryProductTerpenesInput>>;
  type?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type GqlNewLibraryProductV2 = {
  AdditionalOptions?: InputMaybe<Array<Scalars['String']>>;
  CBD?: InputMaybe<Scalars['String']>;
  CBDContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  Description?: InputMaybe<Scalars['String']>;
  Image?: InputMaybe<Scalars['String']>;
  Name: Scalars['String'];
  Options?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Prices?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  Status?: InputMaybe<Scalars['String']>;
  THC?: InputMaybe<Scalars['String']>;
  THCContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  addedUsingCCT?: InputMaybe<Scalars['Boolean']>;
  bottleDepositTaxCents?: InputMaybe<Scalars['Int']>;
  brandId?: InputMaybe<Scalars['String']>;
  cannabinoids?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  cannabinoidsV2?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  comingSoon?: InputMaybe<Scalars['Boolean']>;
  connectedCount?: InputMaybe<Scalars['Int']>;
  descriptionHtml?: InputMaybe<Scalars['String']>;
  duplicatedProductId?: InputMaybe<Scalars['String']>;
  effects?: InputMaybe<Scalars['JSON']>;
  flavors?: InputMaybe<Array<Scalars['String']>>;
  gtin?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<InputMaybe<GqlProducts_ImagesInput>>>;
  integrationKey?: InputMaybe<Scalars['String']>;
  limitsPerCustomer?: InputMaybe<Array<GqlLibraryProductLimitPerCustomerInput>>;
  manualInventory?: InputMaybe<Array<GqlLibraryProductManualInventoryInput>>;
  medicalOnly?: InputMaybe<Scalars['Boolean']>;
  medicalPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  productTemplate?: InputMaybe<Scalars['Boolean']>;
  rawOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  recOnly?: InputMaybe<Scalars['Boolean']>;
  recPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  sku?: InputMaybe<Scalars['String']>;
  stockImage?: InputMaybe<Scalars['String']>;
  stockImageAliases?: InputMaybe<Scalars['String']>;
  stockImageCategory?: InputMaybe<Scalars['String']>;
  strainType?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  terpenes?: InputMaybe<Array<GqlLibraryProductTerpenesInput>>;
  type?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type GqlNextServiceForOrderType = {
  closeMoment?: InputMaybe<Scalars['String']>;
  openMoment?: InputMaybe<Scalars['String']>;
  openString?: InputMaybe<Scalars['String']>;
};

export type GqlNsfAchReturnReport = {
  __typename?: 'NsfAchReturnReport';
  nsfAchReturnReport?: Maybe<Array<Maybe<GqlNsfAchReturnReportRow>>>;
};

export type GqlNsfAchReturnReportResponse = {
  __typename?: 'NsfAchReturnReportResponse';
  data?: Maybe<GqlNsfAchReturnReport>;
};

export type GqlNsfAchReturnReportRow = {
  __typename?: 'NsfAchReturnReportRow';
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<GqlGoogleProtobufTimestamp>;
  dollarAmount?: Maybe<Scalars['Float']>;
  endUserName?: Maybe<Scalars['String']>;
  returnCode?: Maybe<Scalars['String']>;
};

export type GqlOldProductData = {
  __typename?: 'OldProductData';
  CBDContent?: Maybe<GqlProductPotency>;
  Name?: Maybe<Scalars['String']>;
  POSMetaData?: Maybe<GqlProducts_PosMetaData>;
  THCContent?: Maybe<GqlProductPotency>;
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GqlOpenInfoForDevice = {
  __typename?: 'OpenInfoForDevice';
  nextServiceString?: Maybe<Scalars['String']>;
  shouldDeviceDisplayClosed?: Maybe<Scalars['Boolean']>;
  shouldDevicePlayOrderAlert?: Maybe<Scalars['Boolean']>;
};

export type GqlOpenInfoForOrderType = {
  isClosed?: InputMaybe<Scalars['Boolean']>;
  isOpen?: InputMaybe<Scalars['Boolean']>;
  nextService?: InputMaybe<GqlNextServiceForOrderType>;
};

export type GqlOrderEditEvents = {
  __typename?: 'OrderEditEvents';
  agentName?: Maybe<Scalars['String']>;
  at?: Maybe<Scalars['String']>;
  by?: Maybe<Scalars['String']>;
  byType?: Maybe<Scalars['String']>;
};

export type GqlOrderList = {
  __typename?: 'OrderList';
  orders?: Maybe<Array<Maybe<GqlOrders>>>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlOrderMinimum = {
  __typename?: 'OrderMinimum';
  enabled?: Maybe<Scalars['Boolean']>;
  minimumInCents?: Maybe<Scalars['Int']>;
};

export type GqlOrderMinimumInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  minimumInCents?: InputMaybe<Scalars['Int']>;
};

export type GqlOrderPrinted = {
  __typename?: 'OrderPrinted';
  printed?: Maybe<Scalars['Boolean']>;
};

export enum OrderQueryStatuses {
  active = 'active',
  all = 'all',
  allIncludingArchived = 'allIncludingArchived',
  archived = 'archived',
  closed = 'closed'
}

export type GqlOrderReservation = {
  __typename?: 'OrderReservation';
  endTimeISO?: Maybe<Scalars['ISODateTime']>;
  slotId?: Maybe<Scalars['String']>;
  startTimeISO?: Maybe<Scalars['ISODateTime']>;
};

export type GqlOrderReservationInput = {
  endTimeISO?: InputMaybe<Scalars['ISODateTime']>;
  slotId?: InputMaybe<Scalars['String']>;
  startTimeISO?: InputMaybe<Scalars['ISODateTime']>;
};

export type GqlOrderSchedulingDataInput = {
  afterHoursEnabled?: InputMaybe<Scalars['Boolean']>;
  afterHoursInEffect?: InputMaybe<Scalars['Boolean']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  orderTypeHours?: InputMaybe<GqlHoursForOrderType>;
  orderTypeOpenInfo?: InputMaybe<GqlOpenInfoForOrderType>;
  reservationSlots?: InputMaybe<Array<InputMaybe<GqlReservationSlotsForOrderType>>>;
  scheduledOrderingEnabled?: InputMaybe<Scalars['Boolean']>;
  schedulingOption?: InputMaybe<Scalars['String']>;
};

export type GqlOrderStatusEmailSettings = {
  __typename?: 'OrderStatusEmailSettings';
  disableConfirmed?: Maybe<Scalars['Boolean']>;
  disableOutForDelivery?: Maybe<Scalars['Boolean']>;
  disableReadyForPickup?: Maybe<Scalars['Boolean']>;
  disableSubmitted?: Maybe<Scalars['Boolean']>;
};

export type GqlOrderStatusEvents = {
  __typename?: 'OrderStatusEvents';
  agentName?: Maybe<Scalars['String']>;
  at?: Maybe<Scalars['String']>;
  by?: Maybe<Scalars['String']>;
  byType?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
};

export enum OrderType {
  delivery = 'delivery',
  kiosk = 'kiosk',
  pickupAll = 'pickup_all',
  pickupCurbside = 'pickup_curbside',
  pickupDrivethru = 'pickup_drivethru',
  pickupInstore = 'pickup_instore'
}

export type GqlOrderTypeConfig = {
  __typename?: 'OrderTypeConfig';
  anonymousCheckout?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  timeout?: Maybe<GqlTimeoutConfig>;
};

export enum OrderTypes {
  all = 'all',
  delivery = 'delivery',
  kiosk = 'kiosk',
  pickup = 'pickup'
}

export type GqlOrderTypesConfig = {
  __typename?: 'OrderTypesConfig';
  curbsidePickup?: Maybe<GqlOrderTypeConfig>;
  delivery?: Maybe<GqlOrderTypeConfig>;
  driveThruPickup?: Maybe<GqlOrderTypeConfig>;
  kiosk?: Maybe<GqlOrderTypeConfig>;
  offerAnyPickupService?: Maybe<Scalars['Boolean']>;
  offerDeliveryService?: Maybe<Scalars['Boolean']>;
  pickup?: Maybe<GqlOrderTypeConfig>;
};

export type GqlOrderTypesConfigV2 = {
  __typename?: 'OrderTypesConfigV2';
  curbsidePickup?: Maybe<GqlCurbsidePickupOrderingSettings>;
  delivery?: Maybe<GqlDeliveryOrderingSettings>;
  driveThruPickup?: Maybe<GqlDriveThruPickupOrderingSettings>;
  inStorePickup?: Maybe<GqlInStorePickupOrderingSettings>;
  kiosk?: Maybe<GqlKioskOrderingSettings>;
  offerAnyPickupService?: Maybe<Scalars['Boolean']>;
  offerDeliveryService?: Maybe<Scalars['Boolean']>;
};

export type GqlOrderUpdated = {
  __typename?: 'OrderUpdated';
  updated?: Maybe<Scalars['Boolean']>;
};

export type GqlOrder_BottleDepositTaxExistence = {
  __typename?: 'Order_bottleDepositTaxExistence';
  med?: Maybe<GqlOrder_TaxStages>;
  rec?: Maybe<GqlOrder_TaxStages>;
};

export type GqlOrder_CannabisTaxExistence = {
  __typename?: 'Order_cannabisTaxExistence';
  med?: Maybe<GqlOrder_TaxStages>;
  rec?: Maybe<GqlOrder_TaxStages>;
};

export type GqlOrder_Product = {
  __typename?: 'Order_product';
  AdditionalOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  CBDContent?: Maybe<GqlProductPotency>;
  Image?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Options?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated Marked for removal */
  POSMetaData?: Maybe<GqlProducts_PosMetaData>;
  Prices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  Status?: Maybe<Scalars['String']>;
  THCContent?: Maybe<GqlProductPotency>;
  _id?: Maybe<Scalars['String']>;
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  cName?: Maybe<Scalars['String']>;
  integrationKey?: Maybe<Scalars['String']>;
  preTaxMedPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  preTaxRecPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  productName?: Maybe<Scalars['String']>;
  rawOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  strainType?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GqlOrder_SalesTaxExistence = {
  __typename?: 'Order_salesTaxExistence';
  med?: Maybe<GqlOrder_TaxStages>;
  rec?: Maybe<GqlOrder_TaxStages>;
};

export type GqlOrder_TaxStages = {
  __typename?: 'Order_taxStages';
  checkout?: Maybe<Scalars['Boolean']>;
  menu?: Maybe<Scalars['Boolean']>;
  pos?: Maybe<Scalars['Boolean']>;
};

export type GqlOrderingSettingsUpdateInput = {
  curbsidePickup?: InputMaybe<GqlCurbsidePickupInput>;
  delivery?: InputMaybe<GqlDeliveryInput>;
  dispensaryId: Scalars['String'];
  driveThruPickup?: InputMaybe<GqlBasicSettingsInput>;
  inStorePickup?: InputMaybe<GqlBasicSettingsInput>;
  kiosk?: InputMaybe<GqlKioskInput>;
};

export type GqlOrderingSuspension = {
  __typename?: 'OrderingSuspension';
  id: Scalars['String'];
};

export type GqlOrders = {
  __typename?: 'Orders';
  apartmentNum?: Maybe<Scalars['String']>;
  appliedRewards?: Maybe<Array<Maybe<GqlReward>>>;
  archivedAtISO?: Maybe<Scalars['ISODateTime']>;
  archivedBy?: Maybe<Scalars['String']>;
  autoClosed?: Maybe<Scalars['Boolean']>;
  autoConfirmed?: Maybe<Scalars['Boolean']>;
  bottleDepositTaxCents?: Maybe<Scalars['Int']>;
  bottleDepositTaxExistence?: Maybe<GqlOrder_BottleDepositTaxExistence>;
  cancellationReason?: Maybe<Scalars['String']>;
  cannabisTax?: Maybe<Scalars['Float']>;
  cannabisTaxExistence?: Maybe<GqlOrder_CannabisTaxExistence>;
  closedByDriver?: Maybe<Scalars['Boolean']>;
  closedByTerminal?: Maybe<Scalars['Boolean']>;
  coupon?: Maybe<GqlCoupons>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  credit?: Maybe<Scalars['Float']>;
  creditTotal?: Maybe<Scalars['String']>;
  curbsideArrivalInfo?: Maybe<GqlCurbsideArrival>;
  customer?: Maybe<GqlOrders_Customer>;
  customerState?: Maybe<Scalars['String']>;
  /** @deprecated Replaced by durationEstimates.delivery - 10/04/19 */
  deliveryEstimate?: Maybe<Scalars['String']>;
  deliveryFee?: Maybe<Scalars['Float']>;
  deliveryInfo?: Maybe<GqlOrders_DeliveryInfo>;
  destinationTerminal?: Maybe<Scalars['String']>;
  dispensary?: Maybe<GqlOrders_Dispensary>;
  dispoTimezone?: Maybe<Scalars['String']>;
  driverEmail?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  driverNumber?: Maybe<Scalars['String']>;
  driversLicense?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  durationEstimates?: Maybe<GqlDurationEstimates>;
  dutchiePay?: Maybe<GqlDutchiePay>;
  editEvents?: Maybe<Array<Maybe<GqlOrderEditEvents>>>;
  embedded?: Maybe<Scalars['Boolean']>;
  fleetManagementTask?: Maybe<GqlOrders_FleetManagementTask>;
  guestCustomer?: Maybe<GqlOrders_GuestCustomer>;
  hypur?: Maybe<GqlHypurDetails>;
  id?: Maybe<Scalars['String']>;
  isAfterHoursOrder?: Maybe<Scalars['Boolean']>;
  isAnonymous?: Maybe<Scalars['Boolean']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isCurbsidePickupOrder?: Maybe<Scalars['Boolean']>;
  isDriveThruPickupOrder?: Maybe<Scalars['Boolean']>;
  isExternalUserOrder?: Maybe<Scalars['Boolean']>;
  isGuestOrder?: Maybe<Scalars['Boolean']>;
  isKioskOrder?: Maybe<Scalars['Boolean']>;
  /** @deprecated temporary field to toggle compatibility with outdated clients */
  isPTPOT?: Maybe<Scalars['Boolean']>;
  isPreviewOrder?: Maybe<Scalars['Boolean']>;
  linx?: Maybe<GqlOrders_Linx>;
  manualDiscount?: Maybe<GqlOrders_ManualDiscount>;
  medicalCard?: Maybe<GqlOrders_MedicalCard>;
  medicalOrder?: Maybe<Scalars['Boolean']>;
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  mixAndMatch?: Maybe<Scalars['Float']>;
  mobile?: Maybe<Scalars['Boolean']>;
  moneris?: Maybe<Array<Maybe<GqlMonerisDetails>>>;
  orderId?: Maybe<Scalars['String']>;
  orders: Array<GqlOrders_Order>;
  otherFees?: Maybe<Scalars['Float']>;
  paymentFee?: Maybe<Scalars['Float']>;
  paymentId?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  payments?: Maybe<Array<Maybe<GqlPaymentDetails>>>;
  paysafe?: Maybe<GqlPaysafeDetails>;
  platformType?: Maybe<PlatformType>;
  pos?: Maybe<GqlOrders_Pos>;
  preOrderType?: Maybe<PreOrderType>;
  preTaxMedPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  preTaxRecPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  printCommandsJson?: Maybe<Scalars['JSON']>;
  printCommandsWithLogoJson?: Maybe<Scalars['JSON']>;
  receipt?: Maybe<Scalars['JSONObject']>;
  receiptURL?: Maybe<Scalars['String']>;
  reservation?: Maybe<GqlOrderReservation>;
  salesTaxExistence?: Maybe<GqlOrder_SalesTaxExistence>;
  signatureImage?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusEvents?: Maybe<Array<Maybe<GqlOrderStatusEvents>>>;
  statusTimes?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtotal?: Maybe<Scalars['String']>;
  taxAmount?: Maybe<Scalars['Float']>;
  terminal?: Maybe<Scalars['String']>;
  tipAmount?: Maybe<Scalars['Float']>;
  tipValue?: Maybe<GqlOrders_TipValue>;
  total?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Scalars['String']>;
  updateOrderToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  variantSource?: Maybe<Scalars['String']>;
};

export type GqlOrders_Pos = {
  __typename?: 'Orders_POS';
  externalID?: Maybe<Scalars['String']>;
  failureAcks?: Maybe<GqlOrders_Pos_FailureLocations>;
  failureReason?: Maybe<Scalars['String']>;
  failureType?: Maybe<Scalars['String']>;
  humanReadableError?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type GqlOrders_Pos_FailureLocations = {
  __typename?: 'Orders_POS_FailureLocations';
  terminal?: Maybe<Scalars['Boolean']>;
  web?: Maybe<Scalars['Boolean']>;
};

export type GqlOrders_Customer = {
  __typename?: 'Orders_customer';
  _id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  emails?: Maybe<Array<Maybe<GqlOrders_Customer_Emails>>>;
  profile?: Maybe<GqlOrders_Customer_Profile>;
};

export type GqlOrders_Customer_Emails = {
  __typename?: 'Orders_customer_emails';
  address?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type GqlOrders_Customer_Profile = {
  __typename?: 'Orders_customer_profile';
  address?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  cart?: Maybe<GqlOrders_Customer_Profile_Cart>;
  coords?: Maybe<Array<Maybe<Scalars['Float']>>>;
  driversLicense?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptIn?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  linx?: Maybe<GqlOrders_Customer_Profile_Linx>;
  medicalCard?: Maybe<GqlOrders_MedicalCard>;
  phone?: Maybe<Scalars['String']>;
  photoId?: Maybe<Scalars['String']>;
  textNotifications?: Maybe<Scalars['Boolean']>;
};

export type GqlOrders_Customer_Profile_Cart = {
  __typename?: 'Orders_customer_profile_cart';
  orderItems?: Maybe<Array<Maybe<GqlOrders_Customer_Profile_Cart_OrderItems>>>;
};

export type GqlOrders_Customer_Profile_Cart_OrderItems = {
  __typename?: 'Orders_customer_profile_cart_orderItems';
  additionalOption?: Maybe<Scalars['String']>;
  itemName?: Maybe<Scalars['String']>;
  option?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  rawOption?: Maybe<Scalars['String']>;
};

export type GqlOrders_Customer_Profile_Linx = {
  __typename?: 'Orders_customer_profile_linx';
  license?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type GqlOrders_DeliveryInfo = {
  __typename?: 'Orders_deliveryInfo';
  address?: Maybe<Scalars['String']>;
  apartmentNum?: Maybe<Scalars['String']>;
  deliveryAddress?: Maybe<Scalars['String']>;
  deliveryOption?: Maybe<Scalars['Boolean']>;
  lastSearchedAddress?: Maybe<Scalars['String']>;
  location?: Maybe<GqlOrders_Location>;
  nonDeliveryAddress?: Maybe<Scalars['String']>;
};

export type GqlOrders_Dispensary = {
  __typename?: 'Orders_dispensary';
  _id?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  aeropay?: Maybe<Scalars['Boolean']>;
  alt36?: Maybe<Scalars['Boolean']>;
  cName?: Maybe<Scalars['String']>;
  canPay?: Maybe<Scalars['Boolean']>;
  chain?: Maybe<Scalars['String']>;
  check?: Maybe<Scalars['Boolean']>;
  creditCardAtDoor?: Maybe<Scalars['Boolean']>;
  creditCardByPhone?: Maybe<Scalars['Boolean']>;
  customDomainSettings?: Maybe<GqlDispensaries_Profile_CustomDomain_Settings>;
  debitOnly?: Maybe<Scalars['Boolean']>;
  deliveryHours?: Maybe<GqlDispensaries_Profile_Hours>;
  deliveryMin?: Maybe<Scalars['String']>;
  featureFlags?: Maybe<GqlDispensaries_FeatureFlags>;
  feeTiers?: Maybe<Array<Maybe<GqlDispensaries_Profile_FeeTiers>>>;
  linx?: Maybe<Scalars['Boolean']>;
  logoImage?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  offerDelivery?: Maybe<Scalars['Boolean']>;
  ordersConfig?: Maybe<GqlDispensaries_OrdersConfig>;
  /** @deprecated legacy payment option */
  payInStore?: Maybe<Scalars['Boolean']>;
  payOnlineHypur?: Maybe<Scalars['Boolean']>;
  payOnlineMerrco?: Maybe<Scalars['Boolean']>;
  paytender?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  pickupHours?: Maybe<GqlDispensaries_Profile_Hours>;
  plusSettings?: Maybe<GqlDispensaries_Profile_Plus_Settings>;
  timezone?: Maybe<Scalars['String']>;
};

export type GqlOrders_FleetManagementTask = {
  __typename?: 'Orders_fleetManagementTask';
  adapter?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  timeCreated?: Maybe<Scalars['String']>;
  timeLastModified?: Maybe<Scalars['String']>;
  trackingURL?: Maybe<Scalars['String']>;
};

export type GqlOrders_GuestCustomer = {
  __typename?: 'Orders_guestCustomer';
  birthDay?: Maybe<Scalars['String']>;
  birthMonth?: Maybe<Scalars['String']>;
  birthYear?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photoId?: Maybe<Scalars['String']>;
};

export type GqlOrders_Linx = {
  __typename?: 'Orders_linx';
  license?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type GqlOrders_Location = {
  __typename?: 'Orders_location';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  ln1?: Maybe<Scalars['String']>;
  ln2?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type GqlOrders_ManualDiscount = {
  __typename?: 'Orders_manualDiscount';
  fixedDiscountInCents?: Maybe<Scalars['Int']>;
  percentDiscount?: Maybe<Scalars['Int']>;
};

export type GqlOrders_MedicalCard = {
  __typename?: 'Orders_medicalCard';
  expirationDate?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type GqlOrders_Order = {
  __typename?: 'Orders_order';
  additionalOption?: Maybe<Scalars['String']>;
  basePrice?: Maybe<Scalars['Float']>;
  option?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  product?: Maybe<GqlOrder_Product>;
  quantity?: Maybe<Scalars['Int']>;
  rawOption?: Maybe<Scalars['String']>;
};

export type GqlOrders_TipValue = {
  __typename?: 'Orders_tipValue';
  dollar?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
};

export type GqlParseAchReturnFileUploadResponse = {
  __typename?: 'ParseAchReturnFileUploadResponse';
  data: Array<GqlAchReturnFileUploadResult>;
};

export type GqlPasswordUpdate = {
  __typename?: 'PasswordUpdate';
  accessToken: Scalars['String'];
};

export type GqlPayment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Int']>;
  checkoutToken?: Maybe<Scalars['String']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id?: Maybe<Scalars['String']>;
  payee?: Maybe<GqlEntity>;
  payer?: Maybe<GqlEntity>;
  paymentMethod?: Maybe<GqlDutchiePayPaymentMethod>;
  status?: Maybe<Scalars['String']>;
};

export type GqlPaymentCard = {
  __typename?: 'PaymentCard';
  brand?: Maybe<Scalars['String']>;
  lastDigits?: Maybe<Scalars['String']>;
};

export type GqlPaymentDetails = {
  __typename?: 'PaymentDetails';
  card: GqlPaymentCard;
  id: Scalars['String'];
  status: Scalars['String'];
  transactionNumber: Scalars['String'];
};

export type GqlPaymentInfoInput = {
  accountId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

export type GqlPaymentMethod = {
  __typename?: 'PaymentMethod';
  bankAccount?: Maybe<GqlBankDetails>;
  billingAddress?: Maybe<GqlBillingAddress>;
  createdAt?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GqlPaymentMethodInput = {
  paymentInfo: GqlPaymentInfoInput;
  paymentType: PaymentType;
  period: PaymentPeriod;
};

export enum PaymentPeriod {
  annually = 'annually',
  monthly = 'monthly',
  quarterly = 'quarterly'
}

export type GqlPaymentRestrictions = {
  __typename?: 'PaymentRestrictions';
  payByBankSignupIncentive?: Maybe<Scalars['Boolean']>;
};

export type GqlPaymentRestrictionsInput = {
  payByBankSignupIncentive?: InputMaybe<Scalars['Boolean']>;
};

export enum PaymentStatus {
  paymentStatusAuthorized = 'PAYMENT_STATUS_AUTHORIZED',
  paymentStatusAuthorizing = 'PAYMENT_STATUS_AUTHORIZING',
  paymentStatusCancelled = 'PAYMENT_STATUS_CANCELLED',
  paymentStatusCancelling = 'PAYMENT_STATUS_CANCELLING',
  paymentStatusCaptured = 'PAYMENT_STATUS_CAPTURED',
  paymentStatusCapturing = 'PAYMENT_STATUS_CAPTURING',
  paymentStatusDeclined = 'PAYMENT_STATUS_DECLINED',
  paymentStatusFailed = 'PAYMENT_STATUS_FAILED',
  paymentStatusFinalized = 'PAYMENT_STATUS_FINALIZED',
  paymentStatusFinalizing = 'PAYMENT_STATUS_FINALIZING',
  paymentStatusNew = 'PAYMENT_STATUS_NEW',
  paymentStatusRefunded = 'PAYMENT_STATUS_REFUNDED',
  paymentStatusRefunding = 'PAYMENT_STATUS_REFUNDING',
  paymentStatusRefundPending = 'PAYMENT_STATUS_REFUND_PENDING',
  paymentStatusUnspecified = 'PAYMENT_STATUS_UNSPECIFIED'
}

export enum PaymentType {
  bankAccount = 'bankAccount',
  creditCard = 'creditCard',
  manualPayments = 'manualPayments'
}

export type GqlPaymentTypeConfig = {
  __typename?: 'PaymentTypeConfig';
  enabled?: Maybe<Scalars['Boolean']>;
  orderTypes?: Maybe<GqlPaymentsOrderTypes>;
  type?: Maybe<PaymentsPaymentType>;
};

export type GqlPaymentTypesConfig = {
  __typename?: 'PaymentTypesConfig';
  aeropay?: Maybe<Scalars['Boolean']>;
  alt36?: Maybe<Scalars['Boolean']>;
  canPay?: Maybe<Scalars['Boolean']>;
  cash?: Maybe<Scalars['Boolean']>;
  check?: Maybe<Scalars['Boolean']>;
  creditCardAtDoor?: Maybe<Scalars['Boolean']>;
  creditCardByPhone?: Maybe<Scalars['Boolean']>;
  debit?: Maybe<Scalars['Boolean']>;
  dutchiePay?: Maybe<Scalars['Boolean']>;
  linx?: Maybe<Scalars['Boolean']>;
  payOnlineChase?: Maybe<Scalars['Boolean']>;
  payOnlineHypur?: Maybe<Scalars['Boolean']>;
  payOnlineMerrco?: Maybe<Scalars['Boolean']>;
  payOnlineMoneris?: Maybe<Scalars['Boolean']>;
  paytender?: Maybe<Scalars['Boolean']>;
  rethinkPay?: Maybe<Scalars['Boolean']>;
};

export type GqlPaymentsCheckoutCredentials = GqlChaseHostedProfileCredentials | GqlMonerisHtProfileCredentials;

export type GqlPaymentsIsoDate = {
  nanos?: InputMaybe<Scalars['Int']>;
  seconds?: InputMaybe<Scalars['Int']>;
};

export type GqlPaymentsOrderTypes = {
  __typename?: 'PaymentsOrderTypes';
  curbsidePickup?: Maybe<Scalars['Boolean']>;
  delivery?: Maybe<Scalars['Boolean']>;
  driveThruPickup?: Maybe<Scalars['Boolean']>;
  pickup?: Maybe<Scalars['Boolean']>;
};

export enum PaymentsPaymentType {
  paymentTypeDutchiePay = 'PAYMENT_TYPE_DUTCHIE_PAY',
  paymentTypeRethink = 'PAYMENT_TYPE_RETHINK',
  paymentTypeUnspecified = 'PAYMENT_TYPE_UNSPECIFIED'
}

export type GqlPaysafeAuthorizations = {
  __typename?: 'PaysafeAuthorizations';
  amount?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type GqlPaysafeCard = {
  __typename?: 'PaysafeCard';
  lastDigits?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GqlPaysafeDetails = {
  __typename?: 'PaysafeDetails';
  authorizations?: Maybe<Array<Maybe<GqlPaysafeAuthorizations>>>;
  card?: Maybe<GqlPaysafeCard>;
  refunds?: Maybe<Array<Maybe<GqlPaysafeRefunds>>>;
  settlements?: Maybe<Array<Maybe<GqlPaysafeSettlements>>>;
};

export type GqlPaysafeRefunds = {
  __typename?: 'PaysafeRefunds';
  amount?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type GqlPaysafeSettlements = {
  __typename?: 'PaysafeSettlements';
  amount?: Maybe<Scalars['String']>;
  cancelled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
};

export type GqlPendingDispensariesResult = {
  __typename?: 'PendingDispensariesResult';
  dispensaries?: Maybe<Array<Maybe<GqlDispensaries>>>;
  meta?: Maybe<GqlMeta>;
};

export type GqlPersistCheckoutResponse = {
  __typename?: 'PersistCheckoutResponse';
  checkoutToken: Scalars['String'];
};

export type GqlPersonalizationSettings = {
  __typename?: 'PersonalizationSettings';
  enablePersonalizationForDefault?: Maybe<Scalars['Boolean']>;
  enablePersonalizationForEmbedded?: Maybe<Scalars['Boolean']>;
  enablePersonalizationForKiosk?: Maybe<Scalars['Boolean']>;
  enablePersonalizationForStoreFront?: Maybe<Scalars['Boolean']>;
};

export type GqlPersonalizedProducts = {
  __typename?: 'PersonalizedProducts';
  products: Array<GqlProducts>;
};

export type GqlPersonalizedProductsFilter = {
  category?: InputMaybe<Scalars['String']>;
  menuType: ProductMenuTypes;
};

export type GqlPersonalizedProductsFilterV2 = {
  category?: InputMaybe<Scalars['String']>;
  menuType: ProductMenuTypes;
  menuVariant?: InputMaybe<Scalars['String']>;
};

export enum PersonalizedProductsModelNames {
  cartToppers = 'cart_toppers',
  oftenBoughtWith = 'often_bought_with',
  recommendedForYou = 'recommended_for_you',
  relatedItems = 'related_items'
}

export type GqlPickupMinimum = {
  __typename?: 'PickupMinimum';
  enabled?: Maybe<Scalars['Boolean']>;
  minimumInCents?: Maybe<Scalars['Int']>;
};

export type GqlPickupMinimumInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  minimumInCents?: InputMaybe<Scalars['Int']>;
};

export type GqlPickupReminders = {
  __typename?: 'PickupReminders';
  enabled?: Maybe<Scalars['Boolean']>;
  reminderMessage?: Maybe<Scalars['String']>;
  reminderMinutesAfterReady?: Maybe<Scalars['Int']>;
};

export type GqlPickupRemindersInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  reminderMessage?: InputMaybe<Scalars['String']>;
  reminderMinutesAfterReady?: InputMaybe<Scalars['Int']>;
};

export type GqlPipelineProperties = {
  __typename?: 'PipelineProperties';
  pipelines?: Maybe<Array<Maybe<GqlPipelinePropertyTypes>>>;
};

export type GqlPipelinePropertyTypes = {
  __typename?: 'PipelinePropertyTypes';
  id?: Maybe<Scalars['String']>;
  stages?: Maybe<Array<Maybe<GqlPipelineStageProperty>>>;
  value?: Maybe<Scalars['String']>;
};

export type GqlPipelineStageProperty = {
  __typename?: 'PipelineStageProperty';
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlPlaidLinkAccounts = {
  id: Scalars['String'];
  mask?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  subtype?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type GqlPlaidLinkInstitution = {
  institutionId: Scalars['String'];
  name: Scalars['String'];
};

export type GqlPlaidLinkMetadata = {
  accounts: Array<InputMaybe<GqlPlaidLinkAccounts>>;
  institution: GqlPlaidLinkInstitution;
  linkSessionId?: InputMaybe<Scalars['String']>;
};

export type GqlPlaidLinkStart = {
  __typename?: 'PlaidLinkStart';
  linkToken: Scalars['String'];
};

export enum PlatformType {
  kiosk = 'KIOSK',
  mobile = 'MOBILE',
  onlineMenu = 'ONLINE_MENU'
}

export type GqlPlusApiKey = {
  __typename?: 'PlusApiKey';
  createdAt: Scalars['ISODateTime'];
  fresh: Scalars['Boolean'];
  id: Scalars['ID'];
  key: Scalars['String'];
  keyType: PlusApiKeyType;
  lastRequestAt?: Maybe<Scalars['ISODateTime']>;
};

export enum PlusApiKeyType {
  public = 'PUBLIC',
  secret = 'SECRET'
}

export type GqlPlusOAuthProvider = {
  __typename?: 'PlusOAuthProvider';
  authorizationUrl: Scalars['String'];
  clientId: Scalars['String'];
  enterpriseId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  site: Scalars['String'];
  tokenUrl: Scalars['String'];
  userInfoUrl: Scalars['String'];
};

export type GqlPlusOAuthProviderInput = {
  authorizationUrl: Scalars['String'];
  brandLogo?: InputMaybe<Scalars['String']>;
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  name: Scalars['String'];
  site: Scalars['String'];
  tokenUrl: Scalars['String'];
  userInfoUrl: Scalars['String'];
};

export type GqlPolygon = {
  __typename?: 'Polygon';
  features?: Maybe<Array<Maybe<GqlGeoJson_Features>>>;
  type?: Maybe<Scalars['String']>;
};

export type GqlPolygonInput = {
  features?: InputMaybe<Array<InputMaybe<GqlGeoJson_FeaturesInput>>>;
  type?: InputMaybe<Scalars['String']>;
};

export type GqlPopularDispensary = {
  __typename?: 'PopularDispensary';
  actionEstimates?: Maybe<GqlActionEstimates>;
  cName?: Maybe<Scalars['String']>;
  /** @deprecated covered by DeliveryOrderingSettings in ordering-settings */
  deliveryArea?: Maybe<GqlPolygon>;
  /** @deprecated used and defined in ordering-settings */
  deliveryFee?: Maybe<Scalars['String']>;
  /** @deprecated defined within hours-settings */
  deliveryHours?: Maybe<GqlDispensaries_Profile_Hours>;
  deliveryInfo?: Maybe<GqlDispensaries_DeliveryInfo>;
  /** @deprecated used and defined in ordering-settings */
  deliveryMin?: Maybe<Scalars['String']>;
  /** @deprecated used and defined in ordering-settings */
  deliveryMode?: Maybe<DeliveryModes>;
  distance?: Maybe<Scalars['String']>;
  featureFlags?: Maybe<GqlDispensaries_FeatureFlags>;
  feeTiers?: Maybe<Array<Maybe<GqlDispensaries_Profile_FeeTiers>>>;
  hoursSettings?: Maybe<GqlDispensaryHoursSettings>;
  id?: Maybe<Scalars['String']>;
  listImage?: Maybe<Scalars['String']>;
  location?: Maybe<GqlDispensaries_Profile_Location>;
  /** @deprecated used and defined in ordering-settings */
  maxDeliveryDistance?: Maybe<Scalars['Int']>;
  medicalDispensary?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  /** @deprecated use OrderTypesConfigV2 */
  orderTypesConfig?: Maybe<GqlOrderTypesConfig>;
  orderTypesConfigV2?: Maybe<GqlOrderTypesConfigV2>;
  /** @deprecated defined in hours-settings */
  pickupHours?: Maybe<GqlDispensaries_Profile_Hours>;
  recDispensary?: Maybe<Scalars['Boolean']>;
  /** @deprecated defined within HoursSettingsForOrderType in ordering-settings */
  specialHours?: Maybe<Array<Maybe<GqlSpecialHours>>>;
  storeSettings?: Maybe<GqlDispensaries_StoreSettings>;
  timezone?: Maybe<Scalars['String']>;
};

export type GqlPosMedCardInfo = {
  __typename?: 'PosMedCardInfo';
  expirationDate?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  valid?: Maybe<Scalars['Boolean']>;
};

/** Chemical compound for a Potency -- THC, CBD, and so forth */
export enum PotencyCompound {
  cbd = 'CBD',
  thc = 'THC'
}

/**
 * Search parameters for a Product's Potency. Allows for more complex
 * searching of products based on a Potency range
 */
export type GqlPotencyProductSearch = {
  /** Deprecated: Remove with ticket ENG-14662 */
  compound: PotencyCompound;
  max: Scalars['Float'];
  min: Scalars['Float'];
  unit: PotencyUnit;
};

export type GqlPotencyRange = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export enum PotencyType {
  equalTo = 'equalTo',
  greaterThan = 'greaterThan',
  greaterThanEqualTo = 'greaterThanEqualTo',
  lessThan = 'lessThan',
  lessThanEqualTo = 'lessThanEqualTo',
  notApplicable = 'notApplicable'
}

export enum PotencyUnit {
  milligrams = 'MILLIGRAMS',
  milligramsPerGram = 'MILLIGRAMS_PER_GRAM',
  milligramsPerMl = 'MILLIGRAMS_PER_ML',
  percentage = 'PERCENTAGE'
}

export enum PreOrderType {
  curbside = 'CURBSIDE',
  delivery = 'DELIVERY',
  driveThru = 'DRIVE_THRU',
  kiosk = 'KIOSK',
  pickup = 'PICKUP'
}

export type GqlPreviewMongoProduct = {
  __typename?: 'PreviewMongoProduct';
  _id?: Maybe<Scalars['String']>;
  additionalOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  bottleDepositTaxCents?: Maybe<Scalars['Int']>;
  brand?: Maybe<GqlBrand>;
  brandDescription?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['String']>;
  brandLogo?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  cName?: Maybe<Scalars['String']>;
  cbdContent?: Maybe<GqlProductPotency>;
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['String']>;
  dispensary?: Maybe<GqlDispensaries>;
  dispensaryId?: Maybe<Scalars['String']>;
  dispensaryName?: Maybe<Scalars['String']>;
  duplicatedProductId?: Maybe<Scalars['String']>;
  effects?: Maybe<Scalars['JSON']>;
  featured?: Maybe<GqlProducts_Featured>;
  forcedPotencyUnit?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  imgixSettings?: Maybe<GqlProducts_ImgixSettings>;
  integrationKey?: Maybe<Scalars['String']>;
  isBelowKioskThreshold?: Maybe<Scalars['Boolean']>;
  isBelowThreshold?: Maybe<Scalars['Boolean']>;
  limitsPerCustomer?: Maybe<Array<Maybe<GqlProducts_LimitPerCustomer>>>;
  manualInventory?: Maybe<Array<Maybe<GqlProducts_ManualInventory>>>;
  matchedLibraryItems?: Maybe<Array<Maybe<GqlProducts_MatchedLibraryItems>>>;
  matchedLibraryItemsConfidence?: Maybe<Scalars['Float']>;
  measurements?: Maybe<GqlProducts_Measurements>;
  medicalOnly?: Maybe<Scalars['Boolean']>;
  medicalPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  medicalSpecialPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  modifiedAttributes?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  nonArmsLength?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
  optionsBelowKioskThreshold?: Maybe<Array<Maybe<Scalars['String']>>>;
  optionsBelowThreshold?: Maybe<Array<Maybe<Scalars['String']>>>;
  originalPrices?: Maybe<Array<Maybe<Scalars['String']>>>;
  overrides?: Maybe<Array<Maybe<Scalars['String']>>>;
  pastCNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  posMetaData?: Maybe<GqlProducts_PosMetaData>;
  preCropImage?: Maybe<Scalars['String']>;
  preTaxMedPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  preTaxRecPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  prices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  pricingTierData?: Maybe<GqlProducts_PricingTierData>;
  rawMedicalPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  rawOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  rawPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  recOnly?: Maybe<Scalars['Boolean']>;
  recPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  recSpecialPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  reviewedAt?: Maybe<Scalars['String']>;
  reviewedBy?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  /** @deprecated No longer reliable with menuType-specific specials 07/26/20 */
  special?: Maybe<Scalars['Boolean']>;
  specialData?: Maybe<GqlProducts_SpecialData>;
  speculativeEdits?: Maybe<Array<Maybe<GqlProducts>>>;
  status?: Maybe<Scalars['String']>;
  strain?: Maybe<GqlStrain>;
  strainType?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
  syncedAt?: Maybe<Scalars['String']>;
  thcContent?: Maybe<GqlProductPotency>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedByAdminAt?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Float']>;
  wholesalePrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type GqlPreviewProduct = {
  __typename?: 'PreviewProduct';
  appliedLibraryAttributes: GqlPreviewMongoProduct;
  product: GqlPreviewMongoProduct;
  productBatch?: Maybe<GqlProductBatch>;
  productImages: Array<Maybe<GqlProducts_Images>>;
  terpenes: Array<GqlProducts_Terpene>;
};

export type GqlPriceSummary = {
  __typename?: 'PriceSummary';
  discounts: Scalars['Int'];
  fees: Scalars['Int'];
  mixAndMatch: Scalars['Int'];
  rewards: Scalars['Int'];
  /** Total before taxes, fees, etc. */
  subtotal: Scalars['Int'];
  taxes: Scalars['Int'];
  /** Final total including taxes, fees, etc. */
  total: Scalars['Int'];
};

export enum PrintAction {
  confirm = 'confirm',
  reprint = 'reprint'
}

export type GqlPrintJob = {
  __typename?: 'PrintJob';
  _id: Scalars['String'];
  assignedToPrinterId?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISODateTime'];
  dispensaryId: Scalars['String'];
  printAfter: Scalars['ISODateTime'];
  referenceId: Scalars['String'];
  updatedAt: Scalars['ISODateTime'];
};

export type GqlPrintedMenuSettings_CategoryEntry = {
  __typename?: 'PrintedMenuSettings_CategoryEntry';
  category?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type GqlPrintedMenuSettings_CategoryEntryInput = {
  category?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type GqlPrintedMenuSettings_PageBreaks = {
  __typename?: 'PrintedMenuSettings_PageBreaks';
  enabled?: Maybe<Scalars['Boolean']>;
};

export type GqlPrintedMenuSettings_PageBreaksInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type GqlPrintedMenuSettings_Photos = {
  __typename?: 'PrintedMenuSettings_Photos';
  enabled?: Maybe<Scalars['Boolean']>;
};

export type GqlPrintedMenuSettings_PhotosInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type GqlPrintedMenuSettings_StrainTypesEntry = {
  __typename?: 'PrintedMenuSettings_StrainTypesEntry';
  backgroundColor?: Maybe<Scalars['String']>;
  borderColor?: Maybe<Scalars['String']>;
  strainType?: Maybe<Scalars['String']>;
};

export type GqlPrintedMenuSettings_StrainTypesEntryInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  borderColor?: InputMaybe<Scalars['String']>;
  strainType?: InputMaybe<Scalars['String']>;
};

export type GqlPrintedMenuSettings_Text = {
  __typename?: 'PrintedMenuSettings_Text';
  text?: Maybe<Scalars['String']>;
};

export type GqlPrintedMenuSettings_TextInput = {
  text?: InputMaybe<Scalars['String']>;
};

export type GqlPrintedMenuSettings_Type = {
  __typename?: 'PrintedMenuSettings_Type';
  type?: Maybe<Scalars['String']>;
};

export type GqlPrintedMenuSettings_TypeInput = {
  type?: InputMaybe<Scalars['String']>;
};

export type GqlPrinter = {
  __typename?: 'Printer';
  _id: Scalars['String'];
  adoptedAt?: Maybe<Scalars['ISODateTime']>;
  adoptedBy?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISODateTime'];
  deviceIdentifier: Scalars['String'];
  deviceType: Scalars['String'];
  dispensaryId: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  isRecentlyActive?: Maybe<Scalars['Boolean']>;
  lastError?: Maybe<Scalars['ISODateTime']>;
  lastJobId?: Maybe<Scalars['ISODateTime']>;
  lastPrintAt?: Maybe<Scalars['ISODateTime']>;
  lastSeenAt?: Maybe<Scalars['ISODateTime']>;
  name?: Maybe<Scalars['String']>;
  queueConfig?: Maybe<GqlPrinterQueueConfig>;
  status: Scalars['String'];
  updatedAt: Scalars['ISODateTime'];
};

export type GqlPrinterQueueConfig = {
  __typename?: 'PrinterQueueConfig';
  orderTypes: Array<Scalars['String']>;
};

export type GqlPrinterQueueConfigInput = {
  orderTypes: Array<Scalars['String']>;
};

export type GqlProductBatch = {
  __typename?: 'ProductBatch';
  active: Scalars['Boolean'];
  digest?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  productId: Scalars['String'];
};

/** Resulting type from getProductBuyingOptions call */
export type GqlProductBuyingOptionsResult = {
  __typename?: 'ProductBuyingOptionsResult';
  buyingOptions: Array<GqlBuyingOption>;
  marketplaceProduct: GqlMarketplaceProduct;
  weightOptions?: Maybe<Array<Scalars['String']>>;
};

export enum ProductCardButtonOption {
  solid = 'SOLID',
  tinted = 'TINTED'
}

export enum ProductCardDefaultViewOption {
  card = 'CARD',
  list = 'LIST'
}

export enum ProductCardTextAlignmentOption {
  center = 'CENTER',
  left = 'LEFT'
}

export type GqlProductCards = {
  __typename?: 'ProductCards';
  defaultViewLarge?: Maybe<ProductCardDefaultViewOption>;
  defaultViewSmall?: Maybe<ProductCardDefaultViewOption>;
  showProductWeight?: Maybe<Scalars['Boolean']>;
  textAlignment?: Maybe<ProductCardTextAlignmentOption>;
};

export type GqlProductCardsInput = {
  defaultViewLarge?: InputMaybe<ProductCardDefaultViewOption>;
  defaultViewSmall?: InputMaybe<ProductCardDefaultViewOption>;
  showProductWeight?: InputMaybe<Scalars['Boolean']>;
  textAlignment?: InputMaybe<ProductCardTextAlignmentOption>;
};

/** A Product's Category */
export enum ProductCategory {
  accessories = 'ACCESSORIES',
  allCategories = 'ALL_CATEGORIES',
  apparel = 'APPAREL',
  cbd = 'CBD',
  clones = 'CLONES',
  concentrate = 'CONCENTRATE',
  edible = 'EDIBLE',
  flower = 'FLOWER',
  hide = 'HIDE',
  nA = 'N_A',
  preRolls = 'PRE_ROLLS',
  seeds = 'SEEDS',
  tincture = 'TINCTURE',
  topicals = 'TOPICALS',
  vaporizers = 'VAPORIZERS'
}

export type GqlProductChangeEvent = {
  __typename?: 'ProductChangeEvent';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['ID']>;
  createdByUser?: Maybe<GqlUsers>;
  event: ProductChangeEventType;
  id?: Maybe<Scalars['ID']>;
  metadata?: Maybe<Scalars['JSON']>;
  newValues?: Maybe<Scalars['JSON']>;
  oldValues?: Maybe<Scalars['JSON']>;
  productId: Scalars['ID'];
  versionId?: Maybe<Scalars['ID']>;
};

export enum ProductChangeEventType {
  contentTeamCreate = 'content_team_create',
  contentTeamUpdate = 'content_team_update',
  distributedMatchLibrary = 'distributed_match_library',
  engineeringMaintenance = 'engineering_maintenance',
  inventoryUpdate = 'inventory_update',
  libraryConnection = 'library_connection',
  libraryUpdate = 'library_update',
  matchingBrand = 'matching_brand',
  matchingConcentrations = 'matching_concentrations',
  matchingLibrary = 'matching_library',
  matchingStrain = 'matching_strain',
  menuSyncArchive = 'menu_sync_archive',
  menuSyncInsert = 'menu_sync_insert',
  menuSyncUpdate = 'menu_sync_update',
  retailerAdminCreate = 'retailer_admin_create',
  retailerAdminUpdate = 'retailer_admin_update'
}

export type GqlProductChangeRequest = {
  __typename?: 'ProductChangeRequest';
  actionType: ChangeRequestActionType;
  approvalStatus: Scalars['String'];
  approvedAt?: Maybe<Scalars['ISODateTime']>;
  authorId: Scalars['ID'];
  brand?: Maybe<GqlBrand>;
  brandId: Scalars['ID'];
  complianceRegionId?: Maybe<Scalars['ID']>;
  contentAttributes: GqlLibraryProduct;
  createdAt: Scalars['ISODateTime'];
  feedback?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  productId: Scalars['ID'];
  rejectedAt?: Maybe<Scalars['ISODateTime']>;
  rejectionReasons?: Maybe<Array<RejectionReasons>>;
  reviewerId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['ISODateTime'];
};

/** A type that indicates medical or recreational products only */
export enum ProductConsumerType {
  med = 'MED',
  rec = 'REC'
}

export type GqlProductCrmProperty = GqlCrmProperty & {
  __typename?: 'ProductCrmProperty';
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlProductDemandCount = {
  __typename?: 'ProductDemandCount';
  count: Scalars['Int'];
  id: Scalars['String'];
};

export type GqlProductDiscount = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type GqlProductEffect = {
  __typename?: 'ProductEffect';
  name: Scalars['String'];
  power: Scalars['Int'];
};

export type GqlProductFilters = {
  __typename?: 'ProductFilters';
  chainDropdownOptions?: Maybe<Array<Maybe<GqlChainDropdownOption>>>;
  dispensaryDropdownOptions: Array<Maybe<GqlDispensaryDropdownOption>>;
  statesDropdownOptions: Array<Maybe<GqlDropdownOption>>;
};

export enum ProductGroup {
  all = 'all',
  brand = 'brand',
  brands = 'brands',
  categories = 'categories',
  category = 'category',
  individual = 'individual',
  inventoryTags = 'inventory_tags',
  productTags = 'product_tags',
  strains = 'strains',
  vendors = 'vendors'
}

export type GqlProductImpactResponse = {
  __typename?: 'ProductImpactResponse';
  count?: Maybe<Scalars['Int']>;
};

export type GqlProductInsightsFilterInput = {
  inventoryLevel?: InputMaybe<InventoryLevelEnum>;
};

export enum ProductMenuTypes {
  med = 'med',
  rec = 'rec'
}

export type GqlProductPotency = {
  __typename?: 'ProductPotency';
  range?: Maybe<Array<Maybe<Scalars['Float']>>>;
  unit: Scalars['String'];
  /** @deprecated Use range */
  value?: Maybe<Scalars['String']>;
};

/** How much a product is listed for at a Dispensary */
export type GqlProductPrice = {
  __typename?: 'ProductPrice';
  amount: Scalars['Float'];
  salesAmount?: Maybe<Scalars['Float']>;
};

export type GqlProductRecommendation = {
  __typename?: 'ProductRecommendation';
  clickUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  impressionUrl?: Maybe<Scalars['String']>;
};

export type GqlProductRecommendations = {
  __typename?: 'ProductRecommendations';
  adapter?: Maybe<Scalars['String']>;
  products: Array<GqlProductRecommendation>;
};

export type GqlProductSummary = {
  __typename?: 'ProductSummary';
  brandId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  dispensaryId?: Maybe<Scalars['String']>;
  dollarChange?: Maybe<Scalars['Float']>;
  numSold?: Maybe<Scalars['Int']>;
  percentChange?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  sales?: Maybe<Scalars['Float']>;
  strainType?: Maybe<Scalars['String']>;
};

export type GqlProductTag = {
  __typename?: 'ProductTag';
  tagId?: Maybe<Scalars['String']>;
  tagName?: Maybe<Scalars['String']>;
};

export type GqlProductTags = {
  __typename?: 'ProductTags';
  inventoryTags?: Maybe<Array<Maybe<GqlProductTag>>>;
  productTags?: Maybe<Array<Maybe<GqlProductTag>>>;
};

export type GqlProducts = {
  __typename?: 'Products';
  AdditionalOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated Standardize onto CBDContent 12/19/19 */
  CBD?: Maybe<Scalars['String']>;
  CBDContent?: Maybe<GqlProductPotency>;
  Description?: Maybe<Scalars['String']>;
  DispensaryID?: Maybe<Scalars['String']>;
  Image?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Options?: Maybe<Array<Maybe<Scalars['String']>>>;
  POSMetaData?: Maybe<GqlProducts_PosMetaData>;
  Prices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  Status?: Maybe<Scalars['String']>;
  /** @deprecated Standardize onto THCContent 12/19/19 */
  THC?: Maybe<Scalars['String']>;
  THCContent?: Maybe<GqlProductPotency>;
  _id?: Maybe<Scalars['String']>;
  adTrackers?: Maybe<GqlAdTrackers>;
  adminEdits?: Maybe<Array<Maybe<GqlProducts_AdminEdit>>>;
  bottleDepositTaxCents?: Maybe<Scalars['Int']>;
  brand?: Maybe<GqlBrand>;
  brandDescription?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['String']>;
  brandLogo?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  cName?: Maybe<Scalars['String']>;
  cannabinoidsV2?: Maybe<Array<Maybe<GqlProducts_CannabinoidV2>>>;
  cbdContent?: Maybe<GqlProductPotency>;
  certificateOfAnalysisEnabled?: Maybe<Scalars['Boolean']>;
  collectionCardBadge?: Maybe<GqlCollectionCardBadge>;
  collections?: Maybe<Array<Maybe<GqlProducts_Collection>>>;
  comingSoon?: Maybe<Scalars['Boolean']>;
  connectedAt?: Maybe<Scalars['String']>;
  connectedBy?: Maybe<Scalars['String']>;
  connectedByUser?: Maybe<GqlUsers>;
  connectedCount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['String']>;
  dispensary?: Maybe<GqlDispensaries>;
  dispensaryId?: Maybe<Scalars['String']>;
  dispensaryName?: Maybe<Scalars['String']>;
  duplicatedProductId?: Maybe<Scalars['String']>;
  effects?: Maybe<Scalars['JSON']>;
  enterpriseProductId?: Maybe<Scalars['String']>;
  featured?: Maybe<GqlProducts_Featured>;
  forcedPotencyUnit?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  images?: Maybe<Array<GqlProducts_Images>>;
  imgixSettings?: Maybe<GqlProducts_ImgixSettings>;
  integrationKey?: Maybe<Scalars['String']>;
  isBelowKioskThreshold?: Maybe<Scalars['Boolean']>;
  isBelowThreshold?: Maybe<Scalars['Boolean']>;
  libraryProduct?: Maybe<GqlLibraryProduct>;
  libraryProductId?: Maybe<Scalars['String']>;
  libraryProductScore?: Maybe<Scalars['Float']>;
  limitsPerCustomer?: Maybe<Array<Maybe<GqlProducts_LimitPerCustomer>>>;
  manualInventory?: Maybe<Array<Maybe<GqlProducts_ManualInventory>>>;
  matchedLibraryItems?: Maybe<Array<Maybe<GqlProducts_MatchedLibraryItems>>>;
  matchedLibraryItemsConfidence?: Maybe<Scalars['Float']>;
  measurements?: Maybe<GqlProducts_Measurements>;
  medicalOnly?: Maybe<Scalars['Boolean']>;
  medicalPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  medicalSpecialPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  name?: Maybe<Scalars['String']>;
  nonArmsLength?: Maybe<Scalars['Boolean']>;
  optionsBelowKioskThreshold?: Maybe<Array<Maybe<Scalars['String']>>>;
  optionsBelowThreshold?: Maybe<Array<Maybe<Scalars['String']>>>;
  originalPrices?: Maybe<Array<Maybe<Scalars['String']>>>;
  overrides?: Maybe<Array<Maybe<Scalars['String']>>>;
  pastCNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated Removed. Server side only field. 6/2/21 */
  popularSortKey?: Maybe<Scalars['Float']>;
  posMetaData?: Maybe<GqlProducts_PosMetaData>;
  preCropImage?: Maybe<Scalars['String']>;
  preTaxMedPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  preTaxRecPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  prices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  pricingTierData?: Maybe<GqlProducts_PricingTierData>;
  productTemplate?: Maybe<Scalars['Boolean']>;
  provider?: Maybe<ProductsProvider>;
  rawMedicalPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  rawOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  rawPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  recOnly?: Maybe<Scalars['Boolean']>;
  recPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  recSpecialPrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  reviewedAt?: Maybe<Scalars['String']>;
  reviewedBy?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  /** @deprecated No longer reliable with menuType-specific specials 07/26/20 */
  special?: Maybe<Scalars['Boolean']>;
  specialData?: Maybe<GqlProducts_SpecialData>;
  specialIdsPerOption?: Maybe<Array<Maybe<GqlProducts_SpecialIdsPerOption>>>;
  speculativeEdits?: Maybe<Array<Maybe<GqlProducts>>>;
  stockImage?: Maybe<Scalars['String']>;
  stockImageAliases?: Maybe<Scalars['String']>;
  stockImageCategory?: Maybe<Scalars['String']>;
  strain?: Maybe<GqlStrain>;
  strainType?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
  syncedAt?: Maybe<Scalars['String']>;
  terpenes?: Maybe<Array<Maybe<GqlProducts_Terpene>>>;
  thcContent?: Maybe<GqlProductPotency>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedByAdminAt?: Maybe<Scalars['String']>;
  updatedByUser?: Maybe<GqlUsers>;
  /** @deprecated No longer needed. 09/02/25 */
  useBetterPotencyTaxes?: Maybe<Scalars['Boolean']>;
  vapeTaxApplicable?: Maybe<Scalars['Boolean']>;
  weight?: Maybe<Scalars['Float']>;
  wholesalePrices?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type GqlProductsList = {
  __typename?: 'ProductsList';
  /** @deprecated Use menu filters instead 8/3/23 */
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  products: Array<Maybe<GqlProducts>>;
  queryInfo: GqlQueryInfoType;
};

export type GqlProductsPagination = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum ProductsProvider {
  crossingMinds = 'crossingMinds',
  dutchie = 'dutchie',
  moloco = 'moloco'
}

export type GqlProductsSalesByCategory = {
  __typename?: 'ProductsSalesByCategory';
  categoryOptions?: Maybe<Array<Maybe<GqlDropdownOption>>>;
  lineItems?: Maybe<Array<Maybe<GqlCategoryLineItem>>>;
  totalSales?: Maybe<Scalars['Float']>;
};

export type GqlProductsSummaryInput = {
  brand?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  chainId?: InputMaybe<Scalars['String']>;
  clientTimezone?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  increment?: InputMaybe<Scalars['String']>;
  prevEndDate?: InputMaybe<Scalars['String']>;
  prevStartDate?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  strain?: InputMaybe<Scalars['String']>;
};

export type GqlProducts_CannabinoidInputV2 = {
  active?: InputMaybe<Scalars['Boolean']>;
  cannabinoidId?: InputMaybe<Scalars['ID']>;
  unit?: InputMaybe<PotencyUnit>;
  value?: InputMaybe<Scalars['Float']>;
};

export type GqlProducts_CannabinoidV2 = {
  __typename?: 'Products_CannabinoidV2';
  active?: Maybe<Scalars['Boolean']>;
  cannabinoid?: Maybe<GqlCannabinoid>;
  cannabinoidId?: Maybe<Scalars['ID']>;
  unit?: Maybe<PotencyUnit>;
  value?: Maybe<Scalars['Float']>;
};

export type GqlProducts_Collection = {
  __typename?: 'Products_Collection';
  id?: Maybe<Scalars['String']>;
};

export type GqlProducts_Images = {
  __typename?: 'Products_Images';
  _id?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  canonicalUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  description?: Maybe<Scalars['String']>;
  digest?: Maybe<Scalars['String']>;
  etag?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  origin: ImageOrigin;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
  url: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
};

export type GqlProducts_ImagesInput = {
  _id?: InputMaybe<Scalars['String']>;
  active: Scalars['Boolean'];
  createdAt?: InputMaybe<Scalars['ISODateTime']>;
  description?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  origin: ImageOrigin;
  updatedAt?: InputMaybe<Scalars['ISODateTime']>;
  url: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type GqlProducts_PosMetaData = {
  __typename?: 'Products_POSMetaData';
  activeBatchTags?: Maybe<Array<Maybe<GqlTag>>>;
  canonicalBrandId?: Maybe<Scalars['String']>;
  canonicalBrandName?: Maybe<Scalars['String']>;
  canonicalCategory?: Maybe<Scalars['String']>;
  canonicalCategoryId?: Maybe<Scalars['String']>;
  canonicalID?: Maybe<Scalars['String']>;
  canonicalImgUrl?: Maybe<Scalars['String']>;
  canonicalLabResultUrl?: Maybe<Scalars['String']>;
  canonicalName?: Maybe<Scalars['String']>;
  canonicalPackageId?: Maybe<Scalars['String']>;
  canonicalProductTags?: Maybe<Array<Maybe<GqlTag>>>;
  canonicalSKU?: Maybe<Scalars['String']>;
  canonicalStrainId?: Maybe<Scalars['String']>;
  canonicalVendorId?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<GqlProducts_PosMetaData_Children>>>;
  integrationID?: Maybe<Scalars['String']>;
};

export type GqlProducts_PosMetaData_Children = {
  __typename?: 'Products_POSMetaData_children';
  activeBatchTags?: Maybe<Array<Maybe<GqlTag>>>;
  canonicalBrandId?: Maybe<Scalars['String']>;
  canonicalBrandName?: Maybe<Scalars['String']>;
  canonicalCategory?: Maybe<Scalars['String']>;
  canonicalCategoryId?: Maybe<Scalars['String']>;
  canonicalEffectivePotencyMg?: Maybe<Scalars['Float']>;
  canonicalID?: Maybe<Scalars['String']>;
  canonicalImgUrl?: Maybe<Scalars['String']>;
  canonicalLabResultUrl?: Maybe<Scalars['String']>;
  canonicalName?: Maybe<Scalars['String']>;
  canonicalPackageId?: Maybe<Scalars['String']>;
  canonicalProductTags?: Maybe<Array<Maybe<GqlTag>>>;
  canonicalSKU?: Maybe<Scalars['String']>;
  canonicalStrainId?: Maybe<Scalars['String']>;
  canonicalVendorId?: Maybe<Scalars['String']>;
  kioskQuantityAvailable?: Maybe<Scalars['Float']>;
  medPrice?: Maybe<Scalars['Float']>;
  option?: Maybe<Scalars['String']>;
  packageQuantity?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantityAvailable?: Maybe<Scalars['Float']>;
  recEquivalent?: Maybe<GqlProducts_PosMetaData_Children_Equivalent>;
  recPrice?: Maybe<Scalars['Float']>;
  standardEquivalent?: Maybe<GqlProducts_PosMetaData_Children_Equivalent>;
};

export type GqlProducts_PosMetaData_Children_Equivalent = {
  __typename?: 'Products_POSMetaData_children_equivalent';
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type GqlProducts_PosMetaData_Children_StandardEquivalent = {
  __typename?: 'Products_POSMetaData_children_standardEquivalent';
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type GqlProducts_Terpene = {
  __typename?: 'Products_Terpene';
  active?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  libraryTerpene?: Maybe<GqlTerpene>;
  name?: Maybe<Scalars['String']>;
  terpeneId?: Maybe<Scalars['ID']>;
  unit?: Maybe<PotencyUnit>;
  unitSymbol?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type GqlProducts_TerpeneInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  terpeneId?: InputMaybe<Scalars['ID']>;
  unit?: InputMaybe<PotencyUnit>;
  value?: InputMaybe<Scalars['Float']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type GqlProducts_AdminEdit = {
  __typename?: 'Products_adminEdit';
  updatedAt: Scalars['String'];
  updatedBy: Scalars['String'];
};

export type GqlProducts_Featured = {
  __typename?: 'Products_featured';
  current?: Maybe<Scalars['Boolean']>;
  endTime?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

export type GqlProducts_FeaturedInput = {
  endTime?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type GqlProducts_ImgixSettings = {
  __typename?: 'Products_imgixSettings';
  productCard?: Maybe<GqlImgixSettings>;
  productModal?: Maybe<GqlImgixSettings>;
};

export type GqlProducts_LimitPerCustomer = {
  __typename?: 'Products_limitPerCustomer';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlProducts_LimitPerCustomerInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type GqlProducts_ManualInventory = {
  __typename?: 'Products_manualInventory';
  inventory?: Maybe<Scalars['Int']>;
  option?: Maybe<Scalars['String']>;
};

export type GqlProducts_ManualInventoryInput = {
  inventory?: InputMaybe<Scalars['Int']>;
  option?: InputMaybe<Scalars['String']>;
};

export type GqlProducts_MatchedLibraryItems = {
  __typename?: 'Products_matchedLibraryItems';
  _id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
};

export type GqlProducts_Measurement = {
  __typename?: 'Products_measurement';
  unit?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type GqlProducts_Measurements = {
  __typename?: 'Products_measurements';
  netWeight?: Maybe<GqlProducts_Measurement>;
  volume?: Maybe<GqlProducts_Measurement>;
};

export type GqlProducts_PricingTierData = {
  __typename?: 'Products_pricingTierData';
  generatedTiersId?: Maybe<Scalars['String']>;
  tiers?: Maybe<Array<Maybe<GqlProducts_PricingTierData_Tiers>>>;
  tiersId?: Maybe<Scalars['String']>;
  tiersName?: Maybe<Scalars['String']>;
};

export type GqlProducts_PricingTierData_Tiers = {
  __typename?: 'Products_pricingTierData_tiers';
  endWeight?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Int']>;
  pricePerGram?: Maybe<Scalars['Float']>;
  startWeight?: Maybe<Scalars['Float']>;
  weightUOM?: Maybe<Scalars['String']>;
};

export type GqlProducts_SpecialData = {
  __typename?: 'Products_specialData';
  bogoSpecials?: Maybe<Array<Maybe<GqlProducts_SpecialData_BogoSpecials>>>;
  /** @deprecated Need to apply more than one special 7/20/20 */
  discount?: Maybe<Scalars['Float']>;
  /** @deprecated Need to apply more than one special 7/20/20 */
  percentDiscount?: Maybe<Scalars['Boolean']>;
  saleSpecials?: Maybe<Array<Maybe<GqlProducts_SpecialData_SaleSpecials>>>;
};

export type GqlProducts_SpecialData_BogoSpecials = {
  __typename?: 'Products_specialData_bogoSpecials';
  applyRewardsToConditions?: Maybe<Scalars['Boolean']>;
  bogoConditionLogicOperator?: Maybe<Scalars['String']>;
  bogoConditions?: Maybe<Array<Maybe<GqlProducts_SpecialData_BogoSpecials_BogoConditionItem>>>;
  bogoRewardLogicOperator?: Maybe<Scalars['String']>;
  bogoRewards?: Maybe<Array<Maybe<GqlProducts_SpecialData_BogoSpecials_BogoRewardItem>>>;
  createdBy?: Maybe<Scalars['String']>;
  directPOSProductIdMapping?: Maybe<Scalars['Boolean']>;
  /** @deprecated In favor of stackingBehavior 03/29/22 */
  discountBehavior?: Maybe<Scalars['String']>;
  discountBundle?: Maybe<GqlProducts_SpecialData_BogoSpecials_DiscountBundle>;
  discountPrecedence?: Maybe<Scalars['String']>;
  discountStacking?: Maybe<Scalars['Boolean']>;
  discountToCart?: Maybe<GqlDiscountToCart>;
  endStamp?: Maybe<Scalars['String']>;
  /** @deprecated No longer required 10/07/24 */
  ensureCumulativeNonstacking?: Maybe<Scalars['Boolean']>;
  excludeConditionItemsFromRewards?: Maybe<Scalars['Boolean']>;
  excludedProducts?: Maybe<GqlExcludedBogoProducts>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  itemsForAPrice?: Maybe<GqlProducts_SpecialData_BogoSpecials_ItemsForAPrice>;
  menuType?: Maybe<Scalars['String']>;
  minorVersion?: Maybe<Scalars['Int']>;
  nonStackingBehavior?: Maybe<Scalars['String']>;
  /** @deprecated No longer needed 01/07/25 */
  payByBankIncentiveEnabled?: Maybe<Scalars['Boolean']>;
  paymentRestrictions?: Maybe<GqlPaymentRestrictions>;
  qualifyingConditionOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  qualifyingOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  qualifyingRewardOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  rawPOSWeightMapping?: Maybe<Scalars['Boolean']>;
  recurringEndDate?: Maybe<Scalars['String']>;
  redemptionLimit?: Maybe<Scalars['Int']>;
  settingsDerivedFrom?: Maybe<Scalars['String']>;
  /** @deprecated No longer needed 11/21/24 */
  skipV4Merge?: Maybe<Scalars['Boolean']>;
  sourceId?: Maybe<Scalars['String']>;
  specialId?: Maybe<Scalars['String']>;
  specialName?: Maybe<Scalars['String']>;
  specialType?: Maybe<Scalars['String']>;
  stackingBehavior?: Maybe<Scalars['String']>;
  stackingMode?: Maybe<Scalars['String']>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  /** @deprecated No longer needed 01/07/25 */
  useGreedOptimizedCalculator?: Maybe<Scalars['Boolean']>;
  useLatestCartCalculator?: Maybe<Scalars['Boolean']>;
  useTotalQtyCalcsFix?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['Int']>;
};

export type GqlProducts_SpecialData_BogoSpecials_BogoConditionItem = {
  __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem';
  _id?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['String']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  brandName?: Maybe<Scalars['String']>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  categoryName?: Maybe<Scalars['String']>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  enterpriseProductId?: Maybe<Scalars['String']>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  exclusions?: Maybe<Array<Maybe<GqlExclusion>>>;
  inventoryTags?: Maybe<Array<Scalars['String']>>;
  productGroup?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  productTags?: Maybe<Array<Scalars['String']>>;
  quantity?: Maybe<Scalars['Int']>;
  requiresSingleSku?: Maybe<Scalars['Boolean']>;
  selectedCategoriesAndSubcategories?: Maybe<Array<Maybe<Scalars['String']>>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  weight?: Maybe<Scalars['String']>;
  weightOperator?: Maybe<Products_SpecialData_ComparisonOperators>;
  weights?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GqlProducts_SpecialData_BogoSpecials_BogoRewardItem = {
  __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem';
  _id?: Maybe<Scalars['String']>;
  /** @deprecated Use applicationRules */
  applicationRule?: Maybe<GqlApplicationRule>;
  applicationRules?: Maybe<Array<GqlApplicationRule>>;
  brandId?: Maybe<Scalars['String']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  brandName?: Maybe<Scalars['String']>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  categoryName?: Maybe<Scalars['String']>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  discountAmount?: Maybe<Scalars['Float']>;
  discountType?: Maybe<Scalars['String']>;
  dollarDiscount?: Maybe<Scalars['String']>;
  enterpriseProductId?: Maybe<Scalars['String']>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  exclusions?: Maybe<Array<Maybe<GqlExclusion>>>;
  inventoryTags?: Maybe<Array<Scalars['String']>>;
  percentDiscount?: Maybe<Scalars['String']>;
  productGroup?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  productTags?: Maybe<Array<Scalars['String']>>;
  quantity?: Maybe<Scalars['Int']>;
  requiresSingleSku?: Maybe<Scalars['Boolean']>;
  selectedCategoriesAndSubcategories?: Maybe<Array<Maybe<Scalars['String']>>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  targetPrice?: Maybe<Scalars['String']>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  weight?: Maybe<Scalars['String']>;
  weightOperator?: Maybe<Products_SpecialData_ComparisonOperators>;
  weights?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GqlProducts_SpecialData_BogoSpecials_DiscountBundle = {
  __typename?: 'Products_specialData_bogoSpecials_discountBundle';
  _id?: Maybe<Scalars['String']>;
  applyTo?: Maybe<ApplicationScope>;
  discountType?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlProducts_SpecialData_BogoSpecials_DiscountToCart = {
  __typename?: 'Products_specialData_bogoSpecials_discountToCart';
  _id?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlProducts_SpecialData_BogoSpecials_ItemsForAPrice = {
  __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice';
  _id?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export enum Products_SpecialData_ComparisonOperators {
  equalTo = 'equalTo',
  greaterThan = 'greaterThan',
  greaterThanEqualTo = 'greaterThanEqualTo'
}

export type GqlProducts_SpecialData_SaleSpecials = {
  __typename?: 'Products_specialData_saleSpecials';
  createdBy?: Maybe<Scalars['String']>;
  directPOSProductIdMapping?: Maybe<Scalars['Boolean']>;
  discount?: Maybe<Scalars['Float']>;
  discountStacking?: Maybe<Scalars['Boolean']>;
  dollarDiscount?: Maybe<Scalars['Boolean']>;
  eligibleProductOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  menuType?: Maybe<Scalars['String']>;
  minorVersion?: Maybe<Scalars['Int']>;
  nonStackingBehavior?: Maybe<Scalars['String']>;
  /** @deprecated No longer needed 01/07/25 */
  payByBankIncentiveEnabled?: Maybe<Scalars['Boolean']>;
  paymentRestrictions?: Maybe<GqlPaymentRestrictions>;
  percentDiscount?: Maybe<Scalars['Boolean']>;
  rawPOSWeightMapping?: Maybe<Scalars['Boolean']>;
  saleDiscounts?: Maybe<Array<Maybe<GqlSaleDiscount>>>;
  settingsDerivedFrom?: Maybe<Scalars['String']>;
  /** @deprecated No longer needed 11/21/24 */
  skipV4Merge?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  specialId?: Maybe<Scalars['String']>;
  specialName?: Maybe<Scalars['String']>;
  specialRestrictions?: Maybe<Scalars['JSON']>;
  specialType?: Maybe<Scalars['String']>;
  stackingBehavior?: Maybe<Scalars['String']>;
  stackingMode?: Maybe<Scalars['String']>;
  targetPrice?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer needed 01/07/25 */
  useGreedOptimizedCalculator?: Maybe<Scalars['Boolean']>;
  useLatestCartCalculator?: Maybe<Scalars['Boolean']>;
  useTotalQtyCalcsFix?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['Int']>;
};

export type GqlProducts_SpecialIdsPerOption = {
  __typename?: 'Products_specialIdsPerOption';
  conditionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  option?: Maybe<Scalars['String']>;
  rewardIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GqlProgramResponse = {
  __typename?: 'ProgramResponse';
  rewardRedemption?: Maybe<GqlRewardRedemptionDetails>;
};

export type GqlPromo = {
  __typename?: 'Promo';
  html: Scalars['String'];
  recipient: Scalars['JSON'];
};

export type GqlPropertyTypes = {
  __typename?: 'PropertyTypes';
  contact?: Maybe<Array<Maybe<GqlContactCrmProperty>>>;
  deal?: Maybe<Array<Maybe<GqlDealCrmProperty>>>;
  product?: Maybe<Array<Maybe<GqlProductCrmProperty>>>;
};

export type GqlPublicContextSession = {
  __typename?: 'PublicContextSession';
  accessToken?: Maybe<Scalars['String']>;
  claimedByUserId?: Maybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  expiresAt: Scalars['String'];
  id: Scalars['ID'];
  loginMethodVerified?: Maybe<Scalars['Boolean']>;
  status: PublicContextSessionStatus;
};

export enum PublicContextSessionStatus {
  claimed = 'CLAIMED',
  expired = 'EXPIRED',
  unclaimed = 'UNCLAIMED'
}

export type GqlPurchaseOrder = {
  __typename?: 'PurchaseOrder';
  actualArrivalDate?: Maybe<Scalars['String']>;
  brandId: Scalars['String'];
  brandName: Scalars['String'];
  createdAt: Scalars['String'];
  createdByEmail: Scalars['String'];
  destinationDposLocId?: Maybe<Scalars['Int']>;
  destinationDposLspId?: Maybe<Scalars['Int']>;
  destinationDposServerRegion?: Maybe<Scalars['String']>;
  expectedArrivalDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  items: Scalars['Int'];
  purchaseOrderItems: Array<GqlPurchaseOrderLineItem>;
  purchaseOrderNumber: Scalars['Int'];
  receivedAt?: Maybe<Scalars['String']>;
  shippingInformation?: Maybe<Scalars['String']>;
  sourceDposLocId: Scalars['Int'];
  sourceDposLspId: Scalars['Int'];
  sourceDposServerRegion: Scalars['String'];
  status: PurchaseOrderStatus;
  submittedAt?: Maybe<Scalars['String']>;
  subtotalInCents: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type GqlPurchaseOrderLineItem = {
  __typename?: 'PurchaseOrderLineItem';
  confirmedQuantity: Scalars['Int'];
  createdAt: Scalars['String'];
  id: Scalars['String'];
  libraryProductId: Scalars['String'];
  name: Scalars['String'];
  purchaseOrderId: Scalars['String'];
  requestedQuantity: Scalars['Int'];
  subtotalInCents: Scalars['Int'];
  taxInCents: Scalars['Int'];
  unitOfMeasure: UnitOfMeasure;
  unitPriceInCents: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export enum PurchaseOrderStatus {
  amendedConfirmed = 'amended_confirmed',
  amendedProposed = 'amended_proposed',
  closedReceived = 'closed_received',
  confirmed = 'confirmed',
  openDraft = 'open_draft',
  rejected = 'rejected',
  rejectedByFulfillment = 'rejected_by_fulfillment',
  shipped = 'shipped',
  submitted = 'submitted'
}

export type GqlPurchaseOrdersFilterInput = {
  destinationDposLocId?: InputMaybe<Scalars['String']>;
  destinationDposLspId?: InputMaybe<Scalars['String']>;
  destinationDposServerRegion?: InputMaybe<Scalars['String']>;
  sourceDposLocId?: InputMaybe<Scalars['String']>;
  sourceDposLspId?: InputMaybe<Scalars['String']>;
  sourceDposServerRegion?: InputMaybe<Scalars['String']>;
};

export type GqlQuery = {
  __typename?: 'Query';
  AchReturnDetailReport?: Maybe<GqlAchReturnDetailReportResponse>;
  NsfAchReturnReport?: Maybe<GqlNsfAchReturnReportResponse>;
  activeDispensaries?: Maybe<GqlActiveDispenariesResult>;
  activeProductsCheck?: Maybe<Array<Maybe<GqlProducts>>>;
  addressResidentialCheck?: Maybe<GqlValidationResponse>;
  archivedProductLookup?: Maybe<Array<Maybe<GqlProducts>>>;
  availableSegments: Array<GqlSegment>;
  brandPortalProductSearch?: Maybe<GqlBrandPortalProductSearchResponse>;
  bulkLibraryProductUpdateStatus?: Maybe<GqlBulkLibraryProductStatusUpdateResponse>;
  bulkLibraryProductUploadStatus?: Maybe<GqlBulkLibraryProductUploadStatusResponse>;
  calculateCheckout?: Maybe<GqlCalculateCheckout>;
  chainDispensariesByStatus?: Maybe<Array<Maybe<GqlDispensaries>>>;
  chainDispensaryIds: Array<Maybe<Scalars['String']>>;
  chainDispensaryNamesAndIds?: Maybe<Array<Maybe<GqlDispensaries>>>;
  changeRequestProduct?: Maybe<GqlProductChangeRequest>;
  checkAgeVerification: GqlAgeVerification;
  checkPurchaseLimits?: Maybe<GqlCheckPurchaseLimitsResult>;
  computeWithPriceCart?: Maybe<GqlCalculationResults>;
  connectNewProductPreview?: Maybe<GqlConnectProductPreviewResponse>;
  contentStatistics?: Maybe<GqlContentStatistics>;
  createPaymentMethod?: Maybe<GqlMxMemberVerification>;
  /** @deprecated Use getCurbsideArrivals */
  curbsideArrivalsForDispensary?: Maybe<Array<Maybe<GqlCurbsideArrival>>>;
  currentDevice?: Maybe<GqlDevices>;
  dispensaryCustomers?: Maybe<GqlCustomersList>;
  enterpriseAdSettings: Array<GqlEnterpriseDispensaryAdSettings>;
  enterpriseLoyaltySettings?: Maybe<GqlEnterpriseLoyaltySettings>;
  enterpriseMobileAppSettings?: Maybe<GqlEnterpriseMobileAppSettings>;
  enterprisePersonalizationSettings: Array<GqlEnterpriseDispensaryPersonalizationSettings>;
  enterpriseProducts?: Maybe<GqlEnterpriseProducts>;
  enterpriseProductsV2?: Maybe<GqlEnterpriseProducts>;
  enterpriseSpecials?: Maybe<Array<Maybe<GqlEnterpriseSpecial>>>;
  enterpriseSpecialsV3?: Maybe<GqlFilteredEnterpriseSpecials>;
  filteredCoupons?: Maybe<GqlCouponList>;
  filteredDispensaries?: Maybe<Array<Maybe<GqlDispensaries>>>;
  filteredIntegrations?: Maybe<Array<Maybe<GqlIntegrations>>>;
  filteredOrders?: Maybe<GqlOrderList>;
  filteredProducts?: Maybe<GqlProductsList>;
  filteredSpecials?: Maybe<GqlFilteredSpecials>;
  filteredSpecialsV2?: Maybe<GqlFilteredSpecials>;
  filteredStrains?: Maybe<GqlStrainList>;
  /** @deprecated Use getCustomerSubscriptions */
  filteredSubscriptions?: Maybe<Array<Maybe<GqlSubscriptionCustomers>>>;
  filteredTerpenes?: Maybe<Array<Maybe<GqlTerpene>>>;
  filteredUsers?: Maybe<Array<Maybe<GqlUsers>>>;
  findCustomizationProvider?: Maybe<GqlCustomizationProvider>;
  findLibraryProducts?: Maybe<GqlFindLibraryProductsResponse>;
  fundRethink: GqlFundRethinkResponse;
  geolocate?: Maybe<GqlIpInfo>;
  getAchPaymentDetails?: Maybe<GqlGetAchPaymentDetailsResponse>;
  getAddressBasedDispensaryData?: Maybe<GqlAddressBasedDispensaryDataResult>;
  getAdsInspectorEvents: GqlAdsInspectorEvents;
  getBackInStockSubscriptionStatus?: Maybe<GqlBackInStockSubscriptionStatus>;
  /** @deprecated Use listBankAccounts query */
  getBankAccountsV2?: Maybe<GqlBankAccounts>;
  getBillingSubscriptions: Array<Maybe<GqlBillingSubscription>>;
  getBrand?: Maybe<GqlBrand>;
  getBrandCampaignInsights: Array<GqlBrandCampaignInsight>;
  getBrandCollisions?: Maybe<GqlBrandCollisionList>;
  getBrandEnterpriseSettings: Array<GqlBrandEnterpriseSetting>;
  getBrandExports: GqlBrandExportsResponse;
  getBrandImportHistory: GqlBrandImportHistoryResponse;
  getBrandImportHistoryDetail: GqlBrandImportHistoryDetailResponse;
  getBrandImportHistoryFailedRowsExport: GqlBrandImportHistoryFailedRowsExport;
  getBrandKeyMetrics: GqlBrandKeyMetrics;
  getBrandLocationCategoriesInsights: GqlBrandCategoryInsightsSummary;
  getBrandLocationProductsInsights: GqlBrandProductInsightsSummary;
  getBrandLocationsInsights: GqlBrandLocationsInsightsSummary;
  getBrandLspCategoriesInsights: GqlBrandCategoryInsightsSummary;
  getBrandLspProductsInsights: GqlBrandProductInsightsSummary;
  getBrandLsps: Array<GqlBrandLspItem>;
  getBrandLspsInsights: GqlBrandLspsInsightsSummary;
  getBrandMergeHistories?: Maybe<GqlBrandMergeHistoryList>;
  getBrandOverviewLsps: GqlBrandOverviewLspsSummary;
  getBrandRegions: Array<GqlBrandRegion>;
  getBrandUser?: Maybe<GqlBrandUser>;
  getBrandUsers?: Maybe<GqlBrandUserList>;
  getBrandsV2?: Maybe<Array<Maybe<GqlBrand>>>;
  getBucket: GqlBucket;
  getBuckets: Array<Maybe<GqlBucket>>;
  getCannabinoids: Array<GqlCannabinoid>;
  getChainsV2?: Maybe<GqlChainList>;
  getChargebeeHostedPage?: Maybe<GqlChargeBeeHostedPage>;
  getCheckout?: Maybe<GqlCheckout>;
  getCollection: GqlCollection;
  getCollectionProductCount: GqlCollectionProductCount;
  getCollections: Array<GqlCollection>;
  getCollectionsNavigation: Array<GqlCollection>;
  getConsumerStreamToken?: Maybe<GqlConsumerStreamCredentials>;
  getConsumerUser?: Maybe<GqlConsumerUser>;
  getCurbsideArrivalByToken?: Maybe<GqlCurbsideArrival>;
  getCurbsideArrivals: Array<GqlCurbsideArrival>;
  getCustomerDetails: GqlCustomerDetailsResponse;
  getCustomerSubscriptions: Array<GqlCustomerSubscription>;
  /** @deprecated Use getAddressBasedDispensaryData instead */
  getDeliveryInfo?: Maybe<GqlDispensaries_DeliveryInfo>;
  getDevices: Array<GqlDevices>;
  getDispensariesAdSettingsByMenuVariant?: Maybe<Array<GqlDispensariesAdSettingsByMenuVariantResult>>;
  getDispensariesByPersonalizationSettings?: Maybe<Array<GqlDispensariesPersonalizationSettingsByMenuVariantResult>>;
  /** @deprecated Use ShowEnrollment */
  getDutchiePayEnrollment: GqlDutchiePayEnrollment;
  getDutchiePosLoyaltyConfig?: Maybe<GqlDutchiePosLoyaltyConfig>;
  getEcommerceAbandonedCarts?: Maybe<GqlEcommerceAbandonedCartsResponse>;
  /** @deprecated Use getDutchiePayEnrollment */
  getEnrollmentStatus?: Maybe<GqlUserEnrollment>;
  getEnterprise?: Maybe<GqlEnterprise>;
  getEnterpriseByName?: Maybe<Array<Maybe<GqlEnterprise>>>;
  getEnterpriseSpecial?: Maybe<GqlEnterpriseSpecial>;
  getEnterpriseSpecialsHistory?: Maybe<GqlEnterpriseSpecialsHistory>;
  getEnterpriseSpecialsSettings?: Maybe<GqlEnterpriseSpecialsSettings>;
  getEntityLinkingCode?: Maybe<GqlEntityLinkingCodeResponse>;
  getExport: GqlExport;
  getFilteredBrandSummaries?: Maybe<GqlFilteredBrandSummaryResponse>;
  getFilteredProductSummaries?: Maybe<GqlFilteredProductSummaryResponse>;
  getInstoreAnalyticsToken?: Maybe<GqlInstoreAnalyticsToken>;
  getInstoreCart?: Maybe<GqlShowInstoreCartResponse>;
  getInvoicePdf: GqlChargebeeDownload;
  getKioskTerminals: Array<GqlKioskTerminal>;
  getLibraryProduct?: Maybe<GqlLibraryProduct>;
  getMarketingCampaigns?: Maybe<GqlMarketingCampaignsResponse>;
  getMarketingCoupons?: Maybe<GqlMarketingCouponsResponse>;
  getMarketingDataPoints?: Maybe<GqlMarketingDataPointsResponse>;
  getMarketingSpecials?: Maybe<GqlMarketingSpecialsResponse>;
  /** get MarketplaceProduct information from a given id */
  getMarketplaceProduct: GqlMarketplaceProduct;
  /** Gets location based stats for a Marketplace Product */
  getMarketplaceProductLocationStats: GqlMarketplaceProductLocationStats;
  getMenuSections?: Maybe<Array<Maybe<GqlMenuSection>>>;
  getMenuSectionsAdmin?: Maybe<Array<Maybe<GqlMenuSection>>>;
  getMonerisTokenizationProfile?: Maybe<GqlMonerisTokenizationProfile>;
  /** @deprecated Use getRecommendedProducts. */
  getMostPurchasedProducts?: Maybe<Array<GqlMongoProduct>>;
  getOrder?: Maybe<GqlGetOrderType>;
  getOrderForDelivery?: Maybe<GqlOrders>;
  getOrders?: Maybe<GqlAdminOrderListType>;
  getPaymentStatus: GqlRethinkStatus;
  getPaymentsCheckoutCredentials?: Maybe<GqlPaymentsCheckoutCredentials>;
  getPersonalizedProducts?: Maybe<GqlPersonalizedProducts>;
  getPersonalizedProductsV2?: Maybe<GqlPersonalizedProducts>;
  getPlusApiKeys?: Maybe<Array<GqlPlusApiKey>>;
  getPlusEnterpriseApiKeys?: Maybe<Array<GqlPlusApiKey>>;
  getPlusOAuthProviders: Array<Maybe<GqlPlusOAuthProvider>>;
  getPopularDispensaries: Array<GqlPopularDispensary>;
  getPosMedCardInfo?: Maybe<GqlPosMedCardInfo>;
  getProductBuyingOptions?: Maybe<GqlProductBuyingOptionsResult>;
  getProductDemandCounts?: Maybe<Array<Maybe<GqlProductDemandCount>>>;
  getProductSalesByCategory?: Maybe<GqlProductsSalesByCategory>;
  getPromo: GqlPromo;
  getPublicContextSession?: Maybe<GqlPublicContextSession>;
  getPurchaseOrders: Array<Maybe<GqlPurchaseOrder>>;
  getRawAchBatchFile?: Maybe<GqlGetRawAchBatchFileResponse>;
  getRecentlyViewedProducts?: Maybe<Array<GqlProducts>>;
  getRecentlyViewedProductsV2?: Maybe<Array<GqlMongoProduct>>;
  getRecommendedProducts: Array<GqlProducts>;
  getRemoteIntegrationValue?: Maybe<Scalars['String']>;
  getReportingBrands: GqlReportingBrands;
  getReservationSlotsByOrderType?: Maybe<GqlMaxReservationSlotsByOrderType>;
  getRetailer?: Maybe<GqlRetailer>;
  getRetailerByDispensaryId?: Maybe<Array<Maybe<GqlRetailer>>>;
  getRetailerEnrollmentStatus?: Maybe<GqlRetailerEnrollment>;
  getRetailersByEnterpriseId?: Maybe<Array<Maybe<GqlRetailer>>>;
  getRewardsV2?: Maybe<GqlRewardsListV2>;
  getSortedProductRecommendations?: Maybe<GqlProductRecommendations>;
  getSpecialGamification?: Maybe<GqlSpecialGamificationList>;
  getSpecialMenuCards?: Maybe<GqlSpecialMenuCardResponse>;
  getSpecialsHistory?: Maybe<GqlSpecialsHistory>;
  getSponsoredBrand?: Maybe<GqlSponsoredBrand>;
  getSponsoredProducts: Array<GqlProducts>;
  getStateLibraries: Array<GqlStateLibrary>;
  getStockImage?: Maybe<GqlStockImage>;
  getStrain?: Maybe<GqlStrain>;
  getSubscriptionsV2: Array<Maybe<GqlSubscriptionV2>>;
  getTerpene?: Maybe<GqlTerpene>;
  getTimezone?: Maybe<GqlGetTimezoneResult>;
  getTopProduct?: Maybe<GqlTopProduct>;
  getTrackedCart?: Maybe<GqlTrackedCart>;
  getTrendingBrands?: Maybe<GqlTrendingBrandsResponse>;
  getUserIncentiveEligibility?: Maybe<GqlGetUserStatusResponse>;
  getUserQuery?: Maybe<GqlUsers>;
  healthCheck?: Maybe<GqlHealthCheck>;
  hubspotCrmProperties?: Maybe<GqlCrmProperties>;
  hubspotPipelineProperties?: Maybe<GqlPipelineProperties>;
  /** @deprecated Use libraryProductChangeImpactV3 mutation */
  libraryProductChangeImpactV2?: Maybe<GqlLibraryProductChangeImpactResponse>;
  listAccountBalances?: Maybe<GqlListAccountBalancesResponse>;
  listAchBatches?: Maybe<GqlListAchBatchesResponse>;
  /** @deprecated Use listAchEntriesV4 */
  listAchEntries?: Maybe<GqlListAchEntriesResponse>;
  /** @deprecated Use listAchEntriesV4 */
  listAchEntriesV3?: Maybe<GqlListAchEntriesResponseV3>;
  listAchEntriesV4?: Maybe<GqlListAchEntriesResponseV3>;
  /** @deprecated Use listAchReturnsV5 */
  listAchReturns?: Maybe<GqlListAchReturnsResponse>;
  /** @deprecated Use listAchReturnsV5 */
  listAchReturnsV3?: Maybe<GqlListAchReturnsResponseV3>;
  /** @deprecated Use listAchReturnsV5 */
  listAchReturnsV4?: Maybe<GqlListAchReturnsResponseV4>;
  listAchReturnsV5?: Maybe<GqlListAchReturnsResponseV5>;
  /** @deprecated Only used for MX, we no longer use MX */
  listBankAccounts?: Maybe<GqlMxBankAccounts>;
  listBrands: GqlBrandList;
  listEntities?: Maybe<GqlListEntitiesResponse>;
  listEntityFraudAssessments?: Maybe<GqlGetAchPaymentFraudAssessmentsResponse>;
  listLibraryProducts?: Maybe<GqlLibraryProducts>;
  listLoyaltyPassDispensaries?: Maybe<GqlLoyaltyPassDispensaries>;
  listRegions: Array<Maybe<GqlRegion>>;
  listRetailerPaymentTypesStatus?: Maybe<GqlRetailerPaymentTypes>;
  listTransactionFraudAssessments?: Maybe<GqlGetAchPaymentFraudAssessmentsResponse>;
  /** @deprecated Use moving to V2 for scope change */
  matchLibraryProducts?: Maybe<Array<Maybe<GqlLibraryProduct>>>;
  matchLibraryProductsV2?: Maybe<Array<Maybe<GqlLibraryProduct>>>;
  matchingProducts?: Maybe<Array<Maybe<GqlProducts>>>;
  meAdmin?: Maybe<GqlIdentityAdmin>;
  meConsumer?: Maybe<GqlIdentityConsumer>;
  menuFilters?: Maybe<GqlMenuFilters>;
  menuFiltersV2?: Maybe<GqlMenuFilters>;
  pendingDispensaries?: Maybe<GqlPendingDispensariesResult>;
  printJob: GqlPrintJob;
  printers: Array<GqlPrinter>;
  productChangeEvents?: Maybe<Array<Maybe<GqlProductChangeEvent>>>;
  productFilters?: Maybe<GqlProductFilters>;
  salesOrdersQuery?: Maybe<GqlSalesOrdersQueryResponse>;
  searchBrandOverviewLsps: GqlBrandOverviewLspsSummary;
  searchBrandsV2?: Maybe<GqlBrandList>;
  searchBucketProducts?: Maybe<GqlSearchBucketProductsResponse>;
  searchEnterpriseByName?: Maybe<Array<Maybe<GqlEnterprise>>>;
  searchLibraryProducts?: Maybe<GqlLibraryProducts>;
  searchLspBrands: GqlLspBrandsList;
  searchProductChangeRequests?: Maybe<GqlContentChangeRequests>;
  /** Gets valid filters for Products in the search radius */
  searchProductFilters: Array<GqlSearchProductCategoryFilter>;
  /** Search Products in the marketplace based on a series of filters */
  searchProducts: GqlSearchProductsResult;
  secureImageUrlV2?: Maybe<GqlIdUrl>;
  showEnrollment: GqlShowEnrollmentResponse;
  /** @deprecated Use startAggregatorLinkV2 mutation */
  startAggregatorLink: GqlStartAggregatorLinkResponse;
  startAggregatorLinkV2: GqlStartAggregatorLinkV2Response;
  statesWithDispensaries: Array<GqlState>;
  superAdminCustomers?: Maybe<GqlCustomersList>;
  superProducts?: Maybe<GqlMenuCleanup>;
  testPlusOAuthProviders: GqlTestPlusOAuthProviderResponse;
  unsubscribeCustomerQuery?: Maybe<GqlCustomerUnsubscribe>;
  /** @deprecated To remove */
  userExistsCheck?: Maybe<GqlExists>;
  validateCouponQuery?: Maybe<GqlCouponValidationResponse>;
  validatePasswordResetTokenQuery?: Maybe<GqlValidationResponse>;
  validatePasswordTokenQuery?: Maybe<GqlValidationResponse>;
  verifyMxMember?: Maybe<GqlMxMemberVerification>;
};


export type GqlQueryAchReturnDetailReportArgs = {
  endDate?: InputMaybe<GqlPaymentsIsoDate>;
  startDate?: InputMaybe<GqlPaymentsIsoDate>;
};


export type GqlQueryNsfAchReturnReportArgs = {
  endDate?: InputMaybe<GqlPaymentsIsoDate>;
  startDate?: InputMaybe<GqlPaymentsIsoDate>;
};


export type GqlQueryActiveDispensariesArgs = {
  params?: InputMaybe<GqlActiveDispensariesInput>;
};


export type GqlQueryActiveProductsCheckArgs = {
  filter?: InputMaybe<GqlActiveProductsCheckInput>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']>;
};


export type GqlQueryAddressResidentialCheckArgs = {
  input?: InputMaybe<GqlAddressResidentialCheckInput>;
};


export type GqlQueryArchivedProductLookupArgs = {
  cname: Scalars['String'];
  dispensaryId: Scalars['String'];
};


export type GqlQueryAvailableSegmentsArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryBrandPortalProductSearchArgs = {
  filters?: InputMaybe<GqlBrandPortalProductSearchFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<GqlBrandPortalProductSearchSort>;
};


export type GqlQueryBulkLibraryProductUpdateStatusArgs = {
  jobId: Scalars['String'];
};


export type GqlQueryBulkLibraryProductUploadStatusArgs = {
  jobId: Scalars['ID'];
};


export type GqlQueryCalculateCheckoutArgs = {
  checkout: GqlCalculateCheckoutInput;
};


export type GqlQueryChainDispensariesByStatusArgs = {
  chainId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type GqlQueryChainDispensaryIdsArgs = {
  chainId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type GqlQueryChainDispensaryNamesAndIdsArgs = {
  chainId?: InputMaybe<Scalars['String']>;
};


export type GqlQueryChangeRequestProductArgs = {
  id: Scalars['String'];
};


export type GqlQueryCheckAgeVerificationArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryCheckPurchaseLimitsArgs = {
  inputs: GqlCheckPurchaseLimitsInput;
};


export type GqlQueryComputeWithPriceCartArgs = {
  input: GqlCalculationsInput;
};


export type GqlQueryConnectNewProductPreviewArgs = {
  dispensaryId: Scalars['String'];
  libraryProductId: Scalars['String'];
};


export type GqlQueryCreatePaymentMethodArgs = {
  entityId: Scalars['String'];
  entityType: EntityTypes;
  isMobileApp?: InputMaybe<Scalars['Boolean']>;
  memberGuid: Scalars['String'];
};


export type GqlQueryCurbsideArrivalsForDispensaryArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryDispensaryCustomersArgs = {
  filter?: InputMaybe<GqlCustomersFilterInput>;
  pagination?: InputMaybe<GqlCustomersPaginationInput>;
  sort?: InputMaybe<GqlCustomersSortInput>;
};


export type GqlQueryEnterpriseAdSettingsArgs = {
  enterpriseId: Scalars['ID'];
};


export type GqlQueryEnterpriseLoyaltySettingsArgs = {
  id: Scalars['ID'];
};


export type GqlQueryEnterpriseMobileAppSettingsArgs = {
  enterpriseId: Scalars['ID'];
};


export type GqlQueryEnterprisePersonalizationSettingsArgs = {
  enterpriseId: Scalars['ID'];
};


export type GqlQueryEnterpriseProductsArgs = {
  enterpriseId: Scalars['ID'];
};


export type GqlQueryEnterpriseProductsV2Args = {
  enterpriseId: Scalars['ID'];
};


export type GqlQueryEnterpriseSpecialsArgs = {
  enterpriseId: Scalars['ID'];
};


export type GqlQueryEnterpriseSpecialsV3Args = {
  enterpriseId: Scalars['ID'];
  filter?: InputMaybe<GqlFilteredSpecialsInputV2>;
};


export type GqlQueryFilteredCouponsArgs = {
  filter?: InputMaybe<GqlCouponsFilterInput>;
  pagination?: InputMaybe<GqlCouponsPaginationInput>;
  sort?: InputMaybe<GqlCouponsSortInput>;
};


export type GqlQueryFilteredDispensariesArgs = {
  filter?: InputMaybe<GqlDispensariesFilterInput>;
};


export type GqlQueryFilteredIntegrationsArgs = {
  dispensaryId?: InputMaybe<Scalars['String']>;
};


export type GqlQueryFilteredOrdersArgs = {
  filter?: InputMaybe<GqlOrdersFilterInput>;
  pagination?: InputMaybe<GqlOrdersPaginationInput>;
  sort?: InputMaybe<GqlOrdersSortInput>;
};


export type GqlQueryFilteredProductsArgs = {
  filter?: InputMaybe<GqlProductsFilterInput>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  showAllSpecialProducts?: InputMaybe<Scalars['Boolean']>;
  useCache?: InputMaybe<Scalars['Boolean']>;
};


export type GqlQueryFilteredSpecialsArgs = {
  filter?: InputMaybe<GqlFilteredSpecialsInput>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']>;
};


export type GqlQueryFilteredSpecialsV2Args = {
  filter?: InputMaybe<GqlFilteredSpecialsInput>;
  translateSpecialsToV3?: InputMaybe<Scalars['Boolean']>;
};


export type GqlQueryFilteredStrainsArgs = {
  filter?: InputMaybe<GqlStrainsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlStrainsSortInput>;
};


export type GqlQueryFilteredSubscriptionsArgs = {
  filter?: InputMaybe<GqlSubscriptionsFilterInput>;
};


export type GqlQueryFilteredTerpenesArgs = {
  filter?: InputMaybe<GqlTerpenesFilter>;
  sort?: InputMaybe<GqlTerpenesSort>;
};


export type GqlQueryFilteredUsersArgs = {
  filter?: InputMaybe<GqlUsersFilterInput>;
};


export type GqlQueryFindCustomizationProviderArgs = {
  chainId?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
};


export type GqlQueryFindLibraryProductsArgs = {
  id: Scalars['String'];
};


export type GqlQueryFundRethinkArgs = {
  ecommLocationId: Scalars['String'];
};


export type GqlQueryGetAchPaymentDetailsArgs = {
  paymentId: Scalars['String'];
};


export type GqlQueryGetAddressBasedDispensaryDataArgs = {
  input?: InputMaybe<GqlGetDeliveryInfoInput>;
};


export type GqlQueryGetAdsInspectorEventsArgs = {
  input: GqlAdsInspectorEventsInput;
};


export type GqlQueryGetBackInStockSubscriptionStatusArgs = {
  productId: Scalars['String'];
};


export type GqlQueryGetBankAccountsV2Args = {
  entityId: Scalars['String'];
  entityType: EntityTypes;
  paymentMethodIds?: InputMaybe<Array<Scalars['String']>>;
};


export type GqlQueryGetBillingSubscriptionsArgs = {
  dispensaries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GqlQueryGetBrandArgs = {
  id: Scalars['String'];
};


export type GqlQueryGetBrandCampaignInsightsArgs = {
  brandId: Scalars['ID'];
  filters?: InputMaybe<GqlBrandCampaignInsightsFilterInput>;
};


export type GqlQueryGetBrandCollisionsArgs = {
  filters?: InputMaybe<GqlBrandCollisionFilters>;
  pagination?: InputMaybe<GqlPagination>;
  sort?: InputMaybe<GqlBrandCollisionsSort>;
};


export type GqlQueryGetBrandEnterpriseSettingsArgs = {
  brandId: Scalars['String'];
};


export type GqlQueryGetBrandExportsArgs = {
  brandId: Scalars['ID'];
  filters?: InputMaybe<GqlBrandExportsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlBrandExportsSortInput>;
};


export type GqlQueryGetBrandImportHistoryArgs = {
  brandId: Scalars['ID'];
  filters?: InputMaybe<GqlBrandImportHistoryFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlBrandImportHistorySortInput>;
};


export type GqlQueryGetBrandImportHistoryDetailArgs = {
  brandId: Scalars['ID'];
  filters?: InputMaybe<GqlBrandImportHistoryDetailFilterInput>;
  importId: Scalars['ID'];
  pagination?: InputMaybe<GqlPaginationInput>;
};


export type GqlQueryGetBrandImportHistoryFailedRowsExportArgs = {
  brandId: Scalars['ID'];
  importId: Scalars['ID'];
};


export type GqlQueryGetBrandKeyMetricsArgs = {
  brandId: Scalars['ID'];
};


export type GqlQueryGetBrandLocationCategoriesInsightsArgs = {
  brandId: Scalars['ID'];
  dposLocationId: Scalars['ID'];
  dposLspId: Scalars['ID'];
  dposServerRegion: Scalars['String'];
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandLocationProductsInsightsArgs = {
  brandId: Scalars['ID'];
  dposLocationId: Scalars['ID'];
  dposLspId: Scalars['ID'];
  dposServerRegion: Scalars['String'];
  filters?: InputMaybe<GqlProductInsightsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandLocationsInsightsArgs = {
  brandId: Scalars['ID'];
  filters?: InputMaybe<GqlInsightsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandLspCategoriesInsightsArgs = {
  brandId: Scalars['ID'];
  dposLspId: Scalars['ID'];
  dposServerRegion: Scalars['String'];
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandLspProductsInsightsArgs = {
  brandId: Scalars['ID'];
  dposLspId: Scalars['ID'];
  dposServerRegion: Scalars['String'];
  filters?: InputMaybe<GqlProductInsightsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandLspsArgs = {
  brandId: Scalars['ID'];
  filters?: InputMaybe<GqlBrandLspsFilterInput>;
};


export type GqlQueryGetBrandLspsInsightsArgs = {
  brandId: Scalars['ID'];
  filters?: InputMaybe<GqlInsightsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandMergeHistoriesArgs = {
  filters?: InputMaybe<GqlBrandMergeHistoriesFilters>;
  page?: InputMaybe<GqlBrandMergeHistoriesPagination>;
  sort?: InputMaybe<GqlBrandMergeHistoriesSort>;
};


export type GqlQueryGetBrandOverviewLspsArgs = {
  brandId: Scalars['ID'];
  filters?: InputMaybe<GqlBrandOverviewLspsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
};


export type GqlQueryGetBrandRegionsArgs = {
  brandId: Scalars['ID'];
  filters?: InputMaybe<GqlBrandRegionsFilterInput>;
};


export type GqlQueryGetBrandUserArgs = {
  id: Scalars['ID'];
};


export type GqlQueryGetBrandUsersArgs = {
  filter?: InputMaybe<GqlBrandUsersFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlBrandUsersSortInput>;
};


export type GqlQueryGetBrandsV2Args = {
  ids: Array<InputMaybe<Scalars['String']>>;
};


export type GqlQueryGetBucketArgs = {
  id: Scalars['String'];
};


export type GqlQueryGetBucketsArgs = {
  sort?: InputMaybe<GqlBrandsSortInput>;
};


export type GqlQueryGetChainsV2Args = {
  filter?: InputMaybe<GqlChainFilterInput>;
  pagination?: InputMaybe<GqlChainPaginationInput>;
  sort?: InputMaybe<GqlChainSortInput>;
};


export type GqlQueryGetChargebeeHostedPageArgs = {
  chargebeeCustomerId: Scalars['String'];
  pageType: Scalars['String'];
};


export type GqlQueryGetCheckoutArgs = {
  checkoutId: Scalars['String'];
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetCollectionArgs = {
  collectionId: Scalars['String'];
  customCategory?: InputMaybe<Scalars['Boolean']>;
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetCollectionProductCountArgs = {
  dispensaryId: Scalars['String'];
  input: GqlGetCollectionProductCountInput;
};


export type GqlQueryGetCollectionsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  customCategory?: InputMaybe<Scalars['Boolean']>;
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetCollectionsNavigationArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  customCategory?: InputMaybe<Scalars['Boolean']>;
  dispensaryId: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
};


export type GqlQueryGetConsumerStreamTokenArgs = {
  orderId?: InputMaybe<Scalars['String']>;
};


export type GqlQueryGetConsumerUserArgs = {
  id: Scalars['String'];
};


export type GqlQueryGetCurbsideArrivalByTokenArgs = {
  token: Scalars['String'];
};


export type GqlQueryGetCurbsideArrivalsArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetDeliveryInfoArgs = {
  input?: InputMaybe<GqlGetDeliveryInfoInput>;
};


export type GqlQueryGetDevicesArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetDispensariesAdSettingsByMenuVariantArgs = {
  input: GqlGetDispensariesAdSettingsByMenuVariantInput;
};


export type GqlQueryGetDispensariesByPersonalizationSettingsArgs = {
  input: GqlGetDispensariesByPersonalizationSettingsInput;
};


export type GqlQueryGetDutchiePayEnrollmentArgs = {
  entityId: Scalars['String'];
  entityType: EntityTypes;
};


export type GqlQueryGetDutchiePosLoyaltyConfigArgs = {
  dispensaryId?: InputMaybe<Scalars['String']>;
  enterpriseId?: InputMaybe<Scalars['String']>;
  isoRegionCode?: InputMaybe<Scalars['String']>;
};


export type GqlQueryGetEcommerceAbandonedCartsArgs = {
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetEnrollmentStatusArgs = {
  entityId: Scalars['String'];
  entityType: EntityTypes;
};


export type GqlQueryGetEnterpriseArgs = {
  id: Scalars['ID'];
};


export type GqlQueryGetEnterpriseByNameArgs = {
  uniqueName: Scalars['ID'];
};


export type GqlQueryGetEnterpriseSpecialArgs = {
  enterpriseSpecialId: Scalars['ID'];
};


export type GqlQueryGetEnterpriseSpecialsHistoryArgs = {
  enterpriseId: Scalars['ID'];
  enterpriseSpecialId: Scalars['ID'];
};


export type GqlQueryGetEnterpriseSpecialsSettingsArgs = {
  enterpriseId: Scalars['ID'];
};


export type GqlQueryGetExportArgs = {
  id: Scalars['String'];
};


export type GqlQueryGetFilteredBrandSummariesArgs = {
  input: GqlBrandsSummaryInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetFilteredProductSummariesArgs = {
  input: GqlProductsSummaryInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetInstoreCartArgs = {
  cartToken?: InputMaybe<Scalars['String']>;
};


export type GqlQueryGetInvoicePdfArgs = {
  id: Scalars['String'];
};


export type GqlQueryGetKioskTerminalsArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetLibraryProductArgs = {
  id: Scalars['String'];
};


export type GqlQueryGetMarketingCampaignsArgs = {
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetMarketingCouponsArgs = {
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetMarketingDataPointsArgs = {
  input: GqlAnalyticsInput;
};


export type GqlQueryGetMarketingSpecialsArgs = {
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetMarketplaceProductArgs = {
  id: Scalars['String'];
};


export type GqlQueryGetMarketplaceProductLocationStatsArgs = {
  bounds: GqlGeographicSearchBounds;
  marketplaceProductId: Scalars['ID'];
};


export type GqlQueryGetMenuSectionsArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetMenuSectionsAdminArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetMonerisTokenizationProfileArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetMostPurchasedProductsArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetOrderArgs = {
  id: Scalars['String'];
};


export type GqlQueryGetOrderForDeliveryArgs = {
  id: Scalars['String'];
};


export type GqlQueryGetOrdersArgs = {
  input: GqlGetOrdersInput;
};


export type GqlQueryGetPaymentStatusArgs = {
  paymentId: Scalars['String'];
};


export type GqlQueryGetPaymentsCheckoutCredentialsArgs = {
  adapter: Scalars['String'];
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetPersonalizedProductsArgs = {
  input: GqlGetPersonalizedProductsInput;
};


export type GqlQueryGetPersonalizedProductsV2Args = {
  input: GqlGetPersonalizedProductsV2Input;
};


export type GqlQueryGetPlusApiKeysArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetPlusEnterpriseApiKeysArgs = {
  enterpriseId: Scalars['String'];
};


export type GqlQueryGetPlusOAuthProvidersArgs = {
  enterpriseId: Scalars['String'];
};


export type GqlQueryGetPopularDispensariesArgs = {
  lat: Scalars['String'];
  lon: Scalars['String'];
};


export type GqlQueryGetPosMedCardInfoArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetProductBuyingOptionsArgs = {
  bounds: GqlGeographicSearchBounds;
  marketplaceProductId: Scalars['String'];
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<StringSortDirections>;
  weights?: InputMaybe<Array<Scalars['String']>>;
};


export type GqlQueryGetProductDemandCountsArgs = {
  dispensaryId: Scalars['String'];
  productIds: Array<Scalars['String']>;
};


export type GqlQueryGetProductSalesByCategoryArgs = {
  input: GqlSharedSalesInput;
};


export type GqlQueryGetPromoArgs = {
  id: Scalars['String'];
  recipient: Scalars['String'];
};


export type GqlQueryGetPublicContextSessionArgs = {
  id: Scalars['String'];
};


export type GqlQueryGetPurchaseOrdersArgs = {
  filters?: InputMaybe<GqlPurchaseOrdersFilterInput>;
};


export type GqlQueryGetRawAchBatchFileArgs = {
  achBatchId: Scalars['String'];
};


export type GqlQueryGetRecentlyViewedProductsArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetRecentlyViewedProductsV2Args = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetRecommendedProductsArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetRemoteIntegrationValueArgs = {
  dispensaryId: Scalars['String'];
  key: Scalars['String'];
};


export type GqlQueryGetReportingBrandsArgs = {
  filters?: InputMaybe<GqlReportingBrandsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
};


export type GqlQueryGetReservationSlotsByOrderTypeArgs = {
  dispensaryId: Scalars['ID'];
  reservationType?: InputMaybe<Scalars['String']>;
};


export type GqlQueryGetRetailerArgs = {
  id: Scalars['ID'];
};


export type GqlQueryGetRetailerByDispensaryIdArgs = {
  dispensaryIds: Array<Scalars['ID']>;
};


export type GqlQueryGetRetailerEnrollmentStatusArgs = {
  entityId: Scalars['String'];
  entityType: EntityTypes;
};


export type GqlQueryGetRetailersByEnterpriseIdArgs = {
  enterpriseIds: Array<Scalars['ID']>;
};


export type GqlQueryGetRewardsV2Args = {
  customerId?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  enterpriseId?: InputMaybe<Scalars['String']>;
  isoRegionCode?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  pin?: InputMaybe<Scalars['String']>;
};


export type GqlQueryGetSortedProductRecommendationsArgs = {
  input: GqlGetSortedProductRecommendationsInput;
};


export type GqlQueryGetSpecialGamificationArgs = {
  dispensaryId?: InputMaybe<Scalars['String']>;
  menuType?: InputMaybe<Scalars['String']>;
  specialIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GqlQueryGetSpecialMenuCardsArgs = {
  dispensaryId: Scalars['ID'];
  menuType: Scalars['String'];
  specialId?: InputMaybe<Scalars['String']>;
};


export type GqlQueryGetSpecialsHistoryArgs = {
  specialId: Scalars['ID'];
};


export type GqlQueryGetSponsoredBrandArgs = {
  input: GqlGetSponsoredBrandInput;
};


export type GqlQueryGetSponsoredProductsArgs = {
  input: GqlGetSponsoredProductsInput;
};


export type GqlQueryGetStockImageArgs = {
  category?: InputMaybe<Scalars['String']>;
  productName?: InputMaybe<Scalars['String']>;
};


export type GqlQueryGetStrainArgs = {
  id: Scalars['String'];
};


export type GqlQueryGetSubscriptionsV2Args = {
  retailers: Array<InputMaybe<GqlRetailerInput>>;
};


export type GqlQueryGetTerpeneArgs = {
  id: Scalars['String'];
};


export type GqlQueryGetTimezoneArgs = {
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  timeStamp?: InputMaybe<Scalars['Int']>;
};


export type GqlQueryGetTopProductArgs = {
  input: GqlSharedSalesInput;
};


export type GqlQueryGetTrackedCartArgs = {
  checkoutToken: Scalars['String'];
  dispensaryId: Scalars['String'];
};


export type GqlQueryGetTrendingBrandsArgs = {
  input: GqlBrandsSummaryInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetUserIncentiveEligibilityArgs = {
  dispensaryId?: InputMaybe<Scalars['String']>;
  externalId: Scalars['String'];
};


export type GqlQueryGetUserQueryArgs = {
  id: Scalars['String'];
};


export type GqlQueryHubspotCrmPropertiesArgs = {
  integrationId?: InputMaybe<Scalars['String']>;
};


export type GqlQueryHubspotPipelinePropertiesArgs = {
  integrationId?: InputMaybe<Scalars['String']>;
};


export type GqlQueryLibraryProductChangeImpactV2Args = {
  id: Scalars['String'];
  updates: GqlUpdatedLibraryProduct;
};


export type GqlQueryListAccountBalancesArgs = {
  userId: Scalars['String'];
};


export type GqlQueryListAchBatchesArgs = {
  effectiveEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  effectiveStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  fileName?: InputMaybe<Scalars['String']>;
  generatedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  generatedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  processedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  processedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  status?: InputMaybe<Scalars['String']>;
  submittedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  submittedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
};


export type GqlQueryListAchEntriesArgs = {
  effectiveEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  effectiveStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  fileName?: InputMaybe<Scalars['String']>;
  sequenceNumber?: InputMaybe<Scalars['Int']>;
  submittedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  submittedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  traceNumber?: InputMaybe<Scalars['String']>;
};


export type GqlQueryListAchEntriesV3Args = {
  effectiveEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  effectiveStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  fileName?: InputMaybe<Scalars['String']>;
  retailerName?: InputMaybe<Scalars['String']>;
  sequenceNumber?: InputMaybe<Scalars['Int']>;
  submittedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  submittedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  traceNumber?: InputMaybe<Scalars['Int']>;
};


export type GqlQueryListAchEntriesV4Args = {
  achBatchId?: InputMaybe<Scalars['String']>;
  effectiveEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  effectiveStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  fileName?: InputMaybe<Scalars['String']>;
  receiverName?: InputMaybe<Scalars['String']>;
  retailerName?: InputMaybe<Scalars['String']>;
  sequenceNumber?: InputMaybe<Scalars['Int']>;
  submittedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  submittedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  traceNumber?: InputMaybe<Scalars['String']>;
};


export type GqlQueryListAchReturnsArgs = {
  achEntryId?: InputMaybe<Scalars['String']>;
  originalTraceNumber?: InputMaybe<Scalars['String']>;
  responded?: InputMaybe<Scalars['Boolean']>;
  returnCode?: InputMaybe<Scalars['String']>;
  returnTraceNumber?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['String']>;
};


export type GqlQueryListAchReturnsV3Args = {
  achEntryId?: InputMaybe<Scalars['String']>;
  originalTraceNumber?: InputMaybe<Scalars['Int']>;
  responded?: InputMaybe<Scalars['Boolean']>;
  returnCode?: InputMaybe<Scalars['String']>;
  returnTraceNumber?: InputMaybe<Scalars['Int']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['String']>;
};


export type GqlQueryListAchReturnsV4Args = {
  achEntryId?: InputMaybe<Scalars['String']>;
  originalTraceNumber?: InputMaybe<Scalars['String']>;
  responded?: InputMaybe<Scalars['Boolean']>;
  returnCode?: InputMaybe<Scalars['String']>;
  returnTraceNumber?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['String']>;
};


export type GqlQueryListAchReturnsV5Args = {
  achEntryId?: InputMaybe<Scalars['String']>;
  originalTraceNumber?: InputMaybe<Scalars['String']>;
  responded?: InputMaybe<Scalars['Boolean']>;
  returnCode?: InputMaybe<Scalars['String']>;
  returnTraceNumber?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['String']>;
};


export type GqlQueryListBankAccountsArgs = {
  aggregator: Scalars['String'];
};


export type GqlQueryListBrandsArgs = {
  filters?: InputMaybe<GqlListBrandsFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlListBrandsSort>;
};


export type GqlQueryListEntitiesArgs = {
  externalType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};


export type GqlQueryListEntityFraudAssessmentsArgs = {
  externalId: Scalars['String'];
  externalType: Scalars['String'];
};


export type GqlQueryListLibraryProductsArgs = {
  filters?: InputMaybe<GqlListLibraryProductsFilters>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlListLibraryProductsSort>;
};


export type GqlQueryListLoyaltyPassDispensariesArgs = {
  lspGlobalIds?: InputMaybe<Array<Scalars['String']>>;
  lspIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type GqlQueryListRetailerPaymentTypesStatusArgs = {
  ecommLocationId: Scalars['String'];
};


export type GqlQueryListTransactionFraudAssessmentsArgs = {
  transactionId: Scalars['String'];
  transactionType: Scalars['String'];
};


export type GqlQueryMatchLibraryProductsArgs = {
  brand?: InputMaybe<Scalars['String']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  category?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  productTemplate?: InputMaybe<Scalars['Boolean']>;
  state: Scalars['String'];
  subcategory?: InputMaybe<Scalars['String']>;
};


export type GqlQueryMatchLibraryProductsV2Args = {
  brand?: InputMaybe<Scalars['String']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  category?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  state: Scalars['String'];
  subcategory?: InputMaybe<Scalars['String']>;
};


export type GqlQueryMatchingProductsArgs = {
  bypassOnlineThresholds?: InputMaybe<Scalars['Boolean']>;
  dispensaryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  productLibraryState?: InputMaybe<Scalars['String']>;
};


export type GqlQueryMenuFiltersArgs = {
  category?: InputMaybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  pricingType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type GqlQueryMenuFiltersV2Args = {
  category?: InputMaybe<Scalars['String']>;
  checkMinSpendOffers?: InputMaybe<Scalars['Boolean']>;
  collectionId?: InputMaybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  hasProductsOnSpecial?: InputMaybe<Scalars['Boolean']>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']>;
  isKioskMenu?: InputMaybe<Scalars['Boolean']>;
  isOnSpecial?: InputMaybe<Scalars['Boolean']>;
  pricingType?: InputMaybe<MenuPricingTypes>;
  search?: InputMaybe<Scalars['String']>;
  showAllSpecialProducts?: InputMaybe<Scalars['Boolean']>;
  specialId?: InputMaybe<Scalars['String']>;
  specialType?: InputMaybe<Scalars['String']>;
};


export type GqlQueryPendingDispensariesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  searchStr?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<GqlSortInput>;
};


export type GqlQueryPrintJobArgs = {
  id: Scalars['String'];
};


export type GqlQueryPrintersArgs = {
  dispensaryId: Scalars['String'];
};


export type GqlQueryProductChangeEventsArgs = {
  productId: Scalars['ID'];
};


export type GqlQuerySalesOrdersQueryArgs = {
  input: GqlSharedSalesInput;
};


export type GqlQuerySearchBrandOverviewLspsArgs = {
  brandId: Scalars['ID'];
  filters?: InputMaybe<GqlBrandOverviewLspsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search: Scalars['String'];
};


export type GqlQuerySearchBrandsV2Args = {
  filters?: InputMaybe<GqlSearchBrandsFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<GqlSearchBrandsSort>;
};


export type GqlQuerySearchBucketProductsArgs = {
  filter?: InputMaybe<GqlSearchBucketProductFilter>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlSearchBucketProductSort>;
};


export type GqlQuerySearchEnterpriseByNameArgs = {
  keyword: Scalars['String'];
};


export type GqlQuerySearchLibraryProductsArgs = {
  filters?: InputMaybe<GqlSearchLibraryProductsFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<GqlSearchLibraryProductsSort>;
};


export type GqlQuerySearchLspBrandsArgs = {
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<GqlLspBrandSearchSort>;
};


export type GqlQuerySearchProductChangeRequestsArgs = {
  filters?: InputMaybe<GqlContentChangeRequestFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlContentChangeRequestSort>;
};


export type GqlQuerySearchProductFiltersArgs = {
  bounds: GqlGeographicSearchBounds;
};


export type GqlQuerySearchProductsArgs = {
  filters: GqlSearchProductsInput;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<StringSortDirections>;
};


export type GqlQuerySecureImageUrlV2Args = {
  id: Scalars['String'];
};


export type GqlQueryStartAggregatorLinkArgs = {
  aggregator: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  linkCustomizationName?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  redirectUrl?: InputMaybe<Scalars['String']>;
};


export type GqlQueryStartAggregatorLinkV2Args = {
  aggregator: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  linkCustomizationName?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
};


export type GqlQuerySuperAdminCustomersArgs = {
  filter?: InputMaybe<GqlSuperAdminCustomersFilter>;
  pagination?: InputMaybe<GqlCustomersPaginationInput>;
  sort?: InputMaybe<GqlCustomersSortInput>;
};


export type GqlQuerySuperProductsArgs = {
  filter?: InputMaybe<GqlSuperProductsInput>;
};


export type GqlQueryTestPlusOAuthProvidersArgs = {
  enterpriseId: Scalars['String'];
};


export type GqlQueryUnsubscribeCustomerQueryArgs = {
  customerId: Scalars['String'];
};


export type GqlQueryUserExistsCheckArgs = {
  input?: InputMaybe<GqlUserIdExistsInput>;
};


export type GqlQueryValidateCouponQueryArgs = {
  code: Scalars['String'];
  dispensaryId: Scalars['String'];
  isReapplying?: InputMaybe<Scalars['Boolean']>;
  orderSubtotalInCents: Scalars['Int'];
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  products?: InputMaybe<Array<InputMaybe<GqlCouponValidationProductInput>>>;
};


export type GqlQueryValidatePasswordResetTokenQueryArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type GqlQueryValidatePasswordTokenQueryArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type GqlQueryVerifyMxMemberArgs = {
  entityId: Scalars['String'];
  entityType: EntityTypes;
  isMobileApp?: InputMaybe<Scalars['Boolean']>;
  memberGuid: Scalars['String'];
};

export type GqlRadius = {
  __typename?: 'Radius';
  default?: Maybe<RadiusOption>;
};

export type GqlRadiusInput = {
  default?: InputMaybe<RadiusOption>;
};

export enum RadiusOption {
  rounded = 'ROUNDED',
  roundedRectangle = 'ROUNDED_RECTANGLE',
  square = 'SQUARE'
}

export enum RangeBehaviors {
  betweenXAndY = 'BETWEEN_X_AND_Y',
  everyX = 'EVERY_X',
  fromXToY = 'FROM_X_TO_Y'
}

export type GqlRecordUserAcceptanceResponse = {
  __typename?: 'RecordUserAcceptanceResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type GqlRedemptionInput = {
  dispensaryId: Scalars['String'];
  phoneNumber: Scalars['String'];
  program: Scalars['String'];
  rewardId: Scalars['String'];
  rewardType: Scalars['String'];
};

export type GqlRegion = {
  __typename?: 'Region';
  code: Scalars['String'];
  country: Scalars['String'];
  countryName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  subdivision?: Maybe<Scalars['String']>;
  subdivisionName?: Maybe<Scalars['String']>;
};

export enum RejectionReasons {
  compliance = 'compliance',
  incompleteInfo = 'incomplete_info',
  photoGuidelines = 'photo_guidelines'
}

export type GqlRemoteExtensions = {
  __typename?: 'RemoteExtensions';
  builderKey?: Maybe<Scalars['String']>;
  theme?: Maybe<GqlRemoteExtensionsConfiguration>;
};

export type GqlRemoteExtensionsConfiguration = {
  __typename?: 'RemoteExtensionsConfiguration';
  extensionData?: Maybe<Array<GqlExtensionData>>;
  manifestUrl?: Maybe<Scalars['String']>;
  modulePath?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
};

export type GqlRemoteExtensionsInput = {
  extensionData?: InputMaybe<Array<GqlExtensionDataInput>>;
  manifestUrl: Scalars['String'];
  modulePath: Scalars['String'];
  scope: Scalars['String'];
};

export type GqlReportingBrand = {
  __typename?: 'ReportingBrand';
  brandId: Scalars['ID'];
  name: Scalars['String'];
  parentBrandId?: Maybe<Scalars['ID']>;
};

export type GqlReportingBrands = {
  __typename?: 'ReportingBrands';
  brands: Array<GqlReportingBrand>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlReportingBrandsFilterInput = {
  parentBrandsOnly?: InputMaybe<Scalars['Boolean']>;
};

export type GqlReservationConfig = {
  __typename?: 'ReservationConfig';
  /** @deprecated replaced by reservationsAvailableByOrderType */
  delivery?: Maybe<GqlReservationOptionsForOrderType>;
  /** @deprecated replaced by orderTypesConfigV2 */
  enabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated replaced by reservationsAvailableByOrderType */
  pickup?: Maybe<GqlReservationOptionsForOrderType>;
};

export type GqlReservationConfigInput = {
  delivery?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  pickup?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
};

export type GqlReservationOptionsForOrderType = {
  __typename?: 'ReservationOptionsForOrderType';
  advancedDayOrderingEnabled?: Maybe<Scalars['Boolean']>;
  advancedDayOrderingLimit?: Maybe<Scalars['Int']>;
  incrementInMinutes?: Maybe<Scalars['Int']>;
  maxReservationSlotsByDate?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  maxReservationSlotsByDay?: Maybe<GqlMaxReservationSlotsByDay>;
  nextAvailableInMinutes?: Maybe<Scalars['Int']>;
  orderLimitsEnabled?: Maybe<Scalars['Boolean']>;
  sameDayDeliveryEnabled?: Maybe<Scalars['Boolean']>;
};

export type GqlReservationOptionsForOrderTypeInput = {
  advancedDayOrderingEnabled?: InputMaybe<Scalars['Boolean']>;
  advancedDayOrderingLimit?: InputMaybe<Scalars['Int']>;
  incrementInMinutes: Scalars['Int'];
  maxReservationSlotsByDate?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  maxReservationSlotsByDay?: InputMaybe<GqlMaxReservationSlotsByDayInput>;
  nextAvailableInMinutes: Scalars['Int'];
  orderLimitsEnabled?: InputMaybe<Scalars['Boolean']>;
  sameDayDeliveryEnabled?: InputMaybe<Scalars['Boolean']>;
};

export enum ReservationSlotTypes {
  all = 'all',
  curbsidePickup = 'curbsidePickup',
  delivery = 'delivery',
  driveThruPickup = 'driveThruPickup',
  inStorePickup = 'inStorePickup'
}

export type GqlReservationSlotsCreateInput = {
  curbsidePickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  delivery?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  deliveryMode?: InputMaybe<Scalars['String']>;
  deliveryZones?: InputMaybe<Array<InputMaybe<GqlDeliveryZonesInputV2>>>;
  dispensaryId: Scalars['String'];
  driveThruPickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  inStorePickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  orderType?: InputMaybe<ReservationSlotTypes>;
  timezone: Scalars['String'];
};

export type GqlReservationSlotsForOrderType = {
  dayOfWeek?: InputMaybe<Scalars['String']>;
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  isNextDaySlot?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  labelPrefix?: InputMaybe<Scalars['String']>;
  reservation?: InputMaybe<GqlReservationsAvailableForOrderType>;
  startTimeISO?: InputMaybe<Scalars['ISODateTime']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type GqlReservationSlotsInfoForOrderTypeInput = {
  deliveryMode?: InputMaybe<Scalars['String']>;
  deliveryZones?: InputMaybe<Array<InputMaybe<GqlDeliveryZonesInputV2>>>;
  enableASAPOrdering?: InputMaybe<Scalars['Boolean']>;
  enableScheduledOrdering?: InputMaybe<Scalars['Boolean']>;
  hours?: InputMaybe<GqlWeeklyHoursInput>;
  scheduledOrderingConfig?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
  specialHours?: InputMaybe<Array<InputMaybe<GqlSpecialHoursSettingsInput>>>;
};

export type GqlReservationSlotsUpdateInput = {
  curbsidePickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  delivery?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  deliveryZones?: InputMaybe<Array<InputMaybe<GqlDeliveryZonesInputV2>>>;
  dispensaryId: Scalars['String'];
  driveThruPickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  inStorePickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  listOfReservationSlots?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  orderType?: InputMaybe<ReservationSlotTypes>;
  timezone: Scalars['String'];
};

export type GqlReservationsAvailable = {
  __typename?: 'ReservationsAvailable';
  active?: Maybe<Scalars['Boolean']>;
  dayOfWeek?: Maybe<Scalars['String']>;
  deliveryAreaId?: Maybe<Scalars['String']>;
  endTimeISO?: Maybe<Scalars['ISODateTime']>;
  isNextDaySlot?: Maybe<Scalars['Boolean']>;
  quantityRemaining?: Maybe<Scalars['Int']>;
  slotId?: Maybe<Scalars['String']>;
  startTimeISO?: Maybe<Scalars['ISODateTime']>;
};

export type GqlReservationsAvailableByOrderType = {
  __typename?: 'ReservationsAvailableByOrderType';
  curbsidePickup?: Maybe<Array<Maybe<GqlReservationsAvailable>>>;
  delivery?: Maybe<Array<Maybe<GqlReservationsAvailable>>>;
  driveThruPickup?: Maybe<Array<Maybe<GqlReservationsAvailable>>>;
  inStorePickup?: Maybe<Array<Maybe<GqlReservationsAvailable>>>;
  /** @deprecated replaced by inStorePickup via rollout.use-updated-ordering-configurations */
  pickup?: Maybe<Array<Maybe<GqlReservationsAvailable>>>;
};

export type GqlReservationsAvailableForOrderType = {
  dayOfWeek?: InputMaybe<Scalars['String']>;
  deliveryAreaId?: InputMaybe<Scalars['String']>;
  endTimeISO?: InputMaybe<Scalars['ISODateTime']>;
  isNextDaySlot?: InputMaybe<Scalars['Boolean']>;
  quantityRemaining?: InputMaybe<Scalars['Int']>;
  slotId?: InputMaybe<Scalars['String']>;
  startTimeISO?: InputMaybe<Scalars['ISODateTime']>;
};

export type GqlRespondToAchReturnResponse = {
  __typename?: 'RespondToAchReturnResponse';
  achReturnResponse: GqlAchReturnResponse;
};

export enum RestMethods {
  del = 'del',
  get = 'get',
  patch = 'patch',
  post = 'post',
  put = 'put'
}

export type GqlRestriction = {
  discountType?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['String']>;
  weightOperator?: InputMaybe<Scalars['String']>;
};

export enum RestrictionType {
  all = 'ALL',
  brand = 'BRAND',
  category = 'CATEGORY',
  inventoryTag = 'INVENTORY_TAG',
  product = 'PRODUCT',
  productTag = 'PRODUCT_TAG',
  strain = 'STRAIN',
  subcategory = 'SUBCATEGORY',
  vendor = 'VENDOR',
  weight = 'WEIGHT'
}

export type GqlRetailer = {
  __typename?: 'Retailer';
  accountTier?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  assignedToBillingGroup?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  dispensaryId: Scalars['ID'];
  enterprise?: Maybe<GqlEnterprise>;
  enterpriseId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  medLicense?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  profile: GqlRetailerProfile;
  recLicense?: Maybe<Scalars['Boolean']>;
  status: RetailerStatus;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
};

export type GqlRetailerEnrollment = {
  __typename?: 'RetailerEnrollment';
  enrollment?: Maybe<GqlStatus>;
};

export type GqlRetailerInput = {
  assignedToBillingGroup?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type GqlRetailerPaymentTypes = {
  __typename?: 'RetailerPaymentTypes';
  paymentTypes: Array<Maybe<GqlPaymentTypeConfig>>;
};

export type GqlRetailerProfile = {
  __typename?: 'RetailerProfile';
  location?: Maybe<GqlRetailerProfileLocation>;
  medicalDispensary?: Maybe<Scalars['Boolean']>;
  recDispensary?: Maybe<Scalars['Boolean']>;
};

export type GqlRetailerProfileLocation = {
  __typename?: 'RetailerProfileLocation';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export enum RetailerStatus {
  archived = 'archived',
  closed = 'closed',
  open = 'open',
  pending = 'pending'
}

export type GqlRethinkStatus = {
  __typename?: 'RethinkStatus';
  status: RethinkStatuses;
};

export enum RethinkStatuses {
  authorized = 'authorized',
  authorizing = 'authorizing',
  cancelled = 'cancelled',
  cancelling = 'cancelling',
  captured = 'captured',
  capturing = 'capturing',
  declined = 'declined',
  failed = 'failed',
  finalized = 'finalized',
  finalizing = 'finalizing',
  new = 'new',
  refundPending = 'refund_pending',
  refunded = 'refunded',
  refunding = 'refunding'
}

export type GqlReversePaymentResponse = {
  __typename?: 'ReversePaymentResponse';
  achReversal: GqlAchReversal;
};

export type GqlReverseSettlementResponse = {
  __typename?: 'ReverseSettlementResponse';
  achReversal: GqlAchReversal;
};

export type GqlReward = {
  __typename?: 'Reward';
  available?: Maybe<Scalars['Boolean']>;
  brand?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Int']>;
  discountId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  operator?: Maybe<Scalars['String']>;
  redemptionAttempts?: Maybe<Array<Maybe<GqlRewardRedemptionResponse>>>;
  rewardType?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GqlRewardInput = {
  available?: InputMaybe<Scalars['Boolean']>;
  brand?: InputMaybe<Scalars['String']>;
  copy?: InputMaybe<Scalars['String']>;
  discountId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<Scalars['String']>;
  rewardType?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export enum RewardRedeemBy {
  dutchie = 'Dutchie',
  pos = 'POS'
}

export type GqlRewardRedemptionDetails = {
  __typename?: 'RewardRedemptionDetails';
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type GqlRewardRedemptionResponse = {
  __typename?: 'RewardRedemptionResponse';
  programResponse?: Maybe<GqlProgramResponse>;
  redeemBy?: Maybe<RewardRedeemBy>;
  status?: Maybe<RewardStatus>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum RewardStatus {
  pending = 'pending',
  redeemed = 'redeemed'
}

export enum RewardType {
  bundle = 'bundle',
  discountBundle = 'discountBundle',
  discountToCart = 'discountToCart',
  item = 'item',
  itemsForADiscount = 'itemsForADiscount',
  itemsForAPrice = 'itemsForAPrice'
}

export type GqlRewardUserResponse = {
  __typename?: 'RewardUserResponse';
  success?: Maybe<Scalars['Boolean']>;
  wallet?: Maybe<GqlRewardsListV2>;
};

export type GqlRewardV2 = {
  __typename?: 'RewardV2';
  available: Scalars['Boolean'];
  brand?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  cost: Scalars['Int'];
  discountId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isRedeemableOnline?: Maybe<Scalars['Boolean']>;
  operator: Scalars['String'];
  redemptionAttempts?: Maybe<Array<Maybe<GqlRewardRedemptionResponse>>>;
  rewardType: Scalars['String'];
  value: Scalars['String'];
};

export type GqlRewardValidationError = {
  __typename?: 'RewardValidationError';
  discountCode?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type GqlRewardsActivity = {
  __typename?: 'RewardsActivity';
  comment?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  isAdjustment?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  lspName?: Maybe<Scalars['String']>;
  orderType?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['Float']>;
  totalPaid?: Maybe<Scalars['Float']>;
  transactionDateUtc?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
};

export type GqlRewardsIntegrationConfigurationInput = {
  rewardsProgramDisplayDescription?: InputMaybe<Scalars['String']>;
  rewardsProgramDisplayEnrollment?: InputMaybe<Scalars['String']>;
  rewardsProgramDisplayName?: InputMaybe<Scalars['String']>;
};

export type GqlRewardsList = {
  __typename?: 'RewardsList';
  auth?: Maybe<GqlUserAuthInfo>;
  balance?: Maybe<Scalars['String']>;
  isLoyaltyMember?: Maybe<Scalars['Boolean']>;
  rewardBrand?: Maybe<Scalars['String']>;
  rewards: Array<Maybe<GqlReward>>;
  userHasWallet?: Maybe<Scalars['Boolean']>;
};

export type GqlRewardsListV2 = {
  __typename?: 'RewardsListV2';
  auth?: Maybe<GqlUserAuthInfo>;
  balance: Scalars['String'];
  currentYearTierBalance?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['String']>;
  isLoyaltyMember?: Maybe<Scalars['Boolean']>;
  posCustomerId?: Maybe<Scalars['String']>;
  rewardBrand: Scalars['String'];
  rewards: Array<Maybe<GqlRewardV2>>;
  rewardsActivity?: Maybe<Array<Maybe<GqlRewardsActivity>>>;
  tierId?: Maybe<Scalars['Int']>;
  tierName?: Maybe<Scalars['String']>;
  userHasWallet: Scalars['Boolean'];
};

export type GqlRewards_Integration_Configuration = {
  __typename?: 'Rewards_integration_configuration';
  rewardsProgramDisplayDescription?: Maybe<Scalars['String']>;
  rewardsProgramDisplayEnrollment?: Maybe<Scalars['String']>;
  rewardsProgramDisplayName?: Maybe<Scalars['String']>;
};

export type GqlRewards_Integration_ConfigurationInput = {
  rewardsProgramDisplayDescription?: InputMaybe<Scalars['String']>;
  rewardsProgramDisplayEnrollment?: InputMaybe<Scalars['String']>;
  rewardsProgramDisplayName?: InputMaybe<Scalars['String']>;
};

export type GqlSaleDiscount = {
  __typename?: 'SaleDiscount';
  _id?: Maybe<Scalars['String']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  discountAmount?: Maybe<Scalars['Float']>;
  discountType?: Maybe<DiscountType>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  exclusions?: Maybe<Array<Maybe<GqlExclusion>>>;
  inventoryTags?: Maybe<Array<Scalars['String']>>;
  productGroup?: Maybe<ProductGroup>;
  productIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  productTags?: Maybe<Array<Scalars['String']>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  weightOperator?: Maybe<WeightOperator>;
  weights?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GqlSaleDiscountInput = {
  _id?: InputMaybe<Scalars['String']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  brandNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  enterpriseProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  exclusions?: InputMaybe<Array<InputMaybe<GqlExclusionInput>>>;
  inventoryTags?: InputMaybe<Array<Scalars['String']>>;
  productGroup?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productTags?: InputMaybe<Array<Scalars['String']>>;
  requiresSingleSku?: InputMaybe<Scalars['Boolean']>;
  strainIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subcategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subcategoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weightOperator?: InputMaybe<ComparisonOperators>;
  weights?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GqlSchedule = {
  __typename?: 'Schedule';
  endDate?: Maybe<Scalars['ISODateTime']>;
  id: Scalars['ID'];
  startDate: Scalars['ISODateTime'];
  timeRanges?: Maybe<Array<GqlTimeRange>>;
};

export type GqlScheduleInput = {
  endDate?: InputMaybe<Scalars['ISODateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['ISODateTime'];
  timeRanges?: InputMaybe<Array<GqlTimeRangeInput>>;
};

export type GqlScheduledOrderingConfigV2 = {
  __typename?: 'ScheduledOrderingConfigV2';
  advancedDayOrderingEnabled?: Maybe<Scalars['Boolean']>;
  advancedDayOrderingLimit?: Maybe<Scalars['Int']>;
  incrementInMinutes?: Maybe<Scalars['Int']>;
  nextAvailableInMinutes?: Maybe<Scalars['Int']>;
  orderLimitsEnabled?: Maybe<Scalars['Boolean']>;
  sameDayDeliveryEnabled?: Maybe<Scalars['Boolean']>;
};

export type GqlSearchBucketProductFilter = {
  endTime?: InputMaybe<Scalars['ISODateTime']>;
  reviewedBy?: InputMaybe<Scalars['ID']>;
  startTime?: InputMaybe<Scalars['ISODateTime']>;
  verified?: InputMaybe<Scalars['String']>;
};

export type GqlSearchBucketProductSort = {
  sortBy: SearchBucketProductSortByEnum;
  sortDirection: StringSortDirections;
};

export enum SearchBucketProductSortByEnum {
  reviewedAt = 'reviewedAt'
}

export type GqlSearchBucketProductsResponse = {
  __typename?: 'SearchBucketProductsResponse';
  bucketProducts?: Maybe<Array<Maybe<GqlBucketProduct>>>;
  meta?: Maybe<GqlBucketProductsMeta>;
};

export type GqlSearchProductCategoryFilter = {
  __typename?: 'SearchProductCategoryFilter';
  brands?: Maybe<Array<GqlSearchProductFilterBrand>>;
  category: ProductCategory;
  consumerTypes?: Maybe<Array<ProductConsumerType>>;
  src: Scalars['String'];
  strainTypes?: Maybe<Array<Scalars['String']>>;
  subcategories?: Maybe<Array<Scalars['String']>>;
  weights?: Maybe<Array<Scalars['String']>>;
};

export type GqlSearchProductFilterBrand = {
  __typename?: 'SearchProductFilterBrand';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Input object for the searchProducts query */
export type GqlSearchProductsInput = {
  bounds: GqlGeographicSearchBounds;
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  cannabisTypes?: InputMaybe<Array<CannabisType>>;
  categories: Array<ProductCategory>;
  cbdPotency?: InputMaybe<GqlPotencyProductSearch>;
  consumerType?: InputMaybe<ProductConsumerType>;
  effects?: InputMaybe<Array<Effect>>;
  /** Deprecated: Remove with ticket ENG-14662. This field does nothing. Use cbdPotency and thcPotency instead. */
  potency?: InputMaybe<GqlPotencyProductSearch>;
  subcategories?: InputMaybe<Array<Scalars['String']>>;
  thcPotency?: InputMaybe<GqlPotencyProductSearch>;
  weights?: InputMaybe<Array<Scalars['String']>>;
};

export type GqlSearchProductsMetaResult = {
  __typename?: 'SearchProductsMetaResult';
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

/** Output from the searchProducts query */
export type GqlSearchProductsResult = {
  __typename?: 'SearchProductsResult';
  /** List of products found */
  marketplaceProducts?: Maybe<Array<GqlMarketplaceProductSearchResult>>;
  meta?: Maybe<GqlSearchProductsMetaResult>;
};

export type GqlSegment = {
  __typename?: 'Segment';
  customerCount: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GqlSegmentCondition = {
  __typename?: 'SegmentCondition';
  segmentId: Scalars['String'];
};

export type GqlSeoSettings = {
  __typename?: 'SeoSettings';
  enabled: Scalars['Boolean'];
};

export type GqlSerializableContentChangeRequest = {
  __typename?: 'SerializableContentChangeRequest';
  actionType: ChangeRequestActionType;
  approvalStatus: Scalars['String'];
  approvedAt?: Maybe<Scalars['ISODateTime']>;
  authorId: Scalars['ID'];
  brand?: Maybe<GqlBrand>;
  brandId: Scalars['ID'];
  complianceRegionId?: Maybe<Scalars['ID']>;
  computedAttributes?: Maybe<GqlContentChangeRequestComputedAttributes>;
  contentAttributes?: Maybe<GqlContentChangeRequestAttributes>;
  createdAt: Scalars['ISODateTime'];
  createdBy?: Maybe<GqlUsers>;
  dispensary?: Maybe<GqlDispensaries>;
  feedback?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  product?: Maybe<GqlLibraryProduct>;
  productId?: Maybe<Scalars['ID']>;
  rejectedAt?: Maybe<Scalars['ISODateTime']>;
  reviewerId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['ISODateTime'];
};

export type GqlServiceFeeInput = {
  currency: Scalars['String'];
  flatFeeCents?: InputMaybe<Scalars['Int']>;
  percentageFee?: InputMaybe<Scalars['Float']>;
};

export enum Services {
  acceptancesService = 'AcceptancesService',
  accountBalancesService = 'AccountBalancesService',
  achBatchesService = 'AchBatchesService',
  achEntriesService = 'AchEntriesService',
  achReturnReportsService = 'AchReturnReportsService',
  achReturnsService = 'AchReturnsService',
  achReversalsService = 'AchReversalsService',
  bankAccountsService = 'BankAccountsService',
  billingAddressesService = 'BillingAddressesService',
  customersService = 'CustomersService',
  eligibilityService = 'EligibilityService',
  enrollmentsService = 'EnrollmentsService',
  entitiesService = 'EntitiesService',
  entityLinkingsService = 'EntityLinkingsService',
  fraudAssessmentsService = 'FraudAssessmentsService',
  fraudEventsService = 'FraudEventsService',
  instoreAnalyticsTokensService = 'InstoreAnalyticsTokensService',
  instoreCartsService = 'InstoreCartsService',
  messageProxyService = 'MessageProxyService',
  paymentMethodsService = 'PaymentMethodsService',
  paymentsService = 'PaymentsService',
  preAuthsService = 'PreAuthsService',
  registrationService = 'RegistrationService',
  retailerEnrollmentsService = 'RetailerEnrollmentsService',
  retailerPaymentTypesService = 'RetailerPaymentTypesService',
  walletsService = 'WalletsService',
  widgetUrlService = 'WidgetUrlService'
}

export type GqlSharedSalesInput = {
  chainId?: InputMaybe<Scalars['String']>;
  clientTimezone?: InputMaybe<Scalars['String']>;
  customerType?: InputMaybe<CustomerType>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['String'];
  orderType?: InputMaybe<OrderType>;
  prevEndDate?: InputMaybe<Scalars['String']>;
  prevStartDate?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
};

export type GqlShowEnrollmentResponse = {
  __typename?: 'ShowEnrollmentResponse';
  enrollmentStatus: StatusTypes;
  paymentMethods: Array<Maybe<GqlBankAccountPaymentMethod>>;
  requiresAggregatorMigration?: Maybe<Scalars['Boolean']>;
};

export type GqlShowInstoreCartResponse = {
  __typename?: 'ShowInstoreCartResponse';
  instoreCartData?: Maybe<GqlInstoreCartDataType>;
};

export enum SkipReasonEnum {
  combinedWeights = 'COMBINED_WEIGHTS',
  conflictingData = 'CONFLICTING_DATA',
  insufficientData = 'INSUFFICIENT_DATA',
  libraryGap = 'LIBRARY_GAP',
  libraryGapWithTemplate = 'LIBRARY_GAP_WITH_TEMPLATE',
  other = 'OTHER'
}

export enum SortByOptions {
  sourceBrandProductsCount = 'sourceBrandProductsCount',
  targetBrandProductsCount = 'targetBrandProductsCount'
}

export enum SortDirection {
  asc = 'asc',
  desc = 'desc'
}

export type GqlSortOrderInput = {
  dispensaryId?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<GqlSpecialSortOrder>>>;
};

export type GqlSortProductProxy = {
  DispensaryID: Scalars['String'];
  _id: Scalars['String'];
  weight: Scalars['Int'];
};

export enum SpecialApplicationMethodTypes {
  automatic = 'AUTOMATIC',
  byAlpineiq = 'BY_ALPINEIQ',
  byCode = 'BY_CODE',
  byFyllo = 'BY_FYLLO',
  bySpringbig = 'BY_SPRINGBIG',
  manual = 'MANUAL'
}

export type GqlSpecialEmail = {
  __typename?: 'SpecialEmail';
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  heading?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

export type GqlSpecialEmailInput = {
  description?: InputMaybe<Scalars['String']>;
  descriptionHtml?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  heading?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type GqlSpecialGamificationList = {
  __typename?: 'SpecialGamificationList';
  gamificationThresholds?: Maybe<Array<Maybe<GqlGamificationDetailItem>>>;
};

export type GqlSpecialHours = {
  __typename?: 'SpecialHours';
  endDate: Scalars['String'];
  hoursPerDay?: Maybe<Array<Maybe<GqlSpecialHoursDay>>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['String'];
};

export type GqlSpecialHoursDay = {
  __typename?: 'SpecialHoursDay';
  date: Scalars['String'];
  /** @deprecated new SpecialHoursDay in hours-settings is order type agnostic */
  deliveryHours: GqlDayBounds;
  hours: GqlDayBounds;
  /** @deprecated new SpecialHoursDay in hours-settings is order type agnostic */
  pickupHours: GqlDayBounds;
};

export type GqlSpecialHoursSettingsDayInput = {
  date: Scalars['String'];
  hours: GqlDayBoundsInput;
};

export type GqlSpecialHoursSettingsInput = {
  endDate: Scalars['String'];
  hoursPerDay?: InputMaybe<Array<InputMaybe<GqlSpecialHoursSettingsDayInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  startDate: Scalars['String'];
};

export type GqlSpecialMenuCard = {
  __typename?: 'SpecialMenuCard';
  _id?: Maybe<Scalars['String']>;
  displayRank?: Maybe<Scalars['Int']>;
  menuDisplayDescription?: Maybe<Scalars['String']>;
  menuDisplayImage?: Maybe<Scalars['String']>;
  menuDisplayName?: Maybe<Scalars['String']>;
  posDiscountId?: Maybe<Scalars['String']>;
  specialType?: Maybe<Scalars['String']>;
};

export type GqlSpecialMenuCardResponse = {
  __typename?: 'SpecialMenuCardResponse';
  menuCards?: Maybe<Array<Maybe<GqlSpecialMenuCard>>>;
};

export type GqlSpecialMenuDisplay = {
  __typename?: 'SpecialMenuDisplay';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type GqlSpecialMenuDisplayInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export enum SpecialMenuType {
  both = 'BOTH',
  medical = 'MEDICAL',
  recreational = 'RECREATIONAL'
}

export type GqlSpecialRestriction = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<GqlRestriction>;
};

export type GqlSpecialRestrictions = {
  __typename?: 'SpecialRestrictions';
  key: Scalars['String'];
  weight?: Maybe<Scalars['String']>;
  weightOperator?: Maybe<Scalars['String']>;
  weights?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GqlSpecialRestrictionsInput = {
  key: Scalars['String'];
  weight?: InputMaybe<Scalars['String']>;
  weightOperator?: InputMaybe<Scalars['String']>;
};

export type GqlSpecialSchedule = {
  __typename?: 'SpecialSchedule';
  days?: Maybe<Array<Maybe<Scalars['Int']>>>;
  endDate?: Maybe<Scalars['ISODateTime']>;
  endStamp?: Maybe<Scalars['ISODateTime']>;
  endTime?: Maybe<Scalars['String']>;
  startStamp?: Maybe<Scalars['ISODateTime']>;
  startTime?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type GqlSpecialScheduleInput = {
  days?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  endDate?: InputMaybe<Scalars['ISODateTime']>;
  endStamp?: InputMaybe<Scalars['ISODateTime']>;
  endTime?: InputMaybe<Scalars['String']>;
  startStamp?: InputMaybe<Scalars['ISODateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export enum SpecialScopes {
  enterprise = 'enterprise',
  retailer = 'retailer'
}

export enum SpecialSortKey {
  email = 'EMAIL',
  endStamp = 'END_STAMP',
  name = 'NAME',
  specialType = 'SPECIAL_TYPE',
  startStamp = 'START_STAMP'
}

export type GqlSpecialSortOrder = {
  _id?: InputMaybe<Scalars['String']>;
  displayRank?: InputMaybe<Scalars['Int']>;
};

export enum SpecialSource {
  dutchie = 'DUTCHIE',
  pos = 'POS'
}

export enum SpecialStatus {
  active = 'ACTIVE',
  archived = 'ARCHIVED'
}

export type GqlSpecialSummary = {
  __typename?: 'SpecialSummary';
  averageOrderValue?: Maybe<Scalars['Float']>;
  averageOrderValueChangePercentage?: Maybe<Scalars['Float']>;
  clickThroughPercentage?: Maybe<Scalars['Float']>;
  conversionChangePercentage?: Maybe<Scalars['Float']>;
  conversionPercentage?: Maybe<Scalars['Float']>;
  dispensaryId?: Maybe<Scalars['String']>;
  emailSent?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  specialId?: Maybe<Scalars['String']>;
  totalSales?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export enum SpecialTemporalStatus {
  past = 'PAST',
  presentOrFuture = 'PRESENT_OR_FUTURE'
}

export enum SpecialType {
  coupon = 'COUPON',
  offer = 'OFFER',
  sale = 'SALE'
}

export enum SpecialTypes {
  bogo = 'bogo',
  sale = 'sale'
}

export type GqlSpecials = {
  __typename?: 'Specials';
  _id?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  applicableToItemsOnSpecial?: Maybe<Scalars['Boolean']>;
  applicationMethod?: Maybe<SpecialApplicationMethodTypes>;
  applyRewardsToConditions?: Maybe<Scalars['Boolean']>;
  applyToNoGroups?: Maybe<Scalars['Boolean']>;
  bogoConditionLogicOperator?: Maybe<Scalars['String']>;
  bogoConditions?: Maybe<Array<Maybe<GqlBogoConditionItem>>>;
  bogoRewardLogicOperator?: Maybe<Scalars['String']>;
  bogoRewards?: Maybe<Array<Maybe<GqlBogoRewardItem>>>;
  clicks?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  complete?: Maybe<Scalars['Boolean']>;
  conditionLogicOperator?: Maybe<LogicOperator>;
  conditions?: Maybe<Array<Maybe<GqlV4Condition>>>;
  consumerGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  consumerTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['String']>;
  directPOSProductIdMapping?: Maybe<Scalars['Boolean']>;
  discount?: Maybe<Scalars['String']>;
  discountBundle?: Maybe<GqlDiscountBundle>;
  discountPrecedence?: Maybe<Scalars['String']>;
  discountStacking?: Maybe<Scalars['Boolean']>;
  discountToCart?: Maybe<GqlDiscountToCart>;
  discountedPrices?: Maybe<Scalars['JSON']>;
  dispensaryId?: Maybe<Scalars['String']>;
  displayRank?: Maybe<Scalars['Int']>;
  dollarDiscount?: Maybe<Scalars['Boolean']>;
  duplicatedFrom?: Maybe<Scalars['String']>;
  eligibleProductOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  email?: Maybe<GqlSpecialEmail>;
  emailSpecial?: Maybe<Scalars['Boolean']>;
  endDay?: Maybe<Scalars['String']>;
  endStamp?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  endedAt?: Maybe<Scalars['String']>;
  endedBy?: Maybe<Scalars['String']>;
  excludeConditionItemsFromRewards?: Maybe<Scalars['Boolean']>;
  excludedProducts?: Maybe<Array<Maybe<GqlSpecialsExcludedProducts>>>;
  firstTimeConsumerOnly?: Maybe<Scalars['Boolean']>;
  generatedByPOS?: Maybe<Scalars['Boolean']>;
  globalApplicationRules?: Maybe<Array<Maybe<GqlApplicationRule>>>;
  globalConditionThresholds?: Maybe<Array<Maybe<GqlGlobalThreshold>>>;
  globalReward?: Maybe<GqlGlobalReward>;
  globalRewardThresholds?: Maybe<Array<Maybe<GqlGlobalThreshold>>>;
  heading?: Maybe<Scalars['String']>;
  inactiveDispensaryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  isAvailableOnline?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  itemsForAPrice?: Maybe<GqlItemsForAPrice>;
  loyaltyPointsToRedeem?: Maybe<Scalars['Int']>;
  manualDefaultApplyTo?: Maybe<ManualDefaultApplyTo>;
  menuDisplay?: Maybe<GqlSpecialMenuDisplay>;
  menuDisplayDescription?: Maybe<Scalars['String']>;
  menuDisplayImage?: Maybe<Scalars['String']>;
  menuDisplayName?: Maybe<Scalars['String']>;
  menuType?: Maybe<Scalars['String']>;
  minorVersion?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nonStackingBehavior?: Maybe<Scalars['String']>;
  orderType?: Maybe<OrderType>;
  origin?: Maybe<Scalars['String']>;
  originId?: Maybe<Scalars['String']>;
  /** @deprecated No longer needed 01/07/25 */
  payByBankIncentiveEnabled?: Maybe<Scalars['Boolean']>;
  paymentRestrictions?: Maybe<GqlPaymentRestrictions>;
  percentDiscount?: Maybe<Scalars['Boolean']>;
  platformType?: Maybe<Array<Maybe<PlatformType>>>;
  preOrderType?: Maybe<Array<Maybe<PreOrderType>>>;
  productDiscounts?: Maybe<Scalars['JSON']>;
  productGroup?: Maybe<Scalars['String']>;
  productGroupRewards?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  quantityUsed?: Maybe<Scalars['Int']>;
  rawPOSWeightMapping?: Maybe<Scalars['Boolean']>;
  recurring?: Maybe<GqlSpecialsRecurring>;
  redemptionLimit?: Maybe<Scalars['Int']>;
  redemptionLimitPerCart?: Maybe<Scalars['Int']>;
  redemptionLimitPerUser?: Maybe<Scalars['Int']>;
  reimbursed?: Maybe<Scalars['Boolean']>;
  requireManagerApproval?: Maybe<Scalars['Boolean']>;
  rewardLogicOperator?: Maybe<LogicOperator>;
  rewards?: Maybe<Array<Maybe<GqlV4Reward>>>;
  saleDiscounts?: Maybe<Array<Maybe<GqlSaleDiscount>>>;
  schedule?: Maybe<GqlSpecialSchedule>;
  scope?: Maybe<SpecialScopes>;
  /** @deprecated No longer needed 11/21/24 */
  skipV4Merge?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  /** @deprecated Use _id instead 5/21/2021 */
  specialId?: Maybe<Scalars['String']>;
  specialRestrictions?: Maybe<Scalars['JSON']>;
  specialType?: Maybe<SpecialTypes>;
  specialVersion?: Maybe<Scalars['Int']>;
  stackingBehavior?: Maybe<Scalars['String']>;
  stackingMode?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  startDay?: Maybe<Scalars['String']>;
  startStamp?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  status?: Maybe<SpecialStatus>;
  subject?: Maybe<Scalars['String']>;
  targetPrice?: Maybe<Scalars['Boolean']>;
  totalAllowedUses?: Maybe<Scalars['Int']>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  /** @deprecated No longer needed 01/07/25 */
  useGreedOptimizedCalculator?: Maybe<Scalars['Boolean']>;
  useLatestCartCalculator?: Maybe<Scalars['Boolean']>;
  useTotalQtyCalcsFix?: Maybe<Scalars['Boolean']>;
  usedBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  version?: Maybe<Scalars['Int']>;
};

export type GqlSpecialsExcludedBogo = {
  __typename?: 'SpecialsExcludedBOGO';
  Name?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

export type GqlSpecialsExcludedBogoInput = {
  Name?: InputMaybe<Scalars['String']>;
  _id?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
};

export type GqlSpecialsExcludedProducts = {
  __typename?: 'SpecialsExcludedProducts';
  Name?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['String']>;
  conditions?: Maybe<Array<Maybe<GqlSpecialsExcludedBogo>>>;
  key?: Maybe<Scalars['String']>;
  rewards?: Maybe<Array<Maybe<GqlSpecialsExcludedBogo>>>;
};

export type GqlSpecialsExcludedProductsInput = {
  Name?: InputMaybe<Scalars['String']>;
  _id?: InputMaybe<Scalars['String']>;
  conditions?: InputMaybe<Array<InputMaybe<GqlSpecialsExcludedBogoInput>>>;
  key?: InputMaybe<Scalars['String']>;
  rewards?: InputMaybe<Array<InputMaybe<GqlSpecialsExcludedBogoInput>>>;
};

export type GqlSpecialsHistory = {
  __typename?: 'SpecialsHistory';
  id?: Maybe<Scalars['String']>;
  versions?: Maybe<Array<Maybe<GqlSpecials>>>;
};

export type GqlSpecialsInputV3 = {
  _id?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  applicableToItemsOnSpecial?: InputMaybe<Scalars['Boolean']>;
  applicationMethod?: InputMaybe<SpecialApplicationMethodTypes>;
  applyRewardsToConditions?: InputMaybe<Scalars['Boolean']>;
  applyToNoGroups?: InputMaybe<Scalars['Boolean']>;
  bogoConditionLogicOperator?: InputMaybe<Scalars['String']>;
  bogoConditions?: InputMaybe<Array<InputMaybe<GqlBogoConditionItemInput>>>;
  bogoRewardLogicOperator?: InputMaybe<Scalars['String']>;
  bogoRewards?: InputMaybe<Array<InputMaybe<GqlBogoRewardItemInput>>>;
  code?: InputMaybe<Scalars['String']>;
  conditionLogicOperator?: InputMaybe<LogicOperator>;
  conditions?: InputMaybe<Array<InputMaybe<GqlV4ConditionInput>>>;
  consumerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['ISODateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionHtml?: InputMaybe<Scalars['String']>;
  directPOSProductIdMapping?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['String']>;
  discountBundle?: InputMaybe<GqlDiscountBundleInput>;
  discountPrecedence?: InputMaybe<Scalars['String']>;
  discountStacking?: InputMaybe<Scalars['Boolean']>;
  discountToCart?: InputMaybe<GqlDiscountToCartInput>;
  discountedPrices?: InputMaybe<Scalars['JSON']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  displayRank?: InputMaybe<Scalars['Int']>;
  dollarDiscount?: InputMaybe<Scalars['Boolean']>;
  duplicatedFrom?: InputMaybe<Scalars['String']>;
  editedStartStamp?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<GqlSpecialEmailInput>;
  emailSpecial?: InputMaybe<Scalars['Boolean']>;
  endDay?: InputMaybe<Scalars['String']>;
  endStamp?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  endedAt?: InputMaybe<Scalars['String']>;
  endedBy?: InputMaybe<Scalars['String']>;
  enterpriseId?: InputMaybe<Scalars['String']>;
  excludeConditionItemsFromRewards?: InputMaybe<Scalars['Boolean']>;
  excludedProducts?: InputMaybe<Array<InputMaybe<GqlSpecialsExcludedProductsInput>>>;
  firstTimeConsumerOnly?: InputMaybe<Scalars['Boolean']>;
  generatedByPOS?: InputMaybe<Scalars['Boolean']>;
  globalApplicationRules?: InputMaybe<Array<InputMaybe<GqlApplicationRuleInput>>>;
  globalConditionThresholds?: InputMaybe<Array<InputMaybe<GqlGlobalThresholdInput>>>;
  globalReward?: InputMaybe<GqlGlobalRewardInput>;
  globalRewardThresholds?: InputMaybe<Array<InputMaybe<GqlGlobalThresholdInput>>>;
  heading?: InputMaybe<Scalars['String']>;
  inactiveDispensaryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isAvailableOnline?: InputMaybe<Scalars['Boolean']>;
  isRecurring?: InputMaybe<Scalars['Boolean']>;
  itemsForAPrice?: InputMaybe<GqlItemsForAPriceInput>;
  loyaltyPointsToRedeem?: InputMaybe<Scalars['Int']>;
  manualDefaultApplyTo?: InputMaybe<ManualDefaultApplyTo>;
  menuDisplay?: InputMaybe<GqlSpecialMenuDisplayInput>;
  menuDisplayDescription?: InputMaybe<Scalars['String']>;
  menuDisplayImage?: InputMaybe<Scalars['String']>;
  menuDisplayName?: InputMaybe<Scalars['String']>;
  menuType?: InputMaybe<Scalars['String']>;
  minorVersion?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nonStackingBehavior?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<OrderType>;
  origin?: InputMaybe<Scalars['String']>;
  originId?: InputMaybe<Scalars['String']>;
  paymentRestrictions?: InputMaybe<GqlPaymentRestrictionsInput>;
  percentDiscount?: InputMaybe<Scalars['Boolean']>;
  platformType?: InputMaybe<Array<InputMaybe<PlatformType>>>;
  preOrderType?: InputMaybe<Array<InputMaybe<PreOrderType>>>;
  productDiscounts?: InputMaybe<Array<InputMaybe<GqlProductDiscount>>>;
  productGroup?: InputMaybe<Scalars['String']>;
  productGroupRewards?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quantityUsed?: InputMaybe<Scalars['Int']>;
  rawPOSWeightMapping?: InputMaybe<Scalars['Boolean']>;
  recurring?: InputMaybe<GqlSpecialsInputRecurring>;
  redemptionLimit?: InputMaybe<Scalars['Int']>;
  redemptionLimitPerCart?: InputMaybe<Scalars['Int']>;
  redemptionLimitPerUser?: InputMaybe<Scalars['Int']>;
  requireManagerApproval?: InputMaybe<Scalars['Boolean']>;
  rewardLogicOperator?: InputMaybe<LogicOperator>;
  rewards?: InputMaybe<Array<InputMaybe<GqlV4RewardInput>>>;
  saleDiscounts?: InputMaybe<Array<InputMaybe<GqlSaleDiscountInput>>>;
  schedule?: InputMaybe<GqlSpecialScheduleInput>;
  scope?: InputMaybe<SpecialScopes>;
  source?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  specialId?: InputMaybe<Scalars['String']>;
  specialRestrictions?: InputMaybe<Array<InputMaybe<GqlSpecialRestriction>>>;
  specialType?: InputMaybe<Scalars['String']>;
  specialVersion?: InputMaybe<Scalars['Int']>;
  stackingBehavior?: InputMaybe<Scalars['String']>;
  stackingMode?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  startDay?: InputMaybe<Scalars['String']>;
  startStamp?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  targetPrice?: InputMaybe<Scalars['Boolean']>;
  totalAllowedUses?: InputMaybe<Scalars['Int']>;
  totalQuantity?: InputMaybe<GqlTotalQuantityInput>;
  totalSpend?: InputMaybe<GqlTotalSpendInput>;
  totalWeight?: InputMaybe<GqlTotalWeightInput>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

export type GqlSpecialsRecurring = {
  __typename?: 'SpecialsRecurring';
  days?: Maybe<Array<Maybe<Scalars['Int']>>>;
  endDate?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  setEndDate?: Maybe<Scalars['Boolean']>;
  startTime?: Maybe<Scalars['String']>;
};

export type GqlSpecialsSettings = {
  __typename?: 'SpecialsSettings';
  discountBehavior?: Maybe<Scalars['String']>;
  discountPrecedence?: Maybe<Scalars['String']>;
  discountStacking?: Maybe<Scalars['Boolean']>;
  enableIndividualDiscountStacking?: Maybe<Scalars['Boolean']>;
  enableIndividualSpecialPrecedence?: Maybe<Scalars['Boolean']>;
  nonStackingBehavior?: Maybe<Scalars['String']>;
  stackingBehavior?: Maybe<Scalars['String']>;
};

export type GqlSpecialsSettingsInput = {
  discountBehavior?: InputMaybe<Scalars['String']>;
  discountPrecedence?: InputMaybe<Scalars['String']>;
  discountStacking?: InputMaybe<Scalars['Boolean']>;
  enableIndividualDiscountStacking?: InputMaybe<Scalars['Boolean']>;
  enableIndividualSpecialPrecedence?: InputMaybe<Scalars['Boolean']>;
  nonStackingBehavior?: InputMaybe<Scalars['String']>;
  stackingBehavior?: InputMaybe<Scalars['String']>;
};

export type GqlSponsoredBrand = {
  __typename?: 'SponsoredBrand';
  campaignId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  products: Array<GqlProducts>;
  trackers: GqlAdTrackers;
};

export type GqlSponsoredProduct = {
  __typename?: 'SponsoredProduct';
  product: GqlProducts;
  trackers: GqlAdTrackers;
};

export enum SponsoredProductsInventoryId {
  cartTopperProductAuc = 'cart_topper_product_auc',
  categoryProductAuc = 'category_product_auc',
  pdpProductAuc = 'pdp_product_auc',
  searchProductAuc = 'search_product_auc'
}

export enum StackingBehavior {
  compounding = 'COMPOUNDING',
  cumulative = 'CUMULATIVE',
  prohibited = 'PROHIBITED'
}

export type GqlStartAggregatorLinkResponse = {
  __typename?: 'StartAggregatorLinkResponse';
  mx: GqlMxLinkStart;
  plaid: GqlPlaidLinkStart;
};

export type GqlStartAggregatorLinkV2Response = {
  __typename?: 'StartAggregatorLinkV2Response';
  aerosync?: Maybe<GqlAeroSyncLinkStart>;
  plaid?: Maybe<GqlPlaidLinkStart>;
};

export type GqlStartPreAuthCheckResponse = {
  __typename?: 'StartPreAuthCheckResponse';
  channelName?: Maybe<Scalars['String']>;
  checkId?: Maybe<Scalars['String']>;
  status: StartPreAuthCheckResponseStatus;
};

export enum StartPreAuthCheckResponseStatus {
  statusFailed = 'STATUS_FAILED',
  statusPending = 'STATUS_PENDING',
  statusReady = 'STATUS_READY',
  statusUnspecified = 'STATUS_UNSPECIFIED'
}

export type GqlState = {
  __typename?: 'State';
  cities: Array<Maybe<Scalars['String']>>;
  country?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type GqlStateLibrary = {
  __typename?: 'StateLibrary';
  id: Scalars['String'];
  name: Scalars['String'];
  state: Scalars['String'];
};

export type GqlStatus = {
  __typename?: 'Status';
  mx?: Maybe<GqlMxResponse>;
  status: StatusTypes;
};

export enum StatusTypes {
  statusAcceptTerms = 'STATUS_ACCEPT_TERMS',
  statusAccountDisconnected = 'STATUS_ACCOUNT_DISCONNECTED',
  statusAccountPending = 'STATUS_ACCOUNT_PENDING',
  statusAggregatorError = 'STATUS_AGGREGATOR_ERROR',
  statusEnrolled = 'STATUS_ENROLLED',
  statusNoAccount = 'STATUS_NO_ACCOUNT',
  statusUnenrolled = 'STATUS_UNENROLLED',
  statusUnspecified = 'STATUS_UNSPECIFIED'
}

export type GqlStockImage = {
  __typename?: 'StockImage';
  aliasOrder?: Maybe<Scalars['Int']>;
  aliasRegex?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  url: Scalars['String'];
};

export type GqlStrain = {
  __typename?: 'Strain';
  /** @deprecated Use id */
  _id?: Maybe<Scalars['String']>;
  aromas?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  description?: Maybe<Scalars['String']>;
  effects?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  potentialHealthBenefits?: Maybe<Array<Maybe<Scalars['String']>>>;
  ratio?: Maybe<Scalars['String']>;
  terpenes?: Maybe<Array<Maybe<GqlTerpene>>>;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
};

export type GqlStrainLabels = {
  __typename?: 'StrainLabels';
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GqlStrainList = {
  __typename?: 'StrainList';
  queryInfo?: Maybe<GqlQueryInfoType>;
  strains?: Maybe<Array<Maybe<GqlStrain>>>;
};

export enum StrainSortByEnum {
  description = 'description',
  effects = 'effects',
  imageUrl = 'imageUrl',
  name = 'name',
  potentialHealthBenefits = 'potentialHealthBenefits'
}

export enum StringSortDirections {
  asc = 'asc',
  desc = 'desc'
}

export type GqlSubscriptionCustomers = {
  __typename?: 'SubscriptionCustomers';
  _id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  dateAdded?: Maybe<Scalars['String']>;
  dispensary?: Maybe<GqlDispensaries>;
  dispensaryId?: Maybe<Scalars['String']>;
  dispensaryName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailOptIn?: Maybe<Scalars['Boolean']>;
  emailSubscription?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  numOrders?: Maybe<Scalars['Float']>;
  orderTotal?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  textSubscription?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type GqlSubscriptionV2 = {
  __typename?: 'SubscriptionV2';
  assignedToBillingGroup?: Maybe<Scalars['Boolean']>;
  chargebeePlan?: Maybe<GqlChargebeePlan>;
  chargebeeSubscription?: Maybe<GqlChargebeeSubscriptionV2>;
  dispensaryBilling?: Maybe<GqlDispensaryBillingV2>;
  id: Scalars['ID'];
  manualPayments?: Maybe<Scalars['Boolean']>;
  retailerId: Scalars['ID'];
};

export type GqlSubscriptionsInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type GqlSubtotalItem = {
  __typename?: 'SubtotalItem';
  name: Scalars['String'];
  valueCents: Scalars['Int'];
};

export type GqlTag = {
  __typename?: 'Tag';
  tagId?: Maybe<Scalars['String']>;
  tagName?: Maybe<Scalars['String']>;
};

export type GqlTaxApplyToInput = {
  hemp?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GqlTaxConfigTaxInput = {
  applyTo?: InputMaybe<GqlTaxApplyToInput>;
  deliveryPolicy?: InputMaybe<Scalars['String']>;
  destinationRate?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  includeStateSalesTaxInDestinationRate?: InputMaybe<Scalars['Boolean']>;
  medical?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  potency?: InputMaybe<Scalars['String']>;
  potencyRate?: InputMaybe<Scalars['Float']>;
  rate?: InputMaybe<Scalars['Float']>;
  recreational?: InputMaybe<Scalars['Boolean']>;
  stages?: InputMaybe<Array<InputMaybe<GqlTaxStageInput>>>;
  taxBasis?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type GqlTaxExistence = {
  __typename?: 'TaxExistence';
  med?: Maybe<GqlTaxExistenceInside>;
  rec?: Maybe<GqlTaxExistenceInside>;
};

export type GqlTaxExistenceInside = {
  __typename?: 'TaxExistenceInside';
  checkout?: Maybe<Scalars['String']>;
  menu?: Maybe<Scalars['String']>;
  pos?: Maybe<Scalars['String']>;
};

export type GqlTaxStageInput = {
  op?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export enum TaxType {
  bottleDeposit = 'bottleDeposit',
  cannabis = 'cannabis',
  sales = 'sales'
}

export type GqlTemporalLocation = {
  __typename?: 'TemporalLocation';
  coordinates?: Maybe<Scalars['JSONObject']>;
  lastUpdatedAt?: Maybe<Scalars['ISODateTime']>;
  nearbyEnabled?: Maybe<Scalars['Boolean']>;
  onDuty?: Maybe<Scalars['Boolean']>;
};

export type GqlTerminalReceiptOptions = {
  __typename?: 'TerminalReceiptOptions';
  birthdate?: Maybe<Scalars['Boolean']>;
  customerNameOption?: Maybe<Scalars['String']>;
  deliveryAddress?: Maybe<Scalars['Boolean']>;
  disableSocialImpact?: Maybe<Scalars['Boolean']>;
  groupLineItemsBy?: Maybe<Scalars['String']>;
  medical?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['Boolean']>;
  potencyInfo?: Maybe<Scalars['Boolean']>;
  sortLineItemsBy?: Maybe<Scalars['String']>;
};

export type GqlTerpene = {
  __typename?: 'Terpene';
  aliasList?: Maybe<Array<Maybe<Scalars['String']>>>;
  aromas?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  description?: Maybe<Scalars['String']>;
  effects?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  potentialHealthBenefits?: Maybe<Array<Maybe<Scalars['String']>>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  strains: Array<Maybe<GqlStrain>>;
  unitSymbol?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
};

export type GqlTestPlusOAuthProviderResponse = {
  __typename?: 'TestPlusOAuthProviderResponse';
  success: Scalars['Boolean'];
};

export type GqlTextTransformInput = {
  buttons?: InputMaybe<TextTransformOption>;
  links?: InputMaybe<TextTransformOption>;
  tags?: InputMaybe<TextTransformOption>;
};

export enum TextTransformOption {
  lower = 'LOWER',
  sentence = 'SENTENCE',
  title = 'TITLE',
  upper = 'UPPER'
}

export type GqlTextTransforms = {
  __typename?: 'TextTransforms';
  buttons?: Maybe<TextTransformOption>;
  links?: Maybe<TextTransformOption>;
  tags?: Maybe<TextTransformOption>;
};

export type GqlThreshold = {
  __typename?: 'Threshold';
  comparisonOperator?: Maybe<ComparisonOperators>;
  price?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  thresholdType?: Maybe<ThresholdType>;
  weight?: Maybe<GqlWeight>;
};

export type GqlThresholdInput = {
  comparisonOperator?: InputMaybe<ComparisonOperators>;
  price?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  thresholdType?: InputMaybe<ThresholdType>;
  weight?: InputMaybe<GqlWeightInput>;
};

export enum ThresholdType {
  price = 'PRICE',
  quantity = 'QUANTITY',
  totalPrice = 'TOTAL_PRICE',
  totalQuantity = 'TOTAL_QUANTITY',
  totalWeight = 'TOTAL_WEIGHT',
  weight = 'WEIGHT'
}

export type GqlTimeRange = {
  __typename?: 'TimeRange';
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['String'];
  id: Scalars['ID'];
  startTime: Scalars['String'];
};

export type GqlTimeRangeInput = {
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};

export type GqlTimeoutConfig = {
  __typename?: 'TimeoutConfig';
  duration?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type GqlTipValueInput = {
  dollar?: InputMaybe<Scalars['Float']>;
};

export type GqlTopProduct = {
  __typename?: 'TopProduct';
  product?: Maybe<GqlProducts>;
  total?: Maybe<Scalars['Float']>;
};

export type GqlTotalQuantity = {
  __typename?: 'TotalQuantity';
  enabled: Scalars['Boolean'];
  maxQuantity?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  quantityOperator?: Maybe<ComparisonOperators>;
};

export type GqlTotalQuantityInput = {
  enabled: Scalars['Boolean'];
  maxQuantity?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  quantityOperator: ComparisonOperators;
};

export type GqlTotalSpend = {
  __typename?: 'TotalSpend';
  enabled: Scalars['Boolean'];
  maximumSpend?: Maybe<Scalars['Float']>;
  minimumSpend?: Maybe<Scalars['Float']>;
  spendOperator?: Maybe<ComparisonOperators>;
};

export type GqlTotalSpendInput = {
  enabled: Scalars['Boolean'];
  maximumSpend?: InputMaybe<Scalars['Float']>;
  minimumSpend: Scalars['Float'];
  spendOperator: ComparisonOperators;
};

export type GqlTotalWeight = {
  __typename?: 'TotalWeight';
  enabled: Scalars['Boolean'];
  weight?: Maybe<Scalars['String']>;
  weightOperator?: Maybe<ComparisonOperators>;
};

export type GqlTotalWeightInput = {
  enabled: Scalars['Boolean'];
  weight: Scalars['String'];
  weightOperator: ComparisonOperators;
};

export type GqlTrackedCart = {
  __typename?: 'TrackedCart';
  createdAt?: Maybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  order?: Maybe<Scalars['JSON']>;
  token: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
};

export type GqlTrending = {
  __typename?: 'Trending';
  brandId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  dollarHistoryThisPeriod?: Maybe<Array<Maybe<GqlChangeHistoryObject>>>;
  percentChangeFromLastPeriod?: Maybe<Scalars['Float']>;
};

export type GqlTrendingBrandsResponse = {
  __typename?: 'TrendingBrandsResponse';
  meta?: Maybe<GqlAnalyticsMeta>;
  trending?: Maybe<Array<Maybe<GqlTrending>>>;
};

export type GqlUnenrollEnrollmentResponse = {
  __typename?: 'UnenrollEnrollmentResponse';
  success: Scalars['Boolean'];
};

export enum UnitOfMeasure {
  grams = 'grams',
  items = 'items',
  kilograms = 'kilograms',
  milligrams = 'milligrams',
  milliliters = 'milliliters',
  ounces = 'ounces',
  pounds = 'pounds'
}

export type GqlUpdateBillingGroupInput = {
  enterpriseId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  notificationEmails: Array<InputMaybe<Scalars['String']>>;
  payment: GqlPaymentMethodInput;
  retailers: Array<InputMaybe<Scalars['ID']>>;
};

export type GqlUpdateCollectionInput = {
  allConditions: Scalars['Boolean'];
  cardBadgeColor?: InputMaybe<Scalars['String']>;
  cardBadgeEnabled: Scalars['Boolean'];
  cardBadgeTitle?: InputMaybe<Scalars['String']>;
  conditions: Array<InputMaybe<GqlUpdateConditionInput>>;
  customCategory?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['String']>;
  navigationEnabled: Scalars['Boolean'];
  navigationTitle?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  schedule?: InputMaybe<GqlScheduleInput>;
  title: Scalars['String'];
};

export type GqlUpdateCollectionPositionsInput = {
  productCollections: Array<GqlCollectionPositionsInput>;
};

export type GqlUpdateConditionInput = {
  condition: Scalars['String'];
  id: Scalars['ID'];
  itemKey: Scalars['String'];
  itemValue: Scalars['String'];
  productCollectionId: Scalars['String'];
};

export type GqlUpdateEnterpriseAdSettingsResponse = {
  __typename?: 'UpdateEnterpriseAdSettingsResponse';
  adSettings: GqlDispensaryAdSettings;
};

export type GqlUpdateEnterprisePersonalizationSettingsResponse = {
  __typename?: 'UpdateEnterprisePersonalizationSettingsResponse';
  personalizationSettings: GqlDispensaryPersonalizationSettings;
};

export type GqlUpdateImageBannerInput = {
  _id: Scalars['String'];
  alt?: InputMaybe<Scalars['String']>;
  image: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated Use platforms.link instead */
  link?: InputMaybe<Scalars['String']>;
  mobileImage: Scalars['String'];
  /** @deprecated Use platforms.openInNewTab instead */
  openInNewTab?: InputMaybe<Scalars['Boolean']>;
  platforms?: InputMaybe<Array<InputMaybe<GqlImageBannerPlatformInput>>>;
  position: Scalars['Int'];
  schedule?: InputMaybe<GqlScheduleInput>;
};

export type GqlUpdateImageBannersInput = {
  imageBanners: Array<InputMaybe<GqlUpdateImageBannerInput>>;
};

export type GqlUpdateLibraryProductResponse = {
  __typename?: 'UpdateLibraryProductResponse';
  libraryProduct?: Maybe<GqlLibraryProduct>;
};

export type GqlUpdatePrinterInput = {
  deviceIdentifier: Scalars['String'];
  error?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  queueConfig?: InputMaybe<GqlPrinterQueueConfigInput>;
  status?: InputMaybe<Scalars['String']>;
};

export type GqlUpdateRemoteExtensionsInput = {
  builderKey?: InputMaybe<Scalars['String']>;
  theme: GqlRemoteExtensionsInput;
};

export type GqlUpdateSeoSettingsInput = {
  enabled: Scalars['Boolean'];
};

export type GqlUpdateSingleDispensaryAdSettingsResponse = {
  __typename?: 'UpdateSingleDispensaryAdSettingsResponse';
  adSettings?: Maybe<GqlDispensaryAdSettings>;
  id: Scalars['String'];
};

export type GqlUpdateSingleDispensaryPersonalizationSettingsResponse = {
  __typename?: 'UpdateSingleDispensaryPersonalizationSettingsResponse';
  id: Scalars['String'];
  personalizationSettings?: Maybe<GqlDispensaryPersonalizationSettings>;
};

export type GqlUpdateWebCustomizationSettingsInput = {
  colorSettings: GqlColorSettingsInputV2;
  fontSettings: GqlFontSettingsInput;
};

export type GqlUpdateWebCustomizationSettingsV2Input = {
  categories?: InputMaybe<GqlCategoriesInput>;
  colors?: InputMaybe<GqlColorInput>;
  fonts?: InputMaybe<GqlFontInput>;
  productCards?: InputMaybe<GqlProductCardsInput>;
  radius?: InputMaybe<GqlRadiusInput>;
  textTransforms?: InputMaybe<GqlTextTransformInput>;
};

export type GqlUpdatedLibraryProduct = {
  AdditionalOptions?: InputMaybe<Array<Scalars['String']>>;
  CBD?: InputMaybe<Scalars['String']>;
  CBDContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  Description: Scalars['String'];
  DispensaryID?: InputMaybe<Scalars['String']>;
  Image?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  Options?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Prices?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  Status?: InputMaybe<Scalars['String']>;
  THC?: InputMaybe<Scalars['String']>;
  THCContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  _id?: InputMaybe<Scalars['String']>;
  bottleDepositTaxCents?: InputMaybe<Scalars['Int']>;
  brandId?: InputMaybe<Scalars['String']>;
  cannabinoids?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  cannabinoidsV2?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  comingSoon?: InputMaybe<Scalars['Boolean']>;
  complianceRegionId?: InputMaybe<Scalars['String']>;
  connectedCount?: InputMaybe<Scalars['Int']>;
  descriptionHtml?: InputMaybe<Scalars['String']>;
  duplicatedProductId?: InputMaybe<Scalars['String']>;
  effects?: InputMaybe<Scalars['JSON']>;
  flavors?: InputMaybe<Array<Scalars['String']>>;
  gtin?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<InputMaybe<GqlProducts_ImagesInput>>>;
  integrationKey?: InputMaybe<Scalars['String']>;
  limitsPerCustomer?: InputMaybe<Array<GqlLibraryProductLimitPerCustomerInput>>;
  manualInventory?: InputMaybe<Array<GqlLibraryProductManualInventoryInput>>;
  medicalOnly?: InputMaybe<Scalars['Boolean']>;
  medicalPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  productTemplate?: InputMaybe<Scalars['Boolean']>;
  rawOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  recOnly?: InputMaybe<Scalars['Boolean']>;
  recPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  sku?: InputMaybe<Scalars['String']>;
  stockImage?: InputMaybe<Scalars['String']>;
  stockImageAliases?: InputMaybe<Scalars['String']>;
  stockImageCategory?: InputMaybe<Scalars['String']>;
  strainType?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  terpenes?: InputMaybe<Array<GqlLibraryProductTerpenesInput>>;
  type?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type GqlUserAuthInfo = {
  __typename?: 'UserAuthInfo';
  authTextMessageSent?: Maybe<Scalars['Boolean']>;
  incorrectPinProvided?: Maybe<Scalars['Boolean']>;
  pinConfirmed?: Maybe<Scalars['Boolean']>;
};

export type GqlUserEmails = {
  __typename?: 'UserEmails';
  address: Scalars['String'];
  lastVerifiedAt?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type GqlUserEnrollment = {
  __typename?: 'UserEnrollment';
  bankAccounts: Array<GqlBankAccount>;
  enrollment?: Maybe<GqlStatus>;
};

export enum UserRoles {
  super = 'SUPER',
  user = 'USER'
}

export type GqlUsers = {
  __typename?: 'Users';
  _id?: Maybe<Scalars['String']>;
  audioNotificationsOnNewArrivalsDisabled?: Maybe<Scalars['Boolean']>;
  audioNotificationsOnNewOrdersDisabled?: Maybe<Scalars['Boolean']>;
  chainID?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  dispensaryId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailOptIn?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  isWeeklyReportEnabled?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  permissions?: Maybe<GqlUsers_Permissions>;
  phone?: Maybe<Scalars['String']>;
  roleAtDispensary?: Maybe<DispensaryRoles>;
  /** @deprecated no longer sending admin text notifications */
  textNotifications?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type GqlUsers_Permissions = {
  __typename?: 'Users_permissions';
  allLocations?: Maybe<Scalars['Boolean']>;
  analytics?: Maybe<Scalars['Boolean']>;
  billing?: Maybe<Scalars['Boolean']>;
  customers?: Maybe<Scalars['Boolean']>;
  dispensaryIds?: Maybe<Array<Scalars['String']>>;
  driver?: Maybe<Scalars['Boolean']>;
  enterpriseAdmin?: Maybe<Scalars['Boolean']>;
  enterpriseSpecials?: Maybe<Scalars['Boolean']>;
  menu?: Maybe<Scalars['Boolean']>;
  menuReview?: Maybe<Scalars['Boolean']>;
  messaging?: Maybe<Scalars['Boolean']>;
  orders?: Maybe<Scalars['Boolean']>;
  promote?: Maybe<Scalars['Boolean']>;
  settings?: Maybe<Scalars['Boolean']>;
  superMenuReview?: Maybe<Scalars['Boolean']>;
  tasks?: Maybe<Scalars['Boolean']>;
  users?: Maybe<Scalars['Boolean']>;
};

export type GqlValidationResponse = {
  __typename?: 'ValidationResponse';
  isValid?: Maybe<Scalars['Boolean']>;
};

export enum Versions {
  v1 = 'v1',
  v2 = 'v2',
  v3 = 'v3',
  v4 = 'v4'
}

export type GqlWebCustomizationSettings = {
  __typename?: 'WebCustomizationSettings';
  colorSettings: GqlColorSettingsV2;
  fontSettings: GqlFontSettings;
};

export type GqlWebCustomizationSettingsV2 = {
  __typename?: 'WebCustomizationSettingsV2';
  categories?: Maybe<GqlCustomizedCategories>;
  colors?: Maybe<GqlColors>;
  fonts?: Maybe<GqlFonts>;
  productCards?: Maybe<GqlProductCards>;
  radius?: Maybe<GqlRadius>;
  textTransforms?: Maybe<GqlTextTransforms>;
};

export type GqlWeeklyHours = {
  __typename?: 'WeeklyHours';
  Friday?: Maybe<GqlDayBounds>;
  Monday?: Maybe<GqlDayBounds>;
  Saturday?: Maybe<GqlDayBounds>;
  Sunday?: Maybe<GqlDayBounds>;
  Thursday?: Maybe<GqlDayBounds>;
  Tuesday?: Maybe<GqlDayBounds>;
  Wednesday?: Maybe<GqlDayBounds>;
};

export type GqlWeeklyHoursInput = {
  Friday?: InputMaybe<GqlDayBoundsInput>;
  Monday?: InputMaybe<GqlDayBoundsInput>;
  Saturday?: InputMaybe<GqlDayBoundsInput>;
  Sunday?: InputMaybe<GqlDayBoundsInput>;
  Thursday?: InputMaybe<GqlDayBoundsInput>;
  Tuesday?: InputMaybe<GqlDayBoundsInput>;
  Wednesday?: InputMaybe<GqlDayBoundsInput>;
};

export type GqlWeight = {
  __typename?: 'Weight';
  amount?: Maybe<Scalars['Float']>;
  weightUom?: Maybe<WeightUom>;
};

export type GqlWeightInput = {
  amount?: InputMaybe<Scalars['Float']>;
  weightUom?: InputMaybe<WeightUom>;
};

export enum WeightOperator {
  equalTo = 'equalTo',
  greaterThan = 'greaterThan',
  greaterThanEqualTo = 'greaterThanEqualTo',
  lessThan = 'lessThan',
  lessThanEqualTo = 'lessThanEqualTo'
}

export enum WeightUom {
  g = 'G',
  gc = 'GC',
  mg = 'MG',
  oz = 'OZ'
}

export type GqlActiveDispensariesInput = {
  chainId?: InputMaybe<Scalars['String']>;
  integration?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<DispensaryOrderType>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  searchStr?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type GqlActiveProductsCheckInput = {
  bypassThresholds?: InputMaybe<Scalars['Boolean']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isKiosk?: InputMaybe<Scalars['Boolean']>;
};

export type GqlAddCustomerToOrderInput = {
  orderId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type GqlAddressResidentialCheckInput = {
  city?: InputMaybe<Scalars['String']>;
  ln1?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type GqlArchiveOrderInput = {
  orderId?: InputMaybe<Scalars['String']>;
  otherReasonText?: InputMaybe<Scalars['String']>;
  reasonId?: InputMaybe<Orders_CancellationReasonIDs>;
  shouldNotifyCustomer?: InputMaybe<Scalars['Boolean']>;
};

export type GqlBrandCollisionFilters = {
  brandId?: InputMaybe<Scalars['String']>;
  brandNameQuery?: InputMaybe<Scalars['String']>;
  collisionType?: InputMaybe<CollisionType>;
  dispensaryId?: InputMaybe<Scalars['String']>;
};

export type GqlBrandCollisionInput = {
  isAllowed: Scalars['Boolean'];
};

export type GqlBrandCollisionsSort = {
  sortBy?: InputMaybe<SortByOptions>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type GqlBrandEnterpriseSettingsInput = {
  adsEnabled: Scalars['Boolean'];
  enterpriseId: Scalars['String'];
};

export type GqlBrandInput = {
  aliasList?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  enterpriseId?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parentBrandId?: InputMaybe<Scalars['ID']>;
  regions?: InputMaybe<Array<Scalars['String']>>;
};

export type GqlBrandMergeHistoriesFilters = {
  destinationBrandId?: InputMaybe<Scalars['String']>;
  destinationDispensaryId?: InputMaybe<Scalars['String']>;
  reverted?: InputMaybe<Scalars['Boolean']>;
  sourceBrandId?: InputMaybe<Scalars['String']>;
  sourceDispensaryId?: InputMaybe<Scalars['String']>;
};

export type GqlBrandMergeHistoriesPagination = {
  number?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};

export type GqlBrandMergeHistoriesSort = {
  sortBy?: InputMaybe<BrandMergeHistoriesSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlBrandPortalProductSearchFilters = {
  approvalStatus?: InputMaybe<BrandPortalProductSearchApprovalStatusFilterEnum>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  category?: InputMaybe<Scalars['String']>;
  complianceRegion?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Float']>;
};

export type GqlBrandPortalProductSearchSort = {
  sortBy?: InputMaybe<BrandPortalProductSearchSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlBrandUserCreateInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  manageAdCampaigns?: InputMaybe<Scalars['Boolean']>;
  manageBrandGroup?: InputMaybe<Scalars['Boolean']>;
  manageBrands?: InputMaybe<Scalars['Boolean']>;
  managedBrandIds?: InputMaybe<Array<Scalars['ID']>>;
  parentBrandId: Scalars['ID'];
  phone: Scalars['String'];
};

export type GqlBrandUserFocusedAccountInput = {
  dposLspId: Scalars['String'];
  dposServerRegion: Scalars['String'];
};

export type GqlBrandUserUpdateAccountInput = {
  currentPassword?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  newPassword?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
};

export type GqlBrandUserUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  focusedAccounts?: InputMaybe<Array<GqlBrandUserFocusedAccountInput>>;
  lastName?: InputMaybe<Scalars['String']>;
  manageAdCampaigns?: InputMaybe<Scalars['Boolean']>;
  manageBrandGroup?: InputMaybe<Scalars['Boolean']>;
  manageBrands?: InputMaybe<Scalars['Boolean']>;
  managedBrandIds?: InputMaybe<Array<Scalars['ID']>>;
  parentBrandId?: InputMaybe<Scalars['ID']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type GqlBrandUsersFilterInput = {
  search?: InputMaybe<Scalars['String']>;
};

export type GqlBrandUsersSortInput = {
  sortBy?: InputMaybe<BrandUsersSortBy>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlBrandsSortInput = {
  sortBy: Scalars['String'];
  sortDirection: Scalars['String'];
};

export type GqlCategoryPhotoInput = {
  category?: InputMaybe<Scalars['String']>;
  src?: InputMaybe<Scalars['String']>;
};

export type GqlColorSettingsInput = {
  linkColor?: InputMaybe<Scalars['String']>;
  navBarColor?: InputMaybe<Scalars['String']>;
};

export type GqlConsumerSignupDataInput = {
  dispensaryId?: InputMaybe<Scalars['String']>;
  embedded: Scalars['Boolean'];
};

export type GqlConsumerSignupInput = {
  data: GqlConsumerSignupDataInput;
  email: Scalars['String'];
  password: Scalars['String'];
  profile: GqlConsumerSignupProfileInput;
};

export type GqlConsumerSignupMedicalCardInput = {
  expirationDate: Scalars['String'];
  number: Scalars['String'];
  photo?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
};

export type GqlConsumerSignupProfileInput = {
  address?: InputMaybe<GqlConsumerUserProfileAddress>;
  birthday: Scalars['String'];
  driversLicense?: InputMaybe<Scalars['String']>;
  emailNotifications: Scalars['Boolean'];
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  emailSubscription?: InputMaybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  medicalCard?: InputMaybe<GqlConsumerSignupMedicalCardInput>;
  phone?: InputMaybe<Scalars['String']>;
  photoId?: InputMaybe<Scalars['String']>;
  textNotifications: Scalars['Boolean'];
};

export type GqlConsumerUserMedicalCard = {
  __typename?: 'consumerUserMedicalCard';
  expirationDate?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type GqlConsumerUserMedicalCardInput = {
  expirationDate?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type GqlConsumerUserProfile = {
  __typename?: 'consumerUserProfile';
  birthday?: Maybe<Scalars['String']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptIn?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  medicalCard?: Maybe<GqlConsumerUserMedicalCard>;
  phone?: Maybe<Scalars['String']>;
  photoId?: Maybe<Scalars['String']>;
  textNotifications?: Maybe<Scalars['Boolean']>;
};

export type GqlConsumerUserProfileAddress = {
  city?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  ln1?: InputMaybe<Scalars['String']>;
  ln2?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type GqlConsumerUserProfileAddressType = {
  __typename?: 'consumerUserProfileAddressType';
  city?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  ln1?: Maybe<Scalars['String']>;
  ln2?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type GqlConsumerUserProfileInput = {
  _id?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<GqlConsumerUserProfileAddress>;
  birthday?: InputMaybe<Scalars['String']>;
  driversLicense?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  inStoreEnrollmentCompleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  medicalCard?: InputMaybe<GqlConsumerUserMedicalCardInput>;
  phone?: InputMaybe<Scalars['String']>;
  photoId?: InputMaybe<Scalars['String']>;
  textNotifications?: InputMaybe<Scalars['Boolean']>;
};

export type GqlCopuonApplicableCategoryInput = {
  category?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
};

export type GqlCouponApplicableCategory = {
  __typename?: 'couponApplicableCategory';
  category?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
};

export type GqlCouponRestrictions = {
  __typename?: 'couponRestrictions';
  minimumPurchase?: Maybe<Scalars['Boolean']>;
  minimumPurchaseInCents?: Maybe<Scalars['Int']>;
  noSpecials?: Maybe<Scalars['Boolean']>;
};

export type GqlCouponRestrictionsInput = {
  minimumPurchase?: InputMaybe<Scalars['Boolean']>;
  minimumPurchaseInCents?: InputMaybe<Scalars['Int']>;
  noSpecials?: InputMaybe<Scalars['Boolean']>;
};

export type GqlCouponValidationProductInput = {
  brandId?: InputMaybe<Scalars['String']>;
  brandName?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['String']>;
};

export type GqlCoupon_ApplicableCategoriesInput = {
  category?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
};

export type GqlCouponsFilterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  applicableCategories?: InputMaybe<Array<InputMaybe<GqlApplicableCategoryInput>>>;
  code?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  searchStr?: InputMaybe<Scalars['String']>;
};

export type GqlCouponsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type GqlCouponsSortInput = {
  sortBy: Scalars['String'];
  sortDirection: Scalars['String'];
};

export type GqlCreateBucketInput = {
  brandIds?: Array<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  chainId?: InputMaybe<Scalars['String']>;
  connectionStatus?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  dispensaryStatus?: InputMaybe<Scalars['String']>;
  minimumConfidenceScore?: InputMaybe<Scalars['Int']>;
  reviewStatus?: InputMaybe<Scalars['String']>;
  score: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  thresholdFilter?: InputMaybe<Scalars['String']>;
};

export type GqlCreateBucketInputV3 = {
  brandIds?: Array<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  chainId?: InputMaybe<Scalars['String']>;
  connectionStatus?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  dispensaryStatus?: InputMaybe<Scalars['String']>;
  reviewStatus?: InputMaybe<Scalars['String']>;
  score: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  thresholdFilter?: InputMaybe<Scalars['String']>;
};

export type GqlCreateCouponInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addedDate: Scalars['String'];
  applicableCategories?: InputMaybe<Array<InputMaybe<GqlCopuonApplicableCategoryInput>>>;
  code: Scalars['String'];
  dispensaryId: Scalars['String'];
  expDate: Scalars['String'];
  fixedDiscountInCents?: InputMaybe<Scalars['Int']>;
  numAllowedUses?: InputMaybe<Scalars['Int']>;
  numUses?: InputMaybe<Scalars['Int']>;
  oneUsePerCustomer?: InputMaybe<Scalars['Boolean']>;
  percentDiscount?: InputMaybe<Scalars['Float']>;
  restrictions?: InputMaybe<GqlCouponRestrictionsInput>;
};

export type GqlCustomCategoryPhotoInput = {
  category?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type GqlCustomerExportInput = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dispensaryId: Scalars['String'];
  email: Scalars['String'];
  subscriptionsEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type GqlCustomerUpdateInput = {
  _id: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type GqlCustomersFilterInput = {
  dispensaryId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};

export type GqlCustomersPaginationInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type GqlCustomersSortInput = {
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
};

export type GqlDayBounds = {
  __typename?: 'dayBounds';
  active?: Maybe<Scalars['Boolean']>;
  end?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type GqlDayBoundsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['String']>;
  isNextDaySlot?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};

export type GqlDeliveryZipCodesInput = {
  fee?: InputMaybe<Scalars['Int']>;
  feeType?: InputMaybe<FeeTypes>;
  minimum?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  percentFee?: InputMaybe<Scalars['Float']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type GqlDeliveryZonesInput = {
  area?: InputMaybe<GqlPolygonInput>;
  fee?: InputMaybe<Scalars['Int']>;
  feeType?: InputMaybe<FeeTypes>;
  minimum?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  percentFee?: InputMaybe<Scalars['Float']>;
};

export type GqlDispensariesFilterInput = {
  acceptsCreditCardsDelivery?: InputMaybe<Scalars['Boolean']>;
  acceptsCreditCardsPickup?: InputMaybe<Scalars['Boolean']>;
  acceptsDutchiePay?: InputMaybe<Scalars['Boolean']>;
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  cName?: InputMaybe<Scalars['String']>;
  cNameOrID?: InputMaybe<Scalars['String']>;
  chain?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creditCards?: InputMaybe<Scalars['Boolean']>;
  deliversToAddress?: InputMaybe<Scalars['Boolean']>;
  destinationTaxState?: InputMaybe<Scalars['String']>;
  destinationTaxZipcode?: InputMaybe<Scalars['String']>;
  distance?: InputMaybe<Scalars['Float']>;
  freeDelivery?: InputMaybe<Scalars['Boolean']>;
  getIntegration?: InputMaybe<Scalars['Boolean']>;
  hostDomain?: InputMaybe<Scalars['String']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  includeStealthMode?: InputMaybe<Scalars['Boolean']>;
  medical?: InputMaybe<Scalars['Boolean']>;
  nearLat?: InputMaybe<Scalars['Float']>;
  nearLng?: InputMaybe<Scalars['Float']>;
  noMinimum?: InputMaybe<Scalars['Boolean']>;
  offerCurbsidePickup?: InputMaybe<Scalars['Boolean']>;
  offerDelivery?: InputMaybe<Scalars['Boolean']>;
  offerPickup?: InputMaybe<Scalars['Boolean']>;
  openForDelivery?: InputMaybe<Scalars['Boolean']>;
  openForDeliveryRightNow?: InputMaybe<Scalars['Boolean']>;
  openNowForDelivery?: InputMaybe<Scalars['Boolean']>;
  openNowForPickup?: InputMaybe<Scalars['Boolean']>;
  recreational?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<DispensarySortByType>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type GqlDispensaryCustomerInput = {
  _id?: InputMaybe<Scalars['String']>;
  ageVerified?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  dispensaryName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  emailSubscription?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  textSubscription?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type GqlDispensaryDemoRequestInput = {
  dispensaryContactEmail?: InputMaybe<Scalars['String']>;
  dispensaryContactFirstName?: InputMaybe<Scalars['String']>;
  dispensaryContactLastName?: InputMaybe<Scalars['String']>;
  dispensaryContactName?: InputMaybe<Scalars['String']>;
  dispensaryContactPhoneNumber?: InputMaybe<Scalars['String']>;
  dispensaryName?: InputMaybe<Scalars['String']>;
  dispensaryPos?: InputMaybe<Scalars['String']>;
  dispensaryState?: InputMaybe<Scalars['String']>;
  dispensaryType?: InputMaybe<Scalars['String']>;
  roleAtDispensary?: InputMaybe<DispensaryRoles>;
};

export type GqlDispensaryFeatureFlagOptions = {
  enableArrivals?: InputMaybe<Scalars['Boolean']>;
  enableMenuImport?: InputMaybe<Scalars['Boolean']>;
  enableMixAndMatch?: InputMaybe<Scalars['Boolean']>;
  enableNonTerminalAutoConfirm?: InputMaybe<Scalars['Boolean']>;
  enablePausedOrders?: InputMaybe<Scalars['Boolean']>;
  hideDeliveryEstimate?: InputMaybe<Scalars['Boolean']>;
  hideMyAccount?: InputMaybe<Scalars['Boolean']>;
  hideStoreHours?: InputMaybe<Scalars['Boolean']>;
};

export type GqlDispensaryMessagingSettingsInput = {
  disableReadyForPickup?: InputMaybe<Scalars['Boolean']>;
  disableStartDelivery?: InputMaybe<Scalars['Boolean']>;
};

export type GqlDispensaryOnboardingInput = {
  dispensaryContactMethod?: InputMaybe<Scalars['String']>;
  dispensaryContactMethodValue?: InputMaybe<Scalars['String']>;
  dispensaryContactName?: InputMaybe<Scalars['String']>;
  dispensaryDelivery?: InputMaybe<Scalars['String']>;
  dispensaryLogo?: InputMaybe<Scalars['String']>;
  dispensaryLogoFileId?: InputMaybe<Scalars['String']>;
  dispensaryName?: InputMaybe<Scalars['String']>;
  dispensaryPhoneNumber?: InputMaybe<Scalars['String']>;
  dispensaryPhoto?: InputMaybe<Scalars['String']>;
  dispensaryPhotoFileId?: InputMaybe<Scalars['String']>;
  dispensaryPos?: InputMaybe<Scalars['String']>;
  dispensaryPosOther?: InputMaybe<Scalars['String']>;
  dispensarySocialEquityEnrollment?: InputMaybe<Scalars['Boolean']>;
  dispensaryState?: InputMaybe<Scalars['String']>;
  dispensaryTypeMedical?: InputMaybe<Scalars['Boolean']>;
  dispensaryTypeRecreational?: InputMaybe<Scalars['Boolean']>;
  roleAtDispensary?: InputMaybe<DispensaryRoles>;
};

export type GqlDispensaryRemoveFromChainInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type GqlDispensaryStoreSettingsOptions = {
  collapseProductDescription?: InputMaybe<Scalars['Boolean']>;
  defaultViewStyle?: InputMaybe<Scalars['Boolean']>;
  disableGuestCheckout?: InputMaybe<Scalars['Boolean']>;
  disableGuestDOB?: InputMaybe<Scalars['Boolean']>;
  disablePurchaseLimits?: InputMaybe<Scalars['Boolean']>;
  displayKioskAnonymousCheckoutDisclaimer?: InputMaybe<Scalars['Boolean']>;
  displayPhoneConfirmation?: InputMaybe<Scalars['Boolean']>;
  dontCombineWeightedProducts?: InputMaybe<Scalars['Boolean']>;
  dontMapSubcategoriesByProductName?: InputMaybe<Scalars['Boolean']>;
  enableDutchiePayConsumerSurcharge?: InputMaybe<Scalars['Boolean']>;
  enableLimitPerCustomer?: InputMaybe<Scalars['Boolean']>;
  enableOmniauthLoginCheckout?: InputMaybe<Scalars['Boolean']>;
  enableOrderStatusEmails?: InputMaybe<Scalars['Boolean']>;
  enableProductUrgencyMessaging?: InputMaybe<Scalars['Boolean']>;
  enableRoundToNearestDollar?: InputMaybe<Scalars['Boolean']>;
  enableStorefrontAgeGate?: InputMaybe<Scalars['Boolean']>;
  hardAgeGateAgeVerification?: InputMaybe<Scalars['Boolean']>;
  hardAgeGateHideMenuContent?: InputMaybe<Scalars['Boolean']>;
  hideAddressFromDutchieMain?: InputMaybe<Scalars['Boolean']>;
  hideDiscountsFromConsumer?: InputMaybe<Scalars['Boolean']>;
  hideEffects?: InputMaybe<Scalars['Boolean']>;
  hideFilters?: InputMaybe<Scalars['Boolean']>;
  hideFromMobileApp?: InputMaybe<Scalars['Boolean']>;
  hideOutOfStockProducts?: InputMaybe<Scalars['Boolean']>;
  hideRoundingLineItem?: InputMaybe<Scalars['Boolean']>;
  isolatedMenus?: InputMaybe<Scalars['Boolean']>;
  keepUncombinedWeights?: InputMaybe<Scalars['Boolean']>;
  prioritizeStaffPicksInSearchResults?: InputMaybe<Scalars['Boolean']>;
  provideBackInstockEmailNotifications?: InputMaybe<Scalars['Boolean']>;
  quantityLimit?: InputMaybe<Scalars['Boolean']>;
  quantityLimitMaxAvailable?: InputMaybe<Scalars['Boolean']>;
  requireEmailAddressForGuestCheckout?: InputMaybe<Scalars['Boolean']>;
  requireMedCardPhotoForDelivery?: InputMaybe<Scalars['Boolean']>;
  requireMedCardPhotoForPickup?: InputMaybe<Scalars['Boolean']>;
  showLoyaltyRewards?: InputMaybe<Scalars['Boolean']>;
  showMobileAppSmartBanner?: InputMaybe<Scalars['Boolean']>;
  showPOSPackageId?: InputMaybe<Scalars['Boolean']>;
  stealthMode?: InputMaybe<Scalars['Boolean']>;
  usePotencyForConcentrateLimits?: InputMaybe<Scalars['Boolean']>;
  useStandardEquivalentForEdiblesLimits?: InputMaybe<Scalars['Boolean']>;
};

export type GqlDispensaryUpdateCategoryLimits = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type GqlDispensaryUpdateCustomDomainSettings = {
  cloudflareDomain?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
};

export type GqlDispensaryUpdateEmbedSettings = {
  applyToAllLocations?: InputMaybe<Scalars['Boolean']>;
  autoGTM?: InputMaybe<Scalars['Boolean']>;
  autoScroll?: InputMaybe<Scalars['Boolean']>;
  autoScrollOffset?: InputMaybe<Scalars['Int']>;
  disablePageLoadsAtTop?: InputMaybe<Scalars['Boolean']>;
  disableRouting?: InputMaybe<Scalars['Boolean']>;
  disclaimerText?: InputMaybe<Scalars['String']>;
  disclaimerTextHtml?: InputMaybe<Scalars['String']>;
  enableFullScreenEmbeddedCheckout?: InputMaybe<Scalars['Boolean']>;
  iframeCSS?: InputMaybe<Scalars['String']>;
  pageCSS?: InputMaybe<Scalars['String']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']>;
};

export type GqlDispensaryUpdateExciseTax = {
  local?: InputMaybe<Scalars['Float']>;
  medicalLocal?: InputMaybe<Scalars['Float']>;
  medicalState?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['Float']>;
};

export type GqlDispensaryUpdateFeatureFlags = {
  /** @deprecated now defined per order type within BaseOrderingSettings */
  enableAfterHoursOrdering?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated now defined per pickup order type within BaseOrderingSettings */
  enableAfterHoursOrderingForPickup?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated defined within CurbsidePickupOrderingSettings in ordering-settings */
  enableArrivals?: InputMaybe<Scalars['Boolean']>;
  enableMenuImport?: InputMaybe<Scalars['Boolean']>;
  enableMixAndMatch?: InputMaybe<Scalars['Boolean']>;
  enableNonTerminalAutoConfirm?: InputMaybe<Scalars['Boolean']>;
  enablePausedOrders?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated now defined per order type within BaseOrderingSettings */
  enableScheduledOrdering?: InputMaybe<Scalars['Boolean']>;
  hideDeliveryEstimate?: InputMaybe<Scalars['Boolean']>;
  hideMyAccount?: InputMaybe<Scalars['Boolean']>;
  hideStoreHours?: InputMaybe<Scalars['Boolean']>;
};

export type GqlDispensaryUpdateFeeTiers = {
  fee?: InputMaybe<Scalars['String']>;
  feeType?: InputMaybe<FeeTypes>;
  max?: InputMaybe<Scalars['String']>;
  min?: InputMaybe<Scalars['String']>;
  percentFee?: InputMaybe<Scalars['Float']>;
};

export type GqlDispensaryUpdateHours = {
  Friday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Monday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Saturday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Sunday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Thursday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Tuesday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Wednesday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
};

export type GqlDispensaryUpdateHoursDay = {
  active?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};

export type GqlDispensaryUpdateHoursSettingsInput = {
  id?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<GqlDispensaryUpdateHoursSettingsProfileInput>;
};

export type GqlDispensaryUpdateHoursSettingsProfileInput = {
  deliveryHours?: InputMaybe<GqlDispensaryUpdateHours>;
  pickupHours?: InputMaybe<GqlDispensaryUpdateHours>;
  reservationConfig?: InputMaybe<GqlReservationConfigInput>;
  specialHours?: InputMaybe<Array<InputMaybe<GqlSpecialHoursInput>>>;
  storeSettings?: InputMaybe<GqlDispensaryUpdateStoreSettings>;
};

export type GqlDispensaryUpdateInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<GqlDispensaryUpdateProfileInput>;
};

export type GqlDispensaryUpdateKioskConfig = {
  anonymousCheckout?: InputMaybe<Scalars['Boolean']>;
  directedOrders?: InputMaybe<Scalars['Boolean']>;
  fullNameOnly?: InputMaybe<Scalars['Boolean']>;
  hideEmailField?: InputMaybe<Scalars['Boolean']>;
  hidePhoneField?: InputMaybe<Scalars['Boolean']>;
  notesField?: InputMaybe<Scalars['Boolean']>;
  phoneRequired?: InputMaybe<Scalars['Boolean']>;
  showBirthdateField?: InputMaybe<Scalars['Boolean']>;
};

export type GqlDispensaryUpdateOptionsSettings = {
  acceptsCreditCardTips?: InputMaybe<Scalars['Boolean']>;
  acceptsDutchiePayTips?: InputMaybe<Scalars['Boolean']>;
  acceptsTips?: InputMaybe<Scalars['Boolean']>;
  embedSettings?: InputMaybe<GqlDispensaryUpdateEmbedSettings>;
  featureFlags?: InputMaybe<GqlDispensaryFeatureFlagOptions>;
  messagingSettings?: InputMaybe<GqlDispensaryMessagingSettingsInput>;
  orderStatusEmailSettings?: InputMaybe<GqlOrderStatusEmailSettingsInput>;
  ordersConfig?: InputMaybe<GqlDispensaryUpdateOrdersConfig>;
  removeMedicalCardFieldsAtCheckout?: InputMaybe<Scalars['Boolean']>;
  requirePhotoIdForDelivery?: InputMaybe<Scalars['Boolean']>;
  requirePhotoIdForPickup?: InputMaybe<Scalars['Boolean']>;
  requiresDriversLicense?: InputMaybe<Scalars['Boolean']>;
  requiresDriversLicenseForPickup?: InputMaybe<Scalars['Boolean']>;
  storeSettings?: InputMaybe<GqlDispensaryStoreSettingsOptions>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
};

export type GqlDispensaryUpdateOptionsSettingsInput = {
  id?: InputMaybe<Scalars['String']>;
  updatedSettings?: InputMaybe<GqlDispensaryUpdateOptionsSettings>;
};

export type GqlDispensaryUpdateOrderTypeConfig = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  paymentTypes?: InputMaybe<GqlDispensaryUpdatePaymentTypeConfig>;
};

export type GqlDispensaryUpdateOrderTypesConfig = {
  curbsidePickup?: InputMaybe<GqlDispensaryUpdateOrderTypeConfig>;
  delivery?: InputMaybe<GqlDispensaryUpdateOrderTypeConfig>;
  driveThruPickup?: InputMaybe<GqlDispensaryUpdateOrderTypeConfig>;
  kiosk?: InputMaybe<GqlDispensaryUpdateOrderTypeConfig>;
  pickup?: InputMaybe<GqlDispensaryUpdateOrderTypeConfig>;
};

export type GqlDispensaryUpdateOrdersConfig = {
  autoClose?: InputMaybe<Scalars['Boolean']>;
  autoConfirm?: InputMaybe<Scalars['Boolean']>;
  posItemNames?: InputMaybe<Scalars['Boolean']>;
  terminalReceiptOptions?: InputMaybe<GqlDispensaryUpdateTerminalReceiptOptions>;
};

export type GqlDispensaryUpdatePaymentFees = {
  fee?: InputMaybe<Scalars['Float']>;
  feeType?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
};

export type GqlDispensaryUpdatePaymentTypeConfig = {
  aeropay?: InputMaybe<Scalars['Boolean']>;
  alt36?: InputMaybe<Scalars['Boolean']>;
  canPay?: InputMaybe<Scalars['Boolean']>;
  cash?: InputMaybe<Scalars['Boolean']>;
  check?: InputMaybe<Scalars['Boolean']>;
  creditCardAtDoor?: InputMaybe<Scalars['Boolean']>;
  creditCardByPhone?: InputMaybe<Scalars['Boolean']>;
  debit?: InputMaybe<Scalars['Boolean']>;
  dutchiePay?: InputMaybe<Scalars['Boolean']>;
  linx?: InputMaybe<Scalars['Boolean']>;
  payOnlineChase?: InputMaybe<Scalars['Boolean']>;
  payOnlineHypur?: InputMaybe<Scalars['Boolean']>;
  payOnlineMerrco?: InputMaybe<Scalars['Boolean']>;
  payOnlineMoneris?: InputMaybe<Scalars['Boolean']>;
  paytender?: InputMaybe<Scalars['Boolean']>;
  rethinkPay?: InputMaybe<Scalars['Boolean']>;
};

export type GqlDispensaryUpdatePlusSettings = {
  checkoutUrl?: InputMaybe<Scalars['String']>;
  defaultReturnUrl?: InputMaybe<Scalars['String']>;
};

export type GqlDispensaryUpdateProfileInput = {
  SpecialLogoImage?: InputMaybe<Scalars['String']>;
  acceptsDutchiePayTips?: InputMaybe<Scalars['Boolean']>;
  acceptsTips?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  aeropay?: InputMaybe<Scalars['Boolean']>;
  ageVerificationBannerColor?: InputMaybe<Scalars['String']>;
  ageVerificationBannerHtml?: InputMaybe<Scalars['String']>;
  alt36?: InputMaybe<Scalars['Boolean']>;
  bannerImage?: InputMaybe<Scalars['String']>;
  brandedDutchiePayEnabled?: InputMaybe<Scalars['Boolean']>;
  brandedDutchiePayLogoDark?: InputMaybe<Scalars['String']>;
  brandedDutchiePayLogoLight?: InputMaybe<Scalars['String']>;
  brandedDutchiePayName?: InputMaybe<Scalars['String']>;
  canPay?: InputMaybe<Scalars['Boolean']>;
  cashOnly?: InputMaybe<Scalars['Boolean']>;
  cashless?: InputMaybe<Scalars['Boolean']>;
  categoryLimits?: InputMaybe<Array<InputMaybe<GqlDispensaryUpdateCategoryLimits>>>;
  categoryLimitsEnabled?: InputMaybe<Scalars['Boolean']>;
  categoryPhotos?: InputMaybe<Array<InputMaybe<GqlCategoryPhotoInput>>>;
  chain?: InputMaybe<Scalars['String']>;
  check?: InputMaybe<Scalars['Boolean']>;
  colorSettings?: InputMaybe<GqlColorSettingsInput>;
  creditCardAtDoor?: InputMaybe<Scalars['Boolean']>;
  creditCardByPhone?: InputMaybe<Scalars['Boolean']>;
  customCategoryPhotos?: InputMaybe<Array<InputMaybe<GqlCustomCategoryPhotoInput>>>;
  customDomainSettings?: InputMaybe<GqlDispensaryUpdateCustomDomainSettings>;
  debitOnly?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated moved to HoursSettingsUpdateInput. RL 5/8/20 */
  deliveryHours?: InputMaybe<GqlDispensaryUpdateHours>;
  deliveryMin?: InputMaybe<Scalars['String']>;
  deliveryMode?: InputMaybe<DeliveryModes>;
  deliveryZipCodes?: InputMaybe<Array<InputMaybe<GqlDeliveryZipCodesInput>>>;
  deliveryZones?: InputMaybe<Array<InputMaybe<GqlDeliveryZonesInput>>>;
  description?: InputMaybe<Scalars['String']>;
  durationEstimateOverrides?: InputMaybe<GqlDurationEstimatesInput>;
  email?: InputMaybe<Scalars['String']>;
  emailConfirmation?: InputMaybe<Scalars['Boolean']>;
  embedBackUrl?: InputMaybe<Scalars['String']>;
  embedSettings?: InputMaybe<GqlDispensaryUpdateEmbedSettings>;
  embeddedLogoImage?: InputMaybe<Scalars['String']>;
  embeddedMenuUrl?: InputMaybe<Scalars['String']>;
  exciseTax?: InputMaybe<GqlDispensaryUpdateExciseTax>;
  exclusiveExciseTax?: InputMaybe<Scalars['String']>;
  featureFlags?: InputMaybe<GqlDispensaryUpdateFeatureFlags>;
  feeTiers?: InputMaybe<Array<InputMaybe<GqlDispensaryUpdateFeeTiers>>>;
  hideFromCCT?: InputMaybe<Scalars['Boolean']>;
  hypur?: InputMaybe<Scalars['Boolean']>;
  includeSalesTaxInMenu?: InputMaybe<Scalars['Boolean']>;
  inclusiveSalesTax?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated defined in ordering-settings in KioskOrderingSettings */
  kioskConfig?: InputMaybe<GqlDispensaryUpdateKioskConfig>;
  /** @deprecated set as notes field in KioskOrderingSettings */
  kioskInstructions?: InputMaybe<Scalars['String']>;
  /** @deprecated defined in ordering-settings within KioskOrderingSettings */
  kioskOrderingEnabled?: InputMaybe<Scalars['Boolean']>;
  linx?: InputMaybe<Scalars['Boolean']>;
  listImage?: InputMaybe<Scalars['String']>;
  logoImage?: InputMaybe<Scalars['String']>;
  maxDeliveryDistance?: InputMaybe<Scalars['Float']>;
  medSubjectToExciseTax?: InputMaybe<Scalars['Boolean']>;
  medicalDispensary?: InputMaybe<Scalars['Boolean']>;
  menuBannerColor?: InputMaybe<Scalars['String']>;
  menuBannerHtml?: InputMaybe<Scalars['String']>;
  menuBannerTextBannerCollapsed?: InputMaybe<Scalars['Boolean']>;
  menuOrder?: InputMaybe<Scalars['String']>;
  menuUrl?: InputMaybe<Scalars['String']>;
  menuWeights?: InputMaybe<Scalars['String']>;
  messagingSettings?: InputMaybe<GqlDispensaryMessagingSettingsInput>;
  mixAndMatchPricingWeights?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  /** @deprecated moved to OrderingSettingsUpdateInput */
  offerCurbsidePickup?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated moved to OrderingSettingsUpdateInput */
  offerDelivery?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated moved to OrderingSettingsUpdateInput */
  offerDriveThruPickup?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated moved to OrderingSettingsUpdateInput */
  offerPickup?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated moved to OrderingSettingsUpdateInput */
  orderTypesConfig?: InputMaybe<GqlDispensaryUpdateOrderTypesConfig>;
  ordersConfig?: InputMaybe<GqlDispensaryUpdateOrdersConfig>;
  payInStore?: InputMaybe<Scalars['Boolean']>;
  payOnlineHypur?: InputMaybe<Scalars['Boolean']>;
  payOnlineMerrco?: InputMaybe<Scalars['Boolean']>;
  paymentFees?: InputMaybe<Array<InputMaybe<GqlDispensaryUpdatePaymentFees>>>;
  paytender?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  /** @deprecated moved to HoursSettingsUpdateInput. RL 5/8/20 */
  pickupHours?: InputMaybe<GqlDispensaryUpdateHours>;
  /** @deprecated moved to OrderMinimumInput */
  pickupMinimum?: InputMaybe<GqlPickupMinimumInput>;
  plusSettings?: InputMaybe<GqlDispensaryUpdatePlusSettings>;
  printedMenuSettings?: InputMaybe<GqlPrintedMenuSettingsInput>;
  recDispensary?: InputMaybe<Scalars['Boolean']>;
  removeMedicalCardFieldsAtCheckout?: InputMaybe<Scalars['Boolean']>;
  requirePhotoIdForDelivery?: InputMaybe<Scalars['Boolean']>;
  requirePhotoIdForPickup?: InputMaybe<Scalars['Boolean']>;
  requiresDriversLicense?: InputMaybe<Scalars['Boolean']>;
  requiresDriversLicenseForPickup?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated moved to ReservationSlotsUpdateInput */
  reservationConfig?: InputMaybe<GqlReservationConfigInput>;
  salesTax?: InputMaybe<Scalars['Float']>;
  /** @deprecated moved to HoursSettingsUpdateInput. RL 5/8/20 */
  specialHours?: InputMaybe<Array<InputMaybe<GqlSpecialHoursInput>>>;
  specialsSettings?: InputMaybe<GqlSpecialsSettingsInput>;
  storeSettings?: InputMaybe<GqlDispensaryUpdateStoreSettings>;
  taxCalculationMethod?: InputMaybe<Scalars['String']>;
  taxConfig?: InputMaybe<GqlDispensaryUpdateTaxConfig>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type GqlDispensaryUpdateStatusInput = {
  dispensaryId: Scalars['String'];
  status: Scalars['String'];
};

export type GqlDispensaryUpdateStoreSettings = {
  collapseProductDescription?: InputMaybe<Scalars['Boolean']>;
  customerMessagingTermsAccepted?: InputMaybe<Scalars['Boolean']>;
  defaultViewStyle?: InputMaybe<MenuViewStyles>;
  disableGuestCheckout?: InputMaybe<Scalars['Boolean']>;
  disableGuestDOB?: InputMaybe<Scalars['Boolean']>;
  disablePurchaseLimits?: InputMaybe<Scalars['Boolean']>;
  displayKioskAnonymousCheckoutDisclaimer?: InputMaybe<Scalars['Boolean']>;
  displayPhoneConfirmation?: InputMaybe<Scalars['Boolean']>;
  dontCombineWeightedProducts?: InputMaybe<Scalars['Boolean']>;
  dontMapSubcategoriesByProductName?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated now updated via OrderingSettingsUpdateInput */
  enableAfterHoursOrderingForDelivery?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated now updated via OrderingSettingsUpdateInput */
  enableAfterHoursOrderingForPickup?: InputMaybe<Scalars['Boolean']>;
  enableDutchiePayConsumerSurcharge?: InputMaybe<Scalars['Boolean']>;
  enableLLxSaleDiscountSync?: InputMaybe<Scalars['Boolean']>;
  enableLimitPerCustomer?: InputMaybe<Scalars['Boolean']>;
  enableMixAndMatchPricingForDelivery?: InputMaybe<Scalars['Boolean']>;
  enableMixAndMatchPricingForPickup?: InputMaybe<Scalars['Boolean']>;
  enableOmniauthLoginCheckout?: InputMaybe<Scalars['Boolean']>;
  enableOrderStatusEmails?: InputMaybe<Scalars['Boolean']>;
  enableProductUrgencyMessaging?: InputMaybe<Scalars['Boolean']>;
  enableRoundToNearestDollar?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated now updated via OrderingSettingsUpdateInput */
  enableScheduledOrderingForDelivery?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated now updated via OrderingSettingsUpdateInput */
  enableScheduledOrderingForPickup?: InputMaybe<Scalars['Boolean']>;
  enableStorefrontAgeGate?: InputMaybe<Scalars['Boolean']>;
  hardAgeGateAgeVerification?: InputMaybe<Scalars['Boolean']>;
  hardAgeGateHideMenuContent?: InputMaybe<Scalars['Boolean']>;
  hideAddressFromDutchieMain?: InputMaybe<Scalars['Boolean']>;
  hideDiscountsFromConsumer?: InputMaybe<Scalars['Boolean']>;
  hideEffects?: InputMaybe<Scalars['Boolean']>;
  hideFilters?: InputMaybe<Scalars['Boolean']>;
  hideFromMobileApp?: InputMaybe<Scalars['Boolean']>;
  hideOutOfStockProducts?: InputMaybe<Scalars['Boolean']>;
  hideRoundingLineItem?: InputMaybe<Scalars['Boolean']>;
  isolatedMenus?: InputMaybe<Scalars['Boolean']>;
  keepUncombinedWeights?: InputMaybe<Scalars['Boolean']>;
  prioritizeStaffPicksInSearchResults?: InputMaybe<Scalars['Boolean']>;
  provideBackInstockEmailNotifications?: InputMaybe<Scalars['Boolean']>;
  quantityLimit?: InputMaybe<Scalars['Int']>;
  quantityLimitMaxAvailable?: InputMaybe<Scalars['Boolean']>;
  requireEmailAddressForGuestCheckout?: InputMaybe<Scalars['Boolean']>;
  requireMedCardPhotoForDelivery?: InputMaybe<Scalars['Boolean']>;
  requireMedCardPhotoForPickup?: InputMaybe<Scalars['Boolean']>;
  rewardsIntegrationConfiguration?: InputMaybe<GqlRewards_Integration_ConfigurationInput>;
  showLoyaltyRewards?: InputMaybe<Scalars['Boolean']>;
  showMobileAppSmartBanner?: InputMaybe<Scalars['Boolean']>;
  showPOSPackageId?: InputMaybe<Scalars['Boolean']>;
  stealthMode?: InputMaybe<Scalars['Boolean']>;
  subscriptions?: InputMaybe<GqlDispensaries_SubscriptionsInput>;
  usePotencyForConcentrateLimits?: InputMaybe<Scalars['Boolean']>;
  useStandardEquivalentForEdiblesLimits?: InputMaybe<Scalars['Boolean']>;
};

export type GqlDispensaryUpdateTaxConfig = {
  calculationMethod?: InputMaybe<Scalars['String']>;
  discountTaxOrder?: InputMaybe<Scalars['String']>;
  taxes?: InputMaybe<Array<InputMaybe<GqlDispensaryUpdateTaxConfigTaxes>>>;
  version?: InputMaybe<Scalars['Int']>;
};

export type GqlDispensaryUpdateTaxConfigTaxApplyTo = {
  hemp?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GqlDispensaryUpdateTaxConfigTaxStage = {
  op?: InputMaybe<Dispensaries_TaxConfig_Tax_Stage_Ops>;
  type?: InputMaybe<Dispensaries_TaxConfig_Tax_Stage_Types>;
};

export type GqlDispensaryUpdateTaxConfigTaxes = {
  applyTo?: InputMaybe<GqlDispensaryUpdateTaxConfigTaxApplyTo>;
  deliveryPolicy?: InputMaybe<DeliveryPolicy>;
  id?: InputMaybe<Scalars['String']>;
  includeStateSalesTaxInDestinationRate?: InputMaybe<Scalars['Boolean']>;
  medical?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  potency?: InputMaybe<PotencyType>;
  potencyRate?: InputMaybe<Scalars['Float']>;
  rate?: InputMaybe<Scalars['Float']>;
  recreational?: InputMaybe<Scalars['Boolean']>;
  stages?: InputMaybe<Array<InputMaybe<GqlDispensaryUpdateTaxConfigTaxStage>>>;
  taxBasis?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TaxType>;
};

export type GqlDispensaryUpdateTerminalReceiptOptions = {
  birthdate?: InputMaybe<Scalars['Boolean']>;
  customerNameOption?: InputMaybe<Scalars['String']>;
  deliveryAddress?: InputMaybe<Scalars['Boolean']>;
  disableSocialImpact?: InputMaybe<Scalars['Boolean']>;
  groupLineItemsBy?: InputMaybe<Scalars['String']>;
  medical?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['Boolean']>;
  potencyInfo?: InputMaybe<Scalars['Boolean']>;
  sortLineItemsBy?: InputMaybe<Scalars['String']>;
};

export type GqlDispensaryUserStreamTokenInput = {
  dispensaryId: Scalars['String'];
  isSuperAdmin?: InputMaybe<Scalars['Boolean']>;
};

export type GqlDurationEstimateRangeInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  highInMinutes?: InputMaybe<Scalars['Int']>;
  lowInMinutes?: InputMaybe<Scalars['Int']>;
};

export type GqlDurationEstimatesInput = {
  delivery?: InputMaybe<GqlDurationEstimateRangeInput>;
  pickup?: InputMaybe<GqlDurationEstimateRangeInput>;
};

export type GqlEndSpecialsInput = {
  dispensaryId: Scalars['String'];
  ids: Array<InputMaybe<Scalars['String']>>;
  source?: InputMaybe<SpecialSource>;
  triggeredByIntegration: Scalars['Boolean'];
};

export type GqlExportCustomerReportInput = {
  category?: InputMaybe<Array<Scalars['String']>>;
  customerType?: InputMaybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  email: Scalars['String'];
  lastOrder?: InputMaybe<Scalars['String']>;
  maxAge?: InputMaybe<Scalars['Int']>;
  minAge?: InputMaybe<Scalars['Int']>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
};

export type GqlExportOrderReportInput = {
  dispensaryId: Scalars['String'];
  email: Scalars['String'];
  endDate?: InputMaybe<Scalars['ISODate']>;
  menuType?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type GqlFilteredSpecialsInput = {
  current?: InputMaybe<Scalars['Boolean']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  excludeSourcePOS?: InputMaybe<Scalars['Boolean']>;
  past?: InputMaybe<Scalars['Boolean']>;
  platformType?: InputMaybe<Scalars['String']>;
  preOrderType?: InputMaybe<Scalars['String']>;
  searchStr?: InputMaybe<Scalars['String']>;
  sortInput?: InputMaybe<GqlSpecialsSortInput>;
  specialIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GqlFilteredSpecialsInputV2 = {
  pageInput?: InputMaybe<GqlSpecialsPageInput>;
  searchStr?: InputMaybe<Scalars['String']>;
  sortInput?: InputMaybe<Array<InputMaybe<GqlSpecialsSortInputV2>>>;
  source?: InputMaybe<SpecialSource>;
  specialIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<SpecialTemporalStatus>;
  translateSpecialsToV3?: InputMaybe<Scalars['Boolean']>;
};

export type GqlGetDeliveryInfoInput = {
  city?: InputMaybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type GqlGetDispensariesAdSettingsByMenuVariantInput = {
  adsEnabledMenuVariant: Scalars['String'];
};

export type GqlGetDispensariesByPersonalizationSettingsInput = {
  personalizationEnabledMenuVariant: Scalars['String'];
};

export type GqlGetOrdersInput = {
  chainId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<GqlDateRange>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<OrderTypes>;
  hasPhone?: InputMaybe<Scalars['Boolean']>;
  kiosk?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<GqlGetOrderSortInput>;
  status?: InputMaybe<OrderQueryStatuses>;
};

export type GqlGetTimezoneResult = {
  __typename?: 'getTimezoneResult';
  timezone?: Maybe<Scalars['String']>;
};

export type GqlGuestCustomerInput = {
  birthDay?: InputMaybe<Scalars['String']>;
  birthMonth?: InputMaybe<Scalars['String']>;
  birthYear?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  emailSubscription?: InputMaybe<Scalars['Boolean']>;
  externalUserId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  photoId?: InputMaybe<Scalars['String']>;
  termsOptIn?: InputMaybe<Scalars['Boolean']>;
};

export type GqlImageUploadInput = {
  image?: InputMaybe<Scalars['String']>;
};

export type GqlImageUrl = {
  __typename?: 'imageUrl';
  url?: Maybe<Scalars['String']>;
};

export type GqlIncrementClicksInput = {
  _id?: InputMaybe<Scalars['String']>;
};

export type GqlIntegrationCredsInput = {
  adHoc1?: InputMaybe<Scalars['String']>;
  dispensary?: InputMaybe<Scalars['String']>;
  integrationName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type GqlListBrandsFilters = {
  active?: InputMaybe<Scalars['Boolean']>;
  local?: InputMaybe<Scalars['Boolean']>;
};

export type GqlListBrandsSort = {
  sortBy?: InputMaybe<ListBrandsSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlListLibraryProductsFilters = {
  status: LibraryProductStatusEnum;
};

export type GqlListLibraryProductsSort = {
  sortBy?: InputMaybe<ListLibraryProductsSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlLocationInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  ln1?: InputMaybe<Scalars['String']>;
  ln2?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  streetName?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type GqlMarkOrderAutoPrintedInput = {
  autoPrintSuccess?: InputMaybe<Scalars['Boolean']>;
  deviceId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
};

export type GqlMarkOrderPosFailedInput = {
  orderId?: InputMaybe<Scalars['String']>;
  sessionName?: InputMaybe<Scalars['String']>;
};

export type GqlMarkOrderPrintedInput = {
  action?: InputMaybe<PrintAction>;
  deviceId?: InputMaybe<Scalars['String']>;
  durationInMs?: InputMaybe<Scalars['Int']>;
  endTime?: InputMaybe<Scalars['ISODateTime']>;
  failed?: InputMaybe<Scalars['Boolean']>;
  failureReason?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  printId?: InputMaybe<Scalars['String']>;
  printerPreviouslyConnected?: InputMaybe<Scalars['Boolean']>;
  startTime?: InputMaybe<Scalars['ISODateTime']>;
};

export type GqlMarkOrdersBatchPrintedInput = {
  action?: InputMaybe<PrintAction>;
  deviceId?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['ISODateTime']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  printId?: InputMaybe<Scalars['String']>;
};

export type GqlMedicalCardInput = {
  expirationDate?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export enum MenuPricingTypes {
  med = 'med',
  rec = 'rec'
}

export type GqlMenuSectionBulkUpdateInput = {
  brandId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['ID']>;
  dispensaryId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  position: Scalars['Int'];
  products?: InputMaybe<Array<Scalars['ID']>>;
  sectionName?: InputMaybe<Scalars['String']>;
  sectionType: MenuSectionType;
  sortBy?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
};

export type GqlMenuSectionCreateInput = {
  brandId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['ID']>;
  dispensaryId: Scalars['String'];
  products?: InputMaybe<Array<Scalars['ID']>>;
  sectionName?: InputMaybe<Scalars['String']>;
  sectionType: MenuSectionType;
  sortBy?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
};

export type GqlMenuSectionUpdateInput = {
  brandId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['ID']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<Scalars['ID']>>;
  sectionName?: InputMaybe<Scalars['String']>;
  sectionType?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
};

export type GqlMonerisInput = {
  bin?: InputMaybe<Scalars['String']>;
  cardToken?: InputMaybe<Scalars['String']>;
  cvv?: InputMaybe<Scalars['String']>;
  expiryDate?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

export type GqlOrderStatusEmailSettingsInput = {
  disableConfirmed?: InputMaybe<Scalars['Boolean']>;
  disableOutForDelivery?: InputMaybe<Scalars['Boolean']>;
  disableReadyForPickup?: InputMaybe<Scalars['Boolean']>;
  disableSubmitted?: InputMaybe<Scalars['Boolean']>;
};

export enum OrderStatuses {
  closed = 'closed',
  confirmed = 'confirmed',
  inTransit = 'inTransit',
  open = 'open'
}

export type GqlOrdersCreateInput = {
  address?: InputMaybe<Scalars['String']>;
  appliedRewards?: InputMaybe<Array<InputMaybe<GqlRewardInput>>>;
  bypassCanadaDeliveryTax?: InputMaybe<Scalars['Boolean']>;
  channelSource?: InputMaybe<ChannelSources>;
  checkoutId?: InputMaybe<Scalars['String']>;
  checkoutToken?: InputMaybe<Scalars['String']>;
  couponCode?: InputMaybe<Scalars['String']>;
  couponId?: InputMaybe<Scalars['String']>;
  customerState?: InputMaybe<Scalars['String']>;
  deliveryOption: Scalars['Boolean'];
  destinationTerminal?: InputMaybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  driverName?: InputMaybe<Scalars['String']>;
  driverNumber?: InputMaybe<Scalars['String']>;
  driversLicense?: InputMaybe<Scalars['String']>;
  embedded?: InputMaybe<Scalars['Boolean']>;
  expectedTotal?: InputMaybe<Scalars['Float']>;
  guestCustomer?: InputMaybe<GqlGuestCustomerInput>;
  hypurAccessToken?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']>;
  isAfterHoursOrder?: InputMaybe<Scalars['Boolean']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']>;
  isCurbsidePickupOrder?: InputMaybe<Scalars['Boolean']>;
  isDriveThruPickupOrder?: InputMaybe<Scalars['Boolean']>;
  isExternalOrder?: InputMaybe<Scalars['Boolean']>;
  isGuestOrder?: InputMaybe<Scalars['Boolean']>;
  isKioskOrder?: InputMaybe<Scalars['Boolean']>;
  isPTPOT?: InputMaybe<Scalars['Boolean']>;
  isPreviewOrder?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<GqlLocationInput>;
  loyaltyPointsApplied?: InputMaybe<Scalars['Float']>;
  manualDiscount?: InputMaybe<GqlUpdateCouponInput>;
  medicalCard?: InputMaybe<GqlMedicalCardInput>;
  medicalOrder: Scalars['Boolean'];
  mixAndMatch?: InputMaybe<Scalars['Float']>;
  mobile?: InputMaybe<Scalars['Boolean']>;
  monerisInput?: InputMaybe<GqlMonerisInput>;
  paymentId?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  paysafeInput?: InputMaybe<GqlPaysafeInput>;
  photoId?: InputMaybe<Scalars['String']>;
  platformType?: InputMaybe<PlatformType>;
  posCustomerId?: InputMaybe<Scalars['String']>;
  preOrderType?: InputMaybe<PreOrderType>;
  products: Array<GqlProductsInput>;
  reservation?: InputMaybe<GqlOrderReservationInput>;
  reservationType?: InputMaybe<Scalars['String']>;
  saveGuestInfo?: InputMaybe<Scalars['Boolean']>;
  schedulingData?: InputMaybe<GqlOrderSchedulingDataInput>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tip?: InputMaybe<Array<InputMaybe<GqlTipInput>>>;
  userId?: InputMaybe<Scalars['String']>;
  utmData?: InputMaybe<GqlUtmDataInput>;
  utmSource?: InputMaybe<Scalars['String']>;
  variantSource?: InputMaybe<Scalars['String']>;
};

export type GqlOrdersFilterInput = {
  destinationTerminal?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  dispensaryIds?: InputMaybe<Array<Scalars['String']>>;
  getDeliveryOrders?: InputMaybe<Scalars['Boolean']>;
  getKioskOrders?: InputMaybe<Scalars['Boolean']>;
  getPickupOrders?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  orderSource?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<OrderStatuses>>>;
  userId?: InputMaybe<Scalars['String']>;
};

export type GqlOrdersPaginationInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type GqlOrdersSortInput = {
  sortBy: Scalars['String'];
  sortDirection: StringSortDirections;
};

export type GqlOrdersStatusUpdateInput = {
  closedByDriver?: InputMaybe<Scalars['Boolean']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  driverEmail?: InputMaybe<Scalars['String']>;
  driverName?: InputMaybe<Scalars['String']>;
  driverNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  noNotification?: InputMaybe<Scalars['Boolean']>;
  noText?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  terminal?: InputMaybe<Scalars['String']>;
};

export enum Orders_CancellationReasonIDs {
  badinfo = 'BADINFO',
  cancelled = 'CANCELLED',
  complianceviolation = 'COMPLIANCEVIOLATION',
  noidentification = 'NOIDENTIFICATION',
  nopayment = 'NOPAYMENT',
  nopickup = 'NOPICKUP',
  other = 'OTHER',
  soldout = 'SOLDOUT'
}

export type GqlPagination = {
  page?: InputMaybe<Scalars['Int']>;
};

export type GqlPaginationInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset: Scalars['Int'];
};

export type GqlPaysafeInput = {
  token?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type GqlPermissionsInput = {
  allLocations?: InputMaybe<Scalars['Boolean']>;
  analytics?: InputMaybe<Scalars['Boolean']>;
  billing?: InputMaybe<Scalars['Boolean']>;
  customers?: InputMaybe<Scalars['Boolean']>;
  dispensaryIds?: InputMaybe<Array<Scalars['String']>>;
  driver?: InputMaybe<Scalars['Boolean']>;
  enterpriseAdmin?: InputMaybe<Scalars['Boolean']>;
  enterpriseSpecials?: InputMaybe<Scalars['Boolean']>;
  menu?: InputMaybe<Scalars['Boolean']>;
  menuReview?: InputMaybe<Scalars['Boolean']>;
  messaging?: InputMaybe<Scalars['Boolean']>;
  orders?: InputMaybe<Scalars['Boolean']>;
  promote?: InputMaybe<Scalars['Boolean']>;
  settings?: InputMaybe<Scalars['Boolean']>;
  superMenuReview?: InputMaybe<Scalars['Boolean']>;
  tasks?: InputMaybe<Scalars['Boolean']>;
  users?: InputMaybe<Scalars['Boolean']>;
};

export type GqlPrintOrderInput = {
  deviceId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
};

export type GqlPrintedMenuSettingsInput = {
  Categories?: InputMaybe<Array<InputMaybe<GqlPrintedMenuSettings_CategoryEntryInput>>>;
  FooterText?: InputMaybe<GqlPrintedMenuSettings_TextInput>;
  HeaderText?: InputMaybe<GqlPrintedMenuSettings_TextInput>;
  MenuType?: InputMaybe<GqlPrintedMenuSettings_TypeInput>;
  Order?: InputMaybe<GqlPrintedMenuSettings_TypeInput>;
  PageBreaks?: InputMaybe<GqlPrintedMenuSettings_PageBreaksInput>;
  Photos?: InputMaybe<GqlPrintedMenuSettings_PhotosInput>;
  StrainTypes?: InputMaybe<Array<InputMaybe<GqlPrintedMenuSettings_StrainTypesEntryInput>>>;
};

export type GqlProductCreateInput = {
  AdditionalOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  CBD?: InputMaybe<Scalars['String']>;
  CBDContent?: InputMaybe<GqlProductsPotencyInput>;
  Description?: InputMaybe<Scalars['String']>;
  DispensaryID?: InputMaybe<Scalars['String']>;
  Image?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  Options?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Prices?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  Status?: InputMaybe<Scalars['String']>;
  THC?: InputMaybe<Scalars['String']>;
  THCContent?: InputMaybe<GqlProductsPotencyInput>;
  _id?: InputMaybe<Scalars['String']>;
  addedUsingCCT?: InputMaybe<Scalars['Boolean']>;
  bottleDepositTaxCents?: InputMaybe<Scalars['Int']>;
  brandDescription?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['String']>;
  brandLogo?: InputMaybe<Scalars['String']>;
  brandName?: InputMaybe<Scalars['String']>;
  cName?: InputMaybe<Scalars['String']>;
  cannabinoidsV2?: InputMaybe<Array<InputMaybe<GqlProducts_CannabinoidInputV2>>>;
  comingSoon?: InputMaybe<Scalars['Boolean']>;
  createdBy?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['String']>;
  descriptionHtml?: InputMaybe<Scalars['String']>;
  duplicatedProductId?: InputMaybe<Scalars['String']>;
  effects?: InputMaybe<Scalars['JSON']>;
  featured?: InputMaybe<GqlProducts_FeaturedInput>;
  images?: InputMaybe<Array<InputMaybe<GqlProducts_ImagesInput>>>;
  integrationKey?: InputMaybe<Scalars['String']>;
  limitsPerCustomer?: InputMaybe<Array<InputMaybe<GqlProducts_LimitPerCustomerInput>>>;
  manualInventory?: InputMaybe<Array<InputMaybe<GqlProducts_ManualInventoryInput>>>;
  medicalOnly?: InputMaybe<Scalars['Boolean']>;
  medicalPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  medicalSpecialPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  originalPrices?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overrides?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pastCNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preCropImage?: InputMaybe<Scalars['String']>;
  qaRejectionReason?: InputMaybe<Scalars['String']>;
  rawOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  recOnly?: InputMaybe<Scalars['Boolean']>;
  recPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  recSpecialPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  score?: InputMaybe<Scalars['Float']>;
  special?: InputMaybe<Scalars['Boolean']>;
  stockImage?: InputMaybe<Scalars['String']>;
  stockImageAliases?: InputMaybe<Scalars['String']>;
  stockImageCategory?: InputMaybe<Scalars['String']>;
  strainType?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  terpenes?: InputMaybe<Array<InputMaybe<GqlProducts_TerpeneInput>>>;
  type?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export enum ProductsFilterByOption {
  highCbd = 'highCBD',
  highPotency = 'highPotency',
  newProducts = 'newProducts'
}

export type GqlProductsFilterInput = {
  CBDContent?: InputMaybe<GqlProductsPotencyInput>;
  Status?: InputMaybe<Scalars['String']>;
  THCContent?: InputMaybe<GqlProductsPotencyInput>;
  brandId?: InputMaybe<Scalars['String']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bypassKioskThresholds?: InputMaybe<Scalars['Boolean']>;
  bypassOnlineThresholds?: InputMaybe<Scalars['Boolean']>;
  bypassSpecials?: InputMaybe<Scalars['Boolean']>;
  bypassThresholds?: InputMaybe<Scalars['Boolean']>;
  cName?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ProductsFilterByOption>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']>;
  isDefaultSort?: InputMaybe<Scalars['Boolean']>;
  isKioskMenu?: InputMaybe<Scalars['Boolean']>;
  isOnSpecial?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  option?: InputMaybe<Scalars['String']>;
  platformType?: InputMaybe<Scalars['String']>;
  preOrderType?: InputMaybe<Scalars['String']>;
  pricingType?: InputMaybe<MenuPricingTypes>;
  productId?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
  removeProductsBelowOptionThresholds?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Int']>;
  specialId?: InputMaybe<Scalars['String']>;
  specialType?: InputMaybe<Scalars['String']>;
  sponsoredProductsInventoryId?: InputMaybe<SponsoredProductsInventoryId>;
  sponsoredProductsLimit?: InputMaybe<Scalars['Int']>;
  staffPicks?: InputMaybe<Scalars['Boolean']>;
  strainTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subcategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  terpenes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCache?: InputMaybe<Scalars['Boolean']>;
};

export type GqlProductsInput = {
  AdditionalOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Options?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Prices?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  additionalOption?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  option?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  rawOption?: InputMaybe<Scalars['String']>;
  rawOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  special?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export type GqlProductsPotencyInput = {
  range?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  unit: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type GqlQueryInfoType = {
  __typename?: 'queryInfoType';
  perPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type GqlResetPasswordInput = {
  password?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type GqlSalesOrdersQueryResponse = {
  __typename?: 'salesOrdersQueryResponse';
  ordersByDate?: Maybe<Array<Maybe<GqlAnalyticsOrdersByDate>>>;
  percentChange?: Maybe<Scalars['Float']>;
  revenueChange?: Maybe<Scalars['Float']>;
  totalOrders?: Maybe<Scalars['Float']>;
  totalSales?: Maybe<Scalars['Float']>;
};

export type GqlSearchBrandsFilters = {
  active?: InputMaybe<Scalars['Boolean']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  hasCollisions?: InputMaybe<Scalars['Boolean']>;
  hasParent?: InputMaybe<Scalars['Boolean']>;
  local?: InputMaybe<Scalars['Boolean']>;
  localAndGlobal?: InputMaybe<Scalars['Boolean']>;
  missingDescription?: InputMaybe<Scalars['Boolean']>;
  missingLogo?: InputMaybe<Scalars['Boolean']>;
  parentBrandId?: InputMaybe<Scalars['ID']>;
};

export type GqlSearchBrandsSort = {
  sortBy: BrandSortByEnum;
  sortDirection: StringSortDirections;
};

export type GqlSearchLibraryProductsFilters = {
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  category?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Float']>;
  stateLibrary?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LibraryProductStatusEnum>;
  updatedByBrand?: InputMaybe<Scalars['Boolean']>;
};

export type GqlSearchLibraryProductsSort = {
  sortBy: LibraryProductSortByEnum;
  sortDirection: StringSortDirections;
};

export type GqlSetPasswordInput = {
  password?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type GqlSortInput = {
  sortBy: Scalars['String'];
  sortDirection: Scalars['Int'];
};

export type GqlSpecialHoursDayInput = {
  date: Scalars['String'];
  deliveryHours?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  pickupHours?: InputMaybe<GqlDispensaryUpdateHoursDay>;
};

export type GqlSpecialHoursInput = {
  endDate: Scalars['String'];
  hoursPerDay?: InputMaybe<Array<InputMaybe<GqlSpecialHoursDayInput>>>;
  name: Scalars['String'];
  startDate: Scalars['String'];
};

export type GqlSpecialsInputRecurring = {
  days?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  endDate?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  setEndDate?: InputMaybe<Scalars['Boolean']>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type GqlSpecialsPageInput = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type GqlSpecialsSortInput = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};

export type GqlSpecialsSortInputV2 = {
  direction: Scalars['Int'];
  key: SpecialSortKey;
};

export type GqlStrainInput = {
  aromas?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  effects?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageUrl?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  potentialHealthBenefits?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ratio?: InputMaybe<Scalars['String']>;
  terpenes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GqlStrainsFilterInput = {
  missingDescription?: InputMaybe<Scalars['Boolean']>;
  missingImage?: InputMaybe<Scalars['Boolean']>;
  searchStr?: InputMaybe<Scalars['String']>;
};

export type GqlStrainsSortInput = {
  sortBy: StrainSortByEnum;
  sortDirection: StringSortDirections;
};

export type GqlSubscriptionsFilterInput = {
  dispensaryId?: InputMaybe<Scalars['String']>;
};

export type GqlSuperAdminCustomersFilter = {
  search?: InputMaybe<Scalars['String']>;
};

export type GqlSuperProductsInput = {
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  category?: InputMaybe<Scalars['String']>;
  connectionStatus: Scalars['String'];
  dispensaryID?: InputMaybe<Scalars['String']>;
  dispensaryState?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  reviewed?: InputMaybe<Scalars['String']>;
  score: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
  sortBy: Scalars['String'];
  sortDirection: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
  thresholdFilter?: InputMaybe<Scalars['String']>;
};

export type GqlTerpeneInput = {
  aliasList?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  aromas?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  effects?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  potentialHealthBenefits?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GqlTerpenesFilter = {
  searchStr?: InputMaybe<Scalars['String']>;
};

export type GqlTerpenesSort = {
  sortBy: Scalars['String'];
  sortDirection: Scalars['String'];
};

export type GqlTipInput = {
  dollar?: InputMaybe<Scalars['Float']>;
  percent?: InputMaybe<Scalars['Float']>;
};

export type GqlUnsubscribeDispensaryCustomersInput = {
  _id?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dispensaryId: Scalars['String'];
};

export type GqlUpdateCouponInput = {
  _id?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  applicableCategories?: InputMaybe<Array<InputMaybe<GqlCopuonApplicableCategoryInput>>>;
  code?: InputMaybe<Scalars['String']>;
  expDate?: InputMaybe<Scalars['String']>;
  fixedDiscountInCents?: InputMaybe<Scalars['Int']>;
  numAllowedUses?: InputMaybe<Scalars['Int']>;
  numUses?: InputMaybe<Scalars['Int']>;
  oneUsePerCustomer?: InputMaybe<Scalars['Boolean']>;
  percentDiscount?: InputMaybe<Scalars['Float']>;
  reimbursed?: InputMaybe<Scalars['Boolean']>;
  restrictions?: InputMaybe<GqlCouponRestrictionsInput>;
  usedBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GqlUpdateDeviceInput = {
  _id?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<GqlDevice_Config_Input>;
  nickname?: InputMaybe<Scalars['String']>;
};

export type GqlUpdateDispensaryAdSettingsInput = {
  adsEnabledMenuVariant: Scalars['String'];
  disableGroup: Array<InputMaybe<Scalars['String']>>;
  enableGroup: Array<InputMaybe<Scalars['String']>>;
};

export type GqlUpdateDispensaryPersonalizationSettingsInput = {
  disableGroup: Array<InputMaybe<Scalars['String']>>;
  enableGroup: Array<InputMaybe<Scalars['String']>>;
  personalizationEnabledMenuVariant: Scalars['String'];
};

export type GqlUpdateKioskOrderPaymentInput = {
  dispensaryId: Scalars['String'];
  id: Scalars['String'];
  paymentMethod: Scalars['String'];
  paymentMethodId?: InputMaybe<Scalars['String']>;
  tipCents?: InputMaybe<Scalars['Int']>;
  updateOrderToken: Scalars['String'];
};

export type GqlUpdateProductSortInput = {
  dispensaryId?: InputMaybe<Scalars['String']>;
  menuOrder?: InputMaybe<Scalars['String']>;
  menuSortSetting?: InputMaybe<GqlMenuSortSettingInput>;
  sortProductProxies?: InputMaybe<Array<InputMaybe<GqlSortProductProxy>>>;
};

export type GqlUpdateSingleDispensaryAdSettingsInput = {
  dispensaryId: Scalars['String'];
  settings: GqlDispensaryAdSettingsInput;
};

export type GqlUpdateSingleDispensaryPersonalizationSettingsInput = {
  dispensaryId: Scalars['String'];
  settings: GqlDispensaryPersonalizationSettingsInput;
};

export type GqlUserIdExistsInput = {
  email?: InputMaybe<Scalars['String']>;
};

export type GqlUsersCreateInput = {
  chain?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  dispensaryId: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  legacyChain?: InputMaybe<Scalars['Boolean']>;
  permissions?: InputMaybe<GqlPermissionsInput>;
  phone?: InputMaybe<Scalars['String']>;
  roleAtDispensary?: InputMaybe<DispensaryRoles>;
  /** @deprecated no longer sending admin text notifications */
  textNotifications?: InputMaybe<Scalars['Boolean']>;
};

export type GqlUsersDeleteInput = {
  _id?: InputMaybe<Scalars['String']>;
};

export type GqlUsersFilterInput = {
  chainID?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  driver?: InputMaybe<Scalars['Boolean']>;
  superadmin?: InputMaybe<Scalars['Boolean']>;
};

export type GqlUsersUpdateInput = {
  _id?: InputMaybe<Scalars['String']>;
  audioNotificationsOnNewArrivalsDisabled?: InputMaybe<Scalars['Boolean']>;
  audioNotificationsOnNewOrdersDisabled?: InputMaybe<Scalars['Boolean']>;
  browserNotification?: InputMaybe<Scalars['Boolean']>;
  chain?: InputMaybe<Scalars['String']>;
  desktopNotification?: InputMaybe<Scalars['Boolean']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  fullName?: InputMaybe<Scalars['String']>;
  isWeeklyReportEnabled?: InputMaybe<Scalars['Boolean']>;
  legacyChain?: InputMaybe<Scalars['Boolean']>;
  permissions?: InputMaybe<GqlPermissionsInput>;
  phone?: InputMaybe<Scalars['String']>;
  roleAtDispensary?: InputMaybe<DispensaryRoles>;
  /** @deprecated no longer sending admin text notifications */
  textNotifications?: InputMaybe<Scalars['Boolean']>;
};

export type GqlUtmDataInput = {
  dtm_campaign?: InputMaybe<Scalars['String']>;
  dtm_content?: InputMaybe<Scalars['String']>;
  dtm_medium?: InputMaybe<Scalars['String']>;
  utm_campaign?: InputMaybe<Scalars['String']>;
  utm_content?: InputMaybe<Scalars['String']>;
  utm_medium?: InputMaybe<Scalars['String']>;
  utm_source?: InputMaybe<Scalars['String']>;
  utm_term?: InputMaybe<Scalars['String']>;
};

export type GqlV4Condition = {
  __typename?: 'v4Condition';
  conditionType?: Maybe<ConditionType>;
  exclusions?: Maybe<Array<Maybe<GqlV4Restriction>>>;
  groupBySku?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  includeCannabis?: Maybe<Scalars['Boolean']>;
  inclusions?: Maybe<Array<Maybe<GqlV4Restriction>>>;
  thresholds?: Maybe<Array<Maybe<GqlThreshold>>>;
};

export type GqlV4ConditionInput = {
  conditionType?: InputMaybe<ConditionType>;
  exclusions?: InputMaybe<Array<InputMaybe<GqlV4RestrictionInput>>>;
  groupBySku?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  includeCannabis?: InputMaybe<Scalars['Boolean']>;
  inclusions?: InputMaybe<Array<InputMaybe<GqlV4RestrictionInput>>>;
  thresholds?: InputMaybe<Array<InputMaybe<GqlThresholdInput>>>;
};

export type GqlV4Restriction = {
  __typename?: 'v4Restriction';
  brandId?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  inventoryTag?: Maybe<Scalars['String']>;
  matchOperator?: Maybe<Scalars['String']>;
  pricingTierId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productTag?: Maybe<Scalars['String']>;
  restrictionType?: Maybe<RestrictionType>;
  strainId?: Maybe<Scalars['String']>;
  subcategoryId?: Maybe<Scalars['String']>;
  subcategoryName?: Maybe<Scalars['String']>;
  tagId?: Maybe<Scalars['String']>;
  vendorId?: Maybe<Scalars['String']>;
  weight?: Maybe<GqlWeight>;
};

export type GqlV4RestrictionInput = {
  brandId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  categoryName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inventoryTag?: InputMaybe<Scalars['String']>;
  matchOperator?: InputMaybe<Scalars['String']>;
  pricingTierId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  productTag?: InputMaybe<Scalars['String']>;
  restrictionType?: InputMaybe<RestrictionType>;
  strainId?: InputMaybe<Scalars['String']>;
  subcategoryId?: InputMaybe<Scalars['String']>;
  subcategoryName?: InputMaybe<Scalars['String']>;
  tagId?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<GqlWeightInput>;
};

export type GqlV4Reward = {
  __typename?: 'v4Reward';
  amountOff?: Maybe<Scalars['Int']>;
  discountType?: Maybe<DiscountType>;
  discountedPrice?: Maybe<Scalars['Int']>;
  exclusions?: Maybe<Array<Maybe<GqlV4Restriction>>>;
  groupBySku?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  includeNonCannabis?: Maybe<Scalars['Boolean']>;
  inclusions?: Maybe<Array<Maybe<GqlV4Restriction>>>;
  percentDiscount?: Maybe<Scalars['Float']>;
  rangeBehavior?: Maybe<RangeBehaviors>;
  rewardType?: Maybe<RewardType>;
  thresholds?: Maybe<Array<Maybe<GqlThreshold>>>;
};

export type GqlV4RewardInput = {
  amountOff?: InputMaybe<Scalars['Int']>;
  discountType?: InputMaybe<DiscountType>;
  discountedPrice?: InputMaybe<Scalars['Int']>;
  exclusions?: InputMaybe<Array<InputMaybe<GqlV4RestrictionInput>>>;
  groupBySku?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  includeNonCannabis?: InputMaybe<Scalars['Boolean']>;
  inclusions?: InputMaybe<Array<InputMaybe<GqlV4RestrictionInput>>>;
  percentDiscount?: InputMaybe<Scalars['Float']>;
  rangeBehavior?: InputMaybe<RangeBehaviors>;
  rewardType?: InputMaybe<RewardType>;
  thresholds?: InputMaybe<Array<InputMaybe<GqlThresholdInput>>>;
};

export type GqlV4Special = {
  __typename?: 'v4Special';
  allowedUsesPerUser?: Maybe<Scalars['Int']>;
  applicableToItemsOnSpecial?: Maybe<Scalars['Boolean']>;
  applicationMethod?: Maybe<SpecialApplicationMethodTypes>;
  cipher?: Maybe<Scalars['JSON']>;
  code?: Maybe<Scalars['String']>;
  conditionLogicOperator?: Maybe<LogicOperator>;
  conditions?: Maybe<Array<Maybe<GqlV4Condition>>>;
  consumerGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  discountPrecedence?: Maybe<Scalars['String']>;
  dispensaries?: Maybe<Array<Maybe<Scalars['String']>>>;
  dispensaryId?: Maybe<Scalars['String']>;
  displayRank?: Maybe<Scalars['Int']>;
  email?: Maybe<GqlSpecialEmail>;
  endedAt?: Maybe<Scalars['ISODateTime']>;
  endedBy?: Maybe<Scalars['String']>;
  enterpriseId?: Maybe<Scalars['String']>;
  enterpriseSpecialId?: Maybe<Scalars['String']>;
  firstTimeConsumerOnly?: Maybe<Scalars['Boolean']>;
  generatedByPOS?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  inactiveDispensaryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  isAvailableOnline?: Maybe<Scalars['Boolean']>;
  loyaltyPointsToRedeem?: Maybe<Scalars['Int']>;
  manualDefaultApplyTo?: Maybe<ManualDefaultApplyTo>;
  menuDisplay?: Maybe<GqlSpecialMenuDisplay>;
  menuType?: Maybe<SpecialMenuType>;
  name?: Maybe<Scalars['String']>;
  orderType?: Maybe<OrderType>;
  origin?: Maybe<Scalars['String']>;
  originId?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  redemptionLimitPerCart?: Maybe<Scalars['Int']>;
  redemptionLimitPerUser?: Maybe<Scalars['Int']>;
  reimbursed?: Maybe<Scalars['Boolean']>;
  requireManagerApproval?: Maybe<Scalars['Boolean']>;
  rewardLogicOperator?: Maybe<LogicOperator>;
  rewards?: Maybe<Array<Maybe<GqlV4Reward>>>;
  schedule?: Maybe<GqlSpecialSchedule>;
  scope?: Maybe<Scalars['String']>;
  specialType?: Maybe<SpecialType>;
  specialVersion?: Maybe<Scalars['Int']>;
  stackingBehavior?: Maybe<StackingBehavior>;
  status?: Maybe<SpecialStatus>;
  totalAllowedUses?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  usedBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  version?: Maybe<Scalars['Int']>;
};

export type GqlBrandDispensaryFragmentFragment = { __typename?: 'Brand', dispensary?: { __typename?: 'Dispensaries', id: string, name?: string | null } | null };

export type GqlBrandFragmentForDropdownFragment = { __typename?: 'Brand', _id: string, id: string, name: string, imageUrl?: string | null };

export type GqlBrandFragmentFragment = { __typename?: 'Brand', _id: string, aliasList: Array<string | null>, createdAt?: any | null, description?: string | null, id: string, imageUrl?: string | null, libraryProductsCount: number, name: string, productsCount: number, updatedAt?: any | null };

export type GqlCreateBrandMutationVariables = Exact<{
  brand: GqlBrandInput;
}>;


export type GqlCreateBrandMutation = { __typename?: 'Mutation', createBrandV2?: { __typename?: 'Brand', _id: string, aliasList: Array<string | null>, createdAt?: any | null, description?: string | null, id: string, imageUrl?: string | null, libraryProductsCount: number, name: string, productsCount: number, updatedAt?: any | null } | null };

export type GqlDeleteBrandMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type GqlDeleteBrandMutation = { __typename?: 'Mutation', deleteBrand?: { __typename?: 'Brand', _id: string } | null };

export type GqlUpdateBrandMutationVariables = Exact<{
  id: Scalars['String'];
  brand: GqlBrandInput;
}>;


export type GqlUpdateBrandMutation = { __typename?: 'Mutation', updateBrandV2?: { __typename?: 'Brand', _id: string, aliasList: Array<string | null>, createdAt?: any | null, description?: string | null, id: string, imageUrl?: string | null, libraryProductsCount: number, name: string, productsCount: number, updatedAt?: any | null } | null };

export type GqlBrandsForDropdownQueryVariables = Exact<{
  dispensaryId?: InputMaybe<Scalars['String']>;
  searchString?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  parentBrandId?: InputMaybe<Scalars['ID']>;
  hasParent?: InputMaybe<Scalars['Boolean']>;
  localAndGlobal?: InputMaybe<Scalars['Boolean']>;
}>;


export type GqlBrandsForDropdownQuery = { __typename?: 'Query', searchBrandsV2?: { __typename?: 'BrandList', brands: Array<{ __typename?: 'Brand', isGlobal: boolean, _id: string, id: string, name: string, imageUrl?: string | null } | null> } | null };

export type GqlGetBrandRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetBrandRegionsQuery = { __typename?: 'Query', listRegions: Array<{ __typename?: 'Region', id: string, code: string, country: string, subdivision?: string | null, countryName?: string | null, subdivisionName?: string | null } | null> };

export type GqlGetBrandQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GqlGetBrandQuery = { __typename?: 'Query', getBrand?: { __typename?: 'Brand', isGlobal: boolean, source?: string | null, creatorUserId?: string | null, parentBrandId?: string | null, _id: string, aliasList: Array<string | null>, createdAt?: any | null, description?: string | null, id: string, imageUrl?: string | null, libraryProductsCount: number, name: string, productsCount: number, updatedAt?: any | null, regions?: Array<{ __typename?: 'Region', id: string, code: string, country: string, subdivision?: string | null, countryName?: string | null, subdivisionName?: string | null }> | null, dispensary?: { __typename?: 'Dispensaries', name?: string | null, id: string } | null, enterprise?: { __typename?: 'Enterprise', id: string, name: string } | null } | null };

export type GqlSuperBrandsIndexQueryVariables = Exact<{
  filters?: InputMaybe<GqlSearchBrandsFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<GqlSearchBrandsSort>;
}>;


export type GqlSuperBrandsIndexQuery = { __typename?: 'Query', searchBrandsV2?: { __typename?: 'BrandList', brands: Array<{ __typename?: 'Brand', _id: string, aliasList: Array<string | null>, createdAt?: any | null, description?: string | null, id: string, imageUrl?: string | null, libraryProductsCount: number, name: string, productsCount: number, updatedAt?: any | null, dispensary?: { __typename?: 'Dispensaries', id: string, name?: string | null } | null } | null>, queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null } | null };

export type GqlBucketListFragmentFragment = { __typename?: 'Bucket', checkedOutAt?: any | null, completedReviewsCount?: number | null, id: string, name: string, productsCount: number, teamName: string, createdBy?: { __typename?: 'Users', _id?: string | null, firstName?: string | null, lastName?: string | null } | null, checkedOutBy?: { __typename?: 'Users', _id?: string | null, firstName?: string | null, lastName?: string | null } | null };

export type GqlComputeWithPriceCartV2MutationVariables = Exact<{
  priceCartInput: GqlCalculationsInput;
}>;


export type GqlComputeWithPriceCartV2Mutation = { __typename?: 'Mutation', computeWithPriceCartV2?: { __typename?: 'CalculationResults', subTotal?: number | null, taxes?: number | null, discount?: number | null, originalTotal?: number | null, roundedDifference?: number | null, grandTotal?: number | null, loyaltyPointsUsed?: number | null, totalSalesTax?: number | null, totalCannabisTax?: number | null, totalBottleDepositTax?: number | null, taxInclusivePricing?: boolean | null, loyaltyAppliedAsDiscount?: number | null, discountWithoutLoyalty?: number | null, posCustomerId?: number | null, itemTaxes?: Array<{ __typename?: 'ItemTax', taxAmount?: number | null, taxType?: string | null, productId?: number | null, feeItemId?: number | null, showOnMenu?: boolean | null, showOnCheckout?: boolean | null } | null> | null, cartItemPrices?: Array<{ __typename?: 'CartItem', productName?: string | null, productId?: number | null, quantity?: number | null, subtotal?: number | null, unitPrice?: number | null, pricingTierAdjustment?: number | null, pricingTierAdjustmentTotal?: number | null, summaryPrice?: number | null, menuPrice?: number | null, tax?: number | null, unitWeightGrams?: number | null, productType?: string | null, discounts?: Array<{ __typename?: 'Discount', name?: string | null, amount?: number | null, discountId?: number | null, applicationMethod?: string | null, isLoyaltyReward?: boolean | null, isPaymentIncentive?: boolean | null } | null> | null } | null> | null, fees?: Array<{ __typename?: 'Fees', feeItemId?: number | null, feeAmount?: number | null, feeName?: string | null, deliveryFee?: boolean | null, paymentFee?: boolean | null } | null> | null, rewardValidationErrors?: Array<{ __typename?: 'RewardValidationError', discountCode?: string | null, discountId?: number | null, message?: string | null } | null> | null, discountGamification?: { __typename?: 'CalculationResults_CartGamification', gamificationDetails?: Array<{ __typename?: 'GamificationDetailItem', discountId?: number | null, satisfiers?: Array<{ __typename?: 'GamificationDetailItem_Satisfier', thresholdType?: string | null, minimumThreshold?: number | null, products?: Array<{ __typename?: 'GamificationDetailItem_Satisfiers_Product', productId?: number | null, ecommKey?: string | null, amount?: number | null } | null> | null } | null> | null } | null> | null } | null } | null };

export type GqlServerSideCalculationsMutationVariables = Exact<{
  input: GqlLegacyCalculationsInput;
}>;


export type GqlServerSideCalculationsMutation = { __typename?: 'Mutation', serverSideCalculations?: { __typename?: 'LegacyCalculationResults', bottleDepositTaxCents?: number | null, cannabisTax?: number | null, cartSubtotal?: number | null, credit?: number | null, deliveryFee?: number | null, menuTotal?: number | null, mixAndMatch?: number | null, otherFees?: number | null, paymentFee?: number | null, paymentIncentives?: Array<any | null> | null, reward?: number | null, rounding?: number | null, subtotal?: number | null, tax?: number | null, tip?: number | null, total?: number | null, receipt?: any | null, details?: Array<{ __typename?: 'DetailItem', basePrice?: number | null, basePriceMult?: number | null, bottleDepositTaxCents?: number | null, canonicalEffectivePotencyMg?: number | null, enterpriseProductId?: string | null, id?: string | null, isOnSale?: boolean | null, isVapeTaxed?: boolean | null, key?: string | null, menuBasePrice?: number | null, menuCannabisTax?: number | null, menuIndividualPrice?: number | null, menuSaleAdjustment?: number | null, menuPrice?: number | null, menuSalesTax?: number | null, option?: string | null, posId?: string | null, productBrand?: string | null, productBrandId?: string | null, productCategory?: string | null, productSubcategory?: string | null, quantity?: number | null, type?: string | null, weightInGrams?: number | null, weightInMg?: number | null, wholesalePrice?: number | null, bogoSavings?: { __typename?: 'BogoSavingsObj', displayAsPercentDiscount?: boolean | null, isDiscountToCartReward?: boolean | null, menuBogoDiscount?: string | null, total?: number | null, individual?: Array<{ __typename?: 'BogoSavings_Individual', conditionQuantity?: number | null, discountAmount?: number | null, discountStacking?: boolean | null, displayAsPercentDiscount?: boolean | null, isDiscountToCartReward?: boolean | null, maxApplicable?: number | null, nonStackingBehavior?: string | null, specialId?: string | null, stackingBehavior?: string | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', endWeight?: number | null, price?: number | null, pricePerGram?: number | null, startWeight?: number | null, weightUOM?: string | null } | null> | null } | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, discountBehavior?: string | null, discountPrecedence?: string | null, discountStacking?: boolean | null, endStamp?: string | null, excludeConditionItemsFromRewards?: boolean | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, rawPOSWeightMapping?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weightOperator?: WeightOperator | null, weights?: Array<string | null> | null } | null> | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, percentDiscount?: string | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, targetPrice?: string | null, vendorIds?: Array<string | null> | null, weight?: string | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weightOperator?: WeightOperator | null, weights?: Array<string | null> | null } | null> | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, discountType?: string | null, enabled?: boolean | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, percentDiscount?: boolean | null, rawPOSWeightMapping?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialRestrictions?: any | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weightOperator?: WeightOperator | null, weights?: Array<string | null> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weightOperator?: WeightOperator | null, weights?: Array<string | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, bottleDepositTaxExistence?: { __typename?: 'TaxExistence', med?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null, rec?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null } | null, cannabisTaxExistence?: { __typename?: 'TaxExistence', med?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null, rec?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null } | null, lineitems?: Array<{ __typename?: 'LineItem', type?: string | null, value?: number | null } | null> | null, salesTaxExistence?: { __typename?: 'TaxExistence', med?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null, rec?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null } | null } | null };

export type GqlComputeWithPriceCartQueryVariables = Exact<{
  priceCartInput: GqlCalculationsInput;
}>;


export type GqlComputeWithPriceCartQuery = { __typename?: 'Query', computeWithPriceCart?: { __typename?: 'CalculationResults', subTotal?: number | null, taxes?: number | null, discount?: number | null, originalTotal?: number | null, roundedDifference?: number | null, grandTotal?: number | null, loyaltyPointsUsed?: number | null, totalSalesTax?: number | null, totalCannabisTax?: number | null, totalBottleDepositTax?: number | null, taxInclusivePricing?: boolean | null, loyaltyAppliedAsDiscount?: number | null, discountWithoutLoyalty?: number | null, posCustomerId?: number | null, itemTaxes?: Array<{ __typename?: 'ItemTax', taxAmount?: number | null, taxType?: string | null, productId?: number | null, feeItemId?: number | null, showOnMenu?: boolean | null, showOnCheckout?: boolean | null } | null> | null, cartItemPrices?: Array<{ __typename?: 'CartItem', productName?: string | null, productId?: number | null, quantity?: number | null, subtotal?: number | null, unitPrice?: number | null, pricingTierAdjustment?: number | null, pricingTierAdjustmentTotal?: number | null, summaryPrice?: number | null, menuPrice?: number | null, tax?: number | null, unitWeightGrams?: number | null, productType?: string | null, discounts?: Array<{ __typename?: 'Discount', name?: string | null, amount?: number | null, discountId?: number | null, applicationMethod?: string | null, isLoyaltyReward?: boolean | null, isPaymentIncentive?: boolean | null } | null> | null } | null> | null, fees?: Array<{ __typename?: 'Fees', feeItemId?: number | null, feeAmount?: number | null, feeName?: string | null, deliveryFee?: boolean | null, paymentFee?: boolean | null } | null> | null, rewardValidationErrors?: Array<{ __typename?: 'RewardValidationError', discountCode?: string | null, discountId?: number | null, message?: string | null } | null> | null } | null };

export type GqlGetCannabinoidsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetCannabinoidsQuery = { __typename?: 'Query', getCannabinoids: Array<{ __typename?: 'Cannabinoid', name: string, id: string }> };

export type GqlCouponFragmentFragment = { __typename?: 'Coupons', _id: string, active?: boolean | null, addedDate?: string | null, code?: string | null, dispensaryId?: string | null, expDate?: string | null, fixedDiscountInCents?: number | null, numAllowedUses?: number | null, numUses?: number | null, percentDiscount?: number | null, oneUsePerCustomer?: boolean | null, usedBy?: Array<string | null> | null, applicableCategories?: Array<{ __typename?: 'couponApplicableCategory', category?: string | null, subcategory?: string | null } | null> | null, restrictions?: { __typename?: 'couponRestrictions', minimumPurchase?: boolean | null, minimumPurchaseInCents?: number | null, noSpecials?: boolean | null } | null };

export type GqlCreateCouponV2MutationVariables = Exact<{
  input: GqlCreateCouponInput;
}>;


export type GqlCreateCouponV2Mutation = { __typename?: 'Mutation', createCouponV2?: { __typename?: 'Coupons', _id: string, active?: boolean | null, addedDate?: string | null, code?: string | null, dispensaryId?: string | null, expDate?: string | null, fixedDiscountInCents?: number | null, numAllowedUses?: number | null, numUses?: number | null, percentDiscount?: number | null, oneUsePerCustomer?: boolean | null, usedBy?: Array<string | null> | null, applicableCategories?: Array<{ __typename?: 'couponApplicableCategory', category?: string | null, subcategory?: string | null } | null> | null, restrictions?: { __typename?: 'couponRestrictions', minimumPurchase?: boolean | null, minimumPurchaseInCents?: number | null, noSpecials?: boolean | null } | null } | null };

export type GqlDeleteCouponMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type GqlDeleteCouponMutation = { __typename?: 'Mutation', deleteCoupon?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlDeleteCouponV2MutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type GqlDeleteCouponV2Mutation = { __typename?: 'Mutation', deleteCouponV2?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlUpdateCouponMutationVariables = Exact<{
  input: GqlUpdateCouponInput;
}>;


export type GqlUpdateCouponMutation = { __typename?: 'Mutation', updateCoupon?: { __typename?: 'Coupons', _id: string, active?: boolean | null, addedDate?: string | null, code?: string | null, dispensaryId?: string | null, expDate?: string | null, fixedDiscountInCents?: number | null, numAllowedUses?: number | null, numUses?: number | null, percentDiscount?: number | null, oneUsePerCustomer?: boolean | null, usedBy?: Array<string | null> | null, applicableCategories?: Array<{ __typename?: 'couponApplicableCategory', category?: string | null, subcategory?: string | null } | null> | null, restrictions?: { __typename?: 'couponRestrictions', minimumPurchase?: boolean | null, minimumPurchaseInCents?: number | null, noSpecials?: boolean | null } | null } | null };

export type GqlFilteredCouponsQueryVariables = Exact<{
  filter?: InputMaybe<GqlCouponsFilterInput>;
  sort?: InputMaybe<GqlCouponsSortInput>;
  pagination?: InputMaybe<GqlCouponsPaginationInput>;
}>;


export type GqlFilteredCouponsQuery = { __typename?: 'Query', filteredCoupons?: { __typename?: 'CouponList', queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null, coupons?: Array<{ __typename?: 'Coupons', dispensary?: string | null, reimbursed?: boolean | null, _id: string, active?: boolean | null, addedDate?: string | null, code?: string | null, dispensaryId?: string | null, expDate?: string | null, fixedDiscountInCents?: number | null, numAllowedUses?: number | null, numUses?: number | null, percentDiscount?: number | null, oneUsePerCustomer?: boolean | null, usedBy?: Array<string | null> | null, applicableCategories?: Array<{ __typename?: 'couponApplicableCategory', category?: string | null, subcategory?: string | null } | null> | null, restrictions?: { __typename?: 'couponRestrictions', minimumPurchase?: boolean | null, minimumPurchaseInCents?: number | null, noSpecials?: boolean | null } | null } | null> | null } | null };

export type GqlClearAllCurbsideArrivalsMutationVariables = Exact<{
  dispensaryId: Scalars['String'];
}>;


export type GqlClearAllCurbsideArrivalsMutation = { __typename?: 'Mutation', clearAllCurbsideArrivals: { __typename?: 'GenericResponse', success?: boolean | null } };

export type GqlClearCurbsideArrivalMutationVariables = Exact<{
  arrivalId: Scalars['String'];
}>;


export type GqlClearCurbsideArrivalMutation = { __typename?: 'Mutation', clearCurbsideArrival: { __typename?: 'GenericResponse', success?: boolean | null } };

export type GqlMarkCurbsideArrivalArrivedV2MutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type GqlMarkCurbsideArrivalArrivedV2Mutation = { __typename?: 'Mutation', markCurbsideArrivalArrivedV2: { __typename?: 'CurbsideArrival', id?: string | null } };

export type GqlUpdateCurbsideArrivalV2MutationVariables = Exact<{
  token: Scalars['String'];
  arrivalInformation: Scalars['String'];
}>;


export type GqlUpdateCurbsideArrivalV2Mutation = { __typename?: 'Mutation', updateCurbsideArrivalV2?: { __typename?: 'CurbsideArrival', id?: string | null } | null };

export type GqlGetCurbsideArrivalByTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GqlGetCurbsideArrivalByTokenQuery = { __typename?: 'Query', getCurbsideArrivalByToken?: { __typename?: 'CurbsideArrival', id?: string | null, arrivalInformation?: string | null, arrivedAt?: any | null, clearedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, dispensary?: { __typename?: 'Dispensaries', id: string, phone?: string | null, orderTypesConfigV2?: { __typename?: 'OrderTypesConfigV2', curbsidePickup?: { __typename?: 'CurbsidePickupOrderingSettings', arrivalInformationInstructions?: string | null } | null } | null } | null } | null };

export type GqlGetCurbsideArrivalsForBannerQueryVariables = Exact<{
  dispensaryId: Scalars['String'];
}>;


export type GqlGetCurbsideArrivalsForBannerQuery = { __typename?: 'Query', getCurbsideArrivals: Array<{ __typename?: 'CurbsideArrival', id?: string | null }> };

export type GqlGetCurbsideArrivalsQueryVariables = Exact<{
  dispensaryId: Scalars['String'];
}>;


export type GqlGetCurbsideArrivalsQuery = { __typename?: 'Query', getCurbsideArrivals: Array<{ __typename?: 'CurbsideArrival', id?: string | null, arrivalInformation?: string | null, arrivedAt?: any | null, clearedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, order?: { __typename?: 'Orders', id?: string | null, orderId?: string | null, customer?: { __typename?: 'Orders_customer', profile?: { __typename?: 'Orders_customer_profile', firstName?: string | null, lastName?: string | null, phone?: string | null } | null } | null, guestCustomer?: { __typename?: 'Orders_guestCustomer', firstName?: string | null, lastName?: string | null, phone?: string | null } | null } | null }> };

export type GqlUpdateCustomerSubscriptionMutationVariables = Exact<{
  customerId: Scalars['String'];
  subscribed: Scalars['Boolean'];
}>;


export type GqlUpdateCustomerSubscriptionMutation = { __typename?: 'Mutation', updateCustomerSubscription?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlDeviceFragmentFragment = { __typename?: 'Devices', _id?: string | null, accessCode?: string | null, autoPrintDevice?: boolean | null, buildNumber?: string | null, dispensaryId?: string | null, lastSeenAt?: string | null, nickname?: string | null, online?: boolean | null, printerConnected?: boolean | null, updatedAt?: string | null, versionNumber?: string | null, config?: { __typename?: 'Device_config', getDeliveryOrders?: boolean | null, getKioskOrders?: boolean | null, getPickupOrders?: boolean | null, orderSource?: string | null } | null };

export type GqlGetDevicesQueryVariables = Exact<{
  dispensaryId: Scalars['String'];
}>;


export type GqlGetDevicesQuery = { __typename?: 'Query', getDevices: Array<{ __typename?: 'Devices', _id?: string | null, accessCode?: string | null, autoPrintDevice?: boolean | null, buildNumber?: string | null, dispensaryId?: string | null, lastSeenAt?: string | null, nickname?: string | null, online?: boolean | null, printerConnected?: boolean | null, updatedAt?: string | null, versionNumber?: string | null, config?: { __typename?: 'Device_config', getDeliveryOrders?: boolean | null, getKioskOrders?: boolean | null, getPickupOrders?: boolean | null, orderSource?: string | null } | null }> };

export type GqlGetKioskTerminalsQueryVariables = Exact<{
  dispensaryId: Scalars['String'];
}>;


export type GqlGetKioskTerminalsQuery = { __typename?: 'Query', getKioskTerminals: Array<{ __typename?: 'KioskTerminal', id: string, dispensaryId: string, nickname?: string | null }> };

export type GqlAddSubscriptionToChainMutationVariables = Exact<{
  dispensaryIds: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  chargebeeCustomerId: Scalars['String'];
}>;


export type GqlAddSubscriptionToChainMutation = { __typename?: 'Mutation', addSubscriptionToChain?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlRemoveSubscriptionFromChainMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  chargebeeCustomerId: Scalars['String'];
}>;


export type GqlRemoveSubscriptionFromChainMutation = { __typename?: 'Mutation', removeSubscriptionFromChain?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlGetChainBillingInfoQueryVariables = Exact<{
  dispensaries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GqlGetChainBillingInfoQuery = { __typename?: 'Query', getBillingSubscriptions: Array<{ __typename?: 'BillingSubscription', dispensaryBilling?: { __typename?: 'DispensaryBilling', chain?: boolean | null, chargebeeCustomerId?: string | null } | null } | null> };

export type GqlGetSubscriptionsForChainQueryVariables = Exact<{
  dispensaries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GqlGetSubscriptionsForChainQuery = { __typename?: 'Query', getBillingSubscriptions: Array<{ __typename?: 'BillingSubscription', dispensaryBilling?: { __typename?: 'DispensaryBilling', chain?: boolean | null, chargebeeCustomer?: { __typename?: 'ChargebeeCustomer', company?: string | null } | null } | null } | null> };

export type GqlGetSubscriptionsV2PaymentSourcesFragment = { __typename?: 'DispensaryBillingV2', paymentSources?: Array<{ __typename?: 'ChargebeePaymentSource', type?: string | null, card?: { __typename?: 'ChargebeeCard', brand?: string | null, last4?: string | null } | null } | null> | null };

export type GqlGetSubscriptionsV2QueryVariables = Exact<{
  retailers: Array<InputMaybe<GqlRetailerInput>> | InputMaybe<GqlRetailerInput>;
}>;


export type GqlGetSubscriptionsV2Query = { __typename?: 'Query', getSubscriptionsV2: Array<{ __typename?: 'SubscriptionV2', manualPayments?: boolean | null, retailerId: string, dispensaryBilling?: { __typename?: 'DispensaryBillingV2', chain?: boolean | null, chargebeeCustomer?: { __typename?: 'ChargebeeCustomer', id?: string | null, company?: string | null, locationCount?: number | null, contacts?: Array<{ __typename?: 'ChargebeeContact', email?: string | null, sendBillingEmail?: boolean | null } | null> | null } | null, paymentSources?: Array<{ __typename?: 'ChargebeePaymentSource', type?: string | null, card?: { __typename?: 'ChargebeeCard', brand?: string | null, last4?: string | null } | null } | null> | null } | null, chargebeeSubscription?: { __typename?: 'ChargebeeSubscriptionV2', status: string, trialStart?: number | null, trialEnd?: number | null, currentTermStart?: number | null, currentTermEnd?: number | null, nextBillingAt?: number | null, createdAt?: number | null, startedAt?: number | null, activatedAt?: number | null, planAmount?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, total: number, status: string, amountPaid?: number | null, amountDue?: number | null, creditsApplied?: number | null, lineItems?: Array<{ __typename?: 'ChargebeeLineItem', dateFrom?: number | null, dateTo?: number | null, quantity?: number | null, amount?: number | null } | null> | null }> | null } | null, chargebeePlan?: { __typename?: 'ChargebeePlan', period: number, periodUnit: string } | null } | null> };

export type GqlGetSubscriptionsQueryVariables = Exact<{
  dispensaries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GqlGetSubscriptionsQuery = { __typename?: 'Query', getBillingSubscriptions: Array<{ __typename?: 'BillingSubscription', dispensaryId?: string | null, chargebeeSubscriptionId?: string | null, manualPayments?: boolean | null, dispensaryBilling?: { __typename?: 'DispensaryBilling', chain?: boolean | null, chargebeeCustomerId?: string | null, chargebeeCustomer?: { __typename?: 'ChargebeeCustomer', company?: string | null, locationCount?: number | null, contacts?: Array<{ __typename?: 'ChargebeeContact', email?: string | null, sendBillingEmail?: boolean | null } | null> | null } | null, paymentSources?: Array<{ __typename?: 'ChargebeePaymentSource', type?: string | null, card?: { __typename?: 'ChargebeeCard', brand?: string | null, last4?: string | null } | null } | null> | null } | null, chargebeeSubscription?: { __typename?: 'ChargebeeSubscription', status: string, trialStart?: number | null, trialEnd?: number | null, currentTermStart?: number | null, currentTermEnd?: number | null, nextBillingAt?: number | null, createdAt?: number | null, startedAt?: number | null, activatedAt?: number | null, planAmount?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, total: number, status: string, amountPaid?: number | null, amountDue?: number | null, creditsApplied?: number | null, lineItems?: Array<{ __typename?: 'ChargebeeLineItem', dateFrom?: number | null, dateTo?: number | null, quantity?: number | null, amount?: number | null } | null> | null } | null> | null } | null, chargebeePlan: { __typename?: 'ChargebeePlan', period: number, periodUnit: string } } | null> };

export type GqlBaseDispensaryFragmentFragment = { __typename?: 'Dispensaries', id: string, distance?: number | null, name?: string | null, cName?: string | null, timezone?: string | null, phone?: string | null, address?: string | null, description?: string | null, status?: string | null, chain?: string | null, offerAnyPickupService?: boolean | null, offerPickup?: boolean | null, offerCurbsidePickup?: boolean | null, offerDriveThruPickup?: boolean | null, offerDelivery?: boolean | null, listImage?: string | null, bannerImage?: string | null, logoImage?: string | null, embeddedLogoImage?: string | null, embeddedMenuUrl?: string | null, SpecialLogoImage?: string | null, brandedDutchiePayEnabled?: boolean | null, brandedDutchiePayName?: string | null, brandedDutchiePayLogoLight?: string | null, brandedDutchiePayLogoDark?: string | null, embedBackUrl?: string | null, alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, creditCardByPhone?: boolean | null, debitOnly?: boolean | null, cashOnly?: boolean | null, cashless?: boolean | null, createdAtISO?: any | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, recDispensary?: boolean | null, medicalDispensary?: boolean | null, maxDeliveryDistance?: number | null, mixAndMatchPricingWeights?: Array<string | null> | null, acceptsTips?: boolean | null, acceptsDutchiePayTips?: boolean | null, acceptsCreditCardTips?: boolean | null, requiresDriversLicense?: boolean | null, requiresDriversLicenseForPickup?: boolean | null, requirePhotoIdForDelivery?: boolean | null, requirePhotoIdForPickup?: boolean | null, removeMedicalCardFieldsAtCheckout?: boolean | null, menuOrder?: string | null, email?: string | null, emailConfirmation?: boolean | null, stealthMode?: boolean | null, kioskOrderingEnabled?: boolean | null, kioskInstructions?: string | null, categoryLimitsEnabled?: boolean | null, updatedAt?: string | null, updatedAtISO?: any | null, ordersArePaused?: boolean | null, ageVerificationBannerHtml?: string | null, ageVerificationBannerColor?: string | null, menuBannerHtml?: string | null, menuBannerColor?: string | null, menuBannerTextBannerCollapsed?: boolean | null, menuUrl?: string | null, termsAndConditionsUrl?: string | null, customDomainSettings?: { __typename?: 'Dispensaries_profile_customDomain_settings', domain?: string | null } | null, plusSettings?: { __typename?: 'Dispensaries_profile_plus_settings', checkoutUrl?: string | null, defaultReturnUrl?: string | null } | null, location?: { __typename?: 'Dispensaries_profile_location', ln1?: string | null, ln2?: string | null, city?: string | null, state?: string | null, country?: string | null, zipcode?: string | null, geometry?: { __typename?: 'Dispensaries_profile_location_geometry', coordinates?: Array<number | null> | null } | null } | null, temporalLocation?: { __typename?: 'TemporalLocation', lastUpdatedAt?: any | null, coordinates?: any | null, onDuty?: boolean | null, nearbyEnabled?: boolean | null } | null, deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, categoryPhotos?: Array<{ __typename?: 'CategoryPhoto', src?: string | null, category?: string | null } | null> | null, customCategoryPhotos?: Array<{ __typename?: 'CustomCategoryPhoto', url?: string | null, category?: string | null, collectionId?: string | null } | null> | null, effectiveHours?: { __typename?: 'EffectiveHours', deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null } | null, embedSettings?: { __typename?: 'Dispensaries_profile_embed_settings', disclaimerTextHtml?: string | null, disablePageLoadsAtTop?: boolean | null, enableFullScreenEmbeddedCheckout?: boolean | null, autoGTM?: boolean | null, privacyPolicyUrl?: string | null } | null, feeTiers?: Array<{ __typename?: 'Dispensaries_profile_feeTiers', fee?: string | null, feeType?: FeeTypes | null, max?: string | null, min?: string | null, percentFee?: number | null } | null> | null, menuSortSettings?: Array<{ __typename?: 'MenuSortSetting', brands?: Array<string> | null, category: string, menuOrder: string }> | null, actionEstimates?: { __typename?: 'ActionEstimates', pickup?: { __typename?: 'ActionEstimatesValues', readyInMinutes?: number | null, rangeInMinutes?: number | null } | null, delivery?: { __typename?: 'ActionEstimatesValues', readyInMinutes?: number | null, rangeInMinutes?: number | null, deliveryTimeInMinutes?: number | null } | null } | null, durationEstimateOverrides?: { __typename?: 'DurationEstimates', delivery?: { __typename?: 'DurationEstimateRange', enabled?: boolean | null, lowInMinutes?: number | null, highInMinutes?: number | null } | null, pickup?: { __typename?: 'DurationEstimateRange', enabled?: boolean | null, lowInMinutes?: number | null, highInMinutes?: number | null } | null } | null, paymentFees?: Array<{ __typename?: 'Dispensaries_paymentFees', fee?: number | null, feeType?: string | null, paymentType?: string | null } | null> | null, kioskConfig?: { __typename?: 'Dispensaries_kioskConfig', fullNameOnly?: boolean | null, phoneRequired?: boolean | null, notesField?: boolean | null, directedOrders?: boolean | null, hidePhoneField?: boolean | null, hideEmailField?: boolean | null, showBirthdateField?: boolean | null, type?: string | null } | null, categoryLimits?: Array<{ __typename?: 'Dispensaries_categoryLimits', name?: string | null, value?: string | null } | null> | null, specialsSettings?: { __typename?: 'SpecialsSettings', discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, enableIndividualSpecialPrecedence?: boolean | null, enableIndividualDiscountStacking?: boolean | null, stackingBehavior?: string | null, nonStackingBehavior?: string | null } | null, storeSettings: { __typename?: 'Dispensaries_storeSettings', isolatedMenus: boolean, customerMessagingTermsAccepted: boolean, showPOSPackageId: boolean, defaultViewStyle: MenuViewStyles, disablePurchaseLimits: boolean, disableGuestDOB: boolean, displayPhoneConfirmation: boolean, displayKioskAnonymousCheckoutDisclaimer?: boolean | null, enableDutchiePayConsumerSurcharge?: boolean | null, requireEmailAddressForGuestCheckout: boolean, requireMedCardPhotoForPickup?: boolean | null, hideAddressFromDutchieMain: boolean, hideFromMobileApp?: boolean | null, requireMedCardPhotoForDelivery?: boolean | null, enableAfterHoursOrderingForPickup: boolean, enableAfterHoursOrderingForDelivery: boolean, enableLLxSaleDiscountSync?: boolean | null, enableMixAndMatchPricingForPickup: boolean, enableMixAndMatchPricingForDelivery: boolean, enableProductUrgencyMessaging?: boolean | null, enableScheduledOrderingForPickup: boolean, enableScheduledOrderingForDelivery: boolean, enableLimitPerCustomer: boolean, quantityLimit: number, quantityLimitMaxAvailable: boolean, enableOrderStatusEmails: boolean, enableStorefrontAgeGate: boolean, hardAgeGateHideMenuContent: boolean, collapseProductDescription: boolean, hardAgeGateAgeVerification: boolean, disableGuestCheckout: boolean, showMobileAppSmartBanner?: boolean | null, stealthMode: boolean, dontCombineWeightedProducts: boolean, keepUncombinedWeights?: boolean | null, dontMapSubcategoriesByProductName?: boolean | null, prioritizeStaffPicksInSearchResults: boolean, provideBackInstockEmailNotifications: boolean, hideEffects: boolean, hideFilters?: boolean | null, hideOutOfStockProducts: boolean, showLoyaltyRewards?: boolean | null, hideDiscountsFromConsumer?: boolean | null, usePotencyForConcentrateLimits?: boolean | null, useStandardEquivalentForEdiblesLimits?: boolean | null, enableOmniauthLoginCheckout?: boolean | null, enableRoundToNearestDollar?: boolean | null, hideRoundingLineItem?: boolean | null, subscriptions: { __typename?: 'Dispensaries_subscriptions', enabled?: boolean | null }, rewardsIntegrationConfiguration?: { __typename?: 'Rewards_integration_configuration', rewardsProgramDisplayDescription?: string | null, rewardsProgramDisplayEnrollment?: string | null, rewardsProgramDisplayName?: string | null } | null }, featureFlags: { __typename?: 'Dispensaries_featureFlags', enableAfterHoursOrdering?: boolean | null, enableArrivals?: boolean | null, enableMenuImport?: boolean | null, enableMixAndMatch?: boolean | null, enableNonTerminalAutoConfirm?: boolean | null, enablePausedOrders?: boolean | null, enableScheduledOrdering?: boolean | null, hideDeliveryEstimate?: boolean | null, hideMyAccount?: boolean | null, hideStoreHours?: boolean | null }, terminals?: Array<{ __typename?: 'Dispensaries_terminals', _id?: string | null, nickname?: string | null, versionNumber?: string | null, lastSeenAt?: string | null, lastSeenAtISO?: any | null, config?: { __typename?: 'Device_config', orderSource?: string | null } | null } | null> | null, colorSettings?: { __typename?: 'ColorSettings', linkColor?: string | null, navBarColor?: string | null } | null, pickupMinimum?: { __typename?: 'PickupMinimum', enabled?: boolean | null, minimumInCents?: number | null } | null, orderTypesConfig?: { __typename?: 'OrderTypesConfig', offerAnyPickupService?: boolean | null, offerDeliveryService?: boolean | null, pickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null } | null, curbsidePickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null } | null, driveThruPickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null } | null, delivery?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null } | null, kiosk?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null } | null } | null, paymentTypesAccepted?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null };

type GqlBaseOrderingSettingsFragment_CurbsidePickupOrderingSettings_Fragment = { __typename?: 'CurbsidePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

type GqlBaseOrderingSettingsFragment_DeliveryOrderingSettings_Fragment = { __typename?: 'DeliveryOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

type GqlBaseOrderingSettingsFragment_DriveThruPickupOrderingSettings_Fragment = { __typename?: 'DriveThruPickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

type GqlBaseOrderingSettingsFragment_InStorePickupOrderingSettings_Fragment = { __typename?: 'InStorePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

export type GqlBaseOrderingSettingsFragmentFragment = GqlBaseOrderingSettingsFragment_CurbsidePickupOrderingSettings_Fragment | GqlBaseOrderingSettingsFragment_DeliveryOrderingSettings_Fragment | GqlBaseOrderingSettingsFragment_DriveThruPickupOrderingSettings_Fragment | GqlBaseOrderingSettingsFragment_InStorePickupOrderingSettings_Fragment;

export type GqlCurbsidePickupOrderingSettingsFragmentFragment = { __typename?: 'CurbsidePickupOrderingSettings', enableCurbsideArrivals?: boolean | null, arrivalInformationInstructions?: string | null, enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, orderMinimum?: { __typename?: 'OrderMinimum', enabled?: boolean | null, minimumInCents?: number | null } | null, pickupReminders?: { __typename?: 'PickupReminders', enabled?: boolean | null, reminderMinutesAfterReady?: number | null, reminderMessage?: string | null } | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

export type GqlDeliveryOrderingSettingsFragmentFragment = { __typename?: 'DeliveryOrderingSettings', deliveryMode?: DeliveryModes | null, enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, deliveryFeeTiers?: Array<{ __typename?: 'DeliveryFeeTiers', feeInCents?: number | null, maximumInCents?: number | null, minimumInCents?: number | null, feeType?: FeeTypes | null, percentFee?: number | null } | null> | null, deliveryRadius?: { __typename?: 'DeliveryRadius', radiusInMiles?: number | null, orderMinimum?: { __typename?: 'OrderMinimum', enabled?: boolean | null, minimumInCents?: number | null } | null } | null, deliveryZipCodes?: Array<{ __typename?: 'DeliveryZipCodes', zipCode?: string | null, feeInCents?: number | null, minimumInCents?: number | null, feeType?: FeeTypes | null, percentFee?: number | null } | null> | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

export type GqlDeliveryZonesFragmentFragment = { __typename?: 'DeliveryOrderingSettings', deliveryZones?: Array<{ __typename?: 'DeliveryZones', _id?: string | null, name?: string | null, feeInCents?: number | null, minimumInCents?: number | null, feeType?: FeeTypes | null, percentFee?: number | null, area?: { __typename?: 'Polygon', type?: string | null, features?: Array<{ __typename?: 'GeoJson_features', type?: string | null, geometry?: { __typename?: 'GeoJson_geometry', type?: string | null, coordinates?: any | null } | null } | null> | null } | null } | null> | null };

export type GqlDriveThruPickupOrderingSettingsFragmentFragment = { __typename?: 'DriveThruPickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, orderMinimum?: { __typename?: 'OrderMinimum', enabled?: boolean | null, minimumInCents?: number | null } | null, pickupReminders?: { __typename?: 'PickupReminders', enabled?: boolean | null, reminderMinutesAfterReady?: number | null, reminderMessage?: string | null } | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

export type GqlHourSetFragmentFragment = { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null };

export type GqlHoursForDayFragment = { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null };

export type GqlHoursSettingsForOrderTypeFragmentFragment = { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null };

export type GqlInStorePickupOrderingSettingsFragmentFragment = { __typename?: 'InStorePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, orderMinimum?: { __typename?: 'OrderMinimum', enabled?: boolean | null, minimumInCents?: number | null } | null, pickupReminders?: { __typename?: 'PickupReminders', enabled?: boolean | null, reminderMinutesAfterReady?: number | null, reminderMessage?: string | null } | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

export type GqlKioskOrderingSettingsFragmentFragment = { __typename?: 'KioskOrderingSettings', enabled?: boolean | null, fullNameOnly?: boolean | null, phoneRequired?: boolean | null, notesField?: boolean | null, directedOrders?: boolean | null, hideEmailField?: boolean | null, hidePhoneField?: boolean | null, showBirthdateField?: boolean | null, anonymousCheckout?: boolean | null, kioskInstructions?: string | null, type?: KioskTypes | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, timeout?: { __typename?: 'TimeoutConfig', enabled?: boolean | null, duration?: number | null } | null };

export type GqlMaxReservationSlotFragmentFragment = { __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null };

export type GqlMaxReservationSlotsByDayFragmentFragment = { __typename?: 'MaxReservationSlotsByDay', Monday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null } | null> | null, Tuesday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null } | null> | null, Wednesday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null } | null> | null, Thursday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null } | null> | null, Friday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null } | null> | null, Saturday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null } | null> | null, Sunday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null } | null> | null };

export type GqlPaymentTypesFragmentFragment = { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null };

export type GqlScheduledOrderingConfigFragmentFragment = { __typename?: 'ReservationOptionsForOrderType', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null };

export type GqlSpecialHoursDayFragmentFragment = { __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } };

export type GqlSpecialHoursFragmentFragment = { __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null };

export type GqlTaxPropertiesFragment = { __typename?: 'Dispensaries_TaxConfig_Tax', id: string, type: TaxType, name: string, rate: number, potencyRate?: number | null, potency?: PotencyType | null, medical: boolean, recreational: boolean, taxBasis?: string | null, order?: number | null, deliveryPolicy?: DeliveryPolicy | null, includeStateSalesTaxInDestinationRate?: boolean | null, stages: Array<{ __typename?: 'Dispensaries_TaxConfig_Tax_Stage', op: Dispensaries_TaxConfig_Tax_Stage_Ops, type: Dispensaries_TaxConfig_Tax_Stage_Types } | null>, applyTo: { __typename?: 'Dispensaries_TaxConfig_Tax_ApplyTo', types: Array<string | null>, hemp: boolean } };

export type GqlWeeklyHoursFragmentFragment = { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null };

export type GqlDispensaryOnboardingMutationVariables = Exact<{
  input: GqlDispensaryOnboardingInput;
}>;


export type GqlDispensaryOnboardingMutation = { __typename?: 'Mutation', dispensaryOnboarding?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlDispensaryUploadOnboardingAssetMutationVariables = Exact<{
  data: Scalars['String'];
  fileName: Scalars['String'];
}>;


export type GqlDispensaryUploadOnboardingAssetMutation = { __typename?: 'Mutation', dispensaryUploadOnboardingAsset?: { __typename?: 'DispensaryAssetUploadResponse', fileIds?: Array<string | null> | null } | null };

export type GqlGetAddressBasedDispensaryDataQueryVariables = Exact<{
  input?: InputMaybe<GqlGetDeliveryInfoInput>;
}>;


export type GqlGetAddressBasedDispensaryDataQuery = { __typename?: 'Query', getAddressBasedDispensaryData?: { __typename?: 'AddressBasedDispensaryDataResult', deliveryInfo: { __typename?: 'Dispensaries_deliveryInfo', deliveryAreaId?: string | null, withinBounds?: boolean | null, fee?: number | null, minimum?: number | null, feeVaries?: boolean | null, minimumVaries?: boolean | null }, taxes?: Array<{ __typename?: 'Dispensaries_TaxConfig_Tax', destinationRate?: number | null, id: string, type: TaxType, name: string, rate: number, potencyRate?: number | null, potency?: PotencyType | null, medical: boolean, recreational: boolean, taxBasis?: string | null, order?: number | null, deliveryPolicy?: DeliveryPolicy | null, includeStateSalesTaxInDestinationRate?: boolean | null, stages: Array<{ __typename?: 'Dispensaries_TaxConfig_Tax_Stage', op: Dispensaries_TaxConfig_Tax_Stage_Ops, type: Dispensaries_TaxConfig_Tax_Stage_Types } | null>, applyTo: { __typename?: 'Dispensaries_TaxConfig_Tax_ApplyTo', types: Array<string | null>, hemp: boolean } }> | null } | null };

export type GqlDispensarySearchQueryVariables = Exact<{
  dispensaryFilter: GqlDispensariesFilterInput;
}>;


export type GqlDispensarySearchQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', id: string, name?: string | null, cName?: string | null, status?: string | null, recDispensary?: boolean | null, medicalDispensary?: boolean | null, offerPickup?: boolean | null, offerCurbsidePickup?: boolean | null, offerDriveThruPickup?: boolean | null, offerAnyPickupService?: boolean | null, offerDelivery?: boolean | null, listImage?: string | null, distance?: number | null, maxDeliveryDistance?: number | null, timezone?: string | null, location?: { __typename?: 'Dispensaries_profile_location', city?: string | null, county?: string | null, ln1?: string | null, ln2?: string | null, state?: string | null, zipcode?: string | null, country?: string | null, geometry?: { __typename?: 'Dispensaries_profile_location_geometry', coordinates?: Array<number | null> | null, type?: string | null } | null } | null, actionEstimates?: { __typename?: 'ActionEstimates', delivery?: { __typename?: 'ActionEstimatesValues', readyInMinutes?: number | null, rangeInMinutes?: number | null, deliveryTimeInMinutes?: number | null } | null, pickup?: { __typename?: 'ActionEstimatesValues', readyInMinutes?: number | null, rangeInMinutes?: number | null } | null } | null, durationEstimateOverrides?: { __typename?: 'DurationEstimates', pickup?: { __typename?: 'DurationEstimateRange', enabled?: boolean | null, lowInMinutes?: number | null, highInMinutes?: number | null } | null, delivery?: { __typename?: 'DurationEstimateRange', enabled?: boolean | null, lowInMinutes?: number | null, highInMinutes?: number | null } | null } | null, storeSettings: { __typename?: 'Dispensaries_storeSettings', enableAfterHoursOrderingForPickup: boolean, enableAfterHoursOrderingForDelivery: boolean, enableScheduledOrderingForPickup: boolean, enableScheduledOrderingForDelivery: boolean }, featureFlags: { __typename?: 'Dispensaries_featureFlags', hideDeliveryEstimate?: boolean | null }, effectiveHours?: { __typename?: 'EffectiveHours', deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null } | null, deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, deliveryInfo?: { __typename?: 'Dispensaries_deliveryInfo', withinBounds?: boolean | null, fee?: number | null, minimum?: number | null, feeVaries?: boolean | null, minimumVaries?: boolean | null, feeType?: FeeTypes | null, percentFee?: number | null } | null, feeTiers?: Array<{ __typename?: 'Dispensaries_profile_feeTiers', fee?: string | null, feeType?: FeeTypes | null, max?: string | null, min?: string | null, percentFee?: number | null } | null> | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, pickupHours: { __typename?: 'dayBounds', active?: boolean | null, start?: string | null, end?: string | null }, deliveryHours: { __typename?: 'dayBounds', active?: boolean | null, start?: string | null, end?: string | null } } | null> | null } | null> | null, orderTypesConfig?: { __typename?: 'OrderTypesConfig', offerAnyPickupService?: boolean | null, offerDeliveryService?: boolean | null, pickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null, curbsidePickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null, driveThruPickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null, delivery?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null, kiosk?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null } | null, orderTypesConfigV2?: { __typename?: 'OrderTypesConfigV2', offerAnyPickupService?: boolean | null, offerDeliveryService?: boolean | null, inStorePickup?: { __typename?: 'InStorePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null, curbsidePickup?: { __typename?: 'CurbsidePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null, driveThruPickup?: { __typename?: 'DriveThruPickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null, delivery?: { __typename?: 'DeliveryOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null } | null, hoursSettings?: { __typename?: 'DispensaryHoursSettings', inStorePickup?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null, curbsidePickup?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null, driveThruPickup?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null, delivery?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null } | null, enabledOrderTypes?: { __typename?: 'EnabledOrderTypes', pickup?: boolean | null, inStorePickup?: boolean | null, curbsidePickup?: boolean | null, driveThruPickup?: boolean | null, delivery?: boolean | null, kiosk?: boolean | null } | null, paymentTypesAccepted?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null> | null };

export type GqlUpdateEnterpriseMobileAppSettingsMutationVariables = Exact<{
  enterpriseId: Scalars['ID'];
  input?: InputMaybe<GqlEnterpriseMobileAppSettingsInput>;
}>;


export type GqlUpdateEnterpriseMobileAppSettingsMutation = { __typename?: 'Mutation', updateEnterpriseMobileAppSettings?: { __typename?: 'EnterpriseMobileAppSettings', androidAppIcon?: string | null, androidExistingVersion?: string | null, androidExistingVersionCode?: number | null, androidPackageName?: string | null, androidSplashBackgroundColor?: string | null, buildForIpad?: boolean | null, firebaseProjectId?: string | null, headerImage?: string | null, iosAppIcon?: string | null, iosAppStoreId?: string | null, iosBundleIdentifier?: string | null, iosExistingVersion?: string | null, iosSplashBackgroundColor?: string | null, iosTeamId?: string | null, iosTeamName?: string | null, name?: string | null, shortName?: string | null } | null };

export type GqlEnterpriseMobileAppSettingsQueryVariables = Exact<{
  enterpriseId: Scalars['ID'];
}>;


export type GqlEnterpriseMobileAppSettingsQuery = { __typename?: 'Query', enterpriseMobileAppSettings?: { __typename?: 'EnterpriseMobileAppSettings', androidAppIcon?: string | null, androidPackageName?: string | null, androidSplashBackgroundColor?: string | null, iosAppIcon?: string | null, iosAppStoreId?: string | null, iosBundleIdentifier?: string | null, iosSplashBackgroundColor?: string | null } | null };

export type GqlAdminEnterpriseMobileAppSettingsQueryVariables = Exact<{
  enterpriseId: Scalars['ID'];
}>;


export type GqlAdminEnterpriseMobileAppSettingsQuery = { __typename?: 'Query', enterpriseMobileAppSettings?: { __typename?: 'EnterpriseMobileAppSettings', androidAppIcon?: string | null, androidExistingVersion?: string | null, androidExistingVersionCode?: number | null, androidPackageName?: string | null, androidSplashBackgroundColor?: string | null, buildForIpad?: boolean | null, firebaseProjectId?: string | null, headerImage?: string | null, iosAppIcon?: string | null, iosAppStoreId?: string | null, iosBundleIdentifier?: string | null, iosExistingVersion?: string | null, iosSplashBackgroundColor?: string | null, iosTeamId?: string | null, iosTeamName?: string | null, name?: string | null, shortName?: string | null } | null };

export type GqlGeolocateConsumerQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGeolocateConsumerQuery = { __typename?: 'Query', geolocate?: { __typename?: 'IPInfo', ip?: string | null, hostname?: string | null, city?: string | null, region?: string | null, country?: string | null, loc?: string | null, org?: string | null, postal?: string | null, timezone?: string | null } | null };

export type GqlGenerateHypurTokenV2MutationVariables = Exact<{
  code: Scalars['String'];
  hostname?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
}>;


export type GqlGenerateHypurTokenV2Mutation = { __typename?: 'Mutation', generateHypurTokenV2?: { __typename?: 'HypurToken', accessToken: string, embedded: boolean } | null };

export type GqlCreateLibraryProductV2MutationVariables = Exact<{
  libraryProduct: GqlNewLibraryProduct;
  state: Scalars['String'];
}>;


export type GqlCreateLibraryProductV2Mutation = { __typename?: 'Mutation', createLibraryProductV2?: { __typename?: 'LibraryProduct', id: string } | null };

export type GqlCreateLibraryProductV3MutationVariables = Exact<{
  libraryProduct: GqlNewLibraryProductV2;
  state: Scalars['String'];
}>;


export type GqlCreateLibraryProductV3Mutation = { __typename?: 'Mutation', createLibraryProductV3?: { __typename?: 'LibraryProduct', id: string } | null };

export type GqlMatchLibraryProductsV2QueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  state: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  brand?: InputMaybe<Scalars['String']>;
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GqlMatchLibraryProductsV2Query = { __typename?: 'Query', matchLibraryProductsV2?: Array<{ __typename?: 'LibraryProduct', id: string, category?: string | null, image?: string | null, name: string, price: number, productTemplate?: boolean | null, stockImage?: string | null, strainType?: string | null, subcategory?: string | null, brand?: { __typename?: 'Brand', id: string, name: string, imageUrl?: string | null } | null, cbdContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, images?: Array<{ __typename?: 'Products_Images', _id?: string | null, url: string, active: boolean, origin: ImageOrigin } | null> | null, thcContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null } | null> | null };

export type GqlMatchLibraryProductsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  state: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  brand?: InputMaybe<Scalars['String']>;
  productTemplate?: InputMaybe<Scalars['Boolean']>;
}>;


export type GqlMatchLibraryProductsQuery = { __typename?: 'Query', matchLibraryProducts?: Array<{ __typename?: 'LibraryProduct', id: string, category?: string | null, image?: string | null, name: string, price: number, strainType?: string | null, subcategory?: string | null, brand?: { __typename?: 'Brand', id: string, name: string } | null, cbdContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, thcContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null } | null> | null };

export type GqlAddressResidentialCheckQueryVariables = Exact<{
  input: GqlAddressResidentialCheckInput;
}>;


export type GqlAddressResidentialCheckQuery = { __typename?: 'Query', addressResidentialCheck?: { __typename?: 'ValidationResponse', isValid?: boolean | null } | null };

export type GqlHealthCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlHealthCheckQuery = { __typename?: 'Query', healthCheck?: { __typename?: 'HealthCheck', status?: string | null } | null };

export type GqlResetPasswordV2MutationVariables = Exact<{
  input: GqlResetPasswordInput;
}>;


export type GqlResetPasswordV2Mutation = { __typename?: 'Mutation', resetPasswordV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlSendBrandUserPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type GqlSendBrandUserPasswordResetEmailMutation = { __typename?: 'Mutation', sendBrandUserPasswordResetEmail?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlSendPasswordResetEmailV2MutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type GqlSendPasswordResetEmailV2Mutation = { __typename?: 'Mutation', sendPasswordResetEmailV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlSetPasswordV2MutationVariables = Exact<{
  input: GqlSetPasswordInput;
}>;


export type GqlSetPasswordV2Mutation = { __typename?: 'Mutation', setPasswordV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlUpdatePasswordV2MutationVariables = Exact<{
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type GqlUpdatePasswordV2Mutation = { __typename?: 'Mutation', updatePasswordV2?: { __typename?: 'PasswordUpdate', accessToken: string } | null };

export type GqlGetPaymentsCheckoutCredentialsQueryVariables = Exact<{
  adapter: Scalars['String'];
  dispensaryId: Scalars['String'];
}>;


export type GqlGetPaymentsCheckoutCredentialsQuery = { __typename?: 'Query', getPaymentsCheckoutCredentials?: { __typename?: 'ChaseHostedProfileCredentials', uID: string } | { __typename?: 'MonerisHTProfileCredentials', profileId: string } | null };

export type GqlGetMonerisTokenizationProfileQueryVariables = Exact<{
  dispensaryId: Scalars['String'];
}>;


export type GqlGetMonerisTokenizationProfileQuery = { __typename?: 'Query', getMonerisTokenizationProfile?: { __typename?: 'MonerisTokenizationProfile', profileId: string } | null };

export type GqlArchivedProductLookupQueryVariables = Exact<{
  cname: Scalars['String'];
  dispensaryId: Scalars['String'];
}>;


export type GqlArchivedProductLookupQuery = { __typename?: 'Query', archivedProductLookup?: Array<{ __typename?: 'Products', effects?: any | null, description?: string | null, descriptionHtml?: string | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, _id: string, description?: string | null, imageUrl?: string | null, name: string, parentBrandId?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null } | null> | null };

export type GqlConsumerBaseProductFragmentFragment = { __typename?: 'Products', _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null };

export type GqlConsumerSponsoredProductFragmentFragment = { __typename?: 'Products', provider?: ProductsProvider | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, adTrackers?: { __typename?: 'AdTrackers', clickUrl: string, impressionUrl: string } | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null };

export type GqlFilteredProductsQueryVariables = Exact<{
  productsFilter: GqlProductsFilterInput;
  useCache?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']>;
}>;


export type GqlFilteredProductsQuery = { __typename?: 'Query', filteredProducts?: { __typename?: 'ProductsList', products: Array<{ __typename?: 'Products', effects?: any | null, provider?: ProductsProvider | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, _id: string, description?: string | null, imageUrl?: string | null, name: string, parentBrandId?: string | null } | null, cannabinoidsV2?: Array<{ __typename?: 'Products_CannabinoidV2', value?: number | null, unit?: PotencyUnit | null, cannabinoid?: { __typename?: 'Cannabinoid', name: string } | null } | null> | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null } | null>, queryInfo: { __typename?: 'queryInfoType', totalCount?: number | null, totalPages?: number | null } } | null };

export type GqlIndividualFilteredProductQueryVariables = Exact<{
  productsFilter: GqlProductsFilterInput;
  useCache?: InputMaybe<Scalars['Boolean']>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']>;
}>;


export type GqlIndividualFilteredProductQuery = { __typename?: 'Query', filteredProducts?: { __typename?: 'ProductsList', products: Array<{ __typename?: 'Products', effects?: any | null, description?: string | null, descriptionHtml?: string | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, _id: string, description?: string | null, imageUrl?: string | null, name: string, parentBrandId?: string | null } | null, terpenes?: Array<{ __typename?: 'Products_Terpene', id?: string | null, terpeneId?: string | null, unit?: PotencyUnit | null, unitSymbol?: string | null, value?: number | null, libraryTerpene?: { __typename?: 'Terpene', aromas?: Array<string | null> | null, description?: string | null, effects?: Array<string | null> | null, name?: string | null } | null } | null> | null, cannabinoidsV2?: Array<{ __typename?: 'Products_CannabinoidV2', value?: number | null, unit?: PotencyUnit | null, cannabinoid?: { __typename?: 'Cannabinoid', name: string, description?: string | null } | null } | null> | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null } | null> } | null };

export type GqlPosMetaDataFragmentFragment = { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null };

export type GqlCreateAlpineUserV2MutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  program: Scalars['String'];
  dispensaryId: Scalars['String'];
  favoriteStore: Scalars['String'];
  phoneNumber: Scalars['String'];
  acceptedTerms: Scalars['Boolean'];
}>;


export type GqlCreateAlpineUserV2Mutation = { __typename?: 'Mutation', createAlpineUserV2?: { __typename?: 'RewardUserResponse', success?: boolean | null, wallet?: { __typename?: 'RewardsListV2', balance: string, rewardBrand: string, userHasWallet: boolean, rewards: Array<{ __typename?: 'RewardV2', id: string, copy?: string | null, available: boolean, operator: string, cost: number, value: string, rewardType: string } | null>, auth?: { __typename?: 'UserAuthInfo', pinConfirmed?: boolean | null, incorrectPinProvided?: boolean | null, authTextMessageSent?: boolean | null } | null } | null } | null };

export type GqlCreateAlpineUserMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  program: Scalars['String'];
  dispensaryId: Scalars['String'];
  favoriteStore: Scalars['String'];
  phoneNumber: Scalars['String'];
  acceptedTerms: Scalars['Boolean'];
}>;


export type GqlCreateAlpineUserMutation = { __typename?: 'Mutation', createAlpineUser?: { __typename?: 'RewardUserResponse', success?: boolean | null, wallet?: { __typename?: 'RewardsListV2', balance: string, rewardBrand: string, userHasWallet: boolean, rewards: Array<{ __typename?: 'RewardV2', id: string, copy?: string | null, available: boolean, operator: string, cost: number, value: string, rewardType: string } | null>, auth?: { __typename?: 'UserAuthInfo', pinConfirmed?: boolean | null, incorrectPinProvided?: boolean | null, authTextMessageSent?: boolean | null } | null } | null } | null };

export type GqlCreateDutchiePosLoyaltyMemberMutationVariables = Exact<{
  dispensaryId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type GqlCreateDutchiePosLoyaltyMemberMutation = { __typename?: 'Mutation', createDutchiePosLoyaltyMember?: { __typename?: 'RewardUserResponse', success?: boolean | null } | null };

export type GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationVariables = Exact<{
  enterpriseId: Scalars['String'];
  userId: Scalars['String'];
  isoRegionCode: Scalars['String'];
}>;


export type GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation = { __typename?: 'Mutation', createEnterpriseDutchiePosLoyaltyMember?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlCreateSpringbigUserMutationVariables = Exact<{
  dispensaryId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type GqlCreateSpringbigUserMutation = { __typename?: 'Mutation', createSpringbigUser?: { __typename?: 'RewardUserResponse', success?: boolean | null } | null };

export type GqlUpdateDutchiePosLoyaltyMemberMutationVariables = Exact<{
  dispensaryId: Scalars['String'];
  userId: Scalars['String'];
  phone: Scalars['String'];
  lastAndroidLoginUtc?: InputMaybe<Scalars['String']>;
  lastIosLoginUtc?: InputMaybe<Scalars['String']>;
}>;


export type GqlUpdateDutchiePosLoyaltyMemberMutation = { __typename?: 'Mutation', updateDutchiePosLoyaltyMember?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlGetDutchiePosLoyaltyConfigQueryVariables = Exact<{
  dispensaryId?: InputMaybe<Scalars['String']>;
  enterpriseId?: InputMaybe<Scalars['String']>;
  isoRegionCode?: InputMaybe<Scalars['String']>;
}>;


export type GqlGetDutchiePosLoyaltyConfigQuery = { __typename?: 'Query', getDutchiePosLoyaltyConfig?: { __typename?: 'DutchiePosLoyaltyConfig', loyaltyRequireOptIn: boolean, isEnabled: boolean, loyaltyDaysToExpiration?: number | null, onlineName?: string | null, onlineDescription?: string | null, tierEarningBasis?: string | null, redemptionType?: string | null, mode?: string | null, tiers?: Array<{ __typename?: 'DutchiePosLoyaltyTier', id: number, name: string, threshold: number, badgeColor: string } | null> | null } | null };

export type GqlGetRewardsV2QueryVariables = Exact<{
  phoneNumber: Scalars['String'];
  dispensaryId?: InputMaybe<Scalars['String']>;
  enterpriseId?: InputMaybe<Scalars['String']>;
  isoRegionCode?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
}>;


export type GqlGetRewardsV2Query = { __typename?: 'Query', getRewardsV2?: { __typename?: 'RewardsListV2', balance: string, rewardBrand: string, userHasWallet: boolean, isLoyaltyMember?: boolean | null, currentYearTierBalance?: string | null, expirationDate?: string | null, tierName?: string | null, tierId?: number | null, posCustomerId?: string | null, rewards: Array<{ __typename?: 'RewardV2', id: string, copy?: string | null, available: boolean, operator: string, cost: number, value: string, rewardType: string, discountId?: number | null, brand?: string | null, isRedeemableOnline?: boolean | null } | null>, auth?: { __typename?: 'UserAuthInfo', pinConfirmed?: boolean | null, incorrectPinProvided?: boolean | null, authTextMessageSent?: boolean | null } | null, rewardsActivity?: Array<{ __typename?: 'RewardsActivity', lspName?: string | null, location?: string | null, customerId?: string | null, transactionType?: string | null, transactionDateUtc?: string | null, points?: number | null, comment?: string | null, orderType?: string | null, isAdjustment?: boolean | null, totalPaid?: number | null } | null> | null } | null };

export type GqlScheduleFieldsFragment = { __typename?: 'Schedule', endDate?: any | null, id: string, startDate: any, timeRanges?: Array<{ __typename?: 'TimeRange', dayOfWeek: number, endTime: string, id: string, startTime: string }> | null };

export type GqlBulkEndSpecialsV2MutationVariables = Exact<{
  input: GqlEndSpecialsInput;
}>;


export type GqlBulkEndSpecialsV2Mutation = { __typename?: 'Mutation', bulkEndSpecialsV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlCreateEnterpriseSpecialV2MutationVariables = Exact<{
  input: GqlEnterpriseSpecialInputV2;
}>;


export type GqlCreateEnterpriseSpecialV2Mutation = { __typename?: 'Mutation', createEnterpriseSpecialV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlCreateEnterpriseSpecialsSettingsMutationVariables = Exact<{
  enterpriseId: Scalars['ID'];
  input: GqlEnterpriseSpecialsSettingsInput;
}>;


export type GqlCreateEnterpriseSpecialsSettingsMutation = { __typename?: 'Mutation', createEnterpriseSpecialsSettings?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlCreateSpecialV3MutationVariables = Exact<{
  input: GqlSpecialsInputV3;
}>;


export type GqlCreateSpecialV3Mutation = { __typename?: 'Mutation', createSpecialV3?: { __typename?: 'Specials', _id?: string | null } | null };

export type GqlDeleteEnterpriseSpecialMutationVariables = Exact<{
  enterpriseId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GqlDeleteEnterpriseSpecialMutation = { __typename?: 'Mutation', deleteEnterpriseSpecial?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlDeleteSpecialV2MutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type GqlDeleteSpecialV2Mutation = { __typename?: 'Mutation', deleteSpecialV2?: { __typename?: 'Specials', _id?: string | null } | null };

export type GqlEndEnterpriseSpecialMutationVariables = Exact<{
  enterpriseId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GqlEndEnterpriseSpecialMutation = { __typename?: 'Mutation', endEnterpriseSpecial?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlEndSpecialV2MutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type GqlEndSpecialV2Mutation = { __typename?: 'Mutation', endSpecialV2: { __typename?: 'Specials', _id?: string | null } };

export type GqlIncrementSpecialClicksMutationVariables = Exact<{
  input: GqlIncrementClicksInput;
}>;


export type GqlIncrementSpecialClicksMutation = { __typename?: 'Mutation', incrementClicks?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlUpdateEnterpriseSpecialV2MutationVariables = Exact<{
  id: Scalars['String'];
  input: GqlEnterpriseSpecialInputV2;
}>;


export type GqlUpdateEnterpriseSpecialV2Mutation = { __typename?: 'Mutation', updateEnterpriseSpecialV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlUpdateEnterpriseSpecialsSettingsMutationVariables = Exact<{
  enterpriseId: Scalars['ID'];
  input: GqlEnterpriseSpecialsSettingsInput;
}>;


export type GqlUpdateEnterpriseSpecialsSettingsMutation = { __typename?: 'Mutation', updateEnterpriseSpecialsSettings?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlUpdateSpecialV3MutationVariables = Exact<{
  id: Scalars['String'];
  input: GqlSpecialsInputV3;
}>;


export type GqlUpdateSpecialV3Mutation = { __typename?: 'Mutation', updateSpecialV3?: { __typename?: 'Specials', _id?: string | null } | null };

export type GqlUpdateSpecialsSortOrderMutationVariables = Exact<{
  input: GqlSortOrderInput;
}>;


export type GqlUpdateSpecialsSortOrderMutation = { __typename?: 'Mutation', updateSpecialsSortOrder?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlEnterpriseSpecialsV3QueryVariables = Exact<{
  enterpriseId: Scalars['ID'];
  filter?: InputMaybe<GqlFilteredSpecialsInputV2>;
}>;


export type GqlEnterpriseSpecialsV3Query = { __typename?: 'Query', enterpriseSpecialsV3?: { __typename?: 'FilteredEnterpriseSpecials', queryInfo?: { __typename?: 'FilteredSpecialsInfo', totalCount?: number | null } | null, specials?: Array<{ __typename?: 'EnterpriseSpecial', _id?: string | null, active?: boolean | null, applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, cipher?: any | null, clicks?: number | null, complete?: boolean | null, createdAt?: any | null, createdBy?: string | null, description?: string | null, descriptionHtml?: string | null, discount?: string | null, discountedPrices?: any | null, displayRank?: number | null, earliestStartStamp?: any | null, emailSpecial?: boolean | null, endDay?: any | null, endStamp?: any | null, endTime?: string | null, enterpriseId?: string | null, enterpriseSpecialId?: string | null, heading?: string | null, isRecurring?: boolean | null, latestEndStamp?: any | null, localTime?: boolean | null, menuDisplayDescription?: string | null, menuDisplayName?: string | null, menuDisplayImage?: string | null, menuType?: string | null, name?: string | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, retailers?: Array<string | null> | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialRestrictions?: any | null, specialType?: SpecialTypes | null, startDay?: any | null, startStamp?: any | null, startTime?: string | null, subject?: string | null, targetPrice?: boolean | null, timezone?: string | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, quantity?: number | null, requiresSingleSku?: boolean | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, discountAmount?: number | null, discountType?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null } | null };

export type GqlEnterpriseSpecialsQueryVariables = Exact<{
  enterpriseId: Scalars['ID'];
}>;


export type GqlEnterpriseSpecialsQuery = { __typename?: 'Query', enterpriseSpecials?: Array<{ __typename?: 'EnterpriseSpecial', _id?: string | null, active?: boolean | null, applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, cipher?: any | null, clicks?: number | null, createdAt?: any | null, createdBy?: string | null, description?: string | null, descriptionHtml?: string | null, discount?: string | null, discountedPrices?: any | null, displayRank?: number | null, emailSpecial?: boolean | null, endDay?: any | null, endStamp?: any | null, endTime?: string | null, enterpriseId?: string | null, enterpriseSpecialId?: string | null, heading?: string | null, isRecurring?: boolean | null, localTime?: boolean | null, menuDisplayDescription?: string | null, menuDisplayName?: string | null, menuDisplayImage?: string | null, menuType?: string | null, name?: string | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, retailers?: Array<string | null> | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialRestrictions?: any | null, specialType?: SpecialTypes | null, startDay?: any | null, startStamp?: any | null, startTime?: string | null, subject?: string | null, targetPrice?: boolean | null, timezone?: string | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, discountAmount?: number | null, discountType?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, percentDiscount?: string | null, quantity?: number | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, requiresSingleSku?: boolean | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null };

export type GqlFilteredSpecialsV2QueryVariables = Exact<{
  specialsFilter: GqlFilteredSpecialsInput;
  translateSpecialsToV3?: InputMaybe<Scalars['Boolean']>;
}>;


export type GqlFilteredSpecialsV2Query = { __typename?: 'Query', filteredSpecialsV2?: { __typename?: 'FilteredSpecials', queryInfo?: { __typename?: 'FilteredSpecialsInfo', totalCount?: number | null } | null, specials?: Array<{ __typename?: 'Specials', _id?: string | null, active?: boolean | null, applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, menuDisplayName?: string | null, menuDisplayDescription?: string | null, bogoConditionLogicOperator?: string | null, menuDisplayImage?: string | null, bogoRewardLogicOperator?: string | null, clicks?: number | null, createdAt?: any | null, createdBy?: string | null, description?: string | null, descriptionHtml?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, discount?: string | null, discountedPrices?: any | null, discountPrecedence?: string | null, discountStacking?: boolean | null, dispensaryId?: string | null, displayRank?: number | null, emailSpecial?: boolean | null, endDay?: string | null, endStamp?: string | null, endTime?: string | null, heading?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, name?: string | null, nonStackingBehavior?: string | null, platformType?: Array<PlatformType | null> | null, preOrderType?: Array<PreOrderType | null> | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: SpecialTypes | null, stackingBehavior?: string | null, stackingMode?: string | null, startDate?: string | null, startDay?: string | null, startStamp?: string | null, startTime?: string | null, subject?: string | null, targetPrice?: boolean | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, discountAmount?: number | null, discountType?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, discountBundle?: { __typename?: 'DiscountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null } | null };

export type GqlFilteredSpecialsQueryVariables = Exact<{
  specialsFilter: GqlFilteredSpecialsInput;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']>;
}>;


export type GqlFilteredSpecialsQuery = { __typename?: 'Query', filteredSpecials?: { __typename?: 'FilteredSpecials', queryInfo?: { __typename?: 'FilteredSpecialsInfo', totalCount?: number | null } | null, specials?: Array<{ __typename?: 'Specials', _id?: string | null, active?: boolean | null, applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, menuDisplayName?: string | null, menuDisplayDescription?: string | null, bogoConditionLogicOperator?: string | null, menuDisplayImage?: string | null, bogoRewardLogicOperator?: string | null, clicks?: number | null, createdAt?: any | null, createdBy?: string | null, description?: string | null, descriptionHtml?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, discount?: string | null, discountedPrices?: any | null, discountPrecedence?: string | null, discountStacking?: boolean | null, dispensaryId?: string | null, displayRank?: number | null, emailSpecial?: boolean | null, endDay?: string | null, endStamp?: string | null, endTime?: string | null, heading?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, name?: string | null, nonStackingBehavior?: string | null, platformType?: Array<PlatformType | null> | null, preOrderType?: Array<PreOrderType | null> | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: SpecialTypes | null, stackingBehavior?: string | null, stackingMode?: string | null, startDate?: string | null, startDay?: string | null, startStamp?: string | null, startTime?: string | null, subject?: string | null, targetPrice?: boolean | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, discountAmount?: number | null, discountType?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, percentDiscount?: string | null, quantity?: number | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, requiresSingleSku?: boolean | null, targetPrice?: string | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, discountBundle?: { __typename?: 'DiscountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null } | null };

export type GqlGetSpecialGamificationQueryVariables = Exact<{
  dispensaryId?: InputMaybe<Scalars['String']>;
  menuType?: InputMaybe<Scalars['String']>;
  specialIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GqlGetSpecialGamificationQuery = { __typename?: 'Query', getSpecialGamification?: { __typename?: 'SpecialGamificationList', gamificationThresholds?: Array<{ __typename?: 'GamificationDetailItem', discountId?: number | null, satisfiers?: Array<{ __typename?: 'GamificationDetailItem_Satisfier', thresholdType?: string | null, minimumThreshold?: number | null } | null> | null } | null> | null } | null };

export type GqlGetSpecialMenuCardsQueryVariables = Exact<{
  dispensaryId: Scalars['ID'];
  menuType: Scalars['String'];
  specialId?: InputMaybe<Scalars['String']>;
}>;


export type GqlGetSpecialMenuCardsQuery = { __typename?: 'Query', getSpecialMenuCards?: { __typename?: 'SpecialMenuCardResponse', menuCards?: Array<{ __typename?: 'SpecialMenuCard', _id?: string | null, displayRank?: number | null, menuDisplayName?: string | null, menuDisplayDescription?: string | null, menuDisplayImage?: string | null, posDiscountId?: string | null, specialType?: string | null } | null> | null } | null };

export type GqlGetStockImageQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']>;
  productName?: InputMaybe<Scalars['String']>;
}>;


export type GqlGetStockImageQuery = { __typename?: 'Query', getStockImage?: { __typename?: 'StockImage', url: string } | null };

export type GqlCreateStrainV2MutationVariables = Exact<{
  input: GqlStrainInput;
}>;


export type GqlCreateStrainV2Mutation = { __typename?: 'Mutation', createStrainV2?: { __typename?: 'Strain', id: string } | null };

export type GqlDeleteStrainMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type GqlDeleteStrainMutation = { __typename?: 'Mutation', deleteStrain?: { __typename?: 'Strain', id: string } | null };

export type GqlUpdateStrainV2MutationVariables = Exact<{
  id: Scalars['String'];
  input: GqlStrainInput;
}>;


export type GqlUpdateStrainV2Mutation = { __typename?: 'Mutation', updateStrainV2?: { __typename?: 'Strain', id: string } | null };

export type GqlFilteredStrainsQueryVariables = Exact<{
  filter?: InputMaybe<GqlStrainsFilterInput>;
  sort?: InputMaybe<GqlStrainsSortInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
}>;


export type GqlFilteredStrainsQuery = { __typename?: 'Query', filteredStrains?: { __typename?: 'StrainList', queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null, strains?: Array<{ __typename?: 'Strain', description?: string | null, effects?: Array<string | null> | null, id: string, imageUrl?: string | null, name?: string | null, potentialHealthBenefits?: Array<string | null> | null } | null> | null } | null };

export type GqlGetStrainQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GqlGetStrainQuery = { __typename?: 'Query', getStrain?: { __typename?: 'Strain', aromas?: Array<string | null> | null, description?: string | null, effects?: Array<string | null> | null, id: string, imageUrl?: string | null, labels?: Array<string | null> | null, name?: string | null, potentialHealthBenefits?: Array<string | null> | null, ratio?: string | null, terpenes?: Array<{ __typename?: 'Terpene', id: string, name?: string | null } | null> | null } | null };

export type GqlGetCustomerSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetCustomerSubscriptionsQuery = { __typename?: 'Query', getCustomerSubscriptions: Array<{ __typename?: 'CustomerSubscription', dispensaryId?: string | null, dispensaryName?: string | null, emailOptIn?: boolean | null, emailSubscription?: boolean | null, id: string }> };

export type GqlGetUnsubscribeDispensaryQueryVariables = Exact<{
  customerId: Scalars['String'];
}>;


export type GqlGetUnsubscribeDispensaryQuery = { __typename?: 'Query', unsubscribeCustomerQuery?: { __typename?: 'CustomerUnsubscribe', subscribed?: boolean | null, dispensary?: { __typename?: 'Dispensaries', name?: string | null, logoImage?: string | null } | null } | null };

export type GqlTerpeneFragmentFragment = { __typename?: 'Terpene', aliasList?: Array<string | null> | null, aromas?: Array<string | null> | null, description?: string | null, effects?: Array<string | null> | null, id: string, name?: string | null, unitSymbol?: string | null, potentialHealthBenefits?: Array<string | null> | null };

export type GqlCreateTerpeneMutationVariables = Exact<{
  terpene: GqlTerpeneInput;
}>;


export type GqlCreateTerpeneMutation = { __typename?: 'Mutation', createTerpeneV2?: { __typename?: 'Terpene', id: string } | null };

export type GqlDeleteTerpeneMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type GqlDeleteTerpeneMutation = { __typename?: 'Mutation', deleteTerpene?: { __typename?: 'Terpene', id: string } | null };

export type GqlUpdateTerpeneMutationVariables = Exact<{
  id: Scalars['String'];
  terpene: GqlTerpeneInput;
}>;


export type GqlUpdateTerpeneMutation = { __typename?: 'Mutation', updateTerpeneV2?: { __typename?: 'Terpene', id: string } | null };

export type GqlFilteredTerpenesQueryVariables = Exact<{
  filter?: InputMaybe<GqlTerpenesFilter>;
  sort?: InputMaybe<GqlTerpenesSort>;
}>;


export type GqlFilteredTerpenesQuery = { __typename?: 'Query', filteredTerpenes?: Array<{ __typename?: 'Terpene', aliasList?: Array<string | null> | null, aromas?: Array<string | null> | null, description?: string | null, effects?: Array<string | null> | null, id: string, name?: string | null, unitSymbol?: string | null, potentialHealthBenefits?: Array<string | null> | null, strains: Array<{ __typename?: 'Strain', _id?: string | null } | null> } | null> | null };

export type GqlGetTerpeneQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GqlGetTerpeneQuery = { __typename?: 'Query', getTerpene?: { __typename?: 'Terpene', aliasList?: Array<string | null> | null, aromas?: Array<string | null> | null, description?: string | null, effects?: Array<string | null> | null, id: string, name?: string | null, unitSymbol?: string | null, potentialHealthBenefits?: Array<string | null> | null } | null };

export type GqlAdminIdentityFragmentFragment = { __typename?: 'LoginAdmin', accessToken?: string | null, user?: { __typename?: 'IdentityAdmin', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string } | null>, profile: { __typename?: 'IdentityAdminProfile', browserNotification?: boolean | null, chainID?: string | null, desktopNotification?: boolean | null, dispensaryId?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, phone?: string | null, type?: string | null, permissions?: { __typename?: 'IdentityAdminProfilePermissions', allLocations: boolean, billing: boolean, analytics: boolean, customers: boolean, driver: boolean, enterpriseAdmin?: boolean | null, enterpriseSpecials?: boolean | null, menu: boolean, menuReview?: boolean | null, superMenuReview?: boolean | null, orders: boolean, promote: boolean, settings: boolean, users: boolean, tasks?: boolean | null } | null } } | null };

export type GqlConsumerSignupMutationVariables = Exact<{
  input: GqlConsumerSignupInput;
  turnstileToken?: InputMaybe<Scalars['String']>;
  publicContextSessionId?: InputMaybe<Scalars['String']>;
}>;


export type GqlConsumerSignupMutation = { __typename?: 'Mutation', consumerSignup?: { __typename?: 'LoginConsumer', accessToken?: string | null, user?: { __typename?: 'IdentityConsumer', _id: string, emails: Array<{ __typename?: 'UserEmails', address: string } | null>, profile: { __typename?: 'IdentityConsumerProfile', birthday?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, lastName?: string | null, phone?: string | null, photoId?: string | null, textNotifications?: boolean | null, medicalCard?: { __typename?: 'consumerUserMedicalCard', expirationDate?: string | null, number?: string | null, state?: string | null } | null } } | null } | null };

export type GqlCreateUserMutationVariables = Exact<{
  input: GqlUsersCreateInput;
}>;


export type GqlCreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'Users', audioNotificationsOnNewArrivalsDisabled?: boolean | null, audioNotificationsOnNewOrdersDisabled?: boolean | null, chainID?: string | null, createdAt?: string | null, createdBy?: string | null, dispensaryId?: string | null, email?: string | null, fullName?: string | null, phone?: string | null, roleAtDispensary?: DispensaryRoles | null, type?: string | null, permissions?: { __typename?: 'Users_permissions', allLocations?: boolean | null, analytics?: boolean | null, billing?: boolean | null, customers?: boolean | null, dispensaryIds?: Array<string> | null, driver?: boolean | null, menu?: boolean | null, menuReview?: boolean | null, orders?: boolean | null, promote?: boolean | null, settings?: boolean | null, superMenuReview?: boolean | null, users?: boolean | null } | null } | null };

export type GqlDeleteUserMutationVariables = Exact<{
  input: GqlUsersDeleteInput;
}>;


export type GqlDeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename?: 'Users', fullName?: string | null } | null };

export type GqlLoginAdminViaTokenMutationVariables = Exact<{
  transferToken: Scalars['String'];
}>;


export type GqlLoginAdminViaTokenMutation = { __typename?: 'Mutation', loginAdminViaToken?: { __typename?: 'LoginAdmin', accessToken?: string | null, user?: { __typename?: 'IdentityAdmin', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string } | null>, profile: { __typename?: 'IdentityAdminProfile', browserNotification?: boolean | null, chainID?: string | null, desktopNotification?: boolean | null, dispensaryId?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, phone?: string | null, type?: string | null, permissions?: { __typename?: 'IdentityAdminProfilePermissions', allLocations: boolean, billing: boolean, analytics: boolean, customers: boolean, driver: boolean, enterpriseAdmin?: boolean | null, enterpriseSpecials?: boolean | null, menu: boolean, menuReview?: boolean | null, superMenuReview?: boolean | null, orders: boolean, promote: boolean, settings: boolean, users: boolean, tasks?: boolean | null } | null } } | null } | null };

export type GqlLoginAdminMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type GqlLoginAdminMutation = { __typename?: 'Mutation', loginAdmin?: { __typename?: 'LoginAdmin', accessToken?: string | null, user?: { __typename?: 'IdentityAdmin', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string } | null>, profile: { __typename?: 'IdentityAdminProfile', browserNotification?: boolean | null, chainID?: string | null, desktopNotification?: boolean | null, dispensaryId?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, phone?: string | null, type?: string | null, permissions?: { __typename?: 'IdentityAdminProfilePermissions', allLocations: boolean, billing: boolean, analytics: boolean, customers: boolean, driver: boolean, enterpriseAdmin?: boolean | null, enterpriseSpecials?: boolean | null, menu: boolean, menuReview?: boolean | null, superMenuReview?: boolean | null, orders: boolean, promote: boolean, settings: boolean, users: boolean, tasks?: boolean | null } | null } } | null } | null };

export type GqlLoginConsumerMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  turnstileToken?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
  publicContextSessionId?: InputMaybe<Scalars['String']>;
}>;


export type GqlLoginConsumerMutation = { __typename?: 'Mutation', loginConsumer?: { __typename?: 'LoginConsumer', accessToken?: string | null, transferToken?: string | null, user?: { __typename?: 'IdentityConsumer', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string } | null>, profile: { __typename?: 'IdentityConsumerProfile', birthday?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, lastName?: string | null, phone?: string | null, photoId?: string | null, textNotifications?: boolean | null, type?: string | null, medicalCard?: { __typename?: 'consumerUserMedicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null }, payByBankEnrollmentStatus?: { __typename?: 'ShowEnrollmentResponse', enrollmentStatus: StatusTypes, requiresAggregatorMigration?: boolean | null, paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null, financialInstitutionLogo?: string | null } } | null> } | null } | null } | null };

export type GqlLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type GqlLogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlUpdateUserMutationVariables = Exact<{
  input: GqlUsersUpdateInput;
}>;


export type GqlUpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'Users', audioNotificationsOnNewArrivalsDisabled?: boolean | null, audioNotificationsOnNewOrdersDisabled?: boolean | null, chainID?: string | null, createdAt?: string | null, createdBy?: string | null, dispensaryId?: string | null, email?: string | null, fullName?: string | null, isWeeklyReportEnabled?: boolean | null, phone?: string | null, roleAtDispensary?: DispensaryRoles | null, type?: string | null, permissions?: { __typename?: 'Users_permissions', allLocations?: boolean | null, analytics?: boolean | null, billing?: boolean | null, customers?: boolean | null, dispensaryIds?: Array<string> | null, driver?: boolean | null, menu?: boolean | null, menuReview?: boolean | null, orders?: boolean | null, promote?: boolean | null, settings?: boolean | null, superMenuReview?: boolean | null, users?: boolean | null } | null } | null };

export type GqlMeConsumerQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlMeConsumerQuery = { __typename?: 'Query', meConsumer?: { __typename?: 'IdentityConsumer', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string, verified?: boolean | null, lastVerifiedAt?: string | null } | null>, profile: { __typename?: 'IdentityConsumerProfile', birthday?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, lastName?: string | null, phone?: string | null, textNotifications?: boolean | null, type?: string | null, photoId?: string | null, isExternalUser?: boolean | null, inStoreEnrollmentCompleted?: boolean | null, address?: { __typename?: 'consumerUserProfileAddressType', city?: string | null, lat?: number | null, ln1?: string | null, ln2?: string | null, lng?: number | null, state?: string | null, zipcode?: string | null } | null, medicalCard?: { __typename?: 'consumerUserMedicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null }, payByBankEnrollmentStatus?: { __typename?: 'ShowEnrollmentResponse', enrollmentStatus: StatusTypes, requiresAggregatorMigration?: boolean | null, paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null, financialInstitutionLogo?: string | null } } | null> } | null } | null };

export type GqlCreateOrderMutationVariables = Exact<{
  input: GqlOrdersCreateInput;
  turnstileToken?: InputMaybe<Scalars['String']>;
}>;


export type GqlCreateOrderMutation = { __typename?: 'Mutation', createOrderV2?: { __typename?: 'CreateOrderResponse', valid: boolean, errors?: Array<{ __typename?: 'CreateOrderError', name?: string | null, path?: string | null, message?: string | null, params?: any | null, extensions?: any | null } | null> | null, order?: { __typename?: 'Orders', updateOrderToken?: string | null, paymentMethod?: string | null, paymentMethodId?: string | null, createdAt?: string | null, creditTotal?: string | null, medicalOrder?: boolean | null, mixAndMatch?: number | null, otherFees?: number | null, deliveryFee?: number | null, id?: string | null, orderId?: string | null, receipt?: any | null, specialInstructions?: string | null, status?: string | null, statusTimes?: Array<string | null> | null, taxAmount?: number | null, cannabisTax?: number | null, tipAmount?: number | null, subtotal?: string | null, totalCost?: string | null, isKioskOrder?: boolean | null, isPreviewOrder?: boolean | null, isGuestOrder?: boolean | null, isAfterHoursOrder?: boolean | null, messages?: Array<string | null> | null, destinationTerminal?: string | null, customerState?: string | null, isPTPOT?: boolean | null, coupon?: { __typename?: 'Coupons', _id: string } | null, tipValue?: { __typename?: 'Orders_tipValue', percent?: number | null, dollar?: number | null } | null, customer?: { __typename?: 'Orders_customer', _id?: string | null, profile?: { __typename?: 'Orders_customer_profile', driversLicense?: string | null, photoId?: string | null, medicalCard?: { __typename?: 'Orders_medicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null } | null } | null, medicalCard?: { __typename?: 'Orders_medicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null, durationEstimates?: { __typename?: 'DurationEstimates', delivery?: { __typename?: 'DurationEstimateRange', lowInMinutes?: number | null, highInMinutes?: number | null } | null, pickup?: { __typename?: 'DurationEstimateRange', lowInMinutes?: number | null, highInMinutes?: number | null } | null } | null, deliveryInfo?: { __typename?: 'Orders_deliveryInfo', address?: string | null, apartmentNum?: string | null, deliveryAddress?: string | null, deliveryOption?: boolean | null, lastSearchedAddress?: string | null, nonDeliveryAddress?: string | null, location?: { __typename?: 'Orders_location', ln1?: string | null, ln2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null } | null, dispensary?: { __typename?: 'Orders_dispensary', _id?: string | null, cName?: string | null, name?: string | null, phone?: string | null, address?: string | null, offerDelivery?: boolean | null, alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, creditCardByPhone?: boolean | null, debitOnly?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, deliveryMin?: string | null, timezone?: string | null, customDomainSettings?: { __typename?: 'Dispensaries_profile_customDomain_settings', domain?: string | null } | null, plusSettings?: { __typename?: 'Dispensaries_profile_plus_settings', checkoutUrl?: string | null, defaultReturnUrl?: string | null } | null, deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null } | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null } | null, feeTiers?: Array<{ __typename?: 'Dispensaries_profile_feeTiers', fee?: string | null, max?: string | null, min?: string | null } | null> | null, featureFlags?: { __typename?: 'Dispensaries_featureFlags', hideDeliveryEstimate?: boolean | null } | null } | null, orders: Array<{ __typename?: 'Orders_order', basePrice?: number | null, option?: string | null, price?: number | null, quantity?: number | null, product?: { __typename?: 'Order_product', _id?: string | null, Name?: string | null, type?: string | null, strainType?: string | null } | null }>, statusEvents?: Array<{ __typename?: 'OrderStatusEvents', event?: string | null, at?: string | null, by?: string | null, byType?: string | null } | null> | null, guestCustomer?: { __typename?: 'Orders_guestCustomer', phone?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, birthMonth?: string | null, birthDay?: string | null, birthYear?: string | null } | null, salesTaxExistence?: { __typename?: 'Order_salesTaxExistence', med?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null, rec?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null } | null, cannabisTaxExistence?: { __typename?: 'Order_cannabisTaxExistence', med?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null, rec?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null } | null, bottleDepositTaxExistence?: { __typename?: 'Order_bottleDepositTaxExistence', med?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null, rec?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null } | null, appliedRewards?: Array<{ __typename?: 'Reward', id?: string | null, copy?: string | null, available?: boolean | null, value?: string | null, operator?: string | null, brand?: string | null, discountId?: number | null } | null> | null } | null } | null };

export type GqlUpdateKioskOrderPaymentMutationVariables = Exact<{
  input: GqlUpdateKioskOrderPaymentInput;
}>;


export type GqlUpdateKioskOrderPaymentMutation = { __typename?: 'Mutation', updateKioskOrderPayment?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlGenerateHypurRedirectV3MutationVariables = Exact<{
  dispensaryId: Scalars['String'];
  hostname?: InputMaybe<Scalars['String']>;
  embedded: Scalars['Boolean'];
}>;


export type GqlGenerateHypurRedirectV3Mutation = { __typename?: 'Mutation', generateHypurRedirectV3?: { __typename?: 'HypurRedirect', url: string } | null };

export type GqlCheckoutQueryVariables = Exact<{
  checkoutId: Scalars['String'];
  dispensaryId: Scalars['String'];
}>;


export type GqlCheckoutQuery = { __typename?: 'Query', getCheckout?: { __typename?: 'Checkout', id: string, pricingType: string, orderType: string, address?: { __typename?: 'CheckoutAddress', deliverable: boolean, formatted?: string | null, street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, valid: boolean, zip?: string | null, geometry?: { __typename?: 'CheckoutAddressGeometry', coordinates?: Array<number> | null, type?: string | null } | null } | null, items: Array<{ __typename?: 'CheckoutItem', id: string, option: string, productId: string, quantity: number, product?: { __typename?: 'Products', _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null } | null }> } | null };

export type GqlUpdateCheckoutMutationVariables = Exact<{
  dispensaryId: Scalars['String'];
  checkoutId: Scalars['String'];
  address?: InputMaybe<GqlCheckoutAddressInput>;
  orderType: Scalars['String'];
  pricingType?: InputMaybe<Scalars['String']>;
}>;


export type GqlUpdateCheckoutMutation = { __typename?: 'Mutation', updateCheckout?: { __typename?: 'Checkout', id: string } | null };

export type GqlUpdateCheckoutItemQuantityMutationVariables = Exact<{
  dispensaryId: Scalars['String'];
  checkoutId: Scalars['String'];
  productId: Scalars['String'];
  option?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
}>;


export type GqlUpdateCheckoutItemQuantityMutation = { __typename?: 'Mutation', updateQuantity?: { __typename?: 'Checkout', id: string } | null };

export type GqlRemoveCheckoutItemMutationVariables = Exact<{
  checkoutId: Scalars['String'];
  dispensaryId: Scalars['String'];
  productId: Scalars['String'];
  option?: InputMaybe<Scalars['String']>;
}>;


export type GqlRemoveCheckoutItemMutation = { __typename?: 'Mutation', removeItem?: { __typename?: 'Checkout', id: string } | null };

export type GqlGetAllCitiesByStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetAllCitiesByStateQuery = { __typename?: 'Query', statesWithDispensaries: Array<{ __typename?: 'State', cities: Array<string | null>, name?: string | null, country?: string | null }> };

export type GqlGetCitiesWithDispensariesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetCitiesWithDispensariesQuery = { __typename?: 'Query', statesWithDispensaries: Array<{ __typename?: 'State', cities: Array<string | null>, name?: string | null, country?: string | null }> };

export type GqlMostPurchasedProductIdsQueryVariables = Exact<{
  dispensaryId: Scalars['String'];
}>;


export type GqlMostPurchasedProductIdsQuery = { __typename?: 'Query', getMostPurchasedProducts?: Array<{ __typename?: 'MongoProduct', id: string }> | null };

export type GqlRecentlyViewedProductsQueryVariables = Exact<{
  dispensaryId: Scalars['String'];
}>;


export type GqlRecentlyViewedProductsQuery = { __typename?: 'Query', getRecentlyViewedProducts?: Array<{ __typename?: 'Products', id?: string | null }> | null };

export type GqlProductDemandCountsQueryVariables = Exact<{
  dispensaryId: Scalars['String'];
  productIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GqlProductDemandCountsQuery = { __typename?: 'Query', getProductDemandCounts?: Array<{ __typename?: 'ProductDemandCount', id: string, count: number } | null> | null };

export type GqlDispensariesForChainQueryVariables = Exact<{
  dispensaryFilter: GqlDispensariesFilterInput;
}>;


export type GqlDispensariesForChainQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', id: string, name?: string | null, cName?: string | null, status?: string | null, chain?: string | null } | null> | null };

export type GqlOrdersForConsumerInChainQueryVariables = Exact<{
  ordersFilter: GqlOrdersFilterInput;
  ordersSort?: InputMaybe<GqlOrdersSortInput>;
  ordersPagination?: InputMaybe<GqlOrdersPaginationInput>;
}>;


export type GqlOrdersForConsumerInChainQuery = { __typename?: 'Query', filteredOrders?: { __typename?: 'OrderList', queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null, orders?: Array<{ __typename?: 'Orders', createdAt?: string | null, credit?: number | null, deliveryFee?: number | null, id?: string | null, medicalOrder?: boolean | null, mixAndMatch?: number | null, orderId?: string | null, specialInstructions?: string | null, status?: string | null, taxAmount?: number | null, cannabisTax?: number | null, bottleDepositTaxCents?: number | null, tipAmount?: number | null, paymentFee?: number | null, paymentMethod?: string | null, subtotal?: string | null, totalCost?: string | null, isPreviewOrder?: boolean | null, terminal?: string | null, autoConfirmed?: boolean | null, autoClosed?: boolean | null, isKioskOrder?: boolean | null, isAfterHoursOrder?: boolean | null, isCurbsidePickupOrder?: boolean | null, isDriveThruPickupOrder?: boolean | null, driversLicense?: string | null, coupon?: { __typename?: 'Coupons', _id: string, active?: boolean | null, addedDate?: string | null, amount?: string | null, percentDiscount?: number | null, fixedDiscountInCents?: number | null, code?: string | null, dispensary?: string | null, expDate?: string | null, numAllowedUses?: number | null, numUses?: number | null, usedBy?: Array<string | null> | null } | null, durationEstimates?: { __typename?: 'DurationEstimates', delivery?: { __typename?: 'DurationEstimateRange', lowInMinutes?: number | null, highInMinutes?: number | null } | null, pickup?: { __typename?: 'DurationEstimateRange', lowInMinutes?: number | null, highInMinutes?: number | null } | null } | null, dispensary?: { __typename?: 'Orders_dispensary', _id?: string | null, name?: string | null, cName?: string | null, phone?: string | null, logoImage?: string | null, address?: string | null, timezone?: string | null, featureFlags?: { __typename?: 'Dispensaries_featureFlags', hideDeliveryEstimate?: boolean | null } | null } | null, customer?: { __typename?: 'Orders_customer', _id?: string | null, emails?: Array<{ __typename?: 'Orders_customer_emails', address?: string | null } | null> | null, profile?: { __typename?: 'Orders_customer_profile', driversLicense?: string | null, photoId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, birthday?: string | null, medicalCard?: { __typename?: 'Orders_medicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null } | null } | null, guestCustomer?: { __typename?: 'Orders_guestCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, birthMonth?: string | null, birthDay?: string | null, birthYear?: string | null } | null, medicalCard?: { __typename?: 'Orders_medicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null, orders: Array<{ __typename?: 'Orders_order', basePrice?: number | null, option?: string | null, price?: number | null, additionalOption?: string | null, quantity?: number | null, product?: { __typename?: 'Order_product', _id?: string | null, Name?: string | null, type?: string | null, Options?: Array<string | null> | null, Image?: string | null, AdditionalOptions?: Array<string | null> | null, brandName?: string | null, preTaxRecPrices?: Array<number | null> | null, preTaxMedPrices?: Array<number | null> | null } | null }>, deliveryInfo?: { __typename?: 'Orders_deliveryInfo', address?: string | null, apartmentNum?: string | null, deliveryAddress?: string | null, deliveryOption?: boolean | null, lastSearchedAddress?: string | null, nonDeliveryAddress?: string | null, location?: { __typename?: 'Orders_location', lat?: number | null, lng?: number | null, ln1?: string | null, ln2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null } | null, cannabisTaxExistence?: { __typename?: 'Order_cannabisTaxExistence', med?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null, rec?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null } | null, salesTaxExistence?: { __typename?: 'Order_salesTaxExistence', med?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null, rec?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null } | null, bottleDepositTaxExistence?: { __typename?: 'Order_bottleDepositTaxExistence', med?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null, rec?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null } | null, appliedRewards?: Array<{ __typename?: 'Reward', copy?: string | null, value?: string | null, operator?: string | null } | null> | null, reservation?: { __typename?: 'OrderReservation', startTimeISO?: any | null, endTimeISO?: any | null } | null } | null> | null } | null };

export type GqlCreatePointsBoostMutationVariables = Exact<{
  input: GqlCreatePointsBoostInput;
}>;


export type GqlCreatePointsBoostMutation = { __typename?: 'Mutation', createPointsBoost?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlCreatePosMedUserMutationVariables = Exact<{
  dispensaryId: Scalars['String'];
  user: GqlCreatePosMedUserInput;
}>;


export type GqlCreatePosMedUserMutation = { __typename?: 'Mutation', createPOSMedUser?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlGetPosMedCardInfoQueryVariables = Exact<{
  dispensaryId: Scalars['String'];
}>;


export type GqlGetPosMedCardInfoQuery = { __typename?: 'Query', getPosMedCardInfo?: { __typename?: 'PosMedCardInfo', number?: string | null, expirationDate?: string | null, valid?: boolean | null, message?: string | null } | null };

export type GqlUpdateProfileMutationVariables = Exact<{
  profile: GqlConsumerUserProfileInput;
}>;


export type GqlUpdateProfileMutation = { __typename?: 'Mutation', updateProfileV2?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlCreatePublicContextSessionMutationVariables = Exact<{
  dispensaryId: Scalars['String'];
}>;


export type GqlCreatePublicContextSessionMutation = { __typename?: 'Mutation', createPublicContextSession?: { __typename?: 'PublicContextSession', id: string, dispensaryId: string, status: PublicContextSessionStatus, expiresAt: string } | null };

export type GqlUpdatePublicContextSessionMutationVariables = Exact<{
  id: Scalars['String'];
  loginMethodVerified?: InputMaybe<Scalars['Boolean']>;
}>;


export type GqlUpdatePublicContextSessionMutation = { __typename?: 'Mutation', updatePublicContextSession?: { __typename?: 'PublicContextSession', id: string, dispensaryId: string, status: PublicContextSessionStatus, expiresAt: string, loginMethodVerified?: boolean | null, claimedByUserId?: string | null } | null };

export type GqlGetPublicContextSessionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GqlGetPublicContextSessionQuery = { __typename?: 'Query', getPublicContextSession?: { __typename?: 'PublicContextSession', id: string, dispensaryId: string, status: PublicContextSessionStatus, expiresAt: string, loginMethodVerified?: boolean | null, claimedByUserId?: string | null, accessToken?: string | null } | null };

export type GqlCreateInstoreCartUrlMutationVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type GqlCreateInstoreCartUrlMutation = { __typename?: 'Mutation', createInstoreCartUrl?: { __typename?: 'CreateInstoreCartUrlResponse', instoreCartUrl: string } | null };

export type GqlCreateBackInStockSubscriptionMutationVariables = Exact<{
  productId: Scalars['String'];
}>;


export type GqlCreateBackInStockSubscriptionMutation = { __typename?: 'Mutation', createBackInStockSubscription?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlDeleteBackInStockSubscriptionMutationVariables = Exact<{
  productId: Scalars['String'];
}>;


export type GqlDeleteBackInStockSubscriptionMutation = { __typename?: 'Mutation', deleteBackInStockSubscription?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlGetBackInStockSubscriptionStatusQueryVariables = Exact<{
  productId: Scalars['String'];
}>;


export type GqlGetBackInStockSubscriptionStatusQuery = { __typename?: 'Query', getBackInStockSubscriptionStatus?: { __typename?: 'BackInStockSubscriptionStatus', subscribed: boolean } | null };

export type GqlGetCollectionQueryVariables = Exact<{
  dispensaryId: Scalars['String'];
  collectionId: Scalars['String'];
}>;


export type GqlGetCollectionQuery = { __typename?: 'Query', getCollection: { __typename?: 'Collection', id: string, title: string, description?: string | null, image?: string | null, customCategory?: boolean | null, enabled?: boolean | null } };

export type GqlGetCollectionsQueryVariables = Exact<{
  dispensaryId: Scalars['String'];
  customCategory?: InputMaybe<Scalars['Boolean']>;
}>;


export type GqlGetCollectionsQuery = { __typename?: 'Query', getCollections: Array<{ __typename?: 'Collection', customCategory?: boolean | null, enabled?: boolean | null, id: string, navigationTitle?: string | null, slug: string, title: string }> };

export type GqlGetCollectionsNavigationQueryVariables = Exact<{
  dispensaryId: Scalars['String'];
  customCategory?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  activeOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type GqlGetCollectionsNavigationQuery = { __typename?: 'Query', getCollectionsNavigation: Array<{ __typename?: 'Collection', id: string, slug: string, title: string, customCategory?: boolean | null, enabled?: boolean | null, navigationTitle?: string | null, isActive?: boolean | null, schedule?: { __typename?: 'Schedule', id: string, startDate: any, endDate?: any | null, timeRanges?: Array<{ __typename?: 'TimeRange', id: string, dayOfWeek: number, startTime: string, endTime: string }> | null } | null }> };

export type GqlCheckAgeVerificationQueryVariables = Exact<{
  dispensaryId: Scalars['String'];
}>;


export type GqlCheckAgeVerificationQuery = { __typename?: 'Query', checkAgeVerification: { __typename?: 'AgeVerification', isAgeVerified: boolean } };

export type GqlEnterpriseProductsQueryVariables = Exact<{
  enterpriseId: Scalars['ID'];
}>;


export type GqlEnterpriseProductsQuery = { __typename?: 'Query', enterpriseProductsV2?: { __typename?: 'EnterpriseProducts', products?: Array<{ __typename?: 'EnterpriseProduct', brandId?: string | null, brandName?: string | null, enterpriseProductId?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, name?: string | null, options?: Array<string | null> | null, prices?: Array<number | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, subcategory?: string | null, type?: string | null, dispensaryProducts?: Array<{ __typename?: 'EnterpriseDispensaryProduct', brandId?: string | null, brandName?: string | null, dispensaryId?: string | null, id?: string | null, status?: string | null, enterpriseProductId?: string | null } | null> | null } | null> | null } | null };

export type GqlGetChainDispensariesQueryVariables = Exact<{
  dispensaryFilter: GqlDispensariesFilterInput;
}>;


export type GqlGetChainDispensariesQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', id: string, name?: string | null, cName?: string | null, status?: string | null, chain?: string | null, address?: string | null, distance?: number | null, logoImage?: string | null, offerAnyPickupService?: boolean | null, location?: { __typename?: 'Dispensaries_profile_location', ln1?: string | null, ln2?: string | null, city?: string | null, state?: string | null, country?: string | null, geometry?: { __typename?: 'Dispensaries_profile_location_geometry', coordinates?: Array<number | null> | null } | null } | null, effectiveHours?: { __typename?: 'EffectiveHours', deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null } | null, deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, pickupHours: { __typename?: 'dayBounds', active?: boolean | null, start?: string | null, end?: string | null }, deliveryHours: { __typename?: 'dayBounds', active?: boolean | null, start?: string | null, end?: string | null } } | null> | null } | null> | null, hoursSettings?: { __typename?: 'DispensaryHoursSettings', inStorePickup?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null, curbsidePickup?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null, driveThruPickup?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null, delivery?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null } | null, orderTypesConfig?: { __typename?: 'OrderTypesConfig', delivery?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null } | null } | null, orderTypesConfigV2?: { __typename?: 'OrderTypesConfigV2', offerAnyPickupService?: boolean | null, offerDeliveryService?: boolean | null, inStorePickup?: { __typename?: 'InStorePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null, curbsidePickup?: { __typename?: 'CurbsidePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null, driveThruPickup?: { __typename?: 'DriveThruPickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null, delivery?: { __typename?: 'DeliveryOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null } | null, enabledOrderTypes?: { __typename?: 'EnabledOrderTypes', pickup?: boolean | null, inStorePickup?: boolean | null, curbsidePickup?: boolean | null, driveThruPickup?: boolean | null, delivery?: boolean | null, kiosk?: boolean | null } | null, storeSettings: { __typename?: 'Dispensaries_storeSettings', enableAfterHoursOrderingForDelivery: boolean, enableAfterHoursOrderingForPickup: boolean, enableScheduledOrderingForDelivery: boolean, enableScheduledOrderingForPickup: boolean } } | null> | null };

export type GqlEnterpriseLoyaltySettingsQueryVariables = Exact<{
  enterpriseId: Scalars['ID'];
}>;


export type GqlEnterpriseLoyaltySettingsQuery = { __typename?: 'Query', enterpriseLoyaltySettings?: { __typename?: 'EnterpriseLoyaltySettings', enterpriseId: string, landingPageUrl?: string | null, loyaltyEnrollmentUrl?: string | null, name: string, uniqueName: string, isoRegionCodes: Array<string> } | null };

export type GqlDispensaryProductAddToCartFieldsFragment = { __typename?: 'Products', id?: string | null, enterpriseProductId?: string | null, Name?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, Options?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, optionsBelowThreshold?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, strainType?: string | null, type?: string | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', name: string, imageUrl?: string | null, description?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandName?: string | null, categoryName?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, productGroup?: string | null, productId?: string | null, quantity?: number | null, requiresSingleSku?: boolean | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandName?: string | null, categoryName?: string | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, productGroup?: string | null, productId?: string | null, percentDiscount?: string | null, quantity?: number | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, targetPrice?: string | null, requiresSingleSku?: boolean | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null };

export type GqlDeleteAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type GqlDeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: { __typename?: 'DeleteAccountResponse', success: boolean, error?: string | null } };

export type GqlDispensaryDemoRequestMutationVariables = Exact<{
  input: GqlDispensaryDemoRequestInput;
}>;


export type GqlDispensaryDemoRequestMutation = { __typename?: 'Mutation', dispensaryDemoRequest?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlActivateBankAccountMutationVariables = Exact<{
  paymentMethodId: Scalars['String'];
}>;


export type GqlActivateBankAccountMutation = { __typename?: 'Mutation', activateBankAccount?: { __typename?: 'ActivateBankAccountResponse', success?: boolean | null } | null };

export type GqlActivatePaymentMethodV2MutationVariables = Exact<{
  paymentMethodId: Scalars['String'];
}>;


export type GqlActivatePaymentMethodV2Mutation = { __typename?: 'Mutation', activatePaymentMethodV2: { __typename?: 'ActivatePaymentMethodResponse', genericResponse?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null } };

export type GqlApproveInstoreCartMutationVariables = Exact<{
  instoreCartId: Scalars['String'];
  tipCents: Scalars['Int'];
  sessionId?: InputMaybe<Scalars['String']>;
}>;


export type GqlApproveInstoreCartMutation = { __typename?: 'Mutation', approveInstoreCart?: { __typename?: 'ApproveInstoreCartResponse', success?: boolean | null, authorization: { __typename?: 'ApproveInstoreCartAuthorization', authorized: boolean, status: string, code: string } } | null };

export type GqlCompleteAggregatorLinkMutationVariables = Exact<{
  aggregatorToken: Scalars['String'];
  aggregator: Scalars['String'];
  plaid?: InputMaybe<GqlPlaidLinkMetadata>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  dispensaryName?: InputMaybe<Scalars['String']>;
  dispensaryId?: InputMaybe<Scalars['String']>;
}>;


export type GqlCompleteAggregatorLinkMutation = { __typename?: 'Mutation', completeAggregatorLink: { __typename?: 'CompleteAggregatorLinkResponse', paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null } } | null> } };

export type GqlCreateBankAccountMutationVariables = Exact<{
  adapter: Scalars['String'];
  aggregatorToken: Scalars['String'];
  billingAddressId: Scalars['String'];
  entityId: Scalars['String'];
  entityType: EntityTypes;
  sessionId?: InputMaybe<Scalars['String']>;
}>;


export type GqlCreateBankAccountMutation = { __typename?: 'Mutation', createBankAccount?: { __typename?: 'CreateBankAccountResponse', bankAccount?: { __typename?: 'PaymentMethod', id?: string | null, bankAccount?: { __typename?: 'BankDetails', lastDigits: string, bankName: string, ownerName?: Array<string> | null } | null } | null } | null };

export type GqlCreateFraudAccountMutationVariables = Exact<{
  payload: GqlCreateFraudInput;
}>;


export type GqlCreateFraudAccountMutation = { __typename?: 'Mutation', createFraudAccount?: { __typename?: 'CreateFraudAccountResponse', success: boolean } | null };

export type GqlCreateMxEnrollmentMutationVariables = Exact<{
  billingAddress: GqlBillingAddressInput;
  entityId: Scalars['String'];
  entityName: Scalars['String'];
  entityType: EntityTypes;
  entityEmail: Scalars['String'];
  isMobileApp: Scalars['Boolean'];
}>;


export type GqlCreateMxEnrollmentMutation = { __typename?: 'Mutation', createMxEnrollment?: { __typename?: 'CreateMxEnrollmentResponse', url: string, billingAddress?: { __typename?: 'BillingAddress', id: string } | null } | null };

export type GqlCreatePaymentMutationVariables = Exact<{
  amount: Scalars['Int'];
  tipAmount?: InputMaybe<Scalars['Int']>;
  checkoutToken: Scalars['String'];
  currency: Scalars['String'];
  ecommLocationId: Scalars['String'];
  card?: InputMaybe<GqlCreatePaymentCard>;
  customerDetails: GqlCreatePaymentCustomerDetails;
  redirectUrl?: InputMaybe<Scalars['String']>;
}>;


export type GqlCreatePaymentMutation = { __typename?: 'Mutation', createPayment?: { __typename?: 'CreatePaymentResponse', redirectUrl?: string | null, payment: { __typename?: 'CreatePaymentPayment', id?: string | null } } | null };

export type GqlRecordUserAcceptanceMutationVariables = Exact<{
  acceptanceDocumentId: Scalars['String'];
  entityId: Scalars['String'];
  entityType: EntityTypes;
  userId: Scalars['String'];
}>;


export type GqlRecordUserAcceptanceMutation = { __typename?: 'Mutation', recordUserAcceptance?: { __typename?: 'RecordUserAcceptanceResponse', success?: boolean | null } | null };

export type GqlStartPreAuthCheckMutationVariables = Exact<{
  paymentMethodId: Scalars['String'];
}>;


export type GqlStartPreAuthCheckMutation = { __typename?: 'Mutation', startPreAuthCheck?: { __typename?: 'StartPreAuthCheckResponse', channelName?: string | null, checkId?: string | null, status: StartPreAuthCheckResponseStatus } | null };

export type GqlUnenrollPayByBankUserMutationVariables = Exact<{
  entityId: Scalars['String'];
  entityType: EntityTypes;
}>;


export type GqlUnenrollPayByBankUserMutation = { __typename?: 'Mutation', unenrollPayByBankUser: { __typename?: 'UnenrollEnrollmentResponse', success: boolean } };

export type GqlGetCustomerDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetCustomerDetailsQuery = { __typename?: 'Query', getCustomerDetails: { __typename?: 'CustomerDetailsResponse', id: string, name: string, externalId: string, successfulOrderCount: number } };

export type GqlGetEnrollmentStatusQueryVariables = Exact<{
  entityId: Scalars['String'];
  entityType: EntityTypes;
}>;


export type GqlGetEnrollmentStatusQuery = { __typename?: 'Query', getEnrollmentStatus?: { __typename?: 'UserEnrollment', enrollment?: { __typename?: 'Status', status: StatusTypes } | null, bankAccounts: Array<{ __typename?: 'BankAccount', id: string, billingAddress?: { __typename?: 'BillingAddress', line1: string, line2?: string | null, city: string, state: string, country: string, postalCode: string } | null, bankAccount?: { __typename?: 'BankDetails', bankName: string, lastDigits: string } | null }> } | null };

export type GqlGetEntityLinkingCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetEntityLinkingCodeQuery = { __typename?: 'Query', getEntityLinkingCode?: { __typename?: 'EntityLinkingCodeResponse', code: string } | null };

export type GqlFilteredDispensariesQueryVariables = Exact<{
  dispensaryId?: InputMaybe<Scalars['String']>;
}>;


export type GqlFilteredDispensariesQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', SpecialLogoImage?: string | null, name?: string | null } | null> | null };

export type GqlGetInstoreAnalyticsTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetInstoreAnalyticsTokenQuery = { __typename?: 'Query', getInstoreAnalyticsToken?: { __typename?: 'InstoreAnalyticsToken', instoreAnalyticsTokenId: string } | null };

export type GqlGetInstoreCartQueryVariables = Exact<{
  cartToken?: InputMaybe<Scalars['String']>;
}>;


export type GqlGetInstoreCartQuery = { __typename?: 'Query', getInstoreCart?: { __typename?: 'ShowInstoreCartResponse', instoreCartData?: { __typename?: 'InstoreCartDataType', tippingDisabled: boolean, retailerId: string, instoreCart: { __typename?: 'InstoreCart', currency: string, id: string, subtotalCents: number, tipCents: number, totalCents: number, discounts?: Array<{ __typename?: 'SubtotalItem', name: string, valueCents: number }> | null, fees?: Array<{ __typename?: 'SubtotalItem', name: string, valueCents: number }> | null, items: Array<{ __typename?: 'InstoreCartItem', brandName: string, imageUrl?: string | null, name: string, quantity: string, valueCents: number }>, taxes: Array<{ __typename?: 'SubtotalItem', name: string, valueCents: number }> } } | null } | null };

export type GqlGetUserIncentiveEligibilityQueryVariables = Exact<{
  externalId: Scalars['String'];
  dispensaryId?: InputMaybe<Scalars['String']>;
}>;


export type GqlGetUserIncentiveEligibilityQuery = { __typename?: 'Query', getUserIncentiveEligibility?: { __typename?: 'GetUserStatusResponse', eligible: boolean, incentive?: { __typename?: 'Incentive', id: string, name: string, description?: string | null, amountCents: number, cohortName: string, active: boolean } | null } | null };

export type GqlListBankAccountsQueryVariables = Exact<{
  aggregator: Scalars['String'];
}>;


export type GqlListBankAccountsQuery = { __typename?: 'Query', listBankAccounts?: { __typename?: 'MxBankAccounts', bankAccounts?: Array<{ __typename?: 'MxBankAccount', accountAlias: string, bankName: string, billingAddressId: string, entityId: string, id: string, lastDigits: string, status: string, mx?: { __typename?: 'MxResponse', connectionStatus: string, widgetUrl: string } | null }> | null } | null };

export type GqlListRetailerPaymentTypesStatusQueryVariables = Exact<{
  ecommLocationId: Scalars['String'];
}>;


export type GqlListRetailerPaymentTypesStatusQuery = { __typename?: 'Query', listRetailerPaymentTypesStatus?: { __typename?: 'RetailerPaymentTypes', paymentTypes: Array<{ __typename?: 'PaymentTypeConfig', enabled?: boolean | null, type?: PaymentsPaymentType | null, orderTypes?: { __typename?: 'PaymentsOrderTypes', curbsidePickup?: boolean | null, driveThruPickup?: boolean | null, pickup?: boolean | null, delivery?: boolean | null } | null } | null> } | null };

export type GqlShowEnrollmentQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlShowEnrollmentQuery = { __typename?: 'Query', showEnrollment: { __typename?: 'ShowEnrollmentResponse', enrollmentStatus: StatusTypes, requiresAggregatorMigration?: boolean | null, paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null, financialInstitutionLogo?: string | null } } | null> } };

export type GqlStartAggregatorLinkV2QueryVariables = Exact<{
  aggregator: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  paymentMethodId?: InputMaybe<Scalars['String']>;
  linkCustomizationName?: InputMaybe<Scalars['String']>;
}>;


export type GqlStartAggregatorLinkV2Query = { __typename?: 'Query', startAggregatorLinkV2: { __typename?: 'StartAggregatorLinkV2Response', plaid?: { __typename?: 'PlaidLinkStart', linkToken: string } | null, aerosync?: { __typename?: 'AeroSyncLinkStart', token: string, userId: string } | null } };

export type GqlStartAggregatorLinkQueryVariables = Exact<{
  aggregator: Scalars['String'];
  redirectUrl?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  linkCustomizationName?: InputMaybe<Scalars['String']>;
}>;


export type GqlStartAggregatorLinkQuery = { __typename?: 'Query', startAggregatorLink: { __typename?: 'StartAggregatorLinkResponse', plaid: { __typename?: 'PlaidLinkStart', linkToken: string } } };

export type GqlVerifyMxMemberQueryVariables = Exact<{
  entityId: Scalars['String'];
  entityType: EntityTypes;
  memberGuid: Scalars['String'];
  isMobileApp: Scalars['Boolean'];
}>;


export type GqlVerifyMxMemberQuery = { __typename?: 'Query', verifyMxMember?: { __typename?: 'MxMemberVerification', identificationComplete: boolean, needsAccountSelection: boolean, needsMfa: boolean, url?: string | null, accounts: Array<{ __typename?: 'Account', accountAlias: string, accountGuid: string, availableBalance: number, bankName: string, lastDigits: string }> } | null };

export type GqlGetPersonalizedProductsV2QueryVariables = Exact<{
  input: GqlGetPersonalizedProductsV2Input;
}>;


export type GqlGetPersonalizedProductsV2Query = { __typename?: 'Query', getPersonalizedProductsV2?: { __typename?: 'PersonalizedProducts', products: Array<{ __typename?: 'Products', provider?: ProductsProvider | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null }> } | null };

export type GqlGetRecommendedProductsQueryVariables = Exact<{
  dispensaryId: Scalars['String'];
}>;


export type GqlGetRecommendedProductsQuery = { __typename?: 'Query', getRecommendedProducts: Array<{ __typename?: 'Products', _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null }> };

export type GqlGetSortedProductRecommendationsQueryVariables = Exact<{
  input: GqlGetSortedProductRecommendationsInput;
}>;


export type GqlGetSortedProductRecommendationsQuery = { __typename?: 'Query', getSortedProductRecommendations?: { __typename?: 'ProductRecommendations', adapter?: string | null, products: Array<{ __typename?: 'ProductRecommendation', id: string }> } | null };

export type GqlGetPersonalizedProductsQueryVariables = Exact<{
  input: GqlGetPersonalizedProductsInput;
}>;


export type GqlGetPersonalizedProductsQuery = { __typename?: 'Query', getPersonalizedProducts?: { __typename?: 'PersonalizedProducts', products: Array<{ __typename?: 'Products', provider?: ProductsProvider | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null }> } | null };

export type GqlGetTrackedCartQueryVariables = Exact<{
  checkoutToken: Scalars['String'];
  dispensaryId: Scalars['String'];
}>;


export type GqlGetTrackedCartQuery = { __typename?: 'Query', getTrackedCart?: { __typename?: 'TrackedCart', token: string, dispensaryId: string, createdAt?: string | null, updatedAt?: string | null, order?: any | null } | null };

export type GqlPersistCheckoutV2MutationVariables = Exact<{
  order: Scalars['JSON'];
  dispensaryId: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
}>;


export type GqlPersistCheckoutV2Mutation = { __typename?: 'Mutation', persistCheckoutV2?: { __typename?: 'PersistCheckoutResponse', checkoutToken: string } | null };

export type GqlGetRemoteIntegrationValueQueryVariables = Exact<{
  dispensaryId: Scalars['String'];
  key: Scalars['String'];
}>;


export type GqlGetRemoteIntegrationValueQuery = { __typename?: 'Query', getRemoteIntegrationValue?: string | null };

export type GqlGetSponsoredBrandQueryVariables = Exact<{
  input: GqlGetSponsoredBrandInput;
}>;


export type GqlGetSponsoredBrandQuery = { __typename?: 'Query', getSponsoredBrand?: { __typename?: 'SponsoredBrand', id: string, name: string, campaignId: string, trackers: { __typename?: 'AdTrackers', clickUrl: string, impressionUrl: string }, products: Array<{ __typename?: 'Products', provider?: ProductsProvider | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, adTrackers?: { __typename?: 'AdTrackers', clickUrl: string, impressionUrl: string } | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null }> } | null };

export type GqlGetSponsoredProductsQueryVariables = Exact<{
  input: GqlGetSponsoredProductsInput;
}>;


export type GqlGetSponsoredProductsQuery = { __typename?: 'Query', getSponsoredProducts: Array<{ __typename?: 'Products', provider?: ProductsProvider | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, adTrackers?: { __typename?: 'AdTrackers', clickUrl: string, impressionUrl: string } | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null }> };

export const BrandDispensaryFragmentFragmentDoc = gql`
    fragment brandDispensaryFragment on Brand {
  dispensary {
    id
    name
  }
}
    `;
export const BrandFragmentForDropdownFragmentDoc = gql`
    fragment brandFragmentForDropdown on Brand {
  _id
  id
  name
  imageUrl
}
    `;
export const BrandFragmentFragmentDoc = gql`
    fragment brandFragment on Brand {
  _id
  aliasList
  createdAt
  description
  id
  imageUrl
  libraryProductsCount
  name
  productsCount
  updatedAt
}
    `;
export const BucketListFragmentFragmentDoc = gql`
    fragment bucketListFragment on Bucket {
  createdBy {
    _id
    firstName
    lastName
  }
  checkedOutAt
  checkedOutBy {
    _id
    firstName
    lastName
  }
  completedReviewsCount
  id
  name
  productsCount
  teamName
}
    `;
export const CouponFragmentFragmentDoc = gql`
    fragment couponFragment on Coupons {
  _id
  active
  addedDate
  applicableCategories {
    category
    subcategory
  }
  code
  dispensaryId
  expDate
  fixedDiscountInCents
  numAllowedUses
  numUses
  percentDiscount
  oneUsePerCustomer
  restrictions {
    minimumPurchase
    minimumPurchaseInCents
    noSpecials
  }
  usedBy
}
    `;
export const DeviceFragmentFragmentDoc = gql`
    fragment deviceFragment on Devices {
  _id
  accessCode
  autoPrintDevice
  buildNumber
  config {
    getDeliveryOrders
    getKioskOrders
    getPickupOrders
    orderSource
  }
  dispensaryId
  lastSeenAt
  nickname
  online
  printerConnected
  updatedAt
  versionNumber
}
    `;
export const GetSubscriptionsV2PaymentSourcesFragmentDoc = gql`
    fragment GetSubscriptionsV2PaymentSources on DispensaryBillingV2 {
  paymentSources {
    card {
      brand
      last4
    }
    type
  }
}
    `;
export const HourSetFragmentFragmentDoc = gql`
    fragment hourSetFragment on Dispensaries_profile_hours {
  Monday {
    active
    end
    start
  }
  Tuesday {
    active
    end
    start
  }
  Wednesday {
    active
    end
    start
  }
  Thursday {
    active
    end
    start
  }
  Friday {
    active
    end
    start
  }
  Saturday {
    active
    end
    start
  }
  Sunday {
    active
    end
    start
  }
}
    `;
export const PaymentTypesFragmentFragmentDoc = gql`
    fragment paymentTypesFragment on PaymentTypesConfig {
  alt36
  check
  creditCardAtDoor
  payOnlineChase
  payOnlineHypur
  payOnlineMerrco
  payOnlineMoneris
  creditCardByPhone
  debit
  dutchiePay
  rethinkPay
  cash
  linx
  canPay
  paytender
  aeropay
}
    `;
export const BaseDispensaryFragmentFragmentDoc = gql`
    fragment baseDispensaryFragment on Dispensaries {
  id
  customDomainSettings {
    domain
  }
  plusSettings {
    checkoutUrl
    defaultReturnUrl
  }
  distance
  name
  cName
  timezone
  phone
  address
  description
  status
  chain
  location {
    ln1
    ln2
    city
    state
    country
    zipcode
    geometry {
      coordinates
    }
  }
  temporalLocation {
    lastUpdatedAt
    coordinates
    onDuty
    nearbyEnabled
  }
  deliveryHours {
    ...hourSetFragment
  }
  pickupHours {
    ...hourSetFragment
  }
  categoryPhotos {
    src
    category
  }
  customCategoryPhotos {
    url
    category
    collectionId
  }
  effectiveHours {
    deliveryHours {
      ...hourSetFragment
    }
    pickupHours {
      ...hourSetFragment
    }
  }
  offerAnyPickupService
  offerPickup
  offerCurbsidePickup
  offerDriveThruPickup
  offerDelivery
  listImage
  bannerImage
  logoImage
  embeddedLogoImage
  embeddedMenuUrl
  SpecialLogoImage
  brandedDutchiePayEnabled
  brandedDutchiePayName
  brandedDutchiePayLogoLight
  brandedDutchiePayLogoDark
  embedBackUrl
  embedSettings {
    disclaimerTextHtml
    disablePageLoadsAtTop
    enableFullScreenEmbeddedCheckout
    autoGTM
    privacyPolicyUrl
  }
  alt36
  check
  creditCardAtDoor
  payOnlineHypur
  payOnlineMerrco
  creditCardByPhone
  debitOnly
  cashOnly
  cashless
  createdAtISO
  linx
  canPay
  paytender
  aeropay
  recDispensary
  medicalDispensary
  maxDeliveryDistance
  mixAndMatchPricingWeights
  feeTiers {
    fee
    feeType
    max
    min
    percentFee
  }
  acceptsTips
  acceptsDutchiePayTips
  acceptsCreditCardTips
  requiresDriversLicense
  requiresDriversLicenseForPickup
  requirePhotoIdForDelivery
  requirePhotoIdForPickup
  removeMedicalCardFieldsAtCheckout
  menuOrder
  menuSortSettings {
    brands
    category
    menuOrder
  }
  email
  emailConfirmation
  stealthMode
  actionEstimates {
    pickup {
      readyInMinutes
      rangeInMinutes
    }
    delivery {
      readyInMinutes
      rangeInMinutes
      deliveryTimeInMinutes
    }
  }
  durationEstimateOverrides {
    delivery {
      enabled
      lowInMinutes
      highInMinutes
    }
    pickup {
      enabled
      lowInMinutes
      highInMinutes
    }
  }
  paymentFees {
    fee
    feeType
    paymentType
  }
  kioskOrderingEnabled
  kioskInstructions
  kioskConfig {
    fullNameOnly
    phoneRequired
    notesField
    directedOrders
    hidePhoneField
    hideEmailField
    showBirthdateField
    type
  }
  categoryLimits {
    name
    value
  }
  categoryLimitsEnabled
  specialsSettings {
    discountBehavior
    discountStacking
    discountPrecedence
    enableIndividualSpecialPrecedence
    enableIndividualDiscountStacking
    stackingBehavior
    nonStackingBehavior
  }
  storeSettings {
    isolatedMenus
    customerMessagingTermsAccepted
    showPOSPackageId
    defaultViewStyle
    disablePurchaseLimits
    disableGuestDOB
    displayPhoneConfirmation
    displayKioskAnonymousCheckoutDisclaimer
    enableDutchiePayConsumerSurcharge
    requireEmailAddressForGuestCheckout
    requireMedCardPhotoForPickup
    hideAddressFromDutchieMain
    hideFromMobileApp
    requireMedCardPhotoForDelivery
    enableAfterHoursOrderingForPickup
    enableAfterHoursOrderingForDelivery
    enableLLxSaleDiscountSync
    enableMixAndMatchPricingForPickup
    enableMixAndMatchPricingForDelivery
    enableProductUrgencyMessaging
    enableScheduledOrderingForPickup
    enableScheduledOrderingForDelivery
    enableLimitPerCustomer
    quantityLimit
    quantityLimitMaxAvailable
    enableOrderStatusEmails
    enableStorefrontAgeGate
    hardAgeGateHideMenuContent
    collapseProductDescription
    hardAgeGateAgeVerification
    disableGuestCheckout
    showMobileAppSmartBanner
    stealthMode
    dontCombineWeightedProducts
    keepUncombinedWeights
    dontMapSubcategoriesByProductName
    prioritizeStaffPicksInSearchResults
    provideBackInstockEmailNotifications
    hideEffects
    hideFilters
    hideOutOfStockProducts
    showLoyaltyRewards
    hideDiscountsFromConsumer
    usePotencyForConcentrateLimits
    useStandardEquivalentForEdiblesLimits
    enableOmniauthLoginCheckout
    showMobileAppSmartBanner
    subscriptions {
      enabled
    }
    rewardsIntegrationConfiguration {
      rewardsProgramDisplayDescription
      rewardsProgramDisplayEnrollment
      rewardsProgramDisplayName
    }
    enableRoundToNearestDollar
    hideRoundingLineItem
  }
  featureFlags {
    enableAfterHoursOrdering
    enableArrivals
    enableMenuImport
    enableMixAndMatch
    enableNonTerminalAutoConfirm
    enablePausedOrders
    enableScheduledOrdering
    hideDeliveryEstimate
    hideMyAccount
    hideStoreHours
  }
  updatedAt
  updatedAtISO
  terminals {
    _id
    nickname
    versionNumber
    lastSeenAt
    lastSeenAtISO
    config {
      orderSource
    }
  }
  ordersArePaused
  ageVerificationBannerHtml
  ageVerificationBannerColor
  menuBannerHtml
  menuBannerColor
  menuBannerTextBannerCollapsed
  menuUrl
  termsAndConditionsUrl
  colorSettings {
    linkColor
    navBarColor
  }
  pickupMinimum {
    enabled
    minimumInCents
  }
  orderTypesConfig {
    pickup {
      enabled
      paymentTypes {
        ...paymentTypesFragment
      }
    }
    curbsidePickup {
      enabled
      paymentTypes {
        ...paymentTypesFragment
      }
    }
    driveThruPickup {
      enabled
      paymentTypes {
        ...paymentTypesFragment
      }
    }
    delivery {
      enabled
      paymentTypes {
        ...paymentTypesFragment
      }
    }
    kiosk {
      enabled
      paymentTypes {
        ...paymentTypesFragment
      }
    }
    offerAnyPickupService
    offerDeliveryService
  }
  paymentTypesAccepted {
    alt36
    check
    creditCardAtDoor
    payOnlineChase
    payOnlineHypur
    payOnlineMerrco
    payOnlineMoneris
    creditCardByPhone
    debit
    dutchiePay
    rethinkPay
    cash
    linx
    canPay
    paytender
    aeropay
  }
}
    ${HourSetFragmentFragmentDoc}
${PaymentTypesFragmentFragmentDoc}`;
export const BaseOrderingSettingsFragmentFragmentDoc = gql`
    fragment baseOrderingSettingsFragment on BaseOrderingSettings {
  enableASAPOrdering
  enableScheduledOrdering
  enableAfterHoursOrdering
  checkoutMessage
  paymentTypes {
    ...paymentTypesFragment
  }
  scheduledOrderingConfigV2 {
    advancedDayOrderingEnabled
    sameDayDeliveryEnabled
    advancedDayOrderingLimit
    incrementInMinutes
    nextAvailableInMinutes
    orderLimitsEnabled
  }
}
    ${PaymentTypesFragmentFragmentDoc}`;
export const CurbsidePickupOrderingSettingsFragmentFragmentDoc = gql`
    fragment curbsidePickupOrderingSettingsFragment on CurbsidePickupOrderingSettings {
  ...baseOrderingSettingsFragment
  orderMinimum {
    enabled
    minimumInCents
  }
  enableCurbsideArrivals
  arrivalInformationInstructions
  pickupReminders {
    enabled
    reminderMinutesAfterReady
    reminderMessage
  }
}
    ${BaseOrderingSettingsFragmentFragmentDoc}`;
export const DeliveryOrderingSettingsFragmentFragmentDoc = gql`
    fragment deliveryOrderingSettingsFragment on DeliveryOrderingSettings {
  ...baseOrderingSettingsFragment
  deliveryFeeTiers {
    feeInCents
    maximumInCents
    minimumInCents
    feeType
    percentFee
  }
  deliveryMode
  deliveryRadius {
    orderMinimum {
      enabled
      minimumInCents
    }
    radiusInMiles
  }
  deliveryZipCodes {
    zipCode
    feeInCents
    minimumInCents
    feeType
    percentFee
  }
}
    ${BaseOrderingSettingsFragmentFragmentDoc}`;
export const DeliveryZonesFragmentFragmentDoc = gql`
    fragment deliveryZonesFragment on DeliveryOrderingSettings {
  deliveryZones {
    _id
    name
    area {
      type
      features {
        type
        geometry {
          type
          coordinates
        }
      }
    }
    feeInCents
    minimumInCents
    feeType
    percentFee
  }
}
    `;
export const DriveThruPickupOrderingSettingsFragmentFragmentDoc = gql`
    fragment driveThruPickupOrderingSettingsFragment on DriveThruPickupOrderingSettings {
  ...baseOrderingSettingsFragment
  orderMinimum {
    enabled
    minimumInCents
  }
  pickupReminders {
    enabled
    reminderMinutesAfterReady
    reminderMessage
  }
}
    ${BaseOrderingSettingsFragmentFragmentDoc}`;
export const HoursForDayFragmentDoc = gql`
    fragment hoursForDay on dayBounds {
  active
  end
  start
}
    `;
export const WeeklyHoursFragmentFragmentDoc = gql`
    fragment weeklyHoursFragment on WeeklyHours {
  Friday {
    ...hoursForDay
  }
  Monday {
    ...hoursForDay
  }
  Saturday {
    ...hoursForDay
  }
  Sunday {
    ...hoursForDay
  }
  Thursday {
    ...hoursForDay
  }
  Tuesday {
    ...hoursForDay
  }
  Wednesday {
    ...hoursForDay
  }
}
    ${HoursForDayFragmentDoc}`;
export const SpecialHoursDayFragmentFragmentDoc = gql`
    fragment specialHoursDayFragment on SpecialHoursDay {
  date
  hours {
    ...hoursForDay
  }
}
    ${HoursForDayFragmentDoc}`;
export const SpecialHoursFragmentFragmentDoc = gql`
    fragment specialHoursFragment on SpecialHours {
  id
  name
  startDate
  endDate
  hoursPerDay {
    ...specialHoursDayFragment
  }
}
    ${SpecialHoursDayFragmentFragmentDoc}`;
export const HoursSettingsForOrderTypeFragmentFragmentDoc = gql`
    fragment hoursSettingsForOrderTypeFragment on HoursSettingsForOrderType {
  hours {
    ...weeklyHoursFragment
  }
  specialHours {
    ...specialHoursFragment
  }
}
    ${WeeklyHoursFragmentFragmentDoc}
${SpecialHoursFragmentFragmentDoc}`;
export const InStorePickupOrderingSettingsFragmentFragmentDoc = gql`
    fragment inStorePickupOrderingSettingsFragment on InStorePickupOrderingSettings {
  ...baseOrderingSettingsFragment
  orderMinimum {
    enabled
    minimumInCents
  }
  pickupReminders {
    enabled
    reminderMinutesAfterReady
    reminderMessage
  }
}
    ${BaseOrderingSettingsFragmentFragmentDoc}`;
export const KioskOrderingSettingsFragmentFragmentDoc = gql`
    fragment kioskOrderingSettingsFragment on KioskOrderingSettings {
  enabled
  fullNameOnly
  phoneRequired
  notesField
  directedOrders
  hideEmailField
  hidePhoneField
  showBirthdateField
  anonymousCheckout
  kioskInstructions
  type
  paymentTypes {
    ...paymentTypesFragment
  }
  timeout {
    enabled
    duration
  }
}
    ${PaymentTypesFragmentFragmentDoc}`;
export const MaxReservationSlotFragmentFragmentDoc = gql`
    fragment maxReservationSlotFragment on MaxReservationSlot {
  active
  currentCount
  date
  startTime
  endTime
  maxOrders
  deliveryAreaId
  slotId
  isNextDaySlot
}
    `;
export const MaxReservationSlotsByDayFragmentFragmentDoc = gql`
    fragment maxReservationSlotsByDayFragment on MaxReservationSlotsByDay {
  Monday {
    ...maxReservationSlotFragment
  }
  Tuesday {
    ...maxReservationSlotFragment
  }
  Wednesday {
    ...maxReservationSlotFragment
  }
  Thursday {
    ...maxReservationSlotFragment
  }
  Friday {
    ...maxReservationSlotFragment
  }
  Saturday {
    ...maxReservationSlotFragment
  }
  Sunday {
    ...maxReservationSlotFragment
  }
}
    ${MaxReservationSlotFragmentFragmentDoc}`;
export const ScheduledOrderingConfigFragmentFragmentDoc = gql`
    fragment scheduledOrderingConfigFragment on ReservationOptionsForOrderType {
  advancedDayOrderingEnabled
  sameDayDeliveryEnabled
  advancedDayOrderingLimit
  incrementInMinutes
  nextAvailableInMinutes
  orderLimitsEnabled
}
    `;
export const TaxPropertiesFragmentDoc = gql`
    fragment taxProperties on Dispensaries_TaxConfig_Tax {
  id
  type
  name
  rate
  potencyRate
  potency
  medical
  recreational
  taxBasis
  stages {
    op
    type
  }
  applyTo {
    types
    hemp
  }
  order
  deliveryPolicy
  includeStateSalesTaxInDestinationRate
}
    `;
export const PosMetaDataFragmentFragmentDoc = gql`
    fragment POSMetaDataFragment on Products_POSMetaData {
  activeBatchTags {
    tagId
  }
  canonicalBrandId
  canonicalBrandName
  canonicalCategory
  canonicalCategoryId
  canonicalID
  canonicalPackageId
  canonicalImgUrl
  canonicalLabResultUrl
  canonicalName
  canonicalProductTags {
    tagId
  }
  canonicalSKU
  canonicalStrainId
  canonicalVendorId
  children {
    activeBatchTags {
      tagId
    }
    canonicalBrandId
    canonicalBrandName
    canonicalCategory
    canonicalCategoryId
    canonicalEffectivePotencyMg
    canonicalID
    canonicalPackageId
    canonicalImgUrl
    canonicalLabResultUrl
    canonicalName
    canonicalSKU
    canonicalProductTags {
      tagId
    }
    canonicalStrainId
    canonicalVendorId
    kioskQuantityAvailable
    medPrice
    option
    packageQuantity
    price
    quantity
    quantityAvailable
    recEquivalent {
      value
      unit
    }
    recPrice
    standardEquivalent {
      value
      unit
    }
  }
  integrationID
}
    `;
export const ConsumerBaseProductFragmentFragmentDoc = gql`
    fragment consumerBaseProductFragment on Products {
  _id
  id
  AdditionalOptions
  duplicatedProductId
  libraryProductId
  libraryProductScore
  brand {
    id
    name
    parentBrandId
    imageUrl
  }
  brandId
  brandName
  CBD
  CBDContent {
    unit
    range
  }
  certificateOfAnalysisEnabled
  collectionCardBadge {
    color
    title
  }
  comingSoon
  createdAt
  updatedAt
  DispensaryID
  enterpriseProductId
  Image
  images {
    url
    description
    active
  }
  measurements {
    netWeight {
      unit
      values
    }
    volume {
      unit
      values
    }
  }
  medicalOnly
  medicalPrices
  medicalSpecialPrices
  wholesalePrices
  Name
  nonArmsLength
  Options
  limitsPerCustomer {
    key
    value
  }
  manualInventory {
    option
    inventory
  }
  POSMetaData {
    ...POSMetaDataFragment
  }
  Prices
  pricingTierData {
    generatedTiersId
    tiersId
    tiersName
    tiers {
      startWeight
      endWeight
      price
      pricePerGram
      weightUOM
    }
  }
  specialIdsPerOption {
    option
    conditionIds
    rewardIds
  }
  rawOptions
  recOnly
  recPrices
  recSpecialPrices
  special
  specialData {
    bogoSpecials {
      applyRewardsToConditions
      excludeConditionItemsFromRewards
      bogoConditionLogicOperator
      bogoConditions {
        _id
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        productTags
        quantity
        requiresSingleSku
        selectedCategoriesAndSubcategories
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      bogoRewardLogicOperator
      bogoRewards {
        _id
        applicationRules {
          _id
          comparisonOperator
          quantity
          applicationType
        }
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        discountAmount
        discountType
        dollarDiscount
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        percentDiscount
        productTags
        quantity
        requiresSingleSku
        selectedCategoriesAndSubcategories
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        targetPrice
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      createdBy
      directPOSProductIdMapping
      rawPOSWeightMapping
      useLatestCartCalculator
      discountBundle {
        _id
        applyTo
        discountType
        enabled
        limit
        value
      }
      discountToCart {
        _id
        enabled
        discountType
        value
      }
      discountBehavior
      discountStacking
      discountPrecedence
      endStamp
      excludedProducts {
        conditions {
          _id
          key
          Name
        }
        rewards {
          _id
          key
          Name
        }
      }
      isRecurring
      itemsForAPrice {
        _id
        enabled
        value
      }
      menuType
      minorVersion
      nonStackingBehavior
      payByBankIncentiveEnabled
      paymentRestrictions {
        payByBankSignupIncentive
      }
      recurringEndDate
      redemptionLimit
      settingsDerivedFrom
      skipV4Merge
      specialId
      specialName
      specialType
      stackingBehavior
      stackingMode
      sourceId
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      useGreedOptimizedCalculator
      useTotalQtyCalcsFix
      version
      qualifyingOptions
      qualifyingConditionOptions
      qualifyingRewardOptions
    }
    saleSpecials {
      createdBy
      directPOSProductIdMapping
      rawPOSWeightMapping
      useLatestCartCalculator
      discount
      discountStacking
      dollarDiscount
      eligibleProductOptions
      menuType
      minorVersion
      nonStackingBehavior
      payByBankIncentiveEnabled
      paymentRestrictions {
        payByBankSignupIncentive
      }
      percentDiscount
      saleDiscounts {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productIds
        productTags
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        weights
        weightOperator
      }
      settingsDerivedFrom
      skipV4Merge
      source
      sourceId
      specialId
      specialName
      specialType
      specialRestrictions
      stackingBehavior
      stackingMode
      targetPrice
      useGreedOptimizedCalculator
      useTotalQtyCalcsFix
      version
    }
  }
  Status
  strainType
  subcategory
  THC
  THCContent {
    unit
    range
  }
  type
  vapeTaxApplicable
  weight
  featured {
    current
    startTime
    endTime
  }
  isBelowThreshold
  isBelowKioskThreshold
  optionsBelowThreshold
  optionsBelowKioskThreshold
  cName
  pastCNames
  brandLogo
  bottleDepositTaxCents
  useBetterPotencyTaxes
}
    ${PosMetaDataFragmentFragmentDoc}`;
export const ConsumerSponsoredProductFragmentFragmentDoc = gql`
    fragment consumerSponsoredProductFragment on Products {
  ...consumerBaseProductFragment
  adTrackers {
    clickUrl
    impressionUrl
  }
  provider
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;
export const ScheduleFieldsFragmentDoc = gql`
    fragment ScheduleFields on Schedule {
  endDate
  id
  startDate
  timeRanges {
    dayOfWeek
    endTime
    id
    startTime
  }
}
    `;
export const TerpeneFragmentFragmentDoc = gql`
    fragment TerpeneFragment on Terpene {
  aliasList
  aromas
  description
  effects
  id
  name
  unitSymbol
  potentialHealthBenefits
}
    `;
export const AdminIdentityFragmentFragmentDoc = gql`
    fragment adminIdentityFragment on LoginAdmin {
  accessToken
  user {
    _id
    createdAt
    emails {
      address
    }
    profile {
      browserNotification
      chainID
      desktopNotification
      dispensaryId
      emailNotifications
      emailOptIn
      firstName
      fullName
      lastName
      permissions {
        allLocations
        billing
        analytics
        customers
        driver
        enterpriseAdmin
        enterpriseSpecials
        menu
        menuReview
        superMenuReview
        orders
        promote
        settings
        users
        tasks
      }
      phone
      type
    }
  }
}
    `;
export const DispensaryProductAddToCartFieldsFragmentDoc = gql`
    fragment DispensaryProductAddToCartFields on Products {
  id
  enterpriseProductId
  Name
  Image
  medicalOnly
  medicalPrices
  medicalSpecialPrices
  Options
  optionsBelowKioskThreshold
  optionsBelowThreshold
  Prices
  rawOptions
  recOnly
  recPrices
  recSpecialPrices
  strainType
  type
  brand {
    name
    imageUrl
    description
  }
  CBDContent {
    unit
    range
  }
  THCContent {
    unit
    range
  }
  POSMetaData {
    ...POSMetaDataFragment
  }
  manualInventory {
    option
    inventory
  }
  limitsPerCustomer {
    key
    value
  }
  specialData {
    bogoSpecials {
      applyRewardsToConditions
      excludeConditionItemsFromRewards
      bogoConditionLogicOperator
      bogoConditions {
        _id
        brandId
        brandName
        categoryName
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          matchOperator
          productGroup
          productIds
          subcategoryIds
          subcategoryNames
          weights
          weightOperator
        }
        selectedCategoriesAndSubcategories
        productGroup
        productId
        quantity
        requiresSingleSku
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      bogoRewardLogicOperator
      bogoRewards {
        _id
        applicationRules {
          _id
          comparisonOperator
          quantity
          applicationType
        }
        brandId
        brandName
        categoryName
        discountAmount
        discountType
        dollarDiscount
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          matchOperator
          productGroup
          productIds
          subcategoryIds
          subcategoryNames
          weights
          weightOperator
        }
        productGroup
        productId
        percentDiscount
        quantity
        selectedCategoriesAndSubcategories
        targetPrice
        requiresSingleSku
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      createdBy
      directPOSProductIdMapping
      rawPOSWeightMapping
      useLatestCartCalculator
      discountToCart {
        _id
        enabled
        discountType
        value
      }
      discountBehavior
      discountStacking
      discountPrecedence
      endStamp
      excludedProducts {
        conditions {
          _id
          key
          Name
        }
        rewards {
          _id
          key
          Name
        }
      }
      isRecurring
      itemsForAPrice {
        _id
        enabled
        value
      }
      menuType
      minorVersion
      nonStackingBehavior
      paymentRestrictions {
        payByBankSignupIncentive
      }
      recurringEndDate
      redemptionLimit
      settingsDerivedFrom
      specialId
      specialName
      specialType
      stackingBehavior
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        minimumSpend
        spendOperator
      }
      version
      qualifyingOptions
    }
    saleSpecials {
      createdBy
      directPOSProductIdMapping
      rawPOSWeightMapping
      useLatestCartCalculator
      discount
      discountStacking
      dollarDiscount
      eligibleProductOptions
      menuType
      minorVersion
      nonStackingBehavior
      paymentRestrictions {
        payByBankSignupIncentive
      }
      percentDiscount
      saleDiscounts {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          matchOperator
          productGroup
          productIds
          subcategoryIds
          subcategoryNames
          weights
          weightOperator
        }
        productGroup
        productIds
        subcategoryIds
        subcategoryNames
        weights
        weightOperator
      }
      settingsDerivedFrom
      source
      sourceId
      specialId
      specialRestrictions
      specialType
      stackingBehavior
      stackingMode
      targetPrice
      version
    }
  }
  useBetterPotencyTaxes
}
    ${PosMetaDataFragmentFragmentDoc}`;
export const CreateBrandDocument = gql`
    mutation CreateBrand($brand: brandInput!) {
  createBrandV2(brand: $brand) {
    ...brandFragment
  }
}
    ${BrandFragmentFragmentDoc}`;
export type GqlCreateBrandMutationFn = ApolloReactCommon.MutationFunction<GqlCreateBrandMutation, GqlCreateBrandMutationVariables>;

/**
 * __useCreateBrandMutation__
 *
 * To run a mutation, you first call `useCreateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandMutation, { data, loading, error }] = useCreateBrandMutation({
 *   variables: {
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useCreateBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateBrandMutation, GqlCreateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateBrandMutation, GqlCreateBrandMutationVariables>(CreateBrandDocument, options);
      }
export type CreateBrandMutationHookResult = ReturnType<typeof useCreateBrandMutation>;
export type CreateBrandMutationResult = ApolloReactCommon.MutationResult<GqlCreateBrandMutation>;
export type CreateBrandMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateBrandMutation, GqlCreateBrandMutationVariables>;
export const DeleteBrandDocument = gql`
    mutation DeleteBrand($id: String!) {
  deleteBrand(id: $id) {
    _id
  }
}
    `;
export type GqlDeleteBrandMutationFn = ApolloReactCommon.MutationFunction<GqlDeleteBrandMutation, GqlDeleteBrandMutationVariables>;

/**
 * __useDeleteBrandMutation__
 *
 * To run a mutation, you first call `useDeleteBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandMutation, { data, loading, error }] = useDeleteBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlDeleteBrandMutation, GqlDeleteBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlDeleteBrandMutation, GqlDeleteBrandMutationVariables>(DeleteBrandDocument, options);
      }
export type DeleteBrandMutationHookResult = ReturnType<typeof useDeleteBrandMutation>;
export type DeleteBrandMutationResult = ApolloReactCommon.MutationResult<GqlDeleteBrandMutation>;
export type DeleteBrandMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlDeleteBrandMutation, GqlDeleteBrandMutationVariables>;
export const UpdateBrandDocument = gql`
    mutation UpdateBrand($id: String!, $brand: brandInput!) {
  updateBrandV2(id: $id, brand: $brand) {
    ...brandFragment
  }
}
    ${BrandFragmentFragmentDoc}`;
export type GqlUpdateBrandMutationFn = ApolloReactCommon.MutationFunction<GqlUpdateBrandMutation, GqlUpdateBrandMutationVariables>;

/**
 * __useUpdateBrandMutation__
 *
 * To run a mutation, you first call `useUpdateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandMutation, { data, loading, error }] = useUpdateBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useUpdateBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateBrandMutation, GqlUpdateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateBrandMutation, GqlUpdateBrandMutationVariables>(UpdateBrandDocument, options);
      }
export type UpdateBrandMutationHookResult = ReturnType<typeof useUpdateBrandMutation>;
export type UpdateBrandMutationResult = ApolloReactCommon.MutationResult<GqlUpdateBrandMutation>;
export type UpdateBrandMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateBrandMutation, GqlUpdateBrandMutationVariables>;
export const BrandsForDropdownDocument = gql`
    query BrandsForDropdown($dispensaryId: String, $searchString: String, $limit: Int, $parentBrandId: ID, $hasParent: Boolean, $localAndGlobal: Boolean) {
  searchBrandsV2(
    filters: {dispensaryId: $dispensaryId, parentBrandId: $parentBrandId, hasParent: $hasParent, localAndGlobal: $localAndGlobal}
    pagination: {limit: $limit, offset: 0}
    search: $searchString
    sort: {sortBy: score, sortDirection: desc}
  ) {
    brands {
      ...brandFragmentForDropdown
      isGlobal
    }
  }
}
    ${BrandFragmentForDropdownFragmentDoc}`;

/**
 * __useBrandsForDropdownQuery__
 *
 * To run a query within a React component, call `useBrandsForDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandsForDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandsForDropdownQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      parentBrandId: // value for 'parentBrandId'
 *      hasParent: // value for 'hasParent'
 *      localAndGlobal: // value for 'localAndGlobal'
 *   },
 * });
 */
export function useBrandsForDropdownQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlBrandsForDropdownQuery, GqlBrandsForDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlBrandsForDropdownQuery, GqlBrandsForDropdownQueryVariables>(BrandsForDropdownDocument, options);
      }
export function useBrandsForDropdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlBrandsForDropdownQuery, GqlBrandsForDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlBrandsForDropdownQuery, GqlBrandsForDropdownQueryVariables>(BrandsForDropdownDocument, options);
        }
export type BrandsForDropdownQueryHookResult = ReturnType<typeof useBrandsForDropdownQuery>;
export type BrandsForDropdownLazyQueryHookResult = ReturnType<typeof useBrandsForDropdownLazyQuery>;
export type BrandsForDropdownQueryResult = ApolloReactCommon.QueryResult<GqlBrandsForDropdownQuery, GqlBrandsForDropdownQueryVariables>;
export const GetBrandRegionsDocument = gql`
    query GetBrandRegions {
  listRegions {
    id
    code
    country
    subdivision
    countryName
    subdivisionName
  }
}
    `;

/**
 * __useGetBrandRegionsQuery__
 *
 * To run a query within a React component, call `useGetBrandRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrandRegionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetBrandRegionsQuery, GqlGetBrandRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetBrandRegionsQuery, GqlGetBrandRegionsQueryVariables>(GetBrandRegionsDocument, options);
      }
export function useGetBrandRegionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetBrandRegionsQuery, GqlGetBrandRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetBrandRegionsQuery, GqlGetBrandRegionsQueryVariables>(GetBrandRegionsDocument, options);
        }
export type GetBrandRegionsQueryHookResult = ReturnType<typeof useGetBrandRegionsQuery>;
export type GetBrandRegionsLazyQueryHookResult = ReturnType<typeof useGetBrandRegionsLazyQuery>;
export type GetBrandRegionsQueryResult = ApolloReactCommon.QueryResult<GqlGetBrandRegionsQuery, GqlGetBrandRegionsQueryVariables>;
export const GetBrandDocument = gql`
    query GetBrand($id: String!) {
  getBrand(id: $id) {
    ...brandFragment
    isGlobal
    regions {
      id
      code
      country
      subdivision
      countryName
      subdivisionName
    }
    source
    creatorUserId
    dispensary {
      name
      id
    }
    parentBrandId
    enterprise {
      id
      name
    }
  }
}
    ${BrandFragmentFragmentDoc}`;

/**
 * __useGetBrandQuery__
 *
 * To run a query within a React component, call `useGetBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetBrandQuery, GqlGetBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetBrandQuery, GqlGetBrandQueryVariables>(GetBrandDocument, options);
      }
export function useGetBrandLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetBrandQuery, GqlGetBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetBrandQuery, GqlGetBrandQueryVariables>(GetBrandDocument, options);
        }
export type GetBrandQueryHookResult = ReturnType<typeof useGetBrandQuery>;
export type GetBrandLazyQueryHookResult = ReturnType<typeof useGetBrandLazyQuery>;
export type GetBrandQueryResult = ApolloReactCommon.QueryResult<GqlGetBrandQuery, GqlGetBrandQueryVariables>;
export const SuperBrandsIndexDocument = gql`
    query SuperBrandsIndex($filters: searchBrandsFilters, $pagination: paginationInput, $search: String, $sort: searchBrandsSort) {
  searchBrandsV2(
    filters: $filters
    pagination: $pagination
    search: $search
    sort: $sort
  ) {
    brands {
      ...brandFragment
      ...brandDispensaryFragment
    }
    queryInfo {
      totalCount
    }
  }
}
    ${BrandFragmentFragmentDoc}
${BrandDispensaryFragmentFragmentDoc}`;

/**
 * __useSuperBrandsIndexQuery__
 *
 * To run a query within a React component, call `useSuperBrandsIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperBrandsIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperBrandsIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSuperBrandsIndexQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlSuperBrandsIndexQuery, GqlSuperBrandsIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlSuperBrandsIndexQuery, GqlSuperBrandsIndexQueryVariables>(SuperBrandsIndexDocument, options);
      }
export function useSuperBrandsIndexLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlSuperBrandsIndexQuery, GqlSuperBrandsIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlSuperBrandsIndexQuery, GqlSuperBrandsIndexQueryVariables>(SuperBrandsIndexDocument, options);
        }
export type SuperBrandsIndexQueryHookResult = ReturnType<typeof useSuperBrandsIndexQuery>;
export type SuperBrandsIndexLazyQueryHookResult = ReturnType<typeof useSuperBrandsIndexLazyQuery>;
export type SuperBrandsIndexQueryResult = ApolloReactCommon.QueryResult<GqlSuperBrandsIndexQuery, GqlSuperBrandsIndexQueryVariables>;
export const ComputeWithPriceCartV2Document = gql`
    mutation ComputeWithPriceCartV2($priceCartInput: CalculationsInput!) {
  computeWithPriceCartV2(input: $priceCartInput) {
    itemTaxes {
      taxAmount
      taxType
      productId
      feeItemId
      showOnMenu
      showOnCheckout
    }
    cartItemPrices {
      productName
      productId
      quantity
      subtotal
      unitPrice
      pricingTierAdjustment
      pricingTierAdjustmentTotal
      summaryPrice
      menuPrice
      discounts {
        name
        amount
        discountId
        applicationMethod
        isLoyaltyReward
        isPaymentIncentive
      }
      tax
      unitWeightGrams
      productType
    }
    fees {
      feeItemId
      feeAmount
      feeName
      deliveryFee
      paymentFee
    }
    subTotal
    taxes
    discount
    originalTotal
    roundedDifference
    grandTotal
    loyaltyPointsUsed
    rewardValidationErrors {
      discountCode
      discountId
      message
    }
    totalSalesTax
    totalCannabisTax
    totalBottleDepositTax
    taxInclusivePricing
    loyaltyAppliedAsDiscount
    discountWithoutLoyalty
    posCustomerId
    discountGamification {
      gamificationDetails {
        discountId
        satisfiers {
          thresholdType
          minimumThreshold
          products {
            productId
            ecommKey
            amount
          }
        }
      }
    }
  }
}
    `;
export type GqlComputeWithPriceCartV2MutationFn = ApolloReactCommon.MutationFunction<GqlComputeWithPriceCartV2Mutation, GqlComputeWithPriceCartV2MutationVariables>;

/**
 * __useComputeWithPriceCartV2Mutation__
 *
 * To run a mutation, you first call `useComputeWithPriceCartV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComputeWithPriceCartV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [computeWithPriceCartV2Mutation, { data, loading, error }] = useComputeWithPriceCartV2Mutation({
 *   variables: {
 *      priceCartInput: // value for 'priceCartInput'
 *   },
 * });
 */
export function useComputeWithPriceCartV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlComputeWithPriceCartV2Mutation, GqlComputeWithPriceCartV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlComputeWithPriceCartV2Mutation, GqlComputeWithPriceCartV2MutationVariables>(ComputeWithPriceCartV2Document, options);
      }
export type ComputeWithPriceCartV2MutationHookResult = ReturnType<typeof useComputeWithPriceCartV2Mutation>;
export type ComputeWithPriceCartV2MutationResult = ApolloReactCommon.MutationResult<GqlComputeWithPriceCartV2Mutation>;
export type ComputeWithPriceCartV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlComputeWithPriceCartV2Mutation, GqlComputeWithPriceCartV2MutationVariables>;
export const ServerSideCalculationsDocument = gql`
    mutation serverSideCalculations($input: LegacyCalculationsInput!) {
  serverSideCalculations(input: $input) {
    bottleDepositTaxCents
    cannabisTax
    cartSubtotal
    credit
    deliveryFee
    menuTotal
    mixAndMatch
    otherFees
    paymentFee
    paymentIncentives
    reward
    rounding
    subtotal
    tax
    tip
    total
    details {
      basePrice
      basePriceMult
      bogoSavings {
        displayAsPercentDiscount
        individual {
          conditionQuantity
          discountAmount
          discountStacking
          displayAsPercentDiscount
          isDiscountToCartReward
          maxApplicable
          nonStackingBehavior
          specialId
          stackingBehavior
        }
        isDiscountToCartReward
        menuBogoDiscount
        total
      }
      bottleDepositTaxCents
      canonicalEffectivePotencyMg
      enterpriseProductId
      id
      isOnSale
      isVapeTaxed
      key
      menuBasePrice
      menuCannabisTax
      menuIndividualPrice
      menuSaleAdjustment
      menuPrice
      menuSalesTax
      option
      posId
      productBrand
      productBrandId
      productCategory
      productSubcategory
      quantity
      type
      weightInGrams
      weightInMg
      wholesalePrice
      pricingTierData {
        generatedTiersId
        tiersId
        tiersName
        tiers {
          endWeight
          price
          pricePerGram
          startWeight
          weightUOM
        }
      }
      specialData {
        bogoSpecials {
          applyRewardsToConditions
          bogoConditionLogicOperator
          bogoConditions {
            _id
            brandId
            brandIds
            brandName
            brandNames
            categoryIds
            categoryName
            categoryNames
            enterpriseProductIds
            exclusions {
              _id
              brandIds
              brandNames
              categoryIds
              categoryNames
              enterpriseProductIds
              inventoryTags
              matchOperator
              productGroup
              productIds
              productTags
              strainIds
              subcategoryIds
              subcategoryNames
              vendorIds
              weightOperator
              weights
            }
            inventoryTags
            productGroup
            productId
            productIds
            productTags
            quantity
            strainIds
            subcategoryIds
            subcategoryNames
            vendorIds
            weight
            weightOperator
          }
          bogoRewardLogicOperator
          bogoRewards {
            _id
            brandId
            brandIds
            brandName
            brandNames
            categoryIds
            categoryName
            categoryNames
            dollarDiscount
            enterpriseProductIds
            exclusions {
              _id
              brandIds
              brandNames
              categoryIds
              categoryNames
              enterpriseProductIds
              inventoryTags
              matchOperator
              productGroup
              productIds
              productTags
              strainIds
              subcategoryIds
              subcategoryNames
              vendorIds
              weightOperator
              weights
            }
            inventoryTags
            percentDiscount
            productGroup
            productId
            productIds
            productTags
            quantity
            strainIds
            subcategoryIds
            subcategoryNames
            targetPrice
            vendorIds
            weight
          }
          createdBy
          directPOSProductIdMapping
          discountBehavior
          discountBundle {
            _id
            applyTo
            discountType
            enabled
            limit
            value
          }
          discountPrecedence
          discountStacking
          discountToCart {
            _id
            discountType
            enabled
            value
          }
          endStamp
          excludeConditionItemsFromRewards
          excludedProducts {
            conditions {
              _id
              Name
              key
            }
            rewards {
              _id
              Name
              key
            }
          }
          isRecurring
          itemsForAPrice {
            _id
            enabled
            value
          }
          menuType
          minorVersion
          nonStackingBehavior
          paymentRestrictions {
            payByBankSignupIncentive
          }
          rawPOSWeightMapping
          recurringEndDate
          redemptionLimit
          specialId
          specialName
          specialType
          stackingBehavior
          totalQuantity {
            enabled
            maxQuantity
            quantity
            quantityOperator
          }
          totalSpend {
            enabled
            maximumSpend
            minimumSpend
            spendOperator
          }
          totalWeight {
            enabled
            weight
            weightOperator
          }
          version
        }
        saleSpecials {
          createdBy
          directPOSProductIdMapping
          discount
          discountStacking
          dollarDiscount
          eligibleProductOptions
          menuType
          minorVersion
          nonStackingBehavior
          paymentRestrictions {
            payByBankSignupIncentive
          }
          percentDiscount
          rawPOSWeightMapping
          saleDiscounts {
            _id
            brandIds
            brandNames
            categoryIds
            categoryNames
            discountAmount
            discountType
            enterpriseProductIds
            exclusions {
              _id
              brandIds
              brandNames
              categoryIds
              categoryNames
              enterpriseProductIds
              inventoryTags
              matchOperator
              productGroup
              productIds
              productTags
              strainIds
              subcategoryIds
              subcategoryNames
              vendorIds
              weightOperator
              weights
            }
            inventoryTags
            productGroup
            productIds
            productTags
            strainIds
            subcategoryIds
            subcategoryNames
            vendorIds
            weightOperator
            weights
          }
          source
          sourceId
          specialId
          specialName
          specialRestrictions
          specialType
          stackingBehavior
          stackingMode
          targetPrice
          version
        }
      }
    }
    bottleDepositTaxExistence {
      med {
        checkout
        menu
        pos
      }
      rec {
        checkout
        menu
        pos
      }
    }
    cannabisTaxExistence {
      med {
        checkout
        menu
        pos
      }
      rec {
        checkout
        menu
        pos
      }
    }
    lineitems {
      type
      value
    }
    receipt
    salesTaxExistence {
      med {
        checkout
        menu
        pos
      }
      rec {
        checkout
        menu
        pos
      }
    }
  }
}
    `;
export type GqlServerSideCalculationsMutationFn = ApolloReactCommon.MutationFunction<GqlServerSideCalculationsMutation, GqlServerSideCalculationsMutationVariables>;

/**
 * __useServerSideCalculationsMutation__
 *
 * To run a mutation, you first call `useServerSideCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServerSideCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serverSideCalculationsMutation, { data, loading, error }] = useServerSideCalculationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useServerSideCalculationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlServerSideCalculationsMutation, GqlServerSideCalculationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlServerSideCalculationsMutation, GqlServerSideCalculationsMutationVariables>(ServerSideCalculationsDocument, options);
      }
export type ServerSideCalculationsMutationHookResult = ReturnType<typeof useServerSideCalculationsMutation>;
export type ServerSideCalculationsMutationResult = ApolloReactCommon.MutationResult<GqlServerSideCalculationsMutation>;
export type ServerSideCalculationsMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlServerSideCalculationsMutation, GqlServerSideCalculationsMutationVariables>;
export const ComputeWithPriceCartDocument = gql`
    query ComputeWithPriceCart($priceCartInput: CalculationsInput!) {
  computeWithPriceCart(input: $priceCartInput) {
    itemTaxes {
      taxAmount
      taxType
      productId
      feeItemId
      showOnMenu
      showOnCheckout
    }
    cartItemPrices {
      productName
      productId
      quantity
      subtotal
      unitPrice
      pricingTierAdjustment
      pricingTierAdjustmentTotal
      summaryPrice
      menuPrice
      discounts {
        name
        amount
        discountId
        applicationMethod
        isLoyaltyReward
        isPaymentIncentive
      }
      tax
      unitWeightGrams
      productType
    }
    fees {
      feeItemId
      feeAmount
      feeName
      deliveryFee
      paymentFee
    }
    subTotal
    taxes
    discount
    originalTotal
    roundedDifference
    grandTotal
    loyaltyPointsUsed
    rewardValidationErrors {
      discountCode
      discountId
      message
    }
    totalSalesTax
    totalCannabisTax
    totalBottleDepositTax
    taxInclusivePricing
    loyaltyAppliedAsDiscount
    discountWithoutLoyalty
    posCustomerId
  }
}
    `;

/**
 * __useComputeWithPriceCartQuery__
 *
 * To run a query within a React component, call `useComputeWithPriceCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useComputeWithPriceCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComputeWithPriceCartQuery({
 *   variables: {
 *      priceCartInput: // value for 'priceCartInput'
 *   },
 * });
 */
export function useComputeWithPriceCartQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlComputeWithPriceCartQuery, GqlComputeWithPriceCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlComputeWithPriceCartQuery, GqlComputeWithPriceCartQueryVariables>(ComputeWithPriceCartDocument, options);
      }
export function useComputeWithPriceCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlComputeWithPriceCartQuery, GqlComputeWithPriceCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlComputeWithPriceCartQuery, GqlComputeWithPriceCartQueryVariables>(ComputeWithPriceCartDocument, options);
        }
export type ComputeWithPriceCartQueryHookResult = ReturnType<typeof useComputeWithPriceCartQuery>;
export type ComputeWithPriceCartLazyQueryHookResult = ReturnType<typeof useComputeWithPriceCartLazyQuery>;
export type ComputeWithPriceCartQueryResult = ApolloReactCommon.QueryResult<GqlComputeWithPriceCartQuery, GqlComputeWithPriceCartQueryVariables>;
export const GetCannabinoidsDocument = gql`
    query GetCannabinoids {
  getCannabinoids {
    name
    id
  }
}
    `;

/**
 * __useGetCannabinoidsQuery__
 *
 * To run a query within a React component, call `useGetCannabinoidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCannabinoidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCannabinoidsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCannabinoidsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetCannabinoidsQuery, GqlGetCannabinoidsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetCannabinoidsQuery, GqlGetCannabinoidsQueryVariables>(GetCannabinoidsDocument, options);
      }
export function useGetCannabinoidsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetCannabinoidsQuery, GqlGetCannabinoidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetCannabinoidsQuery, GqlGetCannabinoidsQueryVariables>(GetCannabinoidsDocument, options);
        }
export type GetCannabinoidsQueryHookResult = ReturnType<typeof useGetCannabinoidsQuery>;
export type GetCannabinoidsLazyQueryHookResult = ReturnType<typeof useGetCannabinoidsLazyQuery>;
export type GetCannabinoidsQueryResult = ApolloReactCommon.QueryResult<GqlGetCannabinoidsQuery, GqlGetCannabinoidsQueryVariables>;
export const CreateCouponV2Document = gql`
    mutation CreateCouponV2($input: createCouponInput!) {
  createCouponV2(coupon: $input) {
    ...couponFragment
  }
}
    ${CouponFragmentFragmentDoc}`;
export type GqlCreateCouponV2MutationFn = ApolloReactCommon.MutationFunction<GqlCreateCouponV2Mutation, GqlCreateCouponV2MutationVariables>;

/**
 * __useCreateCouponV2Mutation__
 *
 * To run a mutation, you first call `useCreateCouponV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCouponV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCouponV2Mutation, { data, loading, error }] = useCreateCouponV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCouponV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateCouponV2Mutation, GqlCreateCouponV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateCouponV2Mutation, GqlCreateCouponV2MutationVariables>(CreateCouponV2Document, options);
      }
export type CreateCouponV2MutationHookResult = ReturnType<typeof useCreateCouponV2Mutation>;
export type CreateCouponV2MutationResult = ApolloReactCommon.MutationResult<GqlCreateCouponV2Mutation>;
export type CreateCouponV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateCouponV2Mutation, GqlCreateCouponV2MutationVariables>;
export const DeleteCouponDocument = gql`
    mutation DeleteCoupon($id: String!) {
  deleteCoupon(id: $id) {
    success
  }
}
    `;
export type GqlDeleteCouponMutationFn = ApolloReactCommon.MutationFunction<GqlDeleteCouponMutation, GqlDeleteCouponMutationVariables>;

/**
 * __useDeleteCouponMutation__
 *
 * To run a mutation, you first call `useDeleteCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCouponMutation, { data, loading, error }] = useDeleteCouponMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCouponMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlDeleteCouponMutation, GqlDeleteCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlDeleteCouponMutation, GqlDeleteCouponMutationVariables>(DeleteCouponDocument, options);
      }
export type DeleteCouponMutationHookResult = ReturnType<typeof useDeleteCouponMutation>;
export type DeleteCouponMutationResult = ApolloReactCommon.MutationResult<GqlDeleteCouponMutation>;
export type DeleteCouponMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlDeleteCouponMutation, GqlDeleteCouponMutationVariables>;
export const DeleteCouponV2Document = gql`
    mutation DeleteCouponV2($id: String!) {
  deleteCouponV2(id: $id) {
    success
  }
}
    `;
export type GqlDeleteCouponV2MutationFn = ApolloReactCommon.MutationFunction<GqlDeleteCouponV2Mutation, GqlDeleteCouponV2MutationVariables>;

/**
 * __useDeleteCouponV2Mutation__
 *
 * To run a mutation, you first call `useDeleteCouponV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCouponV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCouponV2Mutation, { data, loading, error }] = useDeleteCouponV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCouponV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlDeleteCouponV2Mutation, GqlDeleteCouponV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlDeleteCouponV2Mutation, GqlDeleteCouponV2MutationVariables>(DeleteCouponV2Document, options);
      }
export type DeleteCouponV2MutationHookResult = ReturnType<typeof useDeleteCouponV2Mutation>;
export type DeleteCouponV2MutationResult = ApolloReactCommon.MutationResult<GqlDeleteCouponV2Mutation>;
export type DeleteCouponV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlDeleteCouponV2Mutation, GqlDeleteCouponV2MutationVariables>;
export const UpdateCouponDocument = gql`
    mutation UpdateCoupon($input: updateCouponInput!) {
  updateCoupon(coupon: $input) {
    ...couponFragment
  }
}
    ${CouponFragmentFragmentDoc}`;
export type GqlUpdateCouponMutationFn = ApolloReactCommon.MutationFunction<GqlUpdateCouponMutation, GqlUpdateCouponMutationVariables>;

/**
 * __useUpdateCouponMutation__
 *
 * To run a mutation, you first call `useUpdateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCouponMutation, { data, loading, error }] = useUpdateCouponMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCouponMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateCouponMutation, GqlUpdateCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateCouponMutation, GqlUpdateCouponMutationVariables>(UpdateCouponDocument, options);
      }
export type UpdateCouponMutationHookResult = ReturnType<typeof useUpdateCouponMutation>;
export type UpdateCouponMutationResult = ApolloReactCommon.MutationResult<GqlUpdateCouponMutation>;
export type UpdateCouponMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateCouponMutation, GqlUpdateCouponMutationVariables>;
export const FilteredCouponsDocument = gql`
    query FilteredCoupons($filter: couponsFilterInput, $sort: couponsSortInput, $pagination: couponsPaginationInput) {
  filteredCoupons(filter: $filter, sort: $sort, pagination: $pagination) {
    queryInfo {
      totalCount
    }
    coupons {
      ...couponFragment
      dispensary
      reimbursed
    }
  }
}
    ${CouponFragmentFragmentDoc}`;

/**
 * __useFilteredCouponsQuery__
 *
 * To run a query within a React component, call `useFilteredCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredCouponsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFilteredCouponsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlFilteredCouponsQuery, GqlFilteredCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlFilteredCouponsQuery, GqlFilteredCouponsQueryVariables>(FilteredCouponsDocument, options);
      }
export function useFilteredCouponsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlFilteredCouponsQuery, GqlFilteredCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlFilteredCouponsQuery, GqlFilteredCouponsQueryVariables>(FilteredCouponsDocument, options);
        }
export type FilteredCouponsQueryHookResult = ReturnType<typeof useFilteredCouponsQuery>;
export type FilteredCouponsLazyQueryHookResult = ReturnType<typeof useFilteredCouponsLazyQuery>;
export type FilteredCouponsQueryResult = ApolloReactCommon.QueryResult<GqlFilteredCouponsQuery, GqlFilteredCouponsQueryVariables>;
export const ClearAllCurbsideArrivalsDocument = gql`
    mutation ClearAllCurbsideArrivals($dispensaryId: String!) {
  clearAllCurbsideArrivals(dispensaryId: $dispensaryId) {
    success
  }
}
    `;
export type GqlClearAllCurbsideArrivalsMutationFn = ApolloReactCommon.MutationFunction<GqlClearAllCurbsideArrivalsMutation, GqlClearAllCurbsideArrivalsMutationVariables>;

/**
 * __useClearAllCurbsideArrivalsMutation__
 *
 * To run a mutation, you first call `useClearAllCurbsideArrivalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAllCurbsideArrivalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAllCurbsideArrivalsMutation, { data, loading, error }] = useClearAllCurbsideArrivalsMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useClearAllCurbsideArrivalsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlClearAllCurbsideArrivalsMutation, GqlClearAllCurbsideArrivalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlClearAllCurbsideArrivalsMutation, GqlClearAllCurbsideArrivalsMutationVariables>(ClearAllCurbsideArrivalsDocument, options);
      }
export type ClearAllCurbsideArrivalsMutationHookResult = ReturnType<typeof useClearAllCurbsideArrivalsMutation>;
export type ClearAllCurbsideArrivalsMutationResult = ApolloReactCommon.MutationResult<GqlClearAllCurbsideArrivalsMutation>;
export type ClearAllCurbsideArrivalsMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlClearAllCurbsideArrivalsMutation, GqlClearAllCurbsideArrivalsMutationVariables>;
export const ClearCurbsideArrivalDocument = gql`
    mutation ClearCurbsideArrival($arrivalId: String!) {
  clearCurbsideArrival(arrivalId: $arrivalId) {
    success
  }
}
    `;
export type GqlClearCurbsideArrivalMutationFn = ApolloReactCommon.MutationFunction<GqlClearCurbsideArrivalMutation, GqlClearCurbsideArrivalMutationVariables>;

/**
 * __useClearCurbsideArrivalMutation__
 *
 * To run a mutation, you first call `useClearCurbsideArrivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearCurbsideArrivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearCurbsideArrivalMutation, { data, loading, error }] = useClearCurbsideArrivalMutation({
 *   variables: {
 *      arrivalId: // value for 'arrivalId'
 *   },
 * });
 */
export function useClearCurbsideArrivalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlClearCurbsideArrivalMutation, GqlClearCurbsideArrivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlClearCurbsideArrivalMutation, GqlClearCurbsideArrivalMutationVariables>(ClearCurbsideArrivalDocument, options);
      }
export type ClearCurbsideArrivalMutationHookResult = ReturnType<typeof useClearCurbsideArrivalMutation>;
export type ClearCurbsideArrivalMutationResult = ApolloReactCommon.MutationResult<GqlClearCurbsideArrivalMutation>;
export type ClearCurbsideArrivalMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlClearCurbsideArrivalMutation, GqlClearCurbsideArrivalMutationVariables>;
export const MarkCurbsideArrivalArrivedV2Document = gql`
    mutation MarkCurbsideArrivalArrivedV2($token: String!) {
  markCurbsideArrivalArrivedV2(token: $token) {
    id
  }
}
    `;
export type GqlMarkCurbsideArrivalArrivedV2MutationFn = ApolloReactCommon.MutationFunction<GqlMarkCurbsideArrivalArrivedV2Mutation, GqlMarkCurbsideArrivalArrivedV2MutationVariables>;

/**
 * __useMarkCurbsideArrivalArrivedV2Mutation__
 *
 * To run a mutation, you first call `useMarkCurbsideArrivalArrivedV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCurbsideArrivalArrivedV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCurbsideArrivalArrivedV2Mutation, { data, loading, error }] = useMarkCurbsideArrivalArrivedV2Mutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useMarkCurbsideArrivalArrivedV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlMarkCurbsideArrivalArrivedV2Mutation, GqlMarkCurbsideArrivalArrivedV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlMarkCurbsideArrivalArrivedV2Mutation, GqlMarkCurbsideArrivalArrivedV2MutationVariables>(MarkCurbsideArrivalArrivedV2Document, options);
      }
export type MarkCurbsideArrivalArrivedV2MutationHookResult = ReturnType<typeof useMarkCurbsideArrivalArrivedV2Mutation>;
export type MarkCurbsideArrivalArrivedV2MutationResult = ApolloReactCommon.MutationResult<GqlMarkCurbsideArrivalArrivedV2Mutation>;
export type MarkCurbsideArrivalArrivedV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlMarkCurbsideArrivalArrivedV2Mutation, GqlMarkCurbsideArrivalArrivedV2MutationVariables>;
export const UpdateCurbsideArrivalV2Document = gql`
    mutation UpdateCurbsideArrivalV2($token: String!, $arrivalInformation: String!) {
  updateCurbsideArrivalV2(token: $token, arrivalInformation: $arrivalInformation) {
    id
  }
}
    `;
export type GqlUpdateCurbsideArrivalV2MutationFn = ApolloReactCommon.MutationFunction<GqlUpdateCurbsideArrivalV2Mutation, GqlUpdateCurbsideArrivalV2MutationVariables>;

/**
 * __useUpdateCurbsideArrivalV2Mutation__
 *
 * To run a mutation, you first call `useUpdateCurbsideArrivalV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurbsideArrivalV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurbsideArrivalV2Mutation, { data, loading, error }] = useUpdateCurbsideArrivalV2Mutation({
 *   variables: {
 *      token: // value for 'token'
 *      arrivalInformation: // value for 'arrivalInformation'
 *   },
 * });
 */
export function useUpdateCurbsideArrivalV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateCurbsideArrivalV2Mutation, GqlUpdateCurbsideArrivalV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateCurbsideArrivalV2Mutation, GqlUpdateCurbsideArrivalV2MutationVariables>(UpdateCurbsideArrivalV2Document, options);
      }
export type UpdateCurbsideArrivalV2MutationHookResult = ReturnType<typeof useUpdateCurbsideArrivalV2Mutation>;
export type UpdateCurbsideArrivalV2MutationResult = ApolloReactCommon.MutationResult<GqlUpdateCurbsideArrivalV2Mutation>;
export type UpdateCurbsideArrivalV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateCurbsideArrivalV2Mutation, GqlUpdateCurbsideArrivalV2MutationVariables>;
export const GetCurbsideArrivalByTokenDocument = gql`
    query GetCurbsideArrivalByToken($token: String!) {
  getCurbsideArrivalByToken(token: $token) {
    id
    dispensary {
      id
      phone
      orderTypesConfigV2 {
        curbsidePickup {
          arrivalInformationInstructions
        }
      }
    }
    arrivalInformation
    arrivedAt
    clearedAt
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCurbsideArrivalByTokenQuery__
 *
 * To run a query within a React component, call `useGetCurbsideArrivalByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurbsideArrivalByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurbsideArrivalByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetCurbsideArrivalByTokenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetCurbsideArrivalByTokenQuery, GqlGetCurbsideArrivalByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetCurbsideArrivalByTokenQuery, GqlGetCurbsideArrivalByTokenQueryVariables>(GetCurbsideArrivalByTokenDocument, options);
      }
export function useGetCurbsideArrivalByTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetCurbsideArrivalByTokenQuery, GqlGetCurbsideArrivalByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetCurbsideArrivalByTokenQuery, GqlGetCurbsideArrivalByTokenQueryVariables>(GetCurbsideArrivalByTokenDocument, options);
        }
export type GetCurbsideArrivalByTokenQueryHookResult = ReturnType<typeof useGetCurbsideArrivalByTokenQuery>;
export type GetCurbsideArrivalByTokenLazyQueryHookResult = ReturnType<typeof useGetCurbsideArrivalByTokenLazyQuery>;
export type GetCurbsideArrivalByTokenQueryResult = ApolloReactCommon.QueryResult<GqlGetCurbsideArrivalByTokenQuery, GqlGetCurbsideArrivalByTokenQueryVariables>;
export const GetCurbsideArrivalsForBannerDocument = gql`
    query GetCurbsideArrivalsForBanner($dispensaryId: String!) {
  getCurbsideArrivals(dispensaryId: $dispensaryId) {
    id
  }
}
    `;

/**
 * __useGetCurbsideArrivalsForBannerQuery__
 *
 * To run a query within a React component, call `useGetCurbsideArrivalsForBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurbsideArrivalsForBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurbsideArrivalsForBannerQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetCurbsideArrivalsForBannerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetCurbsideArrivalsForBannerQuery, GqlGetCurbsideArrivalsForBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetCurbsideArrivalsForBannerQuery, GqlGetCurbsideArrivalsForBannerQueryVariables>(GetCurbsideArrivalsForBannerDocument, options);
      }
export function useGetCurbsideArrivalsForBannerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetCurbsideArrivalsForBannerQuery, GqlGetCurbsideArrivalsForBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetCurbsideArrivalsForBannerQuery, GqlGetCurbsideArrivalsForBannerQueryVariables>(GetCurbsideArrivalsForBannerDocument, options);
        }
export type GetCurbsideArrivalsForBannerQueryHookResult = ReturnType<typeof useGetCurbsideArrivalsForBannerQuery>;
export type GetCurbsideArrivalsForBannerLazyQueryHookResult = ReturnType<typeof useGetCurbsideArrivalsForBannerLazyQuery>;
export type GetCurbsideArrivalsForBannerQueryResult = ApolloReactCommon.QueryResult<GqlGetCurbsideArrivalsForBannerQuery, GqlGetCurbsideArrivalsForBannerQueryVariables>;
export const GetCurbsideArrivalsDocument = gql`
    query GetCurbsideArrivals($dispensaryId: String!) {
  getCurbsideArrivals(dispensaryId: $dispensaryId) {
    id
    order {
      id
      orderId
      customer {
        profile {
          firstName
          lastName
          phone
        }
      }
      guestCustomer {
        firstName
        lastName
        phone
      }
    }
    arrivalInformation
    arrivedAt
    clearedAt
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCurbsideArrivalsQuery__
 *
 * To run a query within a React component, call `useGetCurbsideArrivalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurbsideArrivalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurbsideArrivalsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetCurbsideArrivalsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetCurbsideArrivalsQuery, GqlGetCurbsideArrivalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetCurbsideArrivalsQuery, GqlGetCurbsideArrivalsQueryVariables>(GetCurbsideArrivalsDocument, options);
      }
export function useGetCurbsideArrivalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetCurbsideArrivalsQuery, GqlGetCurbsideArrivalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetCurbsideArrivalsQuery, GqlGetCurbsideArrivalsQueryVariables>(GetCurbsideArrivalsDocument, options);
        }
export type GetCurbsideArrivalsQueryHookResult = ReturnType<typeof useGetCurbsideArrivalsQuery>;
export type GetCurbsideArrivalsLazyQueryHookResult = ReturnType<typeof useGetCurbsideArrivalsLazyQuery>;
export type GetCurbsideArrivalsQueryResult = ApolloReactCommon.QueryResult<GqlGetCurbsideArrivalsQuery, GqlGetCurbsideArrivalsQueryVariables>;
export const UpdateCustomerSubscriptionDocument = gql`
    mutation UpdateCustomerSubscription($customerId: String!, $subscribed: Boolean!) {
  updateCustomerSubscription(customerId: $customerId, subscribed: $subscribed) {
    success
  }
}
    `;
export type GqlUpdateCustomerSubscriptionMutationFn = ApolloReactCommon.MutationFunction<GqlUpdateCustomerSubscriptionMutation, GqlUpdateCustomerSubscriptionMutationVariables>;

/**
 * __useUpdateCustomerSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerSubscriptionMutation, { data, loading, error }] = useUpdateCustomerSubscriptionMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      subscribed: // value for 'subscribed'
 *   },
 * });
 */
export function useUpdateCustomerSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateCustomerSubscriptionMutation, GqlUpdateCustomerSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateCustomerSubscriptionMutation, GqlUpdateCustomerSubscriptionMutationVariables>(UpdateCustomerSubscriptionDocument, options);
      }
export type UpdateCustomerSubscriptionMutationHookResult = ReturnType<typeof useUpdateCustomerSubscriptionMutation>;
export type UpdateCustomerSubscriptionMutationResult = ApolloReactCommon.MutationResult<GqlUpdateCustomerSubscriptionMutation>;
export type UpdateCustomerSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateCustomerSubscriptionMutation, GqlUpdateCustomerSubscriptionMutationVariables>;
export const GetDevicesDocument = gql`
    query GetDevices($dispensaryId: String!) {
  getDevices(dispensaryId: $dispensaryId) {
    ...deviceFragment
  }
}
    ${DeviceFragmentFragmentDoc}`;

/**
 * __useGetDevicesQuery__
 *
 * To run a query within a React component, call `useGetDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevicesQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetDevicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetDevicesQuery, GqlGetDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetDevicesQuery, GqlGetDevicesQueryVariables>(GetDevicesDocument, options);
      }
export function useGetDevicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetDevicesQuery, GqlGetDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetDevicesQuery, GqlGetDevicesQueryVariables>(GetDevicesDocument, options);
        }
export type GetDevicesQueryHookResult = ReturnType<typeof useGetDevicesQuery>;
export type GetDevicesLazyQueryHookResult = ReturnType<typeof useGetDevicesLazyQuery>;
export type GetDevicesQueryResult = ApolloReactCommon.QueryResult<GqlGetDevicesQuery, GqlGetDevicesQueryVariables>;
export const GetKioskTerminalsDocument = gql`
    query GetKioskTerminals($dispensaryId: String!) {
  getKioskTerminals(dispensaryId: $dispensaryId) {
    id
    dispensaryId
    nickname
  }
}
    `;

/**
 * __useGetKioskTerminalsQuery__
 *
 * To run a query within a React component, call `useGetKioskTerminalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKioskTerminalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKioskTerminalsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetKioskTerminalsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetKioskTerminalsQuery, GqlGetKioskTerminalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetKioskTerminalsQuery, GqlGetKioskTerminalsQueryVariables>(GetKioskTerminalsDocument, options);
      }
export function useGetKioskTerminalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetKioskTerminalsQuery, GqlGetKioskTerminalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetKioskTerminalsQuery, GqlGetKioskTerminalsQueryVariables>(GetKioskTerminalsDocument, options);
        }
export type GetKioskTerminalsQueryHookResult = ReturnType<typeof useGetKioskTerminalsQuery>;
export type GetKioskTerminalsLazyQueryHookResult = ReturnType<typeof useGetKioskTerminalsLazyQuery>;
export type GetKioskTerminalsQueryResult = ApolloReactCommon.QueryResult<GqlGetKioskTerminalsQuery, GqlGetKioskTerminalsQueryVariables>;
export const AddSubscriptionToChainDocument = gql`
    mutation AddSubscriptionToChain($dispensaryIds: [String]!, $chargebeeCustomerId: String!) {
  addSubscriptionToChain(
    dispensaryIds: $dispensaryIds
    chargebeeCustomerId: $chargebeeCustomerId
  ) {
    message
    success
  }
}
    `;
export type GqlAddSubscriptionToChainMutationFn = ApolloReactCommon.MutationFunction<GqlAddSubscriptionToChainMutation, GqlAddSubscriptionToChainMutationVariables>;

/**
 * __useAddSubscriptionToChainMutation__
 *
 * To run a mutation, you first call `useAddSubscriptionToChainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSubscriptionToChainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSubscriptionToChainMutation, { data, loading, error }] = useAddSubscriptionToChainMutation({
 *   variables: {
 *      dispensaryIds: // value for 'dispensaryIds'
 *      chargebeeCustomerId: // value for 'chargebeeCustomerId'
 *   },
 * });
 */
export function useAddSubscriptionToChainMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlAddSubscriptionToChainMutation, GqlAddSubscriptionToChainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlAddSubscriptionToChainMutation, GqlAddSubscriptionToChainMutationVariables>(AddSubscriptionToChainDocument, options);
      }
export type AddSubscriptionToChainMutationHookResult = ReturnType<typeof useAddSubscriptionToChainMutation>;
export type AddSubscriptionToChainMutationResult = ApolloReactCommon.MutationResult<GqlAddSubscriptionToChainMutation>;
export type AddSubscriptionToChainMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlAddSubscriptionToChainMutation, GqlAddSubscriptionToChainMutationVariables>;
export const RemoveSubscriptionFromChainDocument = gql`
    mutation RemoveSubscriptionFromChain($ids: [String]!, $chargebeeCustomerId: String!) {
  removeSubscriptionFromChain(
    ids: $ids
    chargebeeCustomerId: $chargebeeCustomerId
  ) {
    message
    success
  }
}
    `;
export type GqlRemoveSubscriptionFromChainMutationFn = ApolloReactCommon.MutationFunction<GqlRemoveSubscriptionFromChainMutation, GqlRemoveSubscriptionFromChainMutationVariables>;

/**
 * __useRemoveSubscriptionFromChainMutation__
 *
 * To run a mutation, you first call `useRemoveSubscriptionFromChainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSubscriptionFromChainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSubscriptionFromChainMutation, { data, loading, error }] = useRemoveSubscriptionFromChainMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      chargebeeCustomerId: // value for 'chargebeeCustomerId'
 *   },
 * });
 */
export function useRemoveSubscriptionFromChainMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlRemoveSubscriptionFromChainMutation, GqlRemoveSubscriptionFromChainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlRemoveSubscriptionFromChainMutation, GqlRemoveSubscriptionFromChainMutationVariables>(RemoveSubscriptionFromChainDocument, options);
      }
export type RemoveSubscriptionFromChainMutationHookResult = ReturnType<typeof useRemoveSubscriptionFromChainMutation>;
export type RemoveSubscriptionFromChainMutationResult = ApolloReactCommon.MutationResult<GqlRemoveSubscriptionFromChainMutation>;
export type RemoveSubscriptionFromChainMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlRemoveSubscriptionFromChainMutation, GqlRemoveSubscriptionFromChainMutationVariables>;
export const GetChainBillingInfoDocument = gql`
    query GetChainBillingInfo($dispensaries: [String!]) {
  getBillingSubscriptions(dispensaries: $dispensaries) {
    dispensaryBilling {
      chain
      chargebeeCustomerId
    }
  }
}
    `;

/**
 * __useGetChainBillingInfoQuery__
 *
 * To run a query within a React component, call `useGetChainBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChainBillingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChainBillingInfoQuery({
 *   variables: {
 *      dispensaries: // value for 'dispensaries'
 *   },
 * });
 */
export function useGetChainBillingInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetChainBillingInfoQuery, GqlGetChainBillingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetChainBillingInfoQuery, GqlGetChainBillingInfoQueryVariables>(GetChainBillingInfoDocument, options);
      }
export function useGetChainBillingInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetChainBillingInfoQuery, GqlGetChainBillingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetChainBillingInfoQuery, GqlGetChainBillingInfoQueryVariables>(GetChainBillingInfoDocument, options);
        }
export type GetChainBillingInfoQueryHookResult = ReturnType<typeof useGetChainBillingInfoQuery>;
export type GetChainBillingInfoLazyQueryHookResult = ReturnType<typeof useGetChainBillingInfoLazyQuery>;
export type GetChainBillingInfoQueryResult = ApolloReactCommon.QueryResult<GqlGetChainBillingInfoQuery, GqlGetChainBillingInfoQueryVariables>;
export const GetSubscriptionsForChainDocument = gql`
    query GetSubscriptionsForChain($dispensaries: [String!]) {
  getBillingSubscriptions(dispensaries: $dispensaries) {
    dispensaryBilling {
      chain
      chargebeeCustomer {
        company
      }
    }
  }
}
    `;

/**
 * __useGetSubscriptionsForChainQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionsForChainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsForChainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsForChainQuery({
 *   variables: {
 *      dispensaries: // value for 'dispensaries'
 *   },
 * });
 */
export function useGetSubscriptionsForChainQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetSubscriptionsForChainQuery, GqlGetSubscriptionsForChainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetSubscriptionsForChainQuery, GqlGetSubscriptionsForChainQueryVariables>(GetSubscriptionsForChainDocument, options);
      }
export function useGetSubscriptionsForChainLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetSubscriptionsForChainQuery, GqlGetSubscriptionsForChainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetSubscriptionsForChainQuery, GqlGetSubscriptionsForChainQueryVariables>(GetSubscriptionsForChainDocument, options);
        }
export type GetSubscriptionsForChainQueryHookResult = ReturnType<typeof useGetSubscriptionsForChainQuery>;
export type GetSubscriptionsForChainLazyQueryHookResult = ReturnType<typeof useGetSubscriptionsForChainLazyQuery>;
export type GetSubscriptionsForChainQueryResult = ApolloReactCommon.QueryResult<GqlGetSubscriptionsForChainQuery, GqlGetSubscriptionsForChainQueryVariables>;
export const GetSubscriptionsV2Document = gql`
    query GetSubscriptionsV2($retailers: [RetailerInput]!) {
  getSubscriptionsV2(retailers: $retailers) {
    dispensaryBilling {
      chain
      chargebeeCustomer {
        id
        company
        contacts {
          email
          sendBillingEmail
        }
        locationCount
      }
      ...GetSubscriptionsV2PaymentSources
    }
    chargebeeSubscription {
      status
      trialStart
      trialEnd
      currentTermStart
      currentTermEnd
      nextBillingAt
      createdAt
      startedAt
      activatedAt
      invoices {
        id
        total
        lineItems {
          dateFrom
          dateTo
          quantity
          amount
        }
        status
        amountPaid
        amountDue
        creditsApplied
      }
      planAmount
    }
    manualPayments
    chargebeePlan {
      period
      periodUnit
    }
    retailerId
  }
}
    ${GetSubscriptionsV2PaymentSourcesFragmentDoc}`;

/**
 * __useGetSubscriptionsV2Query__
 *
 * To run a query within a React component, call `useGetSubscriptionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsV2Query({
 *   variables: {
 *      retailers: // value for 'retailers'
 *   },
 * });
 */
export function useGetSubscriptionsV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetSubscriptionsV2Query, GqlGetSubscriptionsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetSubscriptionsV2Query, GqlGetSubscriptionsV2QueryVariables>(GetSubscriptionsV2Document, options);
      }
export function useGetSubscriptionsV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetSubscriptionsV2Query, GqlGetSubscriptionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetSubscriptionsV2Query, GqlGetSubscriptionsV2QueryVariables>(GetSubscriptionsV2Document, options);
        }
export type GetSubscriptionsV2QueryHookResult = ReturnType<typeof useGetSubscriptionsV2Query>;
export type GetSubscriptionsV2LazyQueryHookResult = ReturnType<typeof useGetSubscriptionsV2LazyQuery>;
export type GetSubscriptionsV2QueryResult = ApolloReactCommon.QueryResult<GqlGetSubscriptionsV2Query, GqlGetSubscriptionsV2QueryVariables>;
export const GetSubscriptionsDocument = gql`
    query GetSubscriptions($dispensaries: [String!]) {
  getBillingSubscriptions(dispensaries: $dispensaries) {
    dispensaryBilling {
      chain
      chargebeeCustomerId
      chargebeeCustomer {
        company
        contacts {
          email
          sendBillingEmail
        }
        locationCount
      }
      paymentSources {
        card {
          brand
          last4
        }
        type
      }
    }
    dispensaryId
    chargebeeSubscriptionId
    chargebeeSubscription {
      status
      trialStart
      trialEnd
      currentTermStart
      currentTermEnd
      nextBillingAt
      createdAt
      startedAt
      activatedAt
      invoices {
        id
        total
        lineItems {
          dateFrom
          dateTo
          quantity
          amount
        }
        status
        amountPaid
        amountDue
        creditsApplied
      }
      planAmount
    }
    manualPayments
    chargebeePlan {
      period
      periodUnit
    }
  }
}
    `;

/**
 * __useGetSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsQuery({
 *   variables: {
 *      dispensaries: // value for 'dispensaries'
 *   },
 * });
 */
export function useGetSubscriptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetSubscriptionsQuery, GqlGetSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetSubscriptionsQuery, GqlGetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
      }
export function useGetSubscriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetSubscriptionsQuery, GqlGetSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetSubscriptionsQuery, GqlGetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
        }
export type GetSubscriptionsQueryHookResult = ReturnType<typeof useGetSubscriptionsQuery>;
export type GetSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionsLazyQuery>;
export type GetSubscriptionsQueryResult = ApolloReactCommon.QueryResult<GqlGetSubscriptionsQuery, GqlGetSubscriptionsQueryVariables>;
export const DispensaryOnboardingDocument = gql`
    mutation DispensaryOnboarding($input: dispensaryOnboardingInput!) {
  dispensaryOnboarding(input: $input) {
    success
  }
}
    `;
export type GqlDispensaryOnboardingMutationFn = ApolloReactCommon.MutationFunction<GqlDispensaryOnboardingMutation, GqlDispensaryOnboardingMutationVariables>;

/**
 * __useDispensaryOnboardingMutation__
 *
 * To run a mutation, you first call `useDispensaryOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispensaryOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispensaryOnboardingMutation, { data, loading, error }] = useDispensaryOnboardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDispensaryOnboardingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlDispensaryOnboardingMutation, GqlDispensaryOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlDispensaryOnboardingMutation, GqlDispensaryOnboardingMutationVariables>(DispensaryOnboardingDocument, options);
      }
export type DispensaryOnboardingMutationHookResult = ReturnType<typeof useDispensaryOnboardingMutation>;
export type DispensaryOnboardingMutationResult = ApolloReactCommon.MutationResult<GqlDispensaryOnboardingMutation>;
export type DispensaryOnboardingMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlDispensaryOnboardingMutation, GqlDispensaryOnboardingMutationVariables>;
export const DispensaryUploadOnboardingAssetDocument = gql`
    mutation DispensaryUploadOnboardingAsset($data: String!, $fileName: String!) {
  dispensaryUploadOnboardingAsset(data: $data, fileName: $fileName) {
    fileIds
  }
}
    `;
export type GqlDispensaryUploadOnboardingAssetMutationFn = ApolloReactCommon.MutationFunction<GqlDispensaryUploadOnboardingAssetMutation, GqlDispensaryUploadOnboardingAssetMutationVariables>;

/**
 * __useDispensaryUploadOnboardingAssetMutation__
 *
 * To run a mutation, you first call `useDispensaryUploadOnboardingAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispensaryUploadOnboardingAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispensaryUploadOnboardingAssetMutation, { data, loading, error }] = useDispensaryUploadOnboardingAssetMutation({
 *   variables: {
 *      data: // value for 'data'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useDispensaryUploadOnboardingAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlDispensaryUploadOnboardingAssetMutation, GqlDispensaryUploadOnboardingAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlDispensaryUploadOnboardingAssetMutation, GqlDispensaryUploadOnboardingAssetMutationVariables>(DispensaryUploadOnboardingAssetDocument, options);
      }
export type DispensaryUploadOnboardingAssetMutationHookResult = ReturnType<typeof useDispensaryUploadOnboardingAssetMutation>;
export type DispensaryUploadOnboardingAssetMutationResult = ApolloReactCommon.MutationResult<GqlDispensaryUploadOnboardingAssetMutation>;
export type DispensaryUploadOnboardingAssetMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlDispensaryUploadOnboardingAssetMutation, GqlDispensaryUploadOnboardingAssetMutationVariables>;
export const GetAddressBasedDispensaryDataDocument = gql`
    query GetAddressBasedDispensaryData($input: getDeliveryInfoInput) {
  getAddressBasedDispensaryData(input: $input) {
    deliveryInfo {
      deliveryAreaId
      withinBounds
      fee
      minimum
      feeVaries
      minimumVaries
    }
    taxes {
      ...taxProperties
      destinationRate
    }
  }
}
    ${TaxPropertiesFragmentDoc}`;

/**
 * __useGetAddressBasedDispensaryDataQuery__
 *
 * To run a query within a React component, call `useGetAddressBasedDispensaryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressBasedDispensaryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressBasedDispensaryDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAddressBasedDispensaryDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetAddressBasedDispensaryDataQuery, GqlGetAddressBasedDispensaryDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetAddressBasedDispensaryDataQuery, GqlGetAddressBasedDispensaryDataQueryVariables>(GetAddressBasedDispensaryDataDocument, options);
      }
export function useGetAddressBasedDispensaryDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetAddressBasedDispensaryDataQuery, GqlGetAddressBasedDispensaryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetAddressBasedDispensaryDataQuery, GqlGetAddressBasedDispensaryDataQueryVariables>(GetAddressBasedDispensaryDataDocument, options);
        }
export type GetAddressBasedDispensaryDataQueryHookResult = ReturnType<typeof useGetAddressBasedDispensaryDataQuery>;
export type GetAddressBasedDispensaryDataLazyQueryHookResult = ReturnType<typeof useGetAddressBasedDispensaryDataLazyQuery>;
export type GetAddressBasedDispensaryDataQueryResult = ApolloReactCommon.QueryResult<GqlGetAddressBasedDispensaryDataQuery, GqlGetAddressBasedDispensaryDataQueryVariables>;
export const DispensarySearchDocument = gql`
    query DispensarySearch($dispensaryFilter: dispensariesFilterInput!) {
  filteredDispensaries(filter: $dispensaryFilter) {
    id
    name
    cName
    status
    recDispensary
    medicalDispensary
    offerPickup
    offerCurbsidePickup
    offerDriveThruPickup
    offerAnyPickupService
    offerDelivery
    listImage
    location {
      city
      county
      geometry {
        coordinates
        type
      }
      ln1
      ln2
      state
      zipcode
      country
    }
    actionEstimates {
      delivery {
        readyInMinutes
        rangeInMinutes
        deliveryTimeInMinutes
      }
      pickup {
        readyInMinutes
        rangeInMinutes
      }
    }
    durationEstimateOverrides {
      pickup {
        enabled
        lowInMinutes
        highInMinutes
      }
      delivery {
        enabled
        lowInMinutes
        highInMinutes
      }
    }
    storeSettings {
      enableAfterHoursOrderingForPickup
      enableAfterHoursOrderingForDelivery
      enableScheduledOrderingForPickup
      enableScheduledOrderingForDelivery
    }
    featureFlags {
      hideDeliveryEstimate
    }
    effectiveHours {
      deliveryHours {
        ...hourSetFragment
      }
      pickupHours {
        ...hourSetFragment
      }
    }
    deliveryHours {
      ...hourSetFragment
    }
    deliveryInfo {
      withinBounds
      fee
      minimum
      feeVaries
      minimumVaries
      feeType
      percentFee
    }
    feeTiers {
      fee
      feeType
      max
      min
      percentFee
    }
    pickupHours {
      ...hourSetFragment
    }
    specialHours {
      name
      startDate
      endDate
      hoursPerDay {
        date
        pickupHours {
          active
          start
          end
        }
        deliveryHours {
          active
          start
          end
        }
      }
    }
    distance
    maxDeliveryDistance
    timezone
    orderTypesConfig {
      pickup {
        enabled
        paymentTypes {
          alt36
          check
          creditCardAtDoor
          payOnlineChase
          payOnlineHypur
          payOnlineMerrco
          payOnlineMoneris
          creditCardByPhone
          debit
          cash
          linx
          canPay
          paytender
          aeropay
          dutchiePay
          rethinkPay
        }
      }
      curbsidePickup {
        enabled
        paymentTypes {
          alt36
          check
          creditCardAtDoor
          payOnlineChase
          payOnlineHypur
          payOnlineMerrco
          payOnlineMoneris
          creditCardByPhone
          debit
          cash
          linx
          canPay
          paytender
          aeropay
          dutchiePay
          rethinkPay
        }
      }
      driveThruPickup {
        enabled
        paymentTypes {
          alt36
          check
          creditCardAtDoor
          payOnlineChase
          payOnlineHypur
          payOnlineMerrco
          payOnlineMoneris
          creditCardByPhone
          debit
          cash
          linx
          canPay
          paytender
          aeropay
          dutchiePay
          rethinkPay
        }
      }
      delivery {
        enabled
        paymentTypes {
          alt36
          check
          creditCardAtDoor
          payOnlineChase
          payOnlineHypur
          payOnlineMerrco
          payOnlineMoneris
          creditCardByPhone
          debit
          cash
          linx
          canPay
          paytender
          aeropay
          dutchiePay
          rethinkPay
        }
      }
      kiosk {
        enabled
        paymentTypes {
          alt36
          check
          creditCardAtDoor
          payOnlineChase
          payOnlineHypur
          payOnlineMerrco
          payOnlineMoneris
          creditCardByPhone
          debit
          cash
          linx
          canPay
          paytender
          aeropay
          dutchiePay
          rethinkPay
        }
      }
      offerAnyPickupService
      offerDeliveryService
    }
    orderTypesConfigV2 {
      inStorePickup {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      curbsidePickup {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      driveThruPickup {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      delivery {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      offerAnyPickupService
      offerDeliveryService
    }
    hoursSettings {
      inStorePickup {
        ...hoursSettingsForOrderTypeFragment
      }
      curbsidePickup {
        ...hoursSettingsForOrderTypeFragment
      }
      driveThruPickup {
        ...hoursSettingsForOrderTypeFragment
      }
      delivery {
        ...hoursSettingsForOrderTypeFragment
      }
    }
    enabledOrderTypes {
      pickup
      inStorePickup
      curbsidePickup
      driveThruPickup
      delivery
      kiosk
    }
    paymentTypesAccepted {
      alt36
      check
      creditCardAtDoor
      payOnlineChase
      payOnlineHypur
      payOnlineMerrco
      payOnlineMoneris
      creditCardByPhone
      debit
      cash
      linx
      canPay
      paytender
      aeropay
      dutchiePay
      rethinkPay
    }
  }
}
    ${HourSetFragmentFragmentDoc}
${HoursSettingsForOrderTypeFragmentFragmentDoc}`;

/**
 * __useDispensarySearchQuery__
 *
 * To run a query within a React component, call `useDispensarySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispensarySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispensarySearchQuery({
 *   variables: {
 *      dispensaryFilter: // value for 'dispensaryFilter'
 *   },
 * });
 */
export function useDispensarySearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlDispensarySearchQuery, GqlDispensarySearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlDispensarySearchQuery, GqlDispensarySearchQueryVariables>(DispensarySearchDocument, options);
      }
export function useDispensarySearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlDispensarySearchQuery, GqlDispensarySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlDispensarySearchQuery, GqlDispensarySearchQueryVariables>(DispensarySearchDocument, options);
        }
export type DispensarySearchQueryHookResult = ReturnType<typeof useDispensarySearchQuery>;
export type DispensarySearchLazyQueryHookResult = ReturnType<typeof useDispensarySearchLazyQuery>;
export type DispensarySearchQueryResult = ApolloReactCommon.QueryResult<GqlDispensarySearchQuery, GqlDispensarySearchQueryVariables>;
export const UpdateEnterpriseMobileAppSettingsDocument = gql`
    mutation UpdateEnterpriseMobileAppSettings($enterpriseId: ID!, $input: EnterpriseMobileAppSettingsInput) {
  updateEnterpriseMobileAppSettings(enterpriseId: $enterpriseId, input: $input) {
    androidAppIcon
    androidExistingVersion
    androidExistingVersionCode
    androidPackageName
    androidSplashBackgroundColor
    buildForIpad
    firebaseProjectId
    headerImage
    iosAppIcon
    iosAppStoreId
    iosBundleIdentifier
    iosExistingVersion
    iosSplashBackgroundColor
    iosTeamId
    iosTeamName
    name
    shortName
  }
}
    `;
export type GqlUpdateEnterpriseMobileAppSettingsMutationFn = ApolloReactCommon.MutationFunction<GqlUpdateEnterpriseMobileAppSettingsMutation, GqlUpdateEnterpriseMobileAppSettingsMutationVariables>;

/**
 * __useUpdateEnterpriseMobileAppSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEnterpriseMobileAppSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnterpriseMobileAppSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnterpriseMobileAppSettingsMutation, { data, loading, error }] = useUpdateEnterpriseMobileAppSettingsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnterpriseMobileAppSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateEnterpriseMobileAppSettingsMutation, GqlUpdateEnterpriseMobileAppSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateEnterpriseMobileAppSettingsMutation, GqlUpdateEnterpriseMobileAppSettingsMutationVariables>(UpdateEnterpriseMobileAppSettingsDocument, options);
      }
export type UpdateEnterpriseMobileAppSettingsMutationHookResult = ReturnType<typeof useUpdateEnterpriseMobileAppSettingsMutation>;
export type UpdateEnterpriseMobileAppSettingsMutationResult = ApolloReactCommon.MutationResult<GqlUpdateEnterpriseMobileAppSettingsMutation>;
export type UpdateEnterpriseMobileAppSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateEnterpriseMobileAppSettingsMutation, GqlUpdateEnterpriseMobileAppSettingsMutationVariables>;
export const EnterpriseMobileAppSettingsDocument = gql`
    query EnterpriseMobileAppSettings($enterpriseId: ID!) {
  enterpriseMobileAppSettings(enterpriseId: $enterpriseId) {
    androidAppIcon
    androidPackageName
    androidSplashBackgroundColor
    iosAppIcon
    iosAppStoreId
    iosBundleIdentifier
    iosSplashBackgroundColor
  }
}
    `;

/**
 * __useEnterpriseMobileAppSettingsQuery__
 *
 * To run a query within a React component, call `useEnterpriseMobileAppSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseMobileAppSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseMobileAppSettingsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseMobileAppSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlEnterpriseMobileAppSettingsQuery, GqlEnterpriseMobileAppSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlEnterpriseMobileAppSettingsQuery, GqlEnterpriseMobileAppSettingsQueryVariables>(EnterpriseMobileAppSettingsDocument, options);
      }
export function useEnterpriseMobileAppSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlEnterpriseMobileAppSettingsQuery, GqlEnterpriseMobileAppSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlEnterpriseMobileAppSettingsQuery, GqlEnterpriseMobileAppSettingsQueryVariables>(EnterpriseMobileAppSettingsDocument, options);
        }
export type EnterpriseMobileAppSettingsQueryHookResult = ReturnType<typeof useEnterpriseMobileAppSettingsQuery>;
export type EnterpriseMobileAppSettingsLazyQueryHookResult = ReturnType<typeof useEnterpriseMobileAppSettingsLazyQuery>;
export type EnterpriseMobileAppSettingsQueryResult = ApolloReactCommon.QueryResult<GqlEnterpriseMobileAppSettingsQuery, GqlEnterpriseMobileAppSettingsQueryVariables>;
export const AdminEnterpriseMobileAppSettingsDocument = gql`
    query AdminEnterpriseMobileAppSettings($enterpriseId: ID!) {
  enterpriseMobileAppSettings(enterpriseId: $enterpriseId) {
    androidAppIcon
    androidExistingVersion
    androidExistingVersionCode
    androidPackageName
    androidSplashBackgroundColor
    buildForIpad
    firebaseProjectId
    headerImage
    iosAppIcon
    iosAppStoreId
    iosBundleIdentifier
    iosExistingVersion
    iosSplashBackgroundColor
    iosTeamId
    iosTeamName
    name
    shortName
  }
}
    `;

/**
 * __useAdminEnterpriseMobileAppSettingsQuery__
 *
 * To run a query within a React component, call `useAdminEnterpriseMobileAppSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEnterpriseMobileAppSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEnterpriseMobileAppSettingsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useAdminEnterpriseMobileAppSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlAdminEnterpriseMobileAppSettingsQuery, GqlAdminEnterpriseMobileAppSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlAdminEnterpriseMobileAppSettingsQuery, GqlAdminEnterpriseMobileAppSettingsQueryVariables>(AdminEnterpriseMobileAppSettingsDocument, options);
      }
export function useAdminEnterpriseMobileAppSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlAdminEnterpriseMobileAppSettingsQuery, GqlAdminEnterpriseMobileAppSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlAdminEnterpriseMobileAppSettingsQuery, GqlAdminEnterpriseMobileAppSettingsQueryVariables>(AdminEnterpriseMobileAppSettingsDocument, options);
        }
export type AdminEnterpriseMobileAppSettingsQueryHookResult = ReturnType<typeof useAdminEnterpriseMobileAppSettingsQuery>;
export type AdminEnterpriseMobileAppSettingsLazyQueryHookResult = ReturnType<typeof useAdminEnterpriseMobileAppSettingsLazyQuery>;
export type AdminEnterpriseMobileAppSettingsQueryResult = ApolloReactCommon.QueryResult<GqlAdminEnterpriseMobileAppSettingsQuery, GqlAdminEnterpriseMobileAppSettingsQueryVariables>;
export const GeolocateConsumerDocument = gql`
    query GeolocateConsumer {
  geolocate {
    ip
    hostname
    city
    region
    country
    loc
    org
    postal
    timezone
  }
}
    `;

/**
 * __useGeolocateConsumerQuery__
 *
 * To run a query within a React component, call `useGeolocateConsumerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeolocateConsumerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeolocateConsumerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGeolocateConsumerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGeolocateConsumerQuery, GqlGeolocateConsumerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGeolocateConsumerQuery, GqlGeolocateConsumerQueryVariables>(GeolocateConsumerDocument, options);
      }
export function useGeolocateConsumerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGeolocateConsumerQuery, GqlGeolocateConsumerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGeolocateConsumerQuery, GqlGeolocateConsumerQueryVariables>(GeolocateConsumerDocument, options);
        }
export type GeolocateConsumerQueryHookResult = ReturnType<typeof useGeolocateConsumerQuery>;
export type GeolocateConsumerLazyQueryHookResult = ReturnType<typeof useGeolocateConsumerLazyQuery>;
export type GeolocateConsumerQueryResult = ApolloReactCommon.QueryResult<GqlGeolocateConsumerQuery, GqlGeolocateConsumerQueryVariables>;
export const GenerateHypurTokenV2Document = gql`
    mutation GenerateHypurTokenV2($code: String!, $hostname: String, $state: String!) {
  generateHypurTokenV2(code: $code, hostname: $hostname, state: $state) {
    accessToken
    embedded
  }
}
    `;
export type GqlGenerateHypurTokenV2MutationFn = ApolloReactCommon.MutationFunction<GqlGenerateHypurTokenV2Mutation, GqlGenerateHypurTokenV2MutationVariables>;

/**
 * __useGenerateHypurTokenV2Mutation__
 *
 * To run a mutation, you first call `useGenerateHypurTokenV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateHypurTokenV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateHypurTokenV2Mutation, { data, loading, error }] = useGenerateHypurTokenV2Mutation({
 *   variables: {
 *      code: // value for 'code'
 *      hostname: // value for 'hostname'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGenerateHypurTokenV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlGenerateHypurTokenV2Mutation, GqlGenerateHypurTokenV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlGenerateHypurTokenV2Mutation, GqlGenerateHypurTokenV2MutationVariables>(GenerateHypurTokenV2Document, options);
      }
export type GenerateHypurTokenV2MutationHookResult = ReturnType<typeof useGenerateHypurTokenV2Mutation>;
export type GenerateHypurTokenV2MutationResult = ApolloReactCommon.MutationResult<GqlGenerateHypurTokenV2Mutation>;
export type GenerateHypurTokenV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlGenerateHypurTokenV2Mutation, GqlGenerateHypurTokenV2MutationVariables>;
export const CreateLibraryProductV2Document = gql`
    mutation CreateLibraryProductV2($libraryProduct: NewLibraryProduct!, $state: String!) {
  createLibraryProductV2(libraryProduct: $libraryProduct, state: $state) {
    id
  }
}
    `;
export type GqlCreateLibraryProductV2MutationFn = ApolloReactCommon.MutationFunction<GqlCreateLibraryProductV2Mutation, GqlCreateLibraryProductV2MutationVariables>;

/**
 * __useCreateLibraryProductV2Mutation__
 *
 * To run a mutation, you first call `useCreateLibraryProductV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryProductV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryProductV2Mutation, { data, loading, error }] = useCreateLibraryProductV2Mutation({
 *   variables: {
 *      libraryProduct: // value for 'libraryProduct'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useCreateLibraryProductV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateLibraryProductV2Mutation, GqlCreateLibraryProductV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateLibraryProductV2Mutation, GqlCreateLibraryProductV2MutationVariables>(CreateLibraryProductV2Document, options);
      }
export type CreateLibraryProductV2MutationHookResult = ReturnType<typeof useCreateLibraryProductV2Mutation>;
export type CreateLibraryProductV2MutationResult = ApolloReactCommon.MutationResult<GqlCreateLibraryProductV2Mutation>;
export type CreateLibraryProductV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateLibraryProductV2Mutation, GqlCreateLibraryProductV2MutationVariables>;
export const CreateLibraryProductV3Document = gql`
    mutation CreateLibraryProductV3($libraryProduct: NewLibraryProductV2!, $state: String!) {
  createLibraryProductV3(libraryProduct: $libraryProduct, state: $state) {
    id
  }
}
    `;
export type GqlCreateLibraryProductV3MutationFn = ApolloReactCommon.MutationFunction<GqlCreateLibraryProductV3Mutation, GqlCreateLibraryProductV3MutationVariables>;

/**
 * __useCreateLibraryProductV3Mutation__
 *
 * To run a mutation, you first call `useCreateLibraryProductV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryProductV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryProductV3Mutation, { data, loading, error }] = useCreateLibraryProductV3Mutation({
 *   variables: {
 *      libraryProduct: // value for 'libraryProduct'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useCreateLibraryProductV3Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateLibraryProductV3Mutation, GqlCreateLibraryProductV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateLibraryProductV3Mutation, GqlCreateLibraryProductV3MutationVariables>(CreateLibraryProductV3Document, options);
      }
export type CreateLibraryProductV3MutationHookResult = ReturnType<typeof useCreateLibraryProductV3Mutation>;
export type CreateLibraryProductV3MutationResult = ApolloReactCommon.MutationResult<GqlCreateLibraryProductV3Mutation>;
export type CreateLibraryProductV3MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateLibraryProductV3Mutation, GqlCreateLibraryProductV3MutationVariables>;
export const MatchLibraryProductsV2Document = gql`
    query MatchLibraryProductsV2($limit: Int, $name: String!, $state: String!, $category: String, $subcategory: String, $brandIds: [String], $brand: String, $scopes: [String]) {
  matchLibraryProductsV2(
    limit: $limit
    name: $name
    state: $state
    category: $category
    subcategory: $subcategory
    brandIds: $brandIds
    brand: $brand
    scopes: $scopes
  ) {
    id
    brand {
      id
      name
      imageUrl
    }
    category
    cbdContent {
      unit
      range
    }
    image
    images {
      _id
      url
      active
      origin
    }
    name
    price
    productTemplate
    stockImage
    strainType
    subcategory
    thcContent {
      unit
      range
    }
  }
}
    `;

/**
 * __useMatchLibraryProductsV2Query__
 *
 * To run a query within a React component, call `useMatchLibraryProductsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useMatchLibraryProductsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchLibraryProductsV2Query({
 *   variables: {
 *      limit: // value for 'limit'
 *      name: // value for 'name'
 *      state: // value for 'state'
 *      category: // value for 'category'
 *      subcategory: // value for 'subcategory'
 *      brandIds: // value for 'brandIds'
 *      brand: // value for 'brand'
 *      scopes: // value for 'scopes'
 *   },
 * });
 */
export function useMatchLibraryProductsV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GqlMatchLibraryProductsV2Query, GqlMatchLibraryProductsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlMatchLibraryProductsV2Query, GqlMatchLibraryProductsV2QueryVariables>(MatchLibraryProductsV2Document, options);
      }
export function useMatchLibraryProductsV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlMatchLibraryProductsV2Query, GqlMatchLibraryProductsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlMatchLibraryProductsV2Query, GqlMatchLibraryProductsV2QueryVariables>(MatchLibraryProductsV2Document, options);
        }
export type MatchLibraryProductsV2QueryHookResult = ReturnType<typeof useMatchLibraryProductsV2Query>;
export type MatchLibraryProductsV2LazyQueryHookResult = ReturnType<typeof useMatchLibraryProductsV2LazyQuery>;
export type MatchLibraryProductsV2QueryResult = ApolloReactCommon.QueryResult<GqlMatchLibraryProductsV2Query, GqlMatchLibraryProductsV2QueryVariables>;
export const MatchLibraryProductsDocument = gql`
    query MatchLibraryProducts($limit: Int, $name: String!, $state: String!, $category: String, $subcategory: String, $brandIds: [String], $brand: String, $productTemplate: Boolean) {
  matchLibraryProducts(
    limit: $limit
    name: $name
    state: $state
    category: $category
    subcategory: $subcategory
    brandIds: $brandIds
    brand: $brand
    productTemplate: $productTemplate
  ) {
    id
    brand {
      id
      name
    }
    category
    cbdContent {
      unit
      range
    }
    image
    name
    price
    strainType
    subcategory
    thcContent {
      unit
      range
    }
  }
}
    `;

/**
 * __useMatchLibraryProductsQuery__
 *
 * To run a query within a React component, call `useMatchLibraryProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchLibraryProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchLibraryProductsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      name: // value for 'name'
 *      state: // value for 'state'
 *      category: // value for 'category'
 *      subcategory: // value for 'subcategory'
 *      brandIds: // value for 'brandIds'
 *      brand: // value for 'brand'
 *      productTemplate: // value for 'productTemplate'
 *   },
 * });
 */
export function useMatchLibraryProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlMatchLibraryProductsQuery, GqlMatchLibraryProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlMatchLibraryProductsQuery, GqlMatchLibraryProductsQueryVariables>(MatchLibraryProductsDocument, options);
      }
export function useMatchLibraryProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlMatchLibraryProductsQuery, GqlMatchLibraryProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlMatchLibraryProductsQuery, GqlMatchLibraryProductsQueryVariables>(MatchLibraryProductsDocument, options);
        }
export type MatchLibraryProductsQueryHookResult = ReturnType<typeof useMatchLibraryProductsQuery>;
export type MatchLibraryProductsLazyQueryHookResult = ReturnType<typeof useMatchLibraryProductsLazyQuery>;
export type MatchLibraryProductsQueryResult = ApolloReactCommon.QueryResult<GqlMatchLibraryProductsQuery, GqlMatchLibraryProductsQueryVariables>;
export const AddressResidentialCheckDocument = gql`
    query AddressResidentialCheck($input: addressResidentialCheckInput!) {
  addressResidentialCheck(input: $input) {
    isValid
  }
}
    `;

/**
 * __useAddressResidentialCheckQuery__
 *
 * To run a query within a React component, call `useAddressResidentialCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressResidentialCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressResidentialCheckQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddressResidentialCheckQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlAddressResidentialCheckQuery, GqlAddressResidentialCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlAddressResidentialCheckQuery, GqlAddressResidentialCheckQueryVariables>(AddressResidentialCheckDocument, options);
      }
export function useAddressResidentialCheckLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlAddressResidentialCheckQuery, GqlAddressResidentialCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlAddressResidentialCheckQuery, GqlAddressResidentialCheckQueryVariables>(AddressResidentialCheckDocument, options);
        }
export type AddressResidentialCheckQueryHookResult = ReturnType<typeof useAddressResidentialCheckQuery>;
export type AddressResidentialCheckLazyQueryHookResult = ReturnType<typeof useAddressResidentialCheckLazyQuery>;
export type AddressResidentialCheckQueryResult = ApolloReactCommon.QueryResult<GqlAddressResidentialCheckQuery, GqlAddressResidentialCheckQueryVariables>;
export const HealthCheckDocument = gql`
    query HealthCheck {
  healthCheck {
    status
  }
}
    `;

/**
 * __useHealthCheckQuery__
 *
 * To run a query within a React component, call `useHealthCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useHealthCheckQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlHealthCheckQuery, GqlHealthCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlHealthCheckQuery, GqlHealthCheckQueryVariables>(HealthCheckDocument, options);
      }
export function useHealthCheckLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlHealthCheckQuery, GqlHealthCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlHealthCheckQuery, GqlHealthCheckQueryVariables>(HealthCheckDocument, options);
        }
export type HealthCheckQueryHookResult = ReturnType<typeof useHealthCheckQuery>;
export type HealthCheckLazyQueryHookResult = ReturnType<typeof useHealthCheckLazyQuery>;
export type HealthCheckQueryResult = ApolloReactCommon.QueryResult<GqlHealthCheckQuery, GqlHealthCheckQueryVariables>;
export const ResetPasswordV2Document = gql`
    mutation ResetPasswordV2($input: resetPasswordInput!) {
  resetPasswordV2(input: $input) {
    message
    success
  }
}
    `;
export type GqlResetPasswordV2MutationFn = ApolloReactCommon.MutationFunction<GqlResetPasswordV2Mutation, GqlResetPasswordV2MutationVariables>;

/**
 * __useResetPasswordV2Mutation__
 *
 * To run a mutation, you first call `useResetPasswordV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordV2Mutation, { data, loading, error }] = useResetPasswordV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlResetPasswordV2Mutation, GqlResetPasswordV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlResetPasswordV2Mutation, GqlResetPasswordV2MutationVariables>(ResetPasswordV2Document, options);
      }
export type ResetPasswordV2MutationHookResult = ReturnType<typeof useResetPasswordV2Mutation>;
export type ResetPasswordV2MutationResult = ApolloReactCommon.MutationResult<GqlResetPasswordV2Mutation>;
export type ResetPasswordV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlResetPasswordV2Mutation, GqlResetPasswordV2MutationVariables>;
export const SendBrandUserPasswordResetEmailDocument = gql`
    mutation SendBrandUserPasswordResetEmail($email: String!) {
  sendBrandUserPasswordResetEmail(email: $email) {
    message
    success
  }
}
    `;
export type GqlSendBrandUserPasswordResetEmailMutationFn = ApolloReactCommon.MutationFunction<GqlSendBrandUserPasswordResetEmailMutation, GqlSendBrandUserPasswordResetEmailMutationVariables>;

/**
 * __useSendBrandUserPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendBrandUserPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBrandUserPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBrandUserPasswordResetEmailMutation, { data, loading, error }] = useSendBrandUserPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendBrandUserPasswordResetEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlSendBrandUserPasswordResetEmailMutation, GqlSendBrandUserPasswordResetEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlSendBrandUserPasswordResetEmailMutation, GqlSendBrandUserPasswordResetEmailMutationVariables>(SendBrandUserPasswordResetEmailDocument, options);
      }
export type SendBrandUserPasswordResetEmailMutationHookResult = ReturnType<typeof useSendBrandUserPasswordResetEmailMutation>;
export type SendBrandUserPasswordResetEmailMutationResult = ApolloReactCommon.MutationResult<GqlSendBrandUserPasswordResetEmailMutation>;
export type SendBrandUserPasswordResetEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlSendBrandUserPasswordResetEmailMutation, GqlSendBrandUserPasswordResetEmailMutationVariables>;
export const SendPasswordResetEmailV2Document = gql`
    mutation SendPasswordResetEmailV2($email: String!) {
  sendPasswordResetEmailV2(email: $email) {
    message
    success
  }
}
    `;
export type GqlSendPasswordResetEmailV2MutationFn = ApolloReactCommon.MutationFunction<GqlSendPasswordResetEmailV2Mutation, GqlSendPasswordResetEmailV2MutationVariables>;

/**
 * __useSendPasswordResetEmailV2Mutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailV2Mutation, { data, loading, error }] = useSendPasswordResetEmailV2Mutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendPasswordResetEmailV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlSendPasswordResetEmailV2Mutation, GqlSendPasswordResetEmailV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlSendPasswordResetEmailV2Mutation, GqlSendPasswordResetEmailV2MutationVariables>(SendPasswordResetEmailV2Document, options);
      }
export type SendPasswordResetEmailV2MutationHookResult = ReturnType<typeof useSendPasswordResetEmailV2Mutation>;
export type SendPasswordResetEmailV2MutationResult = ApolloReactCommon.MutationResult<GqlSendPasswordResetEmailV2Mutation>;
export type SendPasswordResetEmailV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlSendPasswordResetEmailV2Mutation, GqlSendPasswordResetEmailV2MutationVariables>;
export const SetPasswordV2Document = gql`
    mutation SetPasswordV2($input: setPasswordInput!) {
  setPasswordV2(input: $input) {
    message
    success
  }
}
    `;
export type GqlSetPasswordV2MutationFn = ApolloReactCommon.MutationFunction<GqlSetPasswordV2Mutation, GqlSetPasswordV2MutationVariables>;

/**
 * __useSetPasswordV2Mutation__
 *
 * To run a mutation, you first call `useSetPasswordV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordV2Mutation, { data, loading, error }] = useSetPasswordV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPasswordV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlSetPasswordV2Mutation, GqlSetPasswordV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlSetPasswordV2Mutation, GqlSetPasswordV2MutationVariables>(SetPasswordV2Document, options);
      }
export type SetPasswordV2MutationHookResult = ReturnType<typeof useSetPasswordV2Mutation>;
export type SetPasswordV2MutationResult = ApolloReactCommon.MutationResult<GqlSetPasswordV2Mutation>;
export type SetPasswordV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlSetPasswordV2Mutation, GqlSetPasswordV2MutationVariables>;
export const UpdatePasswordV2Document = gql`
    mutation UpdatePasswordV2($oldPassword: String!, $newPassword: String!) {
  updatePasswordV2(oldPassword: $oldPassword, newPassword: $newPassword) {
    accessToken
  }
}
    `;
export type GqlUpdatePasswordV2MutationFn = ApolloReactCommon.MutationFunction<GqlUpdatePasswordV2Mutation, GqlUpdatePasswordV2MutationVariables>;

/**
 * __useUpdatePasswordV2Mutation__
 *
 * To run a mutation, you first call `useUpdatePasswordV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordV2Mutation, { data, loading, error }] = useUpdatePasswordV2Mutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUpdatePasswordV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdatePasswordV2Mutation, GqlUpdatePasswordV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdatePasswordV2Mutation, GqlUpdatePasswordV2MutationVariables>(UpdatePasswordV2Document, options);
      }
export type UpdatePasswordV2MutationHookResult = ReturnType<typeof useUpdatePasswordV2Mutation>;
export type UpdatePasswordV2MutationResult = ApolloReactCommon.MutationResult<GqlUpdatePasswordV2Mutation>;
export type UpdatePasswordV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdatePasswordV2Mutation, GqlUpdatePasswordV2MutationVariables>;
export const GetPaymentsCheckoutCredentialsDocument = gql`
    query GetPaymentsCheckoutCredentials($adapter: String!, $dispensaryId: String!) {
  getPaymentsCheckoutCredentials(adapter: $adapter, dispensaryId: $dispensaryId) {
    ... on ChaseHostedProfileCredentials {
      uID
    }
    ... on MonerisHTProfileCredentials {
      profileId
    }
  }
}
    `;

/**
 * __useGetPaymentsCheckoutCredentialsQuery__
 *
 * To run a query within a React component, call `useGetPaymentsCheckoutCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsCheckoutCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsCheckoutCredentialsQuery({
 *   variables: {
 *      adapter: // value for 'adapter'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetPaymentsCheckoutCredentialsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetPaymentsCheckoutCredentialsQuery, GqlGetPaymentsCheckoutCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetPaymentsCheckoutCredentialsQuery, GqlGetPaymentsCheckoutCredentialsQueryVariables>(GetPaymentsCheckoutCredentialsDocument, options);
      }
export function useGetPaymentsCheckoutCredentialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetPaymentsCheckoutCredentialsQuery, GqlGetPaymentsCheckoutCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetPaymentsCheckoutCredentialsQuery, GqlGetPaymentsCheckoutCredentialsQueryVariables>(GetPaymentsCheckoutCredentialsDocument, options);
        }
export type GetPaymentsCheckoutCredentialsQueryHookResult = ReturnType<typeof useGetPaymentsCheckoutCredentialsQuery>;
export type GetPaymentsCheckoutCredentialsLazyQueryHookResult = ReturnType<typeof useGetPaymentsCheckoutCredentialsLazyQuery>;
export type GetPaymentsCheckoutCredentialsQueryResult = ApolloReactCommon.QueryResult<GqlGetPaymentsCheckoutCredentialsQuery, GqlGetPaymentsCheckoutCredentialsQueryVariables>;
export const GetMonerisTokenizationProfileDocument = gql`
    query GetMonerisTokenizationProfile($dispensaryId: String!) {
  getMonerisTokenizationProfile(dispensaryId: $dispensaryId) {
    profileId
  }
}
    `;

/**
 * __useGetMonerisTokenizationProfileQuery__
 *
 * To run a query within a React component, call `useGetMonerisTokenizationProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonerisTokenizationProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonerisTokenizationProfileQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetMonerisTokenizationProfileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetMonerisTokenizationProfileQuery, GqlGetMonerisTokenizationProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetMonerisTokenizationProfileQuery, GqlGetMonerisTokenizationProfileQueryVariables>(GetMonerisTokenizationProfileDocument, options);
      }
export function useGetMonerisTokenizationProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetMonerisTokenizationProfileQuery, GqlGetMonerisTokenizationProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetMonerisTokenizationProfileQuery, GqlGetMonerisTokenizationProfileQueryVariables>(GetMonerisTokenizationProfileDocument, options);
        }
export type GetMonerisTokenizationProfileQueryHookResult = ReturnType<typeof useGetMonerisTokenizationProfileQuery>;
export type GetMonerisTokenizationProfileLazyQueryHookResult = ReturnType<typeof useGetMonerisTokenizationProfileLazyQuery>;
export type GetMonerisTokenizationProfileQueryResult = ApolloReactCommon.QueryResult<GqlGetMonerisTokenizationProfileQuery, GqlGetMonerisTokenizationProfileQueryVariables>;
export const ArchivedProductLookupDocument = gql`
    query ArchivedProductLookup($cname: String!, $dispensaryId: String!) {
  archivedProductLookup(cname: $cname, dispensaryId: $dispensaryId) {
    ...consumerBaseProductFragment
    brand {
      id
      _id
      description
      imageUrl
      name
    }
    effects
    description
    descriptionHtml
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useArchivedProductLookupQuery__
 *
 * To run a query within a React component, call `useArchivedProductLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchivedProductLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchivedProductLookupQuery({
 *   variables: {
 *      cname: // value for 'cname'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useArchivedProductLookupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlArchivedProductLookupQuery, GqlArchivedProductLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlArchivedProductLookupQuery, GqlArchivedProductLookupQueryVariables>(ArchivedProductLookupDocument, options);
      }
export function useArchivedProductLookupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlArchivedProductLookupQuery, GqlArchivedProductLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlArchivedProductLookupQuery, GqlArchivedProductLookupQueryVariables>(ArchivedProductLookupDocument, options);
        }
export type ArchivedProductLookupQueryHookResult = ReturnType<typeof useArchivedProductLookupQuery>;
export type ArchivedProductLookupLazyQueryHookResult = ReturnType<typeof useArchivedProductLookupLazyQuery>;
export type ArchivedProductLookupQueryResult = ApolloReactCommon.QueryResult<GqlArchivedProductLookupQuery, GqlArchivedProductLookupQueryVariables>;
export const FilteredProductsDocument = gql`
    query FilteredProducts($productsFilter: productsFilterInput!, $useCache: Boolean, $page: Int, $perPage: Int, $includeEnterpriseSpecials: Boolean = false) {
  filteredProducts(
    filter: $productsFilter
    useCache: $useCache
    page: $page
    perPage: $perPage
    includeEnterpriseSpecials: $includeEnterpriseSpecials
  ) {
    products {
      ...consumerBaseProductFragment
      brand {
        id
        _id
        description
        imageUrl
        name
      }
      effects
      cannabinoidsV2 {
        value
        unit
        cannabinoid {
          name
        }
      }
      provider
    }
    queryInfo {
      totalCount
      totalPages
    }
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useFilteredProductsQuery__
 *
 * To run a query within a React component, call `useFilteredProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredProductsQuery({
 *   variables: {
 *      productsFilter: // value for 'productsFilter'
 *      useCache: // value for 'useCache'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      includeEnterpriseSpecials: // value for 'includeEnterpriseSpecials'
 *   },
 * });
 */
export function useFilteredProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlFilteredProductsQuery, GqlFilteredProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlFilteredProductsQuery, GqlFilteredProductsQueryVariables>(FilteredProductsDocument, options);
      }
export function useFilteredProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlFilteredProductsQuery, GqlFilteredProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlFilteredProductsQuery, GqlFilteredProductsQueryVariables>(FilteredProductsDocument, options);
        }
export type FilteredProductsQueryHookResult = ReturnType<typeof useFilteredProductsQuery>;
export type FilteredProductsLazyQueryHookResult = ReturnType<typeof useFilteredProductsLazyQuery>;
export type FilteredProductsQueryResult = ApolloReactCommon.QueryResult<GqlFilteredProductsQuery, GqlFilteredProductsQueryVariables>;
export const IndividualFilteredProductDocument = gql`
    query IndividualFilteredProduct($productsFilter: productsFilterInput!, $useCache: Boolean, $includeEnterpriseSpecials: Boolean = false) {
  filteredProducts(
    filter: $productsFilter
    useCache: $useCache
    includeEnterpriseSpecials: $includeEnterpriseSpecials
  ) {
    products {
      ...consumerBaseProductFragment
      brand {
        id
        _id
        description
        imageUrl
        name
      }
      terpenes {
        id
        libraryTerpene {
          aromas
          description
          effects
          name
        }
        terpeneId
        unit
        unitSymbol
        value
      }
      cannabinoidsV2 {
        value
        unit
        cannabinoid {
          name
          description
        }
      }
      effects
      description
      descriptionHtml
    }
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useIndividualFilteredProductQuery__
 *
 * To run a query within a React component, call `useIndividualFilteredProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndividualFilteredProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndividualFilteredProductQuery({
 *   variables: {
 *      productsFilter: // value for 'productsFilter'
 *      useCache: // value for 'useCache'
 *      includeEnterpriseSpecials: // value for 'includeEnterpriseSpecials'
 *   },
 * });
 */
export function useIndividualFilteredProductQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlIndividualFilteredProductQuery, GqlIndividualFilteredProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlIndividualFilteredProductQuery, GqlIndividualFilteredProductQueryVariables>(IndividualFilteredProductDocument, options);
      }
export function useIndividualFilteredProductLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlIndividualFilteredProductQuery, GqlIndividualFilteredProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlIndividualFilteredProductQuery, GqlIndividualFilteredProductQueryVariables>(IndividualFilteredProductDocument, options);
        }
export type IndividualFilteredProductQueryHookResult = ReturnType<typeof useIndividualFilteredProductQuery>;
export type IndividualFilteredProductLazyQueryHookResult = ReturnType<typeof useIndividualFilteredProductLazyQuery>;
export type IndividualFilteredProductQueryResult = ApolloReactCommon.QueryResult<GqlIndividualFilteredProductQuery, GqlIndividualFilteredProductQueryVariables>;
export const CreateAlpineUserV2Document = gql`
    mutation CreateAlpineUserV2($firstName: String, $lastName: String, $address: String, $email: String, $program: String!, $dispensaryId: String!, $favoriteStore: String!, $phoneNumber: String!, $acceptedTerms: Boolean!) {
  createAlpineUserV2(
    firstName: $firstName
    lastName: $lastName
    address: $address
    email: $email
    program: $program
    dispensaryId: $dispensaryId
    favoriteStore: $favoriteStore
    phoneNumber: $phoneNumber
    acceptedTerms: $acceptedTerms
  ) {
    success
    wallet {
      balance
      rewardBrand
      rewards {
        id
        copy
        available
        operator
        cost
        value
        rewardType
      }
      userHasWallet
      auth {
        pinConfirmed
        incorrectPinProvided
        authTextMessageSent
      }
    }
  }
}
    `;
export type GqlCreateAlpineUserV2MutationFn = ApolloReactCommon.MutationFunction<GqlCreateAlpineUserV2Mutation, GqlCreateAlpineUserV2MutationVariables>;

/**
 * __useCreateAlpineUserV2Mutation__
 *
 * To run a mutation, you first call `useCreateAlpineUserV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlpineUserV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlpineUserV2Mutation, { data, loading, error }] = useCreateAlpineUserV2Mutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      address: // value for 'address'
 *      email: // value for 'email'
 *      program: // value for 'program'
 *      dispensaryId: // value for 'dispensaryId'
 *      favoriteStore: // value for 'favoriteStore'
 *      phoneNumber: // value for 'phoneNumber'
 *      acceptedTerms: // value for 'acceptedTerms'
 *   },
 * });
 */
export function useCreateAlpineUserV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateAlpineUserV2Mutation, GqlCreateAlpineUserV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateAlpineUserV2Mutation, GqlCreateAlpineUserV2MutationVariables>(CreateAlpineUserV2Document, options);
      }
export type CreateAlpineUserV2MutationHookResult = ReturnType<typeof useCreateAlpineUserV2Mutation>;
export type CreateAlpineUserV2MutationResult = ApolloReactCommon.MutationResult<GqlCreateAlpineUserV2Mutation>;
export type CreateAlpineUserV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateAlpineUserV2Mutation, GqlCreateAlpineUserV2MutationVariables>;
export const CreateAlpineUserDocument = gql`
    mutation CreateAlpineUser($firstName: String, $lastName: String, $address: String, $email: String, $program: String!, $dispensaryId: String!, $favoriteStore: String!, $phoneNumber: String!, $acceptedTerms: Boolean!) {
  createAlpineUser(
    firstName: $firstName
    lastName: $lastName
    address: $address
    email: $email
    program: $program
    dispensaryId: $dispensaryId
    favoriteStore: $favoriteStore
    phoneNumber: $phoneNumber
    acceptedTerms: $acceptedTerms
  ) {
    success
    wallet {
      balance
      rewardBrand
      rewards {
        id
        copy
        available
        operator
        cost
        value
        rewardType
      }
      userHasWallet
      auth {
        pinConfirmed
        incorrectPinProvided
        authTextMessageSent
      }
    }
  }
}
    `;
export type GqlCreateAlpineUserMutationFn = ApolloReactCommon.MutationFunction<GqlCreateAlpineUserMutation, GqlCreateAlpineUserMutationVariables>;

/**
 * __useCreateAlpineUserMutation__
 *
 * To run a mutation, you first call `useCreateAlpineUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlpineUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlpineUserMutation, { data, loading, error }] = useCreateAlpineUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      address: // value for 'address'
 *      email: // value for 'email'
 *      program: // value for 'program'
 *      dispensaryId: // value for 'dispensaryId'
 *      favoriteStore: // value for 'favoriteStore'
 *      phoneNumber: // value for 'phoneNumber'
 *      acceptedTerms: // value for 'acceptedTerms'
 *   },
 * });
 */
export function useCreateAlpineUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateAlpineUserMutation, GqlCreateAlpineUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateAlpineUserMutation, GqlCreateAlpineUserMutationVariables>(CreateAlpineUserDocument, options);
      }
export type CreateAlpineUserMutationHookResult = ReturnType<typeof useCreateAlpineUserMutation>;
export type CreateAlpineUserMutationResult = ApolloReactCommon.MutationResult<GqlCreateAlpineUserMutation>;
export type CreateAlpineUserMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateAlpineUserMutation, GqlCreateAlpineUserMutationVariables>;
export const CreateDutchiePosLoyaltyMemberDocument = gql`
    mutation CreateDutchiePosLoyaltyMember($dispensaryId: String!, $userId: String!) {
  createDutchiePosLoyaltyMember(dispensaryId: $dispensaryId, userId: $userId) {
    success
  }
}
    `;
export type GqlCreateDutchiePosLoyaltyMemberMutationFn = ApolloReactCommon.MutationFunction<GqlCreateDutchiePosLoyaltyMemberMutation, GqlCreateDutchiePosLoyaltyMemberMutationVariables>;

/**
 * __useCreateDutchiePosLoyaltyMemberMutation__
 *
 * To run a mutation, you first call `useCreateDutchiePosLoyaltyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDutchiePosLoyaltyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDutchiePosLoyaltyMemberMutation, { data, loading, error }] = useCreateDutchiePosLoyaltyMemberMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateDutchiePosLoyaltyMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateDutchiePosLoyaltyMemberMutation, GqlCreateDutchiePosLoyaltyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateDutchiePosLoyaltyMemberMutation, GqlCreateDutchiePosLoyaltyMemberMutationVariables>(CreateDutchiePosLoyaltyMemberDocument, options);
      }
export type CreateDutchiePosLoyaltyMemberMutationHookResult = ReturnType<typeof useCreateDutchiePosLoyaltyMemberMutation>;
export type CreateDutchiePosLoyaltyMemberMutationResult = ApolloReactCommon.MutationResult<GqlCreateDutchiePosLoyaltyMemberMutation>;
export type CreateDutchiePosLoyaltyMemberMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateDutchiePosLoyaltyMemberMutation, GqlCreateDutchiePosLoyaltyMemberMutationVariables>;
export const CreateEnterpriseDutchiePosLoyaltyMemberDocument = gql`
    mutation CreateEnterpriseDutchiePosLoyaltyMember($enterpriseId: String!, $userId: String!, $isoRegionCode: String!) {
  createEnterpriseDutchiePosLoyaltyMember(
    enterpriseId: $enterpriseId
    userId: $userId
    isoRegionCode: $isoRegionCode
  ) {
    success
    message
  }
}
    `;
export type GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationFn = ApolloReactCommon.MutationFunction<GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationVariables>;

/**
 * __useCreateEnterpriseDutchiePosLoyaltyMemberMutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseDutchiePosLoyaltyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseDutchiePosLoyaltyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnterpriseDutchiePosLoyaltyMemberMutation, { data, loading, error }] = useCreateEnterpriseDutchiePosLoyaltyMemberMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      userId: // value for 'userId'
 *      isoRegionCode: // value for 'isoRegionCode'
 *   },
 * });
 */
export function useCreateEnterpriseDutchiePosLoyaltyMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationVariables>(CreateEnterpriseDutchiePosLoyaltyMemberDocument, options);
      }
export type CreateEnterpriseDutchiePosLoyaltyMemberMutationHookResult = ReturnType<typeof useCreateEnterpriseDutchiePosLoyaltyMemberMutation>;
export type CreateEnterpriseDutchiePosLoyaltyMemberMutationResult = ApolloReactCommon.MutationResult<GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation>;
export type CreateEnterpriseDutchiePosLoyaltyMemberMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationVariables>;
export const CreateSpringbigUserDocument = gql`
    mutation CreateSpringbigUser($dispensaryId: String!, $userId: String!) {
  createSpringbigUser(dispensaryId: $dispensaryId, userId: $userId) {
    success
  }
}
    `;
export type GqlCreateSpringbigUserMutationFn = ApolloReactCommon.MutationFunction<GqlCreateSpringbigUserMutation, GqlCreateSpringbigUserMutationVariables>;

/**
 * __useCreateSpringbigUserMutation__
 *
 * To run a mutation, you first call `useCreateSpringbigUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpringbigUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpringbigUserMutation, { data, loading, error }] = useCreateSpringbigUserMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateSpringbigUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateSpringbigUserMutation, GqlCreateSpringbigUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateSpringbigUserMutation, GqlCreateSpringbigUserMutationVariables>(CreateSpringbigUserDocument, options);
      }
export type CreateSpringbigUserMutationHookResult = ReturnType<typeof useCreateSpringbigUserMutation>;
export type CreateSpringbigUserMutationResult = ApolloReactCommon.MutationResult<GqlCreateSpringbigUserMutation>;
export type CreateSpringbigUserMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateSpringbigUserMutation, GqlCreateSpringbigUserMutationVariables>;
export const UpdateDutchiePosLoyaltyMemberDocument = gql`
    mutation UpdateDutchiePosLoyaltyMember($dispensaryId: String!, $userId: String!, $phone: String!, $lastAndroidLoginUtc: String, $lastIosLoginUtc: String) {
  updateDutchiePosLoyaltyMember(
    dispensaryId: $dispensaryId
    userId: $userId
    phone: $phone
    lastAndroidLoginUtc: $lastAndroidLoginUtc
    lastIosLoginUtc: $lastIosLoginUtc
  ) {
    success
  }
}
    `;
export type GqlUpdateDutchiePosLoyaltyMemberMutationFn = ApolloReactCommon.MutationFunction<GqlUpdateDutchiePosLoyaltyMemberMutation, GqlUpdateDutchiePosLoyaltyMemberMutationVariables>;

/**
 * __useUpdateDutchiePosLoyaltyMemberMutation__
 *
 * To run a mutation, you first call `useUpdateDutchiePosLoyaltyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDutchiePosLoyaltyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDutchiePosLoyaltyMemberMutation, { data, loading, error }] = useUpdateDutchiePosLoyaltyMemberMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userId: // value for 'userId'
 *      phone: // value for 'phone'
 *      lastAndroidLoginUtc: // value for 'lastAndroidLoginUtc'
 *      lastIosLoginUtc: // value for 'lastIosLoginUtc'
 *   },
 * });
 */
export function useUpdateDutchiePosLoyaltyMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateDutchiePosLoyaltyMemberMutation, GqlUpdateDutchiePosLoyaltyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateDutchiePosLoyaltyMemberMutation, GqlUpdateDutchiePosLoyaltyMemberMutationVariables>(UpdateDutchiePosLoyaltyMemberDocument, options);
      }
export type UpdateDutchiePosLoyaltyMemberMutationHookResult = ReturnType<typeof useUpdateDutchiePosLoyaltyMemberMutation>;
export type UpdateDutchiePosLoyaltyMemberMutationResult = ApolloReactCommon.MutationResult<GqlUpdateDutchiePosLoyaltyMemberMutation>;
export type UpdateDutchiePosLoyaltyMemberMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateDutchiePosLoyaltyMemberMutation, GqlUpdateDutchiePosLoyaltyMemberMutationVariables>;
export const GetDutchiePosLoyaltyConfigDocument = gql`
    query GetDutchiePosLoyaltyConfig($dispensaryId: String, $enterpriseId: String, $isoRegionCode: String) {
  getDutchiePosLoyaltyConfig(
    dispensaryId: $dispensaryId
    enterpriseId: $enterpriseId
    isoRegionCode: $isoRegionCode
  ) {
    loyaltyRequireOptIn
    isEnabled
    loyaltyDaysToExpiration
    onlineName
    onlineDescription
    tierEarningBasis
    redemptionType
    mode
    tiers {
      id
      name
      threshold
      badgeColor
    }
  }
}
    `;

/**
 * __useGetDutchiePosLoyaltyConfigQuery__
 *
 * To run a query within a React component, call `useGetDutchiePosLoyaltyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDutchiePosLoyaltyConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDutchiePosLoyaltyConfigQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      enterpriseId: // value for 'enterpriseId'
 *      isoRegionCode: // value for 'isoRegionCode'
 *   },
 * });
 */
export function useGetDutchiePosLoyaltyConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetDutchiePosLoyaltyConfigQuery, GqlGetDutchiePosLoyaltyConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetDutchiePosLoyaltyConfigQuery, GqlGetDutchiePosLoyaltyConfigQueryVariables>(GetDutchiePosLoyaltyConfigDocument, options);
      }
export function useGetDutchiePosLoyaltyConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetDutchiePosLoyaltyConfigQuery, GqlGetDutchiePosLoyaltyConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetDutchiePosLoyaltyConfigQuery, GqlGetDutchiePosLoyaltyConfigQueryVariables>(GetDutchiePosLoyaltyConfigDocument, options);
        }
export type GetDutchiePosLoyaltyConfigQueryHookResult = ReturnType<typeof useGetDutchiePosLoyaltyConfigQuery>;
export type GetDutchiePosLoyaltyConfigLazyQueryHookResult = ReturnType<typeof useGetDutchiePosLoyaltyConfigLazyQuery>;
export type GetDutchiePosLoyaltyConfigQueryResult = ApolloReactCommon.QueryResult<GqlGetDutchiePosLoyaltyConfigQuery, GqlGetDutchiePosLoyaltyConfigQueryVariables>;
export const GetRewardsV2Document = gql`
    query GetRewardsV2($phoneNumber: String!, $dispensaryId: String, $enterpriseId: String, $isoRegionCode: String, $dob: String, $pin: String, $customerId: String) {
  getRewardsV2(
    phoneNumber: $phoneNumber
    dispensaryId: $dispensaryId
    enterpriseId: $enterpriseId
    isoRegionCode: $isoRegionCode
    dob: $dob
    pin: $pin
    customerId: $customerId
  ) {
    balance
    rewards {
      id
      copy
      available
      operator
      cost
      value
      rewardType
      discountId
      brand
      isRedeemableOnline
    }
    rewardBrand
    userHasWallet
    isLoyaltyMember
    currentYearTierBalance
    expirationDate
    tierName
    tierId
    auth {
      pinConfirmed
      incorrectPinProvided
      authTextMessageSent
    }
    rewardsActivity {
      lspName
      location
      customerId
      transactionType
      transactionDateUtc
      points
      comment
      orderType
      isAdjustment
      totalPaid
    }
    posCustomerId
  }
}
    `;

/**
 * __useGetRewardsV2Query__
 *
 * To run a query within a React component, call `useGetRewardsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardsV2Query({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      dispensaryId: // value for 'dispensaryId'
 *      enterpriseId: // value for 'enterpriseId'
 *      isoRegionCode: // value for 'isoRegionCode'
 *      dob: // value for 'dob'
 *      pin: // value for 'pin'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetRewardsV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetRewardsV2Query, GqlGetRewardsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetRewardsV2Query, GqlGetRewardsV2QueryVariables>(GetRewardsV2Document, options);
      }
export function useGetRewardsV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetRewardsV2Query, GqlGetRewardsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetRewardsV2Query, GqlGetRewardsV2QueryVariables>(GetRewardsV2Document, options);
        }
export type GetRewardsV2QueryHookResult = ReturnType<typeof useGetRewardsV2Query>;
export type GetRewardsV2LazyQueryHookResult = ReturnType<typeof useGetRewardsV2LazyQuery>;
export type GetRewardsV2QueryResult = ApolloReactCommon.QueryResult<GqlGetRewardsV2Query, GqlGetRewardsV2QueryVariables>;
export const BulkEndSpecialsV2Document = gql`
    mutation BulkEndSpecialsV2($input: endSpecialsInput!) {
  bulkEndSpecialsV2(input: $input) {
    message
    success
  }
}
    `;
export type GqlBulkEndSpecialsV2MutationFn = ApolloReactCommon.MutationFunction<GqlBulkEndSpecialsV2Mutation, GqlBulkEndSpecialsV2MutationVariables>;

/**
 * __useBulkEndSpecialsV2Mutation__
 *
 * To run a mutation, you first call `useBulkEndSpecialsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkEndSpecialsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkEndSpecialsV2Mutation, { data, loading, error }] = useBulkEndSpecialsV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkEndSpecialsV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlBulkEndSpecialsV2Mutation, GqlBulkEndSpecialsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlBulkEndSpecialsV2Mutation, GqlBulkEndSpecialsV2MutationVariables>(BulkEndSpecialsV2Document, options);
      }
export type BulkEndSpecialsV2MutationHookResult = ReturnType<typeof useBulkEndSpecialsV2Mutation>;
export type BulkEndSpecialsV2MutationResult = ApolloReactCommon.MutationResult<GqlBulkEndSpecialsV2Mutation>;
export type BulkEndSpecialsV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlBulkEndSpecialsV2Mutation, GqlBulkEndSpecialsV2MutationVariables>;
export const CreateEnterpriseSpecialV2Document = gql`
    mutation CreateEnterpriseSpecialV2($input: EnterpriseSpecialInputV2!) {
  createEnterpriseSpecialV2(input: $input) {
    message
    success
  }
}
    `;
export type GqlCreateEnterpriseSpecialV2MutationFn = ApolloReactCommon.MutationFunction<GqlCreateEnterpriseSpecialV2Mutation, GqlCreateEnterpriseSpecialV2MutationVariables>;

/**
 * __useCreateEnterpriseSpecialV2Mutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseSpecialV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseSpecialV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnterpriseSpecialV2Mutation, { data, loading, error }] = useCreateEnterpriseSpecialV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnterpriseSpecialV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateEnterpriseSpecialV2Mutation, GqlCreateEnterpriseSpecialV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateEnterpriseSpecialV2Mutation, GqlCreateEnterpriseSpecialV2MutationVariables>(CreateEnterpriseSpecialV2Document, options);
      }
export type CreateEnterpriseSpecialV2MutationHookResult = ReturnType<typeof useCreateEnterpriseSpecialV2Mutation>;
export type CreateEnterpriseSpecialV2MutationResult = ApolloReactCommon.MutationResult<GqlCreateEnterpriseSpecialV2Mutation>;
export type CreateEnterpriseSpecialV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateEnterpriseSpecialV2Mutation, GqlCreateEnterpriseSpecialV2MutationVariables>;
export const CreateEnterpriseSpecialsSettingsDocument = gql`
    mutation CreateEnterpriseSpecialsSettings($enterpriseId: ID!, $input: EnterpriseSpecialsSettingsInput!) {
  createEnterpriseSpecialsSettings(enterpriseId: $enterpriseId, input: $input) {
    message
    success
  }
}
    `;
export type GqlCreateEnterpriseSpecialsSettingsMutationFn = ApolloReactCommon.MutationFunction<GqlCreateEnterpriseSpecialsSettingsMutation, GqlCreateEnterpriseSpecialsSettingsMutationVariables>;

/**
 * __useCreateEnterpriseSpecialsSettingsMutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseSpecialsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseSpecialsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnterpriseSpecialsSettingsMutation, { data, loading, error }] = useCreateEnterpriseSpecialsSettingsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnterpriseSpecialsSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateEnterpriseSpecialsSettingsMutation, GqlCreateEnterpriseSpecialsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateEnterpriseSpecialsSettingsMutation, GqlCreateEnterpriseSpecialsSettingsMutationVariables>(CreateEnterpriseSpecialsSettingsDocument, options);
      }
export type CreateEnterpriseSpecialsSettingsMutationHookResult = ReturnType<typeof useCreateEnterpriseSpecialsSettingsMutation>;
export type CreateEnterpriseSpecialsSettingsMutationResult = ApolloReactCommon.MutationResult<GqlCreateEnterpriseSpecialsSettingsMutation>;
export type CreateEnterpriseSpecialsSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateEnterpriseSpecialsSettingsMutation, GqlCreateEnterpriseSpecialsSettingsMutationVariables>;
export const CreateSpecialV3Document = gql`
    mutation CreateSpecialV3($input: SpecialsInputV3!) {
  createSpecialV3(input: $input) {
    _id
  }
}
    `;
export type GqlCreateSpecialV3MutationFn = ApolloReactCommon.MutationFunction<GqlCreateSpecialV3Mutation, GqlCreateSpecialV3MutationVariables>;

/**
 * __useCreateSpecialV3Mutation__
 *
 * To run a mutation, you first call `useCreateSpecialV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpecialV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpecialV3Mutation, { data, loading, error }] = useCreateSpecialV3Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSpecialV3Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateSpecialV3Mutation, GqlCreateSpecialV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateSpecialV3Mutation, GqlCreateSpecialV3MutationVariables>(CreateSpecialV3Document, options);
      }
export type CreateSpecialV3MutationHookResult = ReturnType<typeof useCreateSpecialV3Mutation>;
export type CreateSpecialV3MutationResult = ApolloReactCommon.MutationResult<GqlCreateSpecialV3Mutation>;
export type CreateSpecialV3MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateSpecialV3Mutation, GqlCreateSpecialV3MutationVariables>;
export const DeleteEnterpriseSpecialDocument = gql`
    mutation DeleteEnterpriseSpecial($enterpriseId: String!, $id: String!) {
  deleteEnterpriseSpecial(enterprise_id: $enterpriseId, id: $id) {
    message
    success
  }
}
    `;
export type GqlDeleteEnterpriseSpecialMutationFn = ApolloReactCommon.MutationFunction<GqlDeleteEnterpriseSpecialMutation, GqlDeleteEnterpriseSpecialMutationVariables>;

/**
 * __useDeleteEnterpriseSpecialMutation__
 *
 * To run a mutation, you first call `useDeleteEnterpriseSpecialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEnterpriseSpecialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEnterpriseSpecialMutation, { data, loading, error }] = useDeleteEnterpriseSpecialMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEnterpriseSpecialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlDeleteEnterpriseSpecialMutation, GqlDeleteEnterpriseSpecialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlDeleteEnterpriseSpecialMutation, GqlDeleteEnterpriseSpecialMutationVariables>(DeleteEnterpriseSpecialDocument, options);
      }
export type DeleteEnterpriseSpecialMutationHookResult = ReturnType<typeof useDeleteEnterpriseSpecialMutation>;
export type DeleteEnterpriseSpecialMutationResult = ApolloReactCommon.MutationResult<GqlDeleteEnterpriseSpecialMutation>;
export type DeleteEnterpriseSpecialMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlDeleteEnterpriseSpecialMutation, GqlDeleteEnterpriseSpecialMutationVariables>;
export const DeleteSpecialV2Document = gql`
    mutation DeleteSpecialV2($id: String!) {
  deleteSpecialV2(id: $id) {
    _id
  }
}
    `;
export type GqlDeleteSpecialV2MutationFn = ApolloReactCommon.MutationFunction<GqlDeleteSpecialV2Mutation, GqlDeleteSpecialV2MutationVariables>;

/**
 * __useDeleteSpecialV2Mutation__
 *
 * To run a mutation, you first call `useDeleteSpecialV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpecialV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpecialV2Mutation, { data, loading, error }] = useDeleteSpecialV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSpecialV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlDeleteSpecialV2Mutation, GqlDeleteSpecialV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlDeleteSpecialV2Mutation, GqlDeleteSpecialV2MutationVariables>(DeleteSpecialV2Document, options);
      }
export type DeleteSpecialV2MutationHookResult = ReturnType<typeof useDeleteSpecialV2Mutation>;
export type DeleteSpecialV2MutationResult = ApolloReactCommon.MutationResult<GqlDeleteSpecialV2Mutation>;
export type DeleteSpecialV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlDeleteSpecialV2Mutation, GqlDeleteSpecialV2MutationVariables>;
export const EndEnterpriseSpecialDocument = gql`
    mutation EndEnterpriseSpecial($enterpriseId: String!, $id: String!) {
  endEnterpriseSpecial(enterprise_id: $enterpriseId, id: $id) {
    success
    message
  }
}
    `;
export type GqlEndEnterpriseSpecialMutationFn = ApolloReactCommon.MutationFunction<GqlEndEnterpriseSpecialMutation, GqlEndEnterpriseSpecialMutationVariables>;

/**
 * __useEndEnterpriseSpecialMutation__
 *
 * To run a mutation, you first call `useEndEnterpriseSpecialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndEnterpriseSpecialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endEnterpriseSpecialMutation, { data, loading, error }] = useEndEnterpriseSpecialMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEndEnterpriseSpecialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlEndEnterpriseSpecialMutation, GqlEndEnterpriseSpecialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlEndEnterpriseSpecialMutation, GqlEndEnterpriseSpecialMutationVariables>(EndEnterpriseSpecialDocument, options);
      }
export type EndEnterpriseSpecialMutationHookResult = ReturnType<typeof useEndEnterpriseSpecialMutation>;
export type EndEnterpriseSpecialMutationResult = ApolloReactCommon.MutationResult<GqlEndEnterpriseSpecialMutation>;
export type EndEnterpriseSpecialMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlEndEnterpriseSpecialMutation, GqlEndEnterpriseSpecialMutationVariables>;
export const EndSpecialV2Document = gql`
    mutation EndSpecialV2($id: String!) {
  endSpecialV2(id: $id) {
    _id
  }
}
    `;
export type GqlEndSpecialV2MutationFn = ApolloReactCommon.MutationFunction<GqlEndSpecialV2Mutation, GqlEndSpecialV2MutationVariables>;

/**
 * __useEndSpecialV2Mutation__
 *
 * To run a mutation, you first call `useEndSpecialV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndSpecialV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endSpecialV2Mutation, { data, loading, error }] = useEndSpecialV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEndSpecialV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlEndSpecialV2Mutation, GqlEndSpecialV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlEndSpecialV2Mutation, GqlEndSpecialV2MutationVariables>(EndSpecialV2Document, options);
      }
export type EndSpecialV2MutationHookResult = ReturnType<typeof useEndSpecialV2Mutation>;
export type EndSpecialV2MutationResult = ApolloReactCommon.MutationResult<GqlEndSpecialV2Mutation>;
export type EndSpecialV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlEndSpecialV2Mutation, GqlEndSpecialV2MutationVariables>;
export const IncrementSpecialClicksDocument = gql`
    mutation IncrementSpecialClicks($input: incrementClicksInput!) {
  incrementClicks(special: $input) {
    message
    success
  }
}
    `;
export type GqlIncrementSpecialClicksMutationFn = ApolloReactCommon.MutationFunction<GqlIncrementSpecialClicksMutation, GqlIncrementSpecialClicksMutationVariables>;

/**
 * __useIncrementSpecialClicksMutation__
 *
 * To run a mutation, you first call `useIncrementSpecialClicksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncrementSpecialClicksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [incrementSpecialClicksMutation, { data, loading, error }] = useIncrementSpecialClicksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIncrementSpecialClicksMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlIncrementSpecialClicksMutation, GqlIncrementSpecialClicksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlIncrementSpecialClicksMutation, GqlIncrementSpecialClicksMutationVariables>(IncrementSpecialClicksDocument, options);
      }
export type IncrementSpecialClicksMutationHookResult = ReturnType<typeof useIncrementSpecialClicksMutation>;
export type IncrementSpecialClicksMutationResult = ApolloReactCommon.MutationResult<GqlIncrementSpecialClicksMutation>;
export type IncrementSpecialClicksMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlIncrementSpecialClicksMutation, GqlIncrementSpecialClicksMutationVariables>;
export const UpdateEnterpriseSpecialV2Document = gql`
    mutation UpdateEnterpriseSpecialV2($id: String!, $input: EnterpriseSpecialInputV2!) {
  updateEnterpriseSpecialV2(id: $id, input: $input) {
    message
    success
  }
}
    `;
export type GqlUpdateEnterpriseSpecialV2MutationFn = ApolloReactCommon.MutationFunction<GqlUpdateEnterpriseSpecialV2Mutation, GqlUpdateEnterpriseSpecialV2MutationVariables>;

/**
 * __useUpdateEnterpriseSpecialV2Mutation__
 *
 * To run a mutation, you first call `useUpdateEnterpriseSpecialV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnterpriseSpecialV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnterpriseSpecialV2Mutation, { data, loading, error }] = useUpdateEnterpriseSpecialV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnterpriseSpecialV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateEnterpriseSpecialV2Mutation, GqlUpdateEnterpriseSpecialV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateEnterpriseSpecialV2Mutation, GqlUpdateEnterpriseSpecialV2MutationVariables>(UpdateEnterpriseSpecialV2Document, options);
      }
export type UpdateEnterpriseSpecialV2MutationHookResult = ReturnType<typeof useUpdateEnterpriseSpecialV2Mutation>;
export type UpdateEnterpriseSpecialV2MutationResult = ApolloReactCommon.MutationResult<GqlUpdateEnterpriseSpecialV2Mutation>;
export type UpdateEnterpriseSpecialV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateEnterpriseSpecialV2Mutation, GqlUpdateEnterpriseSpecialV2MutationVariables>;
export const UpdateEnterpriseSpecialsSettingsDocument = gql`
    mutation UpdateEnterpriseSpecialsSettings($enterpriseId: ID!, $input: EnterpriseSpecialsSettingsInput!) {
  updateEnterpriseSpecialsSettings(enterpriseId: $enterpriseId, input: $input) {
    message
    success
  }
}
    `;
export type GqlUpdateEnterpriseSpecialsSettingsMutationFn = ApolloReactCommon.MutationFunction<GqlUpdateEnterpriseSpecialsSettingsMutation, GqlUpdateEnterpriseSpecialsSettingsMutationVariables>;

/**
 * __useUpdateEnterpriseSpecialsSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEnterpriseSpecialsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnterpriseSpecialsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnterpriseSpecialsSettingsMutation, { data, loading, error }] = useUpdateEnterpriseSpecialsSettingsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnterpriseSpecialsSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateEnterpriseSpecialsSettingsMutation, GqlUpdateEnterpriseSpecialsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateEnterpriseSpecialsSettingsMutation, GqlUpdateEnterpriseSpecialsSettingsMutationVariables>(UpdateEnterpriseSpecialsSettingsDocument, options);
      }
export type UpdateEnterpriseSpecialsSettingsMutationHookResult = ReturnType<typeof useUpdateEnterpriseSpecialsSettingsMutation>;
export type UpdateEnterpriseSpecialsSettingsMutationResult = ApolloReactCommon.MutationResult<GqlUpdateEnterpriseSpecialsSettingsMutation>;
export type UpdateEnterpriseSpecialsSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateEnterpriseSpecialsSettingsMutation, GqlUpdateEnterpriseSpecialsSettingsMutationVariables>;
export const UpdateSpecialV3Document = gql`
    mutation UpdateSpecialV3($id: String!, $input: SpecialsInputV3!) {
  updateSpecialV3(id: $id, input: $input) {
    _id
  }
}
    `;
export type GqlUpdateSpecialV3MutationFn = ApolloReactCommon.MutationFunction<GqlUpdateSpecialV3Mutation, GqlUpdateSpecialV3MutationVariables>;

/**
 * __useUpdateSpecialV3Mutation__
 *
 * To run a mutation, you first call `useUpdateSpecialV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialV3Mutation, { data, loading, error }] = useUpdateSpecialV3Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpecialV3Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateSpecialV3Mutation, GqlUpdateSpecialV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateSpecialV3Mutation, GqlUpdateSpecialV3MutationVariables>(UpdateSpecialV3Document, options);
      }
export type UpdateSpecialV3MutationHookResult = ReturnType<typeof useUpdateSpecialV3Mutation>;
export type UpdateSpecialV3MutationResult = ApolloReactCommon.MutationResult<GqlUpdateSpecialV3Mutation>;
export type UpdateSpecialV3MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateSpecialV3Mutation, GqlUpdateSpecialV3MutationVariables>;
export const UpdateSpecialsSortOrderDocument = gql`
    mutation UpdateSpecialsSortOrder($input: SortOrderInput!) {
  updateSpecialsSortOrder(input: $input) {
    message
    success
  }
}
    `;
export type GqlUpdateSpecialsSortOrderMutationFn = ApolloReactCommon.MutationFunction<GqlUpdateSpecialsSortOrderMutation, GqlUpdateSpecialsSortOrderMutationVariables>;

/**
 * __useUpdateSpecialsSortOrderMutation__
 *
 * To run a mutation, you first call `useUpdateSpecialsSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialsSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialsSortOrderMutation, { data, loading, error }] = useUpdateSpecialsSortOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpecialsSortOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateSpecialsSortOrderMutation, GqlUpdateSpecialsSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateSpecialsSortOrderMutation, GqlUpdateSpecialsSortOrderMutationVariables>(UpdateSpecialsSortOrderDocument, options);
      }
export type UpdateSpecialsSortOrderMutationHookResult = ReturnType<typeof useUpdateSpecialsSortOrderMutation>;
export type UpdateSpecialsSortOrderMutationResult = ApolloReactCommon.MutationResult<GqlUpdateSpecialsSortOrderMutation>;
export type UpdateSpecialsSortOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateSpecialsSortOrderMutation, GqlUpdateSpecialsSortOrderMutationVariables>;
export const EnterpriseSpecialsV3Document = gql`
    query EnterpriseSpecialsV3($enterpriseId: ID!, $filter: filteredSpecialsInputV2) {
  enterpriseSpecialsV3(enterpriseId: $enterpriseId, filter: $filter) {
    queryInfo {
      totalCount
    }
    specials {
      _id
      active
      applyRewardsToConditions
      excludeConditionItemsFromRewards
      bogoConditionLogicOperator
      bogoConditions {
        _id
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          productTags
          matchOperator
          productGroup
          productIds
          productTags
          subcategoryIds
          subcategoryNames
          strainIds
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productTags
        productGroup
        productId
        productIds
        productTags
        quantity
        requiresSingleSku
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      bogoRewardLogicOperator
      bogoRewards {
        _id
        applicationRules {
          _id
          comparisonOperator
          quantity
          applicationType
        }
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        dollarDiscount
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          subcategoryIds
          subcategoryNames
          strainIds
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        percentDiscount
        productTags
        quantity
        requiresSingleSku
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        targetPrice
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      cipher
      clicks
      complete
      createdAt
      createdBy
      description
      descriptionHtml
      discount
      discountedPrices
      discountToCart {
        _id
        enabled
        discountType
        value
      }
      displayRank
      earliestStartStamp
      emailSpecial
      endDay
      endStamp
      endTime
      enterpriseId
      enterpriseSpecialId
      excludedProducts {
        _id
        Name
        key
        conditions {
          _id
          Name
          key
        }
        rewards {
          _id
          Name
          key
        }
      }
      heading
      isRecurring
      itemsForAPrice {
        _id
        enabled
        value
      }
      latestEndStamp
      localTime
      menuDisplayDescription
      menuDisplayName
      menuDisplayImage
      menuType
      name
      percentDiscount
      productDiscounts
      productGroup
      productGroupRewards
      products
      recurring {
        days
        endDate
        endTime
        setEndDate
        startTime
      }
      redemptionLimit
      retailers
      saleDiscounts {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          subcategoryIds
          subcategoryNames
          strainIds
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        weights
        weightOperator
      }
      scope
      source
      sourceId
      specialRestrictions
      specialType
      startDay
      startStamp
      startTime
      subject
      targetPrice
      timezone
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      updatedAt
      updatedBy
      version
    }
  }
}
    `;

/**
 * __useEnterpriseSpecialsV3Query__
 *
 * To run a query within a React component, call `useEnterpriseSpecialsV3Query` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseSpecialsV3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseSpecialsV3Query({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEnterpriseSpecialsV3Query(baseOptions: ApolloReactHooks.QueryHookOptions<GqlEnterpriseSpecialsV3Query, GqlEnterpriseSpecialsV3QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlEnterpriseSpecialsV3Query, GqlEnterpriseSpecialsV3QueryVariables>(EnterpriseSpecialsV3Document, options);
      }
export function useEnterpriseSpecialsV3LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlEnterpriseSpecialsV3Query, GqlEnterpriseSpecialsV3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlEnterpriseSpecialsV3Query, GqlEnterpriseSpecialsV3QueryVariables>(EnterpriseSpecialsV3Document, options);
        }
export type EnterpriseSpecialsV3QueryHookResult = ReturnType<typeof useEnterpriseSpecialsV3Query>;
export type EnterpriseSpecialsV3LazyQueryHookResult = ReturnType<typeof useEnterpriseSpecialsV3LazyQuery>;
export type EnterpriseSpecialsV3QueryResult = ApolloReactCommon.QueryResult<GqlEnterpriseSpecialsV3Query, GqlEnterpriseSpecialsV3QueryVariables>;
export const EnterpriseSpecialsDocument = gql`
    query EnterpriseSpecials($enterpriseId: ID!) {
  enterpriseSpecials(enterpriseId: $enterpriseId) {
    _id
    active
    applyRewardsToConditions
    excludeConditionItemsFromRewards
    bogoConditionLogicOperator
    bogoConditions {
      _id
      brandId
      brandIds
      brandName
      brandNames
      categoryIds
      categoryName
      categoryNames
      enterpriseProductIds
      exclusions {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        enterpriseProductIds
        inventoryTags
        matchOperator
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        weights
        weightOperator
      }
      inventoryTags
      productGroup
      productId
      productIds
      productTags
      quantity
      requiresSingleSku
      subcategoryIds
      subcategoryNames
      strainIds
      vendorIds
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      weight
      weights
      weightOperator
    }
    bogoRewardLogicOperator
    bogoRewards {
      _id
      applicationRules {
        _id
        comparisonOperator
        quantity
        applicationType
      }
      brandId
      brandIds
      brandName
      brandNames
      categoryIds
      categoryName
      categoryNames
      dollarDiscount
      discountAmount
      discountType
      enterpriseProductIds
      exclusions {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        enterpriseProductIds
        inventoryTags
        matchOperator
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        weights
        weightOperator
      }
      inventoryTags
      productGroup
      productId
      productIds
      productTags
      percentDiscount
      productTags
      quantity
      subcategoryIds
      subcategoryNames
      strainIds
      vendorIds
      requiresSingleSku
      targetPrice
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      weight
      weights
      weightOperator
    }
    cipher
    clicks
    createdAt
    createdBy
    description
    descriptionHtml
    discount
    discountedPrices
    discountToCart {
      _id
      enabled
      discountType
      value
    }
    displayRank
    emailSpecial
    endDay
    endStamp
    endTime
    enterpriseId
    enterpriseSpecialId
    excludedProducts {
      _id
      Name
      key
      conditions {
        _id
        Name
        key
      }
      rewards {
        _id
        Name
        key
      }
    }
    heading
    isRecurring
    itemsForAPrice {
      _id
      enabled
      value
    }
    localTime
    menuDisplayDescription
    menuDisplayName
    menuDisplayImage
    menuType
    name
    percentDiscount
    productDiscounts
    productGroup
    productGroupRewards
    products
    recurring {
      days
      endDate
      endTime
      setEndDate
      startTime
    }
    redemptionLimit
    retailers
    saleDiscounts {
      _id
      brandIds
      brandNames
      categoryIds
      categoryNames
      discountAmount
      discountType
      enterpriseProductIds
      exclusions {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        enterpriseProductIds
        inventoryTags
        matchOperator
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        weights
        weightOperator
      }
      inventoryTags
      productGroup
      productIds
      productTags
      subcategoryIds
      subcategoryNames
      strainIds
      vendorIds
      weights
      weightOperator
    }
    scope
    source
    sourceId
    specialRestrictions
    specialType
    startDay
    startStamp
    startTime
    subject
    targetPrice
    timezone
    totalQuantity {
      enabled
      maxQuantity
      quantity
      quantityOperator
    }
    totalWeight {
      enabled
      weight
      weightOperator
    }
    totalSpend {
      enabled
      maximumSpend
      minimumSpend
      spendOperator
    }
    updatedAt
    updatedBy
    version
  }
}
    `;

/**
 * __useEnterpriseSpecialsQuery__
 *
 * To run a query within a React component, call `useEnterpriseSpecialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseSpecialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseSpecialsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseSpecialsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlEnterpriseSpecialsQuery, GqlEnterpriseSpecialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlEnterpriseSpecialsQuery, GqlEnterpriseSpecialsQueryVariables>(EnterpriseSpecialsDocument, options);
      }
export function useEnterpriseSpecialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlEnterpriseSpecialsQuery, GqlEnterpriseSpecialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlEnterpriseSpecialsQuery, GqlEnterpriseSpecialsQueryVariables>(EnterpriseSpecialsDocument, options);
        }
export type EnterpriseSpecialsQueryHookResult = ReturnType<typeof useEnterpriseSpecialsQuery>;
export type EnterpriseSpecialsLazyQueryHookResult = ReturnType<typeof useEnterpriseSpecialsLazyQuery>;
export type EnterpriseSpecialsQueryResult = ApolloReactCommon.QueryResult<GqlEnterpriseSpecialsQuery, GqlEnterpriseSpecialsQueryVariables>;
export const FilteredSpecialsV2Document = gql`
    query FilteredSpecialsV2($specialsFilter: filteredSpecialsInput!, $translateSpecialsToV3: Boolean = false) {
  filteredSpecialsV2(
    filter: $specialsFilter
    translateSpecialsToV3: $translateSpecialsToV3
  ) {
    queryInfo {
      totalCount
    }
    specials {
      _id
      active
      applyRewardsToConditions
      excludeConditionItemsFromRewards
      menuDisplayName
      menuDisplayDescription
      bogoConditionLogicOperator
      menuDisplayImage
      bogoConditions {
        _id
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        productTags
        quantity
        requiresSingleSku
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      bogoRewardLogicOperator
      bogoRewards {
        _id
        applicationRules {
          _id
          comparisonOperator
          quantity
          applicationType
        }
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        dollarDiscount
        discountAmount
        discountType
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        percentDiscount
        productTags
        quantity
        requiresSingleSku
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        targetPrice
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      clicks
      createdAt
      createdBy
      description
      descriptionHtml
      directPOSProductIdMapping
      rawPOSWeightMapping
      discount
      discountedPrices
      discountPrecedence
      discountStacking
      discountToCart {
        _id
        enabled
        discountType
        value
      }
      dispensaryId
      displayRank
      emailSpecial
      endDay
      endStamp
      endTime
      excludedProducts {
        _id
        Name
        key
        conditions {
          _id
          Name
          key
        }
        rewards {
          _id
          Name
          key
        }
      }
      heading
      isRecurring
      itemsForAPrice {
        _id
        enabled
        value
      }
      discountBundle {
        _id
        applyTo
        discountType
        enabled
        limit
        value
      }
      menuType
      minorVersion
      name
      nonStackingBehavior
      paymentRestrictions {
        payByBankSignupIncentive
      }
      platformType
      preOrderType
      percentDiscount
      productDiscounts
      productGroup
      productGroupRewards
      products
      recurring {
        days
        endDate
        endTime
        setEndDate
        startTime
      }
      redemptionLimit
      saleDiscounts {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productIds
        productTags
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        weights
        weightOperator
      }
      scope
      source
      sourceId
      specialId
      specialRestrictions
      specialType
      stackingBehavior
      stackingMode
      startDate
      startDay
      startStamp
      startTime
      subject
      targetPrice
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      updatedAt
      updatedBy
      version
    }
  }
}
    `;

/**
 * __useFilteredSpecialsV2Query__
 *
 * To run a query within a React component, call `useFilteredSpecialsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useFilteredSpecialsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredSpecialsV2Query({
 *   variables: {
 *      specialsFilter: // value for 'specialsFilter'
 *      translateSpecialsToV3: // value for 'translateSpecialsToV3'
 *   },
 * });
 */
export function useFilteredSpecialsV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GqlFilteredSpecialsV2Query, GqlFilteredSpecialsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlFilteredSpecialsV2Query, GqlFilteredSpecialsV2QueryVariables>(FilteredSpecialsV2Document, options);
      }
export function useFilteredSpecialsV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlFilteredSpecialsV2Query, GqlFilteredSpecialsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlFilteredSpecialsV2Query, GqlFilteredSpecialsV2QueryVariables>(FilteredSpecialsV2Document, options);
        }
export type FilteredSpecialsV2QueryHookResult = ReturnType<typeof useFilteredSpecialsV2Query>;
export type FilteredSpecialsV2LazyQueryHookResult = ReturnType<typeof useFilteredSpecialsV2LazyQuery>;
export type FilteredSpecialsV2QueryResult = ApolloReactCommon.QueryResult<GqlFilteredSpecialsV2Query, GqlFilteredSpecialsV2QueryVariables>;
export const FilteredSpecialsDocument = gql`
    query FilteredSpecials($specialsFilter: filteredSpecialsInput!, $includeEnterpriseSpecials: Boolean = false) {
  filteredSpecials(
    filter: $specialsFilter
    includeEnterpriseSpecials: $includeEnterpriseSpecials
  ) {
    queryInfo {
      totalCount
    }
    specials {
      _id
      active
      applyRewardsToConditions
      excludeConditionItemsFromRewards
      menuDisplayName
      menuDisplayDescription
      bogoConditionLogicOperator
      menuDisplayImage
      bogoConditions {
        _id
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          inventoryTags
          enterpriseProductIds
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        productTags
        quantity
        requiresSingleSku
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      bogoRewardLogicOperator
      bogoRewards {
        _id
        applicationRules {
          _id
          comparisonOperator
          quantity
          applicationType
        }
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        dollarDiscount
        discountAmount
        discountType
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          inventoryTags
          enterpriseProductIds
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        productTags
        percentDiscount
        quantity
        strainIds
        subcategoryIds
        subcategoryNames
        requiresSingleSku
        targetPrice
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        vendorIds
        weight
        weights
        weightOperator
      }
      clicks
      createdAt
      createdBy
      description
      descriptionHtml
      directPOSProductIdMapping
      rawPOSWeightMapping
      discount
      discountedPrices
      discountPrecedence
      discountStacking
      discountToCart {
        _id
        enabled
        discountType
        value
      }
      dispensaryId
      displayRank
      emailSpecial
      endDay
      endStamp
      endTime
      excludedProducts {
        _id
        Name
        key
        conditions {
          _id
          Name
          key
        }
        rewards {
          _id
          Name
          key
        }
      }
      heading
      isRecurring
      itemsForAPrice {
        _id
        enabled
        value
      }
      discountBundle {
        _id
        applyTo
        discountType
        enabled
        limit
        value
      }
      menuType
      minorVersion
      name
      nonStackingBehavior
      paymentRestrictions {
        payByBankSignupIncentive
      }
      platformType
      preOrderType
      percentDiscount
      productDiscounts
      productGroup
      productGroupRewards
      products
      recurring {
        days
        endDate
        endTime
        setEndDate
        startTime
      }
      redemptionLimit
      saleDiscounts {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        inventoryTags
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productIds
        productTags
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        weights
        weightOperator
      }
      scope
      source
      sourceId
      specialId
      specialRestrictions
      specialType
      stackingBehavior
      stackingMode
      startDate
      startDay
      startStamp
      startTime
      subject
      targetPrice
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      updatedAt
      updatedBy
      version
    }
  }
}
    `;

/**
 * __useFilteredSpecialsQuery__
 *
 * To run a query within a React component, call `useFilteredSpecialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredSpecialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredSpecialsQuery({
 *   variables: {
 *      specialsFilter: // value for 'specialsFilter'
 *      includeEnterpriseSpecials: // value for 'includeEnterpriseSpecials'
 *   },
 * });
 */
export function useFilteredSpecialsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlFilteredSpecialsQuery, GqlFilteredSpecialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlFilteredSpecialsQuery, GqlFilteredSpecialsQueryVariables>(FilteredSpecialsDocument, options);
      }
export function useFilteredSpecialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlFilteredSpecialsQuery, GqlFilteredSpecialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlFilteredSpecialsQuery, GqlFilteredSpecialsQueryVariables>(FilteredSpecialsDocument, options);
        }
export type FilteredSpecialsQueryHookResult = ReturnType<typeof useFilteredSpecialsQuery>;
export type FilteredSpecialsLazyQueryHookResult = ReturnType<typeof useFilteredSpecialsLazyQuery>;
export type FilteredSpecialsQueryResult = ApolloReactCommon.QueryResult<GqlFilteredSpecialsQuery, GqlFilteredSpecialsQueryVariables>;
export const GetSpecialGamificationDocument = gql`
    query GetSpecialGamification($dispensaryId: String, $menuType: String, $specialIds: [String]) {
  getSpecialGamification(
    dispensaryId: $dispensaryId
    menuType: $menuType
    specialIds: $specialIds
  ) {
    gamificationThresholds {
      discountId
      satisfiers {
        thresholdType
        minimumThreshold
      }
    }
  }
}
    `;

/**
 * __useGetSpecialGamificationQuery__
 *
 * To run a query within a React component, call `useGetSpecialGamificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialGamificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialGamificationQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      menuType: // value for 'menuType'
 *      specialIds: // value for 'specialIds'
 *   },
 * });
 */
export function useGetSpecialGamificationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetSpecialGamificationQuery, GqlGetSpecialGamificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetSpecialGamificationQuery, GqlGetSpecialGamificationQueryVariables>(GetSpecialGamificationDocument, options);
      }
export function useGetSpecialGamificationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetSpecialGamificationQuery, GqlGetSpecialGamificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetSpecialGamificationQuery, GqlGetSpecialGamificationQueryVariables>(GetSpecialGamificationDocument, options);
        }
export type GetSpecialGamificationQueryHookResult = ReturnType<typeof useGetSpecialGamificationQuery>;
export type GetSpecialGamificationLazyQueryHookResult = ReturnType<typeof useGetSpecialGamificationLazyQuery>;
export type GetSpecialGamificationQueryResult = ApolloReactCommon.QueryResult<GqlGetSpecialGamificationQuery, GqlGetSpecialGamificationQueryVariables>;
export const GetSpecialMenuCardsDocument = gql`
    query GetSpecialMenuCards($dispensaryId: ID!, $menuType: String!, $specialId: String) {
  getSpecialMenuCards(
    dispensaryId: $dispensaryId
    menuType: $menuType
    specialId: $specialId
  ) {
    menuCards {
      _id
      displayRank
      menuDisplayName
      menuDisplayDescription
      menuDisplayImage
      posDiscountId
      specialType
    }
  }
}
    `;

/**
 * __useGetSpecialMenuCardsQuery__
 *
 * To run a query within a React component, call `useGetSpecialMenuCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialMenuCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialMenuCardsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      menuType: // value for 'menuType'
 *      specialId: // value for 'specialId'
 *   },
 * });
 */
export function useGetSpecialMenuCardsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetSpecialMenuCardsQuery, GqlGetSpecialMenuCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetSpecialMenuCardsQuery, GqlGetSpecialMenuCardsQueryVariables>(GetSpecialMenuCardsDocument, options);
      }
export function useGetSpecialMenuCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetSpecialMenuCardsQuery, GqlGetSpecialMenuCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetSpecialMenuCardsQuery, GqlGetSpecialMenuCardsQueryVariables>(GetSpecialMenuCardsDocument, options);
        }
export type GetSpecialMenuCardsQueryHookResult = ReturnType<typeof useGetSpecialMenuCardsQuery>;
export type GetSpecialMenuCardsLazyQueryHookResult = ReturnType<typeof useGetSpecialMenuCardsLazyQuery>;
export type GetSpecialMenuCardsQueryResult = ApolloReactCommon.QueryResult<GqlGetSpecialMenuCardsQuery, GqlGetSpecialMenuCardsQueryVariables>;
export const GetStockImageDocument = gql`
    query getStockImage($category: String, $productName: String) {
  getStockImage(category: $category, productName: $productName) {
    url
  }
}
    `;

/**
 * __useGetStockImageQuery__
 *
 * To run a query within a React component, call `useGetStockImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockImageQuery({
 *   variables: {
 *      category: // value for 'category'
 *      productName: // value for 'productName'
 *   },
 * });
 */
export function useGetStockImageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetStockImageQuery, GqlGetStockImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetStockImageQuery, GqlGetStockImageQueryVariables>(GetStockImageDocument, options);
      }
export function useGetStockImageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetStockImageQuery, GqlGetStockImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetStockImageQuery, GqlGetStockImageQueryVariables>(GetStockImageDocument, options);
        }
export type GetStockImageQueryHookResult = ReturnType<typeof useGetStockImageQuery>;
export type GetStockImageLazyQueryHookResult = ReturnType<typeof useGetStockImageLazyQuery>;
export type GetStockImageQueryResult = ApolloReactCommon.QueryResult<GqlGetStockImageQuery, GqlGetStockImageQueryVariables>;
export const CreateStrainV2Document = gql`
    mutation CreateStrainV2($input: strainInput!) {
  createStrainV2(strain: $input) {
    id
  }
}
    `;
export type GqlCreateStrainV2MutationFn = ApolloReactCommon.MutationFunction<GqlCreateStrainV2Mutation, GqlCreateStrainV2MutationVariables>;

/**
 * __useCreateStrainV2Mutation__
 *
 * To run a mutation, you first call `useCreateStrainV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStrainV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStrainV2Mutation, { data, loading, error }] = useCreateStrainV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStrainV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateStrainV2Mutation, GqlCreateStrainV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateStrainV2Mutation, GqlCreateStrainV2MutationVariables>(CreateStrainV2Document, options);
      }
export type CreateStrainV2MutationHookResult = ReturnType<typeof useCreateStrainV2Mutation>;
export type CreateStrainV2MutationResult = ApolloReactCommon.MutationResult<GqlCreateStrainV2Mutation>;
export type CreateStrainV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateStrainV2Mutation, GqlCreateStrainV2MutationVariables>;
export const DeleteStrainDocument = gql`
    mutation DeleteStrain($id: String!) {
  deleteStrain(id: $id) {
    id
  }
}
    `;
export type GqlDeleteStrainMutationFn = ApolloReactCommon.MutationFunction<GqlDeleteStrainMutation, GqlDeleteStrainMutationVariables>;

/**
 * __useDeleteStrainMutation__
 *
 * To run a mutation, you first call `useDeleteStrainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStrainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStrainMutation, { data, loading, error }] = useDeleteStrainMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStrainMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlDeleteStrainMutation, GqlDeleteStrainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlDeleteStrainMutation, GqlDeleteStrainMutationVariables>(DeleteStrainDocument, options);
      }
export type DeleteStrainMutationHookResult = ReturnType<typeof useDeleteStrainMutation>;
export type DeleteStrainMutationResult = ApolloReactCommon.MutationResult<GqlDeleteStrainMutation>;
export type DeleteStrainMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlDeleteStrainMutation, GqlDeleteStrainMutationVariables>;
export const UpdateStrainV2Document = gql`
    mutation UpdateStrainV2($id: String!, $input: strainInput!) {
  updateStrainV2(id: $id, strain: $input) {
    id
  }
}
    `;
export type GqlUpdateStrainV2MutationFn = ApolloReactCommon.MutationFunction<GqlUpdateStrainV2Mutation, GqlUpdateStrainV2MutationVariables>;

/**
 * __useUpdateStrainV2Mutation__
 *
 * To run a mutation, you first call `useUpdateStrainV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStrainV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStrainV2Mutation, { data, loading, error }] = useUpdateStrainV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStrainV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateStrainV2Mutation, GqlUpdateStrainV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateStrainV2Mutation, GqlUpdateStrainV2MutationVariables>(UpdateStrainV2Document, options);
      }
export type UpdateStrainV2MutationHookResult = ReturnType<typeof useUpdateStrainV2Mutation>;
export type UpdateStrainV2MutationResult = ApolloReactCommon.MutationResult<GqlUpdateStrainV2Mutation>;
export type UpdateStrainV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateStrainV2Mutation, GqlUpdateStrainV2MutationVariables>;
export const FilteredStrainsDocument = gql`
    query FilteredStrains($filter: strainsFilterInput, $sort: strainsSortInput, $pagination: paginationInput) {
  filteredStrains(filter: $filter, sort: $sort, pagination: $pagination) {
    queryInfo {
      totalCount
    }
    strains {
      description
      effects
      id
      imageUrl
      name
      potentialHealthBenefits
    }
  }
}
    `;

/**
 * __useFilteredStrainsQuery__
 *
 * To run a query within a React component, call `useFilteredStrainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredStrainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredStrainsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFilteredStrainsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlFilteredStrainsQuery, GqlFilteredStrainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlFilteredStrainsQuery, GqlFilteredStrainsQueryVariables>(FilteredStrainsDocument, options);
      }
export function useFilteredStrainsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlFilteredStrainsQuery, GqlFilteredStrainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlFilteredStrainsQuery, GqlFilteredStrainsQueryVariables>(FilteredStrainsDocument, options);
        }
export type FilteredStrainsQueryHookResult = ReturnType<typeof useFilteredStrainsQuery>;
export type FilteredStrainsLazyQueryHookResult = ReturnType<typeof useFilteredStrainsLazyQuery>;
export type FilteredStrainsQueryResult = ApolloReactCommon.QueryResult<GqlFilteredStrainsQuery, GqlFilteredStrainsQueryVariables>;
export const GetStrainDocument = gql`
    query GetStrain($id: String!) {
  getStrain(id: $id) {
    aromas
    description
    effects
    id
    imageUrl
    labels
    name
    potentialHealthBenefits
    ratio
    terpenes {
      id
      name
    }
  }
}
    `;

/**
 * __useGetStrainQuery__
 *
 * To run a query within a React component, call `useGetStrainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStrainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStrainQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStrainQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetStrainQuery, GqlGetStrainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetStrainQuery, GqlGetStrainQueryVariables>(GetStrainDocument, options);
      }
export function useGetStrainLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetStrainQuery, GqlGetStrainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetStrainQuery, GqlGetStrainQueryVariables>(GetStrainDocument, options);
        }
export type GetStrainQueryHookResult = ReturnType<typeof useGetStrainQuery>;
export type GetStrainLazyQueryHookResult = ReturnType<typeof useGetStrainLazyQuery>;
export type GetStrainQueryResult = ApolloReactCommon.QueryResult<GqlGetStrainQuery, GqlGetStrainQueryVariables>;
export const GetCustomerSubscriptionsDocument = gql`
    query GetCustomerSubscriptions {
  getCustomerSubscriptions {
    dispensaryId
    dispensaryName
    emailOptIn
    emailSubscription
    id
  }
}
    `;

/**
 * __useGetCustomerSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetCustomerSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerSubscriptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetCustomerSubscriptionsQuery, GqlGetCustomerSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetCustomerSubscriptionsQuery, GqlGetCustomerSubscriptionsQueryVariables>(GetCustomerSubscriptionsDocument, options);
      }
export function useGetCustomerSubscriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetCustomerSubscriptionsQuery, GqlGetCustomerSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetCustomerSubscriptionsQuery, GqlGetCustomerSubscriptionsQueryVariables>(GetCustomerSubscriptionsDocument, options);
        }
export type GetCustomerSubscriptionsQueryHookResult = ReturnType<typeof useGetCustomerSubscriptionsQuery>;
export type GetCustomerSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetCustomerSubscriptionsLazyQuery>;
export type GetCustomerSubscriptionsQueryResult = ApolloReactCommon.QueryResult<GqlGetCustomerSubscriptionsQuery, GqlGetCustomerSubscriptionsQueryVariables>;
export const GetUnsubscribeDispensaryDocument = gql`
    query GetUnsubscribeDispensary($customerId: String!) {
  unsubscribeCustomerQuery(customerId: $customerId) {
    subscribed
    dispensary {
      name
      logoImage
    }
  }
}
    `;

/**
 * __useGetUnsubscribeDispensaryQuery__
 *
 * To run a query within a React component, call `useGetUnsubscribeDispensaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnsubscribeDispensaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnsubscribeDispensaryQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetUnsubscribeDispensaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetUnsubscribeDispensaryQuery, GqlGetUnsubscribeDispensaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetUnsubscribeDispensaryQuery, GqlGetUnsubscribeDispensaryQueryVariables>(GetUnsubscribeDispensaryDocument, options);
      }
export function useGetUnsubscribeDispensaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetUnsubscribeDispensaryQuery, GqlGetUnsubscribeDispensaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetUnsubscribeDispensaryQuery, GqlGetUnsubscribeDispensaryQueryVariables>(GetUnsubscribeDispensaryDocument, options);
        }
export type GetUnsubscribeDispensaryQueryHookResult = ReturnType<typeof useGetUnsubscribeDispensaryQuery>;
export type GetUnsubscribeDispensaryLazyQueryHookResult = ReturnType<typeof useGetUnsubscribeDispensaryLazyQuery>;
export type GetUnsubscribeDispensaryQueryResult = ApolloReactCommon.QueryResult<GqlGetUnsubscribeDispensaryQuery, GqlGetUnsubscribeDispensaryQueryVariables>;
export const CreateTerpeneDocument = gql`
    mutation CreateTerpene($terpene: terpeneInput!) {
  createTerpeneV2(terpene: $terpene) {
    id
  }
}
    `;
export type GqlCreateTerpeneMutationFn = ApolloReactCommon.MutationFunction<GqlCreateTerpeneMutation, GqlCreateTerpeneMutationVariables>;

/**
 * __useCreateTerpeneMutation__
 *
 * To run a mutation, you first call `useCreateTerpeneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTerpeneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTerpeneMutation, { data, loading, error }] = useCreateTerpeneMutation({
 *   variables: {
 *      terpene: // value for 'terpene'
 *   },
 * });
 */
export function useCreateTerpeneMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateTerpeneMutation, GqlCreateTerpeneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateTerpeneMutation, GqlCreateTerpeneMutationVariables>(CreateTerpeneDocument, options);
      }
export type CreateTerpeneMutationHookResult = ReturnType<typeof useCreateTerpeneMutation>;
export type CreateTerpeneMutationResult = ApolloReactCommon.MutationResult<GqlCreateTerpeneMutation>;
export type CreateTerpeneMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateTerpeneMutation, GqlCreateTerpeneMutationVariables>;
export const DeleteTerpeneDocument = gql`
    mutation DeleteTerpene($id: String!) {
  deleteTerpene(id: $id) {
    id
  }
}
    `;
export type GqlDeleteTerpeneMutationFn = ApolloReactCommon.MutationFunction<GqlDeleteTerpeneMutation, GqlDeleteTerpeneMutationVariables>;

/**
 * __useDeleteTerpeneMutation__
 *
 * To run a mutation, you first call `useDeleteTerpeneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTerpeneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTerpeneMutation, { data, loading, error }] = useDeleteTerpeneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTerpeneMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlDeleteTerpeneMutation, GqlDeleteTerpeneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlDeleteTerpeneMutation, GqlDeleteTerpeneMutationVariables>(DeleteTerpeneDocument, options);
      }
export type DeleteTerpeneMutationHookResult = ReturnType<typeof useDeleteTerpeneMutation>;
export type DeleteTerpeneMutationResult = ApolloReactCommon.MutationResult<GqlDeleteTerpeneMutation>;
export type DeleteTerpeneMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlDeleteTerpeneMutation, GqlDeleteTerpeneMutationVariables>;
export const UpdateTerpeneDocument = gql`
    mutation UpdateTerpene($id: String!, $terpene: terpeneInput!) {
  updateTerpeneV2(id: $id, terpene: $terpene) {
    id
  }
}
    `;
export type GqlUpdateTerpeneMutationFn = ApolloReactCommon.MutationFunction<GqlUpdateTerpeneMutation, GqlUpdateTerpeneMutationVariables>;

/**
 * __useUpdateTerpeneMutation__
 *
 * To run a mutation, you first call `useUpdateTerpeneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTerpeneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTerpeneMutation, { data, loading, error }] = useUpdateTerpeneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      terpene: // value for 'terpene'
 *   },
 * });
 */
export function useUpdateTerpeneMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateTerpeneMutation, GqlUpdateTerpeneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateTerpeneMutation, GqlUpdateTerpeneMutationVariables>(UpdateTerpeneDocument, options);
      }
export type UpdateTerpeneMutationHookResult = ReturnType<typeof useUpdateTerpeneMutation>;
export type UpdateTerpeneMutationResult = ApolloReactCommon.MutationResult<GqlUpdateTerpeneMutation>;
export type UpdateTerpeneMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateTerpeneMutation, GqlUpdateTerpeneMutationVariables>;
export const FilteredTerpenesDocument = gql`
    query FilteredTerpenes($filter: terpenesFilter, $sort: terpenesSort) {
  filteredTerpenes(filter: $filter, sort: $sort) {
    ...TerpeneFragment
    strains {
      _id
    }
  }
}
    ${TerpeneFragmentFragmentDoc}`;

/**
 * __useFilteredTerpenesQuery__
 *
 * To run a query within a React component, call `useFilteredTerpenesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTerpenesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredTerpenesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFilteredTerpenesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlFilteredTerpenesQuery, GqlFilteredTerpenesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlFilteredTerpenesQuery, GqlFilteredTerpenesQueryVariables>(FilteredTerpenesDocument, options);
      }
export function useFilteredTerpenesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlFilteredTerpenesQuery, GqlFilteredTerpenesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlFilteredTerpenesQuery, GqlFilteredTerpenesQueryVariables>(FilteredTerpenesDocument, options);
        }
export type FilteredTerpenesQueryHookResult = ReturnType<typeof useFilteredTerpenesQuery>;
export type FilteredTerpenesLazyQueryHookResult = ReturnType<typeof useFilteredTerpenesLazyQuery>;
export type FilteredTerpenesQueryResult = ApolloReactCommon.QueryResult<GqlFilteredTerpenesQuery, GqlFilteredTerpenesQueryVariables>;
export const GetTerpeneDocument = gql`
    query GetTerpene($id: String!) {
  getTerpene(id: $id) {
    ...TerpeneFragment
  }
}
    ${TerpeneFragmentFragmentDoc}`;

/**
 * __useGetTerpeneQuery__
 *
 * To run a query within a React component, call `useGetTerpeneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTerpeneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTerpeneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTerpeneQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetTerpeneQuery, GqlGetTerpeneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetTerpeneQuery, GqlGetTerpeneQueryVariables>(GetTerpeneDocument, options);
      }
export function useGetTerpeneLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetTerpeneQuery, GqlGetTerpeneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetTerpeneQuery, GqlGetTerpeneQueryVariables>(GetTerpeneDocument, options);
        }
export type GetTerpeneQueryHookResult = ReturnType<typeof useGetTerpeneQuery>;
export type GetTerpeneLazyQueryHookResult = ReturnType<typeof useGetTerpeneLazyQuery>;
export type GetTerpeneQueryResult = ApolloReactCommon.QueryResult<GqlGetTerpeneQuery, GqlGetTerpeneQueryVariables>;
export const ConsumerSignupDocument = gql`
    mutation ConsumerSignup($input: consumerSignupInput!, $turnstileToken: String, $publicContextSessionId: String) {
  consumerSignup(
    input: $input
    turnstileToken: $turnstileToken
    publicContextSessionId: $publicContextSessionId
  ) {
    accessToken
    user {
      _id
      emails {
        address
      }
      profile {
        birthday
        emailNotifications
        emailOptIn
        firstName
        lastName
        medicalCard {
          expirationDate
          number
          state
        }
        phone
        photoId
        textNotifications
      }
    }
  }
}
    `;
export type GqlConsumerSignupMutationFn = ApolloReactCommon.MutationFunction<GqlConsumerSignupMutation, GqlConsumerSignupMutationVariables>;

/**
 * __useConsumerSignupMutation__
 *
 * To run a mutation, you first call `useConsumerSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerSignupMutation, { data, loading, error }] = useConsumerSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *      turnstileToken: // value for 'turnstileToken'
 *      publicContextSessionId: // value for 'publicContextSessionId'
 *   },
 * });
 */
export function useConsumerSignupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlConsumerSignupMutation, GqlConsumerSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlConsumerSignupMutation, GqlConsumerSignupMutationVariables>(ConsumerSignupDocument, options);
      }
export type ConsumerSignupMutationHookResult = ReturnType<typeof useConsumerSignupMutation>;
export type ConsumerSignupMutationResult = ApolloReactCommon.MutationResult<GqlConsumerSignupMutation>;
export type ConsumerSignupMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlConsumerSignupMutation, GqlConsumerSignupMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: usersCreateInput!) {
  createUser(user: $input) {
    audioNotificationsOnNewArrivalsDisabled
    audioNotificationsOnNewOrdersDisabled
    chainID
    createdAt
    createdBy
    dispensaryId
    email
    fullName
    permissions {
      allLocations
      analytics
      billing
      customers
      dispensaryIds
      driver
      menu
      menuReview
      orders
      promote
      settings
      superMenuReview
      users
    }
    phone
    roleAtDispensary
    type
  }
}
    `;
export type GqlCreateUserMutationFn = ApolloReactCommon.MutationFunction<GqlCreateUserMutation, GqlCreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateUserMutation, GqlCreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateUserMutation, GqlCreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = ApolloReactCommon.MutationResult<GqlCreateUserMutation>;
export type CreateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateUserMutation, GqlCreateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($input: usersDeleteInput!) {
  deleteUser(user: $input) {
    fullName
  }
}
    `;
export type GqlDeleteUserMutationFn = ApolloReactCommon.MutationFunction<GqlDeleteUserMutation, GqlDeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlDeleteUserMutation, GqlDeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlDeleteUserMutation, GqlDeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = ApolloReactCommon.MutationResult<GqlDeleteUserMutation>;
export type DeleteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlDeleteUserMutation, GqlDeleteUserMutationVariables>;
export const LoginAdminViaTokenDocument = gql`
    mutation LoginAdminViaToken($transferToken: String!) {
  loginAdminViaToken(transferToken: $transferToken) {
    ...adminIdentityFragment
  }
}
    ${AdminIdentityFragmentFragmentDoc}`;
export type GqlLoginAdminViaTokenMutationFn = ApolloReactCommon.MutationFunction<GqlLoginAdminViaTokenMutation, GqlLoginAdminViaTokenMutationVariables>;

/**
 * __useLoginAdminViaTokenMutation__
 *
 * To run a mutation, you first call `useLoginAdminViaTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAdminViaTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAdminViaTokenMutation, { data, loading, error }] = useLoginAdminViaTokenMutation({
 *   variables: {
 *      transferToken: // value for 'transferToken'
 *   },
 * });
 */
export function useLoginAdminViaTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlLoginAdminViaTokenMutation, GqlLoginAdminViaTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlLoginAdminViaTokenMutation, GqlLoginAdminViaTokenMutationVariables>(LoginAdminViaTokenDocument, options);
      }
export type LoginAdminViaTokenMutationHookResult = ReturnType<typeof useLoginAdminViaTokenMutation>;
export type LoginAdminViaTokenMutationResult = ApolloReactCommon.MutationResult<GqlLoginAdminViaTokenMutation>;
export type LoginAdminViaTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlLoginAdminViaTokenMutation, GqlLoginAdminViaTokenMutationVariables>;
export const LoginAdminDocument = gql`
    mutation LoginAdmin($email: String!, $password: String!) {
  loginAdmin(email: $email, password: $password) {
    ...adminIdentityFragment
  }
}
    ${AdminIdentityFragmentFragmentDoc}`;
export type GqlLoginAdminMutationFn = ApolloReactCommon.MutationFunction<GqlLoginAdminMutation, GqlLoginAdminMutationVariables>;

/**
 * __useLoginAdminMutation__
 *
 * To run a mutation, you first call `useLoginAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAdminMutation, { data, loading, error }] = useLoginAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlLoginAdminMutation, GqlLoginAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlLoginAdminMutation, GqlLoginAdminMutationVariables>(LoginAdminDocument, options);
      }
export type LoginAdminMutationHookResult = ReturnType<typeof useLoginAdminMutation>;
export type LoginAdminMutationResult = ApolloReactCommon.MutationResult<GqlLoginAdminMutation>;
export type LoginAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlLoginAdminMutation, GqlLoginAdminMutationVariables>;
export const LoginConsumerDocument = gql`
    mutation LoginConsumer($email: String!, $password: String!, $turnstileToken: String, $dispensaryId: String, $publicContextSessionId: String) {
  loginConsumer(
    email: $email
    password: $password
    turnstileToken: $turnstileToken
    dispensaryId: $dispensaryId
    publicContextSessionId: $publicContextSessionId
  ) {
    accessToken
    transferToken
    user {
      _id
      createdAt
      emails {
        address
      }
      profile {
        birthday
        emailNotifications
        emailOptIn
        firstName
        lastName
        medicalCard {
          expirationDate
          number
          state
          photo
        }
        phone
        photoId
        textNotifications
        type
      }
      payByBankEnrollmentStatus {
        enrollmentStatus
        requiresAggregatorMigration
        paymentMethods {
          id
          status
          type
          bankAccountDetails {
            accountAlias
            bankName
            lastDigits
            status
            aggregator
            expiresAt
            billingAddressId
            financialInstitutionLogo
          }
        }
      }
    }
  }
}
    `;
export type GqlLoginConsumerMutationFn = ApolloReactCommon.MutationFunction<GqlLoginConsumerMutation, GqlLoginConsumerMutationVariables>;

/**
 * __useLoginConsumerMutation__
 *
 * To run a mutation, you first call `useLoginConsumerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginConsumerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginConsumerMutation, { data, loading, error }] = useLoginConsumerMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      turnstileToken: // value for 'turnstileToken'
 *      dispensaryId: // value for 'dispensaryId'
 *      publicContextSessionId: // value for 'publicContextSessionId'
 *   },
 * });
 */
export function useLoginConsumerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlLoginConsumerMutation, GqlLoginConsumerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlLoginConsumerMutation, GqlLoginConsumerMutationVariables>(LoginConsumerDocument, options);
      }
export type LoginConsumerMutationHookResult = ReturnType<typeof useLoginConsumerMutation>;
export type LoginConsumerMutationResult = ApolloReactCommon.MutationResult<GqlLoginConsumerMutation>;
export type LoginConsumerMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlLoginConsumerMutation, GqlLoginConsumerMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    message
    success
  }
}
    `;
export type GqlLogoutMutationFn = ApolloReactCommon.MutationFunction<GqlLogoutMutation, GqlLogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlLogoutMutation, GqlLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlLogoutMutation, GqlLogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = ApolloReactCommon.MutationResult<GqlLogoutMutation>;
export type LogoutMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlLogoutMutation, GqlLogoutMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: usersUpdateInput!) {
  updateUser(user: $input) {
    audioNotificationsOnNewArrivalsDisabled
    audioNotificationsOnNewOrdersDisabled
    chainID
    createdAt
    createdBy
    dispensaryId
    email
    fullName
    isWeeklyReportEnabled
    permissions {
      allLocations
      analytics
      billing
      customers
      dispensaryIds
      driver
      menu
      menuReview
      orders
      promote
      settings
      superMenuReview
      users
    }
    phone
    roleAtDispensary
    type
  }
}
    `;
export type GqlUpdateUserMutationFn = ApolloReactCommon.MutationFunction<GqlUpdateUserMutation, GqlUpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateUserMutation, GqlUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateUserMutation, GqlUpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = ApolloReactCommon.MutationResult<GqlUpdateUserMutation>;
export type UpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateUserMutation, GqlUpdateUserMutationVariables>;
export const MeConsumerDocument = gql`
    query MeConsumer {
  meConsumer {
    _id
    createdAt
    emails {
      address
      verified
      lastVerifiedAt
    }
    profile {
      address {
        city
        lat
        ln1
        ln2
        lng
        state
        zipcode
      }
      birthday
      emailNotifications
      emailOptIn
      firstName
      lastName
      medicalCard {
        expirationDate
        number
        state
        photo
      }
      phone
      textNotifications
      type
      photoId
      isExternalUser
      inStoreEnrollmentCompleted
    }
    payByBankEnrollmentStatus {
      enrollmentStatus
      requiresAggregatorMigration
      paymentMethods {
        id
        status
        type
        bankAccountDetails {
          accountAlias
          bankName
          lastDigits
          status
          aggregator
          expiresAt
          billingAddressId
          financialInstitutionLogo
        }
      }
    }
  }
}
    `;

/**
 * __useMeConsumerQuery__
 *
 * To run a query within a React component, call `useMeConsumerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeConsumerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeConsumerQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeConsumerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlMeConsumerQuery, GqlMeConsumerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlMeConsumerQuery, GqlMeConsumerQueryVariables>(MeConsumerDocument, options);
      }
export function useMeConsumerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlMeConsumerQuery, GqlMeConsumerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlMeConsumerQuery, GqlMeConsumerQueryVariables>(MeConsumerDocument, options);
        }
export type MeConsumerQueryHookResult = ReturnType<typeof useMeConsumerQuery>;
export type MeConsumerLazyQueryHookResult = ReturnType<typeof useMeConsumerLazyQuery>;
export type MeConsumerQueryResult = ApolloReactCommon.QueryResult<GqlMeConsumerQuery, GqlMeConsumerQueryVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($input: ordersCreateInput!, $turnstileToken: String) {
  createOrderV2(order: $input, turnstileToken: $turnstileToken) {
    valid
    errors {
      name
      path
      message
      params
      extensions
    }
    order {
      updateOrderToken
      paymentMethod
      paymentMethodId
      coupon {
        _id
      }
      tipValue {
        percent
        dollar
      }
      createdAt
      creditTotal
      customer {
        _id
        profile {
          medicalCard {
            expirationDate
            number
            state
            photo
          }
          driversLicense
          photoId
        }
      }
      medicalOrder
      medicalCard {
        expirationDate
        number
        state
        photo
      }
      mixAndMatch
      durationEstimates {
        delivery {
          lowInMinutes
          highInMinutes
        }
        pickup {
          lowInMinutes
          highInMinutes
        }
      }
      deliveryInfo {
        address
        apartmentNum
        deliveryAddress
        deliveryOption
        lastSearchedAddress
        nonDeliveryAddress
        location {
          ln1
          ln2
          city
          state
          zipcode
        }
      }
      otherFees
      deliveryFee
      dispensary {
        _id
        cName
        name
        phone
        address
        offerDelivery
        alt36
        check
        creditCardAtDoor
        customDomainSettings {
          domain
        }
        plusSettings {
          checkoutUrl
          defaultReturnUrl
        }
        payOnlineHypur
        payOnlineMerrco
        creditCardByPhone
        debitOnly
        linx
        canPay
        paytender
        aeropay
        deliveryMin
        timezone
        deliveryHours {
          Monday {
            end
            start
          }
          Tuesday {
            end
            start
          }
          Wednesday {
            end
            start
          }
          Thursday {
            end
            start
          }
          Friday {
            end
            start
          }
          Saturday {
            end
            start
          }
          Sunday {
            end
            start
          }
        }
        pickupHours {
          Monday {
            end
            start
          }
          Tuesday {
            end
            start
          }
          Wednesday {
            end
            start
          }
          Thursday {
            end
            start
          }
          Friday {
            end
            start
          }
          Saturday {
            end
            start
          }
          Sunday {
            end
            start
          }
        }
        feeTiers {
          fee
          max
          min
        }
        featureFlags {
          hideDeliveryEstimate
        }
      }
      id
      orderId
      orders {
        basePrice
        option
        price
        product {
          _id
          Name
          type
          strainType
        }
        quantity
      }
      receipt
      specialInstructions
      status
      statusTimes
      statusEvents {
        event
        at
        by
        byType
      }
      taxAmount
      cannabisTax
      tipAmount
      subtotal
      totalCost
      guestCustomer {
        phone
        firstName
        lastName
        email
        birthMonth
        birthDay
        birthYear
      }
      isKioskOrder
      isPreviewOrder
      isGuestOrder
      isAfterHoursOrder
      messages
      destinationTerminal
      customerState
      salesTaxExistence {
        med {
          pos
          menu
          checkout
        }
        rec {
          pos
          menu
          checkout
        }
      }
      cannabisTaxExistence {
        med {
          pos
          menu
          checkout
        }
        rec {
          pos
          menu
          checkout
        }
      }
      bottleDepositTaxExistence {
        med {
          pos
          menu
          checkout
        }
        rec {
          pos
          menu
          checkout
        }
      }
      appliedRewards {
        id
        copy
        available
        value
        operator
        brand
        discountId
      }
      isPTPOT
    }
  }
}
    `;
export type GqlCreateOrderMutationFn = ApolloReactCommon.MutationFunction<GqlCreateOrderMutation, GqlCreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      turnstileToken: // value for 'turnstileToken'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateOrderMutation, GqlCreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateOrderMutation, GqlCreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = ApolloReactCommon.MutationResult<GqlCreateOrderMutation>;
export type CreateOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateOrderMutation, GqlCreateOrderMutationVariables>;
export const UpdateKioskOrderPaymentDocument = gql`
    mutation UpdateKioskOrderPayment($input: updateKioskOrderPaymentInput!) {
  updateKioskOrderPayment(input: $input) {
    success
  }
}
    `;
export type GqlUpdateKioskOrderPaymentMutationFn = ApolloReactCommon.MutationFunction<GqlUpdateKioskOrderPaymentMutation, GqlUpdateKioskOrderPaymentMutationVariables>;

/**
 * __useUpdateKioskOrderPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateKioskOrderPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKioskOrderPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKioskOrderPaymentMutation, { data, loading, error }] = useUpdateKioskOrderPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKioskOrderPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateKioskOrderPaymentMutation, GqlUpdateKioskOrderPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateKioskOrderPaymentMutation, GqlUpdateKioskOrderPaymentMutationVariables>(UpdateKioskOrderPaymentDocument, options);
      }
export type UpdateKioskOrderPaymentMutationHookResult = ReturnType<typeof useUpdateKioskOrderPaymentMutation>;
export type UpdateKioskOrderPaymentMutationResult = ApolloReactCommon.MutationResult<GqlUpdateKioskOrderPaymentMutation>;
export type UpdateKioskOrderPaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateKioskOrderPaymentMutation, GqlUpdateKioskOrderPaymentMutationVariables>;
export const GenerateHypurRedirectV3Document = gql`
    mutation GenerateHypurRedirectV3($dispensaryId: String!, $hostname: String, $embedded: Boolean!) {
  generateHypurRedirectV3(
    dispensaryId: $dispensaryId
    hostname: $hostname
    embedded: $embedded
  ) {
    url
  }
}
    `;
export type GqlGenerateHypurRedirectV3MutationFn = ApolloReactCommon.MutationFunction<GqlGenerateHypurRedirectV3Mutation, GqlGenerateHypurRedirectV3MutationVariables>;

/**
 * __useGenerateHypurRedirectV3Mutation__
 *
 * To run a mutation, you first call `useGenerateHypurRedirectV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateHypurRedirectV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateHypurRedirectV3Mutation, { data, loading, error }] = useGenerateHypurRedirectV3Mutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      hostname: // value for 'hostname'
 *      embedded: // value for 'embedded'
 *   },
 * });
 */
export function useGenerateHypurRedirectV3Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlGenerateHypurRedirectV3Mutation, GqlGenerateHypurRedirectV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlGenerateHypurRedirectV3Mutation, GqlGenerateHypurRedirectV3MutationVariables>(GenerateHypurRedirectV3Document, options);
      }
export type GenerateHypurRedirectV3MutationHookResult = ReturnType<typeof useGenerateHypurRedirectV3Mutation>;
export type GenerateHypurRedirectV3MutationResult = ApolloReactCommon.MutationResult<GqlGenerateHypurRedirectV3Mutation>;
export type GenerateHypurRedirectV3MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlGenerateHypurRedirectV3Mutation, GqlGenerateHypurRedirectV3MutationVariables>;
export const CheckoutDocument = gql`
    query Checkout($checkoutId: String!, $dispensaryId: String!) {
  getCheckout(checkoutId: $checkoutId, dispensaryId: $dispensaryId) {
    id
    address {
      deliverable
      formatted
      geometry {
        coordinates
        type
      }
      street1
      street2
      city
      state
      valid
      zip
    }
    pricingType
    orderType
    items {
      id
      option
      productId
      product {
        ...consumerBaseProductFragment
      }
      quantity
    }
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useCheckoutQuery__
 *
 * To run a query within a React component, call `useCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutQuery({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useCheckoutQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlCheckoutQuery, GqlCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlCheckoutQuery, GqlCheckoutQueryVariables>(CheckoutDocument, options);
      }
export function useCheckoutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlCheckoutQuery, GqlCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlCheckoutQuery, GqlCheckoutQueryVariables>(CheckoutDocument, options);
        }
export type CheckoutQueryHookResult = ReturnType<typeof useCheckoutQuery>;
export type CheckoutLazyQueryHookResult = ReturnType<typeof useCheckoutLazyQuery>;
export type CheckoutQueryResult = ApolloReactCommon.QueryResult<GqlCheckoutQuery, GqlCheckoutQueryVariables>;
export const UpdateCheckoutDocument = gql`
    mutation UpdateCheckout($dispensaryId: String!, $checkoutId: String!, $address: CheckoutAddressInput, $orderType: String!, $pricingType: String) {
  updateCheckout(
    dispensaryId: $dispensaryId
    checkoutId: $checkoutId
    address: $address
    orderType: $orderType
    pricingType: $pricingType
  ) {
    id
  }
}
    `;
export type GqlUpdateCheckoutMutationFn = ApolloReactCommon.MutationFunction<GqlUpdateCheckoutMutation, GqlUpdateCheckoutMutationVariables>;

/**
 * __useUpdateCheckoutMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutMutation, { data, loading, error }] = useUpdateCheckoutMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      checkoutId: // value for 'checkoutId'
 *      address: // value for 'address'
 *      orderType: // value for 'orderType'
 *      pricingType: // value for 'pricingType'
 *   },
 * });
 */
export function useUpdateCheckoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateCheckoutMutation, GqlUpdateCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateCheckoutMutation, GqlUpdateCheckoutMutationVariables>(UpdateCheckoutDocument, options);
      }
export type UpdateCheckoutMutationHookResult = ReturnType<typeof useUpdateCheckoutMutation>;
export type UpdateCheckoutMutationResult = ApolloReactCommon.MutationResult<GqlUpdateCheckoutMutation>;
export type UpdateCheckoutMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateCheckoutMutation, GqlUpdateCheckoutMutationVariables>;
export const UpdateCheckoutItemQuantityDocument = gql`
    mutation UpdateCheckoutItemQuantity($dispensaryId: String!, $checkoutId: String!, $productId: String!, $option: String, $quantity: Int!) {
  updateQuantity(
    dispensaryId: $dispensaryId
    checkoutId: $checkoutId
    productId: $productId
    option: $option
    quantity: $quantity
  ) {
    id
  }
}
    `;
export type GqlUpdateCheckoutItemQuantityMutationFn = ApolloReactCommon.MutationFunction<GqlUpdateCheckoutItemQuantityMutation, GqlUpdateCheckoutItemQuantityMutationVariables>;

/**
 * __useUpdateCheckoutItemQuantityMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutItemQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutItemQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutItemQuantityMutation, { data, loading, error }] = useUpdateCheckoutItemQuantityMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      checkoutId: // value for 'checkoutId'
 *      productId: // value for 'productId'
 *      option: // value for 'option'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useUpdateCheckoutItemQuantityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateCheckoutItemQuantityMutation, GqlUpdateCheckoutItemQuantityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateCheckoutItemQuantityMutation, GqlUpdateCheckoutItemQuantityMutationVariables>(UpdateCheckoutItemQuantityDocument, options);
      }
export type UpdateCheckoutItemQuantityMutationHookResult = ReturnType<typeof useUpdateCheckoutItemQuantityMutation>;
export type UpdateCheckoutItemQuantityMutationResult = ApolloReactCommon.MutationResult<GqlUpdateCheckoutItemQuantityMutation>;
export type UpdateCheckoutItemQuantityMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateCheckoutItemQuantityMutation, GqlUpdateCheckoutItemQuantityMutationVariables>;
export const RemoveCheckoutItemDocument = gql`
    mutation RemoveCheckoutItem($checkoutId: String!, $dispensaryId: String!, $productId: String!, $option: String) {
  removeItem(
    checkoutId: $checkoutId
    dispensaryId: $dispensaryId
    productId: $productId
    option: $option
  ) {
    id
  }
}
    `;
export type GqlRemoveCheckoutItemMutationFn = ApolloReactCommon.MutationFunction<GqlRemoveCheckoutItemMutation, GqlRemoveCheckoutItemMutationVariables>;

/**
 * __useRemoveCheckoutItemMutation__
 *
 * To run a mutation, you first call `useRemoveCheckoutItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCheckoutItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCheckoutItemMutation, { data, loading, error }] = useRemoveCheckoutItemMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      dispensaryId: // value for 'dispensaryId'
 *      productId: // value for 'productId'
 *      option: // value for 'option'
 *   },
 * });
 */
export function useRemoveCheckoutItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlRemoveCheckoutItemMutation, GqlRemoveCheckoutItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlRemoveCheckoutItemMutation, GqlRemoveCheckoutItemMutationVariables>(RemoveCheckoutItemDocument, options);
      }
export type RemoveCheckoutItemMutationHookResult = ReturnType<typeof useRemoveCheckoutItemMutation>;
export type RemoveCheckoutItemMutationResult = ApolloReactCommon.MutationResult<GqlRemoveCheckoutItemMutation>;
export type RemoveCheckoutItemMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlRemoveCheckoutItemMutation, GqlRemoveCheckoutItemMutationVariables>;
export const GetAllCitiesByStateDocument = gql`
    query getAllCitiesByState {
  statesWithDispensaries {
    cities
    name
    country
  }
}
    `;

/**
 * __useGetAllCitiesByStateQuery__
 *
 * To run a query within a React component, call `useGetAllCitiesByStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCitiesByStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCitiesByStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCitiesByStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetAllCitiesByStateQuery, GqlGetAllCitiesByStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetAllCitiesByStateQuery, GqlGetAllCitiesByStateQueryVariables>(GetAllCitiesByStateDocument, options);
      }
export function useGetAllCitiesByStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetAllCitiesByStateQuery, GqlGetAllCitiesByStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetAllCitiesByStateQuery, GqlGetAllCitiesByStateQueryVariables>(GetAllCitiesByStateDocument, options);
        }
export type GetAllCitiesByStateQueryHookResult = ReturnType<typeof useGetAllCitiesByStateQuery>;
export type GetAllCitiesByStateLazyQueryHookResult = ReturnType<typeof useGetAllCitiesByStateLazyQuery>;
export type GetAllCitiesByStateQueryResult = ApolloReactCommon.QueryResult<GqlGetAllCitiesByStateQuery, GqlGetAllCitiesByStateQueryVariables>;
export const GetCitiesWithDispensariesDocument = gql`
    query GetCitiesWithDispensaries {
  statesWithDispensaries {
    cities
    name
    country
  }
}
    `;

/**
 * __useGetCitiesWithDispensariesQuery__
 *
 * To run a query within a React component, call `useGetCitiesWithDispensariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesWithDispensariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesWithDispensariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCitiesWithDispensariesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetCitiesWithDispensariesQuery, GqlGetCitiesWithDispensariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetCitiesWithDispensariesQuery, GqlGetCitiesWithDispensariesQueryVariables>(GetCitiesWithDispensariesDocument, options);
      }
export function useGetCitiesWithDispensariesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetCitiesWithDispensariesQuery, GqlGetCitiesWithDispensariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetCitiesWithDispensariesQuery, GqlGetCitiesWithDispensariesQueryVariables>(GetCitiesWithDispensariesDocument, options);
        }
export type GetCitiesWithDispensariesQueryHookResult = ReturnType<typeof useGetCitiesWithDispensariesQuery>;
export type GetCitiesWithDispensariesLazyQueryHookResult = ReturnType<typeof useGetCitiesWithDispensariesLazyQuery>;
export type GetCitiesWithDispensariesQueryResult = ApolloReactCommon.QueryResult<GqlGetCitiesWithDispensariesQuery, GqlGetCitiesWithDispensariesQueryVariables>;
export const MostPurchasedProductIdsDocument = gql`
    query MostPurchasedProductIds($dispensaryId: String!) {
  getMostPurchasedProducts(dispensaryId: $dispensaryId) {
    id
  }
}
    `;

/**
 * __useMostPurchasedProductIdsQuery__
 *
 * To run a query within a React component, call `useMostPurchasedProductIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMostPurchasedProductIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostPurchasedProductIdsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useMostPurchasedProductIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlMostPurchasedProductIdsQuery, GqlMostPurchasedProductIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlMostPurchasedProductIdsQuery, GqlMostPurchasedProductIdsQueryVariables>(MostPurchasedProductIdsDocument, options);
      }
export function useMostPurchasedProductIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlMostPurchasedProductIdsQuery, GqlMostPurchasedProductIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlMostPurchasedProductIdsQuery, GqlMostPurchasedProductIdsQueryVariables>(MostPurchasedProductIdsDocument, options);
        }
export type MostPurchasedProductIdsQueryHookResult = ReturnType<typeof useMostPurchasedProductIdsQuery>;
export type MostPurchasedProductIdsLazyQueryHookResult = ReturnType<typeof useMostPurchasedProductIdsLazyQuery>;
export type MostPurchasedProductIdsQueryResult = ApolloReactCommon.QueryResult<GqlMostPurchasedProductIdsQuery, GqlMostPurchasedProductIdsQueryVariables>;
export const RecentlyViewedProductsDocument = gql`
    query RecentlyViewedProducts($dispensaryId: String!) {
  getRecentlyViewedProducts(dispensaryId: $dispensaryId) {
    id
  }
}
    `;

/**
 * __useRecentlyViewedProductsQuery__
 *
 * To run a query within a React component, call `useRecentlyViewedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyViewedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyViewedProductsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useRecentlyViewedProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlRecentlyViewedProductsQuery, GqlRecentlyViewedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlRecentlyViewedProductsQuery, GqlRecentlyViewedProductsQueryVariables>(RecentlyViewedProductsDocument, options);
      }
export function useRecentlyViewedProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlRecentlyViewedProductsQuery, GqlRecentlyViewedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlRecentlyViewedProductsQuery, GqlRecentlyViewedProductsQueryVariables>(RecentlyViewedProductsDocument, options);
        }
export type RecentlyViewedProductsQueryHookResult = ReturnType<typeof useRecentlyViewedProductsQuery>;
export type RecentlyViewedProductsLazyQueryHookResult = ReturnType<typeof useRecentlyViewedProductsLazyQuery>;
export type RecentlyViewedProductsQueryResult = ApolloReactCommon.QueryResult<GqlRecentlyViewedProductsQuery, GqlRecentlyViewedProductsQueryVariables>;
export const ProductDemandCountsDocument = gql`
    query ProductDemandCounts($dispensaryId: String!, $productIds: [String!]!) {
  getProductDemandCounts(dispensaryId: $dispensaryId, productIds: $productIds) {
    id
    count
  }
}
    `;

/**
 * __useProductDemandCountsQuery__
 *
 * To run a query within a React component, call `useProductDemandCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDemandCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDemandCountsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useProductDemandCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlProductDemandCountsQuery, GqlProductDemandCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlProductDemandCountsQuery, GqlProductDemandCountsQueryVariables>(ProductDemandCountsDocument, options);
      }
export function useProductDemandCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlProductDemandCountsQuery, GqlProductDemandCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlProductDemandCountsQuery, GqlProductDemandCountsQueryVariables>(ProductDemandCountsDocument, options);
        }
export type ProductDemandCountsQueryHookResult = ReturnType<typeof useProductDemandCountsQuery>;
export type ProductDemandCountsLazyQueryHookResult = ReturnType<typeof useProductDemandCountsLazyQuery>;
export type ProductDemandCountsQueryResult = ApolloReactCommon.QueryResult<GqlProductDemandCountsQuery, GqlProductDemandCountsQueryVariables>;
export const DispensariesForChainDocument = gql`
    query DispensariesForChain($dispensaryFilter: dispensariesFilterInput!) {
  filteredDispensaries(filter: $dispensaryFilter) {
    id
    name
    cName
    status
    chain
  }
}
    `;

/**
 * __useDispensariesForChainQuery__
 *
 * To run a query within a React component, call `useDispensariesForChainQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispensariesForChainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispensariesForChainQuery({
 *   variables: {
 *      dispensaryFilter: // value for 'dispensaryFilter'
 *   },
 * });
 */
export function useDispensariesForChainQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlDispensariesForChainQuery, GqlDispensariesForChainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlDispensariesForChainQuery, GqlDispensariesForChainQueryVariables>(DispensariesForChainDocument, options);
      }
export function useDispensariesForChainLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlDispensariesForChainQuery, GqlDispensariesForChainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlDispensariesForChainQuery, GqlDispensariesForChainQueryVariables>(DispensariesForChainDocument, options);
        }
export type DispensariesForChainQueryHookResult = ReturnType<typeof useDispensariesForChainQuery>;
export type DispensariesForChainLazyQueryHookResult = ReturnType<typeof useDispensariesForChainLazyQuery>;
export type DispensariesForChainQueryResult = ApolloReactCommon.QueryResult<GqlDispensariesForChainQuery, GqlDispensariesForChainQueryVariables>;
export const OrdersForConsumerInChainDocument = gql`
    query OrdersForConsumerInChain($ordersFilter: ordersFilterInput!, $ordersSort: ordersSortInput, $ordersPagination: ordersPaginationInput) {
  filteredOrders(
    filter: $ordersFilter
    sort: $ordersSort
    pagination: $ordersPagination
  ) {
    queryInfo {
      totalCount
    }
    orders {
      coupon {
        _id
        active
        addedDate
        amount
        percentDiscount
        fixedDiscountInCents
        code
        dispensary
        expDate
        numAllowedUses
        numUses
        usedBy
      }
      createdAt
      credit
      durationEstimates {
        delivery {
          lowInMinutes
          highInMinutes
        }
        pickup {
          lowInMinutes
          highInMinutes
        }
      }
      deliveryFee
      dispensary {
        _id
        name
        cName
        phone
        logoImage
        address
        timezone
        featureFlags {
          hideDeliveryEstimate
        }
      }
      id
      customer {
        _id
        emails {
          address
        }
        profile {
          medicalCard {
            expirationDate
            number
            state
            photo
          }
          driversLicense
          photoId
          firstName
          lastName
          email
          phone
          birthday
        }
      }
      guestCustomer {
        firstName
        lastName
        email
        phone
        birthMonth
        birthDay
        birthYear
      }
      medicalOrder
      medicalCard {
        expirationDate
        number
        state
        photo
      }
      mixAndMatch
      orderId
      orders {
        basePrice
        option
        price
        additionalOption
        product {
          _id
          Name
          type
          Options
          Image
          AdditionalOptions
          brandName
          preTaxRecPrices
          preTaxMedPrices
        }
        quantity
      }
      specialInstructions
      status
      taxAmount
      cannabisTax
      bottleDepositTaxCents
      tipAmount
      paymentFee
      paymentMethod
      subtotal
      totalCost
      isPreviewOrder
      terminal
      autoConfirmed
      autoClosed
      isKioskOrder
      isAfterHoursOrder
      isCurbsidePickupOrder
      isDriveThruPickupOrder
      driversLicense
      deliveryInfo {
        address
        apartmentNum
        deliveryAddress
        deliveryOption
        lastSearchedAddress
        nonDeliveryAddress
        address
        location {
          lat
          lng
          ln1
          ln2
          city
          state
          zipcode
        }
      }
      cannabisTaxExistence {
        med {
          pos
          menu
          checkout
        }
        rec {
          pos
          menu
          checkout
        }
      }
      salesTaxExistence {
        med {
          pos
          menu
          checkout
        }
        rec {
          pos
          menu
          checkout
        }
      }
      bottleDepositTaxExistence {
        med {
          pos
          menu
          checkout
        }
        rec {
          pos
          menu
          checkout
        }
      }
      appliedRewards {
        copy
        value
        operator
      }
      reservation {
        startTimeISO
        endTimeISO
      }
    }
  }
}
    `;

/**
 * __useOrdersForConsumerInChainQuery__
 *
 * To run a query within a React component, call `useOrdersForConsumerInChainQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersForConsumerInChainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersForConsumerInChainQuery({
 *   variables: {
 *      ordersFilter: // value for 'ordersFilter'
 *      ordersSort: // value for 'ordersSort'
 *      ordersPagination: // value for 'ordersPagination'
 *   },
 * });
 */
export function useOrdersForConsumerInChainQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlOrdersForConsumerInChainQuery, GqlOrdersForConsumerInChainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlOrdersForConsumerInChainQuery, GqlOrdersForConsumerInChainQueryVariables>(OrdersForConsumerInChainDocument, options);
      }
export function useOrdersForConsumerInChainLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlOrdersForConsumerInChainQuery, GqlOrdersForConsumerInChainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlOrdersForConsumerInChainQuery, GqlOrdersForConsumerInChainQueryVariables>(OrdersForConsumerInChainDocument, options);
        }
export type OrdersForConsumerInChainQueryHookResult = ReturnType<typeof useOrdersForConsumerInChainQuery>;
export type OrdersForConsumerInChainLazyQueryHookResult = ReturnType<typeof useOrdersForConsumerInChainLazyQuery>;
export type OrdersForConsumerInChainQueryResult = ApolloReactCommon.QueryResult<GqlOrdersForConsumerInChainQuery, GqlOrdersForConsumerInChainQueryVariables>;
export const CreatePointsBoostDocument = gql`
    mutation CreatePointsBoost($input: CreatePointsBoostInput!) {
  createPointsBoost(input: $input) {
    success
    message
  }
}
    `;
export type GqlCreatePointsBoostMutationFn = ApolloReactCommon.MutationFunction<GqlCreatePointsBoostMutation, GqlCreatePointsBoostMutationVariables>;

/**
 * __useCreatePointsBoostMutation__
 *
 * To run a mutation, you first call `useCreatePointsBoostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePointsBoostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPointsBoostMutation, { data, loading, error }] = useCreatePointsBoostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePointsBoostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreatePointsBoostMutation, GqlCreatePointsBoostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreatePointsBoostMutation, GqlCreatePointsBoostMutationVariables>(CreatePointsBoostDocument, options);
      }
export type CreatePointsBoostMutationHookResult = ReturnType<typeof useCreatePointsBoostMutation>;
export type CreatePointsBoostMutationResult = ApolloReactCommon.MutationResult<GqlCreatePointsBoostMutation>;
export type CreatePointsBoostMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreatePointsBoostMutation, GqlCreatePointsBoostMutationVariables>;
export const CreatePosMedUserDocument = gql`
    mutation CreatePOSMedUser($dispensaryId: String!, $user: CreatePOSMedUserInput!) {
  createPOSMedUser(dispensaryId: $dispensaryId, user: $user) {
    success
  }
}
    `;
export type GqlCreatePosMedUserMutationFn = ApolloReactCommon.MutationFunction<GqlCreatePosMedUserMutation, GqlCreatePosMedUserMutationVariables>;

/**
 * __useCreatePosMedUserMutation__
 *
 * To run a mutation, you first call `useCreatePosMedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePosMedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPosMedUserMutation, { data, loading, error }] = useCreatePosMedUserMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreatePosMedUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreatePosMedUserMutation, GqlCreatePosMedUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreatePosMedUserMutation, GqlCreatePosMedUserMutationVariables>(CreatePosMedUserDocument, options);
      }
export type CreatePosMedUserMutationHookResult = ReturnType<typeof useCreatePosMedUserMutation>;
export type CreatePosMedUserMutationResult = ApolloReactCommon.MutationResult<GqlCreatePosMedUserMutation>;
export type CreatePosMedUserMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreatePosMedUserMutation, GqlCreatePosMedUserMutationVariables>;
export const GetPosMedCardInfoDocument = gql`
    query GetPosMedCardInfo($dispensaryId: String!) {
  getPosMedCardInfo(dispensaryId: $dispensaryId) {
    number
    expirationDate
    valid
    message
  }
}
    `;

/**
 * __useGetPosMedCardInfoQuery__
 *
 * To run a query within a React component, call `useGetPosMedCardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosMedCardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosMedCardInfoQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetPosMedCardInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetPosMedCardInfoQuery, GqlGetPosMedCardInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetPosMedCardInfoQuery, GqlGetPosMedCardInfoQueryVariables>(GetPosMedCardInfoDocument, options);
      }
export function useGetPosMedCardInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetPosMedCardInfoQuery, GqlGetPosMedCardInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetPosMedCardInfoQuery, GqlGetPosMedCardInfoQueryVariables>(GetPosMedCardInfoDocument, options);
        }
export type GetPosMedCardInfoQueryHookResult = ReturnType<typeof useGetPosMedCardInfoQuery>;
export type GetPosMedCardInfoLazyQueryHookResult = ReturnType<typeof useGetPosMedCardInfoLazyQuery>;
export type GetPosMedCardInfoQueryResult = ApolloReactCommon.QueryResult<GqlGetPosMedCardInfoQuery, GqlGetPosMedCardInfoQueryVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($profile: consumerUserProfileInput!) {
  updateProfileV2(profile: $profile) {
    success
  }
}
    `;
export type GqlUpdateProfileMutationFn = ApolloReactCommon.MutationFunction<GqlUpdateProfileMutation, GqlUpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdateProfileMutation, GqlUpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdateProfileMutation, GqlUpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = ApolloReactCommon.MutationResult<GqlUpdateProfileMutation>;
export type UpdateProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdateProfileMutation, GqlUpdateProfileMutationVariables>;
export const CreatePublicContextSessionDocument = gql`
    mutation CreatePublicContextSession($dispensaryId: String!) {
  createPublicContextSession(dispensaryId: $dispensaryId) {
    id
    dispensaryId
    status
    expiresAt
  }
}
    `;
export type GqlCreatePublicContextSessionMutationFn = ApolloReactCommon.MutationFunction<GqlCreatePublicContextSessionMutation, GqlCreatePublicContextSessionMutationVariables>;

/**
 * __useCreatePublicContextSessionMutation__
 *
 * To run a mutation, you first call `useCreatePublicContextSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicContextSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicContextSessionMutation, { data, loading, error }] = useCreatePublicContextSessionMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useCreatePublicContextSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreatePublicContextSessionMutation, GqlCreatePublicContextSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreatePublicContextSessionMutation, GqlCreatePublicContextSessionMutationVariables>(CreatePublicContextSessionDocument, options);
      }
export type CreatePublicContextSessionMutationHookResult = ReturnType<typeof useCreatePublicContextSessionMutation>;
export type CreatePublicContextSessionMutationResult = ApolloReactCommon.MutationResult<GqlCreatePublicContextSessionMutation>;
export type CreatePublicContextSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreatePublicContextSessionMutation, GqlCreatePublicContextSessionMutationVariables>;
export const UpdatePublicContextSessionDocument = gql`
    mutation UpdatePublicContextSession($id: String!, $loginMethodVerified: Boolean) {
  updatePublicContextSession(id: $id, loginMethodVerified: $loginMethodVerified) {
    id
    dispensaryId
    status
    expiresAt
    loginMethodVerified
    claimedByUserId
  }
}
    `;
export type GqlUpdatePublicContextSessionMutationFn = ApolloReactCommon.MutationFunction<GqlUpdatePublicContextSessionMutation, GqlUpdatePublicContextSessionMutationVariables>;

/**
 * __useUpdatePublicContextSessionMutation__
 *
 * To run a mutation, you first call `useUpdatePublicContextSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublicContextSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublicContextSessionMutation, { data, loading, error }] = useUpdatePublicContextSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      loginMethodVerified: // value for 'loginMethodVerified'
 *   },
 * });
 */
export function useUpdatePublicContextSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUpdatePublicContextSessionMutation, GqlUpdatePublicContextSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUpdatePublicContextSessionMutation, GqlUpdatePublicContextSessionMutationVariables>(UpdatePublicContextSessionDocument, options);
      }
export type UpdatePublicContextSessionMutationHookResult = ReturnType<typeof useUpdatePublicContextSessionMutation>;
export type UpdatePublicContextSessionMutationResult = ApolloReactCommon.MutationResult<GqlUpdatePublicContextSessionMutation>;
export type UpdatePublicContextSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUpdatePublicContextSessionMutation, GqlUpdatePublicContextSessionMutationVariables>;
export const GetPublicContextSessionDocument = gql`
    query GetPublicContextSession($id: String!) {
  getPublicContextSession(id: $id) {
    id
    dispensaryId
    status
    expiresAt
    loginMethodVerified
    claimedByUserId
    accessToken
  }
}
    `;

/**
 * __useGetPublicContextSessionQuery__
 *
 * To run a query within a React component, call `useGetPublicContextSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicContextSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicContextSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPublicContextSessionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetPublicContextSessionQuery, GqlGetPublicContextSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetPublicContextSessionQuery, GqlGetPublicContextSessionQueryVariables>(GetPublicContextSessionDocument, options);
      }
export function useGetPublicContextSessionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetPublicContextSessionQuery, GqlGetPublicContextSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetPublicContextSessionQuery, GqlGetPublicContextSessionQueryVariables>(GetPublicContextSessionDocument, options);
        }
export type GetPublicContextSessionQueryHookResult = ReturnType<typeof useGetPublicContextSessionQuery>;
export type GetPublicContextSessionLazyQueryHookResult = ReturnType<typeof useGetPublicContextSessionLazyQuery>;
export type GetPublicContextSessionQueryResult = ApolloReactCommon.QueryResult<GqlGetPublicContextSessionQuery, GqlGetPublicContextSessionQueryVariables>;
export const CreateInstoreCartUrlDocument = gql`
    mutation CreateInstoreCartUrl($orderId: String!) {
  createInstoreCartUrl(orderId: $orderId) {
    instoreCartUrl
  }
}
    `;
export type GqlCreateInstoreCartUrlMutationFn = ApolloReactCommon.MutationFunction<GqlCreateInstoreCartUrlMutation, GqlCreateInstoreCartUrlMutationVariables>;

/**
 * __useCreateInstoreCartUrlMutation__
 *
 * To run a mutation, you first call `useCreateInstoreCartUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstoreCartUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstoreCartUrlMutation, { data, loading, error }] = useCreateInstoreCartUrlMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCreateInstoreCartUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateInstoreCartUrlMutation, GqlCreateInstoreCartUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateInstoreCartUrlMutation, GqlCreateInstoreCartUrlMutationVariables>(CreateInstoreCartUrlDocument, options);
      }
export type CreateInstoreCartUrlMutationHookResult = ReturnType<typeof useCreateInstoreCartUrlMutation>;
export type CreateInstoreCartUrlMutationResult = ApolloReactCommon.MutationResult<GqlCreateInstoreCartUrlMutation>;
export type CreateInstoreCartUrlMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateInstoreCartUrlMutation, GqlCreateInstoreCartUrlMutationVariables>;
export const CreateBackInStockSubscriptionDocument = gql`
    mutation CreateBackInStockSubscription($productId: String!) {
  createBackInStockSubscription(productId: $productId) {
    success
  }
}
    `;
export type GqlCreateBackInStockSubscriptionMutationFn = ApolloReactCommon.MutationFunction<GqlCreateBackInStockSubscriptionMutation, GqlCreateBackInStockSubscriptionMutationVariables>;

/**
 * __useCreateBackInStockSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateBackInStockSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBackInStockSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBackInStockSubscriptionMutation, { data, loading, error }] = useCreateBackInStockSubscriptionMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useCreateBackInStockSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateBackInStockSubscriptionMutation, GqlCreateBackInStockSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateBackInStockSubscriptionMutation, GqlCreateBackInStockSubscriptionMutationVariables>(CreateBackInStockSubscriptionDocument, options);
      }
export type CreateBackInStockSubscriptionMutationHookResult = ReturnType<typeof useCreateBackInStockSubscriptionMutation>;
export type CreateBackInStockSubscriptionMutationResult = ApolloReactCommon.MutationResult<GqlCreateBackInStockSubscriptionMutation>;
export type CreateBackInStockSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateBackInStockSubscriptionMutation, GqlCreateBackInStockSubscriptionMutationVariables>;
export const DeleteBackInStockSubscriptionDocument = gql`
    mutation DeleteBackInStockSubscription($productId: String!) {
  deleteBackInStockSubscription(productId: $productId) {
    success
  }
}
    `;
export type GqlDeleteBackInStockSubscriptionMutationFn = ApolloReactCommon.MutationFunction<GqlDeleteBackInStockSubscriptionMutation, GqlDeleteBackInStockSubscriptionMutationVariables>;

/**
 * __useDeleteBackInStockSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteBackInStockSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBackInStockSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBackInStockSubscriptionMutation, { data, loading, error }] = useDeleteBackInStockSubscriptionMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useDeleteBackInStockSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlDeleteBackInStockSubscriptionMutation, GqlDeleteBackInStockSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlDeleteBackInStockSubscriptionMutation, GqlDeleteBackInStockSubscriptionMutationVariables>(DeleteBackInStockSubscriptionDocument, options);
      }
export type DeleteBackInStockSubscriptionMutationHookResult = ReturnType<typeof useDeleteBackInStockSubscriptionMutation>;
export type DeleteBackInStockSubscriptionMutationResult = ApolloReactCommon.MutationResult<GqlDeleteBackInStockSubscriptionMutation>;
export type DeleteBackInStockSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlDeleteBackInStockSubscriptionMutation, GqlDeleteBackInStockSubscriptionMutationVariables>;
export const GetBackInStockSubscriptionStatusDocument = gql`
    query GetBackInStockSubscriptionStatus($productId: String!) {
  getBackInStockSubscriptionStatus(productId: $productId) {
    subscribed
  }
}
    `;

/**
 * __useGetBackInStockSubscriptionStatusQuery__
 *
 * To run a query within a React component, call `useGetBackInStockSubscriptionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBackInStockSubscriptionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBackInStockSubscriptionStatusQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetBackInStockSubscriptionStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetBackInStockSubscriptionStatusQuery, GqlGetBackInStockSubscriptionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetBackInStockSubscriptionStatusQuery, GqlGetBackInStockSubscriptionStatusQueryVariables>(GetBackInStockSubscriptionStatusDocument, options);
      }
export function useGetBackInStockSubscriptionStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetBackInStockSubscriptionStatusQuery, GqlGetBackInStockSubscriptionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetBackInStockSubscriptionStatusQuery, GqlGetBackInStockSubscriptionStatusQueryVariables>(GetBackInStockSubscriptionStatusDocument, options);
        }
export type GetBackInStockSubscriptionStatusQueryHookResult = ReturnType<typeof useGetBackInStockSubscriptionStatusQuery>;
export type GetBackInStockSubscriptionStatusLazyQueryHookResult = ReturnType<typeof useGetBackInStockSubscriptionStatusLazyQuery>;
export type GetBackInStockSubscriptionStatusQueryResult = ApolloReactCommon.QueryResult<GqlGetBackInStockSubscriptionStatusQuery, GqlGetBackInStockSubscriptionStatusQueryVariables>;
export const GetCollectionDocument = gql`
    query GetCollection($dispensaryId: String!, $collectionId: String!) {
  getCollection(dispensaryId: $dispensaryId, collectionId: $collectionId) {
    id
    title
    description
    image
    customCategory
    enabled
  }
}
    `;

/**
 * __useGetCollectionQuery__
 *
 * To run a query within a React component, call `useGetCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetCollectionQuery, GqlGetCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetCollectionQuery, GqlGetCollectionQueryVariables>(GetCollectionDocument, options);
      }
export function useGetCollectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetCollectionQuery, GqlGetCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetCollectionQuery, GqlGetCollectionQueryVariables>(GetCollectionDocument, options);
        }
export type GetCollectionQueryHookResult = ReturnType<typeof useGetCollectionQuery>;
export type GetCollectionLazyQueryHookResult = ReturnType<typeof useGetCollectionLazyQuery>;
export type GetCollectionQueryResult = ApolloReactCommon.QueryResult<GqlGetCollectionQuery, GqlGetCollectionQueryVariables>;
export const GetCollectionsDocument = gql`
    query GetCollections($dispensaryId: String!, $customCategory: Boolean) {
  getCollections(dispensaryId: $dispensaryId, customCategory: $customCategory) {
    customCategory
    enabled
    id
    navigationTitle
    slug
    title
  }
}
    `;

/**
 * __useGetCollectionsQuery__
 *
 * To run a query within a React component, call `useGetCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      customCategory: // value for 'customCategory'
 *   },
 * });
 */
export function useGetCollectionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetCollectionsQuery, GqlGetCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetCollectionsQuery, GqlGetCollectionsQueryVariables>(GetCollectionsDocument, options);
      }
export function useGetCollectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetCollectionsQuery, GqlGetCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetCollectionsQuery, GqlGetCollectionsQueryVariables>(GetCollectionsDocument, options);
        }
export type GetCollectionsQueryHookResult = ReturnType<typeof useGetCollectionsQuery>;
export type GetCollectionsLazyQueryHookResult = ReturnType<typeof useGetCollectionsLazyQuery>;
export type GetCollectionsQueryResult = ApolloReactCommon.QueryResult<GqlGetCollectionsQuery, GqlGetCollectionsQueryVariables>;
export const GetCollectionsNavigationDocument = gql`
    query GetCollectionsNavigation($dispensaryId: String!, $customCategory: Boolean, $enabled: Boolean, $activeOnly: Boolean) {
  getCollectionsNavigation(
    dispensaryId: $dispensaryId
    customCategory: $customCategory
    enabled: $enabled
    activeOnly: $activeOnly
  ) {
    id
    slug
    title
    customCategory
    enabled
    navigationTitle
    isActive
    schedule {
      id
      startDate
      endDate
      timeRanges {
        id
        dayOfWeek
        startTime
        endTime
      }
    }
  }
}
    `;

/**
 * __useGetCollectionsNavigationQuery__
 *
 * To run a query within a React component, call `useGetCollectionsNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsNavigationQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      customCategory: // value for 'customCategory'
 *      enabled: // value for 'enabled'
 *      activeOnly: // value for 'activeOnly'
 *   },
 * });
 */
export function useGetCollectionsNavigationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetCollectionsNavigationQuery, GqlGetCollectionsNavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetCollectionsNavigationQuery, GqlGetCollectionsNavigationQueryVariables>(GetCollectionsNavigationDocument, options);
      }
export function useGetCollectionsNavigationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetCollectionsNavigationQuery, GqlGetCollectionsNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetCollectionsNavigationQuery, GqlGetCollectionsNavigationQueryVariables>(GetCollectionsNavigationDocument, options);
        }
export type GetCollectionsNavigationQueryHookResult = ReturnType<typeof useGetCollectionsNavigationQuery>;
export type GetCollectionsNavigationLazyQueryHookResult = ReturnType<typeof useGetCollectionsNavigationLazyQuery>;
export type GetCollectionsNavigationQueryResult = ApolloReactCommon.QueryResult<GqlGetCollectionsNavigationQuery, GqlGetCollectionsNavigationQueryVariables>;
export const CheckAgeVerificationDocument = gql`
    query CheckAgeVerification($dispensaryId: String!) {
  checkAgeVerification(dispensaryId: $dispensaryId) {
    isAgeVerified
  }
}
    `;

/**
 * __useCheckAgeVerificationQuery__
 *
 * To run a query within a React component, call `useCheckAgeVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAgeVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAgeVerificationQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useCheckAgeVerificationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlCheckAgeVerificationQuery, GqlCheckAgeVerificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlCheckAgeVerificationQuery, GqlCheckAgeVerificationQueryVariables>(CheckAgeVerificationDocument, options);
      }
export function useCheckAgeVerificationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlCheckAgeVerificationQuery, GqlCheckAgeVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlCheckAgeVerificationQuery, GqlCheckAgeVerificationQueryVariables>(CheckAgeVerificationDocument, options);
        }
export type CheckAgeVerificationQueryHookResult = ReturnType<typeof useCheckAgeVerificationQuery>;
export type CheckAgeVerificationLazyQueryHookResult = ReturnType<typeof useCheckAgeVerificationLazyQuery>;
export type CheckAgeVerificationQueryResult = ApolloReactCommon.QueryResult<GqlCheckAgeVerificationQuery, GqlCheckAgeVerificationQueryVariables>;
export const EnterpriseProductsDocument = gql`
    query EnterpriseProducts($enterpriseId: ID!) {
  enterpriseProductsV2(enterpriseId: $enterpriseId) {
    products {
      brandId
      brandName
      dispensaryProducts {
        brandId
        brandName
        dispensaryId
        id
        status
        enterpriseProductId
      }
      enterpriseProductId
      medicalOnly
      medicalPrices
      name
      options
      prices
      recOnly
      recPrices
      subcategory
      type
    }
  }
}
    `;

/**
 * __useEnterpriseProductsQuery__
 *
 * To run a query within a React component, call `useEnterpriseProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseProductsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlEnterpriseProductsQuery, GqlEnterpriseProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlEnterpriseProductsQuery, GqlEnterpriseProductsQueryVariables>(EnterpriseProductsDocument, options);
      }
export function useEnterpriseProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlEnterpriseProductsQuery, GqlEnterpriseProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlEnterpriseProductsQuery, GqlEnterpriseProductsQueryVariables>(EnterpriseProductsDocument, options);
        }
export type EnterpriseProductsQueryHookResult = ReturnType<typeof useEnterpriseProductsQuery>;
export type EnterpriseProductsLazyQueryHookResult = ReturnType<typeof useEnterpriseProductsLazyQuery>;
export type EnterpriseProductsQueryResult = ApolloReactCommon.QueryResult<GqlEnterpriseProductsQuery, GqlEnterpriseProductsQueryVariables>;
export const GetChainDispensariesDocument = gql`
    query getChainDispensaries($dispensaryFilter: dispensariesFilterInput!) {
  filteredDispensaries(filter: $dispensaryFilter) {
    id
    name
    cName
    status
    chain
    address
    distance
    logoImage
    location {
      ln1
      ln2
      city
      state
      country
      geometry {
        coordinates
      }
    }
    effectiveHours {
      deliveryHours {
        ...hourSetFragment
      }
      pickupHours {
        ...hourSetFragment
      }
    }
    deliveryHours {
      ...hourSetFragment
    }
    pickupHours {
      ...hourSetFragment
    }
    specialHours {
      name
      startDate
      endDate
      hoursPerDay {
        date
        pickupHours {
          active
          start
          end
        }
        deliveryHours {
          active
          start
          end
        }
      }
    }
    hoursSettings {
      inStorePickup {
        ...hoursSettingsForOrderTypeFragment
      }
      curbsidePickup {
        ...hoursSettingsForOrderTypeFragment
      }
      driveThruPickup {
        ...hoursSettingsForOrderTypeFragment
      }
      delivery {
        ...hoursSettingsForOrderTypeFragment
      }
    }
    offerAnyPickupService
    orderTypesConfig {
      delivery {
        enabled
      }
    }
    orderTypesConfigV2 {
      inStorePickup {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      curbsidePickup {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      driveThruPickup {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      delivery {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      offerAnyPickupService
      offerDeliveryService
    }
    enabledOrderTypes {
      pickup
      inStorePickup
      curbsidePickup
      driveThruPickup
      delivery
      kiosk
    }
    storeSettings {
      enableAfterHoursOrderingForDelivery
      enableAfterHoursOrderingForPickup
      enableScheduledOrderingForDelivery
      enableScheduledOrderingForPickup
    }
  }
}
    ${HourSetFragmentFragmentDoc}
${HoursSettingsForOrderTypeFragmentFragmentDoc}`;

/**
 * __useGetChainDispensariesQuery__
 *
 * To run a query within a React component, call `useGetChainDispensariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChainDispensariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChainDispensariesQuery({
 *   variables: {
 *      dispensaryFilter: // value for 'dispensaryFilter'
 *   },
 * });
 */
export function useGetChainDispensariesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetChainDispensariesQuery, GqlGetChainDispensariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetChainDispensariesQuery, GqlGetChainDispensariesQueryVariables>(GetChainDispensariesDocument, options);
      }
export function useGetChainDispensariesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetChainDispensariesQuery, GqlGetChainDispensariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetChainDispensariesQuery, GqlGetChainDispensariesQueryVariables>(GetChainDispensariesDocument, options);
        }
export type GetChainDispensariesQueryHookResult = ReturnType<typeof useGetChainDispensariesQuery>;
export type GetChainDispensariesLazyQueryHookResult = ReturnType<typeof useGetChainDispensariesLazyQuery>;
export type GetChainDispensariesQueryResult = ApolloReactCommon.QueryResult<GqlGetChainDispensariesQuery, GqlGetChainDispensariesQueryVariables>;
export const EnterpriseLoyaltySettingsDocument = gql`
    query EnterpriseLoyaltySettings($enterpriseId: ID!) {
  enterpriseLoyaltySettings(id: $enterpriseId) {
    enterpriseId
    landingPageUrl
    loyaltyEnrollmentUrl
    name
    uniqueName
    isoRegionCodes
  }
}
    `;

/**
 * __useEnterpriseLoyaltySettingsQuery__
 *
 * To run a query within a React component, call `useEnterpriseLoyaltySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseLoyaltySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseLoyaltySettingsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseLoyaltySettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQueryVariables>(EnterpriseLoyaltySettingsDocument, options);
      }
export function useEnterpriseLoyaltySettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQueryVariables>(EnterpriseLoyaltySettingsDocument, options);
        }
export type EnterpriseLoyaltySettingsQueryHookResult = ReturnType<typeof useEnterpriseLoyaltySettingsQuery>;
export type EnterpriseLoyaltySettingsLazyQueryHookResult = ReturnType<typeof useEnterpriseLoyaltySettingsLazyQuery>;
export type EnterpriseLoyaltySettingsQueryResult = ApolloReactCommon.QueryResult<GqlEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQueryVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount {
  deleteAccount {
    success
    error
  }
}
    `;
export type GqlDeleteAccountMutationFn = ApolloReactCommon.MutationFunction<GqlDeleteAccountMutation, GqlDeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlDeleteAccountMutation, GqlDeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlDeleteAccountMutation, GqlDeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = ApolloReactCommon.MutationResult<GqlDeleteAccountMutation>;
export type DeleteAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlDeleteAccountMutation, GqlDeleteAccountMutationVariables>;
export const DispensaryDemoRequestDocument = gql`
    mutation DispensaryDemoRequest($input: dispensaryDemoRequestInput!) {
  dispensaryDemoRequest(input: $input) {
    success
  }
}
    `;
export type GqlDispensaryDemoRequestMutationFn = ApolloReactCommon.MutationFunction<GqlDispensaryDemoRequestMutation, GqlDispensaryDemoRequestMutationVariables>;

/**
 * __useDispensaryDemoRequestMutation__
 *
 * To run a mutation, you first call `useDispensaryDemoRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispensaryDemoRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispensaryDemoRequestMutation, { data, loading, error }] = useDispensaryDemoRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDispensaryDemoRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlDispensaryDemoRequestMutation, GqlDispensaryDemoRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlDispensaryDemoRequestMutation, GqlDispensaryDemoRequestMutationVariables>(DispensaryDemoRequestDocument, options);
      }
export type DispensaryDemoRequestMutationHookResult = ReturnType<typeof useDispensaryDemoRequestMutation>;
export type DispensaryDemoRequestMutationResult = ApolloReactCommon.MutationResult<GqlDispensaryDemoRequestMutation>;
export type DispensaryDemoRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlDispensaryDemoRequestMutation, GqlDispensaryDemoRequestMutationVariables>;
export const ActivateBankAccountDocument = gql`
    mutation activateBankAccount($paymentMethodId: String!) {
  activateBankAccount(paymentMethodId: $paymentMethodId) {
    success
  }
}
    `;
export type GqlActivateBankAccountMutationFn = ApolloReactCommon.MutationFunction<GqlActivateBankAccountMutation, GqlActivateBankAccountMutationVariables>;

/**
 * __useActivateBankAccountMutation__
 *
 * To run a mutation, you first call `useActivateBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateBankAccountMutation, { data, loading, error }] = useActivateBankAccountMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useActivateBankAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlActivateBankAccountMutation, GqlActivateBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlActivateBankAccountMutation, GqlActivateBankAccountMutationVariables>(ActivateBankAccountDocument, options);
      }
export type ActivateBankAccountMutationHookResult = ReturnType<typeof useActivateBankAccountMutation>;
export type ActivateBankAccountMutationResult = ApolloReactCommon.MutationResult<GqlActivateBankAccountMutation>;
export type ActivateBankAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlActivateBankAccountMutation, GqlActivateBankAccountMutationVariables>;
export const ActivatePaymentMethodV2Document = gql`
    mutation ActivatePaymentMethodV2($paymentMethodId: String!) {
  activatePaymentMethodV2(paymentMethodId: $paymentMethodId) {
    genericResponse {
      success
      message
    }
  }
}
    `;
export type GqlActivatePaymentMethodV2MutationFn = ApolloReactCommon.MutationFunction<GqlActivatePaymentMethodV2Mutation, GqlActivatePaymentMethodV2MutationVariables>;

/**
 * __useActivatePaymentMethodV2Mutation__
 *
 * To run a mutation, you first call `useActivatePaymentMethodV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivatePaymentMethodV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activatePaymentMethodV2Mutation, { data, loading, error }] = useActivatePaymentMethodV2Mutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useActivatePaymentMethodV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlActivatePaymentMethodV2Mutation, GqlActivatePaymentMethodV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlActivatePaymentMethodV2Mutation, GqlActivatePaymentMethodV2MutationVariables>(ActivatePaymentMethodV2Document, options);
      }
export type ActivatePaymentMethodV2MutationHookResult = ReturnType<typeof useActivatePaymentMethodV2Mutation>;
export type ActivatePaymentMethodV2MutationResult = ApolloReactCommon.MutationResult<GqlActivatePaymentMethodV2Mutation>;
export type ActivatePaymentMethodV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlActivatePaymentMethodV2Mutation, GqlActivatePaymentMethodV2MutationVariables>;
export const ApproveInstoreCartDocument = gql`
    mutation ApproveInstoreCart($instoreCartId: String!, $tipCents: Int!, $sessionId: String) {
  approveInstoreCart(
    instoreCartId: $instoreCartId
    tipCents: $tipCents
    sessionId: $sessionId
  ) {
    success
    authorization {
      authorized
      status
      code
    }
  }
}
    `;
export type GqlApproveInstoreCartMutationFn = ApolloReactCommon.MutationFunction<GqlApproveInstoreCartMutation, GqlApproveInstoreCartMutationVariables>;

/**
 * __useApproveInstoreCartMutation__
 *
 * To run a mutation, you first call `useApproveInstoreCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveInstoreCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveInstoreCartMutation, { data, loading, error }] = useApproveInstoreCartMutation({
 *   variables: {
 *      instoreCartId: // value for 'instoreCartId'
 *      tipCents: // value for 'tipCents'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useApproveInstoreCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlApproveInstoreCartMutation, GqlApproveInstoreCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlApproveInstoreCartMutation, GqlApproveInstoreCartMutationVariables>(ApproveInstoreCartDocument, options);
      }
export type ApproveInstoreCartMutationHookResult = ReturnType<typeof useApproveInstoreCartMutation>;
export type ApproveInstoreCartMutationResult = ApolloReactCommon.MutationResult<GqlApproveInstoreCartMutation>;
export type ApproveInstoreCartMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlApproveInstoreCartMutation, GqlApproveInstoreCartMutationVariables>;
export const CompleteAggregatorLinkDocument = gql`
    mutation CompleteAggregatorLink($aggregatorToken: String!, $aggregator: String!, $plaid: PlaidLinkMetadata, $paymentMethodId: String, $sessionId: String, $dispensaryName: String, $dispensaryId: String) {
  completeAggregatorLink(
    aggregatorToken: $aggregatorToken
    aggregator: $aggregator
    plaid: $plaid
    paymentMethodId: $paymentMethodId
    sessionId: $sessionId
    dispensaryName: $dispensaryName
    dispensaryId: $dispensaryId
  ) {
    paymentMethods {
      id
      status
      type
      bankAccountDetails {
        accountAlias
        bankName
        lastDigits
        status
        aggregator
        expiresAt
        billingAddressId
      }
    }
  }
}
    `;
export type GqlCompleteAggregatorLinkMutationFn = ApolloReactCommon.MutationFunction<GqlCompleteAggregatorLinkMutation, GqlCompleteAggregatorLinkMutationVariables>;

/**
 * __useCompleteAggregatorLinkMutation__
 *
 * To run a mutation, you first call `useCompleteAggregatorLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAggregatorLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAggregatorLinkMutation, { data, loading, error }] = useCompleteAggregatorLinkMutation({
 *   variables: {
 *      aggregatorToken: // value for 'aggregatorToken'
 *      aggregator: // value for 'aggregator'
 *      plaid: // value for 'plaid'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      sessionId: // value for 'sessionId'
 *      dispensaryName: // value for 'dispensaryName'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useCompleteAggregatorLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCompleteAggregatorLinkMutation, GqlCompleteAggregatorLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCompleteAggregatorLinkMutation, GqlCompleteAggregatorLinkMutationVariables>(CompleteAggregatorLinkDocument, options);
      }
export type CompleteAggregatorLinkMutationHookResult = ReturnType<typeof useCompleteAggregatorLinkMutation>;
export type CompleteAggregatorLinkMutationResult = ApolloReactCommon.MutationResult<GqlCompleteAggregatorLinkMutation>;
export type CompleteAggregatorLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCompleteAggregatorLinkMutation, GqlCompleteAggregatorLinkMutationVariables>;
export const CreateBankAccountDocument = gql`
    mutation createBankAccount($adapter: String!, $aggregatorToken: String!, $billingAddressId: String!, $entityId: String!, $entityType: EntityTypes!, $sessionId: String) {
  createBankAccount(
    adapter: $adapter
    aggregatorToken: $aggregatorToken
    billingAddressId: $billingAddressId
    entityId: $entityId
    entityType: $entityType
    sessionId: $sessionId
  ) {
    bankAccount {
      id
      bankAccount {
        lastDigits
        bankName
        ownerName
      }
    }
  }
}
    `;
export type GqlCreateBankAccountMutationFn = ApolloReactCommon.MutationFunction<GqlCreateBankAccountMutation, GqlCreateBankAccountMutationVariables>;

/**
 * __useCreateBankAccountMutation__
 *
 * To run a mutation, you first call `useCreateBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBankAccountMutation, { data, loading, error }] = useCreateBankAccountMutation({
 *   variables: {
 *      adapter: // value for 'adapter'
 *      aggregatorToken: // value for 'aggregatorToken'
 *      billingAddressId: // value for 'billingAddressId'
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useCreateBankAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateBankAccountMutation, GqlCreateBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateBankAccountMutation, GqlCreateBankAccountMutationVariables>(CreateBankAccountDocument, options);
      }
export type CreateBankAccountMutationHookResult = ReturnType<typeof useCreateBankAccountMutation>;
export type CreateBankAccountMutationResult = ApolloReactCommon.MutationResult<GqlCreateBankAccountMutation>;
export type CreateBankAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateBankAccountMutation, GqlCreateBankAccountMutationVariables>;
export const CreateFraudAccountDocument = gql`
    mutation CreateFraudAccount($payload: CreateFraudInput!) {
  createFraudAccount(payload: $payload) {
    success
  }
}
    `;
export type GqlCreateFraudAccountMutationFn = ApolloReactCommon.MutationFunction<GqlCreateFraudAccountMutation, GqlCreateFraudAccountMutationVariables>;

/**
 * __useCreateFraudAccountMutation__
 *
 * To run a mutation, you first call `useCreateFraudAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFraudAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFraudAccountMutation, { data, loading, error }] = useCreateFraudAccountMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateFraudAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateFraudAccountMutation, GqlCreateFraudAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateFraudAccountMutation, GqlCreateFraudAccountMutationVariables>(CreateFraudAccountDocument, options);
      }
export type CreateFraudAccountMutationHookResult = ReturnType<typeof useCreateFraudAccountMutation>;
export type CreateFraudAccountMutationResult = ApolloReactCommon.MutationResult<GqlCreateFraudAccountMutation>;
export type CreateFraudAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateFraudAccountMutation, GqlCreateFraudAccountMutationVariables>;
export const CreateMxEnrollmentDocument = gql`
    mutation createMxEnrollment($billingAddress: BillingAddressInput!, $entityId: String!, $entityName: String!, $entityType: EntityTypes!, $entityEmail: String!, $isMobileApp: Boolean!) {
  createMxEnrollment(
    billingAddress: $billingAddress
    entityId: $entityId
    entityName: $entityName
    entityType: $entityType
    entityEmail: $entityEmail
    isMobileApp: $isMobileApp
  ) {
    url
    billingAddress {
      id
    }
  }
}
    `;
export type GqlCreateMxEnrollmentMutationFn = ApolloReactCommon.MutationFunction<GqlCreateMxEnrollmentMutation, GqlCreateMxEnrollmentMutationVariables>;

/**
 * __useCreateMxEnrollmentMutation__
 *
 * To run a mutation, you first call `useCreateMxEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMxEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMxEnrollmentMutation, { data, loading, error }] = useCreateMxEnrollmentMutation({
 *   variables: {
 *      billingAddress: // value for 'billingAddress'
 *      entityId: // value for 'entityId'
 *      entityName: // value for 'entityName'
 *      entityType: // value for 'entityType'
 *      entityEmail: // value for 'entityEmail'
 *      isMobileApp: // value for 'isMobileApp'
 *   },
 * });
 */
export function useCreateMxEnrollmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreateMxEnrollmentMutation, GqlCreateMxEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreateMxEnrollmentMutation, GqlCreateMxEnrollmentMutationVariables>(CreateMxEnrollmentDocument, options);
      }
export type CreateMxEnrollmentMutationHookResult = ReturnType<typeof useCreateMxEnrollmentMutation>;
export type CreateMxEnrollmentMutationResult = ApolloReactCommon.MutationResult<GqlCreateMxEnrollmentMutation>;
export type CreateMxEnrollmentMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreateMxEnrollmentMutation, GqlCreateMxEnrollmentMutationVariables>;
export const CreatePaymentDocument = gql`
    mutation CreatePayment($amount: Int!, $tipAmount: Int, $checkoutToken: String!, $currency: String!, $ecommLocationId: String!, $card: CreatePaymentCard, $customerDetails: CreatePaymentCustomerDetails!, $redirectUrl: String) {
  createPayment(
    amount: $amount
    tipAmount: $tipAmount
    checkoutToken: $checkoutToken
    currency: $currency
    ecommLocationId: $ecommLocationId
    card: $card
    customerDetails: $customerDetails
    redirectUrl: $redirectUrl
  ) {
    payment {
      id
    }
    redirectUrl
  }
}
    `;
export type GqlCreatePaymentMutationFn = ApolloReactCommon.MutationFunction<GqlCreatePaymentMutation, GqlCreatePaymentMutationVariables>;

/**
 * __useCreatePaymentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMutation, { data, loading, error }] = useCreatePaymentMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      tipAmount: // value for 'tipAmount'
 *      checkoutToken: // value for 'checkoutToken'
 *      currency: // value for 'currency'
 *      ecommLocationId: // value for 'ecommLocationId'
 *      card: // value for 'card'
 *      customerDetails: // value for 'customerDetails'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useCreatePaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlCreatePaymentMutation, GqlCreatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlCreatePaymentMutation, GqlCreatePaymentMutationVariables>(CreatePaymentDocument, options);
      }
export type CreatePaymentMutationHookResult = ReturnType<typeof useCreatePaymentMutation>;
export type CreatePaymentMutationResult = ApolloReactCommon.MutationResult<GqlCreatePaymentMutation>;
export type CreatePaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlCreatePaymentMutation, GqlCreatePaymentMutationVariables>;
export const RecordUserAcceptanceDocument = gql`
    mutation recordUserAcceptance($acceptanceDocumentId: String!, $entityId: String!, $entityType: EntityTypes!, $userId: String!) {
  recordUserAcceptance(
    acceptanceDocumentId: $acceptanceDocumentId
    entityId: $entityId
    entityType: $entityType
    userId: $userId
  ) {
    success
  }
}
    `;
export type GqlRecordUserAcceptanceMutationFn = ApolloReactCommon.MutationFunction<GqlRecordUserAcceptanceMutation, GqlRecordUserAcceptanceMutationVariables>;

/**
 * __useRecordUserAcceptanceMutation__
 *
 * To run a mutation, you first call `useRecordUserAcceptanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordUserAcceptanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordUserAcceptanceMutation, { data, loading, error }] = useRecordUserAcceptanceMutation({
 *   variables: {
 *      acceptanceDocumentId: // value for 'acceptanceDocumentId'
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRecordUserAcceptanceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlRecordUserAcceptanceMutation, GqlRecordUserAcceptanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlRecordUserAcceptanceMutation, GqlRecordUserAcceptanceMutationVariables>(RecordUserAcceptanceDocument, options);
      }
export type RecordUserAcceptanceMutationHookResult = ReturnType<typeof useRecordUserAcceptanceMutation>;
export type RecordUserAcceptanceMutationResult = ApolloReactCommon.MutationResult<GqlRecordUserAcceptanceMutation>;
export type RecordUserAcceptanceMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlRecordUserAcceptanceMutation, GqlRecordUserAcceptanceMutationVariables>;
export const StartPreAuthCheckDocument = gql`
    mutation StartPreAuthCheck($paymentMethodId: String!) {
  startPreAuthCheck(paymentMethodId: $paymentMethodId) {
    channelName
    checkId
    status
  }
}
    `;
export type GqlStartPreAuthCheckMutationFn = ApolloReactCommon.MutationFunction<GqlStartPreAuthCheckMutation, GqlStartPreAuthCheckMutationVariables>;

/**
 * __useStartPreAuthCheckMutation__
 *
 * To run a mutation, you first call `useStartPreAuthCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPreAuthCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPreAuthCheckMutation, { data, loading, error }] = useStartPreAuthCheckMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useStartPreAuthCheckMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlStartPreAuthCheckMutation, GqlStartPreAuthCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlStartPreAuthCheckMutation, GqlStartPreAuthCheckMutationVariables>(StartPreAuthCheckDocument, options);
      }
export type StartPreAuthCheckMutationHookResult = ReturnType<typeof useStartPreAuthCheckMutation>;
export type StartPreAuthCheckMutationResult = ApolloReactCommon.MutationResult<GqlStartPreAuthCheckMutation>;
export type StartPreAuthCheckMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlStartPreAuthCheckMutation, GqlStartPreAuthCheckMutationVariables>;
export const UnenrollPayByBankUserDocument = gql`
    mutation UnenrollPayByBankUser($entityId: String!, $entityType: EntityTypes!) {
  unenrollPayByBankUser(entityId: $entityId, entityType: $entityType) {
    success
  }
}
    `;
export type GqlUnenrollPayByBankUserMutationFn = ApolloReactCommon.MutationFunction<GqlUnenrollPayByBankUserMutation, GqlUnenrollPayByBankUserMutationVariables>;

/**
 * __useUnenrollPayByBankUserMutation__
 *
 * To run a mutation, you first call `useUnenrollPayByBankUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnenrollPayByBankUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unenrollPayByBankUserMutation, { data, loading, error }] = useUnenrollPayByBankUserMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useUnenrollPayByBankUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlUnenrollPayByBankUserMutation, GqlUnenrollPayByBankUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlUnenrollPayByBankUserMutation, GqlUnenrollPayByBankUserMutationVariables>(UnenrollPayByBankUserDocument, options);
      }
export type UnenrollPayByBankUserMutationHookResult = ReturnType<typeof useUnenrollPayByBankUserMutation>;
export type UnenrollPayByBankUserMutationResult = ApolloReactCommon.MutationResult<GqlUnenrollPayByBankUserMutation>;
export type UnenrollPayByBankUserMutationOptions = ApolloReactCommon.BaseMutationOptions<GqlUnenrollPayByBankUserMutation, GqlUnenrollPayByBankUserMutationVariables>;
export const GetCustomerDetailsDocument = gql`
    query GetCustomerDetails {
  getCustomerDetails {
    id
    name
    externalId
    successfulOrderCount
  }
}
    `;

/**
 * __useGetCustomerDetailsQuery__
 *
 * To run a query within a React component, call `useGetCustomerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetCustomerDetailsQuery, GqlGetCustomerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetCustomerDetailsQuery, GqlGetCustomerDetailsQueryVariables>(GetCustomerDetailsDocument, options);
      }
export function useGetCustomerDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetCustomerDetailsQuery, GqlGetCustomerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetCustomerDetailsQuery, GqlGetCustomerDetailsQueryVariables>(GetCustomerDetailsDocument, options);
        }
export type GetCustomerDetailsQueryHookResult = ReturnType<typeof useGetCustomerDetailsQuery>;
export type GetCustomerDetailsLazyQueryHookResult = ReturnType<typeof useGetCustomerDetailsLazyQuery>;
export type GetCustomerDetailsQueryResult = ApolloReactCommon.QueryResult<GqlGetCustomerDetailsQuery, GqlGetCustomerDetailsQueryVariables>;
export const GetEnrollmentStatusDocument = gql`
    query GetEnrollmentStatus($entityId: String!, $entityType: EntityTypes!) {
  getEnrollmentStatus(entityId: $entityId, entityType: $entityType) {
    enrollment {
      status
    }
    bankAccounts {
      id
      billingAddress {
        line1
        line2
        city
        state
        country
        postalCode
      }
      bankAccount {
        bankName
        lastDigits
      }
    }
  }
}
    `;

/**
 * __useGetEnrollmentStatusQuery__
 *
 * To run a query within a React component, call `useGetEnrollmentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnrollmentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnrollmentStatusQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useGetEnrollmentStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetEnrollmentStatusQuery, GqlGetEnrollmentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetEnrollmentStatusQuery, GqlGetEnrollmentStatusQueryVariables>(GetEnrollmentStatusDocument, options);
      }
export function useGetEnrollmentStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetEnrollmentStatusQuery, GqlGetEnrollmentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetEnrollmentStatusQuery, GqlGetEnrollmentStatusQueryVariables>(GetEnrollmentStatusDocument, options);
        }
export type GetEnrollmentStatusQueryHookResult = ReturnType<typeof useGetEnrollmentStatusQuery>;
export type GetEnrollmentStatusLazyQueryHookResult = ReturnType<typeof useGetEnrollmentStatusLazyQuery>;
export type GetEnrollmentStatusQueryResult = ApolloReactCommon.QueryResult<GqlGetEnrollmentStatusQuery, GqlGetEnrollmentStatusQueryVariables>;
export const GetEntityLinkingCodeDocument = gql`
    query GetEntityLinkingCode {
  getEntityLinkingCode {
    code
  }
}
    `;

/**
 * __useGetEntityLinkingCodeQuery__
 *
 * To run a query within a React component, call `useGetEntityLinkingCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityLinkingCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityLinkingCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEntityLinkingCodeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetEntityLinkingCodeQuery, GqlGetEntityLinkingCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetEntityLinkingCodeQuery, GqlGetEntityLinkingCodeQueryVariables>(GetEntityLinkingCodeDocument, options);
      }
export function useGetEntityLinkingCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetEntityLinkingCodeQuery, GqlGetEntityLinkingCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetEntityLinkingCodeQuery, GqlGetEntityLinkingCodeQueryVariables>(GetEntityLinkingCodeDocument, options);
        }
export type GetEntityLinkingCodeQueryHookResult = ReturnType<typeof useGetEntityLinkingCodeQuery>;
export type GetEntityLinkingCodeLazyQueryHookResult = ReturnType<typeof useGetEntityLinkingCodeLazyQuery>;
export type GetEntityLinkingCodeQueryResult = ApolloReactCommon.QueryResult<GqlGetEntityLinkingCodeQuery, GqlGetEntityLinkingCodeQueryVariables>;
export const FilteredDispensariesDocument = gql`
    query filteredDispensaries($dispensaryId: String) {
  filteredDispensaries(filter: {cNameOrID: $dispensaryId}) {
    SpecialLogoImage
    name
  }
}
    `;

/**
 * __useFilteredDispensariesQuery__
 *
 * To run a query within a React component, call `useFilteredDispensariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredDispensariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredDispensariesQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useFilteredDispensariesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlFilteredDispensariesQuery, GqlFilteredDispensariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlFilteredDispensariesQuery, GqlFilteredDispensariesQueryVariables>(FilteredDispensariesDocument, options);
      }
export function useFilteredDispensariesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlFilteredDispensariesQuery, GqlFilteredDispensariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlFilteredDispensariesQuery, GqlFilteredDispensariesQueryVariables>(FilteredDispensariesDocument, options);
        }
export type FilteredDispensariesQueryHookResult = ReturnType<typeof useFilteredDispensariesQuery>;
export type FilteredDispensariesLazyQueryHookResult = ReturnType<typeof useFilteredDispensariesLazyQuery>;
export type FilteredDispensariesQueryResult = ApolloReactCommon.QueryResult<GqlFilteredDispensariesQuery, GqlFilteredDispensariesQueryVariables>;
export const GetInstoreAnalyticsTokenDocument = gql`
    query GetInstoreAnalyticsToken {
  getInstoreAnalyticsToken {
    instoreAnalyticsTokenId
  }
}
    `;

/**
 * __useGetInstoreAnalyticsTokenQuery__
 *
 * To run a query within a React component, call `useGetInstoreAnalyticsTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstoreAnalyticsTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstoreAnalyticsTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInstoreAnalyticsTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetInstoreAnalyticsTokenQuery, GqlGetInstoreAnalyticsTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetInstoreAnalyticsTokenQuery, GqlGetInstoreAnalyticsTokenQueryVariables>(GetInstoreAnalyticsTokenDocument, options);
      }
export function useGetInstoreAnalyticsTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetInstoreAnalyticsTokenQuery, GqlGetInstoreAnalyticsTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetInstoreAnalyticsTokenQuery, GqlGetInstoreAnalyticsTokenQueryVariables>(GetInstoreAnalyticsTokenDocument, options);
        }
export type GetInstoreAnalyticsTokenQueryHookResult = ReturnType<typeof useGetInstoreAnalyticsTokenQuery>;
export type GetInstoreAnalyticsTokenLazyQueryHookResult = ReturnType<typeof useGetInstoreAnalyticsTokenLazyQuery>;
export type GetInstoreAnalyticsTokenQueryResult = ApolloReactCommon.QueryResult<GqlGetInstoreAnalyticsTokenQuery, GqlGetInstoreAnalyticsTokenQueryVariables>;
export const GetInstoreCartDocument = gql`
    query GetInstoreCart($cartToken: String) {
  getInstoreCart(cartToken: $cartToken) {
    instoreCartData {
      instoreCart {
        currency
        discounts {
          name
          valueCents
        }
        fees {
          name
          valueCents
        }
        id
        items {
          brandName
          imageUrl
          name
          quantity
          valueCents
        }
        subtotalCents
        taxes {
          name
          valueCents
        }
        tipCents
        totalCents
      }
      tippingDisabled
      retailerId
    }
  }
}
    `;

/**
 * __useGetInstoreCartQuery__
 *
 * To run a query within a React component, call `useGetInstoreCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstoreCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstoreCartQuery({
 *   variables: {
 *      cartToken: // value for 'cartToken'
 *   },
 * });
 */
export function useGetInstoreCartQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlGetInstoreCartQuery, GqlGetInstoreCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetInstoreCartQuery, GqlGetInstoreCartQueryVariables>(GetInstoreCartDocument, options);
      }
export function useGetInstoreCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetInstoreCartQuery, GqlGetInstoreCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetInstoreCartQuery, GqlGetInstoreCartQueryVariables>(GetInstoreCartDocument, options);
        }
export type GetInstoreCartQueryHookResult = ReturnType<typeof useGetInstoreCartQuery>;
export type GetInstoreCartLazyQueryHookResult = ReturnType<typeof useGetInstoreCartLazyQuery>;
export type GetInstoreCartQueryResult = ApolloReactCommon.QueryResult<GqlGetInstoreCartQuery, GqlGetInstoreCartQueryVariables>;
export const GetUserIncentiveEligibilityDocument = gql`
    query getUserIncentiveEligibility($externalId: String!, $dispensaryId: String) {
  getUserIncentiveEligibility(
    externalId: $externalId
    dispensaryId: $dispensaryId
  ) {
    eligible
    incentive {
      id
      name
      description
      amountCents
      cohortName
      active
    }
  }
}
    `;

/**
 * __useGetUserIncentiveEligibilityQuery__
 *
 * To run a query within a React component, call `useGetUserIncentiveEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIncentiveEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIncentiveEligibilityQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetUserIncentiveEligibilityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetUserIncentiveEligibilityQuery, GqlGetUserIncentiveEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetUserIncentiveEligibilityQuery, GqlGetUserIncentiveEligibilityQueryVariables>(GetUserIncentiveEligibilityDocument, options);
      }
export function useGetUserIncentiveEligibilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetUserIncentiveEligibilityQuery, GqlGetUserIncentiveEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetUserIncentiveEligibilityQuery, GqlGetUserIncentiveEligibilityQueryVariables>(GetUserIncentiveEligibilityDocument, options);
        }
export type GetUserIncentiveEligibilityQueryHookResult = ReturnType<typeof useGetUserIncentiveEligibilityQuery>;
export type GetUserIncentiveEligibilityLazyQueryHookResult = ReturnType<typeof useGetUserIncentiveEligibilityLazyQuery>;
export type GetUserIncentiveEligibilityQueryResult = ApolloReactCommon.QueryResult<GqlGetUserIncentiveEligibilityQuery, GqlGetUserIncentiveEligibilityQueryVariables>;
export const ListBankAccountsDocument = gql`
    query ListBankAccounts($aggregator: String!) {
  listBankAccounts(aggregator: $aggregator) {
    bankAccounts {
      accountAlias
      bankName
      billingAddressId
      entityId
      id
      lastDigits
      mx {
        connectionStatus
        widgetUrl
      }
      status
    }
  }
}
    `;

/**
 * __useListBankAccountsQuery__
 *
 * To run a query within a React component, call `useListBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBankAccountsQuery({
 *   variables: {
 *      aggregator: // value for 'aggregator'
 *   },
 * });
 */
export function useListBankAccountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlListBankAccountsQuery, GqlListBankAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlListBankAccountsQuery, GqlListBankAccountsQueryVariables>(ListBankAccountsDocument, options);
      }
export function useListBankAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlListBankAccountsQuery, GqlListBankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlListBankAccountsQuery, GqlListBankAccountsQueryVariables>(ListBankAccountsDocument, options);
        }
export type ListBankAccountsQueryHookResult = ReturnType<typeof useListBankAccountsQuery>;
export type ListBankAccountsLazyQueryHookResult = ReturnType<typeof useListBankAccountsLazyQuery>;
export type ListBankAccountsQueryResult = ApolloReactCommon.QueryResult<GqlListBankAccountsQuery, GqlListBankAccountsQueryVariables>;
export const ListRetailerPaymentTypesStatusDocument = gql`
    query ListRetailerPaymentTypesStatus($ecommLocationId: String!) {
  listRetailerPaymentTypesStatus(ecommLocationId: $ecommLocationId) {
    paymentTypes {
      enabled
      type
      orderTypes {
        curbsidePickup
        driveThruPickup
        pickup
        delivery
      }
    }
  }
}
    `;

/**
 * __useListRetailerPaymentTypesStatusQuery__
 *
 * To run a query within a React component, call `useListRetailerPaymentTypesStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRetailerPaymentTypesStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRetailerPaymentTypesStatusQuery({
 *   variables: {
 *      ecommLocationId: // value for 'ecommLocationId'
 *   },
 * });
 */
export function useListRetailerPaymentTypesStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlListRetailerPaymentTypesStatusQuery, GqlListRetailerPaymentTypesStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlListRetailerPaymentTypesStatusQuery, GqlListRetailerPaymentTypesStatusQueryVariables>(ListRetailerPaymentTypesStatusDocument, options);
      }
export function useListRetailerPaymentTypesStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlListRetailerPaymentTypesStatusQuery, GqlListRetailerPaymentTypesStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlListRetailerPaymentTypesStatusQuery, GqlListRetailerPaymentTypesStatusQueryVariables>(ListRetailerPaymentTypesStatusDocument, options);
        }
export type ListRetailerPaymentTypesStatusQueryHookResult = ReturnType<typeof useListRetailerPaymentTypesStatusQuery>;
export type ListRetailerPaymentTypesStatusLazyQueryHookResult = ReturnType<typeof useListRetailerPaymentTypesStatusLazyQuery>;
export type ListRetailerPaymentTypesStatusQueryResult = ApolloReactCommon.QueryResult<GqlListRetailerPaymentTypesStatusQuery, GqlListRetailerPaymentTypesStatusQueryVariables>;
export const ShowEnrollmentDocument = gql`
    query ShowEnrollment {
  showEnrollment {
    enrollmentStatus
    requiresAggregatorMigration
    paymentMethods {
      id
      status
      type
      bankAccountDetails {
        accountAlias
        bankName
        lastDigits
        status
        aggregator
        expiresAt
        billingAddressId
        financialInstitutionLogo
      }
    }
  }
}
    `;

/**
 * __useShowEnrollmentQuery__
 *
 * To run a query within a React component, call `useShowEnrollmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowEnrollmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowEnrollmentQuery({
 *   variables: {
 *   },
 * });
 */
export function useShowEnrollmentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GqlShowEnrollmentQuery, GqlShowEnrollmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlShowEnrollmentQuery, GqlShowEnrollmentQueryVariables>(ShowEnrollmentDocument, options);
      }
export function useShowEnrollmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlShowEnrollmentQuery, GqlShowEnrollmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlShowEnrollmentQuery, GqlShowEnrollmentQueryVariables>(ShowEnrollmentDocument, options);
        }
export type ShowEnrollmentQueryHookResult = ReturnType<typeof useShowEnrollmentQuery>;
export type ShowEnrollmentLazyQueryHookResult = ReturnType<typeof useShowEnrollmentLazyQuery>;
export type ShowEnrollmentQueryResult = ApolloReactCommon.QueryResult<GqlShowEnrollmentQuery, GqlShowEnrollmentQueryVariables>;
export const StartAggregatorLinkV2Document = gql`
    query StartAggregatorLinkV2($aggregator: String!, $firstName: String!, $lastName: String!, $email: String!, $phone: String!, $paymentMethodId: String, $linkCustomizationName: String) {
  startAggregatorLinkV2(
    aggregator: $aggregator
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
    paymentMethodId: $paymentMethodId
    linkCustomizationName: $linkCustomizationName
  ) {
    plaid {
      linkToken
    }
    aerosync {
      token
      userId
    }
  }
}
    `;

/**
 * __useStartAggregatorLinkV2Query__
 *
 * To run a query within a React component, call `useStartAggregatorLinkV2Query` and pass it any options that fit your needs.
 * When your component renders, `useStartAggregatorLinkV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartAggregatorLinkV2Query({
 *   variables: {
 *      aggregator: // value for 'aggregator'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      linkCustomizationName: // value for 'linkCustomizationName'
 *   },
 * });
 */
export function useStartAggregatorLinkV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GqlStartAggregatorLinkV2Query, GqlStartAggregatorLinkV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlStartAggregatorLinkV2Query, GqlStartAggregatorLinkV2QueryVariables>(StartAggregatorLinkV2Document, options);
      }
export function useStartAggregatorLinkV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlStartAggregatorLinkV2Query, GqlStartAggregatorLinkV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlStartAggregatorLinkV2Query, GqlStartAggregatorLinkV2QueryVariables>(StartAggregatorLinkV2Document, options);
        }
export type StartAggregatorLinkV2QueryHookResult = ReturnType<typeof useStartAggregatorLinkV2Query>;
export type StartAggregatorLinkV2LazyQueryHookResult = ReturnType<typeof useStartAggregatorLinkV2LazyQuery>;
export type StartAggregatorLinkV2QueryResult = ApolloReactCommon.QueryResult<GqlStartAggregatorLinkV2Query, GqlStartAggregatorLinkV2QueryVariables>;
export const StartAggregatorLinkDocument = gql`
    query StartAggregatorLink($aggregator: String!, $redirectUrl: String, $paymentMethodId: String, $entityName: String, $email: String, $phone: String, $linkCustomizationName: String) {
  startAggregatorLink(
    aggregator: $aggregator
    redirectUrl: $redirectUrl
    paymentMethodId: $paymentMethodId
    entityName: $entityName
    email: $email
    phone: $phone
    linkCustomizationName: $linkCustomizationName
  ) {
    plaid {
      linkToken
    }
  }
}
    `;

/**
 * __useStartAggregatorLinkQuery__
 *
 * To run a query within a React component, call `useStartAggregatorLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartAggregatorLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartAggregatorLinkQuery({
 *   variables: {
 *      aggregator: // value for 'aggregator'
 *      redirectUrl: // value for 'redirectUrl'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      entityName: // value for 'entityName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      linkCustomizationName: // value for 'linkCustomizationName'
 *   },
 * });
 */
export function useStartAggregatorLinkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlStartAggregatorLinkQuery, GqlStartAggregatorLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlStartAggregatorLinkQuery, GqlStartAggregatorLinkQueryVariables>(StartAggregatorLinkDocument, options);
      }
export function useStartAggregatorLinkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlStartAggregatorLinkQuery, GqlStartAggregatorLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlStartAggregatorLinkQuery, GqlStartAggregatorLinkQueryVariables>(StartAggregatorLinkDocument, options);
        }
export type StartAggregatorLinkQueryHookResult = ReturnType<typeof useStartAggregatorLinkQuery>;
export type StartAggregatorLinkLazyQueryHookResult = ReturnType<typeof useStartAggregatorLinkLazyQuery>;
export type StartAggregatorLinkQueryResult = ApolloReactCommon.QueryResult<GqlStartAggregatorLinkQuery, GqlStartAggregatorLinkQueryVariables>;
export const VerifyMxMemberDocument = gql`
    query VerifyMxMember($entityId: String!, $entityType: EntityTypes!, $memberGuid: String!, $isMobileApp: Boolean!) {
  verifyMxMember(
    entityId: $entityId
    entityType: $entityType
    memberGuid: $memberGuid
    isMobileApp: $isMobileApp
  ) {
    identificationComplete
    needsAccountSelection
    needsMfa
    url
    accounts {
      accountAlias
      accountGuid
      availableBalance
      bankName
      lastDigits
    }
  }
}
    `;

/**
 * __useVerifyMxMemberQuery__
 *
 * To run a query within a React component, call `useVerifyMxMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyMxMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyMxMemberQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *      memberGuid: // value for 'memberGuid'
 *      isMobileApp: // value for 'isMobileApp'
 *   },
 * });
 */
export function useVerifyMxMemberQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlVerifyMxMemberQuery, GqlVerifyMxMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlVerifyMxMemberQuery, GqlVerifyMxMemberQueryVariables>(VerifyMxMemberDocument, options);
      }
export function useVerifyMxMemberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlVerifyMxMemberQuery, GqlVerifyMxMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlVerifyMxMemberQuery, GqlVerifyMxMemberQueryVariables>(VerifyMxMemberDocument, options);
        }
export type VerifyMxMemberQueryHookResult = ReturnType<typeof useVerifyMxMemberQuery>;
export type VerifyMxMemberLazyQueryHookResult = ReturnType<typeof useVerifyMxMemberLazyQuery>;
export type VerifyMxMemberQueryResult = ApolloReactCommon.QueryResult<GqlVerifyMxMemberQuery, GqlVerifyMxMemberQueryVariables>;
export const GetPersonalizedProductsV2Document = gql`
    query GetPersonalizedProductsV2($input: GetPersonalizedProductsV2Input!) {
  getPersonalizedProductsV2(input: $input) {
    products {
      ...consumerBaseProductFragment
      provider
    }
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useGetPersonalizedProductsV2Query__
 *
 * To run a query within a React component, call `useGetPersonalizedProductsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalizedProductsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalizedProductsV2Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPersonalizedProductsV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetPersonalizedProductsV2Query, GqlGetPersonalizedProductsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetPersonalizedProductsV2Query, GqlGetPersonalizedProductsV2QueryVariables>(GetPersonalizedProductsV2Document, options);
      }
export function useGetPersonalizedProductsV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetPersonalizedProductsV2Query, GqlGetPersonalizedProductsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetPersonalizedProductsV2Query, GqlGetPersonalizedProductsV2QueryVariables>(GetPersonalizedProductsV2Document, options);
        }
export type GetPersonalizedProductsV2QueryHookResult = ReturnType<typeof useGetPersonalizedProductsV2Query>;
export type GetPersonalizedProductsV2LazyQueryHookResult = ReturnType<typeof useGetPersonalizedProductsV2LazyQuery>;
export type GetPersonalizedProductsV2QueryResult = ApolloReactCommon.QueryResult<GqlGetPersonalizedProductsV2Query, GqlGetPersonalizedProductsV2QueryVariables>;
export const GetRecommendedProductsDocument = gql`
    query GetRecommendedProducts($dispensaryId: String!) {
  getRecommendedProducts(dispensaryId: $dispensaryId) {
    ...consumerBaseProductFragment
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useGetRecommendedProductsQuery__
 *
 * To run a query within a React component, call `useGetRecommendedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedProductsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetRecommendedProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetRecommendedProductsQuery, GqlGetRecommendedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetRecommendedProductsQuery, GqlGetRecommendedProductsQueryVariables>(GetRecommendedProductsDocument, options);
      }
export function useGetRecommendedProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetRecommendedProductsQuery, GqlGetRecommendedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetRecommendedProductsQuery, GqlGetRecommendedProductsQueryVariables>(GetRecommendedProductsDocument, options);
        }
export type GetRecommendedProductsQueryHookResult = ReturnType<typeof useGetRecommendedProductsQuery>;
export type GetRecommendedProductsLazyQueryHookResult = ReturnType<typeof useGetRecommendedProductsLazyQuery>;
export type GetRecommendedProductsQueryResult = ApolloReactCommon.QueryResult<GqlGetRecommendedProductsQuery, GqlGetRecommendedProductsQueryVariables>;
export const GetSortedProductRecommendationsDocument = gql`
    query GetSortedProductRecommendations($input: GetSortedProductRecommendationsInput!) {
  getSortedProductRecommendations(input: $input) {
    products {
      id
    }
    adapter
  }
}
    `;

/**
 * __useGetSortedProductRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetSortedProductRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSortedProductRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSortedProductRecommendationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSortedProductRecommendationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetSortedProductRecommendationsQuery, GqlGetSortedProductRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetSortedProductRecommendationsQuery, GqlGetSortedProductRecommendationsQueryVariables>(GetSortedProductRecommendationsDocument, options);
      }
export function useGetSortedProductRecommendationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetSortedProductRecommendationsQuery, GqlGetSortedProductRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetSortedProductRecommendationsQuery, GqlGetSortedProductRecommendationsQueryVariables>(GetSortedProductRecommendationsDocument, options);
        }
export type GetSortedProductRecommendationsQueryHookResult = ReturnType<typeof useGetSortedProductRecommendationsQuery>;
export type GetSortedProductRecommendationsLazyQueryHookResult = ReturnType<typeof useGetSortedProductRecommendationsLazyQuery>;
export type GetSortedProductRecommendationsQueryResult = ApolloReactCommon.QueryResult<GqlGetSortedProductRecommendationsQuery, GqlGetSortedProductRecommendationsQueryVariables>;
export const GetPersonalizedProductsDocument = gql`
    query GetPersonalizedProducts($input: GetPersonalizedProductsInput!) {
  getPersonalizedProducts(input: $input) {
    products {
      ...consumerBaseProductFragment
      provider
    }
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useGetPersonalizedProductsQuery__
 *
 * To run a query within a React component, call `useGetPersonalizedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalizedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalizedProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPersonalizedProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetPersonalizedProductsQuery, GqlGetPersonalizedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetPersonalizedProductsQuery, GqlGetPersonalizedProductsQueryVariables>(GetPersonalizedProductsDocument, options);
      }
export function useGetPersonalizedProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetPersonalizedProductsQuery, GqlGetPersonalizedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetPersonalizedProductsQuery, GqlGetPersonalizedProductsQueryVariables>(GetPersonalizedProductsDocument, options);
        }
export type GetPersonalizedProductsQueryHookResult = ReturnType<typeof useGetPersonalizedProductsQuery>;
export type GetPersonalizedProductsLazyQueryHookResult = ReturnType<typeof useGetPersonalizedProductsLazyQuery>;
export type GetPersonalizedProductsQueryResult = ApolloReactCommon.QueryResult<GqlGetPersonalizedProductsQuery, GqlGetPersonalizedProductsQueryVariables>;
export const GetTrackedCartDocument = gql`
    query GetTrackedCart($checkoutToken: String!, $dispensaryId: String!) {
  getTrackedCart(checkoutToken: $checkoutToken, dispensaryId: $dispensaryId) {
    token
    dispensaryId
    createdAt
    updatedAt
    order
  }
}
    `;

/**
 * __useGetTrackedCartQuery__
 *
 * To run a query within a React component, call `useGetTrackedCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackedCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackedCartQuery({
 *   variables: {
 *      checkoutToken: // value for 'checkoutToken'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetTrackedCartQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetTrackedCartQuery, GqlGetTrackedCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetTrackedCartQuery, GqlGetTrackedCartQueryVariables>(GetTrackedCartDocument, options);
      }
export function useGetTrackedCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetTrackedCartQuery, GqlGetTrackedCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetTrackedCartQuery, GqlGetTrackedCartQueryVariables>(GetTrackedCartDocument, options);
        }
export type GetTrackedCartQueryHookResult = ReturnType<typeof useGetTrackedCartQuery>;
export type GetTrackedCartLazyQueryHookResult = ReturnType<typeof useGetTrackedCartLazyQuery>;
export type GetTrackedCartQueryResult = ApolloReactCommon.QueryResult<GqlGetTrackedCartQuery, GqlGetTrackedCartQueryVariables>;
export const PersistCheckoutV2Document = gql`
    mutation PersistCheckoutV2($order: JSON!, $dispensaryId: String!, $token: String) {
  persistCheckoutV2(order: $order, dispensaryId: $dispensaryId, token: $token) {
    checkoutToken
  }
}
    `;
export type GqlPersistCheckoutV2MutationFn = ApolloReactCommon.MutationFunction<GqlPersistCheckoutV2Mutation, GqlPersistCheckoutV2MutationVariables>;

/**
 * __usePersistCheckoutV2Mutation__
 *
 * To run a mutation, you first call `usePersistCheckoutV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersistCheckoutV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [persistCheckoutV2Mutation, { data, loading, error }] = usePersistCheckoutV2Mutation({
 *   variables: {
 *      order: // value for 'order'
 *      dispensaryId: // value for 'dispensaryId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePersistCheckoutV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GqlPersistCheckoutV2Mutation, GqlPersistCheckoutV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GqlPersistCheckoutV2Mutation, GqlPersistCheckoutV2MutationVariables>(PersistCheckoutV2Document, options);
      }
export type PersistCheckoutV2MutationHookResult = ReturnType<typeof usePersistCheckoutV2Mutation>;
export type PersistCheckoutV2MutationResult = ApolloReactCommon.MutationResult<GqlPersistCheckoutV2Mutation>;
export type PersistCheckoutV2MutationOptions = ApolloReactCommon.BaseMutationOptions<GqlPersistCheckoutV2Mutation, GqlPersistCheckoutV2MutationVariables>;
export const GetRemoteIntegrationValueDocument = gql`
    query GetRemoteIntegrationValue($dispensaryId: String!, $key: String!) {
  getRemoteIntegrationValue(dispensaryId: $dispensaryId, key: $key)
}
    `;

/**
 * __useGetRemoteIntegrationValueQuery__
 *
 * To run a query within a React component, call `useGetRemoteIntegrationValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemoteIntegrationValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemoteIntegrationValueQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetRemoteIntegrationValueQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetRemoteIntegrationValueQuery, GqlGetRemoteIntegrationValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetRemoteIntegrationValueQuery, GqlGetRemoteIntegrationValueQueryVariables>(GetRemoteIntegrationValueDocument, options);
      }
export function useGetRemoteIntegrationValueLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetRemoteIntegrationValueQuery, GqlGetRemoteIntegrationValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetRemoteIntegrationValueQuery, GqlGetRemoteIntegrationValueQueryVariables>(GetRemoteIntegrationValueDocument, options);
        }
export type GetRemoteIntegrationValueQueryHookResult = ReturnType<typeof useGetRemoteIntegrationValueQuery>;
export type GetRemoteIntegrationValueLazyQueryHookResult = ReturnType<typeof useGetRemoteIntegrationValueLazyQuery>;
export type GetRemoteIntegrationValueQueryResult = ApolloReactCommon.QueryResult<GqlGetRemoteIntegrationValueQuery, GqlGetRemoteIntegrationValueQueryVariables>;
export const GetSponsoredBrandDocument = gql`
    query GetSponsoredBrand($input: GetSponsoredBrandInput!) {
  getSponsoredBrand(input: $input) {
    id
    name
    campaignId
    trackers {
      clickUrl
      impressionUrl
    }
    products {
      ...consumerSponsoredProductFragment
    }
  }
}
    ${ConsumerSponsoredProductFragmentFragmentDoc}`;

/**
 * __useGetSponsoredBrandQuery__
 *
 * To run a query within a React component, call `useGetSponsoredBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSponsoredBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSponsoredBrandQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSponsoredBrandQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetSponsoredBrandQuery, GqlGetSponsoredBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetSponsoredBrandQuery, GqlGetSponsoredBrandQueryVariables>(GetSponsoredBrandDocument, options);
      }
export function useGetSponsoredBrandLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetSponsoredBrandQuery, GqlGetSponsoredBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetSponsoredBrandQuery, GqlGetSponsoredBrandQueryVariables>(GetSponsoredBrandDocument, options);
        }
export type GetSponsoredBrandQueryHookResult = ReturnType<typeof useGetSponsoredBrandQuery>;
export type GetSponsoredBrandLazyQueryHookResult = ReturnType<typeof useGetSponsoredBrandLazyQuery>;
export type GetSponsoredBrandQueryResult = ApolloReactCommon.QueryResult<GqlGetSponsoredBrandQuery, GqlGetSponsoredBrandQueryVariables>;
export const GetSponsoredProductsDocument = gql`
    query getSponsoredProducts($input: GetSponsoredProductsInput!) {
  getSponsoredProducts(input: $input) {
    ...consumerSponsoredProductFragment
  }
}
    ${ConsumerSponsoredProductFragmentFragmentDoc}`;

/**
 * __useGetSponsoredProductsQuery__
 *
 * To run a query within a React component, call `useGetSponsoredProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSponsoredProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSponsoredProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSponsoredProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GqlGetSponsoredProductsQuery, GqlGetSponsoredProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GqlGetSponsoredProductsQuery, GqlGetSponsoredProductsQueryVariables>(GetSponsoredProductsDocument, options);
      }
export function useGetSponsoredProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GqlGetSponsoredProductsQuery, GqlGetSponsoredProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GqlGetSponsoredProductsQuery, GqlGetSponsoredProductsQueryVariables>(GetSponsoredProductsDocument, options);
        }
export type GetSponsoredProductsQueryHookResult = ReturnType<typeof useGetSponsoredProductsQuery>;
export type GetSponsoredProductsLazyQueryHookResult = ReturnType<typeof useGetSponsoredProductsLazyQuery>;
export type GetSponsoredProductsQueryResult = ApolloReactCommon.QueryResult<GqlGetSponsoredProductsQuery, GqlGetSponsoredProductsQueryVariables>;